/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdvertGenerationAccountConfig {
  /** @format int64 */
  accountId: string;
  /** Account-wide style/instructions. Shared across objects; not mutated by feedback or regenerate. */
  prompt: string;
}

export interface AdvertGenerationGenerationFeedback {
  /** Optional free-text feedback. Typical for NEGATIVE ratings. */
  comment?: string;
  rating: AiadvertGenerationFeedbackRating;
}

export interface AdvertGenerationGetAccountConfigResponse {
  config: AdvertGenerationAccountConfig;
}

export interface AdvertGenerationRegenerateRequest {
  /** Revision instruction appended as a user turn after the previous assistant output. */
  feedback: string;
  /** Prior generation to revise. Account prompt and object data are reloaded server-side. */
  generationId: string;
}

export interface AdvertGenerationSetAccountConfigResponse {
  config: AdvertGenerationAccountConfig;
}

export interface AdvertGenerationSubmitGenerationFeedbackRequest {
  /** Optional free text. Does not trigger regeneration by itself. */
  comment?: string;
  generationId: string;
  rating: AiadvertGenerationFeedbackRating;
}

export interface AdvertGenerationSubmitGenerationFeedbackResponse {
  feedback: AdvertGenerationGenerationFeedback;
}

/**
 * Global tonal corrections applied to the full-resolution original. All zero means no change.
 * Values outside the documented ranges are clamped server-side.
 */
export interface AdvertImageImageAdjustments {
  /**
   * S-curve contrast change. Range -0.3 .. +0.3.
   * @format float
   */
  contrast: number;
  /**
   * Exposure change in EV stops. Range -1.0 .. +1.5.
   * @format float
   */
  exposureEv: number;
  /**
   * Compression of bright tones. Range 0 .. 1.
   * @format float
   */
  highlightRecovery: number;
  /**
   * Brightening of dark tones. Range 0 .. 1.
   * @format float
   */
  shadowLift: number;
  /**
   * Unsharp-mask strength, scaled to image resolution. Range 0 .. 1.
   * @format float
   */
  sharpening: number;
  /**
   * Saturation change weighted toward low-saturation colours. Range -0.3 .. +0.3.
   * @format float
   */
  vibrance: number;
  /**
   * Blend toward the measured neutral white balance (removes colour casts). Range 0 .. 1.
   * @format float
   */
  whiteBalanceStrength: number;
}

export interface AdvertImageOptimizeRequest {
  /** Store media to optimize. Must be a READY image (JPEG, PNG or WebP) owned by the caller's account. */
  mediaId: string;
  /** Optional. Only used as ai-gateway usage referenceId. */
  objectId?: string;
}

export interface AdvertImageOptimizeResponse {
  /** Adjustments applied after server-side clamping. */
  adjustments: AdvertImageImageAdjustments;
  /** True when the image needs no correction. Nothing is uploaded and optimizedMediaId equals originalMediaId. */
  noChangesNeeded: boolean;
  /** Feature-service ID for this optimization. Use for feedback. */
  optimizationId: string;
  /** New store media holding the optimized image. May still be scanning; poll GET /web/media/{id} until READY. Equals originalMediaId when noChangesNeeded is true. */
  optimizedMediaId: string;
  originalMediaId: string;
  /** ai-gateway Complete requestId for usage/cost correlation. */
  requestId: string;
}

export interface AdvertImageSubmitOptimizationFeedbackRequest {
  /** Optional free text. Typical for NEGATIVE ratings. */
  comment?: string;
  optimizationId: string;
  rating: AiadvertImageFeedbackRating;
}

export type AdvertImageSubmitOptimizationFeedbackResponse = object;

export interface AiGatewayAiAccountSettings {
  /** @format int64 */
  accountId: string;
  enabled: boolean;
  /** Use cases enabled for this account. */
  enabledUseCases: AiGatewayAiUseCase[];
}

/**
 * Customer-facing cost for one Complete call / usage row.
 * All costs within the gateway are tracked in CHF. Providers billing in other currencies
 * (e.g. Scaleway in EUR) are converted to CHF by the gateway.
 * Conversion to other currencies is handled by the presentation/billing layer.
 * Amount is in micros of the major currency unit (1e-6).
 * Example: CHF 0.001234 → currencyCode="CHF", amountMicros=1234.
 */
export interface AiGatewayAiCost {
  /**
   * Cost in micros (1e-6 of major unit). Non-negative. Gateway-computed from model pricing × tokens.
   * @format int64
   */
  amountMicros: string;
  /** ISO 4217 currency code. Always CHF within the gateway (non-CHF provider prices are converted). Presentation layers may convert to account currency if needed. */
  currencyCode: string;
}

/** @default "AI_PROVIDER_UNDEFINED" */
export enum AiGatewayAiProvider {
  AI_PROVIDER_UNDEFINED = "AI_PROVIDER_UNDEFINED",
  AI_PROVIDER_INFOMANIAK = "AI_PROVIDER_INFOMANIAK",
  AI_PROVIDER_SCALEWAY = "AI_PROVIDER_SCALEWAY",
}

export interface AiGatewayAiQuota {
  /** ISO 4217 currency code for maxCostMicros. Must be CHF (gateway canonical currency). Stored explicitly for forward-compatibility. */
  costCurrencyCode: string;
  /** If true, requests are rejected when quota exceeded. If false, log-only (soft limit). */
  hardLimit: boolean;
  /**
   * Max cost in CHF micros (1e-6) per period. -1 means unlimited. Must use same currency as AiCost (CHF).
   * @format int64
   */
  maxCostMicros: string;
  /**
   * Max Complete calls per period. -1 means unlimited.
   * @format int32
   */
  maxRequests: number;
  /**
   * Max total tokens per period. -1 means unlimited.
   * @format int32
   */
  maxTotalTokens: number;
  period: AiGatewayQuotaPeriod;
}

export interface AiGatewayAiRequestContext {
  /** Optional idempotency key from the calling service. Same key within TTL returns cached response. */
  clientRequestId?: string;
  /** Domain entity IDs, e.g. mail_abc123 or ticket_xyz789 that were involved in that complete call. */
  referenceIds: string[];
}

export interface AiGatewayAiUsageByUseCase {
  /**
   * Customer-facing cost for one Complete call / usage row.
   * All costs within the gateway are tracked in CHF. Providers billing in other currencies
   * (e.g. Scaleway in EUR) are converted to CHF by the gateway.
   * Conversion to other currencies is handled by the presentation/billing layer.
   * Amount is in micros of the major currency unit (1e-6).
   * Example: CHF 0.001234 → currencyCode="CHF", amountMicros=1234.
   */
  cost: AiGatewayAiCost;
  /** @format int32 */
  requestCount: number;
  tokens: AiGatewayTokenUsage;
  useCase: AiGatewayAiUseCase;
}

export interface AiGatewayAiUsageRecord {
  /** @format int64 */
  accountId: string;
  context: AiGatewayAiRequestContext;
  /** Customer-facing cost attributed to this request. */
  cost: AiGatewayAiCost;
  /**
   * UNIX timestamp in seconds.
   * @format int64
   */
  createdAt: string;
  finishReason: AiGatewayFinishReason;
  /** @format int32 */
  latencyMs: number;
  provider: AiGatewayAiProvider;
  requestId: string;
  /** Actual model ID used by the provider adapter, for debugging and cost attribution. */
  resolvedModel: string;
  usage: AiGatewayTokenUsage;
  useCase: AiGatewayAiUseCase;
  /** True if primary model failed and fallback profile was used. */
  usedFallbackModel: boolean;
}

export interface AiGatewayAiUsageSummary {
  /** @format int64 */
  accountId: string;
  byUseCase: AiGatewayAiUsageByUseCase[];
  /** @format int64 */
  fromUnix: string;
  /** @format int64 */
  toUnix: string;
  /** Sum of record costs in [fromUnix, toUnix). Always CHF. */
  totalCost: AiGatewayAiCost;
  /** @format int32 */
  totalRequests: number;
  totalTokens: AiGatewayTokenUsage;
}

/** @default "AI_USE_CASE_UNDEFINED" */
export enum AiGatewayAiUseCase {
  AI_USE_CASE_UNDEFINED = "AI_USE_CASE_UNDEFINED",
  AI_USE_CASE_CLAIM_MANAGEMENT = "AI_USE_CASE_CLAIM_MANAGEMENT",
  AI_USE_CASE_ADVERT_DESCRIPTION = "AI_USE_CASE_ADVERT_DESCRIPTION",
  AI_USE_CASE_ADVERT_IMAGE = "AI_USE_CASE_ADVERT_IMAGE",
}

/** One element of an OpenAI content array. Exactly the payload matching type must be set. */
export interface AiGatewayChatContentPart {
  /** File payload. Required for CONTENT_PART_TYPE_FILE. Currently rejected with InvalidArgument (file input not supported by provider). */
  file: AiGatewayFileContent;
  /** Image payload. Required for CONTENT_PART_TYPE_IMAGE_URL. */
  imageUrl: AiGatewayImageUrl;
  /** Text payload. Required for CONTENT_PART_TYPE_TEXT. */
  text: string;
  /**
   * Mirrors the OpenAI Chat Completions content part types.
   *
   *  - CONTENT_PART_TYPE_TEXT: OpenAI "text"
   *  - CONTENT_PART_TYPE_IMAGE_URL: OpenAI "image_url"
   *  - CONTENT_PART_TYPE_FILE: OpenAI "file", e.g. PDF. Currently rejected with InvalidArgument until a provider supports it.
   */
  type: AiGatewayContentPartType;
}

/**
 * Chat message, mirrors OpenAI where content is either a string or an array of content parts.
 * Exactly one of content / contentParts must be set.
 * Image and file parts are only allowed on CHAT_ROLE_USER.
 * Per request: at most 12 image parts and at most 3.5 MiB of inline data (images and files combined).
 */
export interface AiGatewayChatMessage {
  /** OpenAI content as plain string. Mutually exclusive with contentParts. */
  content: string;
  /** OpenAI content as array of typed parts (text, image_url, file). Mutually exclusive with content. Image and file parts only on CHAT_ROLE_USER; per request at most 12 images and 3.5 MiB inline data. */
  contentParts: AiGatewayChatContentPart[];
  role: AiGatewayChatRole;
}

/** @default "CHAT_ROLE_UNDEFINED" */
export enum AiGatewayChatRole {
  CHAT_ROLE_UNDEFINED = "CHAT_ROLE_UNDEFINED",
  CHAT_ROLE_SYSTEM = "CHAT_ROLE_SYSTEM",
  CHAT_ROLE_USER = "CHAT_ROLE_USER",
  CHAT_ROLE_ASSISTANT = "CHAT_ROLE_ASSISTANT",
}

export interface AiGatewayCompleteResponse {
  content: string;
  /** Customer-facing cost for this Complete call. Same value persisted on AiUsageRecord. */
  cost: AiGatewayAiCost;
  finishReason: AiGatewayFinishReason;
  provider: AiGatewayAiProvider;
  requestId: string;
  resolvedModel: string;
  usage: AiGatewayTokenUsage;
  usedFallbackModel: boolean;
}

/**
 * Mirrors the OpenAI Chat Completions content part types.
 *
 *  - CONTENT_PART_TYPE_TEXT: OpenAI "text"
 *  - CONTENT_PART_TYPE_IMAGE_URL: OpenAI "image_url"
 *  - CONTENT_PART_TYPE_FILE: OpenAI "file", e.g. PDF. Currently rejected with InvalidArgument until a provider supports it.
 * @default "CONTENT_PART_TYPE_UNDEFINED"
 */
export enum AiGatewayContentPartType {
  CONTENT_PART_TYPE_UNDEFINED = "CONTENT_PART_TYPE_UNDEFINED",
  CONTENT_PART_TYPE_TEXT = "CONTENT_PART_TYPE_TEXT",
  CONTENT_PART_TYPE_IMAGE_URL = "CONTENT_PART_TYPE_IMAGE_URL",
  CONTENT_PART_TYPE_FILE = "CONTENT_PART_TYPE_FILE",
}

/**
 * File input part, mirrors OpenAI {"type":"file","file":{"file_data":"...","filename":"..."}}.
 * Instead of a base64 data URI in file_data, inline files are sent as raw bytes plus mimeType.
 */
export interface AiGatewayFileContent {
  /**
   * Inline file bytes (base64 in JSON). Replaces the OpenAI data URI.
   * @format byte
   */
  fileData: string;
  /** Optional OpenAI filename. */
  filename?: string;
  /** MIME type of fileData. Required. Allowed: application/pdf. */
  mimeType: string;
}

/** @default "FINISH_REASON_UNDEFINED" */
export enum AiGatewayFinishReason {
  FINISH_REASON_UNDEFINED = "FINISH_REASON_UNDEFINED",
  FINISH_REASON_STOP = "FINISH_REASON_STOP",
  FINISH_REASON_LENGTH = "FINISH_REASON_LENGTH",
  FINISH_REASON_CONTENT_FILTER = "FINISH_REASON_CONTENT_FILTER",
  FINISH_REASON_ERROR = "FINISH_REASON_ERROR",
}

export interface AiGatewayGetQuotaResponse {
  /** Typically one entry per QuotaPeriod (daily, monthly). */
  quotas: AiGatewayAiQuota[];
}

export interface AiGatewayGetUsageResponse {
  summary: AiGatewayAiUsageSummary;
}

/**
 * Mirrors OpenAI image_url.detail.
 *
 *  - IMAGE_DETAIL_UNDEFINED: Omitted, provider default ("auto") applies.
 * @default "IMAGE_DETAIL_UNDEFINED"
 */
export enum AiGatewayImageDetail {
  IMAGE_DETAIL_UNDEFINED = "IMAGE_DETAIL_UNDEFINED",
  IMAGE_DETAIL_AUTO = "IMAGE_DETAIL_AUTO",
  IMAGE_DETAIL_LOW = "IMAGE_DETAIL_LOW",
  IMAGE_DETAIL_HIGH = "IMAGE_DETAIL_HIGH",
}

/**
 * Image input part, mirrors OpenAI {"type":"image_url","image_url":{"url":"...","detail":"..."}}.
 * Instead of a base64 data URI in url, inline images are sent as raw bytes plus mimeType.
 */
export interface AiGatewayImageUrl {
  /**
   * Inline image bytes (base64 in JSON). Replaces the OpenAI data URI.
   * @format byte
   */
  data: string;
  /** Optional OpenAI detail level. When unset, the provider default applies. */
  detail?: AiGatewayImageDetail;
  /** MIME type of data. Required with data. Allowed: image/jpeg, image/png, image/webp. */
  mimeType: string;
  /** OpenAI image URL (https). Not accepted yet, requests that set it are rejected with InvalidArgument. Use data instead. */
  url: string;
}

/**
 * Structured output specification for the json_schema response_format of OpenAI-compatible providers (Infomaniak, Scaleway).
 * See https://developer.infomaniak.com/docs/api/post/2/ai/%7Bproduct_id%7D/openai/v1/chat/completions
 */
export interface AiGatewayJsonSchemaResponseFormat {
  /** Optional human-readable description of the schema, passed to the provider to guide generation. */
  description?: string;
  /** Schema name sent to the provider (alphanumeric characters, underscores, and dashes only). */
  name: string;
  /** JSON Schema object describing the required response shape. */
  schema: object;
  /** Whether to enforce strict schema adherence. When unset, the gateway defaults to true. */
  strict: boolean;
}

export interface AiGatewayListUsageRecordsRequest {
  /** @format int64 */
  accountId: string;
  /** Optional. If empty, include all use cases. */
  filterUseCases?: AiGatewayAiUseCase[];
  /**
   * Start of period (inclusive), UNIX seconds.
   * @format int64
   */
  fromUnix: string;
  /**
   * Max records to return. Default 50, max 500.
   * @format int32
   */
  pageSize: number;
  /** Opaque cursor from previous response. */
  pageToken: string;
  /**
   * End of period (exclusive), UNIX seconds.
   * @format int64
   */
  toUnix: string;
}

export interface AiGatewayListUsageRecordsResponse {
  nextPageToken: string;
  records: AiGatewayAiUsageRecord[];
  /**
   * Total matching records (may be approximate for large ranges).
   * @format int32
   */
  totalCount: number;
}

/** @default "QUOTA_PERIOD_UNDEFINED" */
export enum AiGatewayQuotaPeriod {
  QUOTA_PERIOD_UNDEFINED = "QUOTA_PERIOD_UNDEFINED",
  QUOTA_PERIOD_DAILY = "QUOTA_PERIOD_DAILY",
  QUOTA_PERIOD_MONTHLY = "QUOTA_PERIOD_MONTHLY",
}

export interface AiGatewayRawCompleteResponse {
  content: string;
  finishReason: AiGatewayFinishReason;
  provider: AiGatewayAiProvider;
  resolvedModel: string;
  usage: AiGatewayTokenUsage;
}

/** @default "RESPONSE_FORMAT_UNDEFINED" */
export enum AiGatewayResponseFormat {
  RESPONSE_FORMAT_UNDEFINED = "RESPONSE_FORMAT_UNDEFINED",
  RESPONSE_FORMAT_TEXT = "RESPONSE_FORMAT_TEXT",
  RESPONSE_FORMAT_JSON = "RESPONSE_FORMAT_JSON",
}

export interface AiGatewaySetAccountSettingsResponse {
  settings: AiGatewayAiAccountSettings;
}

export interface AiGatewaySetQuotaResponse {
  quotas: AiGatewayAiQuota[];
}

export interface AiGatewayTokenUsage {
  /** @format int32 */
  completionTokens: number;
  /** @format int32 */
  promptTokens: number;
  /** @format int32 */
  totalTokens: number;
}

/** @default "FEEDBACK_RATING_UNDEFINED" */
export enum AiadvertGenerationFeedbackRating {
  FEEDBACK_RATING_UNDEFINED = "FEEDBACK_RATING_UNDEFINED",
  FEEDBACK_RATING_POSITIVE = "FEEDBACK_RATING_POSITIVE",
  FEEDBACK_RATING_NEGATIVE = "FEEDBACK_RATING_NEGATIVE",
}

export interface AiadvertGenerationGenerateRequest {
  objectId: string;
}

export interface AiadvertGenerationGenerateResponse {
  description: string;
  /** Feature-service ID for this generation. Use for feedback and regenerate. */
  generationId: string;
  /** Set when this result was produced by Regenerate; empty for initial Generate. */
  parentGenerationId: string;
  /** ai-gateway Complete requestId for usage/cost correlation. */
  requestId: string;
  title: string;
}

/** @default "FEEDBACK_RATING_UNDEFINED" */
export enum AiadvertImageFeedbackRating {
  FEEDBACK_RATING_UNDEFINED = "FEEDBACK_RATING_UNDEFINED",
  FEEDBACK_RATING_POSITIVE = "FEEDBACK_RATING_POSITIVE",
  FEEDBACK_RATING_NEGATIVE = "FEEDBACK_RATING_NEGATIVE",
}

export interface AiaiGatewayGetAccountSettingsResponse {
  settings: AiGatewayAiAccountSettings;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code: number;
  details: ProtobufAny[];
  message: string;
}

export interface ProtobufAny {
  "@type": string;
  [key: string]: any;
}

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 *
 *  - NULL_VALUE: Null value.
 * @default "NULL_VALUE"
 */
export enum ProtobufNullValue {
  NULL_VALUE = "NULL_VALUE",
}

export interface CalendarreminderCreateBulkRequest {
  activity: ReminderReminderActivity;
  /** For each bucket one reminder with all referenceIds in that bucket is created */
  buckets: ReminderReferenceBucket[];
  contactId: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  date: string;
  /**
   * UNIX timestamp in seconds when the reminder was set to done. 0=not done
   * @format int64
   */
  done: string;
  employeeUserId: string;
  /** @format int64 */
  ownerId: string;
  priority: ReminderReminderPriority;
  subject: string;
}

export type CalendarreminderCreateBulkResponse = object;

export interface CalendarreminderCreateRequest {
  activity: ReminderReminderActivity;
  contactId: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  date: string;
  /**
   * UNIX timestamp in seconds when the reminder was set to done. 0=not done
   * @format int64
   */
  done: string;
  employeeUserId: string;
  /** @format int64 */
  ownerId: string;
  priority: ReminderReminderPriority;
  /** IDs to which this reminder is attached to (e.g. requestId) */
  referenceIds: string[];
  subject: string;
}

export interface CalendarreminderCreateResponse {
  reminder: ReminderReminder;
}

export type CalendarreminderDeleteResponse = object;

export interface CalendarreminderGetResponse {
  reminder: ReminderReminder;
}

export interface CalendarreminderListByContactIdsRequest {
  contactIds: string[];
}

export interface CalendarreminderListByContactIdsResponse {
  reminders: ReminderReminder[];
}

export interface CalendarreminderListByReferenceIdsRequest {
  includeDone: boolean;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
}

export interface CalendarreminderListByReferenceIdsResponse {
  reminders: ReminderReminder[];
}

export interface CalendarreminderListResponse {
  reminders: ReminderReminder[];
}

export interface CalendarreminderUpdateRequest {
  activity: ReminderReminderActivity;
  contactId: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  date: string;
  /**
   * UNIX timestamp in seconds when the reminder was set to done. 0=not done
   * @format int64
   */
  done: string;
  employeeUserId: string;
  id: string;
  priority: ReminderReminderPriority;
  /** IDs to which this reminder is attached to (e.g. requestId) */
  referenceIds: string[];
  subject: string;
}

export type CalendarreminderUpdateResponse = object;

/** @default "PREFERRED_LANGUAGE_UNDEFINED" */
export enum LanguagePreferredLanguage {
  PREFERRED_LANGUAGE_UNDEFINED = "PREFERRED_LANGUAGE_UNDEFINED",
  PREFERRED_LANGUAGE_GERMAN = "PREFERRED_LANGUAGE_GERMAN",
  PREFERRED_LANGUAGE_ENGLISH = "PREFERRED_LANGUAGE_ENGLISH",
  PREFERRED_LANGUAGE_ITALIAN = "PREFERRED_LANGUAGE_ITALIAN",
  PREFERRED_LANGUAGE_FRENCH = "PREFERRED_LANGUAGE_FRENCH",
}

export interface NylasAttendee {
  contactId: string;
  displayName: string;
  email: string;
  status: NylasAttendeeStatus;
}

/** @default "ATTENDEE_STATUS_NEEDS_ACTION" */
export enum NylasAttendeeStatus {
  ATTENDEE_STATUS_NEEDS_ACTION = "ATTENDEE_STATUS_NEEDS_ACTION",
  ATTENDEE_STATUS_ACCEPTED = "ATTENDEE_STATUS_ACCEPTED",
  ATTENDEE_STATUS_DECLINED = "ATTENDEE_STATUS_DECLINED",
  ATTENDEE_STATUS_TENTATIVE = "ATTENDEE_STATUS_TENTATIVE",
}

export interface NylasCalendar {
  associatedEmail: string;
  id: string;
  name: string;
  nylasCalendarId: string;
  /** @format int64 */
  ownerId: string;
  provider: NylasAuthProvider;
  userId: string;
}

export interface NylasCreateEventRequest {
  attendees: NylasAttendee[];
  calendarId: string;
  description: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** If undefined the event will be during all day */
  endTime: TypeTimeOfDay;
  frequency: NylasEventFrequency;
  location: string;
  mediaIds: string[];
  /** If true, participants will be notified of the event creation */
  notifyParticipants: boolean;
  /** @format int32 */
  occurrenceCount: number;
  /** @format int64 */
  ownerId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceEndDate: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceStartDate: TypeDate;
  referenceIds: string[];
  reminders: NylasReminders[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  /** If undefined the event will be during all day */
  startTime: TypeTimeOfDay;
  title: string;
  userId: string;
  visibility: NylasVisibility;
}

export interface NylasCreateEventResponse {
  event: NylasEvent;
}

export type NylasDeleteEventResponse = object;

export interface NylasEvent {
  attendees: NylasAttendee[];
  calendarId: string;
  description: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** If undefined the event will be during all day */
  endTime: TypeTimeOfDay;
  frequency: NylasEventFrequency;
  iCalUid: string;
  id: string;
  location: string;
  masterEventId: string;
  mediaIds: string[];
  /** Represents the notify state of the last action on the event */
  notifyParticipants: boolean;
  /** @format int32 */
  occurrenceCount: number;
  organizer: NylasOrganizer;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceEndDate: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceStartDate: TypeDate;
  referenceIds: string[];
  reminders: NylasReminders[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  /** If undefined the event will be during all day */
  startTime: TypeTimeOfDay;
  status: NylasEventStatus;
  title: string;
  userId: string;
  visibility: NylasVisibility;
}

/** @default "EVENT_FREQUENCY_UNDEFINED" */
export enum NylasEventFrequency {
  EVENT_FREQUENCY_UNDEFINED = "EVENT_FREQUENCY_UNDEFINED",
  EVENT_FREQUENCY_DAILY = "EVENT_FREQUENCY_DAILY",
  EVENT_FREQUENCY_WEEKLY = "EVENT_FREQUENCY_WEEKLY",
  EVENT_FREQUENCY_MONTHLY = "EVENT_FREQUENCY_MONTHLY",
  EVENT_FREQUENCY_YEARLY = "EVENT_FREQUENCY_YEARLY",
}

/** @default "EVENT_STATUS_UNDEFINED" */
export enum NylasEventStatus {
  EVENT_STATUS_UNDEFINED = "EVENT_STATUS_UNDEFINED",
  EVENT_STATUS_TENTATIVE = "EVENT_STATUS_TENTATIVE",
  EVENT_STATUS_CONFIRMED = "EVENT_STATUS_CONFIRMED",
  EVENT_STATUS_CANCELLED = "EVENT_STATUS_CANCELLED",
}

export interface NylasGetEventByIcsResponse {
  event: NylasEvent;
}

export interface NylasListAvailableCalendarsResponse {
  calendars: NylasCalendar[];
}

export interface NylasListCalendarByUserIdResponse {
  calendar: NylasCalendar;
}

export interface NylasListCalendarsByUserIdsRequest {
  ids: string[];
}

export interface NylasListCalendarsByUserIdsResponse {
  calendars: NylasCalendar[];
}

export interface NylasListEventsRequest {
  /**
   * Optional filter parameter
   * Optional filter parameter
   */
  attendeeEmails?: string[];
  /**
   * Optional filter parameter
   * Optional filter parameter
   */
  endDate?: TypeDate;
  /** @format int64 */
  ownerId: string;
  /**
   * Optional filter parameter
   * Optional filter parameter
   */
  referenceIds?: string[];
  /**
   * Optional sort parameter
   * Optional sort parameter
   */
  sortStart?: SortSortOrder;
  /**
   * Optional filter parameter
   * Optional filter parameter
   */
  startDate?: TypeDate;
  userIds: string[];
}

export interface NylasListEventsResponse {
  events: NylasEvent[];
}

export interface NylasOrganizer {
  email: string;
  name: string;
}

/** @default "REMINDER_METHOD_UNDEFINED" */
export enum NylasReminderMethod {
  REMINDER_METHOD_UNDEFINED = "REMINDER_METHOD_UNDEFINED",
  REMINDER_METHOD_EMAIL = "REMINDER_METHOD_EMAIL",
  REMINDER_METHOD_POPUP = "REMINDER_METHOD_POPUP",
  REMINDER_METHOD_SOUND = "REMINDER_METHOD_SOUND",
  REMINDER_METHOD_DISPLAY = "REMINDER_METHOD_DISPLAY",
}

export interface NylasReminders {
  method: NylasReminderMethod;
  /** @format int64 */
  reminderMinutes: string;
}

export interface NylasResolveCalendarByEmailResponse {
  calendar: NylasCalendar;
}

export interface NylasSendRSVPRequest {
  calendarId: string;
  eventId: string;
  iCalUid: string;
  status: NylasAttendeeStatus;
  userId: string;
}

export type NylasSendRSVPResponse = object;

export interface NylasSetCalendarRequest {
  nylasCalendarId: string;
}

export interface NylasSetCalendarResponse {
  calendar: NylasCalendar;
}

export interface NylasUpdateEventRequest {
  attendees: NylasAttendee[];
  description: string;
  editFollowing: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** If undefined the event will be during all day */
  endTime: TypeTimeOfDay;
  frequency: NylasEventFrequency;
  id: string;
  location: string;
  mediaIds: string[];
  /** If true, participants will be notified of the event update */
  notifyParticipants: boolean;
  /** @format int32 */
  occurrenceCount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceEndDate: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  recurrenceStartDate: TypeDate;
  referenceIds: string[];
  reminders: NylasReminders[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  /** If undefined the event will be during all day */
  startTime: TypeTimeOfDay;
  title: string;
  userId: string;
  visibility: NylasVisibility;
}

export interface NylasUpdateEventResponse {
  event: NylasEvent;
}

/** @default "EVENT_VISIBILITY_UNDEFINED" */
export enum NylasVisibility {
  EVENT_VISIBILITY_UNDEFINED = "EVENT_VISIBILITY_UNDEFINED",
  EVENT_VISIBILITY_PRIVATE = "EVENT_VISIBILITY_PRIVATE",
  EVENT_VISIBILITY_PUBLIC = "EVENT_VISIBILITY_PUBLIC",
}

/** @default "PROVIDER_UNDEFINED" */
export enum NylasAuthProvider {
  PROVIDER_UNDEFINED = "PROVIDER_UNDEFINED",
  PROVIDER_GOOGLE = "PROVIDER_GOOGLE",
  PROVIDER_MICROSOFT = "PROVIDER_MICROSOFT",
  PROVIDER_IMAP = "PROVIDER_IMAP",
  PROVIDER_ICLOUD = "PROVIDER_ICLOUD",
  PROVIDER_VIRTUAL_CALENDAR = "PROVIDER_VIRTUAL_CALENDAR",
}

export interface ReminderCountDueRemindersResponse {
  /** @format int32 */
  count: number;
}

export interface ReminderCountUndoneRemindersResponse {
  /** @format int32 */
  count: number;
}

export interface ReminderReferenceBucket {
  referenceIds: string[];
}

export interface ReminderReminder {
  activity: ReminderReminderActivity;
  contactId: string;
  creatorUserId: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  date: string;
  /**
   * UNIX timestamp in seconds when the reminder was set to done. 0=not done
   * @format int64
   */
  done: string;
  employeeUserId: string;
  id: string;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  priority: ReminderReminderPriority;
  /** ID to which this reminder is attached to (e.g. requestId) */
  referenceIds: string[];
  subject: string;
}

/** @default "UNDEFINED_REMINDER_ACTIVITY" */
export enum ReminderReminderActivity {
  UNDEFINED_REMINDER_ACTIVITY = "UNDEFINED_REMINDER_ACTIVITY",
  CALL_REMINDER_ACTIVITY = "CALL_REMINDER_ACTIVITY",
  MAIL_REMINDER_ACTIVITY = "MAIL_REMINDER_ACTIVITY",
  POST_REMINDER_ACTIVITY = "POST_REMINDER_ACTIVITY",
  TODO_REMINDER_ACTIVITY = "TODO_REMINDER_ACTIVITY",
  TO_DISCUSS_REMINDER_ACTIVITY = "TO_DISCUSS_REMINDER_ACTIVITY",
  TO_READ_THROUGH_REMINDER_ACTIVITY = "TO_READ_THROUGH_REMINDER_ACTIVITY",
}

/** @default "NORMAL_REMINDER_PRIORITY" */
export enum ReminderReminderPriority {
  NORMAL_REMINDER_PRIORITY = "NORMAL_REMINDER_PRIORITY",
  LOW_REMINDER_PRIORITY = "LOW_REMINDER_PRIORITY",
  HIGH_REMINDER_PRIORITY = "HIGH_REMINDER_PRIORITY",
}

export interface ReminderSetDoneRequest {
  ids: string[];
}

export type ReminderSetDoneResponse = object;

export interface ReminderSetUnDoneRequest {
  ids: string[];
}

export type ReminderSetUnDoneResponse = object;

export interface ReminderUpdateDateRequest {
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  date: string;
  ids: string[];
}

export type ReminderUpdateDateResponse = object;

export interface ReminderUpdateEmployeeRequest {
  employeeUserId: string;
  ids: string[];
}

export type ReminderUpdateEmployeeResponse = object;

export interface ReminderUpdatePriorityRequest {
  ids: string[];
  priority: ReminderReminderPriority;
}

export type ReminderUpdatePriorityResponse = object;

export interface SchedulerAppointment {
  /** Optional. If set the appointment is automatically added to that calendar as normal event. */
  calendarUserId?: string;
  /** Can be either a userId if created by PROPbase customer or a contactId if created by external person */
  creatorId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  endTime: TypeTimeOfDay;
  id: string;
  /** @format int32 */
  maxParticipants: number;
  objectId: string;
  participants: SchedulerAppointmentParticipant[];
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  startTime: TypeTimeOfDay;
  status: SchedulerAppointmentStatus;
}

export interface SchedulerAppointmentParticipant {
  contactId: string;
  email: string;
  firstName: string;
  id: string;
  /** The language the participant used on the public form. Mails to the participant are written in it. Undefined for participants registered before this field existed. */
  language: LanguagePreferredLanguage;
  lastName: string;
  phone: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  registeredAt: string;
  requestId: string;
}

export interface SchedulerAppointmentSlot {
  /** Can be either a userId if created by PROPbase customer or a contactId if created by external person */
  creatorId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  endTime: TypeTimeOfDay;
  id: string;
  /** True when the on-site contact person leads the appointment (calendarUserId on the Appointment is empty) and that contact is a tenant of the object's current tenancy. Interested parties see start and end time for these slots and only the start time for all others. */
  ledByTenant: boolean;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  startTime: TypeTimeOfDay;
  status: SchedulerAppointmentStatus;
}

export interface SchedulerAppointmentSlotInput {
  /** Optional. If set the appointment is automatically added to that calendar as normal event. */
  calendarUserId?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  endTime: TypeTimeOfDay;
  /**
   * Optional. If set then an appointment is not shown after set amount of participants.
   * @format int32
   */
  maxParticipants?: number;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  startTime: TypeTimeOfDay;
}

/**
 * - APPOINTMENT_STATUS_SCHEDULED: Appointment is planned for the future
 *  - APPOINTMENT_STATUS_CONDUCTED: Appointment took place before today
 *  - APPOINTMENT_STATUS_CANCELLED: Appointment was cancelled
 * @default "APPOINTMENT_STATUS_UNDEFINED"
 */
export enum SchedulerAppointmentStatus {
  APPOINTMENT_STATUS_UNDEFINED = "APPOINTMENT_STATUS_UNDEFINED",
  APPOINTMENT_STATUS_SCHEDULED = "APPOINTMENT_STATUS_SCHEDULED",
  APPOINTMENT_STATUS_CONDUCTED = "APPOINTMENT_STATUS_CONDUCTED",
  APPOINTMENT_STATUS_CANCELLED = "APPOINTMENT_STATUS_CANCELLED",
}

export interface SchedulerCancelAppointmentsRequest {
  ids: string[];
}

export interface SchedulerCancelAppointmentsResponse {
  appointments: SchedulerAppointment[];
}

export interface SchedulerCancelRegistrationRequest {
  /** The participant to unregister. Must belong to an appointment of the object the token was issued for. */
  participantId: string;
  token: string;
}

export type SchedulerCancelRegistrationResponse = object;

export interface SchedulerCreateAppointmentsRequest {
  objectId: string;
  slots: SchedulerAppointmentSlotInput[];
}

export interface SchedulerCreateAppointmentsResponse {
  appointments: SchedulerAppointment[];
}

export interface SchedulerCreateTokenForRequestingAppointmentsRequest {
  /** The contactId of the person who is requested to create the appointments. */
  contactId: string;
  objectId: string;
}

export interface SchedulerCreateTokenForRequestingAppointmentsResponse {
  token: string;
}

export interface SchedulerGetAppointmentResponse {
  appointment: SchedulerAppointment;
}

export interface SchedulerGetAvailableSlotsResponse {
  /** Includes only slots that are in future and not full already. */
  availableSlots: SchedulerAppointmentSlot[];
  objectId: string;
}

export interface SchedulerGetRegistrationResponse {
  objectId: string;
  /** Only the requesting participant, never the other participants of the slot. Unset together with slot when the registration can no longer be displayed - the participant was unregistered, the appointment was deleted or cancelled, or the slot is in the past. That is not an error: the caller falls back to the unpersonalized flow and lets the participant pick a slot again. */
  participant: SchedulerAppointmentParticipant;
  /** The slot the participant is registered for. A slot rather than a full Appointment on purpose: the other participants of the same slot must not be exposed to a public caller. Unset when there is nothing to display - see participant. */
  slot: SchedulerAppointmentSlot;
}

export interface SchedulerGetReminderConfigResponse {
  /**
   * Number of hours before the appointment when the reminder should be sent
   * @format int32
   */
  hoursBeforeAppointment: number;
  mailboxId: string;
}

export interface SchedulerGetSenderMailboxResponse {
  /** Empty means no mailbox is configured and a PROPbase generated no-reply address is used as sender */
  mailboxId: string;
}

export interface SchedulerGetTokenForRegisteringResponse {
  token: string;
}

export interface SchedulerListAppointmentsByObjectIdRequest {
  objectId: string;
}

export interface SchedulerListAppointmentsByObjectIdResponse {
  appointments: SchedulerAppointment[];
}

export interface SchedulerListAppointmentsByTokenResponse {
  appointments: SchedulerAppointment[];
  objectId: string;
}

export interface SchedulerSetReminderConfigRequest {
  /** @format int64 */
  accountId: string;
  /**
   * Number of hours before the appointment when the reminder should be sent
   * @format int32
   */
  hoursBeforeAppointment: number;
  mailboxId: string;
}

export type SchedulerSetReminderConfigResponse = object;

export interface SchedulerSetSenderMailboxRequest {
  /** @format int64 */
  accountId: string;
  /** Empty clears the configuration and falls back to a PROPbase generated no-reply address */
  mailboxId: string;
}

export type SchedulerSetSenderMailboxResponse = object;

export interface SchedulerSubmitRequestedAppointmentsRequest {
  slots: SchedulerAppointmentSlotInput[];
  token: string;
}

export interface SchedulerSubmitRequestedAppointmentsResponse {
  appointments: SchedulerAppointment[];
}

export interface SchedulerSubmitSlotSelectionRequest {
  appointmentId: string;
  email: string;
  firstName: string;
  /** Optional. The language the form is displayed in. Mails to the participant are written in it; if undefined, the preferred language of the linked contact is used. */
  language?: LanguagePreferredLanguage;
  lastName: string;
  phone: string;
  token: string;
}

export interface SchedulerSubmitSlotSelectionResponse {
  participant: SchedulerAppointmentParticipant;
}

export interface SchedulerUnregisterParticipantRequest {
  appointmentId: string;
  participantId: string;
}

export type SchedulerUnregisterParticipantResponse = object;

export interface SchedulerUpdateMaxParticipantsRequest {
  appointmentId: string;
  /**
   * Optional. If unset the limit is removed and the appointment accepts an unlimited number of participants.
   * @format int32
   */
  maxParticipants?: number;
}

export interface SchedulerUpdateMaxParticipantsResponse {
  appointment: SchedulerAppointment;
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortSortOrder {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 */
export interface TypeDate {
  /**
   * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
   * to specify a year by itself or a year and month where the day isn't
   * significant.
   * @format int32
   */
  day: number;
  /**
   * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
   * month and day.
   * @format int32
   */
  month: number;
  /**
   * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
   * a year.
   * @format int32
   */
  year: number;
}

/**
 * Represents a time of day. The date and time zone are either not significant
 * or are specified elsewhere. An API may choose to allow leap seconds. Related
 * types are [google.type.Date][google.type.Date] and
 * `google.protobuf.Timestamp`.
 */
export interface TypeTimeOfDay {
  /**
   * Hours of day in 24 hour format. Should be from 0 to 23. An API may choose
   * to allow the value "24:00:00" for scenarios like business closing time.
   * @format int32
   */
  hours: number;
  /**
   * Minutes of hour of day. Must be from 0 to 59.
   * @format int32
   */
  minutes: number;
  /**
   * Fractions of seconds in nanoseconds. Must be from 0 to 999,999,999.
   * @format int32
   */
  nanos: number;
  /**
   * Seconds of minutes of the time. Must normally be from 0 to 59. An API may
   * allow the value 60 if it allows leap-seconds.
   * @format int32
   */
  seconds: number;
}

/** @default "UNKNOWN" */
export enum HealthCheckResponseServingStatus {
  UNKNOWN = "UNKNOWN",
  SERVING = "SERVING",
  NOT_SERVING = "NOT_SERVING",
}

export interface AddressGeo {
  /** @format float */
  elevation?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface AicAddInsurancePoliceDocumentRequest {
  /** The ID of the insurance this file should be attached to. */
  insuranceId: string;
  /** The ID of the media file. */
  mediaId: string;
}

export interface AicAddInsurancePoliceDocumentResponse {
  /** The ID of the document where the file was attached to. */
  documentId: string;
}

export interface AicAddInvoiceDocumentRequest {
  /** The ID of the insurance this file should be attached to. */
  insuranceId: string;
  /** The ID of the media file. */
  mediaId: string;
}

export interface AicAddInvoiceDocumentResponse {
  /** The ID of the document where the file was attached to. */
  documentId: string;
}

export interface AicAddLossRatioDocumentRequest {
  /** The ID of the insurance this file should be attached to. */
  insuranceId: string;
  /** The ID of the media file. */
  mediaId: string;
}

export interface AicAddLossRatioDocumentResponse {
  /** The ID of the document where the file was attached to. */
  documentId: string;
}

export interface AicAdditionalFileAttribute {
  fileCaused: string;
  fileDate: string;
  fileFirmaName: string;
  /** @format int32 */
  id: number;
}

/** @default "AIC_LANDING_PAGE_DASHBOARD" */
export enum AicAicLandingPage {
  AIC_LANDING_PAGE_DASHBOARD = "AIC_LANDING_PAGE_DASHBOARD",
  AIC_LANDING_PAGE_PROPERTY_OVERVIEW = "AIC_LANDING_PAGE_PROPERTY_OVERVIEW",
  AIC_LANDING_PAGE_PROPERTY_DETAILS = "AIC_LANDING_PAGE_PROPERTY_DETAILS",
  AIC_LANDING_PAGE_DAMAGES_OVERVIEW = "AIC_LANDING_PAGE_DAMAGES_OVERVIEW",
  AIC_LANDING_PAGE_DAMAGES_DETAILS = "AIC_LANDING_PAGE_DAMAGES_DETAILS",
  AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT = "AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT",
  AIC_LANDING_PAGE_INSURANCE = "AIC_LANDING_PAGE_INSURANCE",
  AIC_LANDING_PAGE_FASTLANE = "AIC_LANDING_PAGE_FASTLANE",
}

/** @default "AIC_SYNC_MODE_DISABLED" */
export enum AicAicSyncMode {
  AIC_SYNC_MODE_DISABLED = "AIC_SYNC_MODE_DISABLED",
  AIC_SYNC_MODE_ENABLED_WITHOUT_SUPPORT = "AIC_SYNC_MODE_ENABLED_WITHOUT_SUPPORT",
  AIC_SYNC_MODE_ENABLED_WITH_SUPPORT_NOT_CONFIRMED = "AIC_SYNC_MODE_ENABLED_WITH_SUPPORT_NOT_CONFIRMED",
  AIC_SYNC_MODE_ENABLED_WITH_SUPPORT_CONFIRMED = "AIC_SYNC_MODE_ENABLED_WITH_SUPPORT_CONFIRMED",
}

export interface AicConfirmAicSupportRequest {
  propertyIds: string[];
}

export type AicConfirmAicSupportResponse = object;

export interface AicContactExtraData {
  floor: string;
}

export interface AicCreateDamageReportRequest {
  attributes: AicDamageReportAttributes;
  /** @format int32 */
  id: number;
  /** @format int32 */
  moduleObjectId: number;
  name: string;
  propbaseTicketId: string;
  userid: string;
}

export interface AicCreateDamageReportResponse {
  ticketId: string;
}

export interface AicCreateDocumentRequest {
  /** The ID of the insurance this document should be attached to. */
  insuranceId: string;
  /** The ID of the media file. */
  mediaId: string;
  /** The name of the document. */
  name: string;
  /** The type of the document. */
  type: MediadocumentType;
}

export interface AicCreateDocumentResponse {
  /** The ID of the created and attached document. */
  documentId: string;
}

export interface AicCreateInsuranceRequest {
  /**
   * The AIC policy ID
   * @format int64
   */
  aicId: string;
  /** @format float */
  amount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** @format float */
  excess: number;
  /** @format int64 */
  insuranceWorkspaceId: string;
  policyNumber: string;
  /** The propbase propertyId (prop_xxxxx) where this insurance should be attached to */
  referenceId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  type: InsuranceInsuranceType;
  /** @format float */
  yearlyCosts: number;
}

export interface AicCreateInsuranceResponse {
  insurance: InsuranceInsurance;
}

export interface AicCreateNoteRequest {
  mediaIds: string[];
  note: string;
  ticketId: string;
  userId: string;
}

export interface AicCreateNoteResponse {
  note: NoteNote;
}

export interface AicDamageReportAttributes {
  accountHolder: string;
  additionalFileAttributes: AicAdditionalFileAttribute[];
  areInjuriesPresent: string;
  bankDetailedInfo: string;
  bankIBAN: string;
  bankName: string;
  contacts: CommonaicContactData[];
  /** @format int32 */
  damageAppointment: number;
  damageCaution: string;
  damageClaimNumber: string;
  damageDate: string;
  damageDetails: string;
  /** @format int32 */
  damageNumberRequested: number;
  damageState: string;
  description: string;
  extentOfDamage: string;
  injuryDescription: string;
  /** @format int32 */
  insideTheBuilding: number;
  isDamageRepaired: string;
  numberOfFlats: string;
  onsiteRequested: string;
  /** @format int32 */
  outsideTheBuilding: number;
  regulation: string;
}

export interface AicEnableAicRequest {
  /** @format int64 */
  accountId: string;
  enable: boolean;
}

export type AicEnableAicResponse = object;

export interface AicGetSyncModeForAccountsByPropertyIdResponse {
  /** accountId -> AicSyncMode */
  syncModes: Record<string, AicAicSyncMode>;
}

export interface AicGetSyncModeForPropertiesRequest {
  /** @format int64 */
  accountId: string;
  propertyIds: string[];
}

export interface AicGetSyncModeForPropertiesResponse {
  /** propertyId -> AicSyncMode */
  syncModes: Record<string, AicAicSyncMode>;
}

export interface AicHasAicEnabledResponse {
  enabled: boolean;
}

export interface AicSetSyncModeBucket {
  propertyIds: string[];
  syncMode: AicAicSyncMode;
}

export interface AicSetSyncModeForPropertiesRequest {
  /** @format int64 */
  accountId: string;
  buckets: AicSetSyncModeBucket[];
}

export type AicSetSyncModeForPropertiesResponse = object;

export interface AicUpdateInsuranceResponse {
  insurance: InsuranceInsurance;
}

export interface AileanActivatePropertiesRequest {
  /** @format int64 */
  accountId: string;
  propertyIds: string[];
}

export type AileanActivatePropertiesResponse = object;

export interface AileanActivationEntry {
  /** @format int64 */
  accountId: string;
  propertyId: string;
}

export interface AileanCreateTicketCommentRequest {
  /** @format int64 */
  accountId: string;
  /** If true, the comment is only visible within the account (internal note). */
  accountInternal: boolean;
  comment: string;
  mediaIds: string[];
  ticketId: string;
}

export interface AileanCreateTicketCommentResponse {
  comment: NoteNote;
}

export interface AileanCreateTicketRequest {
  /** @format int64 */
  accountId: string;
  createRequest: TicketticketCreateRequest;
}

export interface AileanCreateTicketResponse {
  createResponse: TicketticketCreateResponse;
}

export interface AileanDeactivatePropertiesRequest {
  /** @format int64 */
  accountId: string;
  propertyIds: string[];
}

export type AileanDeactivatePropertiesResponse = object;

export interface AileanEmployee {
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  roles: string[];
}

export interface AileanEnableAileanRequest {
  /** @format int64 */
  accountId: string;
  enable: boolean;
}

export type AileanEnableAileanResponse = object;

export interface AileanGetTenantsByAccountIdResponse {
  tenants: CommonaileanTenant[];
}

export interface AileanGetTicketResponse {
  ticket: TicketTicket;
}

export interface AileanHasAileanEnabledResponse {
  enabled: boolean;
}

export interface AileanListEmployeesByAccountIdResponse {
  employees: AileanEmployee[];
}

export interface AileanListPropertiesByAccountIdResponse {
  properties: AileanPropertyWithContacts[];
}

export interface AileanListPropertyActivationsRequest {
  propertyIds: string[];
}

export interface AileanListPropertyActivationsResponse {
  /** List of property that are activated. Missing properties are not activated. */
  entries: AileanActivationEntry[];
}

export interface AileanListTicketCommentsResponse {
  comments: NoteNote[];
}

export interface AileanPropertyWithContacts {
  address: CommonaddressAddress;
  assigneeAdmin: CommonaileanAssignee;
  contacts: CommonaileanContact[];
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  /** Display name of the property owner (account). */
  ownerName: string;
}

export interface AileanUpdateTicketRequest {
  updateRequest: TicketticketUpdateRequest;
}

export interface AileanUpdateTicketResponse {
  updateResponse: TicketticketUpdateResponse;
}

/** @default "UNDEFINED_VALUE" */
export enum ApplicableApplicable {
  UNDEFINED_VALUE = "UNDEFINED_VALUE",
  APPLIES = "APPLIES",
  DOES_NOT_APPLY = "DOES_NOT_APPLY",
}

/** @default "BUILDING_CONTACT_TYPE_UNDEFINED" */
export enum BuildingBuildingContactType {
  BUILDING_CONTACT_TYPE_UNDEFINED = "BUILDING_CONTACT_TYPE_UNDEFINED",
  BUILDING_CONTACT_TYPE_CRAFTSMAN = "BUILDING_CONTACT_TYPE_CRAFTSMAN",
  BUILDING_CONTACT_TYPE_JANITOR = "BUILDING_CONTACT_TYPE_JANITOR",
  BUILDING_CONTACT_TYPE_SERVICE_PROVIDER = "BUILDING_CONTACT_TYPE_SERVICE_PROVIDER",
  BUILDING_CONTACT_TYPE_DELEGATE = "BUILDING_CONTACT_TYPE_DELEGATE",
  BUILDING_CONTACT_TYPE_REVISOR = "BUILDING_CONTACT_TYPE_REVISOR",
  BUILDING_CONTACT_TYPE_TENANT_CHANGE = "BUILDING_CONTACT_TYPE_TENANT_CHANGE",
  BUILDING_CONTACT_TYPE_OWNER = "BUILDING_CONTACT_TYPE_OWNER",
}

export interface CommonaddressAddress {
  careOf: string;
  city: string;
  country: string;
  geo: AddressGeo;
  mailbox: string;
  state: string;
  street: string;
  streetAddition: string;
  streetNumber: string;
  subUnit: string;
  zip: string;
}

export interface CommonaicContactData {
  Data: AicContactExtraData;
  Type: string;
  city: string;
  email: string;
  firstname: string;
  homepage: string;
  housenumber: string;
  lastname: string;
  phone: string;
  plot: string;
  region: string;
  salutation: string;
  street: string;
  uid: string;
  zip: string;
}

export interface CommonaicGetJwtPublicKeyResponse {
  /** The public key in PEM format (base64 encoded). */
  publicKey: string;
}

export interface CommonaicGetSsoUrlResponse {
  url: string;
}

export interface CommonaileanAssignee {
  emails: string[];
  id: string;
  name: string;
  phoneNumbers: string[];
  userId: string;
}

export interface CommonaileanBuilding {
  id: string;
}

export interface CommonaileanContact {
  emails: string[];
  id: string;
  industries: IndustryIndustry[];
  isCompany: boolean;
  linkedAs: BuildingBuildingContactType;
  name: string;
  phoneNumbers: string[];
  preferredLanguage: LanguagePreferredLanguage;
}

export interface CommonaileanContract {
  /** @format float */
  additionalCostsPerMonthChf: number;
  address: CommonaddressAddress;
  building: CommonaileanBuilding;
  /** @format float */
  depositChf: number;
  /** Optional end date of the contract. If not set, the contract is considered to be ongoing. */
  endDate?: TypeDate;
  id: string;
  isVacancy: boolean;
  /** @format float */
  netRentPerMonthChf: number;
  object: CommonaileanObject;
  property: CommonaileanProperty;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  typeOfUse: ObjecttenancyTypeOfUse;
}

export interface CommonaileanGetJwtPublicKeyResponse {
  /** The public key in PEM format (base64 encoded). */
  publicKey: string;
}

export interface CommonaileanGetSsoUrlResponse {
  url: string;
}

export interface CommonaileanObject {
  /**
   * The AWN (amtliche/administrative Wohnungsnummer) of the object issued by the federal government.
   * @format int64
   */
  awn: string;
  category: ObjectCategory;
  /** The EWID (Eidgenössische Wohnungsidentifikationsnummer) of the object issued by the federal government. */
  ewid: string;
  /**
   * Floor number where the object is located. Can also be negative for underground floors or 0.5 for mezzanine.
   * @format float
   */
  floor: number;
  id: string;
  /**
   * Living area in square meters.
   * @format float
   */
  livingArea: number;
  /** Name of the object as assigned by the property manager. */
  name: string;
  /** Object number assigned by the property manager. */
  number: string;
  subCategories: ObjectSubCategory[];
}

export interface CommonaileanProperty {
  address: CommonaddressAddress;
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  /** Display name of the property owner (account). */
  ownerName: string;
}

export interface CommonaileanTenant {
  contracts: CommonaileanContract[];
  emails: string[];
  id: string;
  name: string;
  phoneNumbers: string[];
}

export interface CommondeepoGetPartnerAccessUrlResponse {
  url: string;
}

export interface CommondeepoIssuer {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export interface CommondeepsignGetPartnerAccessUrlResponse {
  url: string;
}

export interface CommondeepsignHasDocumentSignatureEnabledResponse {
  enabled: boolean;
}

export interface CommondeepsignIssuer {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export interface CommondeepsignSignRequest {
  attachToReferenceIds: string[];
  cancelled: boolean;
  cancelledMessage: string;
  completed: boolean;
  /** @format int64 */
  created: string;
  documentType: MediadocumentType;
  id: string;
  issuer: CommondeepsignIssuer;
  legalWeight: DeepsignLegalWeight;
  mediaIds: string[];
  name: string;
  note: string;
  signedMediaId: string;
  signers: DeepsignSigner[];
}

export type CommonevorestEnableResponse = object;

export interface CommonevorestGetAccountSettingsResponse {
  allowInvestment: ApplicableApplicable;
  allowSwissCaution: boolean;
  apiKey: string;
  enabled: boolean;
}

export interface CommonevorestGetDepositInfoResponse {
  evorestLink: string;
  hasDeposit: boolean;
}

export interface CommonevorestHasEnabledResponse {
  allowSwissCaution: boolean;
  enabled: boolean;
}

export interface CommonevorestOpenDepositRequest {
  allowInvestment: boolean;
  /** Only required if tenant is a company. */
  contactPersonId: string;
  objectId: string;
  tenancyId: string;
}

export type CommonevorestOpenDepositResponse = object;

export type CommonfirstcautionEnableResponse = object;

export interface CommonfirstcautionGetDepositInfoResponse {
  firstcautionLink: string;
  hasDeposit: boolean;
}

export interface CommonfirstcautionHasEnabledResponse {
  enabled: boolean;
}

export interface CommonfirstcautionOpenDepositRequest {
  /** Only required if tenant is a company. */
  contactPersonId: string;
  objectId: string;
  tenancyId: string;
}

export type CommonfirstcautionOpenDepositResponse = object;

export type CommongocautionEnableResponse = object;

export interface CommongocautionGetAccountSettingsResponse {
  /** Only returned for platform employees. */
  clientId: string;
  /** Only returned for platform employees. */
  clientSecret: string;
  enabled: boolean;
  loginUrl: string;
}

export interface CommongocautionGetDepositInfoResponse {
  gocautionLink: string;
  hasDeposit: boolean;
}

export interface CommongocautionHasEnabledResponse {
  enabled: boolean;
}

export interface CommongocautionOpenDepositRequest {
  /** Only required if tenant is a company. */
  contactPersonId: string;
  objectId: string;
  tenancyId: string;
}

export type CommongocautionOpenDepositResponse = object;

export interface Commonm2MGetTokenRequest {
  audience: string;
  clientId: string;
  clientSecret: string;
}

export interface Commonm2MGetTokenResponse {
  accessToken: string;
  /** @format int64 */
  expiresIn: string;
  scope: string;
  tokenType: string;
}

export interface CommonnoteCreateRequest {
  accountInternal: boolean;
  mediaIds: string[];
  mentions: NoteMention[];
  note: string;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
}

export interface CommonnoteCreateResponse {
  note: NoteNote;
}

export interface CommonnoteCreator {
  /** @format int64 */
  creatorId: string;
  email: string;
  name: string;
  profilePictureUrl: string;
  userId: string;
}

export type CommonnoteDeleteResponse = object;

export interface CommonnoteListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface CommonnoteListByReferenceIdsResponse {
  notes: NoteNote[];
}

export interface CommonnoteUpdateResponse {
  note: NoteNote;
}

/** @default "COST_ABSORPTION_UNDEFINED" */
export enum CostCostAbsorption {
  COST_ABSORPTION_UNDEFINED = "COST_ABSORPTION_UNDEFINED",
  COST_ABSORPTION_OWNER = "COST_ABSORPTION_OWNER",
  COST_ABSORPTION_TENANT = "COST_ABSORPTION_TENANT",
  COST_ABSORPTION_NOT_CLEAR = "COST_ABSORPTION_NOT_CLEAR",
}

/** @default "COST_SHARE_UNIT_UNDEFINED" */
export enum CostCostShareUnit {
  COST_SHARE_UNIT_UNDEFINED = "COST_SHARE_UNIT_UNDEFINED",
  COST_SHARE_UNIT_PERCENT = "COST_SHARE_UNIT_PERCENT",
  COST_SHARE_UNIT_FIXED = "COST_SHARE_UNIT_FIXED",
}

export interface CredittrustGetCertificateResponse {
  /** @format byte */
  certificate: string;
}

export interface CredittrustIdentification {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  firstName: string;
  lastName: string;
}

export interface CredittrustOrderCertificateRequest {
  affiliateOrderId: string;
  city: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  email: string;
  firstName: string;
  houseNumber: string;
  lastName: string;
  locale: string;
  oldCity: string;
  oldHouseNumber: string;
  /** @format int32 */
  oldPostalCode: number;
  oldStreet: string;
  /** @format int32 */
  postalCode: number;
  referrerUrl: string;
  street: string;
  subAffiliate: string;
}

export interface CredittrustOrderCertificateResponse {
  certificateIssuable: boolean;
  crifApproval: boolean;
  crifMatch: boolean;
  intrumApproval: boolean;
  intrumMatch: boolean;
  orderId: string;
}

export interface CredittrustVerification {
  fileHash: string;
  issuerName: string;
  issuerVerified: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  registeredAt: TypeDate;
}

export interface CredittrustVerifyCertificateRequest {
  certificate: string;
}

export interface CredittrustVerifyCertificateResponse {
  identification: CredittrustIdentification;
  verification: CredittrustVerification;
}

export interface DeepoAnalyseNodeStatusResponse {
  finished: boolean;
}

export interface DeepoFileTransmission {
  /** @format int64 */
  created: string;
  editorUrl: string;
  id: string;
  issuer: CommondeepoIssuer;
  mediaId: string;
  processed: boolean;
  referenceIds: string[];
}

export interface DeepoGetFileTransmissionsByReferenceIdResponse {
  fileTransmissions: DeepoFileTransmission[];
}

export interface DeepoHasDeepoEnabledResponse {
  enabled: boolean;
}

export interface DeepoRepairServiceAccountRequest {
  /** @format int64 */
  accountId: string;
}

export interface DeepoRepairServiceAccountResponse {
  message: string;
  success: boolean;
}

export interface DeepoSendFileRequest {
  mediaId: string;
  referenceIds: string[];
}

export interface DeepoSendFileResponse {
  fileTransmission: DeepoFileTransmission;
}

export type DeepsignCancelSignRequestResponse = object;

export interface DeepsignCountOpenSignRequestsResponse {
  /** @format int32 */
  amount: number;
}

export interface DeepsignDownloadFileResponse {
  /** @format byte */
  pdf: string;
}

/** @default "LEGAL_WEIGHT_STANDARD" */
export enum DeepsignLegalWeight {
  LEGAL_WEIGHT_STANDARD = "LEGAL_WEIGHT_STANDARD",
  LEGAL_WEIGHT_PROFESSIONAL = "LEGAL_WEIGHT_PROFESSIONAL",
  LEGAL_WEIGHT_QUALIFIED = "LEGAL_WEIGHT_QUALIFIED",
}

export interface DeepsignListSignRequestsByAttachToReferenceIdsRequest {
  referenceIds: string[];
}

export interface DeepsignListSignRequestsByAttachToReferenceIdsResponse {
  signRequests: CommondeepsignSignRequest[];
}

export interface DeepsignListSignRequestsResponse {
  signRequests: CommondeepsignSignRequest[];
}

export interface DeepsignSignDocumentRequest {
  /** @format int64 */
  accountId: string;
  attachToReferenceIds: string[];
  documentType: MediadocumentType;
  legalWeight: DeepsignLegalWeight;
  mediaIds: string[];
  name: string;
  note: string;
  signers: DeepsignSignerEntry[];
}

export interface DeepsignSignDocumentResponse {
  signRequest: CommondeepsignSignRequest;
}

export interface DeepsignSigner {
  contactId: string;
  /** @format int32 */
  order: number;
  signed: boolean;
}

export interface DeepsignSignerEntry {
  contactId: string;
  /** @format int32 */
  order: number;
}

export interface EvorestGetOwnerConfigResponse {
  allowInvestment: ApplicableApplicable;
}

export type EvorestSetOwnerConfigResponse = object;

/** @default "INDUSTRY_UNDEFINED_VALUE" */
export enum IndustryIndustry {
  INDUSTRY_UNDEFINED_VALUE = "INDUSTRY_UNDEFINED_VALUE",
  INDUSTRY_LIVING_FURNISHING_HOUSEHOLD_APPLIANCES = "INDUSTRY_LIVING_FURNISHING_HOUSEHOLD_APPLIANCES",
  INDUSTRY_LIVING_FURNISHING_MAINTENANCE = "INDUSTRY_LIVING_FURNISHING_MAINTENANCE",
  INDUSTRY_LIVING_FURNISHING_REAL_ESTATE = "INDUSTRY_LIVING_FURNISHING_REAL_ESTATE",
  INDUSTRY_LIVING_FURNISHING_INTERIOR_DESIGN = "INDUSTRY_LIVING_FURNISHING_INTERIOR_DESIGN",
  INDUSTRY_LIVING_FURNISHING_INTERIOR_DECORATION = "INDUSTRY_LIVING_FURNISHING_INTERIOR_DECORATION",
  INDUSTRY_LIVING_FURNISHING_KITCHEN_FACILITIES = "INDUSTRY_LIVING_FURNISHING_KITCHEN_FACILITIES",
  INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_TRADING = "INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_TRADING",
  INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_MANAGEMENT = "INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_MANAGEMENT",
  INDUSTRY_LIVING_FURNISHING_FURNITURE = "INDUSTRY_LIVING_FURNISHING_FURNITURE",
  INDUSTRY_LIVING_FURNISHING_CLEANING = "INDUSTRY_LIVING_FURNISHING_CLEANING",
  INDUSTRY_LIVING_FURNISHING_KEY_SERVICE = "INDUSTRY_LIVING_FURNISHING_KEY_SERVICE",
  INDUSTRY_LIVING_FURNISHING_BLINDS_AND_SHUTTERS = "INDUSTRY_LIVING_FURNISHING_BLINDS_AND_SHUTTERS",
  INDUSTRY_LIVING_FURNISHING_CARPETS = "INDUSTRY_LIVING_FURNISHING_CARPETS",
  INDUSTRY_LIVING_FURNISHING_MOVING = "INDUSTRY_LIVING_FURNISHING_MOVING",
  INDUSTRY_LIVING_FURNISHING_CURTAINS = "INDUSTRY_LIVING_FURNISHING_CURTAINS",
  INDUSTRY_LIVING_FURNISHING_OTHER = "INDUSTRY_LIVING_FURNISHING_OTHER",
  INDUSTRY_BUILD_RENOVATE_ARCHITECTURE = "INDUSTRY_BUILD_RENOVATE_ARCHITECTURE",
  INDUSTRY_BUILD_RENOVATE_CONSTRUCTION = "INDUSTRY_BUILD_RENOVATE_CONSTRUCTION",
  INDUSTRY_BUILD_RENOVATE_ROOFING = "INDUSTRY_BUILD_RENOVATE_ROOFING",
  INDUSTRY_BUILD_RENOVATE_FLOORING_WALL_COVERINGS = "INDUSTRY_BUILD_RENOVATE_FLOORING_WALL_COVERINGS",
  INDUSTRY_BUILD_RENOVATE_PLASTERER = "INDUSTRY_BUILD_RENOVATE_PLASTERER",
  INDUSTRY_BUILD_RENOVATE_HEATING = "INDUSTRY_BUILD_RENOVATE_HEATING",
  INDUSTRY_BUILD_RENOVATE_WOOD_CONSTRUCTION = "INDUSTRY_BUILD_RENOVATE_WOOD_CONSTRUCTION",
  INDUSTRY_BUILD_RENOVATE_ENGINEERING = "INDUSTRY_BUILD_RENOVATE_ENGINEERING",
  INDUSTRY_BUILD_RENOVATE_PAINTER = "INDUSTRY_BUILD_RENOVATE_PAINTER",
  INDUSTRY_BUILD_RENOVATE_METAL_CONSTRUCTION = "INDUSTRY_BUILD_RENOVATE_METAL_CONSTRUCTION",
  INDUSTRY_BUILD_RENOVATE_SANITARY = "INDUSTRY_BUILD_RENOVATE_SANITARY",
  INDUSTRY_BUILD_RENOVATE_LOCKSMITH = "INDUSTRY_BUILD_RENOVATE_LOCKSMITH",
  INDUSTRY_BUILD_RENOVATE_JOINERY = "INDUSTRY_BUILD_RENOVATE_JOINERY",
  INDUSTRY_BUILD_RENOVATE_PLUMBING = "INDUSTRY_BUILD_RENOVATE_PLUMBING",
  INDUSTRY_BUILD_RENOVATE_CARPENTRY = "INDUSTRY_BUILD_RENOVATE_CARPENTRY",
  INDUSTRY_BUILD_RENOVATE_ELECTRICIAN = "INDUSTRY_BUILD_RENOVATE_ELECTRICIAN",
  INDUSTRY_BUILD_RENOVATE_CRAFTSMAN = "INDUSTRY_BUILD_RENOVATE_CRAFTSMAN",
  INDUSTRY_BUILD_RENOVATE_OTHER = "INDUSTRY_BUILD_RENOVATE_OTHER",
  INDUSTRY_FINANCIAL_LAW_ADVOCACY = "INDUSTRY_FINANCIAL_LAW_ADVOCACY",
  INDUSTRY_FINANCIAL_LAW_BANK = "INDUSTRY_FINANCIAL_LAW_BANK",
  INDUSTRY_FINANCIAL_LAW_ACCOUNTING = "INDUSTRY_FINANCIAL_LAW_ACCOUNTING",
  INDUSTRY_FINANCIAL_LAW_FINANCIAL_CONSULTING = "INDUSTRY_FINANCIAL_LAW_FINANCIAL_CONSULTING",
  INDUSTRY_FINANCIAL_LAW_NOTARY = "INDUSTRY_FINANCIAL_LAW_NOTARY",
  INDUSTRY_FINANCIAL_LAW_LAWYER = "INDUSTRY_FINANCIAL_LAW_LAWYER",
  INDUSTRY_FINANCIAL_LAW_TAX_CONSULTING = "INDUSTRY_FINANCIAL_LAW_TAX_CONSULTING",
  INDUSTRY_FINANCIAL_LAW_TRUSTEESHIP = "INDUSTRY_FINANCIAL_LAW_TRUSTEESHIP",
  INDUSTRY_FINANCIAL_LAW_ASSET_MANAGEMENT = "INDUSTRY_FINANCIAL_LAW_ASSET_MANAGEMENT",
  INDUSTRY_FINANCIAL_LAW_INSURANCE = "INDUSTRY_FINANCIAL_LAW_INSURANCE",
  INDUSTRY_FINANCIAL_LAW_OTHER = "INDUSTRY_FINANCIAL_LAW_OTHER",
  INDUSTRY_GARDEN_PLANTS_FLORIST = "INDUSTRY_GARDEN_PLANTS_FLORIST",
  INDUSTRY_GARDEN_PLANTS_HORTICULTURE = "INDUSTRY_GARDEN_PLANTS_HORTICULTURE",
  INDUSTRY_GARDEN_PLANTS_GARDEN_MAINTENANCE = "INDUSTRY_GARDEN_PLANTS_GARDEN_MAINTENANCE",
  INDUSTRY_GARDEN_PLANTS_NURSERY = "INDUSTRY_GARDEN_PLANTS_NURSERY",
  INDUSTRY_GARDEN_PLANTS_DUMPSTER_SERVICE = "INDUSTRY_GARDEN_PLANTS_DUMPSTER_SERVICE",
  INDUSTRY_GARDEN_PLANTS_OTHER = "INDUSTRY_GARDEN_PLANTS_OTHER",
  INDUSTRY_OTHER_METER_READING = "INDUSTRY_OTHER_METER_READING",
  INDUSTRY_OTHER_FACILITY_MANAGEMENT = "INDUSTRY_OTHER_FACILITY_MANAGEMENT",
  INDUSTRY_OTHER_MAINTENANCE_INSTALLATION = "INDUSTRY_OTHER_MAINTENANCE_INSTALLATION",
  INDUSTRY_OTHER_BUILDING_SERVICES_ENGINEERING = "INDUSTRY_OTHER_BUILDING_SERVICES_ENGINEERING",
  INDUSTRY_OTHER_KEY_SERVICE = "INDUSTRY_OTHER_KEY_SERVICE",
  INDUSTRY_OTHER_CLEANING = "INDUSTRY_OTHER_CLEANING",
  INDUSTRY_OTHER_WHITE_GOODS = "INDUSTRY_OTHER_WHITE_GOODS",
  INDUSTRY_OTHER_OTHER = "INDUSTRY_OTHER_OTHER",
  INDUSTRY_OTHER_FIRE_PROTECTION = "INDUSTRY_OTHER_FIRE_PROTECTION",
  INDUSTRY_BUILD_RENOVATE_FACADES = "INDUSTRY_BUILD_RENOVATE_FACADES",
  INDUSTRY_OTHER_ELECTRICITY_PLANT = "INDUSTRY_OTHER_ELECTRICITY_PLANT",
  INDUSTRY_OTHER_WATERWORKS = "INDUSTRY_OTHER_WATERWORKS",
  INDUSTRY_OTHER_SWEEPINGS = "INDUSTRY_OTHER_SWEEPINGS",
  INDUSTRY_OTHER_ANTENNA_SYSTEM = "INDUSTRY_OTHER_ANTENNA_SYSTEM",
  INDUSTRY_OTHER_PEST_CONTROL = "INDUSTRY_OTHER_PEST_CONTROL",
  INDUSTRY_FINANCIAL_LAW_PUBLIC_SECTOR = "INDUSTRY_FINANCIAL_LAW_PUBLIC_SECTOR",
  INDUSTRY_BUILD_RENOVATE_DISTRICT_HEATING = "INDUSTRY_BUILD_RENOVATE_DISTRICT_HEATING",
  INDUSTRY_BUILD_RENOVATE_AIR_CONDITIONING = "INDUSTRY_BUILD_RENOVATE_AIR_CONDITIONING",
  INDUSTRY_BUILD_RENOVATE_GARAGE_GATES = "INDUSTRY_BUILD_RENOVATE_GARAGE_GATES",
  INDUSTRY_BUILD_RENOVATE_MOLD_CONTROL = "INDUSTRY_BUILD_RENOVATE_MOLD_CONTROL",
  INDUSTRY_OTHER_MARKINGS = "INDUSTRY_OTHER_MARKINGS",
  INDUSTRY_BUILD_RENOVATE_JOINTS = "INDUSTRY_BUILD_RENOVATE_JOINTS",
  INDUSTRY_OTHER_OIL = "INDUSTRY_OTHER_OIL",
  INDUSTRY_BUILD_RENOVATE_LIFT_SERVICE = "INDUSTRY_BUILD_RENOVATE_LIFT_SERVICE",
  INDUSTRY_OTHER_WATER_TREATMENT = "INDUSTRY_OTHER_WATER_TREATMENT",
  INDUSTRY_OTHER_ADVERTISING = "INDUSTRY_OTHER_ADVERTISING",
  INDUSTRY_OTHER_GROCERIES = "INDUSTRY_OTHER_GROCERIES",
  INDUSTRY_OTHER_CAR_DEALERSHIP = "INDUSTRY_OTHER_CAR_DEALERSHIP",
  INDUSTRY_OTHER_STATIONERY_SHOP = "INDUSTRY_OTHER_STATIONERY_SHOP",
  INDUSTRY_BUILD_GLAZIER = "INDUSTRY_BUILD_GLAZIER",
  INDUSTRY_BUILD_SCAFFOLDER = "INDUSTRY_BUILD_SCAFFOLDER",
  INDUSTRY_OTHER_CHIMNEY_SWEEPER = "INDUSTRY_OTHER_CHIMNEY_SWEEPER",
  INDUSTRY_OTHER_ENGRAVING = "INDUSTRY_OTHER_ENGRAVING",
  INDUSTRY_BUILD_MASONRY = "INDUSTRY_BUILD_MASONRY",
  INDUSTRY_CONSTRUCTION_MANAGEMENT = "INDUSTRY_CONSTRUCTION_MANAGEMENT",
  INDUSTRY_SEWER_CLEANING = "INDUSTRY_SEWER_CLEANING",
  INDUSTRY_NATURE_CONSERVATION = "INDUSTRY_NATURE_CONSERVATION",
  INDUSTRY_GEOMATICS = "INDUSTRY_GEOMATICS",
  INDUSTRY_DECONSTRUCTION = "INDUSTRY_DECONSTRUCTION",
  INDUSTRY_GEOLOGIST = "INDUSTRY_GEOLOGIST",
  INDUSTRY_POLLUTANT_EXPERT = "INDUSTRY_POLLUTANT_EXPERT",
  INDUSTRY_INSULATION = "INDUSTRY_INSULATION",
  INDUSTRY_LOCKING_SYSTEMS = "INDUSTRY_LOCKING_SYSTEMS",
  INDUSTRY_KITCHEN_DESIGNER = "INDUSTRY_KITCHEN_DESIGNER",
}

export interface InsuranceInsurance {
  /** @format float */
  amount: number;
  benefits: InsuranceInsuranceBenefit[];
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  earliestTerminationDate: TypeDate;
  editedByAic: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** @format float */
  excess: number;
  id: string;
  /** @format int32 */
  indexYear: number;
  insuranceCompany: string;
  notes: string;
  /** @format int64 */
  numericId: string;
  /**
   * Account ID of owner (who owns the stuff in real life)
   * @format int64
   */
  ownerId: string;
  policyNumber: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  premiumPaidUntil: TypeDate;
  /** Some opaque ID where this entity is attached to (e.g. propertyId or buildingId) */
  referenceId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  type: InsuranceInsuranceType;
  /** @format float */
  yearlyCosts: number;
}

/** @default "INSURANCE_BENEFIT_UNDEFINED" */
export enum InsuranceInsuranceBenefit {
  INSURANCE_BENEFIT_UNDEFINED = "INSURANCE_BENEFIT_UNDEFINED",
  INSURANCE_BENEFIT_LIABILITY = "INSURANCE_BENEFIT_LIABILITY",
  INSURANCE_BENEFIT_WATER = "INSURANCE_BENEFIT_WATER",
  INSURANCE_BENEFIT_LOSS_OF_RENTAL_INCOME = "INSURANCE_BENEFIT_LOSS_OF_RENTAL_INCOME",
  INSURANCE_BENEFIT_BURGLARY_ROBBERY = "INSURANCE_BENEFIT_BURGLARY_ROBBERY",
  INSURANCE_BENEFIT_GLASS_BREAKAGE = "INSURANCE_BENEFIT_GLASS_BREAKAGE",
  INSURANCE_BENEFIT_EXTENDED_COVERAGE = "INSURANCE_BENEFIT_EXTENDED_COVERAGE",
  INSURANCE_BENEFIT_BUILDING_SERVICES_FAILURE = "INSURANCE_BENEFIT_BUILDING_SERVICES_FAILURE",
  INSURANCE_BENEFIT_CONVERSIONS_AND_RENOVATIONS = "INSURANCE_BENEFIT_CONVERSIONS_AND_RENOVATIONS",
  INSURANCE_BENEFIT_NATURAL_HAZARDS = "INSURANCE_BENEFIT_NATURAL_HAZARDS",
  INSURANCE_BENEFIT_ACCIDENT_AND_SICKNESS = "INSURANCE_BENEFIT_ACCIDENT_AND_SICKNESS",
}

/** @default "INSURANCE_TYPE_UNDEFINED" */
export enum InsuranceInsuranceType {
  INSURANCE_TYPE_UNDEFINED = "INSURANCE_TYPE_UNDEFINED",
  INSURANCE_TYPE_FIRE_ELEMENTAL_DAMAGE = "INSURANCE_TYPE_FIRE_ELEMENTAL_DAMAGE",
  INSURANCE_TYPE_BUILDING_PROPERTY_LIABILITY = "INSURANCE_TYPE_BUILDING_PROPERTY_LIABILITY",
  INSURANCE_TYPE_LIABILITY = "INSURANCE_TYPE_LIABILITY",
  INSURANCE_TYPE_BUILDING_PROPERTY_INSURANCE = "INSURANCE_TYPE_BUILDING_PROPERTY_INSURANCE",
  INSURANCE_TYPE_LEGAL_EXPENSES = "INSURANCE_TYPE_LEGAL_EXPENSES",
  INSURANCE_TYPE_CONSTRUCTION_LIABILITY = "INSURANCE_TYPE_CONSTRUCTION_LIABILITY",
  INSURANCE_TYPE_CANTONAL_BUILDING_INSURANCE = "INSURANCE_TYPE_CANTONAL_BUILDING_INSURANCE",
  INSURANCE_TYPE_ACCIDENT_INSURANCE = "INSURANCE_TYPE_ACCIDENT_INSURANCE",
  INSURANCE_TYPE_ART_IN_ARCHITECTURE = "INSURANCE_TYPE_ART_IN_ARCHITECTURE",
  INSURANCE_TYPE_BUSINESS_INSURANCE = "INSURANCE_TYPE_BUSINESS_INSURANCE",
  INSURANCE_TYPE_ACCIDENT_INSURANCE_UVG = "INSURANCE_TYPE_ACCIDENT_INSURANCE_UVG",
  INSURANCE_TYPE_BUILDERS_LIABILITY_INSURANCE = "INSURANCE_TYPE_BUILDERS_LIABILITY_INSURANCE",
  INSURANCE_TYPE_CONSTRUCTION_INSURANCE = "INSURANCE_TYPE_CONSTRUCTION_INSURANCE",
  INSURANCE_TYPE_BUILDERS_LIABILITY_VISITOR_CUSTOMER_ACCIDENT = "INSURANCE_TYPE_BUILDERS_LIABILITY_VISITOR_CUSTOMER_ACCIDENT",
  INSURANCE_TYPE_CONSTRUCTION_VISITOR_CUSTOMER_ACCIDENT = "INSURANCE_TYPE_CONSTRUCTION_VISITOR_CUSTOMER_ACCIDENT",
  INSURANCE_TYPE_BUILDERS_LIABILITY_CONSTRUCTION_VISITOR_CUSTOMER_ACCIDENT = "INSURANCE_TYPE_BUILDERS_LIABILITY_CONSTRUCTION_VISITOR_CUSTOMER_ACCIDENT",
  INSURANCE_TYPE_TENANCY_DEPOSIT = "INSURANCE_TYPE_TENANCY_DEPOSIT",
  INSURANCE_TYPE_ENVIRONMENTAL_LIABILITY = "INSURANCE_TYPE_ENVIRONMENTAL_LIABILITY",
  INSURANCE_TYPE_PROFESSIONAL_LIABILITY = "INSURANCE_TYPE_PROFESSIONAL_LIABILITY",
  INSURANCE_TYPE_OBJECT = "INSURANCE_TYPE_OBJECT",
  INSURANCE_TYPE_PERSONAL_LIABILITY = "INSURANCE_TYPE_PERSONAL_LIABILITY",
  INSURANCE_TYPE_ADVANCE_PAYMENT_GUARANTEE = "INSURANCE_TYPE_ADVANCE_PAYMENT_GUARANTEE",
  INSURANCE_TYPE_BID_BOND = "INSURANCE_TYPE_BID_BOND",
  INSURANCE_TYPE_PERFORMANCE_GUARANTEE = "INSURANCE_TYPE_PERFORMANCE_GUARANTEE",
  INSURANCE_TYPE_WARRANTY_FOR_DEFECTS = "INSURANCE_TYPE_WARRANTY_FOR_DEFECTS",
  INSURANCE_TYPE_CYBER = "INSURANCE_TYPE_CYBER",
  INSURANCE_TYPE_D_AND_O = "INSURANCE_TYPE_D_AND_O",
  INSURANCE_TYPE_PROPERTY_INSURANCE = "INSURANCE_TYPE_PROPERTY_INSURANCE",
  INSURANCE_TYPE_ENGINEERING_INSURANCE = "INSURANCE_TYPE_ENGINEERING_INSURANCE",
  INSURANCE_TYPE_VISITOR_CUSTOMER_ACCIDENT = "INSURANCE_TYPE_VISITOR_CUSTOMER_ACCIDENT",
  INSURANCE_TYPE_OTHER = "INSURANCE_TYPE_OTHER",
}

/** @default "OTHER" */
export enum MediadocumentType {
  OTHER = "OTHER",
  APPLICATION_FORM = "APPLICATION_FORM",
  HANDOVER_PROTOCOL = "HANDOVER_PROTOCOL",
  CONTRACT = "CONTRACT",
  BUILDING_PLAN = "BUILDING_PLAN",
  INVOICE = "INVOICE",
  HOUSE_REGULATION = "HOUSE_REGULATION",
  INSTRUCTION_MANUAL = "INSTRUCTION_MANUAL",
  CREDIT_CHECK = "CREDIT_CHECK",
  OWNERS_MEETING = "OWNERS_MEETING",
  PAY_IN_SLIP = "PAY_IN_SLIP",
  ENERGY_CERTIFICATE = "ENERGY_CERTIFICATE",
  WARRANTY_CERTIFICATE = "WARRANTY_CERTIFICATE",
  BANK_STATEMENT = "BANK_STATEMENT",
  ADDITIONAL_COSTS_BILL = "ADDITIONAL_COSTS_BILL",
  SEPA_DIRECT_DEBIT_MANDATE = "SEPA_DIRECT_DEBIT_MANDATE",
  AGREEMENT = "AGREEMENT",
  DEPOSIT_CONFIRMATION = "DEPOSIT_CONFIRMATION",
  BUILDING_INSURANCE_POLICY = "BUILDING_INSURANCE_POLICY",
  KEY_LIST = "KEY_LIST",
  TERMINATION_DOC_TYPE = "TERMINATION_DOC_TYPE",
  RENT_ADJUSTMENT_DOC_TYPE = "RENT_ADJUSTMENT_DOC_TYPE",
  REFERENCES_DOC_TYPE = "REFERENCES_DOC_TYPE",
  MAINTENANCE_CONTRACT_DOC_TYPE = "MAINTENANCE_CONTRACT_DOC_TYPE",
  REGULATIONS = "REGULATIONS",
  REGULATIONS_FOR_USE_AND_MANAGEMENT = "REGULATIONS_FOR_USE_AND_MANAGEMENT",
  ANNUAL_FINANCIAL_STATEMENT = "ANNUAL_FINANCIAL_STATEMENT",
  PURCHASE_CONTRACT_AND_LAND_REGISTER = "PURCHASE_CONTRACT_AND_LAND_REGISTER",
  CONDOMINIUM_OWNERSHIP = "CONDOMINIUM_OWNERSHIP",
  RENEWAL_FOND = "RENEWAL_FOND",
  MORTGAGE = "MORTGAGE",
  ORDER = "ORDER",
  OFFER = "OFFER",
  IDENTITY = "IDENTITY",
  EXTRACT_FROM_DEBT_COLLECTION_REGISTER = "EXTRACT_FROM_DEBT_COLLECTION_REGISTER",
  BANK_ACCOUNT_DETAILS = "BANK_ACCOUNT_DETAILS",
  PURCHASE_CONTRACT = "PURCHASE_CONTRACT",
  LAND_REGISTER = "LAND_REGISTER",
  SITUATION_PLAN = "SITUATION_PLAN",
  CONSTRUCTION_LAW_AGREEMENT = "CONSTRUCTION_LAW_AGREEMENT",
  EASEMENT_AGREEMENT = "EASEMENT_AGREEMENT",
  CADASTRAL_ESTIMATE = "CADASTRAL_ESTIMATE",
  LETTER = "LETTER",
  TRADE_REGISTER_EXCERPT = "TRADE_REGISTER_EXCERPT",
  PAYMENT_REMINDER = "PAYMENT_REMINDER",
  PROTOCOL = "PROTOCOL",
  COURT_DOC_TYPE = "COURT_DOC_TYPE",
  HONORARIUM = "HONORARIUM",
  BUDGET = "BUDGET",
  OFFICIAL_ESTIMATE = "OFFICIAL_ESTIMATE",
  BUILDING_DESCRIPTION = "BUILDING_DESCRIPTION",
  PERMITS = "PERMITS",
  LEGAL_MATTERS = "LEGAL_MATTERS",
  TENANT_CHANGE_NOTIFICATION = "TENANT_CHANGE_NOTIFICATION",
  LOSS_RATIO = "LOSS_RATIO",
  SHARE_CERTIFICATE_DOCUMENT = "SHARE_CERTIFICATE_DOCUMENT",
  CERTIFICATE_OF_APPOINTMENT = "CERTIFICATE_OF_APPOINTMENT",
  REPORT_DOC_TYPE = "REPORT_DOC_TYPE",
}

export interface NoteCreateFromMailRequest {
  accountInternal: boolean;
  mailId: string;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
}

export interface NoteCreateFromMailResponse {
  note: NoteNote;
}

export interface NoteCreateUnregisteredRequest {
  email: string;
  mediaIds: string[];
  name: string;
  note: string;
  referenceIds: string[];
}

export interface NoteCreateUnregisteredResponse {
  note: NoteNote;
}

export interface NoteMention {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export interface NoteNote {
  accountInternal: boolean;
  /** @format int64 */
  createdAt: string;
  creator: CommonnoteCreator;
  historyEntries: NoteNoteHistoryEntry[];
  id: string;
  mediaIds: string[];
  mentions: NoteMention[];
  note: string;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
  /** @format int64 */
  updatedAt: string;
}

export interface NoteNoteHistoryEntry {
  /** @format int64 */
  editedAt: string;
  previousMediaIds: string[];
  previousNote: string;
}

export interface NylasAuthGetGrantByIdResponse {
  grant: NylasAuthGrant;
}

export interface NylasAuthGetGrantByUserIdResponse {
  grant: NylasAuthGrant;
}

export interface NylasAuthGetGrantsByAccountIdResponse {
  grants: NylasAuthGrant[];
}

export interface NylasAuthGetMyConfigResponse {
  /** @format int64 */
  accountId: string;
  email: string;
  id: string;
  provider: NylasAuthProvider;
  scopes: NylasAuthScope[];
  userId: string;
}

export interface NylasAuthGrant {
  /** @format int64 */
  accountId: string;
  email: string;
  grantId: string;
  id: string;
  provider: NylasAuthProvider;
  scopes: NylasAuthScope[];
  userId: string;
}

/** @default "SCOPE_UNDEFINED" */
export enum NylasAuthScope {
  SCOPE_UNDEFINED = "SCOPE_UNDEFINED",
  SCOPE_EMAIL = "SCOPE_EMAIL",
  SCOPE_CALENDAR = "SCOPE_CALENDAR",
}

export interface NylasAuthStartAuthResponse {
  authUrl: string;
}

export type NylasAuthUnlinkRequest = object;

export type NylasAuthUnlinkResponse = object;

/** @default "UNDEFINED_CATEGORY" */
export enum ObjectCategory {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/**
 * - ATELIER: SwissRETS fields (can also contain IDX fields)
 *  - AGRICULTURAL_INSTALLATION: IDX fields
 * @default "UNDEFINED_SUB_CATEGORY"
 */
export enum ObjectSubCategory {
  UNDEFINED_SUB_CATEGORY = "UNDEFINED_SUB_CATEGORY",
  ATELIER = "ATELIER",
  ATTIC_FLAT = "ATTIC_FLAT",
  BAR = "BAR",
  CAFE = "CAFE",
  CAR_REPAIR_SHOP = "CAR_REPAIR_SHOP",
  CASTLE = "CASTLE",
  CHALET = "CHALET",
  EARTH_SHELTERED_DWELLING = "EARTH_SHELTERED_DWELLING",
  DETACHED_HOUSE = "DETACHED_HOUSE",
  DOCTORS_OFFICE = "DOCTORS_OFFICE",
  DUPLEX_HOUSE = "DUPLEX_HOUSE",
  FARM_HOUSE = "FARM_HOUSE",
  FURNISHED_FLAT = "FURNISHED_FLAT",
  GRANNY_FLAT = "GRANNY_FLAT",
  HOBBY_ROOM = "HOBBY_ROOM",
  HOTEL = "HOTEL",
  LOFT = "LOFT",
  MAISONETTE = "MAISONETTE",
  MULTIPLEX_HOUSE = "MULTIPLEX_HOUSE",
  OFFICE = "OFFICE",
  ONE_ROOM_FLAT = "ONE_ROOM_FLAT",
  RESTAURANT = "RESTAURANT",
  RETAIL_LOCATION = "RETAIL_LOCATION",
  ROOF_FLAT = "ROOF_FLAT",
  ROW_HOUSE = "ROW_HOUSE",
  RUSTICO = "RUSTICO",
  SINGLE_ROOM = "SINGLE_ROOM",
  STOECKLI = "STOECKLI",
  STEPPED_FLAT = "STEPPED_FLAT",
  STEPPED_HOUSE = "STEPPED_HOUSE",
  VILLA = "VILLA",
  WORKSHOP = "WORKSHOP",
  AGRICULTURAL_INSTALLATION = "AGRICULTURAL_INSTALLATION",
  MOUNTAIN_FARM = "MOUNTAIN_FARM",
  FARM = "FARM",
  DUPLEX = "DUPLEX",
  STUDIO = "STUDIO",
  TERRACE_FLAT = "TERRACE_FLAT",
  BACHELOR_FLAT = "BACHELOR_FLAT",
  ATTIC = "ATTIC",
  ALOTTMENT_GARDEN = "ALOTTMENT_GARDEN",
  CLUB = "CLUB",
  CASINO = "CASINO",
  MOVIE = "MOVIE",
  SQUASH = "SQUASH",
  INDOOR_TENNIS = "INDOOR_TENNIS",
  TENNIS = "TENNIS",
  SPORTS_HALL = "SPORTS_HALL",
  CAMP_GROUND = "CAMP_GROUND",
  OUTDOOR_SWIMMING_POOL = "OUTDOOR_SWIMMING_POOL",
  INDOOR_SWIMMING_POOL = "INDOOR_SWIMMING_POOL",
  GOLF_COURSE = "GOLF_COURSE",
  MOTEL = "MOTEL",
  PUB = "PUB",
  SINGLE_HOUSE = "SINGLE_HOUSE",
  BIFAMILIAR_HOUSE = "BIFAMILIAR_HOUSE",
  TERRANCE_HOUSE = "TERRANCE_HOUSE",
  MULTIPLE_DWELLING = "MULTIPLE_DWELLING",
  CAVE_HOUSE = "CAVE_HOUSE",
  SHOP = "SHOP",
  ADVERTISING_AREA = "ADVERTISING_AREA",
  COMMERCIAL_SUB_CATEGORY = "COMMERCIAL_SUB_CATEGORY",
  STORAGE_ROOM = "STORAGE_ROOM",
  PRACTICE = "PRACTICE",
  KIOSK = "KIOSK",
  GARDENING = "GARDENING",
  FUEL_STATION = "FUEL_STATION",
  CHEESE_FACTORY = "CHEESE_FACTORY",
  BUTCHER = "BUTCHER",
  BAKERY = "BAKERY",
  HAIRDRESSER = "HAIRDRESSER",
  SHOPPING_CENTER = "SHOPPING_CENTER",
  FACTORY = "FACTORY",
  INDUSTRIAL_OBJECT = "INDUSTRIAL_OBJECT",
  ARCADE = "ARCADE",
  LIVING_COMMERCIAL_BUILDING = "LIVING_COMMERCIAL_BUILDING",
  LIBRARY = "LIBRARY",
  HOSPITAL = "HOSPITAL",
  LABORATORY = "LABORATORY",
  MINI_GOLD_COURSE = "MINI_GOLD_COURSE",
  NURSING_HOME = "NURSING_HOME",
  RIDING_HALL = "RIDING_HALL",
  SANATORIUM = "SANATORIUM",
  PARTY_ROOM = "PARTY_ROOM",
  SAUNA = "SAUNA",
  SOLARIUM = "SOLARIUM",
  CARPENTRY_SHOP = "CARPENTRY_SHOP",
  OLD_AGE_HOME = "OLD_AGE_HOME",
  DEPARTMENT_STORE = "DEPARTMENT_STORE",
  HOME = "HOME",
  DISPLAY_WINDOW = "DISPLAY_WINDOW",
  PARKING_GARAGE = "PARKING_GARAGE",
  PARKING_SURFACE = "PARKING_SURFACE",
  OPEN_SLOT = "OPEN_SLOT",
  COVERED_SLOT = "COVERED_SLOT",
  SINGLE_GARAGE = "SINGLE_GARAGE",
  DOUBLE_GARAGE = "DOUBLE_GARAGE",
  UNDERGROUND_SLOT = "UNDERGROUND_SLOT",
  BOAT_DRY_DOCK = "BOAT_DRY_DOCK",
  BOAT_LANDING_STAGE = "BOAT_LANDING_STAGE",
  COVERED_PARKING_PLACE_BIKE = "COVERED_PARKING_PLACE_BIKE",
  OUTDOOR_PARKING_PLACE_BIKE = "OUTDOOR_PARKING_PLACE_BIKE",
  HORSE_BOX = "HORSE_BOX",
  BOAT_MOORING = "BOAT_MOORING",
  BUILDING_LAND = "BUILDING_LAND",
  AGRICULTURAL_LAND = "AGRICULTURAL_LAND",
  COMMERCIAL_LAND = "COMMERCIAL_LAND",
  INDUSTRIAL_LAND = "INDUSTRIAL_LAND",
  CELLAR_COMPARTMENT = "CELLAR_COMPARTMENT",
  ATTIC_COMPARTMENT = "ATTIC_COMPARTMENT",
  OTHER = "OTHER",
  VISITOR_PARKING_LOT = "VISITOR_PARKING_LOT",
  CARETAKER_ROOM = "CARETAKER_ROOM",
  FITNESS_CENTER = "FITNESS_CENTER",
  ARCHIVE_ROOM = "ARCHIVE_ROOM",
  ANTENNA_SYSTEM = "ANTENNA_SYSTEM",
  TRAINING_ROOM = "TRAINING_ROOM",
  TOILET_FACILITY = "TOILET_FACILITY",
  BICYCLE_PARKING = "BICYCLE_PARKING",
  HANDICAPPED_INDOOR_PARKING = "HANDICAPPED_INDOOR_PARKING",
  HANDICAPPED_OUTDOOR_PARKING = "HANDICAPPED_OUTDOOR_PARKING",
  DOUBLE_OUTDOOR_PARKING = "DOUBLE_OUTDOOR_PARKING",
  DOUBLE_INDOOR_PARKING = "DOUBLE_INDOOR_PARKING",
  JANITOR_ROOM = "JANITOR_ROOM",
  LAUNDRY_ROOM = "LAUNDRY_ROOM",
  CUSTOMER_PARKING = "CUSTOMER_PARKING",
  RETIREMENT_APARTMENT = "RETIREMENT_APARTMENT",
  STAFF_ROOM = "STAFF_ROOM",
  SERVER_ROOM = "SERVER_ROOM",
  MEETING_ROOM = "MEETING_ROOM",
  BUILDING_SERVICES = "BUILDING_SERVICES",
  COMMERCIAL_STORAGE_ROOM = "COMMERCIAL_STORAGE_ROOM",
  ELECTRIC_PARKING_SPACE = "ELECTRIC_PARKING_SPACE",
}

/** @default "TYPE_OF_USE_UNDEFINED" */
export enum ObjecttenancyTypeOfUse {
  TYPE_OF_USE_UNDEFINED = "TYPE_OF_USE_UNDEFINED",
  TYPE_OF_USE_VACATION = "TYPE_OF_USE_VACATION",
  TYPE_OF_USE_COMMERCIAL = "TYPE_OF_USE_COMMERCIAL",
  TYPE_OF_USE_PARKING = "TYPE_OF_USE_PARKING",
  TYPE_OF_USE_PARKING_EXTERNAL = "TYPE_OF_USE_PARKING_EXTERNAL",
  TYPE_OF_USE_AGRICULTURAL = "TYPE_OF_USE_AGRICULTURAL",
  TYPE_OF_USE_CONSTRUCTION = "TYPE_OF_USE_CONSTRUCTION",
  TYPE_OF_USE_GASTRONOMY = "TYPE_OF_USE_GASTRONOMY",
  TYPE_OF_USE_INDUSTRIAL = "TYPE_OF_USE_INDUSTRIAL",
  TYPE_OF_USE_INVESTMENT = "TYPE_OF_USE_INVESTMENT",
  TYPE_OF_USE_STORAGE = "TYPE_OF_USE_STORAGE",
  TYPE_OF_USE_RESIDENTIAL = "TYPE_OF_USE_RESIDENTIAL",
  TYPE_OF_USE_SECONDARY_ROOM = "TYPE_OF_USE_SECONDARY_ROOM",
  TYPE_OF_USE_OFFICE = "TYPE_OF_USE_OFFICE",
  TYPE_OF_USE_STORE = "TYPE_OF_USE_STORE",
  TYPE_OF_USE_ADVERTISING_AREA = "TYPE_OF_USE_ADVERTISING_AREA",
  TYPE_OF_USE_RADIO_ANTENNA = "TYPE_OF_USE_RADIO_ANTENNA",
}

export interface TicketAdditionalData {
  key: string;
  value: string;
}

export interface TicketChecklistItem {
  assignee: TicketticketAssignee;
  id: string;
  note: string;
  /** @format int32 */
  order: number;
  status: TicketChecklistItemStatus;
  title: string;
}

/** @default "CHECKLIST_ITEM_STATUS_OPEN" */
export enum TicketChecklistItemStatus {
  CHECKLIST_ITEM_STATUS_OPEN = "CHECKLIST_ITEM_STATUS_OPEN",
  CHECKLIST_ITEM_STATUS_IN_PROGRESS = "CHECKLIST_ITEM_STATUS_IN_PROGRESS",
  CHECKLIST_ITEM_STATUS_DONE = "CHECKLIST_ITEM_STATUS_DONE",
}

export interface TicketCorrespondence {
  address: CommonaddressAddress;
  companyName: string;
  contactId: string;
  email: string;
  name: string;
  phone: string;
}

export interface TicketExternalTicketWatcher {
  /** Optional */
  contactId?: string;
  email: string;
  includeCorrespondenceContact: boolean;
  /** Optional. Only set when contactId is set. */
  name?: string;
  notifyOnlyStatusChanges: boolean;
}

export interface TicketOnSiteContact {
  address: CommonaddressAddress;
  companyName: string;
  contactId: string;
  email: string;
  name: string;
  phone: string;
  phoneNumbers: V2PhoneNumber[];
}

export interface TicketReadStatus {
  assignee: boolean;
}

export interface TicketRecurrence {
  /** @format int32 */
  createAtAmount: number;
  createAtUnit: TicketScheduleUnit;
  /** @format int32 */
  repeatAmount: number;
  repeatUnit: TicketScheduleUnit;
}

/** @default "SCHEDULE_UNIT_UNDEFINED" */
export enum TicketScheduleUnit {
  SCHEDULE_UNIT_UNDEFINED = "SCHEDULE_UNIT_UNDEFINED",
  SCHEDULE_UNIT_DAY = "SCHEDULE_UNIT_DAY",
  SCHEDULE_UNIT_MONTH = "SCHEDULE_UNIT_MONTH",
  SCHEDULE_UNIT_YEAR = "SCHEDULE_UNIT_YEAR",
}

export interface TicketSetAssignee {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export interface TicketSetCorrespondence {
  contactId: string;
}

export interface TicketSetOnSiteContact {
  contactId: string;
  includeCorrespondenceContact: boolean;
  notify: boolean;
  notifyOnlyStatusChanges: boolean;
}

export interface TicketSetTicketWatcher {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export interface TicketTicket {
  additionalData: TicketAdditionalData[];
  assignee: TicketticketAssignee;
  checklist: TicketChecklistItem[];
  correspondences: TicketCorrespondence[];
  /** DEPRECATED!. Use costsEntries array. */
  costs: TicketticketCosts;
  costsEntries: TicketticketCosts[];
  /** @format int64 */
  createdAt: string;
  creator: TicketticketCreator;
  description: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dueDate: TypeDate;
  externalTicketWatchers: TicketExternalTicketWatcher[];
  id: string;
  /** Optional. The document ID of the invoice document that is linked to this ticket. */
  invoiceDocumentId?: string;
  /** Human readable unique key */
  key: string;
  links: TicketTicketLink[];
  mediaIds: string[];
  /** DEPRECATED!. Use onSiteContacts array. */
  onSiteContact: TicketOnSiteContact;
  onSiteContacts: TicketOnSiteContact[];
  /** @format int64 */
  ownerId: string;
  priority: TicketTicketPriority;
  /** With this key a ticket can be read without any authz by non-registered members */
  publicId: string;
  readStatus: TicketReadStatus;
  recurrence: TicketRecurrence;
  references: TicketTicketReference[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  status: TicketTicketStatus;
  title: string;
  type: TicketTicketType;
  /** @format int64 */
  updatedAt: string;
  watchers: TicketTicketWatcher[];
}

export interface TicketTicketLink {
  ticketId: string;
  type: TicketTicketLinkType;
}

/** @default "TICKET_LINK_TYPE_RELATES" */
export enum TicketTicketLinkType {
  TICKET_LINK_TYPE_RELATES = "TICKET_LINK_TYPE_RELATES",
  TICKET_LINK_TYPE_BLOCKS = "TICKET_LINK_TYPE_BLOCKS",
  TICKET_LINK_TYPE_IS_BLOCKED_BY = "TICKET_LINK_TYPE_IS_BLOCKED_BY",
}

/** @default "DEFAULT" */
export enum TicketTicketPriority {
  DEFAULT = "DEFAULT",
  LOW = "LOW",
  HIGH = "HIGH",
}

export interface TicketTicketReference {
  id: string;
  relatedIds: string[];
}

/** @default "TICKET_STATUS_OPEN" */
export enum TicketTicketStatus {
  TICKET_STATUS_OPEN = "TICKET_STATUS_OPEN",
  TICKET_STATUS_IN_PROGRESS = "TICKET_STATUS_IN_PROGRESS",
  TICKET_STATUS_DONE = "TICKET_STATUS_DONE",
  TICKET_STATUS_CLOSED = "TICKET_STATUS_CLOSED",
  TICKET_STATUS_DRAFT = "TICKET_STATUS_DRAFT",
}

/** @default "TICKET_TYPE_UNDEFINED" */
export enum TicketTicketType {
  TICKET_TYPE_UNDEFINED = "TICKET_TYPE_UNDEFINED",
  TICKET_TYPE_ORDER = "TICKET_TYPE_ORDER",
  TICKET_TYPE_OFFER = "TICKET_TYPE_OFFER",
  TICKET_TYPE_ACTIVITY = "TICKET_TYPE_ACTIVITY",
  TICKET_TYPE_TASK = "TICKET_TYPE_TASK",
  TICKET_TYPE_CHECKLIST = "TICKET_TYPE_CHECKLIST",
  TICKET_TYPE_CLAIM = "TICKET_TYPE_CLAIM",
}

export interface TicketTicketWatcher {
  /** @format int64 */
  accountId: string;
  accountName: string;
  name: string;
  profilePictureUrl: string;
  userId: string;
}

export interface TicketUpdateTicketOperation {
  additionalData: TicketAdditionalData[];
  assignee: TicketSetAssignee;
  checklist: TicketChecklistItem[];
  correspondences: TicketSetCorrespondence[];
  /** DEPRECATED!. Use costsEntries array. */
  costs: TicketticketCosts;
  costsEntries: TicketticketCosts[];
  description: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dueDate: TypeDate;
  externalTicketWatchers: TicketExternalTicketWatcher[];
  id: string;
  links: TicketTicketLink[];
  mediaIds: string[];
  /** DEPRECATED!. Use onSiteContacts array. */
  onSiteContact: TicketSetOnSiteContact;
  onSiteContacts: TicketSetOnSiteContact[];
  /** @format int64 */
  ownerId: string;
  priority: TicketTicketPriority;
  recurrence: TicketRecurrence;
  references: TicketTicketReference[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  status: TicketTicketStatus;
  title: string;
  type: TicketTicketType;
  watchers: TicketSetTicketWatcher[];
}

export interface TicketticketAssignee {
  /** @format int64 */
  accountId: string;
  accountLogoUrl: string;
  accountName: string;
  address: CommonaddressAddress;
  email: string;
  name: string;
  phone: string;
  profilePictureUrl: string;
  userId: string;
}

export interface TicketticketCosts {
  costAbsorption: CostCostAbsorption;
  costShareUnit: CostCostShareUnit;
  /** @format double */
  costShareValue: number;
  /** Room name. One entry per room for post-cleaning tickets. */
  room: string;
}

export interface TicketticketCreateRequest {
  additionalData: TicketAdditionalData[];
  assignee: TicketSetAssignee;
  checklist: TicketChecklistItem[];
  correspondences: TicketSetCorrespondence[];
  /** DEPRECATED!. Use costsEntries array. */
  costs: TicketticketCosts;
  costsEntries: TicketticketCosts[];
  description: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dueDate: TypeDate;
  externalTicketWatchers: TicketExternalTicketWatcher[];
  /** Optional */
  key?: string;
  links: TicketTicketLink[];
  mediaIds: string[];
  /** DEPRECATED!. Use onSiteContacts array. */
  onSiteContact: TicketSetOnSiteContact;
  onSiteContacts: TicketSetOnSiteContact[];
  /** @format int64 */
  ownerId: string;
  priority: TicketTicketPriority;
  recurrence: TicketRecurrence;
  references: TicketTicketReference[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  status: TicketTicketStatus;
  title: string;
  type: TicketTicketType;
  watchers: TicketSetTicketWatcher[];
}

export interface TicketticketCreateResponse {
  ticket: TicketTicket;
}

export interface TicketticketCreator {
  /** @format int64 */
  accountId: string;
  accountLogoUrl: string;
  accountName: string;
  address: CommonaddressAddress;
  email: string;
  name: string;
  phone: string;
  profilePictureUrl: string;
  userId: string;
}

export interface TicketticketUpdateRequest {
  omitCorrespondenceNotification: boolean;
  update: TicketUpdateTicketOperation;
  updateMask: string;
  updateRecurrenceFields: boolean;
}

export interface TicketticketUpdateResponse {
  ticket: TicketTicket;
}

export interface V1HealthCheckResponse {
  status: HealthCheckResponseServingStatus;
}

/** PhoneNumber stores phoneNumbers */
export interface V2PhoneNumber {
  number: string;
  type: V2PhoneNumberType;
}

/** @default "PHONE_NUMBER_TYPE_OTHER" */
export enum V2PhoneNumberType {
  PHONE_NUMBER_TYPE_OTHER = "PHONE_NUMBER_TYPE_OTHER",
  HOME = "HOME",
  WORK = "WORK",
  MOBILE = "MOBILE",
  FAX = "FAX",
}

export interface ZipGetInfoResponse {
  entries: ZipZipEntry[];
}

export interface ZipZipEntry {
  city: string;
  state: string;
}

export interface Activityv2Activity {
  contactIds: string[];
  documentIds: string[];
  employeeContactId: string;
  id: string;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  referenceIds: string[];
  subject: string;
  text: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestamp: string;
}

export interface Activityv2ListByContactIdsRequest {
  contactIds: string[];
}

export interface Activityv2ListByContactIdsResponse {
  activities: Activityv2Activity[];
}

export interface Activityv2ListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface Activityv2ListByReferenceIdsResponse {
  activities: Activityv2Activity[];
}

export interface Activityv3Activity {
  billable: boolean;
  creator: Activityv3Creator;
  employeeContactIds: string[];
  hasEndTime: boolean;
  hasStartTime: boolean;
  /** @format double */
  hourlyRate: number;
  id: string;
  mediaIds: string[];
  /** @format int64 */
  ownerId: string;
  references: V3ActivityReference[];
  source: V3Source;
  subject: string;
  text: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampEnd: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampStart: string;
}

export interface Activityv3CreateRequest {
  billable: boolean;
  employeeContactIds: string[];
  hasEndTime: boolean;
  hasStartTime: boolean;
  /** @format double */
  hourlyRate: number;
  mediaIds: string[];
  /** @format int64 */
  ownerId: string;
  references: V3ActivityReference[];
  source: V3Source;
  subject: string;
  text: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampEnd: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampStart: string;
}

export interface Activityv3CreateResponse {
  activity: Activityv3Activity;
}

export interface Activityv3Creator {
  /** @format int64 */
  accountId: string;
  accountLogoUrl: string;
  accountName: string;
  name: string;
  profilePictureUrl: string;
  userId: string;
}

export type Activityv3DeleteResponse = object;

export interface Activityv3GetResponse {
  activity: Activityv3Activity;
}

export interface Activityv3ListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface Activityv3ListByReferenceIdsResponse {
  activities: Activityv3Activity[];
}

export type Activityv3UpdateResponse = object;

export interface Contactactivityv2CreateRequest {
  contactIds: string[];
  documentIds: string[];
  employeeContactId: string;
  referenceIds: string[];
  subject: string;
  text: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestamp: string;
}

export interface Contactactivityv2CreateResponse {
  activity: Activityv2Activity;
}

export type Contactactivityv2DeleteResponse = object;

export interface Contactactivityv2GetResponse {
  activity: Activityv2Activity;
}

export type Contactactivityv2UpdateResponse = object;

/** @default "UNDEFINED_CIVIL_STATUS" */
export enum Contactcontactv2CivilStatus {
  UNDEFINED_CIVIL_STATUS = "UNDEFINED_CIVIL_STATUS",
  CIVIL_STATUS_SINGLE = "CIVIL_STATUS_SINGLE",
  CIVIL_STATUS_MARRIED = "CIVIL_STATUS_MARRIED",
  CIVIL_STATUS_DIVORCED = "CIVIL_STATUS_DIVORCED",
  CIVIL_STATUS_WIDOWED = "CIVIL_STATUS_WIDOWED",
  CIVIL_STATUS_SEPARATED = "CIVIL_STATUS_SEPARATED",
  CIVIL_STATUS_REGISTERED_PARTNERSHIP = "CIVIL_STATUS_REGISTERED_PARTNERSHIP",
  CIVIL_STATUS_DISSOLVED_PARTNERSHIP = "CIVIL_STATUS_DISSOLVED_PARTNERSHIP",
}

export interface Contactcontactv2Company {
  active: boolean;
  address: CommonaddressAddress;
  addressHistory: V2AddressEntry[];
  condominiumIds: string[];
  contactPersons: Contactcontactv2ContactPerson[];
  documentIds: string[];
  /** official contact email of the company, not the email of the responsible person (e.g. info@company.com) */
  email: string;
  iban: string;
  id: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveAt: TypeDate;
  includeInSerialEmails: boolean;
  industries: IndustryIndustry[];
  legalForm: V2LegalForm;
  name: string;
  note: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
  phoneNumbers: V2PhoneNumber[];
  portalAccess: boolean;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredLanguage: LanguagePreferredLanguage;
  relations: V2Relation[];
  salutationName: string;
  tags: string[];
  tenancyIds: string[];
  types: Contactcontactv2Type[];
  uniqueEnterpriseIdentification: string;
  /**
   * UNIX timestamp in seconds when company was modified the last time
   * @format int64
   */
  updatedAt: string;
  vatNumber: string;
  website: string;
}

export interface Contactcontactv2ContactPerson {
  active: boolean;
  address: CommonaddressAddress;
  birthName: string;
  birthplace: string;
  civilStatus: Contactcontactv2CivilStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath: TypeDate;
  email: string;
  employment: Contactcontactv2Employment;
  firstName: string;
  gender: Contactcontactv2Gender;
  id: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveAt: TypeDate;
  includeInSerialEmails: boolean;
  lastName: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name: string;
  nationality: string;
  note: string;
  /** @format int64 */
  numericId: string;
  phoneNumbers: V2PhoneNumber[];
  portalAccess: boolean;
  preferredLanguage: LanguagePreferredLanguage;
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil: TypeDate;
  salutationName: string;
  title: string;
}

export type Contactcontactv2DeleteResponse = object;

export interface Contactcontactv2Employment {
  companyName: string;
  companyPosition: string;
}

/** @default "UNDEFINED_GENDER" */
export enum Contactcontactv2Gender {
  UNDEFINED_GENDER = "UNDEFINED_GENDER",
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
  HEIRS = "HEIRS",
}

export interface Contactcontactv2ListEmployeesResponse {
  persons: V2Person[];
}

export interface Contactcontactv2ListResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

/**
 * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
 *
 *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
 *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
 *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
 *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
 *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
 *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
 *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
 *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
 * @default "UNDEFINED_RESIDENCE_STATUS"
 */
export enum Contactcontactv2ResidenceStatus {
  UNDEFINED_RESIDENCE_STATUS = "UNDEFINED_RESIDENCE_STATUS",
  RESIDENCE_STATUS_B_STAY = "RESIDENCE_STATUS_B_STAY",
  RESIDENCE_STATUS_C_SETTLE = "RESIDENCE_STATUS_C_SETTLE",
  RESIDENCE_STATUS_CI_STAY_EMPLOYMENT = "RESIDENCE_STATUS_CI_STAY_EMPLOYMENT",
  RESIDENCE_STATUS_G_BORDER_CROSSER = "RESIDENCE_STATUS_G_BORDER_CROSSER",
  RESIDENCE_STATUS_L_SHORT_STAY = "RESIDENCE_STATUS_L_SHORT_STAY",
  RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER = "RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER",
  RESIDENCE_STATUS_N_SEEKING_ASYLUM = "RESIDENCE_STATUS_N_SEEKING_ASYLUM",
  RESIDENCE_STATUS_S_PROTECTION_NEEDED = "RESIDENCE_STATUS_S_PROTECTION_NEEDED",
  RESIDENCE_STATUS_NO_STATUS = "RESIDENCE_STATUS_NO_STATUS",
}

/**
 * Type defines the general contact-type for individuals, not companies.
 * A contact can have multiple types.
 * @default "NONE"
 */
export enum Contactcontactv2Type {
  NONE = "NONE",
  LANDLORD = "LANDLORD",
  CLIENT = "CLIENT",
  TENANT = "TENANT",
  EMPLOYEE = "EMPLOYEE",
  CARETAKER = "CARETAKER",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  INTERESTED_PARTY = "INTERESTED_PARTY",
  BANK = "BANK",
  INSURANCE = "INSURANCE",
  REAL_ESTATE_MANAGER = "REAL_ESTATE_MANAGER",
  CRAFTSMAN = "CRAFTSMAN",
  AUTHORITY = "AUTHORITY",
  ACCOUNTANT = "ACCOUNTANT",
  MARKETER = "MARKETER",
  CONDOMINIUM_OWNER = "CONDOMINIUM_OWNER",
  SUB_TENANT = "SUB_TENANT",
  REPRESENTATION = "REPRESENTATION",
  COOPERATIVE = "COOPERATIVE",
  SALE = "SALE",
  EXTERNAL_DEBTOR = "EXTERNAL_DEBTOR",
  GUARANTOR = "GUARANTOR",
  REVISOR = "REVISOR",
  DELEGATE = "DELEGATE",
  BOARD = "BOARD",
  OWNER = "OWNER",
}

export interface Contactcontactv2UpdateCompanyResponse {
  company: Contactcontactv2Company;
}

export interface Contactcontactv2UpdateContactPersonResponse {
  contactPerson: Contactcontactv2ContactPerson;
}

export interface Contactv2ActivateRequest {
  ids: string[];
}

export type Contactv2ActivateResponse = object;

export type Contactv2AddDocumentsResponse = object;

export interface Contactv2DeactivateRequest {
  ids: string[];
}

export type Contactv2DeactivateResponse = object;

export interface Contactv2GetUsedTagsResponse {
  tags: string[];
}

export interface Contactv2PublishUpdatedEventsRequest {
  ownerIds: string[];
}

export type Contactv2PublishUpdatedEventsResponse = object;

export type Contactv2RemoveDocumentsResponse = object;

export interface TelephoneGet3CXApiKeyResponse {
  apiKey: string;
}

export type TelephoneSet3CXApiKeyResponse = object;

export interface V2AddContactPersonResponse {
  contactPerson: Contactcontactv2ContactPerson;
}

export interface V2AdditionalEmail {
  email: string;
  use: boolean;
}

export interface V2AddressEntry {
  address: CommonaddressAddress;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export interface V2CheckDuplicatesRequest {
  address: CommonaddressAddress;
  emails: string[];
  firstName: string;
  isCompany: boolean;
  /** Either company name if isCompany=true, otherwise lastName of person. */
  name: string;
  /** @format int64 */
  ownerId: string;
  phoneNumbers: string[];
}

export interface V2CheckDuplicatesResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2CopyContactsRequest {
  /** @format int64 */
  sourceAccountId: string;
  /** @format int64 */
  targetTargetId: string;
}

export type V2CopyContactsResponse = object;

export interface V2CreateCompanyRequest {
  address: CommonaddressAddress;
  addressHistory: V2AddressEntry[];
  documentIds: string[];
  /** official contact email of the company, not the email of the responsible person (e.g. info@company.com) */
  email: string;
  iban: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId: string;
  includeInSerialEmails: boolean;
  industries: IndustryIndustry[];
  legalForm: V2LegalForm;
  name: string;
  note: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
  phoneNumbers: V2PhoneNumber[];
  portalAccess: boolean;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredLanguage: LanguagePreferredLanguage;
  salutationName: string;
  tags: string[];
  types: Contactcontactv2Type[];
  uniqueEnterpriseIdentification: string;
  vatNumber: string;
  website: string;
}

export interface V2CreateCompanyResponse {
  company: Contactcontactv2Company;
}

export interface V2CreatePersonRequest {
  address: CommonaddressAddress;
  addressHistory: V2AddressEntry[];
  ahv: string;
  birthName: string;
  birthplace: string;
  civilStatus: Contactcontactv2CivilStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath: TypeDate;
  documentIds: string[];
  email: string;
  employment: Contactcontactv2Employment;
  firstName: string;
  gender: Contactcontactv2Gender;
  iban: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId: string;
  industries: IndustryIndustry[];
  lastName: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name: string;
  nationality: string;
  note: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
  phoneNumbers: V2PhoneNumber[];
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredLanguage: LanguagePreferredLanguage;
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil: TypeDate;
  salutationName: string;
  tags: string[];
  title: string;
  types: Contactcontactv2Type[];
  website: string;
  workEmail: V2AdditionalEmail;
}

export interface V2CreatePersonResponse {
  person: V2Person;
}

export interface V2DeleteAddressResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export type V2DeleteContactPersonsResponse = object;

export interface V2DuplicateContactsRequest {
  ids: string[];
  /** @format int64 */
  targetOwnerId: string;
}

export interface V2DuplicateContactsResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2GetOwnerContactResponse {
  company: Contactcontactv2Company;
  person: V2Person;
}

/** @default "LEGAL_FORM_UNDEFINED" */
export enum V2LegalForm {
  LEGAL_FORM_UNDEFINED = "LEGAL_FORM_UNDEFINED",
  LEGAL_FORM_PUBLIC_LIMITED_COMPANY = "LEGAL_FORM_PUBLIC_LIMITED_COMPANY",
  LEGAL_FORM_LIMITED_LIABILITY_COMPANY = "LEGAL_FORM_LIMITED_LIABILITY_COMPANY",
  LEGAL_FORM_SIMPLE_PARTNERSHIP = "LEGAL_FORM_SIMPLE_PARTNERSHIP",
  LEGAL_FORM_GENERAL_PARTNERSHIP = "LEGAL_FORM_GENERAL_PARTNERSHIP",
  LEGAL_FORM_LIMITED_PARTNERSHIP = "LEGAL_FORM_LIMITED_PARTNERSHIP",
  LEGAL_FORM_SOLE_PROPRIETORSHIP = "LEGAL_FORM_SOLE_PROPRIETORSHIP",
  LEGAL_FORM_COOPERATIVE = "LEGAL_FORM_COOPERATIVE",
  LEGAL_FORM_ASSOCIATION = "LEGAL_FORM_ASSOCIATION",
  LEGAL_FORM_FOUNDATION = "LEGAL_FORM_FOUNDATION",
  LEGAL_FORM_OTHER = "LEGAL_FORM_OTHER",
}

export interface V2LinkCompaniesRequest {
  relations: V2Relation[];
}

export type V2LinkCompaniesResponse = object;

export interface V2LinkPersonsRequest {
  relations: V2Relation[];
}

export type V2LinkPersonsResponse = object;

export interface V2ListForPhoneProviderResponse {
  companies: V2PhoneProviderCompany[];
  persons: V2PhoneProviderPerson[];
}

export interface V2Person {
  active: boolean;
  address: CommonaddressAddress;
  addressHistory: V2AddressEntry[];
  ahv: string;
  birthName: string;
  birthplace: string;
  civilStatus: Contactcontactv2CivilStatus;
  condominiumIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath: TypeDate;
  documentIds: string[];
  email: string;
  employment: Contactcontactv2Employment;
  firstName: string;
  gender: Contactcontactv2Gender;
  iban: string;
  id: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveAt: TypeDate;
  industries: IndustryIndustry[];
  lastName: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name: string;
  nationality: string;
  note: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
  phoneNumbers: V2PhoneNumber[];
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredLanguage: LanguagePreferredLanguage;
  relations: V2Relation[];
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil: TypeDate;
  salutationName: string;
  tags: string[];
  tenancyIds: string[];
  title: string;
  types: Contactcontactv2Type[];
  /**
   * UNIX timestamp in seconds when person was modified the last time
   * @format int64
   */
  updatedAt: string;
  website: string;
  workEmail: V2AdditionalEmail;
}

export interface V2PhoneProviderCompany {
  contactPersons: V2PhoneProviderContactPerson[];
  id: string;
  name: string;
  phoneNumbers: V2PhoneNumber[];
}

export interface V2PhoneProviderContactPerson {
  firstName: string;
  id: string;
  lastName: string;
  phoneNumbers: V2PhoneNumber[];
}

export interface V2PhoneProviderPerson {
  firstName: string;
  id: string;
  lastName: string;
  phoneNumbers: V2PhoneNumber[];
}

/** @default "PREFERRED_COMMUNICATION_CHANNEL_UNDEFINED" */
export enum V2PreferredCommunicationChannel {
  PREFERRED_COMMUNICATION_CHANNEL_UNDEFINED = "PREFERRED_COMMUNICATION_CHANNEL_UNDEFINED",
  PREFERRED_COMMUNICATION_CHANNEL_EMAIL = "PREFERRED_COMMUNICATION_CHANNEL_EMAIL",
  PREFERRED_COMMUNICATION_CHANNEL_LETTER = "PREFERRED_COMMUNICATION_CHANNEL_LETTER",
}

export interface V2Relation {
  incomingContactId: string;
  outgoingContactId: string;
}

export interface V2ResolveByCondominiumIdsResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2ResolveByMailMultipleOwnersRequest {
  emails: string[];
  ownerIds: string[];
}

export interface V2ResolveByMailMultipleOwnersResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2ResolveByMailResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2ResolveByTenancyIdsResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2ResolveEmployeesRequest {
  emails: string[];
  /** @format int64 */
  ownerId: string;
}

export interface V2ResolveEmployeesResponse {
  persons: V2Person[];
}

export interface V2ResolveRequest {
  contactIds: string[];
}

export interface V2ResolveResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2SearchByMailResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2SetAddressRequest {
  address: CommonaddressAddress;
  ids: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export interface V2SetAddressResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export interface V2UnLinkCompaniesRequest {
  relations: V2Relation[];
}

export type V2UnLinkCompaniesResponse = object;

export interface V2UnLinkPersonsRequest {
  relations: V2Relation[];
}

export type V2UnLinkPersonsResponse = object;

export interface V2UpdateAddressHistoryRequest {
  address: CommonaddressAddress;
  ids: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  oldValidFrom: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export interface V2UpdateAddressHistoryResponse {
  companies: Contactcontactv2Company[];
  persons: V2Person[];
}

export type V2UpdateGenericResponse = object;

export interface V2UpdatePersonResponse {
  person: V2Person;
}

export interface V3ActivityReference {
  id: string;
  relatedIds: string[];
}

/** @default "ACTIVITY_SOURCE_UNDEFINED" */
export enum V3Source {
  ACTIVITY_SOURCE_UNDEFINED = "ACTIVITY_SOURCE_UNDEFINED",
  ACTIVITY_SOURCE_PHONE = "ACTIVITY_SOURCE_PHONE",
  ACTIVITY_SOURCE_MAIL = "ACTIVITY_SOURCE_MAIL",
  ACTIVITY_SOURCE_PERSONAL = "ACTIVITY_SOURCE_PERSONAL",
}

export interface CredentialsCreateCredentialsRequest {
  /** FTP hostname */
  hostname: string;
  /** FTP password (stored AES encrypted) */
  password: string;
  /**
   * FTP port
   * @format int64
   */
  port: string;
  /** FTP username (stored AES encrypted) */
  username: string;
}

export interface CredentialsCreateCredentialsResponse {
  credentialsId: string;
}

export interface CredentialsCredentials {
  /** FTP hostname */
  hostname: string;
  /** xid */
  id: string;
  /** FTP password (stored AES encrypted) */
  password: string;
  /**
   * FTP port
   * @format int64
   */
  port: string;
  /** FTP username (stored AES encrypted) */
  username: string;
}

export interface CredentialsFindDecryptedCredentialsResponse {
  credentials: CredentialsCredentials;
}

export interface CredentialsUpdateCredentialsRequest {
  /** FTP hostname */
  hostname: string;
  /** xid */
  id: string;
  /** FTP password (stored AES encrypted) */
  password: string;
  /**
   * FTP port
   * @format int64
   */
  port: string;
  /** If true password is updated, otherwise not */
  updatePassword: boolean;
  /** FTP username (stored AES encrypted) */
  username: string;
}

export interface CredentialsUpdateCredentialsResponse {
  credentials: CredentialsCredentials;
}

export type DocumentBundleCreateDocumentBundleResponse = object;

export interface Exporthistoryv2GetLatestResponse {
  casaone: V2ExportRun;
  comparis: V2ExportRun;
  flatfox: V2ExportRun;
  homegate: V2ExportRun;
  immoscout: V2ExportRun;
  immowelt: V2ExportRun;
  maison: V2ExportRun;
  newhome: V2ExportRun;
  properstar: V2ExportRun;
  realadvisor: V2ExportRun;
  robinreal: V2ExportRun;
  urbanhome: V2ExportRun;
}

export interface ExportschedulerSchedule {
  evening: boolean;
  exportId: string;
  morning: boolean;
  noon: boolean;
}

export interface TendGetRedXAreaModelResponse {
  /** @format byte */
  zipUbsPk: string;
  /** @format byte */
  zipUbsSima: string;
}

export interface TendGetRentalIndexCSVResponse {
  csv: string;
  csvUbsPk: string;
}

/** ExportService ----------------------- */
export interface V2CreateExportRequest {
  /** @format int64 */
  accountId: string;
  agencyId: string;
  credentialsId: string;
  customImageUrl: string;
  customName: string;
  objects: string[];
  platform: V2Platform;
  type: V2ExportType;
}

export interface V2CreateExportResponse {
  export: V2Export;
}

export type V2DeleteExportResponse = object;

export interface V2Export {
  /**
   * coozzy account ID (BIGINT)
   * @format int64
   */
  accountId: string;
  /**
   * The agencyID used when encoding the IDX file. If empty, the objects ownerID will be used
   * AgencyID is used to by the target platform to identify the object.
   */
  agencyId: string;
  /** xid */
  credentialsId: string;
  customImageUrl: string;
  customName: string;
  /** xid */
  id: string;
  /** valid platform string (see 'export/export/export/service.go#L218' for all valid platforms) */
  platform: V2Platform;
  /** all targets to be exported */
  targets: V2Target[];
  /** idx, swissrets */
  type: V2ExportType;
}

export type V2ExportIdxResponse = object;

export interface V2ExportRun {
  /** @format int64 */
  accountId: string;
  events: V2ExportRunEvent[];
  exportId: string;
  platform: string;
  runId: string;
  /** @format int64 */
  started: string;
  status: string;
  targets: V2Target[];
}

export interface V2ExportRunEvent {
  data: Record<string, string>;
  /** @format int64 */
  date: string;
  errorType: string;
  message: string;
  path: string;
  targets: V2TargetStatus[];
  type: string;
}

/** @default "UNDEFINED_EXPORT_TYPE" */
export enum V2ExportType {
  UNDEFINED_EXPORT_TYPE = "UNDEFINED_EXPORT_TYPE",
  IDX_EXPORT_TYPE = "IDX_EXPORT_TYPE",
  SWISSRETS_EXPORT_TYPE = "SWISSRETS_EXPORT_TYPE",
}

export interface V2FindExportResponse {
  export: V2Export;
}

export interface V2ListExportsResponse {
  exports: V2Export[];
}

export interface V2ListObjectPlatformsResponse {
  platforms: V2Platform[];
}

export interface V2ListPresetsResponse {
  presets: V2Preset[];
}

/** @default "UNDEFINED_PLATFORM" */
export enum V2Platform {
  UNDEFINED_PLATFORM = "UNDEFINED_PLATFORM",
  PROPBASE_PLATFORM = "PROPBASE_PLATFORM",
  HOMEGATE_PLATFORM = "HOMEGATE_PLATFORM",
  COMPARIS_PLATFORM = "COMPARIS_PLATFORM",
  NEWHOME_PLATFORM = "NEWHOME_PLATFORM",
  IMMOSCOUT_PLATFORM = "IMMOSCOUT_PLATFORM",
  IMMOWELT_PLATFORM = "IMMOWELT_PLATFORM",
  CASAONE_PLATFORM = "CASAONE_PLATFORM",
  FLATFOX_PLATFORM = "FLATFOX_PLATFORM",
  URBANHOME_PLATFORM = "URBANHOME_PLATFORM",
  PROPERSTAR_PLATFORM = "PROPERSTAR_PLATFORM",
  MAISON_PLATFORM = "MAISON_PLATFORM",
  REALADVISOR_PLATFORM = "REALADVISOR_PLATFORM",
  ROBINREAL_PLATFORM = "ROBINREAL_PLATFORM",
}

/**
 * - ALL_FIELDS_DISABLED_PRESET: includes NO values
 *  - FULL_AGENCY_NO_VISIT_PRESET: includes ALL agency values but NO visit values
 *  - FULL_PRESET: includes ALL availbale idx fields (if set)
 * @default "UNDEFINED_PRESET"
 */
export enum V2Preset {
  UNDEFINED_PRESET = "UNDEFINED_PRESET",
  ALL_FIELDS_DISABLED_PRESET = "ALL_FIELDS_DISABLED_PRESET",
  FULL_AGENCY_NO_VISIT_PRESET = "FULL_AGENCY_NO_VISIT_PRESET",
  FULL_PRESET = "FULL_PRESET",
}

export interface V2RemoveAllTargetsResponse {
  export: V2Export;
}

export interface V2SendExportUploadCommandRequest {
  /** credentials to connect to the FTP server */
  credentials: CredentialsCredentials;
  /** the export which triggered this command */
  exportId: string;
  /** the export run this upload belongs to */
  exportRunId: string;
  /** the target platform key */
  platform: V2Platform;
  /** data source path: upload everything inside this folder */
  sourcePath: string;
}

export type V2SendExportUploadCommandResponse = object;

export interface V2SetAgencyIdRequest {
  AgencyId: string;
  ExportId: string;
}

export type V2SetAgencyIdResponse = object;

export interface V2SetPresetRequest {
  exportId: string;
  preset: V2Preset;
}

export type V2SetPresetResponse = object;

export interface V2StartExportResponse {
  exportRunId: string;
}

export interface V2StatisticsCountStatus {
  /** @format int32 */
  failed: number;
  /** @format int32 */
  finished: number;
  /** @format int32 */
  started: number;
}

export interface V2StatisticsCounts {
  /** @format int32 */
  overall: number;
  platforms: V2StatisticsPlatforms;
  status: V2StatisticsCountStatus;
  /** @format int32 */
  today: number;
}

export interface V2StatisticsPlatforms {
  /** @format int32 */
  casaone: number;
  /** @format int32 */
  comparis: number;
  /** @format int32 */
  flatfox: number;
  /** @format int32 */
  homegate: number;
  /** @format int32 */
  immoscout: number;
  /** @format int32 */
  immowelt: number;
  /** @format int32 */
  maison: number;
  /** @format int32 */
  newhome: number;
  /** @format int32 */
  properstar: number;
  /** @format int32 */
  realadvisor: number;
  /** @format int32 */
  robinreal: number;
  /** @format int32 */
  urbanhome: number;
}

export interface V2StatisticsResponse {
  counts: V2StatisticsCounts;
}

export interface V2Target {
  /** xid */
  exportId: string;
  /** xid */
  id: string;
  /** propbase objectId */
  objectId: string;
  /**
   * The preset-key which defines which values are exported. The key needs to be understood by the consuming
   * service (e.g. idx, swissrets). The export service does not have any knowledge of a concrete preset.
   */
  preset: V2Preset;
}

export interface V2TargetStatus {
  /** Target ID */
  id: string;
  /** Free text message */
  message: string;
  /** Object ID */
  objectId: string;
  /** Status of the single target */
  status: V2TargetStatusStatus;
}

/** @default "PENDING" */
export enum V2TargetStatusStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface V2UpdateExportRequest {
  /** @format int64 */
  accountId: string;
  credentialsId: string;
  customImageUrl: string;
  customName: string;
  id: string;
  platform: V2Platform;
  targets: string[];
  type: V2ExportType;
}

export interface V2UpdateExportResponse {
  export: V2Export;
}

export interface V2UpdatePlatformsRequest {
  /** @format int64 */
  accountId: string;
  objectId: string;
  platforms: V2Platform[];
}

export interface V2UpdatePlatformsResponse {
  exports: V2Export[];
}

export interface DocumentMergeAllDocumentsRequest {
  media: DocumentmergingMedium[];
  mergeMediumName: string;
}

export interface DocumentMergeAllDocumentsResponse {
  /** @format byte */
  media: string;
}

export interface DocumentSaveRequest {
  mediaId: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  showInPortal: boolean;
  type: MediadocumentType;
}

export interface DocumentVersion {
  mediaId: string;
  userId: string;
  /** @format int32 */
  version: number;
}

export interface DocumentmergingMedium {
  id: string;
  mediumName: string;
}

export interface MediadocumentDocument {
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  showInPortal: boolean;
  type: MediadocumentType;
  /** @format int32 */
  version: number;
  versions: DocumentVersion[];
}

export interface MediadocumentListRequest {
  documentIds: string[];
}

export interface MediadocumentListResponse {
  documents: MediadocumentDocument[];
}

export type MediadocumentUpdateResponse = object;

export interface StoreCompleteUploadRequest {
  id: string;
}

export interface StoreCompleteUploadResponse {
  /** Current media; may still be PENDING or SCANNING (url empty until READY). */
  media: StoreMedia;
}

export interface StoreCreateUploadRequest {
  /** @format int64 */
  accountId: string;
  /** Stored filename (max 255 chars). */
  filename: string;
  /**
   * Optional. Max image width/height in pixels before resize (images only).
   * @format int32
   */
  maxDimension?: number;
  /** Client MIME hint only; overwritten from detected content after upload. */
  mimeType: string;
  public: boolean;
  /**
   * Declared size in bytes.
   * @format int32
   */
  size: number;
}

export interface StoreCreateUploadResponse {
  /** PENDING media; url and thumbnails are empty. */
  media: StoreMedia;
  /** GCS V4 signed PUT URL (quarantine bucket). */
  uploadUrl: string;
  /**
   * UNIX seconds; upload URL TTL is 15 minutes.
   * @format int64
   */
  uploadUrlValidUntil: string;
}

export type StoreDeleteMediaResponse = object;

export interface StoreGetMediaResponse {
  media: StoreMedia;
}

export interface StoreListMediaRequest {
  ids: string[];
}

export interface StoreListMediaResponse {
  media: StoreMedia[];
}

export interface StoreMedia {
  /** The filename (original or given one) */
  filename: string;
  /** Media ID */
  id: string;
  /** The MIME type of the media: https://en.wikipedia.org/wiki/Media_type */
  mimeType: string;
  /**
   * Account ID of the user who uploaded the media
   * @format int64
   */
  ownerId: string;
  /**
   * The size of the media in bytes
   * @format int32
   */
  size: number;
  /** Usable url and thumbnails only when READY. */
  status: StoreMediaStatus;
  /** Empty unless status is READY. */
  thumbnails: StoreThumbnail[];
  /**
   * UNIX timestamp in seconds when the media was uploaded
   * @format int64
   */
  uploadedAt: string;
  /** Empty unless status is READY. */
  url: string;
  /**
   * UNIX timestamp in seconds until which this URL is valid. Is set to 0 if no expiration or not READY.
   * @format int64
   */
  validUntil: string;
}

/**
 * - MEDIA_STATUS_PENDING: Signed upload created; waiting for quarantine object and/or scan
 *  - MEDIA_STATUS_SCANNING: Virus scan / promote in progress
 *  - MEDIA_STATUS_READY: Available for download; url and thumbnails are set
 *  - MEDIA_STATUS_REJECTED: Rejected (e.g. infected or blocked MIME); no usable url
 *  - MEDIA_STATUS_EXPIRED: Upload URL or quarantine object expired without becoming READY
 * @default "MEDIA_STATUS_UNDEFINED"
 */
export enum StoreMediaStatus {
  MEDIA_STATUS_UNDEFINED = "MEDIA_STATUS_UNDEFINED",
  MEDIA_STATUS_PENDING = "MEDIA_STATUS_PENDING",
  MEDIA_STATUS_SCANNING = "MEDIA_STATUS_SCANNING",
  MEDIA_STATUS_READY = "MEDIA_STATUS_READY",
  MEDIA_STATUS_REJECTED = "MEDIA_STATUS_REJECTED",
  MEDIA_STATUS_EXPIRED = "MEDIA_STATUS_EXPIRED",
}

export interface StoreSetPublicFlagRequest {
  ids: string[];
  public: boolean;
}

export type StoreSetPublicFlagResponse = object;

export interface StoreThumbnail {
  type: StoreThumbnailType;
  url: string;
}

/**
 * - S: Maximum width/height: 100px
 *  - M: Maximum width/height: 400px
 * @default "S"
 */
export enum StoreThumbnailType {
  S = "S",
  M = "M",
}

/**
 * Docs-only request shape for Upload. The real HTTP body is multipart/form-data;
 * the binary `file` part cannot be represented in protobuf and is documented on the RPC.
 */
export interface StoreUploadMediaRequest {
  /**
   * Form field. Owner account ID; falls back to x-account-id, else -1.
   * @format int64
   */
  accountId: string;
  /** Optional form field. Stored filename override (max 255 chars); defaults to the original upload name. */
  filename?: string;
  /**
   * Optional form field. Max image width/height in pixels before resize (images only).
   * @format int32
   */
  maxDimension?: number;
  /** Form field. Truthy when sent as "true" or "1". Defaults to private. */
  public: boolean;
}

export interface Mailv2Participant {
  email: string;
  name: string;
}

export interface Messagemailv2MarkReadRequest {
  /** @format int64 */
  accountId: string;
  ids: string[];
}

export type Messagemailv2MarkReadResponse = object;

export interface Messagemailv2MarkUnreadRequest {
  /** @format int64 */
  accountId: string;
  ids: string[];
}

export type Messagemailv2MarkUnreadResponse = object;

export interface Messagesignaturev2GetResponse {
  signature: Signaturev2Signature;
}

export interface Messagesignaturev2RenderResponse {
  /** Signature with replaced placeholders */
  signature: string;
}

export interface Messagetemplatev2CreateRequest {
  attachmentMediaIds: string[];
  language: string;
  message: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  subject: string;
  type: V2TemplateType;
}

export interface Messagetemplatev2CreateResponse {
  template: Templatev2Template;
}

export type Messagetemplatev2DeleteResponse = object;

export interface Messagetemplatev2ListResponse {
  templates: Templatev2Template[];
}

export interface Messagetemplatev2RenderResponse {
  attachmentMediaIds: string[];
  subject: string;
  text: string;
}

export type Messagetemplatev2UpdateResponse = object;

export type Signaturev2SetResponse = object;

export interface Signaturev2Signature {
  /** @format int64 */
  accountId: string;
  id: string;
  name: string;
  signature: string;
}

export interface Templatev2Template {
  attachmentMediaIds: string[];
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  createdAt: string;
  id: string;
  language: string;
  message: string;
  name: string;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  subject: string;
  type: V2TemplateType;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  updatedAt: string;
}

export interface V2ActivateMailboxesRequest {
  ids: string[];
}

export type V2ActivateMailboxesResponse = object;

export interface V2AddConfidentialEmailsRequest {
  /** @format int64 */
  accountId: string;
  emails: string[];
}

export type V2AddConfidentialEmailsResponse = object;

export interface V2ArchiveRequest {
  ids: string[];
}

export type V2ArchiveResponse = object;

export interface V2AutomaticReply {
  bodyHtml: string;
  bodyText: string;
  enabled: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  endTime: TypeTimeOfDay;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  startTime: TypeTimeOfDay;
  subject: string;
}

export interface V2BulkRenderTextEntry {
  buildingId: string;
  contactId: string;
  objectId: string;
  propertyId: string;
}

export interface V2BulkRenderTextRequest {
  entries: V2BulkRenderTextEntry[];
  text: string;
  title: string;
}

export interface V2BulkRenderTextResponse {
  entries: V2BulkRenderedTextEntries[];
}

export interface V2BulkRenderedTextEntries {
  contactId: string;
  text: string;
  title: string;
}

export interface V2BulkSendMailEntry {
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  confidential: boolean;
  from: Mailv2Participant;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
  /** Optional: If set to id of mail the user replies to -> support for threaded mails */
  replyToMailId: string;
  subject: string;
  to: Mailv2Participant[];
}

export interface V2BulkSendMailRequest {
  entries: V2BulkSendMailEntry[];
}

export interface V2BulkSendMailResponse {
  mail: V2Mail[];
}

export interface V2CidMapping {
  cid: string;
  mediaId: string;
}

export interface V2CountDraftsResponse {
  /** @format int32 */
  amount: number;
}

export interface V2CountUnreadMailsResponse {
  /** @format int32 */
  count: number;
}

export interface V2CreateDomainRequest {
  domain: string;
  /** @format int64 */
  ownerId: string;
}

export interface V2CreateDomainResponse {
  domain: V2Domain;
}

export interface V2CreateMailboxRequest {
  allowedUserIds: string[];
  mailboxType: V2MailboxType;
  /** Can be empty if no specific user is using this mailbox */
  mainUserId: string;
  name: string;
  outboundEmail: string;
  /** @format int64 */
  ownerId: string;
  signatureId: string;
}

export interface V2CreateMailboxResponse {
  mailbox: V2Mailbox;
}

export interface V2DeactivateMailboxesRequest {
  ids: string[];
}

export type V2DeactivateMailboxesResponse = object;

export type V2DeleteDomainResponse = object;

export type V2DeleteDraftsResponse = object;

export type V2DeleteMailsResponse = object;

export type V2DeleteSignatureResponse = object;

/** @default "DELIVER_STATUS_UNDEFINED" */
export enum V2DeliverStatus {
  DELIVER_STATUS_UNDEFINED = "DELIVER_STATUS_UNDEFINED",
  DELIVER_STATUS_PENDING = "DELIVER_STATUS_PENDING",
  DELIVER_STATUS_DELIVERED = "DELIVER_STATUS_DELIVERED",
  DELIVER_STATUS_ERROR = "DELIVER_STATUS_ERROR",
}

export interface V2DeliverabilityData {
  /** @format int64 */
  changedAt: string;
  errorMessage: string;
  status: V2DeliverStatus;
}

export interface V2Domain {
  domain: string;
  id: string;
  isValid: boolean;
  /** @format int64 */
  ownerId: string;
  validationKey: string;
}

export type V2EditMailboxResponse = object;

export interface V2EngagementData {
  /** @format int64 */
  changedAt: string;
  status: V2EngagementStatus;
}

/** @default "ENGAGEMENT_STATUS_UNDEFINED" */
export enum V2EngagementStatus {
  ENGAGEMENT_STATUS_UNDEFINED = "ENGAGEMENT_STATUS_UNDEFINED",
  ENGAGEMENT_STATUS_OPENED = "ENGAGEMENT_STATUS_OPENED",
  ENGAGEMENT_STATUS_CLICKED = "ENGAGEMENT_STATUS_CLICKED",
}

/** @default "FILTER_FOLDER_ALL" */
export enum V2FilterFolder {
  FILTER_FOLDER_ALL = "FILTER_FOLDER_ALL",
  FILTER_FOLDER_INBOUND = "FILTER_FOLDER_INBOUND",
  FILTER_FOLDER_OUTBOUND = "FILTER_FOLDER_OUTBOUND",
  FILTER_FOLDER_ARCHIVED = "FILTER_FOLDER_ARCHIVED",
  FILTER_FOLDER_TRASH = "FILTER_FOLDER_TRASH",
  FILTER_FOLDER_SPAM = "FILTER_FOLDER_SPAM",
}

export interface V2ForwardRequest {
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  confidential: boolean;
  forwardingMailId: string;
  from: Mailv2Participant;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
  subject: string;
  to: Mailv2Participant[];
}

export interface V2ForwardResponse {
  mail: V2Mail;
}

export interface V2GetDeliveryAndEngagementDataEntry {
  bcc: Mailv2Participant[];
  cc: Mailv2Participant[];
  deliverData: V2DeliverabilityData;
  engagementData: V2EngagementData;
  from: Mailv2Participant;
  id: string;
  referenceId: string[];
  /**
   * UNIX timestamp in seconds when mail was sent/received
   * @format int64
   */
  timestamp: string;
  to: Mailv2Participant[];
}

export interface V2GetDeliveryAndEngagementDataRequest {
  referenceIds: string[];
}

export interface V2GetDeliveryAndEngagementDataResponse {
  entries: V2GetDeliveryAndEngagementDataEntry[];
}

export interface V2GetMailboxResponse {
  mailbox: V2Mailbox;
}

export interface V2GetRequestAddressResponse {
  email: string;
}

export interface V2GetTicketAddressResponse {
  email: string;
}

export interface V2HasDomainDedicatedIpResponse {
  hasDedicated: boolean;
}

export interface V2ListByAccountIdResponse {
  signatures: Signaturev2Signature[];
}

export interface V2ListConfidentialEmailsResponse {
  emails: string[];
}

export interface V2ListDomainsResponse {
  domains: V2Domain[];
}

export interface V2ListDraftsResponse {
  drafts: V2MailDraft[];
}

export interface V2ListLatestMailsForReferenceIdsRequest {
  referenceIds: string[];
}

export interface V2ListLatestMailsForReferenceIdsResponse {
  mails: V2Mail[];
}

export interface V2ListMailIdsRequest {
  filterFolder: V2FilterFolder;
  /** All mails with provided entity prefixes in referenceIds are excluded from results */
  filterReferenceIdPrefixes: string[];
  filterUnread: ApplicableApplicable;
  mailboxIds: string[];
  query: string;
  sortReceivedAt: SortSortOrder;
}

export interface V2ListMailIdsResponse {
  ids: string[];
}

export interface V2ListMailboxesByAccountIdResponse {
  mailboxes: V2Mailbox[];
}

export interface V2ListMailboxesByUserIdResponse {
  mailboxes: V2Mailbox[];
}

export interface V2ListMailsByIdsRequest {
  mailIds: string[];
}

export interface V2ListMailsByIdsResponse {
  mails: V2Mail[];
}

export interface V2ListMailsByReferenceIdsRequest {
  /** Optional filter. At least one provided email address must be a participant (FROM, TO, CC or BCC) */
  emailAddresses?: string[];
  filterFolder: V2FilterFolder;
  /** @format int32 */
  itemsPerPage: number;
  /** Optional filter that only needs to be set if filter folder is inbound/outbound */
  mailboxIds?: string[];
  /** @format int32 */
  page: number;
  query: string;
  referenceIds: string[];
}

export interface V2ListMailsByReferenceIdsResponse {
  mails: V2Mail[];
  /** @format int32 */
  totalMailsCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface V2ListMailsRequest {
  filterFolder: V2FilterFolder;
  /**
   * All mails with provided entity prefixes in referenceIds are excluded from results
   * All mails with provided entity prefixes in referenceIds are excluded from results
   */
  filterReferenceIdPrefixes: string[];
  filterUnread: ApplicableApplicable;
  /** @format int32 */
  itemsPerPage: number;
  /** If set to true, the response will only contain exact count until 100 mails. Page count won't be accurate after that. This flag can be used for performance reasons. */
  limitPagination: boolean;
  mailboxIds: string[];
  /** @format int32 */
  page: number;
  query: string;
  /** DEPRECATED. It's not supported anymore and sorting will not be applied */
  sortFromEmail: SortSortOrder;
  sortReceivedAt: SortSortOrder;
}

export interface V2ListMailsResponse {
  mails: V2Mail[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface V2Mail {
  archived: boolean;
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  cidMappings: V2CidMapping[];
  confidential: boolean;
  deliverData: V2DeliverabilityData;
  engagementData: V2EngagementData;
  from: Mailv2Participant;
  hasForwarding: boolean;
  hasReply: boolean;
  id: string;
  inTrash: boolean;
  inbound: boolean;
  mailType: V2MailType;
  mailboxId: string;
  maliciousAttachmentsMissing: boolean;
  missingHtml: boolean;
  /** @format int64 */
  ownerId: string;
  readEntries: V2Read[];
  referenceIds: string[];
  replyTo: string;
  /** If the mail was sent by our platform or was received by external sender */
  sentByPlatform: boolean;
  spam: boolean;
  subject: string;
  /**
   * UNIX timestamp in seconds when mail was sent/received
   * @format int64
   */
  timestamp: string;
  to: Mailv2Participant[];
}

export interface V2MailDraft {
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  forwardingMailId: string;
  id: string;
  mailboxId: string;
  ownerId: string;
  referenceIds: string[];
  replyToMailId: string;
  subject: string;
  /**
   * UNIX timestamp in seconds when draft was saved the last time
   * @format int64
   */
  timestamp: string;
  to: Mailv2Participant[];
  userId: string;
}

/** @default "MAIL_TYPE_NORMAL" */
export enum V2MailType {
  MAIL_TYPE_NORMAL = "MAIL_TYPE_NORMAL",
  MAIL_TYPE_IMIP = "MAIL_TYPE_IMIP",
  MAIL_TYPE_TICKET_NOTIFICATION = "MAIL_TYPE_TICKET_NOTIFICATION",
}

export interface V2Mailbox {
  active: boolean;
  allowedUserIds: string[];
  automaticReply: V2AutomaticReply;
  confidential: boolean;
  id: string;
  inboundEmail: string;
  mailboxType: V2MailboxType;
  /** Can be empty if no specific user is using this mailbox */
  mainUserId: string;
  name: string;
  outboundEmail: string;
  /** @format int64 */
  ownerId: string;
  signatureId: string;
}

/** @default "MAILBOX_TYPE_SPF" */
export enum V2MailboxType {
  MAILBOX_TYPE_SPF = "MAILBOX_TYPE_SPF",
  MAILBOX_TYPE_NYLAS = "MAILBOX_TYPE_NYLAS",
  MAILBOX_TYPE_NYLAS_MANUAL = "MAILBOX_TYPE_NYLAS_MANUAL",
}

export interface V2MarkAsNoSpamRequest {
  ids: string[];
}

export type V2MarkAsNoSpamResponse = object;

export interface V2MarkAsSpamRequest {
  ids: string[];
}

export type V2MarkAsSpamResponse = object;

export interface V2MoveToTrashRequest {
  ids: string[];
}

export type V2MoveToTrashResponse = object;

export interface V2Read {
  /** @format int64 */
  accountId: string;
  /**
   * UNIX timestamp in seconds when marked as read
   * @format int64
   */
  timestamp: string;
}

export interface V2RemoveConfidentialEmailsRequest {
  /** @format int64 */
  accountId: string;
  emails: string[];
}

export type V2RemoveConfidentialEmailsResponse = object;

export interface V2RenderByIdResponse {
  /** Signature with replaced placeholders */
  signature: string;
}

export interface V2RenderTextRequest {
  contactId: string;
  objectId: string;
  text: string;
  title: string;
}

export interface V2RenderTextResponse {
  text: string;
  title: string;
}

export interface V2RestoreFromTrashRequest {
  ids: string[];
}

export type V2RestoreFromTrashResponse = object;

export interface V2SaveDraftRequest {
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  forwardingMailId: string;
  /** Optional parameter to save new drafts and update existing ones */
  id?: string;
  mailboxId: string;
  referenceIds: string[];
  replyToMailId: string;
  subject: string;
  /**
   * UNIX timestamp in seconds when draft was saved the last time
   * @format int64
   */
  timestamp: string;
  to: Mailv2Participant[];
}

export interface V2SaveDraftResponse {
  draft: V2MailDraft;
}

export interface V2SendMailRequest {
  attachmentMediaIds: string[];
  bcc: Mailv2Participant[];
  bodyHtml: string;
  bodyText: string;
  cc: Mailv2Participant[];
  confidential: boolean;
  from: Mailv2Participant;
  /** Optional */
  mailType?: V2MailType;
  /** @format int64 */
  ownerId: string;
  referenceIds: string[];
  /** Optional: If set to id of mail the user replies to -> support for threaded mails */
  replyToMailId?: string;
  /**
   * Optional: for scheduled mails
   * @format int64
   */
  sendAt?: string;
  subject: string;
  to: Mailv2Participant[];
}

export interface V2SendMailResponse {
  mail: V2Mail;
}

export interface V2SetAutomaticReplyRequest {
  automaticReply: V2AutomaticReply;
  ids: string[];
}

export interface V2SetAutomaticReplyResponse {
  mailboxes: V2Mailbox[];
}

export interface V2SetConfidentialRequest {
  confidential: boolean;
  ids: string[];
}

export type V2SetConfidentialResponse = object;

export interface V2SetMailboxesConfidentialRequest {
  confidential: boolean;
  mailboxIds: string[];
}

export interface V2SetMailboxesConfidentialResponse {
  mailboxes: V2Mailbox[];
}

export type V2SetReferenceIdsResponse = object;

export interface V2SetSignatureRequest {
  /** @format int64 */
  accountId: string;
  /** OPTIONAL. If not provided a new signature is created */
  id: string;
  name: string;
  signature: string;
}

export interface V2SetSignatureResponse {
  signature: Signaturev2Signature;
}

/** @default "TEMPLATE_TYPE_EMAIL" */
export enum V2TemplateType {
  TEMPLATE_TYPE_EMAIL = "TEMPLATE_TYPE_EMAIL",
  TEMPLATE_TYPE_LETTER = "TEMPLATE_TYPE_LETTER",
  TEMPLATE_TYPE_TICKET = "TEMPLATE_TYPE_TICKET",
  TEMPLATE_TYPE_DEEP_SIGN = "TEMPLATE_TYPE_DEEP_SIGN",
}

export interface V2UnarchiveRequest {
  ids: string[];
}

export type V2UnarchiveResponse = object;

export interface V2ValidateDomainResponse {
  isValid: boolean;
}

export interface AccountingAbacusConnectionConfig {
  /** AbaConnect base URL, e.g. https://host/abaconnect/services */
  abaConnectBaseUrl: string;
  /** Usernames only on read; passwords are never returned */
  abaConnectUser: string;
  abaEngineBaseUrl: string;
  abaEngineUser: string;
  /** @format int64 */
  mandantId: string;
  systemVariant: AccountingSystemVariant;
}

export interface AccountingAbacusCredentials {
  /** Write-only. Required on first provision; later only applied when updatePasswords is true. */
  abaConnectPassword: string;
  abaConnectUser: string;
  /** Write-only. Required on first provision; later only applied when updatePasswords is true. */
  abaEnginePassword: string;
  abaEngineUser: string;
}

export interface AccountingChangeContractRelationRequest {
  /** @format int64 */
  contractRelationNumber: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
}

export type AccountingChangeContractRelationResponse = object;

export interface AccountingContractErrorInfo {
  /** @format int64 */
  debtorId: string;
  errorMessages: string[];
  /**
   * UNIX timestamp when sync was attempted for the last time
   * @format int64
   */
  lastTimeSynced: string;
  /** @format int64 */
  numericId: string;
  /** @format int64 */
  ownerId: string;
}

export interface AccountingDocumentSyncLogEntry {
  attachedToEntityId: string;
  /** @format int64 */
  attachedToEntityNumericId: string;
  documentId: string;
  documentName: string;
  /** @format int64 */
  timestamp: string;
}

export interface AccountingGetDocSyncLogsResponse {
  logEntries: AccountingDocumentSyncLogEntry[];
  /** @format int32 */
  totalLogsCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface AccountingGetEnabledResponse {
  /** @format int64 */
  accountId: string;
  /** Usernames only; passwords are never returned */
  connection: AccountingAbacusConnectionConfig;
  directConnectionEnabled: boolean;
  disableBackSync: boolean;
  disableSync: boolean;
  enabled: boolean;
  /** @format int64 */
  targetAccountId: string;
  /** @format int64 */
  targetEnterpriseId: string;
  /** @format int64 */
  targetMainOwnerId: string;
  /** @format int64 */
  targetMandantId: string;
  /** @format int64 */
  targetProviderId: string;
  /** @format int64 */
  targetSystemId: string;
}

export interface AccountingGetLogsResponse {
  logEntries: AccountingLogEntry[];
  /** @format int32 */
  totalLogsCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface AccountingIsEnabled {
  enabled: boolean;
  propertyId: string;
}

export interface AccountingIsEnabledRequest {
  propertyIds: string[];
}

export interface AccountingIsEnabledResponse {
  isEnabled: AccountingIsEnabled[];
}

export interface AccountingListAllContractErrorsResponse {
  errors: AccountingContractErrorInfo[];
}

export interface AccountingLogEntry {
  entityId: string;
  /** @format int64 */
  entityNumericId: string;
  errorMessage: string;
  success: boolean;
  /** @format int64 */
  timestamp: string;
  triggeredBy: AccountingTriggeredBy;
}

export type AccountingSetContractSyncResponse = object;

/**
 * Configures enablement, account wiring, Inubit routing IDs, and Abacus connection in one RPC.
 * targetMandantId / targetProviderId / targetSystemId stay required for Inubit dual-run.
 */
export interface AccountingSetEnabledRequest {
  /** @format int64 */
  accountId: string;
  connection: AccountingAbacusConnectionConfig;
  /** Required when first provisioning. Passwords applied only when updatePasswords is true (or on first create). */
  credentials: AccountingAbacusCredentials;
  disableBackSync: boolean;
  disableSync: boolean;
  enabled: boolean;
  /** @format int64 */
  targetAccountId: string;
  /** @format int64 */
  targetEnterpriseId: string;
  /** @format int64 */
  targetMainOwnerId: string;
  /** @format int64 */
  targetMandantId: string;
  /** @format int64 */
  targetProviderId: string;
  /** @format int64 */
  targetSystemId: string;
  updatePasswords: boolean;
}

export type AccountingSetEnabledResponse = object;

export type AccountingSetPropertySyncResponse = object;

export interface AccountingSkipNextEventRequest {
  /** @format int64 */
  accountId: string;
}

export type AccountingSkipNextEventResponse = object;

export interface AccountingStatistics {
  contractErrors: AccountingContractErrorInfo[];
  enabled: boolean;
  invalidPayloadContractNumericIds: string[];
  /** @format int32 */
  invalidPayloadContracts: number;
  /**
   * UNIX timestamp when it was synced the last time
   * @format int64
   */
  lastContractSync: string;
  sourceAccountIds: string[];
  /** @format int32 */
  successfulContractSync: number;
  /** @format int64 */
  targetAccountId: string;
}

/**
 * Code-owned Abacus request-building variant (not provisioned via RPC config)
 * @default "SYSTEM_VARIANT_UNSPECIFIED"
 */
export enum AccountingSystemVariant {
  SYSTEM_VARIANT_UNSPECIFIED = "SYSTEM_VARIANT_UNSPECIFIED",
  SYSTEM_VARIANT_STANDARD = "SYSTEM_VARIANT_STANDARD",
  SYSTEM_VARIANT_PK_GR = "SYSTEM_VARIANT_PK_GR",
  SYSTEM_VARIANT_IMMOGUIDI = "SYSTEM_VARIANT_IMMOGUIDI",
  SYSTEM_VARIANT_BERNASCONI = "SYSTEM_VARIANT_BERNASCONI",
  SYSTEM_VARIANT_JHK = "SYSTEM_VARIANT_JHK",
  SYSTEM_VARIANT_ALLENSPACH = "SYSTEM_VARIANT_ALLENSPACH",
}

export type AccountingTriggerDebitUntilSyncResponse = object;

export type AccountingTriggerDocumentSyncResponse = object;

export type AccountingTriggerRentAdjustmentSyncResponse = object;

export interface AccountingTriggeredBy {
  name: string;
  userId: string;
}

export type BriefbutlerAcknowledgeErrorsResponse = object;

export interface BriefbutlerBriefbutlerProfile {
  briefbutlerId: string;
  description: string;
}

export interface BriefbutlerErrorEntryBriefbutler {
  entityId: string;
  errorMessage: string;
  id: string;
  mediaId: string;
  renderId: string;
  /** @format int64 */
  timestamp: string;
}

export interface BriefbutlerListErrorsByAccountIdResponse {
  errors: BriefbutlerErrorEntryBriefbutler[];
}

export interface BriefbutlerSendRawDocumentRequest {
  briefbutlerId: string;
  mediaId: string;
}

export type BriefbutlerSendRawDocumentResponse = object;

export interface BuildingAddBuildingContactsRequest {
  buildingContacts: ObjectbuildingBuildingContact[];
  ids: string[];
}

export type BuildingAddBuildingContactsResponse = object;

export interface BuildingBuildingFilterOption {
  id: string;
  name: string;
  objectIds: string[];
  /** @format int64 */
  ownerId: string;
}

export interface BuildingBuildingStrategy {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  reviewAt: TypeDate;
  type: BuildingBuildingStrategyType;
}

/** @default "BUILDING_STRATEGY_TYPE_UNDEFINED" */
export enum BuildingBuildingStrategyType {
  BUILDING_STRATEGY_TYPE_UNDEFINED = "BUILDING_STRATEGY_TYPE_UNDEFINED",
  BUILDING_STRATEGY_TYPE_NO_RENOVATION = "BUILDING_STRATEGY_TYPE_NO_RENOVATION",
  BUILDING_STRATEGY_TYPE_MAINTAIN = "BUILDING_STRATEGY_TYPE_MAINTAIN",
  BUILDING_STRATEGY_TYPE_REPAIR = "BUILDING_STRATEGY_TYPE_REPAIR",
  BUILDING_STRATEGY_TYPE_REPLACEMENT = "BUILDING_STRATEGY_TYPE_REPLACEMENT",
  BUILDING_STRATEGY_TYPE_SALE = "BUILDING_STRATEGY_TYPE_SALE",
}

/** @default "UNDEFINED_CONSTRUCTION_TYPE" */
export enum BuildingConstructionType {
  UNDEFINED_CONSTRUCTION_TYPE = "UNDEFINED_CONSTRUCTION_TYPE",
  OLD_BUILDING = "OLD_BUILDING",
  NEW_BUILDING = "NEW_BUILDING",
  HIGH_RISE_BUILDING = "HIGH_RISE_BUILDING",
  MIDDLE_TERRACED_HOUSE = "MIDDLE_TERRACED_HOUSE",
  RAISED_GROUND_FLOOR = "RAISED_GROUND_FLOOR",
  CORNER_BUILDING = "CORNER_BUILDING",
  MINERGIE_CONSTRUCTION = "MINERGIE_CONSTRUCTION",
  MINERGIE_CERTIFIED = "MINERGIE_CERTIFIED",
  LISTED_BUILDING = "LISTED_BUILDING",
}

export interface BuildingDistances {
  /** @format float */
  kindergarten: number;
  /** @format float */
  motorway: number;
  /** @format float */
  primarySchool: number;
  /** @format float */
  publicTransport: number;
  /** @format float */
  shop: number;
  /** @format float */
  upperSchool: number;
}

export interface BuildingEditBuildingContactsRequest {
  buildingContacts: ObjectbuildingBuildingContact[];
  ids: string[];
}

export type BuildingEditBuildingContactsResponse = object;

export interface BuildingGetByObjectIdResponse {
  building: ObjectbuildingBuilding;
}

export interface BuildingListAllResponse {
  buildings: ObjectbuildingBuilding[];
}

export interface BuildingListByCoordinatesResponse {
  buildings: ObjectbuildingBuilding[];
}

export type BuildingMoveBuildingResponse = object;

export interface BuildingRating {
  /** @format float */
  microLocationRating: number;
  /** @format float */
  microLocationRatingProposal: number;
}

export interface BuildingRemoveBuildingContactsRequest {
  buildingContacts: ObjectbuildingBuildingContact[];
  ids: string[];
}

export type BuildingRemoveBuildingContactsResponse = object;

/** https://swissrets.ch/SIA-areas.html */
export interface BuildingSia {
  /** @format float */
  siaAff: number;
  /** @format float */
  siaAgf: number;
  /** @format float */
  siaAkf: number;
  /** @format float */
  siaAkfn: number;
  /** @format float */
  siaAkft: number;
  /** @format float */
  siaAnf: number;
  /** @format float */
  siaAngf: number;
  /** @format float */
  siaAvf: number;
  /** @format float */
  siaBuf: number;
  /** @format float */
  siaFf: number;
  /** @format float */
  siaGf: number;
  /** @format float */
  siaGgf: number;
  /** @format float */
  siaGsf: number;
  /** @format float */
  siaHnf: number;
  /** @format float */
  siaHnf1: number;
  /** @format float */
  siaHnf2: number;
  /** @format float */
  siaHnf3: number;
  /** @format float */
  siaHnf4: number;
  /** @format float */
  siaHnf5: number;
  /** @format float */
  siaHnf6: number;
  /** @format float */
  siaKf: number;
  /** @format float */
  siaKfn: number;
  /** @format float */
  siaKft: number;
  /** @format float */
  siaNf: number;
  /** @format float */
  siaNgf: number;
  /** @format float */
  siaNnf: number;
  /** @format float */
  siaUf: number;
  /** @format float */
  siaUuf: number;
  /** @format float */
  siaVf: number;
}

export interface BuildingUpdateMicroLocationRatingProposalResponse {
  building: ObjectbuildingBuilding;
}

export interface CondominiumCondominium {
  activated: boolean;
  closed: boolean;
  contract: ObjectcondominiumContract;
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  finalInvoiceCreated: boolean;
  /** Deprecated, use rent message */
  flatRateValues: ObjectcondominiumFlatRateValues[];
  id: string;
  isLatest: boolean;
  /** @format int64 */
  numericId: string;
  objectId: string;
  opted: boolean;
  owner: CondominiumOwner;
  /** @format int64 */
  ownerId: string;
  rent: ObjectcondominiumRent;
  secondaryResidence: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  status: CondominiumCondominiumStatus;
  taxable: boolean;
  tenants: ObjectcondominiumTenant[];
  /**
   * UNIX timestamp in seconds when condominium was modified the last time
   * @format int64
   */
  updatedAt: string;
}

/** @default "CONDOMINIUM_STATUS_NOT_ACTIVATED" */
export enum CondominiumCondominiumStatus {
  CONDOMINIUM_STATUS_NOT_ACTIVATED = "CONDOMINIUM_STATUS_NOT_ACTIVATED",
  CONDOMINIUM_STATUS_CURRENT = "CONDOMINIUM_STATUS_CURRENT",
  CONDOMINIUM_STATUS_CURRENT_TERMINATED = "CONDOMINIUM_STATUS_CURRENT_TERMINATED",
  CONDOMINIUM_STATUS_TERMINATED = "CONDOMINIUM_STATUS_TERMINATED",
  CONDOMINIUM_STATUS_CLOSED = "CONDOMINIUM_STATUS_CLOSED",
  CONDOMINIUM_STATUS_FUTURE = "CONDOMINIUM_STATUS_FUTURE",
}

export interface CondominiumHasActivatedCondominiumEntry {
  hasActivatedCondominium: boolean;
  objectId: string;
}

export interface CondominiumHasActivatedCondominiumRequest {
  objectIds: string[];
}

export interface CondominiumHasActivatedCondominiumResponse {
  entries: CondominiumHasActivatedCondominiumEntry[];
}

export interface CondominiumHasCondominiumWithContactIdsResponse {
  existing: boolean;
}

export interface CondominiumListByOwnerContactResponse {
  condominiums: CondominiumCondominium[];
}

export interface CondominiumListByTenantContactsResponse {
  condominiums: CondominiumCondominium[];
}

export interface CondominiumOwner {
  billingContactId: string;
  contactIds: string[];
  correspondenceContactId: string;
  /** @format int32 */
  numberOfPersons: number;
  roommateContactIds: string[];
}

export interface ContactcommonContactReference {
  /** @format int64 */
  accountId: string;
  name: string;
  userReference: string;
}

export interface ContractRenderTemplateRequest {
  attachAutomatically: boolean;
  description: string;
  id: string;
  signatories: string[];
  /** The ID of the tenancy for which a new contract should be rendered */
  tenancyId: string;
  title: string;
}

export interface ContractRenderTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface Contractv2ContactData {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface Contractv2ContractTemplate {
  category: Contractv2TemplateCategory;
  /** @format int64 */
  createdAt: string;
  creatorName: string;
  enforcePdf: boolean;
  id: string;
  language: V2Language;
  mediaId: string;
  /** @format int64 */
  ownerId: string;
  title: string;
  /** @format int64 */
  updatedAt: string;
}

export interface Contractv2CreateTemplateRequest {
  category: Contractv2TemplateCategory;
  creatorName: string;
  enforcePdf: boolean;
  language: V2Language;
  mediaId: string;
  /** @format int64 */
  ownerId: string;
  title: string;
}

export interface Contractv2CreateTemplateResponse {
  template: Contractv2ContractTemplate;
}

export type Contractv2DeleteTemplateResponse = object;

export interface Contractv2DeviceData {
  id: string;
  note: string;
}

export interface Contractv2ListTemplatesResponse {
  templates: Contractv2ContractTemplate[];
}

export interface Contractv2RenderCondominiumTemplateRequest {
  attachAutomatically: boolean;
  condominiumId: string;
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  includeRoommates: boolean;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  title: string;
}

export interface Contractv2RenderCondominiumTemplateResponse {
  renderId: string;
}

export interface Contractv2RenderCondominiumsTemplateRequest {
  attachAutomatically: boolean;
  condominiumIds: string[];
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  includeRoommates: boolean;
  order: V2RenderOrder;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  title: string;
}

export interface Contractv2RenderCondominiumsTemplateResponse {
  renderId: string;
}

export interface Contractv2RenderContactTemplateRequest {
  attachAutomatically: boolean;
  contactId: string;
  /** Optional. Determines the used address for some placeholders if the tenant is a company contact. */
  contactPersonId?: string;
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  title: string;
}

export interface Contractv2RenderContactTemplateResponse {
  renderId: string;
}

export interface Contractv2RenderContactsTemplateRequest {
  attachAutomatically: boolean;
  contactIds: string[];
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  order: V2RenderOrder;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  title: string;
}

export interface Contractv2RenderContactsTemplateResponse {
  renderId: string;
}

export interface Contractv2RenderDeviceTemplateRequest {
  assigneeContactId: string;
  attachAutomatically: boolean;
  contactId: string;
  description: string;
  devices: Contractv2DeviceData[];
  documentName: string;
  enforcePdf: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  executeFrom: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  executeUntil: TypeDate;
  id: string;
  /** Either provide this or randomContactData, but not both! */
  onSiteContactPersonId: string;
  orderDescription: string;
  orderNumber: string;
  /** Either provide this or onSiteContactPersonId, but not both! */
  randomContactData: Contractv2ContactData;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  title: string;
}

export interface Contractv2RenderDeviceTemplateResponse {
  renderId: string;
}

export interface Contractv2RenderTenanciesTemplateRequest {
  attachAutomatically: boolean;
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  oneDocumentPerTenancy: boolean;
  order: V2RenderOrder;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  tenancyIds: string[];
  title: string;
}

export interface Contractv2RenderTenanciesTemplateResponse {
  renderId: string;
}

/** @default "TEMPLATE_CATEGORY_UNDEFINED" */
export enum Contractv2TemplateCategory {
  TEMPLATE_CATEGORY_UNDEFINED = "TEMPLATE_CATEGORY_UNDEFINED",
  TEMPLATE_CATEGORY_GENERAL = "TEMPLATE_CATEGORY_GENERAL",
  TEMPLATE_CATEGORY_ORDERS = "TEMPLATE_CATEGORY_ORDERS",
  TEMPLATE_CATEGORY_TERMINATION = "TEMPLATE_CATEGORY_TERMINATION",
  TEMPLATE_CATEGORY_CONTRACTS = "TEMPLATE_CATEGORY_CONTRACTS",
  TEMPLATE_CATEGORY_PAYMENTS = "TEMPLATE_CATEGORY_PAYMENTS",
  TEMPLATE_CATEGORY_OFFER = "TEMPLATE_CATEGORY_OFFER",
  TEMPLATE_CATEGORY_LETTER = "TEMPLATE_CATEGORY_LETTER",
}

export type Contractv2UpdateTemplateResponse = object;

/** @default "COUNTRY_INDEX_BASE_YEAR_1914" */
export enum CountryIndexCountryIndexBaseYear {
  COUNTRYINDEXBASEYEAR1914 = "COUNTRY_INDEX_BASE_YEAR_1914",
  COUNTRYINDEXBASEYEAR1939 = "COUNTRY_INDEX_BASE_YEAR_1939",
  COUNTRYINDEXBASEYEAR1966 = "COUNTRY_INDEX_BASE_YEAR_1966",
  COUNTRYINDEXBASEYEAR1977 = "COUNTRY_INDEX_BASE_YEAR_1977",
  COUNTRYINDEXBASEYEAR1982 = "COUNTRY_INDEX_BASE_YEAR_1982",
  COUNTRYINDEXBASEYEAR1993 = "COUNTRY_INDEX_BASE_YEAR_1993",
  COUNTRYINDEXBASEYEAR2000 = "COUNTRY_INDEX_BASE_YEAR_2000",
  COUNTRYINDEXBASEYEAR2005 = "COUNTRY_INDEX_BASE_YEAR_2005",
  COUNTRYINDEXBASEYEAR2010 = "COUNTRY_INDEX_BASE_YEAR_2010",
  COUNTRYINDEXBASEYEAR2015 = "COUNTRY_INDEX_BASE_YEAR_2015",
  COUNTRYINDEXBASEYEAR2020 = "COUNTRY_INDEX_BASE_YEAR_2020",
  COUNTRYINDEXBASEYEAR2025 = "COUNTRY_INDEX_BASE_YEAR_2025",
}

export interface CountryIndexGetInflationResponse {
  /** @format float */
  inflation: number;
}

export interface CountryIndexReadRequest {
  fileUrl: string;
}

export type CountryIndexReadResponse = object;

/** @default "DEMO_DATA_SET_1" */
export enum DemoDataDemoDataSet {
  DEMODATASET1 = "DEMO_DATA_SET_1",
  DEMODATASET2 = "DEMO_DATA_SET_2",
  DEMODATASET3 = "DEMO_DATA_SET_3",
}

/** @default "UNDEFINED_INTERVAL" */
export enum DeviceCostsInterval {
  UNDEFINED_INTERVAL = "UNDEFINED_INTERVAL",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
  MONTHLY = "MONTHLY",
  TRIANNUAL = "TRIANNUAL",
  HALF_YEARLY = "HALF_YEARLY",
  BI_MONTHLY = "BI_MONTHLY",
  TWO_YEARLY = "TWO_YEARLY",
  THREE_YEARLY = "THREE_YEARLY",
  FOUR_YEARLY = "FOUR_YEARLY",
  FIVE_YEARLY = "FIVE_YEARLY",
  TEN_YEARLY = "TEN_YEARLY",
  TWENTY_YEARLY = "TWENTY_YEARLY",
  EVERY6YEARS = "EVERY_6_YEARS",
  EVERY8YEARS = "EVERY_8_YEARS",
  EVERY15YEARS = "EVERY_15_YEARS",
}

export interface DeviceDefaultDataEntry {
  bkpH: string;
  /** @format float */
  cataloguePrice: number;
  facilityPlant: DeviceDeviceFacilityPlant;
  /** @format int32 */
  lifeSpan: number;
  system: DeviceDeviceSystem;
  type: DeviceDeviceType;
  unit: ObjectdeviceDeviceUnit;
}

/**
 * - DEVICE_CONDITION_REPAIR_NEEDED: Deprecated. Will be moved to action value
 *  - DEVICE_CONDITION_REPLACEMENT_NEEDED: Deprecated. Will be moved to action value
 * @default "DEVICE_CONDITION_UNDEFINED"
 */
export enum DeviceDeviceCondition {
  DEVICE_CONDITION_UNDEFINED = "DEVICE_CONDITION_UNDEFINED",
  DEVICE_CONDITION_NORMAL_WEAR = "DEVICE_CONDITION_NORMAL_WEAR",
  DEVICE_CONDITION_REPAIR_NEEDED = "DEVICE_CONDITION_REPAIR_NEEDED",
  DEVICE_CONDITION_REPLACEMENT_NEEDED = "DEVICE_CONDITION_REPLACEMENT_NEEDED",
  DEVICE_CONDITION_PERFECT = "DEVICE_CONDITION_PERFECT",
  DEVICE_CONDITION_DEFICIENCY = "DEVICE_CONDITION_DEFICIENCY",
}

export interface DeviceDeviceCount {
  id: string;
  /** @format int32 */
  installed: number;
  /** @format int32 */
  total: number;
  /** @format int32 */
  uninstalled: number;
}

/** @default "DEVICE_FACILITY_PLANT_UNDEFINED" */
export enum DeviceDeviceFacilityPlant {
  DEVICE_FACILITY_PLANT_UNDEFINED = "DEVICE_FACILITY_PLANT_UNDEFINED",
  DEVICEFACILITYSHELLCONSTRUCTION1 = "DEVICE_FACILITY_SHELL_CONSTRUCTION1",
  DEVICEFACILITYSHELLCONSTRUCTION2 = "DEVICE_FACILITY_SHELL_CONSTRUCTION2",
  DEVICE_FACILITY_PLANT_ELECTRICITY = "DEVICE_FACILITY_PLANT_ELECTRICITY",
  DEVICE_FACILITY_PLANT_AIR_CONDITIONING = "DEVICE_FACILITY_PLANT_AIR_CONDITIONING",
  DEVICE_FACILITY_PLANT_SANITARY = "DEVICE_FACILITY_PLANT_SANITARY",
  DEVICE_FACILITY_PLANT_TRANSPORT_WAREHOUSE = "DEVICE_FACILITY_PLANT_TRANSPORT_WAREHOUSE",
  DEVICEFACILITYPLANTINTERIOR1 = "DEVICE_FACILITY_PLANT_INTERIOR1",
  DEVICEFACILITYPLANTINTERIOR2 = "DEVICE_FACILITY_PLANT_INTERIOR2",
  DEVICE_FACILITY_PLANT_GARDEN = "DEVICE_FACILITY_PLANT_GARDEN",
  DEVICE_FACILITY_PLANT_DEVICE = "DEVICE_FACILITY_PLANT_DEVICE",
  DEVICE_FACILITY_PLANT_FURNITURE = "DEVICE_FACILITY_PLANT_FURNITURE",
  DEVICE_FACILITY_PLANT_ELECTRONICS = "DEVICE_FACILITY_PLANT_ELECTRONICS",
  DEVICE_FACILITY_PLANT_TEXTILES = "DEVICE_FACILITY_PLANT_TEXTILES",
  DEVICE_FACILITY_PLANT_DECORATION = "DEVICE_FACILITY_PLANT_DECORATION",
  DEVICE_FACILITY_PLANT_HOUSEHOLD_GOODS = "DEVICE_FACILITY_PLANT_HOUSEHOLD_GOODS",
  DEVICE_FACILITY_PLANT_OTHER = "DEVICE_FACILITY_PLANT_OTHER",
}

/**
 * - DEVICE_INSTALLATION_STATUS_INSTALLED: No uninstallation date, or uninstallation date is after today
 *  - DEVICE_INSTALLATION_STATUS_UNINSTALLED: Uninstallation date is today or earlier
 * @default "DEVICE_INSTALLATION_STATUS_UNDEFINED"
 */
export enum DeviceDeviceInstallationStatus {
  DEVICE_INSTALLATION_STATUS_UNDEFINED = "DEVICE_INSTALLATION_STATUS_UNDEFINED",
  DEVICE_INSTALLATION_STATUS_INSTALLED = "DEVICE_INSTALLATION_STATUS_INSTALLED",
  DEVICE_INSTALLATION_STATUS_UNINSTALLED = "DEVICE_INSTALLATION_STATUS_UNINSTALLED",
}

/** @default "DEVICE_MEASURE_UNDEFINED" */
export enum DeviceDeviceMeasure {
  DEVICE_MEASURE_UNDEFINED = "DEVICE_MEASURE_UNDEFINED",
  DEVICE_MEASURE_IMPLEMENTATION_PERIOD = "DEVICE_MEASURE_IMPLEMENTATION_PERIOD",
  DEVICE_MEASURE_IMMEDIATELY = "DEVICE_MEASURE_IMMEDIATELY",
}

/** @default "DEVICE_SYSTEM_UNDEFINED" */
export enum DeviceDeviceSystem {
  DEVICE_SYSTEM_UNDEFINED = "DEVICE_SYSTEM_UNDEFINED",
  DEVICE_SYSTEM_MASTER_BUILDER_WORK = "DEVICE_SYSTEM_MASTER_BUILDER_WORK",
  DEVICE_SYSTEM_WINDOW_DOOR = "DEVICE_SYSTEM_WINDOW_DOOR",
  DEVICE_SYSTEM_ROOFING = "DEVICE_SYSTEM_ROOFING",
  DEVICE_SYSTEM_SEALING_INSULATION = "DEVICE_SYSTEM_SEALING_INSULATION",
  DEVICE_SYSTEM_FACADE_PLASTER = "DEVICE_SYSTEM_FACADE_PLASTER",
  DEVICE_SYSTEM_OUTER_FINISHES = "DEVICE_SYSTEM_OUTER_FINISHES",
  DEVICE_SYSTEM_HEAVY_CURRENT_INSTALLATION = "DEVICE_SYSTEM_HEAVY_CURRENT_INSTALLATION",
  DEVICE_SYSTEM_LIGHTS = "DEVICE_SYSTEM_LIGHTS",
  DEVICE_SYSTEM_TELEPHONE = "DEVICE_SYSTEM_TELEPHONE",
  DEVICE_SYSTEM_LOW_CURRENT_INSTALLATION = "DEVICE_SYSTEM_LOW_CURRENT_INSTALLATION",
  DEVICE_SYSTEM_OTHER_ELECTRICITY = "DEVICE_SYSTEM_OTHER_ELECTRICITY",
  DEVICE_SYSTEM_HEATING_TRANSITION_POSITION = "DEVICE_SYSTEM_HEATING_TRANSITION_POSITION",
  DEVICE_SYSTEM_ENERGY_SUPPLY = "DEVICE_SYSTEM_ENERGY_SUPPLY",
  DEVICE_SYSTEM_HEAT_GENERATION = "DEVICE_SYSTEM_HEAT_GENERATION",
  DEVICE_SYSTEM_HEAT_DISTRIBUTION = "DEVICE_SYSTEM_HEAT_DISTRIBUTION",
  DEVICE_SYSTEM_VENTILATION = "DEVICE_SYSTEM_VENTILATION",
  DEVICE_SYSTEM_AIR_CONDITIONING = "DEVICE_SYSTEM_AIR_CONDITIONING",
  DEVICE_SYSTEM_COOLING = "DEVICE_SYSTEM_COOLING",
  DEVICE_SYSTEM_SPECIAL_FACILITY = "DEVICE_SYSTEM_SPECIAL_FACILITY",
  DEVICE_SYSTEM_INSULATION = "DEVICE_SYSTEM_INSULATION",
  DEVICE_SYSTEM_OTHER_HEATING = "DEVICE_SYSTEM_OTHER_HEATING",
  DEVICE_SYSTEM_SANITARY = "DEVICE_SYSTEM_SANITARY",
  DEVICE_SYSTEM_SPECIAL_SANITARY = "DEVICE_SYSTEM_SPECIAL_SANITARY",
  DEVICE_SYSTEM_SANITARY_SUPPLY_DISPOSAL = "DEVICE_SYSTEM_SANITARY_SUPPLY_DISPOSAL",
  DEVICE_SYSTEM_SANITARY_PIPING = "DEVICE_SYSTEM_SANITARY_PIPING",
  DEVICE_SYSTEM_SANITARY_INSULATION = "DEVICE_SYSTEM_SANITARY_INSULATION",
  DEVICE_SYSTEM_SANITARY_EQUIPMENT = "DEVICE_SYSTEM_SANITARY_EQUIPMENT",
  DEVICE_SYSTEM_ELECTRIC_PNEUMATIC_BOARD = "DEVICE_SYSTEM_ELECTRIC_PNEUMATIC_BOARD",
  DEVICE_SYSTEM_KITCHEN_EQUIPMENT = "DEVICE_SYSTEM_KITCHEN_EQUIPMENT",
  DEVICE_SYSTEM_OTHER_SANITARY = "DEVICE_SYSTEM_OTHER_SANITARY",
  DEVICE_SYSTEM_ELEVATOR = "DEVICE_SYSTEM_ELEVATOR",
  DEVICE_SYSTEM_MOVING_STAIRCASE = "DEVICE_SYSTEM_MOVING_STAIRCASE",
  DEVICE_SYSTEM_FACADE_CLEANING = "DEVICE_SYSTEM_FACADE_CLEANING",
  DEVICE_SYSTEM_GOODS_CONVEYING = "DEVICE_SYSTEM_GOODS_CONVEYING",
  DEVICE_SYSTEM_LIFTING = "DEVICE_SYSTEM_LIFTING",
  DEVICE_SYSTEM_PARKING = "DEVICE_SYSTEM_PARKING",
  DEVICE_SYSTEM_TRANSPORT_OTHER = "DEVICE_SYSTEM_TRANSPORT_OTHER",
  DEVICE_SYSTEM_PLASTERER = "DEVICE_SYSTEM_PLASTERER",
  DEVICE_SYSTEM_METAL = "DEVICE_SYSTEM_METAL",
  DEVICE_SYSTEM_CARPENTER = "DEVICE_SYSTEM_CARPENTER",
  DEVICE_SYSTEM_WINDOW = "DEVICE_SYSTEM_WINDOW",
  DEVICE_SYSTEM_LOCKING = "DEVICE_SYSTEM_LOCKING",
  DEVICE_SYSTEM_INTERIOR_FINISHES = "DEVICE_SYSTEM_INTERIOR_FINISHES",
  DEVICE_SYSTEM_ELEMENT_WALL = "DEVICE_SYSTEM_ELEMENT_WALL",
  DEVICE_SYSTEM_CHROME_STEEL_FACILITY = "DEVICE_SYSTEM_CHROME_STEEL_FACILITY",
  DEVICESYSTEMOTHERINTERIOR1 = "DEVICE_SYSTEM_OTHER_INTERIOR1",
  DEVICE_SYSTEM_FLOORING = "DEVICE_SYSTEM_FLOORING",
  DEVICE_SYSTEM_WALL_COVERING = "DEVICE_SYSTEM_WALL_COVERING",
  DEVICE_SYSTEM_CEILING = "DEVICE_SYSTEM_CEILING",
  DEVICE_SYSTEM_INTERIOR_SURFACE_TREATMENTS = "DEVICE_SYSTEM_INTERIOR_SURFACE_TREATMENTS",
  DEVICESYSTEMOTHERINTERIOR2 = "DEVICE_SYSTEM_OTHER_INTERIOR2",
  DEVICE_SYSTEM_OTHER_TRANSPORT = "DEVICE_SYSTEM_OTHER_TRANSPORT",
  DEVICE_SYSTEM_GARDEN_TRANSITION_POSITION = "DEVICE_SYSTEM_GARDEN_TRANSITION_POSITION",
  DEVICE_SYSTEM_GARDENING = "DEVICE_SYSTEM_GARDENING",
  DEVICE_SYSTEM_FENCING = "DEVICE_SYSTEM_FENCING",
  DEVICE_SYSTEM_SUPERSTRUCTURE = "DEVICE_SYSTEM_SUPERSTRUCTURE",
  DEVICE_SYSTEM_PLAYGROUND = "DEVICE_SYSTEM_PLAYGROUND",
  DEVICE_SYSTEM_GARDEN_OTHER = "DEVICE_SYSTEM_GARDEN_OTHER",
  DEVICE_SYSTEM_DEVICE_TRANSITION_POSITION = "DEVICE_SYSTEM_DEVICE_TRANSITION_POSITION",
  DEVICE_SYSTEM_ELECTRONICS_DESIGN = "DEVICE_SYSTEM_ELECTRONICS_DESIGN",
  DEVICE_SYSTEM_MEDICAL_DEVICES = "DEVICE_SYSTEM_MEDICAL_DEVICES",
  DEVICE_SYSTEM_LABELS_MARKINGS_SIGNAGE = "DEVICE_SYSTEM_LABELS_MARKINGS_SIGNAGE",
}

/**
 * A device matches when query is a case-insensitive substring of brand, model, serialNumber or manufacturer,
 * or when its type, system or referenceId is in the corresponding matching* list. Ignored when query is empty.
 */
export interface DeviceDeviceTextSearch {
  /** Reference IDs whose object name or numericId contains query (resolved by the caller). */
  matchingReferenceIds: string[];
  /** Systems whose localized label contains query (resolved by the caller). */
  matchingSystems: DeviceDeviceSystem[];
  /** Types whose localized label contains query (resolved by the caller). */
  matchingTypes: DeviceDeviceType[];
  query: string;
}

/**
 * - DEVICE_TYPE_CHROME_STEEP_FINISH: Not used
 * @default "DEVICE_TYPE_UNDEFINED"
 */
export enum DeviceDeviceType {
  DEVICE_TYPE_UNDEFINED = "DEVICE_TYPE_UNDEFINED",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES = "DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES",
  DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER = "DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER",
  DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN = "DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN",
  DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR = "DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE = "DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE",
  DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE = "DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE",
  DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR = "DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION = "DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL",
  DEVICE_TYPE_ROOFING_PENT_ROOF = "DEVICE_TYPE_ROOFING_PENT_ROOF",
  DEVICE_TYPE_ROOFING_SADDLE_ROOF = "DEVICE_TYPE_ROOFING_SADDLE_ROOF",
  DEVICE_TYPE_ROOFING_TERRACE = "DEVICE_TYPE_ROOFING_TERRACE",
  DEVICE_TYPE_ROOFING_HIPPED_ROOF = "DEVICE_TYPE_ROOFING_HIPPED_ROOF",
  DEVICE_TYPE_ROOFING_TENT_ROOF = "DEVICE_TYPE_ROOFING_TENT_ROOF",
  DEVICE_TYPE_ROOFING_FLAT_ROOF = "DEVICE_TYPE_ROOFING_FLAT_ROOF",
  DEVICE_TYPE_ROOFING_SHEARING_ROOF = "DEVICE_TYPE_ROOFING_SHEARING_ROOF",
  DEVICE_TYPE_ROOFING_FRONT_PANEL = "DEVICE_TYPE_ROOFING_FRONT_PANEL",
  DEVICE_TYPE_SEALING_INSULATION_FACADE = "DEVICE_TYPE_SEALING_INSULATION_FACADE",
  DEVICE_TYPE_SEALING_INSULATION_INTERIOR = "DEVICE_TYPE_SEALING_INSULATION_INTERIOR",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD = "DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES = "DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT = "DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT",
  DEVICE_TYPE_FACADE_PLASTER_PAINTING = "DEVICE_TYPE_FACADE_PLASTER_PAINTING",
  DEVICE_TYPE_FACADE_PLASTER = "DEVICE_TYPE_FACADE_PLASTER",
  DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT",
  DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL",
  DEVICE_TYPE_OUTER_FINISHES = "DEVICE_TYPE_OUTER_FINISHES",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING",
  DEVICETYPEHEAVYCURRENTINSTALLATIONCO2 = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CO2",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION",
  DEVICE_TYPE_LIGHTS_ILLUMINANT = "DEVICE_TYPE_LIGHTS_ILLUMINANT",
  DEVICE_TYPE_LIGHTS = "DEVICE_TYPE_LIGHTS",
  DEVICE_TYPE_LIGHTS_CEILING = "DEVICE_TYPE_LIGHTS_CEILING",
  DEVICE_TYPE_LIGHTS_CABINET = "DEVICE_TYPE_LIGHTS_CABINET",
  DEVICE_TYPE_LIGHTS_SPOTS = "DEVICE_TYPE_LIGHTS_SPOTS",
  DEVICE_TYPE_LIGHTS_MIRROR_CABINET = "DEVICE_TYPE_LIGHTS_MIRROR_CABINET",
  DEVICE_TYPE_TELEPHONE_CENTER = "DEVICE_TYPE_TELEPHONE_CENTER",
  DEVICE_TYPE_TELEPHONE_DISTRIBUTOR = "DEVICE_TYPE_TELEPHONE_DISTRIBUTOR",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE",
  DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY = "DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY",
  DEVICE_TYPE_OTHER_ELECTRICITY_OTHER = "DEVICE_TYPE_OTHER_ELECTRICITY_OTHER",
  DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION = "DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION",
  DEVICE_TYPE_OTHER_ELECTRICITY = "DEVICE_TYPE_OTHER_ELECTRICITY",
  DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET = "DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET",
  DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX = "DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION",
  DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY = "DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY",
  DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING = "DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING",
  DEVICE_TYPE_ENERGY_SUPPLY_TANK = "DEVICE_TYPE_ENERGY_SUPPLY_TANK",
  DEVICE_TYPE_ENERGY_SUPPLY_STORAGE = "DEVICE_TYPE_ENERGY_SUPPLY_STORAGE",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED",
  DEVICE_TYPE_HEAT_GENERATION = "DEVICE_TYPE_HEAT_GENERATION",
  DEVICE_TYPE_HEAT_GENERATION_BOILER = "DEVICE_TYPE_HEAT_GENERATION_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BURNER = "DEVICE_TYPE_HEAT_GENERATION_BURNER",
  DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE = "DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE = "DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER = "DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM = "DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER = "DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP = "DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP",
  DEVICE_TYPE_HEAT_GENERATION_FIREPLACE = "DEVICE_TYPE_HEAT_GENERATION_FIREPLACE",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR = "DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR",
  DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER = "DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING = "DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES = "DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES",
  DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER = "DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS = "DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS",
  DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT = "DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING = "DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING",
  DEVICE_TYPE_HEAT_DISTRIBUTION = "DEVICE_TYPE_HEAT_DISTRIBUTION",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER",
  DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP = "DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR",
  DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING",
  DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER = "DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER",
  DEVICE_TYPE_VENTILATION_VENTILATION = "DEVICE_TYPE_VENTILATION_VENTILATION",
  DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN = "DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN",
  DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN = "DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN",
  DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM = "DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM",
  DEVICE_TYPE_VENTILATION = "DEVICE_TYPE_VENTILATION",
  DEVICE_TYPE_VENTILATION_CONTROLLED_HOME = "DEVICE_TYPE_VENTILATION_CONTROLLED_HOME",
  DEVICE_TYPE_VENTILATION_CHANNELS = "DEVICE_TYPE_VENTILATION_CHANNELS",
  DEVICE_TYPE_AIR_CONDITIONING_RECOOLING = "DEVICE_TYPE_AIR_CONDITIONING_RECOOLING",
  DEVICE_TYPE_AIR_CONDITIONING = "DEVICE_TYPE_AIR_CONDITIONING",
  DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS = "DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS",
  DEVICE_TYPE_COOLING_CHILLERS = "DEVICE_TYPE_COOLING_CHILLERS",
  DEVICE_TYPE_COOLING_COLD_RESERVOIR = "DEVICE_TYPE_COOLING_COLD_RESERVOIR",
  DEVICE_TYPE_COOLING_COLD_WATER_TANK = "DEVICE_TYPE_COOLING_COLD_WATER_TANK",
  DEVICE_TYPE_COOLING_COLD_STORAGE_CELL = "DEVICE_TYPE_COOLING_COLD_STORAGE_CELL",
  DEVICE_TYPE_COOLING = "DEVICE_TYPE_COOLING",
  DEVICE_TYPE_SPECIAL_FACILITY = "DEVICE_TYPE_SPECIAL_FACILITY",
  DEVICE_TYPE_INSULATION = "DEVICE_TYPE_INSULATION",
  DEVICE_TYPE_INSULATION_CHIMNEY = "DEVICE_TYPE_INSULATION_CHIMNEY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES",
  DEVICE_TYPE_SANITARY_BATHTUB = "DEVICE_TYPE_SANITARY_BATHTUB",
  DEVICE_TYPE_SANITARY_RENOVATION = "DEVICE_TYPE_SANITARY_RENOVATION",
  DEVICE_TYPE_SANITARY_CONTROL_FITTINGS = "DEVICE_TYPE_SANITARY_CONTROL_FITTINGS",
  DEVICE_TYPE_SANITARY_WASHBASIN = "DEVICE_TYPE_SANITARY_WASHBASIN",
  DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC = "DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET = "DEVICE_TYPE_SANITARY_MIRROR_CABINET",
  DEVICE_TYPE_SANITARY_BIDET = "DEVICE_TYPE_SANITARY_BIDET",
  DEVICE_TYPE_SANITARY_SHOWER = "DEVICE_TYPE_SANITARY_SHOWER",
  DEVICE_TYPE_SANITARY_LAVABO = "DEVICE_TYPE_SANITARY_LAVABO",
  DEVICE_TYPE_SANITARY_URINAL = "DEVICE_TYPE_SANITARY_URINAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK = "DEVICE_TYPE_SANITARY_FLUSH_TANK",
  DEVICE_TYPE_SANITARY_TOILET = "DEVICE_TYPE_SANITARY_TOILET",
  DEVICE_TYPE_SANITARY_TOILET_CERAMIC = "DEVICE_TYPE_SANITARY_TOILET_CERAMIC",
  DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT = "DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT",
  DEVICE_TYPE_SANITARY_TOILET_COVER = "DEVICE_TYPE_SANITARY_TOILET_COVER",
  DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE = "DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE",
  DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC = "DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC",
  DEVICE_TYPE_SANITARY_BATHTUB_STEEL = "DEVICE_TYPE_SANITARY_BATHTUB_STEEL",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED = "DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER",
  DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION = "DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION",
  DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER = "DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE",
  DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER = "DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER",
  DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER = "DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER",
  DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE = "DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE",
  DEVICE_TYPE_SPECIAL_SANITARY = "DEVICE_TYPE_SPECIAL_SANITARY",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER",
  DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER = "DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER",
  DEVICE_TYPE_SANITARY_PIPING_WARM_WATER = "DEVICE_TYPE_SANITARY_PIPING_WARM_WATER",
  DEVICE_TYPE_SANITARY_PIPING = "DEVICE_TYPE_SANITARY_PIPING",
  DEVICE_TYPE_SANITARY_INSULATION = "DEVICE_TYPE_SANITARY_INSULATION",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE = "DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE",
  DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_EQUIPMENT = "DEVICE_TYPE_SANITARY_EQUIPMENT",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE",
  DEVICE_TYPE_SANITARY_SHOWER_ROD = "DEVICE_TYPE_SANITARY_SHOWER_ROD",
  DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL = "DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER",
  DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD = "DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING = "DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC",
  DEVICE_TYPE_OTHER_SANITARY = "DEVICE_TYPE_OTHER_SANITARY",
  DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT = "DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT",
  DEVICE_TYPE_ELEVATOR_BED_LIFT = "DEVICE_TYPE_ELEVATOR_BED_LIFT",
  DEVICE_TYPE_ELEVATOR = "DEVICE_TYPE_ELEVATOR",
  DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT = "DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT",
  DEVICE_TYPE_MOVING_STAIRCASE = "DEVICE_TYPE_MOVING_STAIRCASE",
  DEVICE_TYPE_FACADE_CLEANING = "DEVICE_TYPE_FACADE_CLEANING",
  DEVICE_TYPE_GOODS_CONVEYING_OTHER = "DEVICE_TYPE_GOODS_CONVEYING_OTHER",
  DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE = "DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE",
  DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT = "DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT",
  DEVICE_TYPE_GOODS_CONVEYING = "DEVICE_TYPE_GOODS_CONVEYING",
  DEVICE_TYPE_LIFTING = "DEVICE_TYPE_LIFTING",
  DEVICE_TYPE_PARKING = "DEVICE_TYPE_PARKING",
  DEVICE_TYPE_TRANSPORT_OTHER = "DEVICE_TYPE_TRANSPORT_OTHER",
  DEVICE_TYPE_PLASTERER = "DEVICE_TYPE_PLASTERER",
  DEVICE_TYPE_METAL = "DEVICE_TYPE_METAL",
  DEVICE_TYPE_METAL_CAR_SHELTER = "DEVICE_TYPE_METAL_CAR_SHELTER",
  DEVICE_TYPE_METAL_MAILBOX = "DEVICE_TYPE_METAL_MAILBOX",
  DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT = "DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT",
  DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER = "DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER",
  DEVICE_TYPE_CARPENTER_CELLAR_DOOR = "DEVICE_TYPE_CARPENTER_CELLAR_DOOR",
  DEVICE_TYPE_CARPENTER_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR = "DEVICE_TYPE_CARPENTER_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME = "DEVICE_TYPE_CARPENTER_DOOR_FRAME",
  DEVICE_TYPE_CARPENTER_LOCKS = "DEVICE_TYPE_CARPENTER_LOCKS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR",
  DEVICE_TYPE_CARPENTER = "DEVICE_TYPE_CARPENTER",
  DEVICE_TYPE_CARPENTER_DOOR_WOODEN = "DEVICE_TYPE_CARPENTER_DOOR_WOODEN",
  DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_CARPENTER_DOOR_METAL = "DEVICE_TYPE_CARPENTER_DOOR_METAL",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL",
  DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT = "DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL",
  DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR = "DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR",
  DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR = "DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR",
  DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR = "DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR",
  DEVICE_TYPE_CARPENTER_SHELF = "DEVICE_TYPE_CARPENTER_SHELF",
  DEVICE_TYPE_CARPENTER_SHELF_WOOD = "DEVICE_TYPE_CARPENTER_SHELF_WOOD",
  DEVICE_TYPE_CARPENTER_SHELF_METAL = "DEVICE_TYPE_CARPENTER_SHELF_METAL",
  DEVICE_TYPE_CARPENTER_CLOSET = "DEVICE_TYPE_CARPENTER_CLOSET",
  DEVICE_TYPE_CARPENTER_CLOSET_WOOD = "DEVICE_TYPE_CARPENTER_CLOSET_WOOD",
  DEVICE_TYPE_CARPENTER_CLOSET_METAL = "DEVICE_TYPE_CARPENTER_CLOSET_METAL",
  DEVICE_TYPE_WINDOW_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_INSULATING_GLAZING = "DEVICE_TYPE_WINDOW_INSULATING_GLAZING",
  DEVICE_TYPE_WINDOW_FITTINGS = "DEVICE_TYPE_WINDOW_FITTINGS",
  DEVICE_TYPE_WINDOW_WINDOW_FRAME = "DEVICE_TYPE_WINDOW_WINDOW_FRAME",
  DEVICE_TYPE_WINDOW_SPECIAL_GLAZING = "DEVICE_TYPE_WINDOW_SPECIAL_GLAZING",
  DEVICE_TYPE_WINDOW_WINDOW_SILL = "DEVICE_TYPE_WINDOW_WINDOW_SILL",
  DEVICE_TYPE_WINDOW = "DEVICE_TYPE_WINDOW",
  DEVICE_TYPE_WINDOW_DOUBLE = "DEVICE_TYPE_WINDOW_DOUBLE",
  DEVICE_TYPE_WINDOW_TRIPLE = "DEVICE_TYPE_WINDOW_TRIPLE",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES = "DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE = "DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE",
  DEVICE_TYPE_LOCKING_LOCK = "DEVICE_TYPE_LOCKING_LOCK",
  DEVICE_TYPE_LOCKING_KEY = "DEVICE_TYPE_LOCKING_KEY",
  DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER = "DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER",
  DEVICE_TYPE_LOCKING = "DEVICE_TYPE_LOCKING",
  DEVICE_TYPE_INTERIOR_FINISHES = "DEVICE_TYPE_INTERIOR_FINISHES",
  DEVICE_TYPE_ELEMENT_WALL = "DEVICE_TYPE_ELEMENT_WALL",
  DEVICE_TYPE_CHROME_STEEP_FINISH = "DEVICE_TYPE_CHROME_STEEP_FINISH",
  DEVICETYPEOTHERINTERIOR1 = "DEVICE_TYPE_OTHER_INTERIOR1",
  DEVICE_TYPE_FLOORING_COVERING = "DEVICE_TYPE_FLOORING_COVERING",
  DEVICE_TYPE_FLOORING_BALL_YARN = "DEVICE_TYPE_FLOORING_BALL_YARN",
  DEVICE_TYPE_FLOORING_LAMINATE = "DEVICE_TYPE_FLOORING_LAMINATE",
  DEVICE_TYPE_FLOORING_LINOLEUM = "DEVICE_TYPE_FLOORING_LINOLEUM",
  DEVICE_TYPE_FLOORING_VINYL = "DEVICE_TYPE_FLOORING_VINYL",
  DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET = "DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET",
  DEVICE_TYPE_FLOORING_PARQUET = "DEVICE_TYPE_FLOORING_PARQUET",
  DEVICE_TYPE_FLOORING_PARQUET_SEALING = "DEVICE_TYPE_FLOORING_PARQUET_SEALING",
  DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY = "DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY",
  DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR = "DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR",
  DEVICE_TYPE_FLOORING_TILES = "DEVICE_TYPE_FLOORING_TILES",
  DEVICE_TYPE_FLOORING_CARPET = "DEVICE_TYPE_FLOORING_CARPET",
  DEVICE_TYPE_FLOORING_SKIRTING = "DEVICE_TYPE_FLOORING_SKIRTING",
  DEVICE_TYPE_FLOORING_JOINT = "DEVICE_TYPE_FLOORING_JOINT",
  DEVICE_TYPE_FLOORING = "DEVICE_TYPE_FLOORING",
  DEVICE_TYPE_FLOORING_PVC = "DEVICE_TYPE_FLOORING_PVC",
  DEVICE_TYPE_FLOORING_RUBBER = "DEVICE_TYPE_FLOORING_RUBBER",
  DEVICE_TYPE_FLOORING_CORK = "DEVICE_TYPE_FLOORING_CORK",
  DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY",
  DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES = "DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD",
  DEVICE_TYPE_FLOORING_TILES_CERAMIC = "DEVICE_TYPE_FLOORING_TILES_CERAMIC",
  DEVICE_TYPE_FLOORING_TILES_STONEWARE = "DEVICE_TYPE_FLOORING_TILES_STONEWARE",
  DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE = "DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE",
  DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE = "DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE",
  DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD = "DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD = "DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_FOURNIER = "DEVICE_TYPE_FLOORING_PARQUET_FOURNIER",
  DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER = "DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER",
  DEVICE_TYPE_FLOORING_CARPET_BALL_YARN = "DEVICE_TYPE_FLOORING_CARPET_BALL_YARN",
  DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT = "DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT",
  DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC = "DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC",
  DEVICE_TYPE_FLOORING_SKIRTING_WOOD = "DEVICE_TYPE_FLOORING_SKIRTING_WOOD",
  DEVICE_TYPE_FLOORING_RAW = "DEVICE_TYPE_FLOORING_RAW",
  DEVICE_TYPE_FLOORING_COATED = "DEVICE_TYPE_FLOORING_COATED",
  DEVICE_TYPE_WALL_COVERING_WORK = "DEVICE_TYPE_WALL_COVERING_WORK",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER",
  DEVICE_TYPE_WALL_COVERING_PLASTER = "DEVICE_TYPE_WALL_COVERING_PLASTER",
  DEVICE_TYPE_WALL_COVERING_ABRASION = "DEVICE_TYPE_WALL_COVERING_ABRASION",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER",
  DEVICE_TYPE_WALL_COVERING = "DEVICE_TYPE_WALL_COVERING",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER",
  DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR = "DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR",
  DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL = "DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL",
  DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS = "DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS",
  DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC = "DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING = "DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING",
  DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT = "DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE",
  DEVICE_TYPE_WALL_COVERING_CERAMIC = "DEVICE_TYPE_WALL_COVERING_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_STONEWORK = "DEVICE_TYPE_WALL_COVERING_STONEWORK",
  DEVICE_TYPE_WALL_COVERING_STONEWARE = "DEVICE_TYPE_WALL_COVERING_STONEWARE",
  DEVICE_TYPE_WALL_COVERING_TILES = "DEVICE_TYPE_WALL_COVERING_TILES",
  DEVICE_TYPE_CEILING_WORK = "DEVICE_TYPE_CEILING_WORK",
  DEVICE_TYPE_CEILING_WALLPAPER = "DEVICE_TYPE_CEILING_WALLPAPER",
  DEVICE_TYPE_CEILING_PLASTER = "DEVICE_TYPE_CEILING_PLASTER",
  DEVICE_TYPE_CEILING_ABRASION = "DEVICE_TYPE_CEILING_ABRASION",
  DEVICE_TYPE_CEILING_WOOD_WORKER = "DEVICE_TYPE_CEILING_WOOD_WORKER",
  DEVICE_TYPE_CEILING = "DEVICE_TYPE_CEILING",
  DEVICE_TYPE_CEILING_REGULAR = "DEVICE_TYPE_CEILING_REGULAR",
  DEVICE_TYPE_CEILING_REGULAR_METAL = "DEVICE_TYPE_CEILING_REGULAR_METAL",
  DEVICE_TYPE_CEILING_REGULAR_WOOD = "DEVICE_TYPE_CEILING_REGULAR_WOOD",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING = "DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING",
  DEVICETYPEOTHERINTERIOR2SHUTTER = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER",
  DEVICETYPEOTHERINTERIOR2SHUTTERMOTOR = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER_MOTOR",
  DEVICETYPEOTHERINTERIOR2BLADE = "DEVICE_TYPE_OTHER_INTERIOR2_BLADE",
  DEVICETYPEOTHERINTERIOR2BLIND = "DEVICE_TYPE_OTHER_INTERIOR2_BLIND",
  DEVICETYPEOTHERINTERIOR2LETTERBOX = "DEVICE_TYPE_OTHER_INTERIOR2_LETTER_BOX",
  DEVICETYPEOTHERINTERIOR2 = "DEVICE_TYPE_OTHER_INTERIOR2",
  DEVICETYPEOTHERINTERIOR2SETS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS",
  DEVICETYPEOTHERINTERIOR2SETSSOAPHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_SOAP_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSTOOTHGLASS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOOTH_GLASS",
  DEVICETYPEOTHERINTERIOR2SETSGLASSSHELF = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_GLASS_SHELF",
  DEVICETYPEOTHERINTERIOR2SETSTOWELBARS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOWEL_BARS",
  DEVICETYPEOTHERINTERIOR2SETSHOLDINGRACK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_HOLDING_RACK",
  DEVICETYPEOTHERINTERIOR2SETSCURTAINROD = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_CURTAIN_ROD",
  DEVICETYPEOTHERINTERIOR2SETSPACKAGE = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PACKAGE",
  DEVICETYPEOTHERINTERIOR2SETSWASHBASINBOWL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_WASHBASIN_BOWL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERHOOK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_HOOK",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2ARMATURE = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE",
  DEVICETYPEOTHERINTERIOR2ARMATURESINGLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SINGLE_LEVER",
  DEVICETYPEOTHERINTERIOR2DOUBLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_DOUBLE_LEVER",
  DEVICETYPEOTHERINTERIOR2ARMATURESWIVEL = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SWIVEL",
  DEVICETYPEOTHERINTERIOR2ARMATUREPULLOUTSPRAY = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_PULL_OUT_SPRAY",
  DEVICETYPEOTHERINTERIOR2ARMATURETHERMALMIXER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_THERMAL_MIXER",
  DEVICETYPEOTHERINTERIOR2OPERATINGGARNITURE = "DEVICE_TYPE_OTHER_INTERIOR2_OPERATING_GARNITURE",
  DEVICETYPEOTHERINTERIOR2CRANK = "DEVICE_TYPE_OTHER_INTERIOR2_CRANK",
  DEVICETYPEOTHERINTERIOR2BELT = "DEVICE_TYPE_OTHER_INTERIOR2_BELT",
  DEVICETYPEOTHERINTERIOR2ELECTRIC = "DEVICE_TYPE_OTHER_INTERIOR2_ELECTRIC",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_FENCE = "DEVICE_TYPE_GARDENING_FENCE",
  DEVICE_TYPE_GARDENING_WALLS = "DEVICE_TYPE_GARDENING_WALLS",
  DEVICE_TYPE_GARDENING_CEMENT_BOARD = "DEVICE_TYPE_GARDENING_CEMENT_BOARD",
  DEVICE_TYPE_GARDENING_ACCESS_PATH = "DEVICE_TYPE_GARDENING_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_LAWN = "DEVICE_TYPE_GARDENING_LAWN",
  DEVICE_TYPE_GARDENING = "DEVICE_TYPE_GARDENING",
  DEVICE_TYPE_FENCING = "DEVICE_TYPE_FENCING",
  DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE = "DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE",
  DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND = "DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND",
  DEVICE_TYPE_SUPERSTRUCTURE = "DEVICE_TYPE_SUPERSTRUCTURE",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE",
  DEVICE_TYPE_PLAYGROUND = "DEVICE_TYPE_PLAYGROUND",
  DEVICE_TYPE_PLAYGROUND_DEVICE = "DEVICE_TYPE_PLAYGROUND_DEVICE",
  DEVICE_TYPE_GARDEN_OTHER = "DEVICE_TYPE_GARDEN_OTHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER",
  DEVICE_TYPE_AIR_COMPRESSOR = "DEVICE_TYPE_AIR_COMPRESSOR",
  DEVICE_TYPE_GAS_SYSTEM_LABORATORY = "DEVICE_TYPE_GAS_SYSTEM_LABORATORY",
  DEVICE_TYPE_HOIST_CRANE = "DEVICE_TYPE_HOIST_CRANE",
  DEVICE_TYPE_HEATING_DISTRIBUTOR = "DEVICE_TYPE_HEATING_DISTRIBUTOR",
  DEVICE_TYPE_INTERIOR_METAL_DOORS = "DEVICE_TYPE_INTERIOR_METAL_DOORS",
  DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING = "DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING",
  DEVICE_TYPE_REFRIGERATING_MACHINE = "DEVICE_TYPE_REFRIGERATING_MACHINE",
  DEVICE_TYPE_REFRIGERATED_CEILING = "DEVICE_TYPE_REFRIGERATED_CEILING",
  DEVICE_TYPE_COOLING_DISTRIBUTOR = "DEVICE_TYPE_COOLING_DISTRIBUTOR",
  DEVICE_TYPE_VENTILATION_MONOBLOCK = "DEVICE_TYPE_VENTILATION_MONOBLOCK",
  DEVICE_TYPE_NEUTRALIZATION_SYSTEM = "DEVICE_TYPE_NEUTRALIZATION_SYSTEM",
  DEVICE_TYPE_PURE_WATER_SYSTEM = "DEVICE_TYPE_PURE_WATER_SYSTEM",
  DEVICE_TYPE_WATER_SYSTEM_SEPARATOR = "DEVICE_TYPE_WATER_SYSTEM_SEPARATOR",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT = "DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLER = "DEVICE_TYPE_RECIRCULATING_AIR_COOLER",
  DEVICE_TYPE_STAIR = "DEVICE_TYPE_STAIR",
  DEVICE_TYPE_WARDROBE = "DEVICE_TYPE_WARDROBE",
  DEVICE_TYPE_COAT_HOOKS = "DEVICE_TYPE_COAT_HOOKS",
  DEVICE_TYPE_GATE = "DEVICE_TYPE_GATE",
  DEVICE_TYPE_CURTAIN_RAIL = "DEVICE_TYPE_CURTAIN_RAIL",
  DEVICE_TYPE_FURNITURE_BEDROOM_BED = "DEVICE_TYPE_FURNITURE_BEDROOM_BED",
  DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE = "DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE",
  DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER = "DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER",
  DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE = "DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE",
  DEVICE_TYPE_FURNITURE_OFFICE_DESK = "DEVICE_TYPE_FURNITURE_OFFICE_DESK",
  DEVICE_TYPE_FURNITURE_OFFICE_CHAIR = "DEVICE_TYPE_FURNITURE_OFFICE_CHAIR",
  DEVICE_TYPE_FURNITURE_OFFICE_STOOL = "DEVICE_TYPE_FURNITURE_OFFICE_STOOL",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR",
  DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS = "DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL",
  DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN = "DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN",
  DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS = "DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS",
  DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE = "DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE",
  DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR = "DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR",
  DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES = "DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES",
  DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT",
  DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE = "DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE",
  DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA = "DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA",
  DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED = "DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED",
  DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET = "DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET",
  DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE = "DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER",
  DEVICE_TYPE_LOCKING_CARD_READER = "DEVICE_TYPE_LOCKING_CARD_READER",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER",
  DEVICE_TYPE_COOLING_ENERGY_METER = "DEVICE_TYPE_COOLING_ENERGY_METER",
  DEVICETYPEOTHERINTERIOR1COINCOUNTER = "DEVICE_TYPE_OTHER_INTERIOR1_COIN_COUNTER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING = "DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING",
  DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM = "DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER",
  DEVICE_TYPE_CIRCULATION_PUMP = "DEVICE_TYPE_CIRCULATION_PUMP",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM",
  DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED = "DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN",
  DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE = "DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE",
  DEVICE_TYPE_CARPENTER_FOLDING_LADDER = "DEVICE_TYPE_CARPENTER_FOLDING_LADDER",
  DEVICE_TYPE_SANITARY_CLOTHESLINE = "DEVICE_TYPE_SANITARY_CLOTHESLINE",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER",
  DEVICE_TYPE_LOCKING_KEY_SAFE = "DEVICE_TYPE_LOCKING_KEY_SAFE",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR",
  DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING = "DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE",
  DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING = "DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING",
}

export interface DeviceGetDefaultDataResponse {
  data: DeviceDefaultDataEntry[];
}

export interface DeviceIdFilter {
  ids: string[];
}

export interface DeviceInspection {
  contact: ContactcommonContactReference;
  contract: string;
  costs: ObjectdeviceCosts;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  lastOfficialControl: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextOfficialControl: TypeDate;
  note: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionEnd: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionStart: TypeDate;
}

export interface DeviceLockingKey {
  combinedKeys: boolean;
  combinedKeysNote: string;
  description: string;
  lockingPlanNumber: string;
}

export interface DeviceMaintenance {
  contact: ContactcommonContactReference;
  contract: string;
  costs: ObjectdeviceCosts;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  lastMaintenance: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextMaintenance: TypeDate;
  note: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionEnd: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionStart: TypeDate;
}

export interface DeviceRevision {
  contact: ContactcommonContactReference;
  contract: string;
  costs: ObjectdeviceCosts;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  lastOfficialRevision: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextOfficialRevision: TypeDate;
  note: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionEnd: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  subscriptionStart: TypeDate;
}

export type DeviceUpsertHandoverDeviceDataResponse = object;

/** @default "COST_DISTRIBUTION_UNDEFINED" */
export enum EnergySourceCostDistribution {
  COST_DISTRIBUTION_UNDEFINED = "COST_DISTRIBUTION_UNDEFINED",
  COST_DISTRIBUTION_NONE = "COST_DISTRIBUTION_NONE",
  COST_DISTRIBUTION_CONSUMPTION = "COST_DISTRIBUTION_CONSUMPTION",
  COST_DISTRIBUTION_FIXED_KEY = "COST_DISTRIBUTION_FIXED_KEY",
}

/** @default "ENERGY_SOURCE_KIND_UNDEFINED" */
export enum EnergySourceEnergySourceKind {
  ENERGY_SOURCE_KIND_UNDEFINED = "ENERGY_SOURCE_KIND_UNDEFINED",
  ENERGY_SOURCE_KIND_HEATER = "ENERGY_SOURCE_KIND_HEATER",
  ENERGY_SOURCE_KIND_HOT_WATER = "ENERGY_SOURCE_KIND_HOT_WATER",
  ENERGY_SOURCE_KIND_HEATER_AND_HOT_WATER = "ENERGY_SOURCE_KIND_HEATER_AND_HOT_WATER",
}

/** @default "HEAT_DISTRIBUTION_UNDEFINED" */
export enum EnergySourceHeatDistribution {
  HEAT_DISTRIBUTION_UNDEFINED = "HEAT_DISTRIBUTION_UNDEFINED",
  HEAT_DISTRIBUTION_RADIATORS = "HEAT_DISTRIBUTION_RADIATORS",
  HEAT_DISTRIBUTION_FLOOR_HEATING = "HEAT_DISTRIBUTION_FLOOR_HEATING",
  HEAT_DISTRIBUTION_CEILING_HEATING = "HEAT_DISTRIBUTION_CEILING_HEATING",
}

export interface EnergySourceOrder {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  documentIds: string[];
  /** @format float */
  quantity: number;
}

export interface FahrlaenderConfiguration {
  /** @format int64 */
  accountId: string;
  apiPassword: string;
  apiUser: string;
  features: FahrlaenderFahrlaenderFeatures[];
}

/** @default "FAHRLAENDER_FEATURES_UNDEFINED" */
export enum FahrlaenderFahrlaenderFeatures {
  FAHRLAENDER_FEATURES_UNDEFINED = "FAHRLAENDER_FEATURES_UNDEFINED",
  FAHRLAENDER_FEATURES_MICRO_LOCATION = "FAHRLAENDER_FEATURES_MICRO_LOCATION",
  FAHRLAENDER_FEATURES_MARKET_RENT = "FAHRLAENDER_FEATURES_MARKET_RENT",
}

export interface FahrlaenderLoadConfigurationResponse {
  configuration: FahrlaenderConfiguration;
}

export type FahrlaenderSaveConfigurationResponse = object;

export interface FahrlaenderUpdateMarketRentResponse {
  /** @format int32 */
  commandsPublished: number;
}

export interface FahrlaenderUpdateMicroLocationRatingsResponse {
  /** @format int32 */
  commandsPublished: number;
}

/** @default "ACTION_UNDEFINED" */
export enum HandoverProtocolAction {
  ACTION_UNDEFINED = "ACTION_UNDEFINED",
  ACTION_REPAIR = "ACTION_REPAIR",
  ACTION_REPLACE = "ACTION_REPLACE",
  ACTION_DEPRECIATION = "ACTION_DEPRECIATION",
  ACTION_CLEAN = "ACTION_CLEAN",
}

/** @default "ATTACH_TO_HANDOVER_ONLY" */
export enum HandoverProtocolAttachTo {
  ATTACH_TO_HANDOVER_ONLY = "ATTACH_TO_HANDOVER_ONLY",
  ATTACH_TO_DEVICE_ONLY = "ATTACH_TO_DEVICE_ONLY",
  ATTACH_TO_HANDOVER_AND_DEVICE = "ATTACH_TO_HANDOVER_AND_DEVICE",
}

export interface HandoverProtocolBuildingData {
  name: string;
  /** @format int64 */
  numericId: string;
}

/** @default "CLEANLINESS_ROOM_UNDEFINED" */
export enum HandoverProtocolCleanlinessRoom {
  CLEANLINESS_ROOM_UNDEFINED = "CLEANLINESS_ROOM_UNDEFINED",
  CLEANLINESS_ROOM_PERFECT = "CLEANLINESS_ROOM_PERFECT",
  CLEANLINESS_ROOM_SLIGHTLY_SOILED = "CLEANLINESS_ROOM_SLIGHTLY_SOILED",
  CLEANLINESS_ROOM_HEAVILY_SOILED = "CLEANLINESS_ROOM_HEAVILY_SOILED",
}

/** @default "CLEANLINESS_ROOM_ACTION_UNDEFINED" */
export enum HandoverProtocolCleanlinessRoomAction {
  CLEANLINESS_ROOM_ACTION_UNDEFINED = "CLEANLINESS_ROOM_ACTION_UNDEFINED",
  CLEANLINESS_ROOM_ACTION_TENANT = "CLEANLINESS_ROOM_ACTION_TENANT",
  CLEANLINESS_ROOM_ACTION_SERVICE_PROVIDER = "CLEANLINESS_ROOM_ACTION_SERVICE_PROVIDER",
}

export interface HandoverProtocolCountMyDraftsResponse {
  /** @format int32 */
  count: number;
}

export type HandoverProtocolDeleteTemplatesResponse = object;

export interface HandoverProtocolGetPdfPreviewResponse {
  /** @format byte */
  pdf: string;
}

export interface HandoverProtocolGetTemplateByIdResponse {
  template: ObjecthandoverProtocolTemplate;
}

export interface HandoverProtocolHandoverProtocol {
  assigneeContactId: string;
  creator: ObjecthandoverProtocolCreator;
  devicesWithoutRoom: ObjecthandoverProtocolDevice[];
  /** Deprecated. Use status field for more fine grained status representation. */
  finished: boolean;
  id: string;
  movingInTenancyReferences: HandoverProtocolTenancyReference[];
  movingOutTenancyReferences: HandoverProtocolTenancyReference[];
  note: string;
  ownerData: HandoverProtocolOwnerData;
  /** @format int64 */
  ownerId: string;
  participants: ObjecthandoverProtocolParticipant[];
  protocolMediaId: string;
  rooms: ObjecthandoverProtocolRoom[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  scheduledDate: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  scheduledTime: TypeTimeOfDay;
  status: HandoverProtocolProtocolStatus;
  templateId: string;
}

export interface HandoverProtocolKeyData {
  /**
   * Deprecated. Use amount value outside KeyData.
   * @format int32
   */
  amount: number;
  combinedKeys: boolean;
  combinedKeysDescription: string;
  description: string;
  keyNumber: string;
  lockingPlanNumber: string;
  /** @format int32 */
  returnedAmount: number;
}

export interface HandoverProtocolListAllProtocolsResponse {
  protocols: HandoverProtocolHandoverProtocol[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalProtocols: number;
}

export interface HandoverProtocolListMyProtocolsResponse {
  protocols: HandoverProtocolHandoverProtocol[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalProtocols: number;
}

export interface HandoverProtocolListOtherProtocolsResponse {
  protocols: HandoverProtocolHandoverProtocol[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalProtocols: number;
}

export interface HandoverProtocolListTemplatesByPropertyIdResponse {
  templates: ObjecthandoverProtocolTemplate[];
}

export interface HandoverProtocolObjectData {
  address: CommonaddressAddress;
  areas: ObjectAreas;
  category: ObjectCategory;
  /** @format float */
  decimalFloor: number;
  name: string;
  /** @format int64 */
  numericId: string;
}

export interface HandoverProtocolOwnerData {
  name: string;
}

/** @default "PARTICIPANT_TYPE_UNDEFINED" */
export enum HandoverProtocolParticipantType {
  PARTICIPANT_TYPE_UNDEFINED = "PARTICIPANT_TYPE_UNDEFINED",
  PARTICIPANT_TYPE_ADMINISTRATOR = "PARTICIPANT_TYPE_ADMINISTRATOR",
  PARTICIPANT_TYPE_TENANT_MOVE_OUT = "PARTICIPANT_TYPE_TENANT_MOVE_OUT",
  PARTICIPANT_TYPE_TENANT_MOVE_IN = "PARTICIPANT_TYPE_TENANT_MOVE_IN",
  PARTICIPANT_TYPE_THIRD_PARTY_MOVE_OUT = "PARTICIPANT_TYPE_THIRD_PARTY_MOVE_OUT",
  PARTICIPANT_TYPE_THIRD_PARTY_MOVE_IN = "PARTICIPANT_TYPE_THIRD_PARTY_MOVE_IN",
}

export interface HandoverProtocolPropertyData {
  name: string;
  /** @format int64 */
  numericId: string;
}

/** @default "PROTOCOL_STATUS_UNDEFINED" */
export enum HandoverProtocolProtocolStatus {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export interface HandoverProtocolSaveDataAddressHistory {
  address: CommonaddressAddress;
  /** Optional. Set only if editing existing address timeline. */
  oldValidFrom?: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export interface HandoverProtocolSaveDataDevice {
  /** @format float */
  acquisitionCosts: number;
  action: HandoverProtocolAction;
  /** @format int32 */
  amount: number;
  brand: string;
  /** @format float */
  cataloguePrice: number;
  cleaningNecessary: boolean;
  condition: ObjecthandoverProtocolCondition;
  costAbsorption: CostCostAbsorption;
  costShareUnit: CostCostShareUnit;
  /** @format double */
  costShareValue: number;
  /** @format double */
  costShareValueCalculated: number;
  deleted: boolean;
  /** Leave empty for new devices. */
  id: string;
  images: ObjecthandoverProtocolImage[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  keyData: HandoverProtocolSaveDataKeyData;
  /** @format int32 */
  lifeSpan: number;
  manufacturer: string;
  model: string;
  /** Defect comment. Shown in PDF and transferred to the draft order ticket. Maps to device Measures / Note (conditionNote). */
  note: string;
  objectId: string;
  postCleaningAction: HandoverProtocolCleanlinessRoomAction;
  /** @format double */
  postCleaningCostShareValue: number;
  postCleaningCostUnit: CostCostShareUnit;
  /** General device remark. Shown in PDF only; not transferred to the draft order ticket. */
  remark: string;
  serialNumber: string;
  type: DeviceDeviceType;
  unit: ObjecthandoverProtocolDeviceUnit;
}

export interface HandoverProtocolSaveDataKeyData {
  /**
   * Deprecated. Use amount value outside SaveDataKeyData.
   * @format int32
   */
  amount: number;
  combinedKeys: boolean;
  combinedKeysDescription: string;
  description: string;
  keyNumber: string;
  lockingPlanNumber: string;
  /** @format int32 */
  returnedAmount: number;
}

export interface HandoverProtocolSaveDataParticipant {
  address: CommonaddressAddress;
  /** All provided entries are updated on the contact. */
  addressHistory: HandoverProtocolSaveDataAddressHistory[];
  attending: boolean;
  /** Must only be set if new person should be contact person of company otherwise leave empty. */
  companyContactId: string;
  /** Leave empty for new contacts. Use mock_<number> for new companies to reference them for new contact persons. */
  contactId: string;
  email: string;
  /** Use only if person/contact person. */
  firstName: string;
  /** Use only if person/contact person. */
  lastName: string;
  /** Use only if company */
  name: string;
  phoneNumbers: V2PhoneNumber[];
  powerOfAttorneyMediaIds: string[];
  type: HandoverProtocolParticipantType;
}

export interface HandoverProtocolSaveDataResponse {
  protocol: HandoverProtocolHandoverProtocol;
}

export interface HandoverProtocolSaveDataRoom {
  cleanliness: HandoverProtocolCleanlinessRoom;
  cleanlinessAction: HandoverProtocolCleanlinessRoomAction;
  /** @format double */
  cleanlinessCost: number;
  cleanlinessCostUnit: CostCostShareUnit;
  deleted: boolean;
  devices: HandoverProtocolSaveDataDevice[];
  /** Leave empty for new rooms. */
  id: string;
  images: ObjecthandoverProtocolImage[];
  name: string;
  note: string;
  objectId: string;
}

export interface HandoverProtocolSetFavoriteTemplateResponse {
  template: ObjecthandoverProtocolTemplate;
}

export interface HandoverProtocolSignResponse {
  protocol: HandoverProtocolHandoverProtocol;
}

export interface HandoverProtocolTemplateReference {
  propertyId: string;
  propertyName: string;
}

export interface HandoverProtocolTemplateRoom {
  deviceIds: string[];
  id: string;
}

export interface HandoverProtocolTenancyData {
  contactIds: string[];
  /** @format float */
  depositAmount: number;
  depositType: TenancyDepositType;
  /** Date when tenancy ends. */
  endingAt: TypeDate;
  /** Date when tenancy starts. */
  startingAt: TypeDate;
}

export interface HandoverProtocolTenancyReference {
  buildingData: HandoverProtocolBuildingData;
  objectData: HandoverProtocolObjectData;
  objectId: string;
  propertyData: HandoverProtocolPropertyData;
  tenancyData: HandoverProtocolTenancyData;
  tenancyId: string;
}

export interface HandoverProtocolWriteParticipant {
  attending: boolean;
  contactId: string;
  powerOfAttorneyMediaIds: string[];
  signed: boolean;
  type: HandoverProtocolParticipantType;
}

export interface HandoverProtocolWriteTenancyReference {
  objectId: string;
  tenancyId: string;
}

export interface InsuranceAddDocumentIdsResponse {
  insurance: InsuranceInsurance;
}

export interface InsuranceUpdateAicFieldsResponse {
  insurance: InsuranceInsurance;
}

export interface InvestPlanComponent {
  bkp: string;
  /** @format float */
  costs: number;
  /** @format float */
  futurePercentage: number;
  id: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  name: string;
  note: string;
  optionalValueEnhancingComponent: boolean;
  /** @format int64 */
  ownerId: string;
  /** @format float */
  percentage: number;
  /** @format float */
  plannedCosts: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  plannedReplacementDate: TypeDate;
  referenceId: string;
}

export interface InvestPlanCreateBulkEntry {
  bkp: string;
  /** @format float */
  costs: number;
  /** @format float */
  futurePercentage: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  name: string;
  note: string;
  optionalValueEnhancingComponent: boolean;
  /** @format int64 */
  ownerId: string;
  /** @format float */
  percentage: number;
  /** @format float */
  plannedCosts: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  plannedReplacementDate: TypeDate;
  referenceId: string;
}

export interface InvestPlanCreateBulkPlanEntry {
  bkp: string;
  /** @format float */
  costs: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  name: string;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
}

export interface InvestPlanEnableEntry {
  buildingId: string;
  enable: boolean;
}

export interface InvestPlanHasEnabledEntry {
  buildingId: string;
  enabled: boolean;
}

export interface InvestPlanPlannedCosts {
  bkp: string;
  /** @format float */
  costs: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
}

export interface InvestPlanUpdateBulkPlanEntry {
  bkp: string;
  /** @format float */
  costs: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  id: string;
  name: string;
}

/** @default "AUTOMATIC_REFERENCE_CHECK_MODE_UNDEFINED" */
export enum MarketbaseAutomaticReferenceCheckMode {
  AUTOMATIC_REFERENCE_CHECK_MODE_UNDEFINED = "AUTOMATIC_REFERENCE_CHECK_MODE_UNDEFINED",
  AUTOMATIC_REFERENCE_CHECK_MODE_DO_NOT_CHECK = "AUTOMATIC_REFERENCE_CHECK_MODE_DO_NOT_CHECK",
  AUTOMATIC_REFERENCE_CHECK_MODE_IF_AFFORDABILITY_APPROPRIATE = "AUTOMATIC_REFERENCE_CHECK_MODE_IF_AFFORDABILITY_APPROPRIATE",
  AUTOMATIC_REFERENCE_CHECK_MODE_IF_COMPLETE_DOSSIER_AND_AFFORDABILITY = "AUTOMATIC_REFERENCE_CHECK_MODE_IF_COMPLETE_DOSSIER_AND_AFFORDABILITY",
}

export interface MortgageAmortization {
  /** @format double */
  amount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  byDate: TypeDate;
}

export interface MortgageMortgage {
  /** @format double */
  amortisationAmount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  amortizationFrom: TypeDate;
  amortizations: MortgageAmortization[];
  /** @format double */
  amount: number;
  bankCountry: string;
  bankName: string;
  bankNumber: string;
  bic: string;
  /** @format double */
  carryingAmount: number;
  debitAccount: string;
  designation: string;
  documentIds: string[];
  dueDateMonthsAmortization: number[];
  dueDateMonthsInterestRate: number[];
  enableAmortizations: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  expiresAt: TypeDate;
  id: string;
  /** @format float */
  interestRate: number;
  mortgageDesignation: MortgageMortgageDesignation;
  mortgageeAddress: CommonaddressAddress;
  number: string;
  /** @format int64 */
  numericId: string;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** Could be property, building or object ID */
  referenceId: string;
  terminableOn: MortgageMortgageTerminableOn;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

/** @default "MORTGAGE_DESIGNATION_UNDEFINED" */
export enum MortgageMortgageDesignation {
  MORTGAGE_DESIGNATION_UNDEFINED = "MORTGAGE_DESIGNATION_UNDEFINED",
  MORTGAGEDESIGNATIONFIXED1YEAR = "MORTGAGE_DESIGNATION_FIXED_1_YEAR",
  MORTGAGEDESIGNATIONFIXED2YEAR = "MORTGAGE_DESIGNATION_FIXED_2_YEAR",
  MORTGAGEDESIGNATIONFIXED3YEAR = "MORTGAGE_DESIGNATION_FIXED_3_YEAR",
  MORTGAGEDESIGNATIONFIXED4YEAR = "MORTGAGE_DESIGNATION_FIXED_4_YEAR",
  MORTGAGEDESIGNATIONFIXED5YEAR = "MORTGAGE_DESIGNATION_FIXED_5_YEAR",
  MORTGAGEDESIGNATIONFIXED6YEAR = "MORTGAGE_DESIGNATION_FIXED_6_YEAR",
  MORTGAGEDESIGNATIONFIXED7YEAR = "MORTGAGE_DESIGNATION_FIXED_7_YEAR",
  MORTGAGEDESIGNATIONFIXED8YEAR = "MORTGAGE_DESIGNATION_FIXED_8_YEAR",
  MORTGAGEDESIGNATIONFIXED9YEAR = "MORTGAGE_DESIGNATION_FIXED_9_YEAR",
  MORTGAGEDESIGNATIONFIXED10YEAR = "MORTGAGE_DESIGNATION_FIXED_10_YEAR",
  MORTGAGEDESIGNATIONFIXED11YEAR = "MORTGAGE_DESIGNATION_FIXED_11_YEAR",
  MORTGAGEDESIGNATIONFIXED12YEAR = "MORTGAGE_DESIGNATION_FIXED_12_YEAR",
  MORTGAGEDESIGNATIONFIXED13YEAR = "MORTGAGE_DESIGNATION_FIXED_13_YEAR",
  MORTGAGEDESIGNATIONFIXED14YEAR = "MORTGAGE_DESIGNATION_FIXED_14_YEAR",
  MORTGAGEDESIGNATIONFIXED15YEAR = "MORTGAGE_DESIGNATION_FIXED_15_YEAR",
  MORTGAGEDESIGNATIONFIXED16YEAR = "MORTGAGE_DESIGNATION_FIXED_16_YEAR",
  MORTGAGEDESIGNATIONFIXED17YEAR = "MORTGAGE_DESIGNATION_FIXED_17_YEAR",
  MORTGAGEDESIGNATIONFIXED18YEAR = "MORTGAGE_DESIGNATION_FIXED_18_YEAR",
  MORTGAGEDESIGNATIONFIXED19YEAR = "MORTGAGE_DESIGNATION_FIXED_19_YEAR",
  MORTGAGEDESIGNATIONFIXED20YEAR = "MORTGAGE_DESIGNATION_FIXED_20_YEAR",
  MORTGAGEDESIGNATIONFIXED21YEAR = "MORTGAGE_DESIGNATION_FIXED_21_YEAR",
  MORTGAGEDESIGNATIONFIXED22YEAR = "MORTGAGE_DESIGNATION_FIXED_22_YEAR",
  MORTGAGEDESIGNATIONFIXED23YEAR = "MORTGAGE_DESIGNATION_FIXED_23_YEAR",
  MORTGAGEDESIGNATIONFIXED24YEAR = "MORTGAGE_DESIGNATION_FIXED_24_YEAR",
  MORTGAGEDESIGNATIONFIXED25YEAR = "MORTGAGE_DESIGNATION_FIXED_25_YEAR",
  MORTGAGE_DESIGNATION_VARIABLE = "MORTGAGE_DESIGNATION_VARIABLE",
  MORTGAGE_DESIGNATION_LIBOR = "MORTGAGE_DESIGNATION_LIBOR",
  MORTGAGE_DESIGNATION_SARON = "MORTGAGE_DESIGNATION_SARON",
}

/** @default "MORTGAGE_TERMINABLE_ON_UNDEFINED" */
export enum MortgageMortgageTerminableOn {
  MORTGAGE_TERMINABLE_ON_UNDEFINED = "MORTGAGE_TERMINABLE_ON_UNDEFINED",
  MORTGAGETERMINABLEON1MONTH = "MORTGAGE_TERMINABLE_ON_1_MONTH",
  MORTGAGETERMINABLEON2MONTHS = "MORTGAGE_TERMINABLE_ON_2_MONTHS",
  MORTGAGETERMINABLEON3MONTHS = "MORTGAGE_TERMINABLE_ON_3_MONTHS",
  MORTGAGETERMINABLEON6MONTHS = "MORTGAGE_TERMINABLE_ON_6_MONTHS",
  MORTGAGETERMINABLEON12MONTHS = "MORTGAGE_TERMINABLE_ON_12_MONTHS",
}

export interface ObjectAddCraftsmenRequest {
  contactIdsCraftsman: string[];
  ids: string[];
}

export type ObjectAddCraftsmenResponse = object;

export interface ObjectAddJanitorsRequest {
  contactIdsJanitor: string[];
  ids: string[];
}

export type ObjectAddJanitorsResponse = object;

export interface ObjectAddServiceProvidersRequest {
  contactIdsServiceProvider: string[];
  ids: string[];
}

export type ObjectAddServiceProvidersResponse = object;

/** @default "ADDITIONAL_ROOM_ATTIC" */
export enum ObjectAdditionalRooms {
  ADDITIONAL_ROOM_ATTIC = "ADDITIONAL_ROOM_ATTIC",
  ADDITIONAL_ROOM_BICYCLE_STORAGE = "ADDITIONAL_ROOM_BICYCLE_STORAGE",
  ADDITIONAL_ROOM_WASHING_AND_DRYING_ROOM = "ADDITIONAL_ROOM_WASHING_AND_DRYING_ROOM",
  ADDITIONAL_ROOM_BASEMENT = "ADDITIONAL_ROOM_BASEMENT",
  ADDITIONAL_ROOM_FITNESS_ROOM = "ADDITIONAL_ROOM_FITNESS_ROOM",
  ADDITIONAL_ROOM_HOBBY_ROOM = "ADDITIONAL_ROOM_HOBBY_ROOM",
  ADDITIONAL_ROOM_ARCHIVE = "ADDITIONAL_ROOM_ARCHIVE",
  ADDITIONAL_ROOM_STORING_PLACE = "ADDITIONAL_ROOM_STORING_PLACE",
  ADDITIONAL_ROOM_WORKROOM = "ADDITIONAL_ROOM_WORKROOM",
  ADDITIONAL_ROOM_HALL = "ADDITIONAL_ROOM_HALL",
  ADDITIONAL_ROOM_COLD_STORAGE_CELL = "ADDITIONAL_ROOM_COLD_STORAGE_CELL",
}

/** @default "UNDEFINED_ADMINISTRATION_TYPE" */
export enum ObjectAdministrationType {
  UNDEFINED_ADMINISTRATION_TYPE = "UNDEFINED_ADMINISTRATION_TYPE",
  LETTING = "LETTING",
  INITIAL_LETTING = "INITIAL_LETTING",
  PARTIAL_LETTING = "PARTIAL_LETTING",
  CONDOMINIUM_OWNERSHIP = "CONDOMINIUM_OWNERSHIP",
  OWNERS_CORPORATION = "OWNERS_CORPORATION",
}

export interface ObjectAreas {
  /** @format float */
  effectiveArea: number;
  /** @format float */
  livingArea: number;
  /** @format float */
  netLivingArea: number;
  /** @format float */
  plotArea: number;
}

export interface ObjectAvailability {
  /**
   * Only used if availability is FROM_DATE or TEMPORARY_LIVING
   * @format int64
   */
  availableFrom: string;
  /**
   * Only used if availability is TEMPORARY_LIVING
   * @format int64
   */
  availableTo: string;
  type: ObjectAvailabilityType;
}

/** @default "IMMEDIATELY" */
export enum ObjectAvailabilityType {
  IMMEDIATELY = "IMMEDIATELY",
  BY_ARRANGEMENT = "BY_ARRANGEMENT",
  FROM_DATE = "FROM_DATE",
  TEMPORARY_LIVING = "TEMPORARY_LIVING",
}

/** @default "COMMERCIAL_FEATURES_GOODS_LIFT" */
export enum ObjectCommercialFeatures {
  COMMERCIAL_FEATURES_GOODS_LIFT = "COMMERCIAL_FEATURES_GOODS_LIFT",
  COMMERCIAL_FEATURES_RAMP = "COMMERCIAL_FEATURES_RAMP",
  COMMERCIAL_FEATURES_VISITOR_PARKING = "COMMERCIAL_FEATURES_VISITOR_PARKING",
  COMMERCIAL_FEATURES_CAFETERIA = "COMMERCIAL_FEATURES_CAFETERIA",
  COMMERCIAL_FEATURES_CRANE = "COMMERCIAL_FEATURES_CRANE",
  COMMERCIAL_FEATURES_LIFTING_PLATFORM = "COMMERCIAL_FEATURES_LIFTING_PLATFORM",
  COMMERCIAL_FEATURES_TRUCK_APPROACH_RAMP = "COMMERCIAL_FEATURES_TRUCK_APPROACH_RAMP",
}

export interface ObjectContacts {
  contactIdAssigneeAccounting: string;
  contactIdAssigneeAdministration: string;
  contactIdAssigneeAsset: string;
  contactIdAssigneeMarketing: string;
  contactIdAssigneeOwner: string;
  contactIdViewingAppointment: string;
  contactIdsCraftsman: string[];
  contactIdsJanitor: string[];
  contactIdsServiceProvider: string[];
  publishAssigneePhone: boolean;
}

export interface ObjectDefaultAnswer {
  attachmentMediaIds: string[];
  includeApplicationFormLink: boolean;
  includeViewingAppointmentContact: boolean;
  mailboxId: string;
  subject: string;
  templateId: string;
  text: string;
}

/** @default "UNDEFINED_DEPOSIT_INSURANCE" */
export enum ObjectDepositInsurance {
  UNDEFINED_DEPOSIT_INSURANCE = "UNDEFINED_DEPOSIT_INSURANCE",
  NO_DEPOSIT_INSURANCE = "NO_DEPOSIT_INSURANCE",
  ALL_DEPOSIT_INSURANCES = "ALL_DEPOSIT_INSURANCES",
  AXA = "AXA",
  ADUNOKAUTION = "ADUNOKAUTION",
  FIRST_CAUTION = "FIRST_CAUTION",
  GO_CAUTION = "GO_CAUTION",
  HELVETIA = "HELVETIA",
  MOBILAR = "MOBILAR",
  SMART_CAUTION = "SMART_CAUTION",
  SWISS_CAUTION = "SWISS_CAUTION",
  ZUERICH = "ZUERICH",
}

/** @default "EXTRAS_BALCONY" */
export enum ObjectExtras {
  EXTRAS_BALCONY = "EXTRAS_BALCONY",
  EXTRAS_FRENCH_BALCONY = "EXTRAS_FRENCH_BALCONY",
  EXTRAS_WINTER_GARDEN = "EXTRAS_WINTER_GARDEN",
  EXTRAS_GARDEN = "EXTRAS_GARDEN",
  EXTRAS_VERANDA = "EXTRAS_VERANDA",
  EXTRAS_TERRACE = "EXTRAS_TERRACE",
  EXTRAS_LOGGIA = "EXTRAS_LOGGIA",
  EXTRAS_GARDEN_HOUSE = "EXTRAS_GARDEN_HOUSE",
}

/** @default "FLOORING_TILES" */
export enum ObjectFlooring {
  FLOORING_TILES = "FLOORING_TILES",
  FLOORING_LAMINATE = "FLOORING_LAMINATE",
  FLOORING_PARQUET = "FLOORING_PARQUET",
  FLOORING_STONE = "FLOORING_STONE",
  FLOORING_DOUBLE_FLOOR = "FLOORING_DOUBLE_FLOOR",
  FLOORING_WOOD_BOARDS = "FLOORING_WOOD_BOARDS",
  FLOORING_MARBLE = "FLOORING_MARBLE",
  FLOORING_PVC = "FLOORING_PVC",
  FLOORING_CARPET = "FLOORING_CARPET",
  FLOORING_TERRACOTTA = "FLOORING_TERRACOTTA",
  FLOORING_ANHYDRIT = "FLOORING_ANHYDRIT",
  FLOORING_VINYL = "FLOORING_VINYL",
  FLOORING_OTHERS = "FLOORING_OTHERS",
}

/** @default "UNDEFINED_FURNISHING" */
export enum ObjectFurnishing {
  UNDEFINED_FURNISHING = "UNDEFINED_FURNISHING",
  FURNISHED = "FURNISHED",
  PARTLY_FURNISHED = "PARTLY_FURNISHED",
  NOT_FURNISHED = "NOT_FURNISHED",
}

/** @default "UNDEFINED_FURNISHING_TYPE" */
export enum ObjectFurnishingType {
  UNDEFINED_FURNISHING_TYPE = "UNDEFINED_FURNISHING_TYPE",
  SIMPLE_FURNISHING = "SIMPLE_FURNISHING",
  STANDARD_FURNISHING = "STANDARD_FURNISHING",
  UPSCALE_FURNISHING = "UPSCALE_FURNISHING",
  LUXURY_FURNISHING = "LUXURY_FURNISHING",
}

export interface ObjectGetAccountingStatisticsResponse {
  /** @format int32 */
  countOverall: number;
  /** @format int32 */
  inMarketingOverall: number;
  /** @format int32 */
  inMarketingSince12Weeks: number;
  /** @format int32 */
  inMarketingSince4Weeks: number;
  /** @format int32 */
  inMarketingSince8Weeks: number;
  /** @format int32 */
  notInMarketingOverall: number;
  /** @format int32 */
  notInMarketingSince12Weeks: number;
  /** @format int32 */
  notInMarketingSince4Weeks: number;
  /** @format int32 */
  notInMarketingSince8Weeks: number;
  /** @format int32 */
  publishedOverall: number;
  /** @format int32 */
  publishedSince12Weeks: number;
  /** @format int32 */
  publishedSince4Weeks: number;
  /** @format int32 */
  publishedSince8Weeks: number;
  /** @format float */
  vacancyRate: number;
  /** @format int32 */
  vacantOverall: number;
  /** @format int32 */
  vacantSince12Weeks: number;
  /** @format int32 */
  vacantSince4Weeks: number;
  /** @format int32 */
  vacantSince8Weeks: number;
}

export interface ObjectGetAdministrationStatisticsResponse {
  /** @format int32 */
  countOverall: number;
  /** @format int32 */
  inMarketingOverall: number;
  /** @format int32 */
  inMarketingSince12Weeks: number;
  /** @format int32 */
  inMarketingSince4Weeks: number;
  /** @format int32 */
  inMarketingSince8Weeks: number;
  /** @format int32 */
  notInMarketingOverall: number;
  /** @format int32 */
  notInMarketingSince12Weeks: number;
  /** @format int32 */
  notInMarketingSince4Weeks: number;
  /** @format int32 */
  notInMarketingSince8Weeks: number;
  /** @format int32 */
  publishedOverall: number;
  /** @format int32 */
  publishedSince12Weeks: number;
  /** @format int32 */
  publishedSince4Weeks: number;
  /** @format int32 */
  publishedSince8Weeks: number;
  /** @format float */
  vacancyRate: number;
  /** @format int32 */
  vacantOverall: number;
  /** @format int32 */
  vacantSince12Weeks: number;
  /** @format int32 */
  vacantSince4Weeks: number;
  /** @format int32 */
  vacantSince8Weeks: number;
}

export interface ObjectGetApplicationInfoResponse {
  /** @format byte */
  pdf: string;
}

export interface ObjectGetApplicationLinkResponse {
  link: string;
}

export interface ObjectGetAssetStatisticsResponse {
  /** @format int32 */
  countOverall: number;
  /** @format int32 */
  inMarketingOverall: number;
  /** @format int32 */
  inMarketingSince12Weeks: number;
  /** @format int32 */
  inMarketingSince4Weeks: number;
  /** @format int32 */
  inMarketingSince8Weeks: number;
  /** @format int32 */
  notInMarketingOverall: number;
  /** @format int32 */
  notInMarketingSince12Weeks: number;
  /** @format int32 */
  notInMarketingSince4Weeks: number;
  /** @format int32 */
  notInMarketingSince8Weeks: number;
  /** @format int32 */
  publishedOverall: number;
  /** @format int32 */
  publishedSince12Weeks: number;
  /** @format int32 */
  publishedSince4Weeks: number;
  /** @format int32 */
  publishedSince8Weeks: number;
  /** @format float */
  vacancyRate: number;
  /** @format int32 */
  vacantOverall: number;
  /** @format int32 */
  vacantSince12Weeks: number;
  /** @format int32 */
  vacantSince4Weeks: number;
  /** @format int32 */
  vacantSince8Weeks: number;
}

export interface ObjectGetByBuildingIdAndNumericIdResponse {
  object: ObjectobjectObject;
}

export interface ObjectGetDefaultAnswerResponse {
  defaultAnswer: ObjectDefaultAnswer;
}

export interface ObjectGetMarketingExposeResponse {
  /** @format byte */
  pdf: string;
}

export interface ObjectGetMarketingResponse {
  acceptsCreditTrust: boolean;
  /** @format float */
  additional: number;
  address: CommonaddressAddress;
  availability: ObjectAvailability;
  category: ObjectCategory;
  /** @format float */
  coldRent: number;
  currency: string;
  /** @format float */
  decimalFloor: number;
  deposit: ObjectobjectDeposit;
  description: string;
  /** @format float */
  effectiveArea: number;
  /** @format int32 */
  floor: number;
  /** @format float */
  heating: number;
  id: string;
  images: ObjectobjectImage[];
  /** @format float */
  livingArea: number;
  /** @format int64 */
  marketingAccountId: string;
  marketingAssignee: ObjectMarketingAssignee;
  marketingLanguage: LanguagePreferredLanguage;
  /** @format int64 */
  ownerId: string;
  parking: ObjectParking[];
  publicId: string;
  publishAddress: boolean;
  /** @format float */
  rooms: number;
  subCategories: ObjectSubCategory[];
  title: string;
  unit: ObjectUnit;
}

export interface ObjectGetObjectTypesResponse {
  hasCondominiumObjects: boolean;
  hasRentalObjects: boolean;
}

export interface ObjectGetOwnerStatisticsResponse {
  /** @format int32 */
  countOverall: number;
  /** @format int32 */
  inMarketingOverall: number;
  /** @format int32 */
  inMarketingSince12Weeks: number;
  /** @format int32 */
  inMarketingSince4Weeks: number;
  /** @format int32 */
  inMarketingSince8Weeks: number;
  /** @format int32 */
  notInMarketingOverall: number;
  /** @format int32 */
  notInMarketingSince12Weeks: number;
  /** @format int32 */
  notInMarketingSince4Weeks: number;
  /** @format int32 */
  notInMarketingSince8Weeks: number;
  /** @format int32 */
  publishedOverall: number;
  /** @format int32 */
  publishedSince12Weeks: number;
  /** @format int32 */
  publishedSince4Weeks: number;
  /** @format int32 */
  publishedSince8Weeks: number;
  /** @format float */
  vacancyRate: number;
  /** @format int32 */
  vacantOverall: number;
  /** @format int32 */
  vacantSince12Weeks: number;
  /** @format int32 */
  vacantSince4Weeks: number;
  /** @format int32 */
  vacantSince8Weeks: number;
}

export interface ObjectGetTotalValueQuotaForBuildingResponse {
  /** @format float */
  totalValueQuota: number;
}

export interface ObjectGetViewingAppointmentResponse {
  viewingAppointment: ObjectViewingAppointment;
}

/** @default "GLAZING_ACOUSTIC_GLAZING" */
export enum ObjectGlazing {
  GLAZING_ACOUSTIC_GLAZING = "GLAZING_ACOUSTIC_GLAZING",
  GLAZING_SUN_PROTECTION = "GLAZING_SUN_PROTECTION",
  GLAZING_SIMPLY_GLAZED = "GLAZING_SIMPLY_GLAZED",
  GLAZING_DOUBLE_GLAZED = "GLAZING_DOUBLE_GLAZED",
  GLAZING_TRIPLE_GLAZED = "GLAZING_TRIPLE_GLAZED",
  GLAZING_RESISTANT_GLASS = "GLAZING_RESISTANT_GLASS",
}

export interface ObjectHaveSamePropertyResponse {
  sameProperty: boolean;
}

/** @default "CENTRAL_HEATING" */
export enum ObjectHeating {
  CENTRAL_HEATING = "CENTRAL_HEATING",
  SELF_CONTAINED_CENTRAL_HEATING = "SELF_CONTAINED_CENTRAL_HEATING",
  UNDERFLOOR_HEATING = "UNDERFLOOR_HEATING",
  RADIATOR = "RADIATOR",
  CONTROLLED_RESIDENTIAL_VENTILATION = "CONTROLLED_RESIDENTIAL_VENTILATION",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  STOVE = "STOVE",
  WOOD_BURNING_STOVE = "WOOD_BURNING_STOVE",
  STORAGE_HEATER = "STORAGE_HEATER",
  FIREPLACE = "FIREPLACE",
  OPEN_FIREPLACE = "OPEN_FIREPLACE",
}

export interface ObjectIsActiveResponse {
  active: boolean;
}

export interface ObjectIsOnePublishedRequest {
  ids: string[];
}

export interface ObjectIsOnePublishedResponse {
  published: boolean;
}

/** @default "NO_KITCHEN" */
export enum ObjectKitchen {
  NO_KITCHEN = "NO_KITCHEN",
  TEA_KITCHEN = "TEA_KITCHEN",
  BUILD_IN_KITCHEN = "BUILD_IN_KITCHEN",
  KITCHENETTE = "KITCHENETTE",
  EAT_IN_KITCHEN = "EAT_IN_KITCHEN",
  SMALL_KITCHEN = "SMALL_KITCHEN",
  OPEN_KITCHEN = "OPEN_KITCHEN",
  GLASS_CERAMIC_STOVE = "GLASS_CERAMIC_STOVE",
  INDUCTION_STOVE = "INDUCTION_STOVE",
  TEPANIAKI = "TEPANIAKI",
  STEAMER = "STEAMER",
  COMBI_STEAMER = "COMBI_STEAMER",
  DISHWASHER = "DISHWASHER",
}

export interface ObjectListFreeByDateRequest {
  buildingIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
}

export interface ObjectListFreeByDateResponse {
  objects: ObjectobjectObject[];
}

export interface ObjectListIdsByEmployeeResponse {
  ids: string[];
}

export interface ObjectListIdsInMarketingResponse {
  ids: string[];
}

export interface ObjectListMarketingResponse {
  objects: ObjectobjectObject[];
  /** @format int32 */
  totalObjectCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface ObjectListPublishedResponse {
  objects: ObjectobjectObject[];
}

export type ObjectMarkForMarketingResponse = object;

export interface ObjectMarketingAssignee {
  email: string;
  name: string;
  phone: string;
}

export type ObjectMarketingMarkSeenResponse = object;

export interface ObjectMarketingStatus {
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  clearFromMarketingAt: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  markedAsSeenAt: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  markedForMarketingAt: string;
  marketingNote: string;
  newInMarketing: boolean;
  publications: ObjectPublication[];
  /**
   * UNIX timestamp in seconds when tenancy was marked as ending
   * @format int64
   */
  setVacantAt: string;
  specialPublication: ObjectSpecialPublication;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  startMarketingAt: string;
  /**
   * Holds info when tenancy for this object is ending. -1 = undetermined end of tenancy
   * @format int64
   */
  vacantAt: string;
}

/** @default "NO_MARKETING_STATUS_FILTER" */
export enum ObjectMarketingStatusFilter {
  NO_MARKETING_STATUS_FILTER = "NO_MARKETING_STATUS_FILTER",
  NEW = "NEW",
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
  RENTED = "RENTED",
}

export interface ObjectMoveObjectsRequest {
  ids: string[];
  newBuildingId: string;
}

export type ObjectMoveObjectsResponse = object;

export interface ObjectObjectFilterOption {
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
}

export interface ObjectParking {
  /** @format int32 */
  amount: number;
  /** @format float */
  costs: number;
  parkingType: ObjectParkingType;
}

/** @default "UNDEFINED_PARKING_TYPE" */
export enum ObjectParkingType {
  UNDEFINED_PARKING_TYPE = "UNDEFINED_PARKING_TYPE",
  PARKING_TYPE_PARKING_SPACE = "PARKING_TYPE_PARKING_SPACE",
  PARKING_TYPE_CARPORT = "PARKING_TYPE_CARPORT",
  PARKING_TYPE_DOUBLE_CARPORT = "PARKING_TYPE_DOUBLE_CARPORT",
  PARKING_TYPE_GARAGE = "PARKING_TYPE_GARAGE",
  PARKING_TYPE_DOUBLE_GARAGE = "PARKING_TYPE_DOUBLE_GARAGE",
  PARKING_TYPE_DUPLEX = "PARKING_TYPE_DUPLEX",
  PARKING_TYPE_CAR_PARK = "PARKING_TYPE_CAR_PARK",
  PARKING_TYPE_UNDERGROUND_GARAGE = "PARKING_TYPE_UNDERGROUND_GARAGE",
  PARKING_TYPE_ELECTRIC = "PARKING_TYPE_ELECTRIC",
}

/** @default "UNDEFINED_PAYMENT_INTERVAL" */
export enum ObjectPaymentInterval {
  UNDEFINED_PAYMENT_INTERVAL = "UNDEFINED_PAYMENT_INTERVAL",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  HALF_YEARLY = "HALF_YEARLY",
  YEARLY = "YEARLY",
}

/** @default "PETS_ALLOWED" */
export enum ObjectPets {
  PETS_ALLOWED = "PETS_ALLOWED",
  PETS_NOT_ALLOWED = "PETS_NOT_ALLOWED",
  PETS_SMALL_ALLOWED = "PETS_SMALL_ALLOWED",
  PETS_DOGS_ALLOWED = "PETS_DOGS_ALLOWED",
  PETS_CATS_ALLOWED = "PETS_CATS_ALLOWED",
  PETS_AFTER_CONSULTATION = "PETS_AFTER_CONSULTATION",
}

/** @default "UNDEFINED_LOCATION" */
export enum ObjectPosition {
  UNDEFINED_LOCATION = "UNDEFINED_LOCATION",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  MIDDLE = "MIDDLE",
  MIDDLE_LEFT = "MIDDLE_LEFT",
  MIDDLE_RIGHT = "MIDDLE_RIGHT",
  NORTH = "NORTH",
  SOUTH = "SOUTH",
  WEST = "WEST",
  EAST = "EAST",
  NORTH_WEST = "NORTH_WEST",
  NORTH_EAST = "NORTH_EAST",
  SOUTH_WEST = "SOUTH_WEST",
  SOUTH_EAST = "SOUTH_EAST",
  MIDDLE_FRONT = "MIDDLE_FRONT",
  MIDDLE_LEFT_LEFT = "MIDDLE_LEFT_LEFT",
  MIDDLE_RIGHT_RIGHT = "MIDDLE_RIGHT_RIGHT",
}

export interface ObjectPricing {
  /** @format float */
  additional: number;
  additionalValues: ObjectobjectAdditionalValues[];
  advancePaymentValues: ObjectobjectAdvancePaymentValue[];
  /** @format float */
  coldRent: number;
  /** @format float */
  commonDistrictRent: number;
  /** E.g. CHF */
  currency: string;
  flatRateValues: ObjectobjectFlatRateValues[];
  /** @format float */
  heating: number;
  /** @format float */
  marketGrossRent: number;
  /** @format float */
  marketHeatingAndAdditional: number;
  /** @format float */
  marketNetRent: number;
  /** @format float */
  marketRent: number;
  paymentInterval: ObjectPaymentInterval;
  /** @format float */
  rentM2PerYear: number;
  /** @format float */
  rentReserves: number;
  /** @format float */
  sellingPrice: number;
  /** @format float */
  sellingPriceM2: number;
  /** @format float */
  targetAdditional: number;
  /** @format float */
  targetColdRent: number;
  /** @format float */
  targetHeating: number;
  /** @format float */
  targetMarketGrossRent: number;
  /** @format float */
  targetMarketHeatingAndAdditional: number;
  /** @format float */
  targetMarketNetRent: number;
  /** @format float */
  underMarketGrossRent: number;
  /** @format float */
  underMarketHeatingAndAdditional: number;
  /** @format float */
  underMarketNetRent: number;
  unit: ObjectUnit;
  /** @format float */
  upperMarketGrossRent: number;
  /** @format float */
  upperMarketHeatingAndAdditional: number;
  /** @format float */
  upperMarketNetRent: number;
}

/** @default "PROMOTION_TYPE_UNDEFINED" */
export enum ObjectPromotionType {
  PROMOTION_TYPE_UNDEFINED = "PROMOTION_TYPE_UNDEFINED",
  PROMOTION_TYPE_TOP = "PROMOTION_TYPE_TOP",
  PROMOTION_TYPE_HIGHLIGHT = "PROMOTION_TYPE_HIGHLIGHT",
  PROMOTION_TYPE_SPECIAL = "PROMOTION_TYPE_SPECIAL",
}

export interface ObjectPublication {
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  published: string;
  /** @format int64 */
  publishedByAccountId: string;
  publishedByUserId: string;
  /** @format int32 */
  unPublishAtAmountOfRequests: number;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  unPublished: string;
  /** @format int64 */
  unPublishedByAccountId: string;
  unPublishedByUserId: string;
}

export interface ObjectPublishRequest {
  ids: string[];
  /**
   * Optional timestamp in seconds if the user wants to schedule publish time. If left empty it's marked as publish immediately.
   * @format int64
   */
  publishAt?: string;
  specialPublication: ObjectSpecialPublication;
  /**
   * Optional timestamp in seconds if user wants to schedule unPublish
   * @format int64
   */
  unPublishAt?: string;
  /**
   * Optional parameter if user wants to automatically unPublish
   * @format int32
   */
  unPublishAtAmountOfRequests?: number;
}

export type ObjectPublishResponse = object;

export interface ObjectRemoveCraftsmenRequest {
  contactIdsCraftsman: string[];
  ids: string[];
}

export type ObjectRemoveCraftsmenResponse = object;

export interface ObjectRemoveFromMarketingRequest {
  ids: string[];
}

export type ObjectRemoveFromMarketingResponse = object;

export interface ObjectRemoveJanitorsRequest {
  contactIdsJanitor: string[];
  ids: string[];
}

export type ObjectRemoveJanitorsResponse = object;

export interface ObjectRemoveServiceProvidersRequest {
  contactIdsServiceProvider: string[];
  ids: string[];
}

export type ObjectRemoveServiceProvidersResponse = object;

export interface ObjectRenovation {
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  end: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  start: string;
  text: string;
}

/** @default "SANITARY_BATHROOM_WITH_WINDOW" */
export enum ObjectSanitary {
  SANITARY_BATHROOM_WITH_WINDOW = "SANITARY_BATHROOM_WITH_WINDOW",
  SANITARY_BATHROOM_WITH_SHOWER = "SANITARY_BATHROOM_WITH_SHOWER",
  SANITARY_BATHROOM_WITH_BATHTUB = "SANITARY_BATHROOM_WITH_BATHTUB",
  SANITARY_SAUNA = "SANITARY_SAUNA",
  SANITARY_SWIMMING_POOL = "SANITARY_SWIMMING_POOL",
  SANITARY_JACUZZI = "SANITARY_JACUZZI",
  SANITARY_TOWEL_RADIATOR = "SANITARY_TOWEL_RADIATOR",
  SANITARY_WASHING_MACHINE = "SANITARY_WASHING_MACHINE",
  SANITARY_DRYER = "SANITARY_DRYER",
  SANITARY_CONNECTION_FOR_WASHING_MACHINE = "SANITARY_CONNECTION_FOR_WASHING_MACHINE",
}

export interface ObjectSetContactsRequest {
  contacts: ObjectContacts;
  ids: string[];
}

export type ObjectSetContactsResponse = object;

export type ObjectSetDefaultAnswerResponse = object;

export interface ObjectSetMarketingAssigneeRequest {
  contactIdAssigneeMarketing: string;
  ids: string[];
}

export type ObjectSetMarketingAssigneeResponse = object;

export interface ObjectSetViewingAppointmentContactRequest {
  contactIdViewingAppointment: string;
  ids: string[];
}

export type ObjectSetViewingAppointmentContactResponse = object;

export type ObjectSetViewingAppointmentResponse = object;

export interface ObjectSpecialPublication {
  /** @format int32 */
  exclusiveDays: number;
  /**
   * UNIX timestamp in seconds when exclusivity ends
   * @format int64
   */
  exclusiveUntil: string;
  exclusivity: boolean;
  platform: string;
  /**
   * UNIX timestamp in seconds when promotion started
   * @format int64
   */
  promotedAt: string;
  /** @format int32 */
  promotedDays: number;
  /**
   * UNIX timestamp in seconds when promotion ends
   * @format int64
   */
  promotedUntil: string;
  promotion: boolean;
  promotionType: ObjectPromotionType;
}

/** @default "TECHNOLOGY_ALARM_SYSTEM" */
export enum ObjectTechnology {
  TECHNOLOGY_ALARM_SYSTEM = "TECHNOLOGY_ALARM_SYSTEM",
  TECHNOLOGY_CAMERA = "TECHNOLOGY_CAMERA",
  TECHNOLOGY_HIGH_VOLTAGE_CURRENT = "TECHNOLOGY_HIGH_VOLTAGE_CURRENT",
}

export interface ObjectUnPublishRequest {
  ids: string[];
}

export type ObjectUnPublishResponse = object;

/** @default "ON_REQUEST" */
export enum ObjectUnit {
  ON_REQUEST = "ON_REQUEST",
  FIXED = "FIXED",
  M2YEAR = "M2_YEAR",
  M2MONTH = "M2_MONTH",
}

export type ObjectUpdateMarketingInfoResponse = object;

export interface ObjectUpdatePricingResponse {
  pricing: ObjectPricing;
}

/** @default "UNDEFINED_UTILIZATION" */
export enum ObjectUtilization {
  UNDEFINED_UTILIZATION = "UNDEFINED_UTILIZATION",
  AGRICULTURAL = "AGRICULTURAL",
  COMMERCIAL_UTILIZATION = "COMMERCIAL_UTILIZATION",
  CONSTRUCTION = "CONSTRUCTION",
  GASTRONOMY_UTILIZATION = "GASTRONOMY_UTILIZATION",
  INDUSTRIAL = "INDUSTRIAL",
  INVESTMENT = "INVESTMENT",
  PARKING = "PARKING",
  RESIDENTIAL = "RESIDENTIAL",
  STORAGE = "STORAGE",
  VACATION = "VACATION",
}

export interface ObjectVideo {
  mediaId: string;
}

export interface ObjectViewingAppointment {
  contactType: ObjectViewingAppointmentContactType;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  publishContact: boolean;
  remark: string;
}

/** @default "UNDEFINED_VIEWING_APPOINTMENT_CONTACT_TYPE" */
export enum ObjectViewingAppointmentContactType {
  UNDEFINED_VIEWING_APPOINTMENT_CONTACT_TYPE = "UNDEFINED_VIEWING_APPOINTMENT_CONTACT_TYPE",
  VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE = "VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE",
  VIEWING_APPOINTMENT_CONTACT_TYPE_EMPLOYEE = "VIEWING_APPOINTMENT_CONTACT_TYPE_EMPLOYEE",
  VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT = "VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT",
  VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER = "VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER",
  VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER = "VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER",
  VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT = "VIEWING_APPOINTMENT_CONTACT_TYPE_FREE_TEXT",
}

/** @default "WINDOW_ALUMINIUM" */
export enum ObjectWindow {
  WINDOW_ALUMINIUM = "WINDOW_ALUMINIUM",
  WINDOW_WOOD = "WINDOW_WOOD",
  WINDOW_PLASTIC = "WINDOW_PLASTIC",
  WINDOW_LAMELLAR_SHUTTER = "WINDOW_LAMELLAR_SHUTTER",
  WINDOW_SHUTTER_BLINDS = "WINDOW_SHUTTER_BLINDS",
}

export interface ObjectaccountingGetStatisticsResponse {
  statistics: AccountingStatistics;
}

export interface ObjectbriefbutlerLoadSettingsResponse {
  enabled: boolean;
  profiles: BriefbutlerBriefbutlerProfile[];
}

export interface ObjectbriefbutlerSaveSettingsRequest {
  /** @format int64 */
  accountId: string;
  enabled: boolean;
  profiles: BriefbutlerBriefbutlerProfile[];
}

export type ObjectbriefbutlerSaveSettingsResponse = object;

export interface ObjectbuildingAddDocumentsRequest {
  documentIds: string[];
  id: string;
}

export interface ObjectbuildingAddDocumentsResponse {
  building: ObjectbuildingBuilding;
}

export interface ObjectbuildingBuilding {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  acquisitionDate: TypeDate;
  address: CommonaddressAddress;
  /** @format float */
  buildingArea: number;
  buildingStrategy: BuildingBuildingStrategy;
  /** @format int64 */
  buildingValue: string;
  buildingZone: string;
  characteristics: ObjectbuildingCharacteristics;
  constructionTypes: BuildingConstructionType[];
  /** @format int32 */
  constructionYear: number;
  contacts: ObjectbuildingBuildingContact[];
  contractAmendments: string;
  distances: BuildingDistances;
  documentIds: string[];
  egid: string;
  energySources: ObjectbuildingEnergySource[];
  /** @format int32 */
  floors: number;
  id: string;
  imageMediaId: string;
  landRegisterNumber: string;
  locationQuality: ObjectbuildingLocationQuality;
  name: string;
  note: string;
  /** @format int32 */
  number: number;
  /** @format int64 */
  numericId: string;
  objectIds: string[];
  onboardingFinished: boolean;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** @format float */
  plotArea: number;
  plotIds: string[];
  rating: BuildingRating;
  realEstateNumber: string;
  /** @format int32 */
  renovationYear: number;
  sia: BuildingSia;
  /** @format float */
  volume: number;
}

export interface ObjectbuildingBuildingContact {
  id: string;
  note: string;
  type: BuildingBuildingContactType;
}

export interface ObjectbuildingCharacteristics {
  broadbandInternet: boolean;
  cableTv: boolean;
  /** Power supply for e-cars */
  chargingStation: boolean;
  childFriendly: boolean;
  communityGarden: boolean;
  conciergeService: boolean;
  elevator: boolean;
  fiberGlass: boolean;
  intercom: boolean;
  isdn: boolean;
  park: boolean;
  playground: boolean;
  satellite: boolean;
}

export interface ObjectbuildingCountResponse {
  /** @format int32 */
  count: number;
}

export interface ObjectbuildingCreateRequest {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  acquisitionDate: TypeDate;
  address: CommonaddressAddress;
  /** @format float */
  buildingArea: number;
  buildingStrategy: BuildingBuildingStrategy;
  /** @format int64 */
  buildingValue: string;
  buildingZone: string;
  characteristics: ObjectbuildingCharacteristics;
  constructionTypes: BuildingConstructionType[];
  /** @format int32 */
  constructionYear: number;
  contacts: ObjectbuildingBuildingContact[];
  contractAmendments: string;
  distances: BuildingDistances;
  documentIds: string[];
  egid: string;
  energySources: ObjectbuildingEnergySource[];
  /** @format int32 */
  floors: number;
  imageMediaId: string;
  landRegisterNumber: string;
  locationQuality: ObjectbuildingLocationQuality;
  name: string;
  note: string;
  /** @format int32 */
  number: number;
  /** @format int64 */
  numericId: string;
  objectIds: string[];
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** @format float */
  plotArea: number;
  plotIds: string[];
  rating: BuildingRating;
  realEstateNumber: string;
  /** @format int32 */
  renovationYear: number;
  sia: BuildingSia;
  /** @format float */
  volume: number;
}

export interface ObjectbuildingCreateResponse {
  building: ObjectbuildingBuilding;
}

export type ObjectbuildingDeleteResponse = object;

export interface ObjectbuildingEnergySource {
  documentIds: string[];
  hasStorage: boolean;
  /** @format int64 */
  orderDate: string;
  /** @format float */
  orderQuantity: number;
  /**
   * DO NOT USE! Deprecated and replaced with tankReadings.
   * @format float
   */
  tankContent: number;
  tankReadings: ObjectbuildingTankReading[];
  /** @format float */
  tankSize: number;
  type: ObjectbuildingEnergySourceType;
  unit: ObjectbuildingEnergySourceUnit;
}

/** @default "UNDEFINED_ENERGY_SOURCE_TYPE" */
export enum ObjectbuildingEnergySourceType {
  UNDEFINED_ENERGY_SOURCE_TYPE = "UNDEFINED_ENERGY_SOURCE_TYPE",
  ENERGY_SOURCE_NO = "ENERGY_SOURCE_NO",
  ENERGY_SOURCE_AIR = "ENERGY_SOURCE_AIR",
  ENERGY_SOURCE_GEOTHERMAL_ENERGY = "ENERGY_SOURCE_GEOTHERMAL_ENERGY",
  ENERGY_SOURCE_GEOTHERMAL_PROBE = "ENERGY_SOURCE_GEOTHERMAL_PROBE",
  ENERGY_SOURCE_EARTH_TUBE = "ENERGY_SOURCE_EARTH_TUBE",
  ENERGY_SOURCE_WATER = "ENERGY_SOURCE_WATER",
  ENERGY_SOURCE_GAS = "ENERGY_SOURCE_GAS",
  ENERGY_SOURCE_OIL = "ENERGY_SOURCE_OIL",
  ENERGY_SOURCE_WOOD_GENERIC = "ENERGY_SOURCE_WOOD_GENERIC",
  ENERGY_SOURCE_WOOD = "ENERGY_SOURCE_WOOD",
  ENERGY_SOURCE_WOOD_PELLETS = "ENERGY_SOURCE_WOOD_PELLETS",
  ENERGY_SOURCE_WOOD_CHIPS = "ENERGY_SOURCE_WOOD_CHIPS",
  ENERGY_SOURCE_WASTE_HEAT = "ENERGY_SOURCE_WASTE_HEAT",
  ENERGY_SOURCE_ELECTRICITY = "ENERGY_SOURCE_ELECTRICITY",
  ENERGY_SOURCE_SUN = "ENERGY_SOURCE_SUN",
  ENERGY_SOURCE_DISTRICT_HEATING_GENERIC = "ENERGY_SOURCE_DISTRICT_HEATING_GENERIC",
  ENERGY_SOURCE_DISTRICT_HEATING_HIGH = "ENERGY_SOURCE_DISTRICT_HEATING_HIGH",
  ENERGY_SOURCE_DISTRICT_HEATING_LOW = "ENERGY_SOURCE_DISTRICT_HEATING_LOW",
  ENERGY_SOURCE_HEAT_PUMP = "ENERGY_SOURCE_HEAT_PUMP",
  ENERGY_SOURCE_OTHER = "ENERGY_SOURCE_OTHER",
}

/** @default "ENERGY_SOURCE_UNIT_UNDEFINED" */
export enum ObjectbuildingEnergySourceUnit {
  ENERGY_SOURCE_UNIT_UNDEFINED = "ENERGY_SOURCE_UNIT_UNDEFINED",
  ENERGY_SOURCE_UNIT_L = "ENERGY_SOURCE_UNIT_L",
  ENERGY_SOURCE_UNIT_KG = "ENERGY_SOURCE_UNIT_KG",
  ENERGYSOURCEUNITM3 = "ENERGY_SOURCE_UNIT_M3",
  ENERGY_SOURCE_UNIT_STERE = "ENERGY_SOURCE_UNIT_STERE",
}

export type ObjectbuildingFinishOnboardingResponse = object;

export interface ObjectbuildingGetResponse {
  building: ObjectbuildingBuilding;
}

export interface ObjectbuildingListByContactIdsRequest {
  contactIds: string[];
}

export interface ObjectbuildingListByContactIdsResponse {
  buildings: ObjectbuildingBuilding[];
}

export interface ObjectbuildingListByIdsRequest {
  ids: string[];
}

export interface ObjectbuildingListByIdsResponse {
  buildings: ObjectbuildingBuilding[];
}

export interface ObjectbuildingListByObjectIdsRequest {
  objectIds: string[];
}

export interface ObjectbuildingListByObjectIdsResponse {
  buildings: ObjectbuildingBuilding[];
}

export interface ObjectbuildingListFilterOptionsResponse {
  options: BuildingBuildingFilterOption[];
}

export interface ObjectbuildingListResponse {
  buildings: ObjectbuildingBuilding[];
  /** @format int32 */
  totalObjectCount: number;
  /** @format int32 */
  totalPageCount: number;
}

/**
 * - VERY_BAD_QUALITY: sehr schlecht
 *  - BAD_QUALITY: schlecht
 *  - MODERATE_QUALITY: mässig
 *  - AVERAGE_QUALITY: durchschnittlich
 *  - GOOD_QUALITY: gut
 *  - BETTER_QUALITY: gut bis sehr gut
 *  - VERY_GOOD_QUALITY: sehr gut bis ausgezeichnet
 *  - TOP_QUALITY: ausgezeichnet
 *  - EXCELLENT_QUALITY: allerbeste
 * @default "UNDEFINED_LOCATION_QUALITY"
 */
export enum ObjectbuildingLocationQuality {
  UNDEFINED_LOCATION_QUALITY = "UNDEFINED_LOCATION_QUALITY",
  VERY_BAD_QUALITY = "VERY_BAD_QUALITY",
  BAD_QUALITY = "BAD_QUALITY",
  MODERATE_QUALITY = "MODERATE_QUALITY",
  AVERAGE_QUALITY = "AVERAGE_QUALITY",
  GOOD_QUALITY = "GOOD_QUALITY",
  BETTER_QUALITY = "BETTER_QUALITY",
  VERY_GOOD_QUALITY = "VERY_GOOD_QUALITY",
  TOP_QUALITY = "TOP_QUALITY",
  EXCELLENT_QUALITY = "EXCELLENT_QUALITY",
}

export interface ObjectbuildingTankReading {
  /** @format int64 */
  date: string;
  documentIds: string[];
  /** @format float */
  value: number;
}

export interface ObjectbuildingUpdateResponse {
  building: ObjectbuildingBuilding;
}

export interface ObjectcondominiumActivateResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumAddDocumentsByNumericIdResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumAddDocumentsResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumAdditionalValues {
  type: PropertyAdditionalRentComponents;
  /** @format float */
  value: number;
}

export interface ObjectcondominiumContract {
  amendments: string;
  intendedUse: string;
  licensePlate: string;
  typeOfUse: ObjectcondominiumTypeOfUse;
}

export interface ObjectcondominiumCreateRequest {
  activated: boolean;
  closed: boolean;
  contract: ObjectcondominiumContract;
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  finalInvoiceCreated: boolean;
  /** Deprecated, use rent message */
  flatRateValues: ObjectcondominiumFlatRateValues[];
  /** @format int64 */
  numericId: string;
  objectId: string;
  opted: boolean;
  owner: CondominiumOwner;
  /** @format int64 */
  ownerId: string;
  rent: ObjectcondominiumRent;
  secondaryResidence: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  taxable: boolean;
  tenants: ObjectcondominiumTenant[];
}

export interface ObjectcondominiumCreateResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumDeactivateByNumericIdResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumDeactivateResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumDeleteRentAdjustmentsRequest {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  byDate: TypeDate;
  objectIds: string[];
}

export type ObjectcondominiumDeleteRentAdjustmentsResponse = object;

export type ObjectcondominiumDeleteResponse = object;

export interface ObjectcondominiumFlatRateValues {
  type: PropertyFlatRateRentComponents;
  /** @format float */
  value: number;
}

export interface ObjectcondominiumGetResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumListByBillingContactIdResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumListByContactIdResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumListByIdsRequest {
  ids: string[];
}

export interface ObjectcondominiumListByIdsResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumListByObjectIdsRequest {
  objectIds: string[];
}

export interface ObjectcondominiumListByObjectIdsResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumListByOwnerResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumListCurrentByObjectIdsRequest {
  objectIds: string[];
}

export interface ObjectcondominiumListCurrentByObjectIdsResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumPublishUpdatedEventsRequest {
  ownerIds: string[];
}

export type ObjectcondominiumPublishUpdatedEventsResponse = object;

export interface ObjectcondominiumRemoveDocumentsResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcondominiumRent {
  adjustments: ObjectcondominiumRentAdjustment[];
}

export interface ObjectcondominiumRentAdjustment {
  additionalValues: ObjectcondominiumAdditionalValues[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  byDate: TypeDate;
  documentIds: string[];
  dueDates: number[];
  flatRateValues: ObjectcondominiumFlatRateValues[];
}

export interface ObjectcondominiumTenant {
  contactIds: string[];
  correspondenceContactId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
}

/** @default "TYPE_OF_USE_UNDEFINED" */
export enum ObjectcondominiumTypeOfUse {
  TYPE_OF_USE_UNDEFINED = "TYPE_OF_USE_UNDEFINED",
  TYPE_OF_USE_VACATION = "TYPE_OF_USE_VACATION",
  TYPE_OF_USE_COMMERCIAL = "TYPE_OF_USE_COMMERCIAL",
  TYPE_OF_USE_PARKING = "TYPE_OF_USE_PARKING",
  TYPE_OF_USE_PARKING_EXTERNAL = "TYPE_OF_USE_PARKING_EXTERNAL",
  TYPE_OF_USE_AGRICULTURAL = "TYPE_OF_USE_AGRICULTURAL",
  TYPE_OF_USE_CONSTRUCTION = "TYPE_OF_USE_CONSTRUCTION",
  TYPE_OF_USE_GASTRONOMY = "TYPE_OF_USE_GASTRONOMY",
  TYPE_OF_USE_INDUSTRIAL = "TYPE_OF_USE_INDUSTRIAL",
  TYPE_OF_USE_INVESTMENT = "TYPE_OF_USE_INVESTMENT",
  TYPE_OF_USE_STORAGE = "TYPE_OF_USE_STORAGE",
  TYPE_OF_USE_RESIDENTIAL = "TYPE_OF_USE_RESIDENTIAL",
  TYPE_OF_USE_SECONDARY_ROOM = "TYPE_OF_USE_SECONDARY_ROOM",
  TYPE_OF_USE_OFFICE = "TYPE_OF_USE_OFFICE",
  TYPE_OF_USE_STORE = "TYPE_OF_USE_STORE",
  TYPE_OF_USE_ADVERTISING_AREA = "TYPE_OF_USE_ADVERTISING_AREA",
}

export interface ObjectcondominiumUpdateBulkEntry {
  activated: boolean;
  closed: boolean;
  contract: ObjectcondominiumContract;
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  finalInvoiceCreated: boolean;
  flatRateValues: ObjectcondominiumFlatRateValues[];
  id: string;
  opted: boolean;
  owner: CondominiumOwner;
  rent: ObjectcondominiumRent;
  secondaryResidence: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  taxable: boolean;
  tenants: ObjectcondominiumTenant[];
}

export interface ObjectcondominiumUpdateBulkRequest {
  entries: ObjectcondominiumUpdateBulkEntry[];
}

export interface ObjectcondominiumUpdateBulkResponse {
  condominiums: CondominiumCondominium[];
}

export interface ObjectcondominiumUpdateResponse {
  condominium: CondominiumCondominium;
}

export interface ObjectcontractContactData {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface ObjectcontractContractTemplate {
  category: ObjectcontractTemplateCategory;
  creatorName: string;
  id: string;
  mediaId: string;
  /** @format int64 */
  ownerId: string;
  title: string;
}

export interface ObjectcontractCreateTemplateRequest {
  category: ObjectcontractTemplateCategory;
  creatorName: string;
  mediaId: string;
  /** @format int64 */
  ownerId: string;
  title: string;
}

export interface ObjectcontractCreateTemplateResponse {
  template: ObjectcontractContractTemplate;
}

export type ObjectcontractDeleteTemplateResponse = object;

export interface ObjectcontractDeviceData {
  id: string;
  note: string;
}

export interface ObjectcontractListTemplatesResponse {
  templates: ObjectcontractContractTemplate[];
}

export interface ObjectcontractRenderCondominiumTemplateRequest {
  attachAutomatically: boolean;
  /** The ID of the condominium for which a new contract should be rendered */
  condominiumId: string;
  description: string;
  id: string;
  title: string;
}

export interface ObjectcontractRenderCondominiumTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface ObjectcontractRenderCondominiumsTemplateRequest {
  condominiumIds: string[];
  description: string;
  id: string;
  title: string;
}

export interface ObjectcontractRenderCondominiumsTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface ObjectcontractRenderContactTemplateRequest {
  attachAutomatically: boolean;
  contactId: string;
  description: string;
  id: string;
  title: string;
}

export interface ObjectcontractRenderContactTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface ObjectcontractRenderContactsTemplateRequest {
  contactIds: string[];
  description: string;
  id: string;
  title: string;
}

export interface ObjectcontractRenderContactsTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface ObjectcontractRenderDeviceTemplateRequest {
  assigneeContactId: string;
  contactId: string;
  description: string;
  devices: ObjectcontractDeviceData[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  executeFrom: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  executeUntil: TypeDate;
  id: string;
  /** Either provide this or randomContactData, but not both! */
  onSiteContactPersonId: string;
  orderDescription: string;
  /** Either provide this or onSiteContactPersonId, but not both! */
  randomContactData: ObjectcontractContactData;
  title: string;
}

export interface ObjectcontractRenderDeviceTemplateResponse {
  /** @format byte */
  contract: string;
}

export interface ObjectcontractRenderTenanciesTemplateRequest {
  description: string;
  id: string;
  tenancyIds: string[];
  title: string;
}

export interface ObjectcontractRenderTenanciesTemplateResponse {
  /** @format byte */
  contract: string;
}

/** @default "TEMPLATE_CATEGORY_UNDEFINED" */
export enum ObjectcontractTemplateCategory {
  TEMPLATE_CATEGORY_UNDEFINED = "TEMPLATE_CATEGORY_UNDEFINED",
  TEMPLATE_CATEGORY_GENERAL = "TEMPLATE_CATEGORY_GENERAL",
  TEMPLATE_CATEGORY_ORDERS = "TEMPLATE_CATEGORY_ORDERS",
  TEMPLATE_CATEGORY_TERMINATION = "TEMPLATE_CATEGORY_TERMINATION",
  TEMPLATE_CATEGORY_CONTRACTS = "TEMPLATE_CATEGORY_CONTRACTS",
  TEMPLATE_CATEGORY_PAYMENTS = "TEMPLATE_CATEGORY_PAYMENTS",
  TEMPLATE_CATEGORY_OFFER = "TEMPLATE_CATEGORY_OFFER",
  TEMPLATE_CATEGORY_LETTER = "TEMPLATE_CATEGORY_LETTER",
}

export type ObjectcontractUpdateTemplateResponse = object;

export interface ObjectdemoDataGenerateRequest {
  /** @format int64 */
  accountId: string;
  dataSet: DemoDataDemoDataSet;
}

export type ObjectdemoDataGenerateResponse = object;

export interface ObjectdeviceAddDocumentsResponse {
  device: ObjectdeviceDevice;
}

export interface ObjectdeviceCosts {
  /** @format float */
  amount: number;
  currency: string;
  interval: DeviceCostsInterval;
}

export interface ObjectdeviceCreateRequest {
  /** @format float */
  acquisitionCosts: number;
  /** @format int32 */
  amount: number;
  assetNumberFm: string;
  /** Construction costs plan for heating (German: Baukostenplan Heizung) */
  bkpH: string;
  brand: string;
  /** @format float */
  cataloguePrice: number;
  condition: DeviceDeviceCondition;
  conditionNote: string;
  documentIds: string[];
  facilityPlant: DeviceDeviceFacilityPlant;
  images: ObjectdeviceImage[];
  inspection: DeviceInspection;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installation: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  lockingKey: DeviceLockingKey;
  maintenance: DeviceMaintenance;
  manufacturer: string;
  measure: DeviceDeviceMeasure;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  measureUntil: TypeDate;
  model: string;
  note: string;
  /** @format int32 */
  order: number;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
  revision: DeviceRevision;
  roomId: string;
  serialNumber: string;
  system: DeviceDeviceSystem;
  type: DeviceDeviceType;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  uninstallation: TypeDate;
  unit: ObjectdeviceDeviceUnit;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  warrantyEnd: TypeDate;
}

export interface ObjectdeviceCreateResponse {
  device: ObjectdeviceDevice;
}

export type ObjectdeviceDeleteResponse = object;

export interface ObjectdeviceDevice {
  /** @format float */
  acquisitionCosts: number;
  /** @format int32 */
  amount: number;
  assetNumberFm: string;
  /** Construction costs plan for heating (German: Baukostenplan Heizung) */
  bkpH: string;
  brand: string;
  /** @format float */
  cataloguePrice: number;
  condition: DeviceDeviceCondition;
  conditionNote: string;
  documentIds: string[];
  facilityPlant: DeviceDeviceFacilityPlant;
  id: string;
  images: ObjectdeviceImage[];
  inspection: DeviceInspection;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installation: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  lockingKey: DeviceLockingKey;
  maintenance: DeviceMaintenance;
  manufacturer: string;
  measure: DeviceDeviceMeasure;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  measureUntil: TypeDate;
  model: string;
  note: string;
  /** @format int64 */
  numericId: string;
  /** @format int32 */
  order: number;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
  revision: DeviceRevision;
  roomId: string;
  serialNumber: string;
  system: DeviceDeviceSystem;
  type: DeviceDeviceType;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  uninstallation: TypeDate;
  unit: ObjectdeviceDeviceUnit;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  warrantyEnd: TypeDate;
}

/** @default "DEVICE_UNIT_UNDEFINED" */
export enum ObjectdeviceDeviceUnit {
  DEVICE_UNIT_UNDEFINED = "DEVICE_UNIT_UNDEFINED",
  DEVICE_UNIT_L = "DEVICE_UNIT_L",
  DEVICE_UNIT_KG = "DEVICE_UNIT_KG",
  DEVICEUNITM2 = "DEVICE_UNIT_M2",
  DEVICEUNITM3 = "DEVICE_UNIT_M3",
  DEVICE_UNIT_PCS = "DEVICE_UNIT_PCS",
  DEVICE_UNIT_M = "DEVICE_UNIT_M",
  DEVICE_UNIT_FLAT_RATE = "DEVICE_UNIT_FLAT_RATE",
}

export interface ObjectdeviceImage {
  mediaId: string;
  /** @format int32 */
  order: number;
}

export interface ObjectdeviceListByIdsRequest {
  ids: string[];
}

export interface ObjectdeviceListByIdsResponse {
  devices: ObjectdeviceDevice[];
}

export interface ObjectdeviceListByReferenceIdsRequest {
  /** Optional. Leave out to return installed and uninstalled devices. */
  filterInstallationStatus?: DeviceDeviceInstallationStatus;
  /**
   * filters (optional, combined with AND)
   * Optional. When set (even with empty ids), only devices whose referenceId is in ids are returned. The caller resolves object-owned filters (category, floor, rooms, tenant, owner, assignee) into this list.
   */
  filterReferenceIds?: DeviceIdFilter;
  /** Optional. When set (even with empty ids), only devices whose roomId is in ids are returned. */
  filterRoomIds?: DeviceIdFilter;
  /** Optional. Only used when page is set. Returns the page containing this device (after filtering and sorting) instead of the requested page. If the device is not part of the result, the requested page is returned. */
  focusDeviceId?: string;
  /** When true, response includes allDeviceIds. */
  includeAllDeviceIds: boolean;
  /** When true, response includes referenceIdCounts and roomIdCounts. */
  includeCounts: boolean;
  /**
   * Only used when page is set
   * @format int32
   */
  itemsPerPage: number;
  /**
   * Optional. Leave out or set to 0 to disable pagination
   * @format int32
   */
  page?: number;
  /** Scope of the list (building and object IDs). Defines the default order: devices follow the position of their referenceId in this list, then id DESC. Counts are calculated over this whole scope, independent of the filters. */
  referenceIds: string[];
  /** Primary sort by acquisitionCosts. At most one primary sort* should be set. */
  sortAcquisitionCosts: SortSortOrder;
  /** Primary sort by installation. Devices without a date are sorted last. At most one primary sort* should be set. */
  sortInstallation: SortSortOrder;
  /**
   * sortable (default: position of referenceId in referenceIds, then id DESC)
   * Primary sort by type, using the position in typeSortOrder. At most one primary sort* should be set.
   */
  sortType: SortSortOrder;
  /** Primary sort by uninstallation. Devices without a date are sorted last. At most one primary sort* should be set. */
  sortUninstallation: SortSortOrder;
  /** Primary sort by warrantyEnd. Devices without a date are sorted last. At most one primary sort* should be set. */
  sortWarrantyEnd: SortSortOrder;
  /** Optional free text search. */
  textSearch?: DeviceDeviceTextSearch;
  /** Only used with sortType. Device types in ascending order of their localized label (resolved by the caller). Types not in the list are sorted after all listed types. */
  typeSortOrder: DeviceDeviceType[];
}

export interface ObjectdeviceListByReferenceIdsResponse {
  /** Only set when includeAllDeviceIds is true. IDs of all devices matching the filters, in sort order, ignoring pagination. */
  allDeviceIds: string[];
  devices: ObjectdeviceDevice[];
  /**
   * Page actually returned. Differs from the requested page when focusDeviceId moved it.
   * @format int32
   */
  page: number;
  /** Only set when includeCounts is true. Device counts per referenceId over the whole scope, ignoring filters and text search. */
  referenceIdCounts: DeviceDeviceCount[];
  /** Only set when includeCounts is true. Device counts per roomId over the whole scope, ignoring filters and text search. Devices without roomId are not counted. */
  roomIdCounts: DeviceDeviceCount[];
  /**
   * Number of devices matching the filters.
   * @format int32
   */
  totalDevices: number;
  /** @format int32 */
  totalPages: number;
}

export interface ObjectdeviceUpdateResponse {
  device: ObjectdeviceDevice;
}

export interface ObjectenergySourceCreateRequest {
  /** @format float */
  co2PerYear: number;
  /** @format float */
  consumption: number;
  /** @format float */
  consumptionKwhPerYear: number;
  costDistribution: EnergySourceCostDistribution;
  costDistribution2: EnergySourceCostDistribution;
  documentIds: string[];
  /** @format float */
  energyReferenceArea: number;
  heatDistribution: EnergySourceHeatDistribution;
  kind: EnergySourceEnergySourceKind;
  orders: EnergySourceOrder[];
  /** @format int64 */
  ownerId: string;
  photovoltaic: boolean;
  referenceId: string;
  selfConsumptionCommunity: boolean;
  tankReadings: ObjectenergySourceTankReading[];
  /** @format float */
  tankSize: number;
  type: ObjectenergySourceEnergySourceType;
  unit: ObjectenergySourceEnergySourceUnit;
}

export interface ObjectenergySourceCreateResponse {
  energySource: ObjectenergySourceEnergySource;
}

export type ObjectenergySourceDeleteResponse = object;

export interface ObjectenergySourceEnergySource {
  /** @format float */
  co2PerYear: number;
  /** @format float */
  consumption: number;
  /** @format float */
  consumptionKwhPerYear: number;
  costDistribution: EnergySourceCostDistribution;
  costDistribution2: EnergySourceCostDistribution;
  documentIds: string[];
  /** @format float */
  energyReferenceArea: number;
  heatDistribution: EnergySourceHeatDistribution;
  id: string;
  kind: EnergySourceEnergySourceKind;
  orders: EnergySourceOrder[];
  /** @format int64 */
  ownerId: string;
  photovoltaic: boolean;
  referenceId: string;
  selfConsumptionCommunity: boolean;
  tankReadings: ObjectenergySourceTankReading[];
  /** @format float */
  tankSize: number;
  type: ObjectenergySourceEnergySourceType;
  unit: ObjectenergySourceEnergySourceUnit;
}

/** @default "ENERGY_SOURCE_TYPE_UNDEFINED" */
export enum ObjectenergySourceEnergySourceType {
  ENERGY_SOURCE_TYPE_UNDEFINED = "ENERGY_SOURCE_TYPE_UNDEFINED",
  ENERGY_SOURCE_NO = "ENERGY_SOURCE_NO",
  ENERGY_SOURCE_AIR = "ENERGY_SOURCE_AIR",
  ENERGY_SOURCE_GEOTHERMAL_ENERGY = "ENERGY_SOURCE_GEOTHERMAL_ENERGY",
  ENERGY_SOURCE_GEOTHERMAL_PROBE = "ENERGY_SOURCE_GEOTHERMAL_PROBE",
  ENERGY_SOURCE_EARTH_TUBE = "ENERGY_SOURCE_EARTH_TUBE",
  ENERGY_SOURCE_WATER = "ENERGY_SOURCE_WATER",
  ENERGY_SOURCE_GAS = "ENERGY_SOURCE_GAS",
  ENERGY_SOURCE_OIL = "ENERGY_SOURCE_OIL",
  ENERGY_SOURCE_WOOD_GENERIC = "ENERGY_SOURCE_WOOD_GENERIC",
  ENERGY_SOURCE_WOOD = "ENERGY_SOURCE_WOOD",
  ENERGY_SOURCE_WOOD_PELLETS = "ENERGY_SOURCE_WOOD_PELLETS",
  ENERGY_SOURCE_WOOD_CHIPS = "ENERGY_SOURCE_WOOD_CHIPS",
  ENERGY_SOURCE_WASTE_HEAT = "ENERGY_SOURCE_WASTE_HEAT",
  ENERGY_SOURCE_ELECTRICITY = "ENERGY_SOURCE_ELECTRICITY",
  ENERGY_SOURCE_SUN = "ENERGY_SOURCE_SUN",
  ENERGY_SOURCE_DISTRICT_HEATING_GENERIC = "ENERGY_SOURCE_DISTRICT_HEATING_GENERIC",
  ENERGY_SOURCE_DISTRICT_HEATING_HIGH = "ENERGY_SOURCE_DISTRICT_HEATING_HIGH",
  ENERGY_SOURCE_DISTRICT_HEATING_LOW = "ENERGY_SOURCE_DISTRICT_HEATING_LOW",
  ENERGY_SOURCE_HEAT_PUMP = "ENERGY_SOURCE_HEAT_PUMP",
  ENERGY_SOURCE_OTHER = "ENERGY_SOURCE_OTHER",
}

/** @default "ENERGY_SOURCE_UNIT_UNDEFINED" */
export enum ObjectenergySourceEnergySourceUnit {
  ENERGY_SOURCE_UNIT_UNDEFINED = "ENERGY_SOURCE_UNIT_UNDEFINED",
  ENERGY_SOURCE_UNIT_L = "ENERGY_SOURCE_UNIT_L",
  ENERGY_SOURCE_UNIT_KG = "ENERGY_SOURCE_UNIT_KG",
  ENERGYSOURCEUNITM3 = "ENERGY_SOURCE_UNIT_M3",
  ENERGY_SOURCE_UNIT_KWH = "ENERGY_SOURCE_UNIT_KWH",
}

export interface ObjectenergySourceListByIdsRequest {
  ids: string[];
}

export interface ObjectenergySourceListByIdsResponse {
  energySources: ObjectenergySourceEnergySource[];
}

export interface ObjectenergySourceListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface ObjectenergySourceListByReferenceIdsResponse {
  energySources: ObjectenergySourceEnergySource[];
}

export interface ObjectenergySourceTankReading {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  documentIds: string[];
  /** @format float */
  value: number;
}

export interface ObjectenergySourceUpdateResponse {
  energySource: ObjectenergySourceEnergySource;
}

/** @default "CONDITION_UNDEFINED" */
export enum ObjecthandoverProtocolCondition {
  CONDITION_UNDEFINED = "CONDITION_UNDEFINED",
  CONDITION_PERFECT = "CONDITION_PERFECT",
  CONDITION_NORMAL_WEAR = "CONDITION_NORMAL_WEAR",
  CONDITION_DEFICIENCY = "CONDITION_DEFICIENCY",
  CONDITION_DIRTY = "CONDITION_DIRTY",
}

export interface ObjecthandoverProtocolContactData {
  address: CommonaddressAddress;
  addressHistory: V2AddressEntry[];
  contactPersonIds: string[];
  email: string;
  /** Only set on persons/contact persons */
  firstName: string;
  /** Only set on persons/contact persons */
  lastName: string;
  /** Only set on companies */
  name: string;
  phoneNumbers: V2PhoneNumber[];
}

export interface ObjecthandoverProtocolCreateRequest {
  assigneeContactId: string;
  devicesWithoutRoom: ObjecthandoverProtocolDevice[];
  draft: boolean;
  movingInTenancyReferences: HandoverProtocolWriteTenancyReference[];
  movingOutTenancyReferences: HandoverProtocolWriteTenancyReference[];
  note: string;
  /** @format int64 */
  ownerId: string;
  participants: HandoverProtocolWriteParticipant[];
  rooms: ObjecthandoverProtocolRoom[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  scheduledDate: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  scheduledTime: TypeTimeOfDay;
  templateId: string;
}

export interface ObjecthandoverProtocolCreateResponse {
  protocol: HandoverProtocolHandoverProtocol;
}

export interface ObjecthandoverProtocolCreateTemplateRequest {
  devicesWithoutRoomIds: string[];
  name: string;
  /** @format int64 */
  ownerId: string;
  rooms: HandoverProtocolTemplateRoom[];
  templateReferences: HandoverProtocolTemplateReference[];
}

export interface ObjecthandoverProtocolCreateTemplateResponse {
  template: ObjecthandoverProtocolTemplate;
}

export interface ObjecthandoverProtocolCreator {
  /** @format int64 */
  accountId: string;
  userId: string;
}

export type ObjecthandoverProtocolDeleteResponse = object;

export interface ObjecthandoverProtocolDevice {
  action: HandoverProtocolAction;
  cleaningNecessary: boolean;
  condition: ObjecthandoverProtocolCondition;
  costAbsorption: CostCostAbsorption;
  costShareUnit: CostCostShareUnit;
  /** @format double */
  costShareValue: number;
  /** @format double */
  costShareValueCalculated: number;
  deviceData: ObjecthandoverProtocolDeviceData;
  id: string;
  images: ObjecthandoverProtocolImage[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  keyData: HandoverProtocolKeyData;
  /** Defect comment. Shown in PDF and transferred to the draft order ticket. Maps to device Measures / Note (conditionNote). */
  note: string;
  /** @format int32 */
  order: number;
  postCleaningAction: HandoverProtocolCleanlinessRoomAction;
  /** @format double */
  postCleaningCostShareValue: number;
  postCleaningCostUnit: CostCostShareUnit;
  previousCondition: ObjecthandoverProtocolCondition;
  /** General device remark. Shown in PDF only; not transferred to the draft order ticket. (COOZ-14008) */
  remark: string;
  type: DeviceDeviceType;
}

export interface ObjecthandoverProtocolDeviceData {
  /** @format float */
  acquisitionCosts: number;
  /** @format int32 */
  amount: number;
  brand: string;
  /** @format float */
  cataloguePrice: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  manufacturer: string;
  model: string;
  referenceId: string;
  serialNumber: string;
  unit: ObjecthandoverProtocolDeviceUnit;
}

/** @default "DEVICE_UNIT_UNDEFINED" */
export enum ObjecthandoverProtocolDeviceUnit {
  DEVICE_UNIT_UNDEFINED = "DEVICE_UNIT_UNDEFINED",
  DEVICE_UNIT_L = "DEVICE_UNIT_L",
  DEVICE_UNIT_KG = "DEVICE_UNIT_KG",
  DEVICEUNITM2 = "DEVICE_UNIT_M2",
  DEVICEUNITM3 = "DEVICE_UNIT_M3",
  DEVICE_UNIT_PCS = "DEVICE_UNIT_PCS",
  DEVICE_UNIT_M = "DEVICE_UNIT_M",
  DEVICE_UNIT_FLAT_RATE = "DEVICE_UNIT_FLAT_RATE",
}

export type ObjecthandoverProtocolEnableResponse = object;

export interface ObjecthandoverProtocolHasEnabledResponse {
  enabled: boolean;
}

export interface ObjecthandoverProtocolImage {
  attachTo: HandoverProtocolAttachTo;
  mediaId: string;
}

export interface ObjecthandoverProtocolListByIdsRequest {
  ids: string[];
}

export interface ObjecthandoverProtocolListByIdsResponse {
  protocols: HandoverProtocolHandoverProtocol[];
}

export interface ObjecthandoverProtocolListByObjectIdsRequest {
  objectIds: string[];
}

export interface ObjecthandoverProtocolListByObjectIdsResponse {
  protocols: HandoverProtocolHandoverProtocol[];
}

export interface ObjecthandoverProtocolListTemplatesResponse {
  templates: ObjecthandoverProtocolTemplate[];
}

export interface ObjecthandoverProtocolParticipant {
  attending: boolean;
  contactData: ObjecthandoverProtocolContactData;
  contactId: string;
  powerOfAttorneyMediaIds: string[];
  signed: boolean;
  type: HandoverProtocolParticipantType;
}

export interface ObjecthandoverProtocolRoom {
  cleanliness: HandoverProtocolCleanlinessRoom;
  cleanlinessAction: HandoverProtocolCleanlinessRoomAction;
  /** @format double */
  cleanlinessCost: number;
  cleanlinessCostUnit: CostCostShareUnit;
  devices: ObjecthandoverProtocolDevice[];
  id: string;
  images: ObjecthandoverProtocolImage[];
  name: string;
  note: string;
  /** @format int32 */
  order: number;
  referenceId: string;
}

export interface ObjecthandoverProtocolSignature {
  contactId: string;
  hasSigned: boolean;
  /** @format byte */
  signature: string;
  type: HandoverProtocolParticipantType;
}

export interface ObjecthandoverProtocolTemplate {
  devicesWithoutRoomIds: string[];
  favorite: boolean;
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
  rooms: HandoverProtocolTemplateRoom[];
  templateReferences: HandoverProtocolTemplateReference[];
}

export interface ObjecthandoverProtocolUpdateResponse {
  protocol: HandoverProtocolHandoverProtocol;
}

export interface ObjecthandoverProtocolUpdateTemplateResponse {
  template: ObjecthandoverProtocolTemplate;
}

export interface ObjectinsuranceCreateRequest {
  /** @format float */
  amount: number;
  benefits: InsuranceInsuranceBenefit[];
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  earliestTerminationDate: TypeDate;
  editedByAic: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  /** @format float */
  excess: number;
  /** @format int32 */
  indexYear: number;
  insuranceCompany: string;
  notes: string;
  /**
   * Account ID of owner (who owns the stuff in real life)
   * @format int64
   */
  ownerId: string;
  policyNumber: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  premiumPaidUntil: TypeDate;
  /** Some opaque ID where this entity is attached to (e.g. propertyId or buildingId) */
  referenceId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate: TypeDate;
  type: InsuranceInsuranceType;
  /** @format float */
  yearlyCosts: number;
}

export interface ObjectinsuranceCreateResponse {
  insurance: InsuranceInsurance;
}

export type ObjectinsuranceDeleteResponse = object;

export interface ObjectinsuranceListByIdsResponse {
  insurances: InsuranceInsurance[];
}

export interface ObjectinsuranceListByReferenceIdsResponse {
  insurances: InsuranceInsurance[];
}

export interface ObjectinsuranceUpdateResponse {
  insurance: InsuranceInsurance;
}

export interface ObjectinvestPlanCreateBulkRequest {
  entries: InvestPlanCreateBulkEntry[];
  plans: InvestPlanCreateBulkPlanEntry[];
}

export interface ObjectinvestPlanCreateBulkResponse {
  components: InvestPlanComponent[];
  plans: InvestPlanPlannedCosts[];
}

export type ObjectinvestPlanDeleteResponse = object;

export interface ObjectinvestPlanEnableRequest {
  entries: InvestPlanEnableEntry[];
}

export type ObjectinvestPlanEnableResponse = object;

export interface ObjectinvestPlanHasEnabledRequest {
  buildingIds: string[];
}

export interface ObjectinvestPlanHasEnabledResponse {
  entries: InvestPlanHasEnabledEntry[];
}

export interface ObjectinvestPlanListByReferenceIdsRequest {
  ids: string[];
}

export interface ObjectinvestPlanListByReferenceIdsResponse {
  components: InvestPlanComponent[];
  plans: InvestPlanPlannedCosts[];
}

export interface ObjectinvestPlanUpdateBulkEntry {
  bkp: string;
  /** @format float */
  costs: number;
  /** @format float */
  futurePercentage: number;
  id: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installationDate: TypeDate;
  /** @format int32 */
  lifeSpan: number;
  name: string;
  note: string;
  optionalValueEnhancingComponent: boolean;
  /** @format float */
  percentage: number;
  /** @format float */
  plannedCosts: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  plannedReplacementDate: TypeDate;
}

export interface ObjectinvestPlanUpdateBulkRequest {
  entries: ObjectinvestPlanUpdateBulkEntry[];
  plans: InvestPlanUpdateBulkPlanEntry[];
}

export interface ObjectinvestPlanUpdateBulkResponse {
  components: InvestPlanComponent[];
  plans: InvestPlanPlannedCosts[];
}

export type ObjectmortgageAddDocumentsResponse = object;

export interface ObjectmortgageCreateRequest {
  /** @format double */
  amortisationAmount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  amortizationFrom: TypeDate;
  amortizations: MortgageAmortization[];
  /** @format double */
  amount: number;
  bankCountry: string;
  bankName: string;
  bankNumber: string;
  bic: string;
  /** @format double */
  carryingAmount: number;
  debitAccount: string;
  designation: string;
  documentIds: string[];
  dueDateMonthsAmortization: number[];
  dueDateMonthsInterestRate: number[];
  enableAmortizations: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  expiresAt: TypeDate;
  /** @format float */
  interestRate: number;
  mortgageDesignation: MortgageMortgageDesignation;
  mortgageeAddress: CommonaddressAddress;
  number: string;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** Could be property, building or object ID */
  referenceId: string;
  terminableOn: MortgageMortgageTerminableOn;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export interface ObjectmortgageCreateResponse {
  mortgage: MortgageMortgage;
}

export type ObjectmortgageDeleteResponse = object;

export interface ObjectmortgageListByIdsRequest {
  ids: string[];
}

export interface ObjectmortgageListByIdsResponse {
  mortgages: MortgageMortgage[];
}

export interface ObjectmortgageListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface ObjectmortgageListByReferenceIdsResponse {
  mortgages: MortgageMortgage[];
}

export interface ObjectmortgageUpdateResponse {
  mortgage: MortgageMortgage;
}

export interface ObjectobjectAddDocumentsRequest {
  documentIds: string[];
  id: string;
}

export interface ObjectobjectAddDocumentsResponse {
  object: ObjectobjectObject;
}

export interface ObjectobjectAdditionalValues {
  type: PropertyAdditionalRentComponents;
  /** @format float */
  value: number;
}

export interface ObjectobjectAdvancePaymentValue {
  type: PropertyAdvancePaymentRentComponents;
  /** @format float */
  value: number;
}

export interface ObjectobjectCharacteristics {
  additionalRooms: ObjectAdditionalRooms[];
  areas: ObjectAreas;
  /** @format int32 */
  bathrooms: number;
  /**
   * In meter
   * @format float
   */
  ceilingHeight: number;
  commercialFeatures: ObjectCommercialFeatures[];
  condition: ObjectobjectCondition;
  /** @format float */
  decimalFloor: number;
  extras: ObjectExtras[];
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  firstTimeOccupancy: string;
  flatSharingCommunity: ApplicableApplicable;
  /**
   * Ground floor = 0
   * @format int32
   */
  floor: number;
  /**
   * Maximum floor load in kg/m³
   * @format float
   */
  floorLoad: number;
  floorings: ObjectFlooring[];
  /** Widely used to control the amount of foreigners buying holiday flats in popular regions */
  foreignQuota: ApplicableApplicable;
  furnishing: ObjectFurnishing;
  furnishingType: ObjectFurnishingType;
  /** A small building for storing garden tools, bicycles, ... */
  gardenShed: ApplicableApplicable;
  glazings: ObjectGlazing[];
  /**
   * Total premium of an insurance contract before brokerage or discounts have been deducted, in percent.
   * @format int32
   */
  grossPremium: number;
  /** @format int32 */
  guestToilets: number;
  /**
   * In meter
   * @format float
   */
  hallHeight: number;
  heatings: ObjectHeating[];
  kitchens: ObjectKitchen[];
  locationQualities: ObjectobjectLocationQuality[];
  /** @format float */
  numberOfFloors: number;
  /** optiert */
  opted: ApplicableApplicable;
  petAllowances: ObjectPets[];
  pets: ApplicableApplicable;
  photovoltaic: ApplicableApplicable;
  /** Planned for the future */
  planned: ApplicableApplicable;
  /** @format float */
  rooms: number;
  sanitaries: ObjectSanitary[];
  secondaryResidenceAllowed: ApplicableApplicable;
  /** @format int32 */
  separateToilets: number;
  /** Intentionally missing interior finish in order to allow customization */
  shellConstruction: ApplicableApplicable;
  /** @format int32 */
  showers: number;
  smoking: ApplicableApplicable;
  technologies: ObjectTechnology[];
  thermalSolarCollector: ApplicableApplicable;
  /** @format int32 */
  toilets: number;
  /** Mainly used for parking slots */
  underRoof: ApplicableApplicable;
  /** @format float */
  volume: number;
  wheelchairAccessible: ApplicableApplicable;
  windows: ObjectWindow[];
  /** @format int32 */
  yearBuilt: number;
  /** @format int32 */
  yearLastRenovation: number;
}

/** @default "UNDEFINED_CONDITION" */
export enum ObjectobjectCondition {
  UNDEFINED_CONDITION = "UNDEFINED_CONDITION",
  FIRST_OCCUPANCY = "FIRST_OCCUPANCY",
  FIRST_OCCUPANCY_AFTER_RESTORATION = "FIRST_OCCUPANCY_AFTER_RESTORATION",
  EXCELLENT = "EXCELLENT",
  DILAPIDATED = "DILAPIDATED",
  LIVEABLE = "LIVEABLE",
  WELL_KEPT = "WELL_KEPT",
  GOOD = "GOOD",
  MODERNIZED = "MODERNIZED",
  LIKE_NEW = "LIKE_NEW",
  PASSABLE = "PASSABLE",
  PARTLY_RENOVATED = "PARTLY_RENOVATED",
  PARTLY_NEED_OF_RENOVATION = "PARTLY_NEED_OF_RENOVATION",
  PARTLY_RESTORATED = "PARTLY_RESTORATED",
  PARTLY_NEED_OF_RESTORATION = "PARTLY_NEED_OF_RESTORATION",
  FULLY_RENOVATED = "FULLY_RENOVATED",
  FULLY_RESTORATED = "FULLY_RESTORATED",
}

export interface ObjectobjectCountResponse {
  /** @format int32 */
  count: number;
}

export interface ObjectobjectCreateBulkRequest {
  address: CommonaddressAddress;
  administrationType: ObjectAdministrationType;
  /** @format int32 */
  amount: number;
  buildingId: string;
  category: ObjectCategory;
  marketingLanguage: LanguagePreferredLanguage;
  /** @format int64 */
  ownerId: string;
  type: ObjectobjectType;
}

export type ObjectobjectCreateBulkResponse = object;

export interface ObjectobjectCreateRequest {
  address: CommonaddressAddress;
  administrationType: ObjectAdministrationType;
  assignedSideRooms: string;
  availability: ObjectAvailability;
  /** @format int64 */
  awn: string;
  buildingId: string;
  category: ObjectCategory;
  characteristics: ObjectobjectCharacteristics;
  contacts: ObjectContacts;
  deposit: ObjectobjectDeposit;
  description: string;
  development: ObjectobjectDevelopment;
  documents: ObjectobjectDocument[];
  energySources: ObjectobjectEnergySource[];
  ewid: string;
  images: ObjectobjectImage[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveBy: TypeDate;
  marketingLanguage: LanguagePreferredLanguage;
  name: string;
  needsMatching: boolean;
  note: string;
  number: string;
  /** @format int64 */
  numericId: string;
  otoId: string;
  /** @format int64 */
  ownerId: string;
  parking: ObjectParking[];
  /** Do only use first array element. Others are ignored */
  positions: ObjectPosition[];
  pricing: ObjectPricing;
  publishAddress: boolean;
  publishCharacteristicsInDescription: boolean;
  published: boolean;
  renovations: ObjectRenovation[];
  sharedUse: string;
  specialFeatures: string;
  subCategories: ObjectSubCategory[];
  tags: string[];
  title: string;
  type: ObjectobjectType;
  unusualAgreement: string;
  utilizations: ObjectUtilization[];
  /** @format float */
  valueQuota: number;
  videoUrl: string;
  videos: ObjectVideo[];
  virtualTourUrl: string;
}

export interface ObjectobjectCreateResponse {
  object: ObjectobjectObject;
}

export type ObjectobjectDeleteResponse = object;

export interface ObjectobjectDeposit {
  /** @format float */
  amount: number;
  bankDepotAccepted: boolean;
  bankDepotIds: string[];
  bankDepotNames: string[];
  bankGuaranteeAccepted: boolean;
  bankGuaranteeIds: string[];
  bankGuaranteeNames: string[];
  cashPaymentAccepted: boolean;
  collectiveInsuranceAccepted: boolean;
  collectiveInsuranceNames: string[];
  cooperativeShareAccepted: boolean;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  depositInsurance: ObjectDepositInsurance;
  depositNeeded: boolean;
  insuranceAccepted: boolean;
  insuranceNames: string[];
}

/**
 * The state of development of the plot
 * @default "UNDEFINED_DEVELOPMENT"
 */
export enum ObjectobjectDevelopment {
  UNDEFINED_DEVELOPMENT = "UNDEFINED_DEVELOPMENT",
  FULL = "FULL",
  PARTIAL = "PARTIAL",
  UNDEVELOPED = "UNDEVELOPED",
}

export interface ObjectobjectDocument {
  documentId: string;
  /** DEPRECATED. Not used anymore. Use the field type on document to determine it's content. */
  isFloorPlan: boolean;
  /**
   * True if document is allowed to be published (e.g. to searching platforms)
   * If set to true the document is published to marketplaces (has to be supported by marketplace)
   */
  isPublic: boolean;
}

export interface ObjectobjectEnergySource {
  documentIds: string[];
  hasStorage: boolean;
  /** @format int64 */
  orderDate: string;
  /** @format float */
  orderQuantity: number;
  /**
   * DO NOT USE! Deprecated and replaced with tankReadings.
   * @format float
   */
  tankContent: number;
  tankReadings: ObjectobjectTankReading[];
  /** @format float */
  tankSize: number;
  type: ObjectobjectEnergySourceType;
  unit: ObjectobjectEnergySourceUnit;
}

/** @default "UNDEFINED_ENERGY_SOURCE_TYPE" */
export enum ObjectobjectEnergySourceType {
  UNDEFINED_ENERGY_SOURCE_TYPE = "UNDEFINED_ENERGY_SOURCE_TYPE",
  ENERGY_SOURCE_NO = "ENERGY_SOURCE_NO",
  ENERGY_SOURCE_AIR = "ENERGY_SOURCE_AIR",
  ENERGY_SOURCE_GEOTHERMAL_ENERGY = "ENERGY_SOURCE_GEOTHERMAL_ENERGY",
  ENERGY_SOURCE_GEOTHERMAL_PROBE = "ENERGY_SOURCE_GEOTHERMAL_PROBE",
  ENERGY_SOURCE_EARTH_TUBE = "ENERGY_SOURCE_EARTH_TUBE",
  ENERGY_SOURCE_WATER = "ENERGY_SOURCE_WATER",
  ENERGY_SOURCE_GAS = "ENERGY_SOURCE_GAS",
  ENERGY_SOURCE_OIL = "ENERGY_SOURCE_OIL",
  ENERGY_SOURCE_WOOD_GENERIC = "ENERGY_SOURCE_WOOD_GENERIC",
  ENERGY_SOURCE_WOOD = "ENERGY_SOURCE_WOOD",
  ENERGY_SOURCE_WOOD_PELLETS = "ENERGY_SOURCE_WOOD_PELLETS",
  ENERGY_SOURCE_WOOD_CHIPS = "ENERGY_SOURCE_WOOD_CHIPS",
  ENERGY_SOURCE_WASTE_HEAT = "ENERGY_SOURCE_WASTE_HEAT",
  ENERGY_SOURCE_ELECTRICITY = "ENERGY_SOURCE_ELECTRICITY",
  ENERGY_SOURCE_SUN = "ENERGY_SOURCE_SUN",
  ENERGY_SOURCE_DISTRICT_HEATING_GENERIC = "ENERGY_SOURCE_DISTRICT_HEATING_GENERIC",
  ENERGY_SOURCE_DISTRICT_HEATING_HIGH = "ENERGY_SOURCE_DISTRICT_HEATING_HIGH",
  ENERGY_SOURCE_DISTRICT_HEATING_LOW = "ENERGY_SOURCE_DISTRICT_HEATING_LOW",
  ENERGY_SOURCE_HEAT_PUMP = "ENERGY_SOURCE_HEAT_PUMP",
  ENERGY_SOURCE_OTHER = "ENERGY_SOURCE_OTHER",
}

/** @default "ENERGY_SOURCE_UNIT_UNDEFINED" */
export enum ObjectobjectEnergySourceUnit {
  ENERGY_SOURCE_UNIT_UNDEFINED = "ENERGY_SOURCE_UNIT_UNDEFINED",
  ENERGY_SOURCE_UNIT_L = "ENERGY_SOURCE_UNIT_L",
  ENERGY_SOURCE_UNIT_KG = "ENERGY_SOURCE_UNIT_KG",
  ENERGYSOURCEUNITM3 = "ENERGY_SOURCE_UNIT_M3",
  ENERGY_SOURCE_UNIT_STERE = "ENERGY_SOURCE_UNIT_STERE",
}

export interface ObjectobjectFlatRateValues {
  type: PropertyFlatRateRentComponents;
  /** @format float */
  value: number;
}

export interface ObjectobjectGetByPublicIdResponse {
  object: ObjectobjectObject;
}

export interface ObjectobjectGetMarketingStatisticsResponse {
  /** @format int32 */
  employeeInMarketing: number;
  /** @format int32 */
  employeeInMarketingFor12Weeks: number;
  /** @format int32 */
  employeeInMarketingFor4Weeks: number;
  /** @format int32 */
  employeeInMarketingFor8Weeks: number;
  /** @format int32 */
  employeeOnline: number;
  /** @format int32 */
  employeeOnlineFor12Weeks: number;
  /** @format int32 */
  employeeOnlineFor4Weeks: number;
  /** @format int32 */
  employeeOnlineFor8Weeks: number;
  /** @format int32 */
  overallInMarketing: number;
  /** @format int32 */
  overallInMarketingFor12Weeks: number;
  /** @format int32 */
  overallInMarketingFor4Weeks: number;
  /** @format int32 */
  overallInMarketingFor8Weeks: number;
  /** @format int32 */
  overallNewInMarketing: number;
  /** @format int32 */
  overallOnline: number;
  /** @format int32 */
  overallOnlineFor12Weeks: number;
  /** @format int32 */
  overallOnlineFor4Weeks: number;
  /** @format int32 */
  overallOnlineFor8Weeks: number;
}

export interface ObjectobjectGetResponse {
  object: ObjectobjectObject;
}

export interface ObjectobjectGetUsedTagsResponse {
  tags: string[];
}

export interface ObjectobjectImage {
  mediaId: string;
  /** @format int32 */
  order: number;
  title: string;
}

export interface ObjectobjectListByBuildingIdsRequest {
  buildingIds: string[];
}

export interface ObjectobjectListByBuildingIdsResponse {
  objects: ObjectobjectObject[];
}

export interface ObjectobjectListByContactIdResponse {
  objects: ObjectobjectObject[];
}

export interface ObjectobjectListByIdsRequest {
  ids: string[];
}

export interface ObjectobjectListByIdsResponse {
  objects: ObjectobjectObject[];
}

export interface ObjectobjectListFilterOptionsResponse {
  options: ObjectObjectFilterOption[];
}

export interface ObjectobjectListResponse {
  objects: ObjectobjectObject[];
  /** @format int32 */
  totalObjectCount: number;
  /** @format int32 */
  totalPageCount: number;
}

/** @default "PARTICULARLY_QUIET" */
export enum ObjectobjectLocationQuality {
  PARTICULARLY_QUIET = "PARTICULARLY_QUIET",
  SUNNY = "SUNNY",
  BEAUTIFUL_VIEW = "BEAUTIFUL_VIEW",
  HILLSIDE = "HILLSIDE",
  LAKESIDE = "LAKESIDE",
  UNOBSTRUCTABLE = "UNOBSTRUCTABLE",
  FOREST = "FOREST",
  COMMERCIAL_CENTER = "COMMERCIAL_CENTER",
  PEDESTRIAN_AREA = "PEDESTRIAN_AREA",
  CENTRAL = "CENTRAL",
  WELL_DEVELOPED = "WELL_DEVELOPED",
}

export interface ObjectobjectObject {
  acceptsCreditTrust: boolean;
  address: CommonaddressAddress;
  administrationType: ObjectAdministrationType;
  assignedSideRooms: string;
  /** Per-advert override for automatic digital reference check. UNDEFINED means use account settings. */
  automaticReferenceCheck: MarketbaseAutomaticReferenceCheckMode;
  availability: ObjectAvailability;
  /** @format int64 */
  awn: string;
  buildingId: string;
  category: ObjectCategory;
  characteristics: ObjectobjectCharacteristics;
  condominiumOwnership: boolean;
  contacts: ObjectContacts;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  debitUntil: TypeDate;
  defaultAnswer: ObjectDefaultAnswer;
  deposit: ObjectobjectDeposit;
  description: string;
  development: ObjectobjectDevelopment;
  documents: ObjectobjectDocument[];
  energySources: ObjectobjectEnergySource[];
  ewid: string;
  id: string;
  images: ObjectobjectImage[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveBy: TypeDate;
  marketingLanguage: LanguagePreferredLanguage;
  marketingStatus: ObjectMarketingStatus;
  name: string;
  needsMatching: boolean;
  note: string;
  number: string;
  /** @format int64 */
  numericId: string;
  onboardingFinished: boolean;
  otoId: string;
  /** @format int64 */
  ownerId: string;
  parking: ObjectParking[];
  /** Do only use first array element. Others are ignored */
  positions: ObjectPosition[];
  pricing: ObjectPricing;
  /** A unique number consisting of "<ownerId>.<x>" while x = number (counting up) that is unique for the ownerId */
  publicId: string;
  publishAddress: boolean;
  publishCharacteristicsInDescription: boolean;
  /** Per-advert override for mailbox ID used as sender for digital reference request emails. Empty means use account settings. */
  referenceSenderMailboxId: string;
  renovations: ObjectRenovation[];
  sharedUse: string;
  specialFeatures: string;
  subCategories: ObjectSubCategory[];
  tags: string[];
  title: string;
  type: ObjectobjectType;
  unusualAgreement: string;
  /**
   * UNIX timestamp in seconds when object was modified the last time
   * @format int64
   */
  updatedAt: string;
  utilizations: ObjectUtilization[];
  /** @format float */
  valueQuota: number;
  videoUrl: string;
  videos: ObjectVideo[];
  viewingAppointment: ObjectViewingAppointment;
  virtualTourUrl: string;
}

export interface ObjectobjectPublishUpdatedEventsRequest {
  ownerIds: string[];
}

export type ObjectobjectPublishUpdatedEventsResponse = object;

export interface ObjectobjectSetAccountingAssigneeRequest {
  contactIdAssigneeAccounting: string;
  ids: string[];
}

export type ObjectobjectSetAccountingAssigneeResponse = object;

export interface ObjectobjectSetAdminAssigneeRequest {
  contactIdAssigneeAdministration: string;
  ids: string[];
}

export type ObjectobjectSetAdminAssigneeResponse = object;

export interface ObjectobjectSetAssetAssigneeRequest {
  contactIdAssigneeAsset: string;
  ids: string[];
}

export type ObjectobjectSetAssetAssigneeResponse = object;

export interface ObjectobjectSetOwnerAssigneeRequest {
  contactIdAssigneeOwner: string;
  ids: string[];
}

export type ObjectobjectSetOwnerAssigneeResponse = object;

export interface ObjectobjectTankReading {
  /** @format int64 */
  date: string;
  documentIds: string[];
  /** @format float */
  value: number;
}

/** @default "RENT" */
export enum ObjectobjectType {
  RENT = "RENT",
  SALE = "SALE",
}

export interface ObjectobjectUpdateResponse {
  object: ObjectobjectObject;
}

export interface ObjectplotCreateRequest {
  plotCreations: PlotPlotCreation[];
}

export interface ObjectplotCreateResponse {
  plots: PlotPlot[];
}

export type ObjectplotDeleteResponse = object;

export interface ObjectplotListByIdsResponse {
  plots: PlotPlot[];
}

export interface ObjectplotListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface ObjectplotListByReferenceIdsResponse {
  plots: PlotPlot[];
}

export interface ObjectplotUpdateRequest {
  plotUpdates: PlotPlotUpdate[];
}

export interface ObjectplotUpdateResponse {
  plots: PlotPlot[];
}

export interface Objectpropertyv2CreateRequest {
  additionalRentComponents: V2AdditionalRentComponentEntry[];
  /** Only zip, city and state are required and set */
  address: CommonaddressAddress;
  advancePaymentRentComponents: V2AdvancePaymentRentComponentEntry[];
  assignees: V2Assignees;
  bankInfo: V2BankInfo[];
  buildingIds: string[];
  constructionZone: string;
  development: Propertyv2Development;
  documentIds: string[];
  egrid: string;
  flatRateRentComponents: V2FlatRateRentComponentEntry[];
  imageMediaId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  keyDateServiceChargeSettlement: TypeDate;
  landRegisterNumber: string;
  name: string;
  note: string;
  /** @format int64 */
  numericId: string;
  onboardingFinished: boolean;
  opted: boolean;
  optedPortionKey: Propertyv2OptedPortionKey;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** @format float */
  plotArea: number;
  /** @format int64 */
  propertyValue: string;
  transferToAccounting: boolean;
  type: Propertyv2PropertyType;
}

export interface Objectpropertyv2CreateResponse {
  property: Propertyv2Property;
}

export type Objectpropertyv2DeleteResponse = object;

export interface Objectpropertyv2ListByIdsResponse {
  properties: Propertyv2Property[];
}

export interface Objectpropertyv2ListResponse {
  properties: Propertyv2Property[];
  /** @format int32 */
  totalPageCount: number;
  /** @format int32 */
  totalPropertiesCount: number;
}

export interface Objectpropertyv2UpdateResponse {
  property: Propertyv2Property;
}

export interface ObjectrentalIndexCreateRequest {
  compositionLinesOrColumns: RentalIndexCompositionLinesOrColumns;
  compositionType: RentalIndexCompositionType;
  fields: RentalIndexTemplateField[];
  language: LanguagePreferredLanguage;
  name: string;
  onlyMovingInOutTenancies: boolean;
  /** @format int64 */
  ownerId: string;
  sortingType: RentalIndexSortingType;
  tenancyType: RentalIndexTenancyType;
}

export interface ObjectrentalIndexCreateResponse {
  template: RentalIndexRentalIndexTemplate;
}

export type ObjectrentalIndexDeleteResponse = object;

export interface ObjectrentalIndexListResponse {
  templates: RentalIndexRentalIndexTemplate[];
}

export interface ObjectrentalIndexRenderRequest {
  buildingIds: string[];
  compositionLinesOrColumns: RentalIndexCompositionLinesOrColumns;
  compositionType: RentalIndexCompositionType;
  customHeader: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  fields: RentalIndexTemplateField[];
  hideInactiveObjects: boolean;
  language: LanguagePreferredLanguage;
  onlyMovingInOutTenancies: boolean;
  sortingType: RentalIndexSortingType;
  /** If fixed date leave empty */
  startDate: TypeDate;
  tenancyType: RentalIndexTenancyType;
}

export interface ObjectrentalIndexRenderResponse {
  /** @format byte */
  file: string;
}

export interface ObjectrentalIndexUpdateResponse {
  template: RentalIndexRentalIndexTemplate;
}

export interface ObjectroomCreateRequest {
  roomCreations: RoomRoomCreation[];
}

export interface ObjectroomCreateResponse {
  rooms: ObjectroomRoom[];
}

export type ObjectroomDeleteResponse = object;

export interface ObjectroomListByIdsRequest {
  ids: string[];
}

export interface ObjectroomListByIdsResponse {
  rooms: ObjectroomRoom[];
}

export interface ObjectroomListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface ObjectroomListByReferenceIdsResponse {
  rooms: ObjectroomRoom[];
}

export interface ObjectroomRoom {
  dimensions: RoomRoomDimensions;
  documentIds: string[];
  id: string;
  imageMediaIds: string[];
  name: string;
  note: string;
  /** @format int32 */
  order: number;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
}

export interface ObjectroomUpdateRequest {
  roomUpdates: RoomRoomUpdate[];
}

export interface ObjectroomUpdateResponse {
  rooms: ObjectroomRoom[];
}

export interface ObjecttenancyActivateResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyAddDocumentsByNumericIdResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyAddDocumentsResponse {
  tenancy: ObjecttenancyTenancy;
}

/** @default "UNDEFINED_ADDITIONAL_COSTS_BILLING_TYPE" */
export enum ObjecttenancyAdditionalCostsBillingType {
  UNDEFINED_ADDITIONAL_COSTS_BILLING_TYPE = "UNDEFINED_ADDITIONAL_COSTS_BILLING_TYPE",
  FLATRATE_ADDITIONAL_COSTS_BILLING_TYPE = "FLATRATE_ADDITIONAL_COSTS_BILLING_TYPE",
  ADVANCE_PAYMENT_ADDITIONAL_COSTS_BILLING_TYPE = "ADVANCE_PAYMENT_ADDITIONAL_COSTS_BILLING_TYPE",
}

export interface ObjecttenancyAdditionalValues {
  type: PropertyAdditionalRentComponents;
  /** @format float */
  value: number;
}

export interface ObjecttenancyAdvancePaymentValue {
  type: PropertyAdvancePaymentRentComponents;
  /** @format float */
  value: number;
}

export interface ObjecttenancyContract {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  activationDate: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  creationDate: TypeDate;
  intendedUse: string;
  licensePlate: string;
  number: string;
  rentType: TenancyRentType;
  type: TenancyContractType;
  typeOfUse: ObjecttenancyTypeOfUse;
}

export interface ObjecttenancyCreateRequest {
  activated: boolean;
  closed: boolean;
  contract: ObjecttenancyContract;
  contractAmendments: string;
  deposit: ObjecttenancyDeposit;
  /**
   * Date when tenant wants to move out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredMoveOutAt: TypeDate;
  documentIds: string[];
  earlyRightOfTerminationOptions: TenancyEarlyRightOfTerminationOption[];
  /**
   * Date when tenancy ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  familyFlat: boolean;
  finalInvoiceCreated: boolean;
  indexData: TenancyIndexData;
  /**
   * Date when tenant liability ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liabilityEndsAt: TypeDate;
  /**
   * Date when tenant actually moved out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  movedOutAt: TypeDate;
  /**
   * Date when next tenant could possibly move in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextPossibleMoveInAt: TypeDate;
  note: string;
  /** @format int64 */
  numericId: string;
  objectId: string;
  opted: boolean;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** DO NOT USE! Deprecated and ignored. */
  reasonForTermination: string;
  renewalOptions: TenancyRenewalOption[];
  rent: ObjecttenancyRent;
  /**
   * Date when tenant returns object
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  returningAt: TypeDate;
  roommates: TenancyRoommate[];
  secondaryResidence: boolean;
  /**
   * Date when tenancy starts
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  subTenants: TenancySubTenant[];
  taxable: boolean;
  tenant: ObjecttenancyTenant;
  terminatedBy: TenancyTerminatedBy;
  /**
   * Date when on which date tenancy should be terminated
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminatedOn: TypeDate;
  /**
   * Date when termination was handed in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationCreatedAt: TypeDate;
  terminationJustification: string;
  terminationLandlord: TenancyTermination;
  terminationReason: TenancyTerminationReason[];
  /**
   * Date when termination was sent by tenant
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationSentByTenantAt: TypeDate;
  terminationTenant: TenancyTermination;
  terminationType: TenancyTerminationType;
  unjustifiedUse: TenancyUnjustifiedUse;
  vacancy: boolean;
  vacancyReason: TenancyVacancyReason;
}

export interface ObjecttenancyCreateResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyDeactivateByNumericIdResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyDeactivateResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyDeleteRentAdjustmentsRequest {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  byDate: TypeDate;
  objectIds: string[];
}

export type ObjecttenancyDeleteRentAdjustmentsResponse = object;

export type ObjecttenancyDeleteResponse = object;

export interface ObjecttenancyDeposit {
  address: CommonaddressAddress;
  /** @format float */
  amount: number;
  bankAccount: string;
  bankName: string;
  bic: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  certificateReceivedAt: TypeDate;
  /** @format int32 */
  clearingNumber: number;
  depositShares: TenancyDepositShare[];
  dividedBySeveralPersons: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dueDate: TypeDate;
  insuranceCompany: string;
  note: string;
  /** @format float */
  paidAmount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  paidAt: TypeDate;
  paidOut: boolean;
  /** @format float */
  paidOutAmount: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  paidOutAt: TypeDate;
  policyNumber: string;
  type: TenancyDepositType;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validUntil: TypeDate;
}

export interface ObjecttenancyFlatRateValues {
  type: PropertyFlatRateRentComponents;
  /** @format float */
  value: number;
}

export interface ObjecttenancyGetResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyListByBillingContactIdResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyListByContactIdResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyListByIdsRequest {
  ids: string[];
}

export interface ObjecttenancyListByIdsResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyListByOwnerResponse {
  tenancies: ObjecttenancyTenancy[];
  /** @format int32 */
  totalPageCount: number;
  /** @format int32 */
  totalTenanciesCount: number;
}

export interface ObjecttenancyListCurrentByObjectIdsRequest {
  objectIds: string[];
}

export interface ObjecttenancyListCurrentByObjectIdsResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyListRequest {
  objectIds: string[];
}

export interface ObjecttenancyListResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyPublishUpdatedEventsRequest {
  ownerIds: string[];
}

export type ObjecttenancyPublishUpdatedEventsResponse = object;

export interface ObjecttenancyRemoveDocumentsResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface ObjecttenancyRent {
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  additionalCosts: number;
  additionalCostsBillingType: ObjecttenancyAdditionalCostsBillingType;
  adjustments: ObjecttenancyRentAdjustment[];
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  advancePaymentValues: ObjecttenancyAdvancePaymentValue[];
  /**
   * DO NOT USE! Deprecated. Use rent adjustments.
   * @format float
   */
  coldRent: number;
  /**
   * UNIX timestamp in seconds
   * DO NOT USE! Deprecated. Use rent adjustments.
   * @format int64
   */
  costIncreaseDate: string;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  costIncreaseType: TenancyCostIncreaseType;
  /**
   * DO NOT USE! Deprecated. Use rent adjustments.
   * @format float
   */
  costIncreaseValue: number;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  countryIndex: TenancyCountryIndex;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  dueDates: number[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  firstRentAdjustmentPossibleAt: TypeDate;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  flatRateValues: ObjecttenancyFlatRateValues[];
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  heatingCosts: number;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  inArrears: boolean;
  interval: TenancyTenancyPaymentInterval;
  /**
   * DO NOT USE! Deprecated. Use rent adjustments.
   * @format int32
   */
  monthlyRentDueBy: number;
  /** DO NOT USE! Deprecated. Use rent adjustments. */
  referenceInterestRate: TenancyReferenceInterestRate;
}

export interface ObjecttenancyRentAdjustment {
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  additionalCosts: number;
  /** DO NOT USE! Deprecated and ignored. */
  additionalCostsBillingType: ObjecttenancyAdditionalCostsBillingType;
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  additionalCostsPerMonth: number;
  additionalValues: ObjecttenancyAdditionalValues[];
  advancePaymentValues: ObjecttenancyAdvancePaymentValue[];
  /**
   * Date when this adjustment takes affect
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  byDate: TypeDate;
  calculationBasis: TenancyTenancyCalculationBasis;
  clearJustificationInitialRent: string;
  /** @format float */
  coldRent: number;
  /** @format float */
  coldRentM2PerYear: number;
  /** @format float */
  coldRentPerMonth: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  costIncreaseDate: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  costIncreasePossibleDate: TypeDate;
  costIncreaseType: TenancyCostIncreaseType;
  /** @format float */
  costIncreaseValue: number;
  countryIndex: TenancyCountryIndex;
  documentIds: string[];
  dueDates: number[];
  /** DO NOT USE! Deprecated and ignored. */
  finalized: boolean;
  flatRateValues: ObjecttenancyFlatRateValues[];
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  grossRent: number;
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  grossRentPerMonth: number;
  /**
   * Ignored on write. Only use as read value.
   * @format float
   */
  heatingCosts: number;
  inArrears: boolean;
  /** @format int32 */
  monthlyRentDueBy: number;
  referenceInterestRate: TenancyReferenceInterestRate;
  retentionOfRents: TenancyRetentionOfRent[];
}

export interface ObjecttenancyTenancy {
  activated: boolean;
  closed: boolean;
  contract: ObjecttenancyContract;
  contractAmendments: string;
  deposit: ObjecttenancyDeposit;
  /**
   * Date when tenant wants to move out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredMoveOutAt: TypeDate;
  documentIds: string[];
  earlyRightOfTerminationOptions: TenancyEarlyRightOfTerminationOption[];
  /**
   * Date when tenancy ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  familyFlat: boolean;
  finalInvoiceCreated: boolean;
  id: string;
  indexData: TenancyIndexData;
  isLatest: boolean;
  /**
   * Date when tenant liability ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liabilityEndsAt: TypeDate;
  /**
   * Date when tenant actually moved out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  movedOutAt: TypeDate;
  /**
   * Date when next tenant could possibly move in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextPossibleMoveInAt: TypeDate;
  note: string;
  /** @format int64 */
  numericId: string;
  objectId: string;
  opted: boolean;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** DO NOT USE! Deprecated and ignored. */
  reasonForTermination: string;
  renewalOptions: TenancyRenewalOption[];
  rent: ObjecttenancyRent;
  /**
   * Date when tenant returns object
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  returningAt: TypeDate;
  roommates: TenancyRoommate[];
  secondaryResidence: boolean;
  /**
   * Date when tenancy starts
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  status: TenancyTenancyStatus;
  subTenants: TenancySubTenant[];
  taxable: boolean;
  tenant: ObjecttenancyTenant;
  terminatedBy: TenancyTerminatedBy;
  /**
   * Date when on which date tenancy should be terminated
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminatedOn: TypeDate;
  /**
   * Date when termination was handed in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationCreatedAt: TypeDate;
  terminationJustification: string;
  terminationLandlord: TenancyTermination;
  terminationReason: TenancyTerminationReason[];
  /**
   * Date when termination was sent by tenant
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationSentByTenantAt: TypeDate;
  terminationTenant: TenancyTermination;
  terminationType: TenancyTerminationType;
  unjustifiedUse: TenancyUnjustifiedUse;
  /**
   * UNIX timestamp in seconds when tenancy was modified the last time
   * @format int64
   */
  updatedAt: string;
  vacancy: boolean;
  vacancyReason: TenancyVacancyReason;
}

export interface ObjecttenancyTenant {
  billingContactId: string;
  contactIds: string[];
  correspondenceContactId: string;
  guarantorContactIds: string[];
  /**
   * DO NOT USE! Deprecated and ignored. Use industryName
   * @format int32
   */
  industryCode: number;
  industryName: string;
  /** @format int32 */
  numberOfPersons: number;
  type: TenancyTenantType;
}

export interface ObjecttenancyUpdateBulkEntry {
  activated: boolean;
  closed: boolean;
  contract: ObjecttenancyContract;
  contractAmendments: string;
  deposit: ObjecttenancyDeposit;
  /**
   * Date when tenant wants to move out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredMoveOutAt: TypeDate;
  documentIds: string[];
  earlyRightOfTerminationOptions: TenancyEarlyRightOfTerminationOption[];
  /**
   * Date when tenancy ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  familyFlat: boolean;
  finalInvoiceCreated: boolean;
  id: string;
  indexData: TenancyIndexData;
  /**
   * Date when tenant liability ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liabilityEndsAt: TypeDate;
  /**
   * Date when tenant actually moved out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  movedOutAt: TypeDate;
  /**
   * Date when next tenant could possibly move in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextPossibleMoveInAt: TypeDate;
  note: string;
  objectId: string;
  opted: boolean;
  /** DO NOT USE! Deprecated and ignored. */
  reasonForTermination: string;
  renewalOptions: TenancyRenewalOption[];
  rent: ObjecttenancyRent;
  /**
   * Date when tenant returns object
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  returningAt: TypeDate;
  roommates: TenancyRoommate[];
  secondaryResidence: boolean;
  /**
   * Date when tenancy starts
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
  subTenants: TenancySubTenant[];
  taxable: boolean;
  tenant: ObjecttenancyTenant;
  terminatedBy: TenancyTerminatedBy;
  /**
   * Date when on which date tenancy should be terminated
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminatedOn: TypeDate;
  /**
   * Date when termination was handed in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationCreatedAt: TypeDate;
  terminationJustification: string;
  terminationLandlord: TenancyTermination;
  terminationReason: TenancyTerminationReason[];
  /**
   * Date when termination was sent by tenant
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationSentByTenantAt: TypeDate;
  terminationTenant: TenancyTermination;
  terminationType: TenancyTerminationType;
  unjustifiedUse: TenancyUnjustifiedUse;
  vacancyReason: TenancyVacancyReason;
}

export interface ObjecttenancyUpdateBulkRequest {
  entries: ObjecttenancyUpdateBulkEntry[];
}

export interface ObjecttenancyUpdateBulkResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface ObjecttenancyUpdateResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface PlotListByOwnerIdResponse {
  plots: PlotPlot[];
  /** @format int32 */
  totalPageCount: number;
  /** @format int32 */
  totalPlotCount: number;
}

export interface PlotListByPropertyIdResponse {
  plots: PlotPlot[];
}

export interface PlotPlot {
  /** @format float */
  cadastralValue: number;
  category: PlotPlotCategory;
  constructionZone: string;
  documentIds: string[];
  easements: string;
  egrid: string;
  formOfOwnership: string;
  id: string;
  inventories: string;
  landRegisterNumber: string;
  loads: string;
  noiseSensitivity: string;
  note: string;
  /** @format int64 */
  numericId: string;
  operation: PlotPlotOperation;
  /** @format int64 */
  ownerId: string;
  /** @format float */
  plotArea: number;
  plotType: string;
  priorityNotices: string;
  /** @format float */
  promissoryNote: number;
  propertyId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  purchaseDate: TypeDate;
  /** @format float */
  purchasePrice: number;
  realEstateRights: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  reviewStrategyDate: TypeDate;
  strategy: PlotPlotStrategy;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  termUntil: TypeDate;
  utilizationZone: string;
}

/** @default "PLOT_CATEGORY_UNDEFINED" */
export enum PlotPlotCategory {
  PLOT_CATEGORY_UNDEFINED = "PLOT_CATEGORY_UNDEFINED",
  PLOT_CATEGORY_PLOT = "PLOT_CATEGORY_PLOT",
  PLOT_CATEGORY_PURCHASE_CONTRACT = "PLOT_CATEGORY_PURCHASE_CONTRACT",
  PLOT_CATEGORY_BUILDING_RIGHT = "PLOT_CATEGORY_BUILDING_RIGHT",
  PLOT_CATEGORY_DEVELOPMENT_AGREEMENT = "PLOT_CATEGORY_DEVELOPMENT_AGREEMENT",
  PLOT_CATEGORY_UNSOLD_CONDOMINIUM = "PLOT_CATEGORY_UNSOLD_CONDOMINIUM",
}

export interface PlotPlotCreation {
  /** @format float */
  cadastralValue: number;
  category: PlotPlotCategory;
  constructionZone: string;
  documentIds: string[];
  easements: string;
  egrid: string;
  formOfOwnership: string;
  inventories: string;
  landRegisterNumber: string;
  loads: string;
  noiseSensitivity: string;
  note: string;
  operation: PlotPlotOperation;
  /** @format int64 */
  ownerId: string;
  /** @format float */
  plotArea: number;
  plotType: string;
  priorityNotices: string;
  /** @format float */
  promissoryNote: number;
  propertyId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  purchaseDate: TypeDate;
  /** @format float */
  purchasePrice: number;
  realEstateRights: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  reviewStrategyDate: TypeDate;
  strategy: PlotPlotStrategy;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  termUntil: TypeDate;
  utilizationZone: string;
}

/** @default "PLOT_OPERATION_UNDEFINED" */
export enum PlotPlotOperation {
  PLOT_OPERATION_UNDEFINED = "PLOT_OPERATION_UNDEFINED",
  PLOT_OPERATION_WITH_OPERATION = "PLOT_OPERATION_WITH_OPERATION",
  PLOT_OPERATION_WITHOUT_OPERATION = "PLOT_OPERATION_WITHOUT_OPERATION",
}

/** @default "PLOT_STRATEGY_UNDEFINED" */
export enum PlotPlotStrategy {
  PLOT_STRATEGY_UNDEFINED = "PLOT_STRATEGY_UNDEFINED",
  PLOT_STRATEGY_CONTINUE_WITHOUT_RENOVATION = "PLOT_STRATEGY_CONTINUE_WITHOUT_RENOVATION",
  PLOT_STRATEGY_MAINTAIN = "PLOT_STRATEGY_MAINTAIN",
  PLOT_STRATEGY_REPAIR = "PLOT_STRATEGY_REPAIR",
  PLOT_STRATEGY_REPLACEMENT_NEW_CONSTRUCTION = "PLOT_STRATEGY_REPLACEMENT_NEW_CONSTRUCTION",
  PLOT_STRATEGY_SALE = "PLOT_STRATEGY_SALE",
}

export interface PlotPlotUpdate {
  /** @format float */
  cadastralValue: number;
  category: PlotPlotCategory;
  constructionZone: string;
  documentIds: string[];
  easements: string;
  egrid: string;
  formOfOwnership: string;
  id: string;
  inventories: string;
  landRegisterNumber: string;
  loads: string;
  noiseSensitivity: string;
  note: string;
  operation: PlotPlotOperation;
  /** @format float */
  plotArea: number;
  plotType: string;
  priorityNotices: string;
  /** @format float */
  promissoryNote: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  purchaseDate: TypeDate;
  /** @format float */
  purchasePrice: number;
  realEstateRights: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  reviewStrategyDate: TypeDate;
  strategy: PlotPlotStrategy;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  termUntil: TypeDate;
  utilizationZone: string;
}

/**
 * - ADDITIONAL_RENT_COMPONENT_RENT: Added for COOZ-10074
 * @default "ADDITIONAL_RENT_COMPONENT_UNDEFINED"
 */
export enum PropertyAdditionalRentComponents {
  ADDITIONAL_RENT_COMPONENT_UNDEFINED = "ADDITIONAL_RENT_COMPONENT_UNDEFINED",
  ADDITIONAL_RENT_COMPONENT_RENT_REDUCTION = "ADDITIONAL_RENT_COMPONENT_RENT_REDUCTION",
  ADDITIONAL_RENT_COMPONENT_ADDED_VALUE_E_CHARGING_STATION = "ADDITIONAL_RENT_COMPONENT_ADDED_VALUE_E_CHARGING_STATION",
  ADDITIONAL_RENT_COMPONENT_TENANT_IMPROVEMENT = "ADDITIONAL_RENT_COMPONENT_TENANT_IMPROVEMENT",
  ADDITIONAL_RENT_COMPONENT_AMORTIZATION = "ADDITIONAL_RENT_COMPONENT_AMORTIZATION",
  ADDITIONAL_RENT_COMPONENT_RENT = "ADDITIONAL_RENT_COMPONENT_RENT",
}

/** @default "ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED" */
export enum PropertyAdvancePaymentRentComponents {
  ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED = "ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED",
  ADVANCE_PAYMENT_RENT_COMPONENT_GENERAL_ELECTRICITY = "ADVANCE_PAYMENT_RENT_COMPONENT_GENERAL_ELECTRICITY",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_ELECTRICITY_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_ELECTRICITY_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_HOT_WATER = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_HOT_WATER",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING",
  ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_TV = "ADVANCE_PAYMENT_RENT_COMPONENT_TV",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_MAINTENANCE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_MAINTENANCE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_ELEVATOR = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_ELEVATOR",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ADDITIONAL_COSTS = "ADVANCE_PAYMENT_RENT_COMPONENT_ADDITIONAL_COSTS",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_ADDITIONAL_COSTS = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_ADDITIONAL_COSTS",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELEVATOR = "ADVANCE_PAYMENT_RENT_COMPONENT_ELEVATOR",
  ADVANCE_PAYMENT_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION = "ADVANCE_PAYMENT_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION",
  ADVANCE_PAYMENT_RENT_COMPONENT_SEE_CONTRACT = "ADVANCE_PAYMENT_RENT_COMPONENT_SEE_CONTRACT",
  ADVANCE_PAYMENT_RENT_COMPONENT_E_CHARGING_STATION = "ADVANCE_PAYMENT_RENT_COMPONENT_E_CHARGING_STATION",
}

/** @default "FLAT_RATE_RENT_COMPONENT_UNDEFINED" */
export enum PropertyFlatRateRentComponents {
  FLAT_RATE_RENT_COMPONENT_UNDEFINED = "FLAT_RATE_RENT_COMPONENT_UNDEFINED",
  FLAT_RATE_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING = "FLAT_RATE_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING",
  FLAT_RATE_RENT_COMPONENT_HEATING_HOT_WATER = "FLAT_RATE_RENT_COMPONENT_HEATING_HOT_WATER",
  FLAT_RATE_RENT_COMPONENT_HEATING = "FLAT_RATE_RENT_COMPONENT_HEATING",
  FLAT_RATE_RENT_COMPONENT_GARBAGE = "FLAT_RATE_RENT_COMPONENT_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ELEVATOR = "FLAT_RATE_RENT_COMPONENT_ELEVATOR",
  FLAT_RATE_RENT_COMPONENT_TV = "FLAT_RATE_RENT_COMPONENT_TV",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_GARBAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE = "FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE",
  FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE_GARBAGE = "FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ADDITIONAL_COSTS = "FLAT_RATE_RENT_COMPONENT_ADDITIONAL_COSTS",
  FLAT_RATE_RENT_COMPONENT_WATER = "FLAT_RATE_RENT_COMPONENT_WATER",
  FLAT_RATE_RENT_COMPONENT_MAINTENANCE = "FLAT_RATE_RENT_COMPONENT_MAINTENANCE",
  FLAT_RATE_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION = "FLAT_RATE_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION",
  FLAT_RATE_RENT_COMPONENT_DISH_WASHER = "FLAT_RATE_RENT_COMPONENT_DISH_WASHER",
  FLAT_RATE_RENT_COMPONENT_FREEZER = "FLAT_RATE_RENT_COMPONENT_FREEZER",
  FLAT_RATE_RENT_COMPONENT_SEE_CONTRACT = "FLAT_RATE_RENT_COMPONENT_SEE_CONTRACT",
  FLAT_RATE_RENT_COMPONENT_BUDGET_EXPECTATIONS = "FLAT_RATE_RENT_COMPONENT_BUDGET_EXPECTATIONS",
  FLAT_RATE_RENT_COMPONENT_RENOVATION_FUND = "FLAT_RATE_RENT_COMPONENT_RENOVATION_FUND",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY1 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_1",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY2 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_2",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY3 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_3",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS1 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_1",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS2 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_2",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS3 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_3",
}

export interface Propertyv2AddDocumentsByNumericIdResponse {
  property: Propertyv2Property;
}

export interface Propertyv2CountResponse {
  /** @format int32 */
  count: number;
}

/** @default "PROPERTY_DEVELOPMENT_UNDEFINED" */
export enum Propertyv2Development {
  PROPERTY_DEVELOPMENT_UNDEFINED = "PROPERTY_DEVELOPMENT_UNDEFINED",
  PROPERTY_DEVELOPMENT_FULL = "PROPERTY_DEVELOPMENT_FULL",
  PROPERTY_DEVELOPMENT_PARTIAL = "PROPERTY_DEVELOPMENT_PARTIAL",
  PROPERTY_DEVELOPMENT_UNDEVELOPED = "PROPERTY_DEVELOPMENT_UNDEVELOPED",
}

export type Propertyv2FinishOnboardingResponse = object;

export interface Propertyv2ListByBuildingIdsResponse {
  properties: Propertyv2Property[];
}

export interface Propertyv2ListFilterOptionsResponse {
  options: V2PropertyFilterOption[];
}

/** @default "OPTED_PORTION_KEY_UNDEFINED" */
export enum Propertyv2OptedPortionKey {
  OPTED_PORTION_KEY_UNDEFINED = "OPTED_PORTION_KEY_UNDEFINED",
  OPTEDPORTIONKEYM2 = "OPTED_PORTION_KEY_M2",
  OPTEDPORTIONKEYM3 = "OPTED_PORTION_KEY_M3",
  OPTED_PORTION_KEY_VALUE_RATIO = "OPTED_PORTION_KEY_VALUE_RATIO",
  OPTED_PORTION_KEY_TV = "OPTED_PORTION_KEY_TV",
  OPTED_PORTION_KEY_ELEVATOR = "OPTED_PORTION_KEY_ELEVATOR",
  OPTED_PORTION_KEY_LOCATION_COMPENSATION = "OPTED_PORTION_KEY_LOCATION_COMPENSATION",
  OPTED_PORTION_KEY_UNIT = "OPTED_PORTION_KEY_UNIT",
  OPTED_PORTION_KEY_NUMBER_OF_INHABITANTS = "OPTED_PORTION_KEY_NUMBER_OF_INHABITANTS",
  OPTED_PORTION_KEY_SHARE = "OPTED_PORTION_KEY_SHARE",
}

export interface Propertyv2Property {
  additionalRentComponents: V2AdditionalRentComponentEntry[];
  /** Only zip, city and state are required and set */
  address: CommonaddressAddress;
  advancePaymentRentComponents: V2AdvancePaymentRentComponentEntry[];
  assignees: V2Assignees;
  bankInfo: V2BankInfo[];
  buildingIds: string[];
  constructionZone: string;
  development: Propertyv2Development;
  documentIds: string[];
  egrid: string;
  flatRateRentComponents: V2FlatRateRentComponentEntry[];
  id: string;
  imageMediaId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  keyDateServiceChargeSettlement: TypeDate;
  landRegisterNumber: string;
  name: string;
  note: string;
  /** @format int64 */
  numericId: string;
  onboardingFinished: boolean;
  opted: boolean;
  optedPortionKey: Propertyv2OptedPortionKey;
  /**
   * The account ID of the owner
   * @format int64
   */
  ownerId: string;
  /** @format float */
  plotArea: number;
  /** @format int64 */
  propertyValue: string;
  transferToAccounting: boolean;
  type: Propertyv2PropertyType;
}

/** @default "PROPERTY_TYPE_UNDEFINED" */
export enum Propertyv2PropertyType {
  PROPERTY_TYPE_UNDEFINED = "PROPERTY_TYPE_UNDEFINED",
  PROPERTY_TYPE_RENTAL = "PROPERTY_TYPE_RENTAL",
  PROPERTY_TYPE_CONDOMINIUM_OWNERSHIP = "PROPERTY_TYPE_CONDOMINIUM_OWNERSHIP",
  PROPERTY_TYPE_COOPERATIVE = "PROPERTY_TYPE_COOPERATIVE",
}

export interface Propertyv2SetAccountingAssigneeRequest {
  contactIdAssigneeAccounting: string;
  ids: string[];
}

export type Propertyv2SetAccountingAssigneeResponse = object;

export interface Propertyv2SetAdminAssigneeRequest {
  contactIdAssigneeAdministration: string;
  ids: string[];
}

export type Propertyv2SetAdminAssigneeResponse = object;

export interface Propertyv2SetAssetAssigneeRequest {
  contactIdAssigneeAsset: string;
  ids: string[];
}

export type Propertyv2SetAssetAssigneeResponse = object;

export interface Propertyv2SetOwnerAssigneeRequest {
  contactIdAssigneeOwner: string;
  ids: string[];
}

export type Propertyv2SetOwnerAssigneeResponse = object;

export interface Propertyv2TransferToAccountingRequest {
  ids: string[];
}

export type Propertyv2TransferToAccountingResponse = object;

/** @default "COMPOSITION_LINES_OR_COLUMNS_UNDEFINED" */
export enum RentalIndexCompositionLinesOrColumns {
  COMPOSITION_LINES_OR_COLUMNS_UNDEFINED = "COMPOSITION_LINES_OR_COLUMNS_UNDEFINED",
  COMPOSITION_LINES_OR_COLUMNS_VERTICAL = "COMPOSITION_LINES_OR_COLUMNS_VERTICAL",
  COMPOSITION_LINES_OR_COLUMNS_HORIZONTAL = "COMPOSITION_LINES_OR_COLUMNS_HORIZONTAL",
  COMPOSITION_LINES_OR_COLUMNS_VERTICAL_WITH_DETAILS = "COMPOSITION_LINES_OR_COLUMNS_VERTICAL_WITH_DETAILS",
}

/** @default "COMPOSITION_TYPE_UNDEFINED" */
export enum RentalIndexCompositionType {
  COMPOSITION_TYPE_UNDEFINED = "COMPOSITION_TYPE_UNDEFINED",
  COMPOSITION_TYPE_SEPARATELY = "COMPOSITION_TYPE_SEPARATELY",
  COMPOSITION_TYPE_CONSOLIDATE = "COMPOSITION_TYPE_CONSOLIDATE",
}

export interface RentalIndexRenderPdfRequest {
  buildingBreakPage: boolean;
  buildingIds: string[];
  displayHeaderEveryPage: boolean;
  displayPropertySummary: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  hideInactiveObjects: boolean;
  language: LanguagePreferredLanguage;
  sortingType: RentalIndexSortingType;
  /** If fixed date leave empty */
  startDate: TypeDate;
  withoutTenantsNames: boolean;
}

export interface RentalIndexRenderPdfResponse {
  /** @format byte */
  file: string;
}

export interface RentalIndexRentalIndexTemplate {
  compositionLinesOrColumns: RentalIndexCompositionLinesOrColumns;
  compositionType: RentalIndexCompositionType;
  fields: RentalIndexTemplateField[];
  id: string;
  language: LanguagePreferredLanguage;
  name: string;
  onlyMovingInOutTenancies: boolean;
  /** @format int64 */
  ownerId: string;
  sortingType: RentalIndexSortingType;
  tenancyType: RentalIndexTenancyType;
}

/** @default "SORTING_TYPE_UNDEFINED" */
export enum RentalIndexSortingType {
  SORTING_TYPE_UNDEFINED = "SORTING_TYPE_UNDEFINED",
  SORTING_TYPE_OBJECT_ID = "SORTING_TYPE_OBJECT_ID",
  SORTING_TYPE_OBJECT_NUMBER = "SORTING_TYPE_OBJECT_NUMBER",
  SORTING_TYPE_STANDARD = "SORTING_TYPE_STANDARD",
}

export interface RentalIndexTemplateField {
  name: string;
  /** @format int32 */
  order: number;
}

/** @default "TENANCY_TYPE_UNDEFINED" */
export enum RentalIndexTenancyType {
  TENANCY_TYPE_UNDEFINED = "TENANCY_TYPE_UNDEFINED",
  TENANCY_TYPE_ALL = "TENANCY_TYPE_ALL",
  TENANCY_TYPE_RENTED = "TENANCY_TYPE_RENTED",
  TENANCY_TYPE_VACANT = "TENANCY_TYPE_VACANT",
}

export interface RoomRoomCreation {
  dimensions: RoomRoomDimensions;
  documentIds: string[];
  imageMediaIds: string[];
  name: string;
  note: string;
  /** @format int32 */
  order: number;
  /** @format int64 */
  ownerId: string;
  referenceId: string;
}

export interface RoomRoomDimensions {
  /** @format float */
  area: number;
  /** @format float */
  height: number;
  /** @format float */
  length: number;
  /** @format float */
  volume: number;
  /** @format float */
  width: number;
}

export interface RoomRoomUpdate {
  dimensions: RoomRoomDimensions;
  documentIds: string[];
  id: string;
  imageMediaIds: string[];
  name: string;
  note: string;
  /** @format int32 */
  order: number;
}

/** @default "UNDEFINED_SCOPE" */
export enum ShareShareScope {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type TenancyAddDepositConfirmationResponse = object;

export type TenancyAddDepositPaymentSlipResponse = object;

export interface TenancyCloseRequest {
  ids: string[];
}

export type TenancyCloseResponse = object;

/** @default "UNDEFINED_CONTRACT_TYPE" */
export enum TenancyContractType {
  UNDEFINED_CONTRACT_TYPE = "UNDEFINED_CONTRACT_TYPE",
  INDEFINITE = "INDEFINITE",
  LIMITED = "LIMITED",
  INDIVIDUAL = "INDIVIDUAL",
}

/** @default "COST_INCREASE_TYPE_UNDEFINED" */
export enum TenancyCostIncreaseType {
  COST_INCREASE_TYPE_UNDEFINED = "COST_INCREASE_TYPE_UNDEFINED",
  COST_INCREASE_TYPE_FLAT_RATE = "COST_INCREASE_TYPE_FLAT_RATE",
  COST_INCREASE_TYPE_INDEX = "COST_INCREASE_TYPE_INDEX",
}

export interface TenancyCountryIndex {
  /** @format int64 */
  baseDate: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  /** @format float */
  inflation: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  possibleDate: TypeDate;
  /** @format float */
  possibleInflation: number;
}

export interface TenancyDepositShare {
  /** @format float */
  amount: number;
  contactId: string;
}

/** @default "DEPOSIT_TYPE_UNDEFINED" */
export enum TenancyDepositType {
  DEPOSIT_TYPE_UNDEFINED = "DEPOSIT_TYPE_UNDEFINED",
  DEPOSIT_TYPE_NO_DEPOSIT = "DEPOSIT_TYPE_NO_DEPOSIT",
  DEPOSIT_TYPE_DEPOT = "DEPOSIT_TYPE_DEPOT",
  DEPOSIT_TYPE_INSURANCE_GUARANTEE = "DEPOSIT_TYPE_INSURANCE_GUARANTEE",
  DEPOSIT_TYPE_COOPERATIVE_SHARE = "DEPOSIT_TYPE_COOPERATIVE_SHARE",
  DEPOSIT_TYPE_CASH_PAYMENT = "DEPOSIT_TYPE_CASH_PAYMENT",
  DEPOSIT_TYPE_BANK_GUARANTEE = "DEPOSIT_TYPE_BANK_GUARANTEE",
  DEPOSIT_TYPE_COLLECTIVE_INSURANCE = "DEPOSIT_TYPE_COLLECTIVE_INSURANCE",
  DEPOSIT_TYPE_COMPULSORY_SHARE_CERTIFICATES = "DEPOSIT_TYPE_COMPULSORY_SHARE_CERTIFICATES",
}

export interface TenancyEarlyRightOfTerminationOption {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  exerciseUntil: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  until: TypeDate;
}

export interface TenancyHasActivatedTenancyEntry {
  hasActivatedTenancy: boolean;
  objectId: string;
}

export interface TenancyHasActivatedTenancyRequest {
  objectIds: string[];
}

export interface TenancyHasActivatedTenancyResponse {
  entries: TenancyHasActivatedTenancyEntry[];
}

export interface TenancyHasAdditionalRentComponentInUseResponse {
  inUse: boolean;
}

export interface TenancyHasAdvancePaymentRentComponentInUseResponse {
  inUse: boolean;
}

export interface TenancyHasFlatRateRentComponentInUseResponse {
  inUse: boolean;
}

export interface TenancyHasTenanciesWithContactIdsResponse {
  existing: boolean;
}

export interface TenancyIndexData {
  additionalCostsAdjustmentAllowed: boolean;
  belowInitialRentAllowed: boolean;
  /** @format float */
  contractPercentImputedAtIndex: number;
  /** @format float */
  maximumRate: number;
  /** @format int32 */
  referenceMonthForIndex: number;
  rentAdjustmentAdditionalBenefit: boolean;
  /** @format int32 */
  rentAdjustmentByMonths: number;
  /** @format int32 */
  rentAdjustmentByPoints: number;
  rentAdjustmentMonths: number[];
  rentAdjustmentNotification: TenancyRentAdjustmentNotification;
}

export interface TenancyListByDateAndObjectIdsRequest {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate: TypeDate;
  includeTenancies: boolean;
  includeVacancies: boolean;
  objectIds: string[];
  /** If fixed date leave empty */
  startDate: TypeDate;
}

export interface TenancyListByDateAndObjectIdsResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface TenancyListByGuarantorResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface TenancyListByTenantResponse {
  tenancies: ObjecttenancyTenancy[];
}

export interface TenancyReferenceInterestRate {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  date: TypeDate;
  /** @format float */
  rate: number;
  /** @format float */
  ratePossible: number;
}

export interface TenancyRenewalOption {
  automaticExtending: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  exerciseUntil: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  from: TypeDate;
  type: TenancyRenewalOptionType;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  until: TypeDate;
  used: boolean;
}

/** @default "RENEWAL_OPTION_TYPE_UNDEFINED" */
export enum TenancyRenewalOptionType {
  RENEWAL_OPTION_TYPE_UNDEFINED = "RENEWAL_OPTION_TYPE_UNDEFINED",
  RENEWAL_OPTION_TYPE_REAL = "RENEWAL_OPTION_TYPE_REAL",
  RENEWAL_OPTION_TYPE_UNREAL = "RENEWAL_OPTION_TYPE_UNREAL",
}

export interface TenancyRentAdjustmentNotification {
  unit: TenancyRentAdjustmentNotificationUnit;
  /** @format int32 */
  value: number;
}

/** @default "RENT_ADJUSTMENT_NOTIFICATION_DAYS" */
export enum TenancyRentAdjustmentNotificationUnit {
  RENT_ADJUSTMENT_NOTIFICATION_DAYS = "RENT_ADJUSTMENT_NOTIFICATION_DAYS",
  RENT_ADJUSTMENT_NOTIFICATION_MONTHS = "RENT_ADJUSTMENT_NOTIFICATION_MONTHS",
}

/** @default "RENT_TYPE_UNDEFINED" */
export enum TenancyRentType {
  RENT_TYPE_UNDEFINED = "RENT_TYPE_UNDEFINED",
  RENT_TYPE_VMWG = "RENT_TYPE_VMWG",
  RENT_TYPE_CONDOMINIUM_OWNERSHIP = "RENT_TYPE_CONDOMINIUM_OWNERSHIP",
  RENT_TYPE_INDEX = "RENT_TYPE_INDEX",
  RENT_TYPE_GRADUATED = "RENT_TYPE_GRADUATED",
  RENT_TYPE_TURNOVER = "RENT_TYPE_TURNOVER",
  RENT_TYPE_SUBSIDIZES = "RENT_TYPE_SUBSIDIZES",
  RENT_TYPE_NOT_VMWG = "RENT_TYPE_NOT_VMWG",
}

export interface TenancyRetentionOfRent {
  /** @format float */
  actual: number;
  inPercent: boolean;
  /** @format float */
  possible: number;
  remark: string;
  type: TenancyRetentionOfRentType;
}

/** @default "RETENTION_OF_RENT_INSUFFICIENT_GROSS_RENT" */
export enum TenancyRetentionOfRentType {
  RETENTION_OF_RENT_INSUFFICIENT_GROSS_RENT = "RETENTION_OF_RENT_INSUFFICIENT_GROSS_RENT",
  RETENTION_OF_RENT_INSUFFICIENT_NET_RETURN = "RETENTION_OF_RENT_INSUFFICIENT_NET_RETURN",
  RETENTION_OF_RENT_VALUE_ENHANCING_INVESTMENTS = "RETENTION_OF_RENT_VALUE_ENHANCING_INVESTMENTS",
  RETENTION_OF_RENT_ADJUSTMENT_NEIGHBORHOOD = "RETENTION_OF_RENT_ADJUSTMENT_NEIGHBORHOOD",
  RETENTION_OF_RENT_NOT_FULLY_UTILIZED_RENT_INCREASE = "RETENTION_OF_RENT_NOT_FULLY_UTILIZED_RENT_INCREASE",
}

export interface TenancyRoommate {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  birthday: TypeDate;
  firstName: string;
  lastName: string;
}

export type TenancySetDepositInsurancePolicyResponse = object;

export type TenancySetDepositPayoutResponse = object;

export interface TenancySetTerminationResponse {
  tenancy: ObjecttenancyTenancy;
}

export interface TenancySubTenant {
  contactIds: string[];
  /**
   * Date when subtenancy ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt: TypeDate;
  /**
   * Date when subtenancy starts
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt: TypeDate;
}

export interface TenancySumRentValuesResponse {
  /**
   * Sum of cold rent values of real (non-vacancy) tenancies
   * @format float
   */
  realColdRent: number;
  /**
   * Sum of cold rent values of vacancy tenancies
   * @format float
   */
  vacancyColdRent: number;
}

/** @default "TACIT_CONTRACT_RENEWAL_UNDEFINED" */
export enum TenancyTacitContractRenewal {
  TACIT_CONTRACT_RENEWAL_UNDEFINED = "TACIT_CONTRACT_RENEWAL_UNDEFINED",
  TACITCONTRACTRENEWAL1YEAR = "TACIT_CONTRACT_RENEWAL_1_YEAR",
  TACITCONTRACTRENEWAL2YEAR = "TACIT_CONTRACT_RENEWAL_2_YEAR",
  TACITCONTRACTRENEWAL3YEAR = "TACIT_CONTRACT_RENEWAL_3_YEAR",
  TACITCONTRACTRENEWAL4YEAR = "TACIT_CONTRACT_RENEWAL_4_YEAR",
  TACITCONTRACTRENEWAL5YEAR = "TACIT_CONTRACT_RENEWAL_5_YEAR",
}

/** @default "TENANCY_CALCULATION_BASIS_DEFAULT" */
export enum TenancyTenancyCalculationBasis {
  TENANCY_CALCULATION_BASIS_DEFAULT = "TENANCY_CALCULATION_BASIS_DEFAULT",
  TENANCYCALCULATIONBASISM2YEAR = "TENANCY_CALCULATION_BASIS_M2_YEAR",
}

/** @default "UNDEFINED_TENANCY_PAYMENT_INTERVAL" */
export enum TenancyTenancyPaymentInterval {
  UNDEFINED_TENANCY_PAYMENT_INTERVAL = "UNDEFINED_TENANCY_PAYMENT_INTERVAL",
  TENANCY_PAYMENT_INTERVAL_MONTHLY = "TENANCY_PAYMENT_INTERVAL_MONTHLY",
  TENANCY_PAYMENT_INTERVAL_QUARTERLY = "TENANCY_PAYMENT_INTERVAL_QUARTERLY",
  TENANCY_PAYMENT_INTERVAL_HALF_YEARLY = "TENANCY_PAYMENT_INTERVAL_HALF_YEARLY",
  TENANCY_PAYMENT_INTERVAL_YEARLY = "TENANCY_PAYMENT_INTERVAL_YEARLY",
}

/** @default "TENANCY_STATUS_NOT_ACTIVATED" */
export enum TenancyTenancyStatus {
  TENANCY_STATUS_NOT_ACTIVATED = "TENANCY_STATUS_NOT_ACTIVATED",
  TENANCY_STATUS_CURRENT = "TENANCY_STATUS_CURRENT",
  TENANCY_STATUS_CURRENT_TERMINATED = "TENANCY_STATUS_CURRENT_TERMINATED",
  TENANCY_STATUS_TERMINATED = "TENANCY_STATUS_TERMINATED",
  TENANCY_STATUS_CLOSED = "TENANCY_STATUS_CLOSED",
  TENANCY_STATUS_FUTURE = "TENANCY_STATUS_FUTURE",
}

/** @default "UNDEFINED_TENANT_TYPE" */
export enum TenancyTenantType {
  UNDEFINED_TENANT_TYPE = "UNDEFINED_TENANT_TYPE",
  EXTERNAL_TENANT_TYPE = "EXTERNAL_TENANT_TYPE",
  OWN_TENANT_TYPE = "OWN_TENANT_TYPE",
  CORPORATE_TENANT_TYPE = "CORPORATE_TENANT_TYPE",
}

/** @default "TERMINATED_BY_UNDEFINED" */
export enum TenancyTerminatedBy {
  TERMINATED_BY_UNDEFINED = "TERMINATED_BY_UNDEFINED",
  TERMINATED_BY_LANDLORD = "TERMINATED_BY_LANDLORD",
  TERMINATED_BY_TENANT = "TERMINATED_BY_TENANT",
}

export interface TenancyTermination {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  earliestDate: TypeDate;
  /**
   * Notice period in months
   * @format int32
   */
  periodInMonths: number;
  /** On which months the contract can be terminated (1=January) */
  possibleMonths: number[];
  tacitContractRenewal: TenancyTacitContractRenewal;
}

/** @default "TERMINATION_REASON_UNDEFINED" */
export enum TenancyTerminationReason {
  TERMINATION_REASON_UNDEFINED = "TERMINATION_REASON_UNDEFINED",
  TERMINATION_REASON_IMPORTANT_REASONS = "TERMINATION_REASON_IMPORTANT_REASONS",
  TERMINATION_REASON_DEATH = "TERMINATION_REASON_DEATH",
  TERMINATION_REASON_TOO_SMALL = "TERMINATION_REASON_TOO_SMALL",
  TERMINATION_REASON_TOO_BIG = "TERMINATION_REASON_TOO_BIG",
  TERMINATION_REASON_TOO_EXPENSIVE = "TERMINATION_REASON_TOO_EXPENSIVE",
  TERMINATION_REASON_IMMISSIONS_TOO_HIGH = "TERMINATION_REASON_IMMISSIONS_TOO_HIGH",
  TERMINATION_REASON_FAMILY = "TERMINATION_REASON_FAMILY",
  TERMINATION_REASON_JOB = "TERMINATION_REASON_JOB",
  TERMINATION_REASON_VIOLATION_OF_DUE_DILIGENCE = "TERMINATION_REASON_VIOLATION_OF_DUE_DILIGENCE",
  TERMINATION_REASON_BANKRUPTCY_OF_TENANT = "TERMINATION_REASON_BANKRUPTCY_OF_TENANT",
  TERMINATION_REASON_OWN_NEED = "TERMINATION_REASON_OWN_NEED",
  TERMINATION_REASON_RENOVATION = "TERMINATION_REASON_RENOVATION",
  TERMINATION_REASON_TEMPORARY_CONTRACT = "TERMINATION_REASON_TEMPORARY_CONTRACT",
  TERMINATION_REASON_ARREARS = "TERMINATION_REASON_ARREARS",
  TERMINATION_REASON_ECONOMIC_REASONS = "TERMINATION_REASON_ECONOMIC_REASONS",
  TERMINATION_REASON_AREA_TOO_SMALL = "TERMINATION_REASON_AREA_TOO_SMALL",
  TERMINATION_REASON_AREA_TOO_LARGE = "TERMINATION_REASON_AREA_TOO_LARGE",
  TERMINATION_REASON_HOME_PURCHASE = "TERMINATION_REASON_HOME_PURCHASE",
  TERMINATION_REASON_SALE = "TERMINATION_REASON_SALE",
  TERMINATION_REASON_UNAUTHORISED_SUBLETTING = "TERMINATION_REASON_UNAUTHORISED_SUBLETTING",
  TERMINATION_REASON_PAYMENT_DEFAULT = "TERMINATION_REASON_PAYMENT_DEFAULT",
  TERMINATION_REASON_POSTSCRIPT = "TERMINATION_REASON_POSTSCRIPT",
  TERMINATION_REASON_INTERNAL_CHANGE = "TERMINATION_REASON_INTERNAL_CHANGE",
  TERMINATION_REASON_CONTRACT_OVERRIDE = "TERMINATION_REASON_CONTRACT_OVERRIDE",
  TERMINATION_REASON_COMPLETE_RENOVATION = "TERMINATION_REASON_COMPLETE_RENOVATION",
}

/** @default "TERMINATION_TYPE_UNDEFINED" */
export enum TenancyTerminationType {
  TERMINATION_TYPE_UNDEFINED = "TERMINATION_TYPE_UNDEFINED",
  TERMINATION_TYPE_TERM = "TERMINATION_TYPE_TERM",
  TERMINATION_TYPE_OFF_TERM = "TERMINATION_TYPE_OFF_TERM",
  TERMINATION_TYPE_EXCEPTIONAL = "TERMINATION_TYPE_EXCEPTIONAL",
}

export interface TenancyUnjustifiedUse {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  from: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  until: TypeDate;
}

/** @default "VACANCY_REASON_UNDEFINED" */
export enum TenancyVacancyReason {
  VACANCY_REASON_UNDEFINED = "VACANCY_REASON_UNDEFINED",
  VACANCY_REASON_NO_NEXT_TENANT = "VACANCY_REASON_NO_NEXT_TENANT",
  VACANCY_REASON_INITIAL_LETTING = "VACANCY_REASON_INITIAL_LETTING",
  VACANCY_REASON_RENOVATION = "VACANCY_REASON_RENOVATION",
  VACANCY_REASON_TEMPORARY_TENANCY = "VACANCY_REASON_TEMPORARY_TENANCY",
  VACANCY_REASON_SALE = "VACANCY_REASON_SALE",
  VACANCYREASONTERMINATIONUNDEROR257D = "VACANCY_REASON_TERMINATION_UNDER_OR_257D",
  VACANCY_REASON_EVICTION = "VACANCY_REASON_EVICTION",
}

export interface V2AddBuildingResponse {
  property: Propertyv2Property;
}

/**
 * - ADDITIONAL_RENT_COMPONENT_RENT: Added for COOZ-10074
 * @default "ADDITIONAL_RENT_COMPONENT_UNDEFINED"
 */
export enum V2AdditionalRentComponent {
  ADDITIONAL_RENT_COMPONENT_UNDEFINED = "ADDITIONAL_RENT_COMPONENT_UNDEFINED",
  ADDITIONAL_RENT_COMPONENT_RENT_REDUCTION = "ADDITIONAL_RENT_COMPONENT_RENT_REDUCTION",
  ADDITIONAL_RENT_COMPONENT_ADDED_VALUE_E_CHARGING_STATION = "ADDITIONAL_RENT_COMPONENT_ADDED_VALUE_E_CHARGING_STATION",
  ADDITIONAL_RENT_COMPONENT_TENANT_IMPROVEMENT = "ADDITIONAL_RENT_COMPONENT_TENANT_IMPROVEMENT",
  ADDITIONAL_RENT_COMPONENT_AMORTIZATION = "ADDITIONAL_RENT_COMPONENT_AMORTIZATION",
  ADDITIONAL_RENT_COMPONENT_RENT = "ADDITIONAL_RENT_COMPONENT_RENT",
}

export interface V2AdditionalRentComponentEntry {
  description: string;
  inactive: boolean;
  rentComponent: V2AdditionalRentComponent;
}

/** @default "ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED" */
export enum V2AdvancePaymentRentComponent {
  ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED = "ADVANCE_PAYMENT_RENT_COMPONENT_UNDEFINED",
  ADVANCE_PAYMENT_RENT_COMPONENT_GENERAL_ELECTRICITY = "ADVANCE_PAYMENT_RENT_COMPONENT_GENERAL_ELECTRICITY",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_ELECTRICITY_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE_ELECTRICITY_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_HOT_WATER = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_HOT_WATER",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING",
  ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_GARBAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_TV = "ADVANCE_PAYMENT_RENT_COMPONENT_TV",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_MAINTENANCE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_MAINTENANCE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_ELEVATOR = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE_ELEVATOR",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_GARBAGE = "ADVANCE_PAYMENT_RENT_COMPONENT_WATER_SEWAGE_GARBAGE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ADDITIONAL_COSTS = "ADVANCE_PAYMENT_RENT_COMPONENT_ADDITIONAL_COSTS",
  ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_ADDITIONAL_COSTS = "ADVANCE_PAYMENT_RENT_COMPONENT_HEATING_ADDITIONAL_COSTS",
  ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE = "ADVANCE_PAYMENT_RENT_COMPONENT_MAINTENANCE",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER = "ADVANCE_PAYMENT_RENT_COMPONENT_ELECTRICITY_WATER",
  ADVANCE_PAYMENT_RENT_COMPONENT_ELEVATOR = "ADVANCE_PAYMENT_RENT_COMPONENT_ELEVATOR",
  ADVANCE_PAYMENT_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION = "ADVANCE_PAYMENT_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION",
  ADVANCE_PAYMENT_RENT_COMPONENT_SEE_CONTRACT = "ADVANCE_PAYMENT_RENT_COMPONENT_SEE_CONTRACT",
  ADVANCE_PAYMENT_RENT_COMPONENT_E_CHARGING_STATION = "ADVANCE_PAYMENT_RENT_COMPONENT_E_CHARGING_STATION",
}

export interface V2AdvancePaymentRentComponentEntry {
  description: string;
  inactive: boolean;
  rentComponent: V2AdvancePaymentRentComponent;
}

export interface V2Assignees {
  contactIdAssigneeAccounting: string;
  contactIdAssigneeAdmin: string;
  contactIdAssigneeAsset: string;
  contactIdAssigneeOwner: string;
}

export interface V2BankInfo {
  address: CommonaddressAddress;
  bankName: string;
  clearingNumber: string;
  documentIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  expiresAt: TypeDate;
  iban: string;
  inTheNameOf: string;
  note: string;
  typeOfUseForInsurance: V2TypeOfUseForInsurance;
  useForInsurancePurposes: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom: TypeDate;
}

export type V2DeleteRenderFileResponse = object;

export interface V2DeleteRenderFilesRequest {
  renderIds: string[];
}

export type V2DeleteRenderFilesResponse = object;

/** @default "FLAT_RATE_RENT_COMPONENT_UNDEFINED" */
export enum V2FlatRateRentComponent {
  FLAT_RATE_RENT_COMPONENT_UNDEFINED = "FLAT_RATE_RENT_COMPONENT_UNDEFINED",
  FLAT_RATE_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING = "FLAT_RATE_RENT_COMPONENT_MAINTENANCE_GARDEN_SURROUNDING",
  FLAT_RATE_RENT_COMPONENT_HEATING_HOT_WATER = "FLAT_RATE_RENT_COMPONENT_HEATING_HOT_WATER",
  FLAT_RATE_RENT_COMPONENT_HEATING = "FLAT_RATE_RENT_COMPONENT_HEATING",
  FLAT_RATE_RENT_COMPONENT_GARBAGE = "FLAT_RATE_RENT_COMPONENT_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ELEVATOR = "FLAT_RATE_RENT_COMPONENT_ELEVATOR",
  FLAT_RATE_RENT_COMPONENT_TV = "FLAT_RATE_RENT_COMPONENT_TV",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_GARBAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE",
  FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE = "FLAT_RATE_RENT_COMPONENT_ELECTRICITY_WATER_SEWAGE_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE = "FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE",
  FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE_GARBAGE = "FLAT_RATE_RENT_COMPONENT_WATER_SEWAGE_GARBAGE",
  FLAT_RATE_RENT_COMPONENT_ADDITIONAL_COSTS = "FLAT_RATE_RENT_COMPONENT_ADDITIONAL_COSTS",
  FLAT_RATE_RENT_COMPONENT_WATER = "FLAT_RATE_RENT_COMPONENT_WATER",
  FLAT_RATE_RENT_COMPONENT_MAINTENANCE = "FLAT_RATE_RENT_COMPONENT_MAINTENANCE",
  FLAT_RATE_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION = "FLAT_RATE_RENT_COMPONENT_SERVICE_MINERGIE_VENTILATION",
  FLAT_RATE_RENT_COMPONENT_DISH_WASHER = "FLAT_RATE_RENT_COMPONENT_DISH_WASHER",
  FLAT_RATE_RENT_COMPONENT_FREEZER = "FLAT_RATE_RENT_COMPONENT_FREEZER",
  FLAT_RATE_RENT_COMPONENT_SEE_CONTRACT = "FLAT_RATE_RENT_COMPONENT_SEE_CONTRACT",
  FLAT_RATE_RENT_COMPONENT_BUDGET_EXPECTATIONS = "FLAT_RATE_RENT_COMPONENT_BUDGET_EXPECTATIONS",
  FLAT_RATE_RENT_COMPONENT_RENOVATION_FUND = "FLAT_RATE_RENT_COMPONENT_RENOVATION_FUND",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY1 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_1",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY2 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_2",
  FLATRATERENTCOMPONENTINFAVOROFPROPERTY3 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_PROPERTY_3",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS1 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_1",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS2 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_2",
  FLATRATERENTCOMPONENTINFAVOROFADDITIONALCOSTS3 = "FLAT_RATE_RENT_COMPONENT_IN_FAVOR_OF_ADDITIONAL_COSTS_3",
}

export interface V2FlatRateRentComponentEntry {
  description: string;
  inactive: boolean;
  rentComponent: V2FlatRateRentComponent;
}

export interface V2GetAllowedPropertyTypesResponse {
  types: Propertyv2PropertyType[];
}

export interface V2GetByOwnerIdAndNumericIdResponse {
  property: Propertyv2Property;
}

export interface V2GetRenderFileResponse {
  /** @format byte */
  contract: string;
}

export interface V2GetRenderFilesRequest {
  renderIds: string[];
}

export interface V2GetRenderFilesResponse {
  /** @format byte */
  contract: string;
}

export interface V2GetRenderStatusResponse {
  errorMessage: string;
  failed: boolean;
  finished: boolean;
}

/** @default "EN" */
export enum V2Language {
  EN = "EN",
  DE = "DE",
  FR = "FR",
  IT = "IT",
}

export interface V2ListIdsResponse {
  numericIds: string[];
}

export interface V2ListRenderStatusRequest {
  renderIds: string[];
}

export interface V2ListRenderStatusResponse {
  status: V2RenderStatus[];
}

export interface V2PropertyFilterOption {
  buildingIds: string[];
  id: string;
  name: string;
  /** @format int64 */
  ownerId: string;
}

/** @default "RENDER_ORDER_DEFAULT" */
export enum V2RenderOrder {
  RENDER_ORDER_DEFAULT = "RENDER_ORDER_DEFAULT",
  RENDER_ORDER_NUMERIC_ID = "RENDER_ORDER_NUMERIC_ID",
  RENDER_ORDER_OBJECT_NUMBER_ASC = "RENDER_ORDER_OBJECT_NUMBER_ASC",
  RENDER_ORDER_OBJECT_NUMBER_DESC = "RENDER_ORDER_OBJECT_NUMBER_DESC",
}

export interface V2RenderStatus {
  errorMessage: string;
  failed: boolean;
  finished: boolean;
  renderId: string;
}

export interface V2RenderTenancyTemplateRequest {
  attachAutomatically: boolean;
  /** Optional. Determines the used address for some placeholders if the tenant is a company contact. */
  contactPersonId?: string;
  description: string;
  documentName: string;
  enforcePdf: boolean;
  id: string;
  sendingProfile: string;
  /** Only used when attachAutomatically=true */
  showInPortal: boolean;
  signatories: string[];
  tenancyId: string;
  title: string;
  useGuarantorAddress: boolean;
}

export interface V2RenderTenancyTemplateResponse {
  renderId: string;
}

export interface V2SellRequest {
  id: string;
  keepNetworkPartners: boolean;
  /** @format int64 */
  targetOwnerId: string;
}

export interface V2SellResponse {
  property: Propertyv2Property;
}

/** @default "TYPE_OF_USE_FOR_INSURANCE_UNDEFINED" */
export enum V2TypeOfUseForInsurance {
  TYPE_OF_USE_FOR_INSURANCE_UNDEFINED = "TYPE_OF_USE_FOR_INSURANCE_UNDEFINED",
  TYPE_OF_USE_FOR_INSURANCE_DEBIT = "TYPE_OF_USE_FOR_INSURANCE_DEBIT",
  TYPE_OF_USE_FOR_INSURANCE_CREDIT = "TYPE_OF_USE_FOR_INSURANCE_CREDIT",
  TYPE_OF_USE_FOR_INSURANCE_DEBIT_AND_CREDIT = "TYPE_OF_USE_FOR_INSURANCE_DEBIT_AND_CREDIT",
}

export type ReportingDeleteJdbcConnectionResponse = object;

export interface ReportingGetAdditionalReportingsResponse {
  additionalReportings: ReportingReportingUrl[];
}

export interface ReportingGetBuildingRentReportsRequest {
  buildingIds: string[];
}

export interface ReportingGetBuildingRentReportsResponse {
  reports: ReportingRentReport[];
}

export interface ReportingGetDefaultReportingsResponse {
  adminBase: ReportingReportingUrl[];
  assetBase: ReportingReportingUrl[];
  financeBase: ReportingReportingUrl[];
  marketBase: ReportingReportingUrl[];
  ownerBase: ReportingReportingUrl[];
}

export interface ReportingGetJdbcConnectionsResponse {
  connections: ReportingJdbcConnection[];
}

export interface ReportingGetMyReportingsResponse {
  additionalReportings: ReportingReportingUrl[];
  defaultReportings: ReportingReportingUrl[];
}

export interface ReportingGetPropertyRentReportsResponse {
  reports: ReportingRentReport[];
}

export interface ReportingGetReportingUrlsResponse {
  reportingUrls: ReportingReportingUrls;
}

export interface ReportingHasJdbcConnectionResponse {
  hasJdbcConnection: boolean;
}

export interface ReportingJdbcConnection {
  /** @format int64 */
  accountId: string;
  client: string;
  host: string;
  password: string;
  username: string;
}

export interface ReportingRentReport {
  /** @format float */
  grossActualRentPerYear: number;
  /** @format float */
  grossOverallRentPerYear: number;
  /** @format float */
  grossTargetRentPerYear: number;
  /** @format float */
  netActualRentPerYear: number;
  /** @format float */
  netOverallRentPerYear: number;
  /** @format float */
  netTargetRentPerYear: number;
  referenceId: string;
  targetRentIncomplete: boolean;
}

export interface ReportingReportingUrl {
  allowedUserIds: string[];
  imageUrl: string;
  subTitle: string;
  title: string;
  url: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validUntil: TypeDate;
}

export interface ReportingReportingUrls {
  /** @format int64 */
  accountId: string;
  accounting: ReportingReportingUrl[];
  accountingOverview: ReportingReportingUrl[];
  adminOverview: ReportingReportingUrl[];
  administration: ReportingReportingUrl[];
  assetOverview: ReportingReportingUrl[];
  marketing: ReportingReportingUrl[];
  marketingOverview: ReportingReportingUrl[];
  overview: ReportingReportingUrl[];
  ownerOverview: ReportingReportingUrl[];
  publishHistory: ReportingReportingUrl[];
  tenantList: ReportingReportingUrl[];
}

export type ReportingSetAdditionalReportingsResponse = object;

export interface ReportingSetDefaultReportingsRequest {
  adminBase: ReportingReportingUrl[];
  assetBase: ReportingReportingUrl[];
  financeBase: ReportingReportingUrl[];
  marketBase: ReportingReportingUrl[];
  ownerBase: ReportingReportingUrl[];
}

export type ReportingSetDefaultReportingsResponse = object;

export type ReportingSetJdbcConnectionResponse = object;

export interface ReportingSetReportingPermissionsRequest {
  /** @format int64 */
  accountId: string;
  allowedUserIds: string[];
  url: string;
}

export type ReportingSetReportingPermissionsResponse = object;

export type ReportingSetReportingUrlsResponse = object;

/** The tenancy doesn't have to anything with the tenancy of the object stack! */
export interface Applicationv2Tenancy {
  /** whether the current tenancy was canceled by the tenant (if not, it was cancelled by the landlord/owner) */
  cancelledByTenant: ApplicableApplicable;
  hasCurrentLandlord: boolean;
  landlordEmail: string;
  landlordName: string;
  landlordPersonName: string;
  landlordPhone: string;
  /** @format float */
  previousGrossRent: number;
  relationToMainIndividual: string;
  relocationReason: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  rentedSince: TypeDate;
  sameAsMainIndividual: boolean;
}

/** @default "UNDEFINED_CIVIL_STATUS" */
export enum Requestapplicationv2CivilStatus {
  UNDEFINED_CIVIL_STATUS = "UNDEFINED_CIVIL_STATUS",
  CIVIL_STATUS_SINGLE = "CIVIL_STATUS_SINGLE",
  CIVIL_STATUS_MARRIED = "CIVIL_STATUS_MARRIED",
  CIVIL_STATUS_DIVORCED = "CIVIL_STATUS_DIVORCED",
  CIVIL_STATUS_WIDOWED = "CIVIL_STATUS_WIDOWED",
  CIVIL_STATUS_SEPARATED = "CIVIL_STATUS_SEPARATED",
  CIVIL_STATUS_REGISTERED_PARTNERSHIP = "CIVIL_STATUS_REGISTERED_PARTNERSHIP",
  CIVIL_STATUS_DISSOLVED_PARTNERSHIP = "CIVIL_STATUS_DISSOLVED_PARTNERSHIP",
}

export interface Requestapplicationv2Company {
  address: CommonaddressAddress;
  contactPerson: V2CompanyContactPerson;
  debtEnforcementRegisterMediaIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  founded: TypeDate;
  idCardMediaIds: string[];
  insurance: V2InsuranceInformation;
  /** LegalInformation store's all necessary data in order to comply with any kind of law or are required by one. */
  legal: V2LegalInformation;
  /** DEPRECATED!. Use requestedParkingSpaces array. */
  licensePlate: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liquidated: TypeDate;
  mediaIds: string[];
  name: string;
  /** @format int32 */
  numberOfEmployees: number;
  /**
   * DEPRECATED!. Use requestedParkingSpaces array.
   * @format int32
   */
  parkingSpacesRequested: number;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredDeposit: V2PreferredDeposit;
  preferredLanguage: LanguagePreferredLanguage;
  purpose: string;
  remark: string;
  requestedParkingSpaces: V2RequestedParkingSpace[];
  /** @format int32 */
  revenue: number;
  /** how the company plans to use the space to which it has applied to */
  spaceUtilization: string;
  tenancy: Applicationv2Tenancy;
  /** whether the company has an entry in the trade register */
  tradeRegisterEntry: ApplicableApplicable;
  tradeRegisterExcerptMediaIds: string[];
  /** whether the company is liable to value added tax (Mehrwertsteuerpflichtig) */
  vatLiable: ApplicableApplicable;
  website: string;
}

export interface Requestapplicationv2CreateRequest {
  company: Requestapplicationv2Company;
  guarantors: Requestapplicationv2Individual[];
  /** Either individuals or company must be provided. Both are NOT allowed! */
  individuals: Requestapplicationv2Individual[];
}

export interface Requestapplicationv2CreateResponse {
  application: V2Application;
}

export type Requestapplicationv2DeleteResponse = object;

/** Employment stores the person's current employment information */
export interface Requestapplicationv2Employment {
  /** the person's company email */
  companyEmail: string;
  companyName: string;
  /** the person's position in the company */
  companyPosition: string;
  employmentDuration: V2EmploymentDuration;
  /** @format double */
  income: number;
  profession: string;
  /**
   * DEPRECATED!. Use employmentDuration enum.
   * @format int32
   */
  sinceYears: number;
  status: V2EmploymentStatus;
  /** the person's supervisor in the company */
  supervisor: string;
  /** email of the person's company supervisor in the company */
  supervisorEmail: string;
  /** phone number of the person's supervisor in the company */
  supervisorPhone: string;
  type: V2EmploymentType;
}

/** @default "UNDEFINED_GENDER" */
export enum Requestapplicationv2Gender {
  UNDEFINED_GENDER = "UNDEFINED_GENDER",
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export interface Requestapplicationv2GetLatestResponse {
  application: V2Application;
}

export interface Requestapplicationv2GetSettingsResponse {
  settings: Requestapplicationv2Settings;
}

export interface Requestapplicationv2Individual {
  address: CommonaddressAddress;
  /** @format int32 */
  children: number;
  civilStatus: Requestapplicationv2CivilStatus;
  creditTrustCertificateMediaIds: string[];
  debtEnforcementRegisterMediaIds: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dob: TypeDate;
  email: string;
  employment: Requestapplicationv2Employment;
  firstName: string;
  gender: Requestapplicationv2Gender;
  household: V2Household;
  idCardMediaIds: string[];
  insurance: V2InsuranceInformation;
  lastName: string;
  /** LegalInformation store's all necessary data in order to comply with any kind of law or are required by one. */
  legal: V2LegalInformation;
  mainIndividual: boolean;
  mediaIds: string[];
  mobileNumber: string;
  nationality: string;
  phoneNumber: string;
  pob: string;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  preferredDeposit: V2PreferredDeposit;
  preferredLanguage: LanguagePreferredLanguage;
  remark: string;
  /**
   * residence status in switzerland
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus: Requestapplicationv2ResidenceStatus;
  /**
   * how long the residenceStatus value is valid
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil: TypeDate;
  tenancy: Applicationv2Tenancy;
  wageStatementMediaIds: string[];
}

/**
 * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
 *
 *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
 *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
 *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
 *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
 *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
 *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
 *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
 *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
 * @default "UNDEFINED_RESIDENCE_STATUS"
 */
export enum Requestapplicationv2ResidenceStatus {
  UNDEFINED_RESIDENCE_STATUS = "UNDEFINED_RESIDENCE_STATUS",
  RESIDENCE_STATUS_B_STAY = "RESIDENCE_STATUS_B_STAY",
  RESIDENCE_STATUS_C_SETTLE = "RESIDENCE_STATUS_C_SETTLE",
  RESIDENCE_STATUS_CI_STAY_EMPLOYMENT = "RESIDENCE_STATUS_CI_STAY_EMPLOYMENT",
  RESIDENCE_STATUS_G_BORDER_CROSSER = "RESIDENCE_STATUS_G_BORDER_CROSSER",
  RESIDENCE_STATUS_L_SHORT_STAY = "RESIDENCE_STATUS_L_SHORT_STAY",
  RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER = "RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER",
  RESIDENCE_STATUS_N_SEEKING_ASYLUM = "RESIDENCE_STATUS_N_SEEKING_ASYLUM",
  RESIDENCE_STATUS_S_PROTECTION_NEEDED = "RESIDENCE_STATUS_S_PROTECTION_NEEDED",
  RESIDENCE_STATUS_NO_STATUS = "RESIDENCE_STATUS_NO_STATUS",
}

export interface Requestapplicationv2SetSettingsResponse {
  settings: Requestapplicationv2Settings;
}

export interface Requestapplicationv2Settings {
  /** @format int64 */
  accountId: string;
  affordability: V2AffordabilitySettings;
  applicationDossier: V2ApplicationDossierSettings;
  automaticReferenceCheck: MarketbaseAutomaticReferenceCheckMode;
  /** @format float */
  contractCreationCost: number;
  /**
   * Single HTML body for employer reference request emails. May contain one or more language
   * versions in the same mail (Swiss practice). Must include the #link_referenz# placeholder.
   */
  employerReferenceEmailTemplate: string;
  /**
   * Single HTML body for landlord reference request emails. May contain one or more language
   * versions in the same mail (Swiss practice). Must include the #link_referenz# placeholder.
   */
  landlordReferenceEmailTemplate: string;
  /** Mailbox ID used as sender for digital reference request emails. Required when automaticReferenceCheck is not DO_NOT_CHECK. */
  referenceSenderMailboxId: string;
  showContractCreationCostAgreement: boolean;
}

export interface Requestrequestv2CreateRequest {
  checklist: V2Checklist;
  /** If receiver or requester read the last message */
  createdByReceiver: boolean;
  favorite: boolean;
  guarantors: V2Guarantor[];
  initialMessage: string;
  marketplaceName: string;
  objectId: string;
  /** @format int64 */
  ownerId: string;
  rejected: boolean;
  requesters: V2Requester[];
  sendDefaultAnswer: boolean;
  source: V2RequestSource;
  /** DO NOT USE! Deprecated. Use tenancyIds */
  tenancyId: string;
  tenancyIds: string[];
}

export interface Requestrequestv2CreateResponse {
  request: V2Request;
}

export type Requestrequestv2DeleteResponse = object;

export interface Requestrequestv2ListByIdsResponse {
  requests: V2Request[];
}

export interface Requestrequestv2MarkReadRequest {
  ids: string[];
  /** True=receiver read, false=requester read */
  readByReceiver: boolean;
}

export type Requestrequestv2MarkReadResponse = object;

export interface Requestrequestv2MarkUnreadRequest {
  ids: string[];
  /** True=receiver unread, false=requester unread */
  unreadByReceiver: boolean;
}

export type Requestrequestv2MarkUnreadResponse = object;

export interface Requestv2GetMarketingStatisticsResponse {
  /** @format int32 */
  employeeNewRequests: number;
  /** @format int32 */
  employeeUnreadRequests: number;
  /** @format int32 */
  overallNewRequests: number;
  /** @format int32 */
  overallUnreadRequests: number;
}

export interface Requestv2GetStatisticsResponse {
  statistics: V2RequestStatistics[];
}

export interface V2AddGuarantorsResponse {
  request: V2Request;
}

export interface V2AddRequestersResponse {
  request: V2Request;
}

export interface V2Affordability {
  /**
   * Sum of lower incomes from all parties including guarantors. Used for detail tooltip. Only set when status is CALCULATED.
   * @format double
   */
  grossIncome: number;
  /**
   * Affordability ratio in percent: (grossRentPerMonth * 12) / grossIncome * 100. Only set when status is CALCULATED.
   * @format double
   */
  percent: number;
  status: V2AffordabilityStatus;
  /** True when status is CALCULATED and percent <= account maximumAffordabilityPercent. Used by automatic reference check. */
  withinMaximum: boolean;
}

export interface V2AffordabilitySettings {
  /**
   * Whole number under 100. Green range is 0 to this value (inclusive).
   * @format int32
   */
  maximumAffordabilityPercent: number;
  /**
   * Whole number under 100. Must be greater than maximumAffordabilityPercent. Orange range is maximumAffordabilityPercent+1 to this value.
   * @format int32
   */
  toleranceRangeUpToPercent: number;
}

/**
 * - AFFORDABILITY_STATUS_NOT_AVAILABLE: No application form sent yet → UI shows "-"
 *  - AFFORDABILITY_STATUS_NO_INCOME: Applicant selected no income / incomes cannot be used → UI shows "no income"
 *  - AFFORDABILITY_STATUS_CALCULATED: Percent was calculated → UI shows bar + value
 * @default "AFFORDABILITY_STATUS_UNDEFINED"
 */
export enum V2AffordabilityStatus {
  AFFORDABILITY_STATUS_UNDEFINED = "AFFORDABILITY_STATUS_UNDEFINED",
  AFFORDABILITY_STATUS_NOT_AVAILABLE = "AFFORDABILITY_STATUS_NOT_AVAILABLE",
  AFFORDABILITY_STATUS_NO_INCOME = "AFFORDABILITY_STATUS_NO_INCOME",
  AFFORDABILITY_STATUS_CALCULATED = "AFFORDABILITY_STATUS_CALCULATED",
}

export interface V2Application {
  company: Requestapplicationv2Company;
  /** @format int64 */
  createdAt: string;
  creatorEmail: string;
  guarantors: Requestapplicationv2Individual[];
  id: string;
  individuals: Requestapplicationv2Individual[];
  /** @format int64 */
  ownerId: string;
  /** @format int32 */
  version: number;
}

export interface V2ApplicationDossierSettings {
  requireDebtCollectionRegistryExtract: boolean;
  requireIdDocument: boolean;
}

export interface V2Checklist {
  applicationFormReceived: boolean;
  applicationFormRequested: boolean;
  contractReceived: boolean;
  contractSent: boolean;
  creditCheckDone: boolean;
  referencesObtained: boolean;
  viewingAppointmentArranged: boolean;
  viewingAppointmentContactShared: boolean;
  viewingAppointmentDone: boolean;
}

export interface V2CompanyContactPerson {
  email: string;
  fax: string;
  firstName: string;
  gender: Requestapplicationv2Gender;
  lastName: string;
  mobileNumber: string;
  phoneNumber: string;
  position: string;
  status: V2EmploymentStatus;
}

export interface V2EmployerReference {
  contactPerson: string;
  /** Structured answers from the digital form. Set only when digitallySubmitted is true. Manual free-text fields (duration, probation, …) stay unused for digital submissions. */
  digitalAnswers: V2SubmitEmployerReferenceAnswers;
  /** True after the employer submitted the digital form. */
  digitallySubmitted: boolean;
  duration: string;
  email: string;
  /**
   * UNIX timestamp in seconds when the reference email was last sent. 0 if never sent.
   * @format int64
   */
  emailRequestedAt: string;
  /** User who triggered the email request. Empty when requested automatically by the system. */
  emailRequestedByUserId: string;
  finalized: boolean;
  name: string;
  notes: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  obtainedOn: TypeDate;
  phone: string;
  probation: string;
  /**
   * Digital reference check
   * Public UUID used in the digital reference form URL. Empty if never requested by email.
   */
  publicId: string;
  salary: string;
  /** Answer to: Is the employment relationship still in effect? */
  stillInEffect: string;
  temporalEmployment: string;
}

export interface V2EmployerReferenceFormPrefill {
  /** Applicant answer for Q1 (Since). */
  employmentDuration: string;
  /** Applicant answer for Q3 (Type). */
  employmentType: string;
  /** Applicant answer for Q5 (income). */
  income: string;
}

/** @default "UNDEFINED_EMPLOYMENT_DURATION" */
export enum V2EmploymentDuration {
  UNDEFINED_EMPLOYMENT_DURATION = "UNDEFINED_EMPLOYMENT_DURATION",
  EMPLOYMENTDURATIONLESSTHAN3MONTHS = "EMPLOYMENT_DURATION_LESS_THAN_3_MONTHS",
  EMPLOYMENTDURATIONMORETHAN3MONTHS = "EMPLOYMENT_DURATION_MORE_THAN_3_MONTHS",
  EMPLOYMENTDURATION1YEAR = "EMPLOYMENT_DURATION_1_YEAR",
  EMPLOYMENTDURATION2YEARS = "EMPLOYMENT_DURATION_2_YEARS",
  EMPLOYMENTDURATION3YEARS = "EMPLOYMENT_DURATION_3_YEARS",
  EMPLOYMENTDURATION4YEARS = "EMPLOYMENT_DURATION_4_YEARS",
  EMPLOYMENTDURATION5YEARS = "EMPLOYMENT_DURATION_5_YEARS",
  EMPLOYMENTDURATIONMORETHAN5YEARS = "EMPLOYMENT_DURATION_MORE_THAN_5_YEARS",
}

/** @default "UNDEFINED_EMPLOYMENT_STATUS" */
export enum V2EmploymentStatus {
  UNDEFINED_EMPLOYMENT_STATUS = "UNDEFINED_EMPLOYMENT_STATUS",
  EMPLOYMENT_STATUS_UNEMPLOYED = "EMPLOYMENT_STATUS_UNEMPLOYED",
  EMPLOYMENT_STATUS_EMPLOYEE = "EMPLOYMENT_STATUS_EMPLOYEE",
  EMPLOYMENT_STATUS_SELF_EMPLOYED = "EMPLOYMENT_STATUS_SELF_EMPLOYED",
  EMPLOYMENT_STATUS_APPRENTICE = "EMPLOYMENT_STATUS_APPRENTICE",
  EMPLOYMENT_STATUS_RETIRED = "EMPLOYMENT_STATUS_RETIRED",
}

/** @default "UNDEFINED_EMPLOYMENT_TYPE" */
export enum V2EmploymentType {
  UNDEFINED_EMPLOYMENT_TYPE = "UNDEFINED_EMPLOYMENT_TYPE",
  EMPLOYMENT_TYPE_TEMPORARY = "EMPLOYMENT_TYPE_TEMPORARY",
  EMPLOYMENT_TYPE_INDEFINITE = "EMPLOYMENT_TYPE_INDEFINITE",
  EMPLOYMENT_TYPE_LIMITED = "EMPLOYMENT_TYPE_LIMITED",
}

export interface V2GetByIdResponse {
  application: V2Application;
}

export interface V2GetReferenceFormResponse {
  administration: V2ReferenceFormAdministration;
  applicant: V2ReferenceFormApplicant;
  employerPrefill: V2EmployerReferenceFormPrefill;
  landlordPrefill: V2LandlordReferenceFormPrefill;
  language: LanguagePreferredLanguage;
  type: V2ReferenceType;
  /** False when the link is no longer valid (already submitted or manually finalized). */
  valid: boolean;
}

export interface V2Guarantor {
  /** Always set to the contactId of a contact of the owner of the request */
  contactId: string;
  employerReference: V2EmployerReference;
  landlordReference: V2LandlordReference;
}

export interface V2Household {
  /** @format int32 */
  adults: number;
  /** @format int32 */
  children: number;
  instruments: ApplicableApplicable;
  instrumentsDescription: string;
  /** DEPRECATED!. Use requestedParkingSpaces array. */
  licensePlate: string;
  /**
   * amount of parking spaces requested by the household
   * DEPRECATED!. Use requestedParkingSpaces array.
   * @format int32
   */
  parkingSpacesRequested: number;
  pets: ApplicableApplicable;
  petsDescription: string;
  requestedParkingSpaces: V2RequestedParkingSpace[];
  /** are smokers living in the person's household? */
  smokers: ApplicableApplicable;
  tvProvider: V2TvProvider;
}

/** InsuranceInformation stores insurance information */
export interface V2InsuranceInformation {
  hasLiabilityInsurance: ApplicableApplicable;
}

export interface V2LandlordReference {
  complaints: string;
  contactPerson: string;
  costs: string;
  /** Structured answers from the digital form. Set only when digitallySubmitted is true. Manual free-text fields (duration, punctualPayment, …) stay unused for digital submissions. */
  digitalAnswers: V2SubmitLandlordReferenceAnswers;
  /** True after the landlord submitted the digital form. */
  digitallySubmitted: boolean;
  duration: string;
  email: string;
  /**
   * UNIX timestamp in seconds when the reference email was last sent. 0 if never sent.
   * @format int64
   */
  emailRequestedAt: string;
  /** User who triggered the email request. Empty when requested automatically by the system. */
  emailRequestedByUserId: string;
  finalized: boolean;
  name: string;
  notes: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  obtainedOn: TypeDate;
  phone: string;
  /**
   * Digital reference check
   * Public UUID used in the digital reference form URL. Empty if never requested by email.
   */
  publicId: string;
  punctualPayment: string;
}

export interface V2LandlordReferenceFormPrefill {
  /**
   * Applicant answer for Q4.
   * @format float
   */
  previousGrossRent: number;
  /** Applicant answer for Q1. */
  rentedSince: string;
}

/** LegalInformation store's all necessary data in order to comply with any kind of law or are required by one. */
export interface V2LegalInformation {
  /** does the person have had a debt certificate issued in the last five years? */
  debtCertificateLastFiveYears: ApplicableApplicable;
  /** does the person have had a foreclosure in the last two years? */
  foreclosureLastTwoYears: ApplicableApplicable;
}

export interface V2ListByObjectIdAndRequesterEmailResponse {
  requests: V2Request[];
}

export interface V2ListByRequesterContactIdResponse {
  requests: V2Request[];
}

export interface V2ListReceivedByObjectIdsResponse {
  /** @format int32 */
  new: number;
  /** @format int32 */
  overall: number;
  requests: V2Request[];
  reserved: boolean;
  /** @format int32 */
  unread: number;
}

export interface V2ListSentResponse {
  requests: V2Request[];
}

export interface V2MarkRejectedRequest {
  ids: string[];
}

export type V2MarkRejectedResponse = object;

export interface V2MoveResponse {
  request: V2Request;
}

export interface V2PartiallySetChecklistRequest {
  applicationFormReceived: boolean;
  applicationFormRequested: boolean;
  contractReceived: boolean;
  contractSent: boolean;
  creditCheckDone: boolean;
  ids: string[];
  referencesObtained: boolean;
  viewingAppointmentArranged: boolean;
  viewingAppointmentContactShared: boolean;
  viewingAppointmentDone: boolean;
}

export interface V2PartiallySetChecklistResponse {
  requests: V2Request[];
}

export interface V2PreferredDeposit {
  bankDepotIds: string[];
  bankDepotNames: string[];
  bankGuaranteeIds: string[];
  bankGuaranteeNames: string[];
  collectiveInsuranceNames: string[];
  insuranceNames: string[];
  /** @format float */
  premiumPerYear: number;
  /** @format float */
  premiumThisYear: number;
  type: V2PreferredDepositType;
}

/** @default "PREFERRED_DEPOSIT_TYPE_UNDEFINED" */
export enum V2PreferredDepositType {
  PREFERRED_DEPOSIT_TYPE_UNDEFINED = "PREFERRED_DEPOSIT_TYPE_UNDEFINED",
  PREFERRED_DEPOSIT_TYPE_INSURANCE = "PREFERRED_DEPOSIT_TYPE_INSURANCE",
  PREFERRED_DEPOSIT_TYPE_COLLECTIVE_INSURANCE = "PREFERRED_DEPOSIT_TYPE_COLLECTIVE_INSURANCE",
  PREFERRED_DEPOSIT_TYPE_DEPOT = "PREFERRED_DEPOSIT_TYPE_DEPOT",
  PREFERRED_DEPOSIT_TYPE_BANK_GUARANTEE = "PREFERRED_DEPOSIT_TYPE_BANK_GUARANTEE",
  PREFERRED_DEPOSIT_TYPE_COOPERATIVE_SHARE = "PREFERRED_DEPOSIT_TYPE_COOPERATIVE_SHARE",
  PREFERRED_DEPOSIT_TYPE_CASH_PAYMENT = "PREFERRED_DEPOSIT_TYPE_CASH_PAYMENT",
}

export interface V2ReactivateRequest {
  ids: string[];
}

export type V2ReactivateResponse = object;

/** @default "REFERENCE_CONFIRMATION_UNDEFINED" */
export enum V2ReferenceConfirmation {
  REFERENCE_CONFIRMATION_UNDEFINED = "REFERENCE_CONFIRMATION_UNDEFINED",
  REFERENCE_CONFIRMATION_APPLIES = "REFERENCE_CONFIRMATION_APPLIES",
  REFERENCE_CONFIRMATION_DOES_NOT_APPLY = "REFERENCE_CONFIRMATION_DOES_NOT_APPLY",
  REFERENCE_CONFIRMATION_NO_INFORMATION = "REFERENCE_CONFIRMATION_NO_INFORMATION",
}

export interface V2ReferenceFormAdministration {
  address: CommonaddressAddress;
  assigneeName: string;
  companyName: string;
  logoUrl: string;
  telephone: string;
}

export interface V2ReferenceFormApplicant {
  address: CommonaddressAddress;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth: TypeDate;
  mobile: string;
  name: string;
}

/** @default "REFERENCE_TYPE_UNDEFINED" */
export enum V2ReferenceType {
  REFERENCE_TYPE_UNDEFINED = "REFERENCE_TYPE_UNDEFINED",
  REFERENCE_TYPE_EMPLOYER = "REFERENCE_TYPE_EMPLOYER",
  REFERENCE_TYPE_LANDLORD = "REFERENCE_TYPE_LANDLORD",
}

/** @default "REFERENCE_YES_NO_UNDEFINED" */
export enum V2ReferenceYesNo {
  REFERENCE_YES_NO_UNDEFINED = "REFERENCE_YES_NO_UNDEFINED",
  REFERENCE_YES_NO_YES = "REFERENCE_YES_NO_YES",
  REFERENCE_YES_NO_NO = "REFERENCE_YES_NO_NO",
  REFERENCE_YES_NO_NO_INFORMATION = "REFERENCE_YES_NO_NO_INFORMATION",
}

export interface V2RemoveRequestersResponse {
  request: V2Request;
}

export interface V2Request {
  /** Computed on read from application incomes, object gross rent, and account affordability settings. Not persisted. */
  affordability: V2Affordability;
  applicationId: string;
  checklist: V2Checklist;
  favorite: boolean;
  guarantors: V2Guarantor[];
  id: string;
  initialMessage: string;
  /** @format int64 */
  lastModifiedAt: string;
  marketplaceName: string;
  /** If new request wasn't read by the receiver at least once */
  new: boolean;
  objectId: string;
  /**
   * Account ID of the owner of the object
   * @format int64
   */
  ownerId: string;
  readApplicationForm: boolean;
  /** If receiver read the last message */
  readByReceiver: boolean;
  /** If at least one requester read the last message */
  readByRequester: boolean;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  received: string;
  rejected: boolean;
  requesters: V2Requester[];
  source: V2RequestSource;
  /** DO NOT USE! Deprecated. Use tenancyIds */
  tenancyId: string;
  tenancyIds: string[];
}

export interface V2RequestEmployerReferenceByEmailResponse {
  employerReference: V2EmployerReference;
}

export interface V2RequestLandlordReferenceByEmailResponse {
  landlordReference: V2LandlordReference;
}

/**
 * - PERSONAL_REQUEST_SOURCE: E.g. if requester came into office
 * @default "UNDEFINED_REQUEST_SOURCE"
 */
export enum V2RequestSource {
  UNDEFINED_REQUEST_SOURCE = "UNDEFINED_REQUEST_SOURCE",
  PHONE_REQUEST_SOURCE = "PHONE_REQUEST_SOURCE",
  MAIL_REQUEST_SOURCE = "MAIL_REQUEST_SOURCE",
  WEBSITE_REQUEST_SOURCE = "WEBSITE_REQUEST_SOURCE",
  MARKETPLACE_REQUEST_SOURCE = "MARKETPLACE_REQUEST_SOURCE",
  PERSONAL_REQUEST_SOURCE = "PERSONAL_REQUEST_SOURCE",
}

export interface V2RequestStatistics {
  /** @format int32 */
  applicationsReceived: number;
  /** @format int32 */
  appointmentsDone: number;
  objectId: string;
  /** @format int32 */
  overall: number;
  /** @format int32 */
  unread: number;
}

export interface V2RequestedParkingSpace {
  checked: boolean;
  licensePlate: string;
  type: ObjectParkingType;
}

export interface V2Requester {
  /**
   * Optional accountId of the requester if registered
   * @format int64
   */
  accountId: string;
  /** Always set to the contactId of a contact of the owner of the request */
  contactId: string;
  employerReference: V2EmployerReference;
  landlordReference: V2LandlordReference;
  /** Optional userId of the requester if registered */
  userId: string;
}

export type V2ReserveResponse = object;

export interface V2SendRequest {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredStartOfContract: TypeDate;
  id: string;
  language: string;
  objectId: string;
  /** Optional. If not provided the email will be used to match. */
  requestId?: string;
  viewingAppointmentDone: boolean;
}

export type V2SendResponse = object;

export interface V2SetChecklistRequest {
  checklist: V2Checklist;
  ids: string[];
}

export type V2SetChecklistResponse = object;

export type V2SetEmployerReferenceFinalizedResponse = object;

export type V2SetEmployerReferenceResponse = object;

export interface V2SetFavoriteRequest {
  ids: string[];
}

export type V2SetFavoriteResponse = object;

export type V2SetLandlordReferenceFinalizedResponse = object;

export type V2SetLandlordReferenceResponse = object;

export interface V2SetNotFavoriteRequest {
  ids: string[];
}

export type V2SetNotFavoriteResponse = object;

export interface V2SubmitEmployerReferenceAnswers {
  duration: V2ReferenceConfirmation;
  probationOngoing: V2ReferenceYesNo;
  salaryCorrect: V2ReferenceConfirmation;
  stillInEffect: V2ReferenceYesNo;
  temporaryPosition: V2ReferenceConfirmation;
}

export interface V2SubmitLandlordReferenceAnswers {
  complaintsOrConflicts: V2ReferenceYesNo;
  duration: V2ReferenceConfirmation;
  monthlyRent: V2ReferenceConfirmation;
  rentPaidOnTime: V2ReferenceYesNo;
}

export type V2SubmitReferenceFormResponse = object;

/** @default "TV_PROVIDER_UNDEFINED" */
export enum V2TvProvider {
  TV_PROVIDER_UNDEFINED = "TV_PROVIDER_UNDEFINED",
  TV_PROVIDER_UPC = "TV_PROVIDER_UPC",
  TV_PROVIDER_THIRD_PARTY = "TV_PROVIDER_THIRD_PARTY",
}

export interface SearchBoolFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: boolean;
}

export interface SearchBuildingAddress {
  city: string;
  country: string;
  geo: SearchBuildingGeo;
  mailbox: string;
  state: string;
  street: string;
  streetAddition: string;
  streetNumber: string;
  zip: string;
}

export interface SearchBuildingFacets {
  /** Not-searchable facet. */
  buildingStrategyTypes: SearchBuildingStrategyTypeFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  cities: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  craftsmenNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  janitorsNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  objectCounts: SearchInt32FacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  propertyTypes: SearchPropertyTypeFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  serviceProvidersNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  zips: SearchStringFacetValue[];
}

export interface SearchBuildingGeo {
  /** @format double */
  elevation: number;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
}

export interface SearchBuildingHit {
  /** @format double */
  actualGross: number;
  /** @format double */
  actualNet: number;
  address: SearchBuildingAddress;
  buildingArea: string;
  buildingStrategy: SearchBuildingHitStrategy;
  buildingZone: string;
  constructionYear: string;
  craftsmen: SearchsearchBuildingContact[];
  floors: string;
  /** @format double */
  grossOverallRentPerYear: number;
  hasActivatedTenancy: boolean;
  /** Previously Algolia objectID. */
  id: string;
  imageUrl: string;
  janitors: SearchsearchBuildingContact[];
  landRegisterNumber: string;
  name: string;
  /** @format double */
  netOverallRentPerYear: number;
  networkPartnerAccounting: SearchBuildingNetworkPartnerAccount;
  networkPartnerAsset: SearchBuildingNetworkPartnerAccount;
  networkPartners: SearchBuildingNetworkPartner[];
  number: string;
  /** @format int64 */
  numericId: string;
  /** @format int32 */
  objectCount: number;
  objectIds: string[];
  owner: SearchBuildingOwner;
  plotArea: string;
  propertyType: Propertyv2PropertyType;
  renovationYear: string;
  serviceProviders: SearchsearchBuildingContact[];
  /** @format double */
  targetGross: number;
  targetIncomplete: boolean;
  /** @format double */
  targetNet: number;
  thumbnailMUrl: string;
  thumbnailSUrl: string;
  transferToAccounting: boolean;
}

export interface SearchBuildingHitDate {
  /** @format int32 */
  day: number;
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
}

export interface SearchBuildingHitStrategy {
  reviewAt: SearchBuildingHitDate;
  /**
   * Unix seconds used for default/primary review-date sort. Missing reviewAt uses a far-future sentinel so ASC sorts put undated buildings last.
   * @format int64
   */
  reviewAtSortValue: string;
  type: BuildingBuildingStrategyType;
}

export interface SearchBuildingNetworkPartner {
  /** Format: {targetAccountId}-{scopeString}. */
  combinedId: string;
}

export interface SearchBuildingNetworkPartnerAccount {
  /** @format int64 */
  accountId: string;
  name: string;
}

export interface SearchBuildingOwner {
  /** @format int64 */
  id: string;
  name: string;
}

export interface SearchBuildingStrategyTypeFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: BuildingBuildingStrategyType;
}

export interface SearchCondominiumFacets {
  /** Searchable facet; filter typeahead client-side. */
  assigneeAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAdministrationNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeMarketingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeOwnerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  categories: SearchObjectCategoryFacetValue[];
  /** Not-searchable facet (obj.floor / decimalFloor). */
  floors: SearchDoubleFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  preferredCommunicationChannels: SearchPreferredCommunicationChannelFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  rooms: SearchDoubleFacetValue[];
  /** Not-searchable facet. */
  statuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  tags: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  zips: SearchStringFacetValue[];
}

export interface SearchCondominiumHit {
  billingContact: SearchObjectContactRef;
  closed: boolean;
  condominiumOwners: SearchObjectContactRef[];
  correspondenceContact: SearchObjectContactRef;
  endingAt: SearchObjectHitDate;
  /** Previously Algolia objectID (condominium id). */
  id: string;
  /** @format int64 */
  numericId: string;
  obj: SearchCondominiumHitObject;
  owner: SearchObjectOwner;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  roommates: SearchObjectContactRef[];
  startingAt: SearchObjectHitDate;
  /** Denormalized status label (Algolia string). */
  status: string;
  tenants: SearchObjectContactRef[];
}

export interface SearchCondominiumHitObject {
  address: SearchObjectAddress;
  assignees: SearchObjectAssignees;
  buildingId: string;
  category: ObjectCategory;
  /** @format double */
  effectiveArea: number;
  /**
   * Object characteristics decimalFloor (may be fractional).
   * @format double
   */
  floor: number;
  id: string;
  /** @format double */
  livingArea: number;
  name: string;
  networkPartners: SearchObjectNetworkPartner[];
  number: string;
  /** @format int64 */
  numericId: string;
  /** @format double */
  rooms: number;
  subCategories: ObjectSubCategory[];
  tags: string[];
  /** @format double */
  valueQuota: number;
}

export interface SearchContactAddress {
  careOf: string;
  city: string;
  country: string;
  mailbox: string;
  state: string;
  street: string;
  streetAddition: string;
  streetNumber: string;
  zip: string;
}

export interface SearchContactFacets {
  /** Not-searchable facet. */
  industries: SearchIndustryFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  preferredCommunicationChannels: SearchPreferredCommunicationChannelFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  tags: SearchStringFacetValue[];
  /** Not-searchable facet. */
  types: SearchTypeFacetValue[];
}

export interface SearchContactHit {
  active: boolean;
  address: SearchContactAddress;
  birthName: string;
  /** False when the contact is part of an open tenancy, condominium, or object relation. */
  canBeSetInactive: boolean;
  contactPersons: SearchContactPersonHit[];
  email: string;
  firstName: string;
  /** Persons only; default/undefined for companies. */
  gender: Contactcontactv2Gender;
  /** True if the contact or any contact person has an email. */
  hasEmail: boolean;
  /** Previously Algolia objectID. */
  id: string;
  industries: IndustryIndustry[];
  /** True for company; false for person. */
  isCompany: boolean;
  /** True if the contact has the employee type. */
  isEmployee: boolean;
  /** True if the only contact type is interested party. */
  isOnlyInterestedParty: boolean;
  /** True if the contact has the client (owner) type. */
  isOwner: boolean;
  /** True if linked to at least one tenancy. */
  isTenant: boolean;
  /** Person last name, or company name used for sorting. */
  lastName: string;
  /** Full name or company name. */
  name: string;
  nationality: string;
  note: string;
  /** @format int64 */
  numericId: string;
  owner: SearchContactOwner;
  phoneNumbers: SearchContactPhoneNumber[];
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  tags: string[];
  title: string;
  types: Contactcontactv2Type[];
  website: string;
  workEmail: SearchContactWorkEmail;
}

export interface SearchContactOwner {
  /** @format int64 */
  id: string;
  name: string;
}

export interface SearchContactPersonHit {
  active: boolean;
  birthName: string;
  companyPosition: string;
  /** True if a date of death is set. */
  dead: boolean;
  email: string;
  firstName: string;
  gender: Contactcontactv2Gender;
  hasEmail: boolean;
  id: string;
  lastName: string;
  name: string;
  /** @format int64 */
  numericId: string;
  phoneNumbers: SearchContactPhoneNumber[];
  title: string;
}

export interface SearchContactPhoneNumber {
  number: string;
  type: V2PhoneNumberType;
}

export interface SearchContactWorkEmail {
  email: string;
  /** Whether this work email should be used as the preferred email. */
  use: boolean;
}

export interface SearchDoubleFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  /** @format double */
  value: number;
}

export interface SearchGenerateApiKeyRequest {
  /** @format int64 */
  accountId: string;
}

export interface SearchGenerateApiKeyResponse {
  key: string;
}

export type SearchGenerateUnauthorizedApiKeyRequest = object;

export interface SearchGenerateUnauthorizedApiKeyResponse {
  key: string;
}

export interface SearchGlobalSearchHit {
  /** entity numericId as string, or ticket key */
  displayId: string;
  id: string;
  /** secondary line (address, email, …) */
  subtitle: string;
  /** primary dropdown label */
  title: string;
  /** CONTACT_… … TICKET_… */
  type: SearchSearchIndex;
}

export interface SearchGlobalSearchRequest {
  /**
   * must match auth; ACL filter
   * @format int64
   */
  accountId: string;
  /** used for localization on some subTitles; unset/UNDEFINED => German */
  language: LanguagePreferredLanguage;
  /** free-text; empty => empty hits */
  query: string;
}

export interface SearchGlobalSearchResponse {
  /** max 7, best-first */
  hits: SearchGlobalSearchHit[];
}

export interface SearchIndustryFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: IndustryIndustry;
}

export interface SearchInt32FacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  /** @format int32 */
  value: number;
}

export interface SearchListBuildingsRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /**
   * facets without free-text typeahead
   * Maps to buildingStrategy.type. Not-searchable facet. Empty = no filter.
   */
  buildingStrategyTypes: BuildingBuildingStrategyType[];
  /**
   * searchable facets (typeahead client-side)
   * Maps to address.city. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  cities: string[];
  /** Maps to craftsmen.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  craftsmenNames: string[];
  /** When true, response includes facet buckets (cities, zips, craftsmen/janitors/serviceProviders/owner/network-partner names, objectCounts, buildingStrategyTypes, propertyTypes). filterOnly networkPartnerCombinedIds are not returned. */
  includeFacets: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to janitors.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  janitorsNames: string[];
  /** Maps to networkPartnerAccounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAccountingNames: string[];
  /** Maps to networkPartnerAsset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAssetNames: string[];
  /**
   * filterOnly
   * Maps to networkPartners.combinedId. filterOnly facet. Empty = no filter.
   */
  networkPartnerCombinedIds: string[];
  /** Maps to objectCount. Searchable facet; typeahead is client-side. Empty = no filter. */
  objectCounts: number[];
  /** Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Maps to propertyType. Not-searchable facet. Empty = no filter. */
  propertyTypes: Propertyv2PropertyType[];
  /** Free-text search over numericId, name, address.street, address.streetNumber, address.streetAddition, address.zip and address.city. Empty = filter/sort only. */
  query: string;
  /** Maps to serviceProviders.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  serviceProvidersNames: string[];
  /** Primary sort by address.city. Tie breakers apply. At most one primary sort* should be set. */
  sortCity: SortSortOrder;
  /** Primary sort by name. Tie breakers apply. At most one primary sort* should be set. */
  sortName: SortSortOrder;
  /** Primary sort by objectCount. Tie breakers apply. At most one primary sort* should be set. */
  sortObjectCount: SortSortOrder;
  /** Primary sort by owner.name. Tie breakers apply. At most one primary sort* should be set. */
  sortOwnerName: SortSortOrder;
  /**
   * sortable (default primary order when none set: buildingStrategy.reviewAtSortValue, owner.name, name, address.city, address.zip, address.street, address.streetNumber, objectCount)
   * Primary sort by buildingStrategy.reviewAtSortValue. Default when no sort* is set starts with reviewAtSortValue ASC. At most one primary sort* should be set.
   */
  sortReviewAt: SortSortOrder;
  /** Primary sort by address.street. Tie breakers apply. At most one primary sort* should be set. */
  sortStreet: SortSortOrder;
  /** Primary sort by address.streetNumber. Tie breakers apply. At most one primary sort* should be set. */
  sortStreetNumber: SortSortOrder;
  /** Primary sort by address.zip. Tie breakers apply. At most one primary sort* should be set. */
  sortZip: SortSortOrder;
  /** Maps to address.zip. Searchable facet; typeahead is client-side. Empty = no filter. */
  zips: string[];
}

export interface SearchListBuildingsResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchBuildingFacets;
  hits: SearchBuildingHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchListCondominiumsRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /** Maps to obj.assignees.accounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAccountingNames: string[];
  /** Maps to obj.assignees.administration.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAdministrationNames: string[];
  /** Maps to obj.assignees.asset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAssetNames: string[];
  /** Maps to obj.assignees.marketing.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeMarketingNames: string[];
  /** Maps to obj.assignees.owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeOwnerNames: string[];
  /**
   * facets without free-text typeahead
   * Maps to obj.category. Not-searchable facet. Empty = no filter.
   */
  categories: ObjectCategory[];
  /**
   * filterOnly
   * Maps to closed. filterOnly facet. Unset = no filter.
   */
  closed: boolean;
  /** Maps to obj.floor (decimalFloor). Not-searchable facet. Empty = no filter. */
  floors: number[];
  /** When true, response includes facet buckets. filterOnly facets are not returned. */
  includeFacets: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to obj.networkPartners.combinedId. filterOnly facet. Empty = no filter. */
  networkPartnerCombinedIds: string[];
  /** Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Maps to preferredCommunicationChannel. Not-searchable facet. Empty = no filter. */
  preferredCommunicationChannels: V2PreferredCommunicationChannel[];
  /** Free-text search over condominiumOwners.name, billingContact.name, tenants.name, roommates.name, numericId, obj.numericId, obj.address.street/streetNumber/mailbox/subUnit/streetAddition/zip/city. Empty = filter/sort only. */
  query: string;
  /** Maps to obj.rooms. Searchable facet; typeahead is client-side. Empty = no filter. */
  rooms: number[];
  /**
   * sortable (default: numericId ASC)
   * Primary sort by numericId. Default when unset is numericId ASC.
   */
  sortNumericId: SortSortOrder;
  /** Maps to status (denormalized label). Not-searchable facet. Empty = no filter. */
  statuses: string[];
  /** Maps to obj.tags. Searchable facet; typeahead is client-side. Empty = no filter. */
  tags: string[];
  /**
   * searchable facets (typeahead client-side)
   * Maps to obj.address.zip. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  zips: string[];
}

export interface SearchListCondominiumsResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchCondominiumFacets;
  hits: SearchCondominiumHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchListContactsRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /**
   * filterOnly facets
   * filterOnly facet. Unset = no filter.
   */
  active: boolean;
  /** Maps to contactPersons.hasEmail. filterOnly facet. Unset = no filter. */
  contactPersonsHasEmail: boolean;
  /** filterOnly facet. Unset = no filter. */
  hasEmail: boolean;
  /** When true, response includes facet buckets for non-filterOnly facets (industries, preferredCommunicationChannels, types, ownerNames, tags). */
  includeFacets: boolean;
  /**
   * not searchable facets
   * Not-searchable facet. Empty = no filter.
   */
  industries: IndustryIndustry[];
  /** filterOnly facet. Unset = no filter. */
  isCompany: boolean;
  /** filterOnly facet. Unset = no filter. */
  isEmployee: boolean;
  /** filterOnly facet. Unset = no filter. */
  isOnlyInterestedParty: boolean;
  /** filterOnly facet. Unset = no filter. */
  isOwner: boolean;
  /** filterOnly facet. Unset = no filter. */
  isTenant: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to owner.id. filterOnly facet. Empty = no filter. */
  ownerIds: string[];
  /**
   * searchable facets
   * Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Not-searchable facet. Empty = no filter. */
  preferredCommunicationChannels: V2PreferredCommunicationChannel[];
  /** Free-text search over searchable attributes (includes owner.name and tags). Empty = filter/sort only. */
  query: string;
  /** Primary sort. Tie breakers apply. At most one primary sort* should be set. */
  sortEmail: SortSortOrder;
  /** Primary sort. Default when no sort* is set: name ASC, then email ASC. At most one primary sort* should be set. */
  sortName: SortSortOrder;
  /** Primary sort. Tie breakers: name ASC, then email ASC. At most one primary sort* should be set. */
  sortNumericId: SortSortOrder;
  /** Primary sort by owner.name. Tie breakers: name ASC, then email ASC. At most one primary sort* should be set. */
  sortOwnerName: SortSortOrder;
  /** Searchable facet; typeahead is client-side. Empty = no filter. */
  tags: string[];
  /** Not-searchable facet. Empty = no filter. */
  types: Contactcontactv2Type[];
}

export interface SearchListContactsResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchContactFacets;
  hits: SearchContactHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchListObjectsRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /** Maps to assignees.accounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAccountingNames: string[];
  /** Maps to assignees.administration.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAdministrationNames: string[];
  /** Maps to assignees.asset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAssetNames: string[];
  /** Maps to assignees.marketing.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeMarketingNames: string[];
  /** Maps to assignees.owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeOwnerNames: string[];
  /**
   * facets without free-text typeahead
   * Maps to assignees.viewingAppointment.name. Not-searchable facet. Empty = no filter.
   */
  assigneeViewingAppointmentNames: string[];
  /**
   * filterOnly
   * Maps to buildingId. filterOnly facet. Empty = no filter.
   */
  buildingIds: string[];
  /** Maps to building.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  buildingNames: string[];
  /** Maps to category. Not-searchable facet. Empty = no filter. */
  categories: ObjectCategory[];
  /**
   * searchable facets (typeahead client-side)
   * Maps to address.city. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  cities: string[];
  /** Maps to condominiumOwnership. filterOnly facet. Unset = no filter. */
  condominiumOwnership: boolean;
  /** Maps to floor (decimalFloor). Not-searchable facet. Empty = no filter. */
  floors: number[];
  /** Maps to futureRentalStatus. Not-searchable facet. Empty = no filter. */
  futureRentalStatuses: string[];
  /** Maps to inMarketingStatus (e.g. online/offline/no). Searchable facet; typeahead is client-side. Empty = no filter. */
  inMarketingStatuses: string[];
  /** Maps to inactive. filterOnly facet. Unset = no filter. */
  inactive: boolean;
  /** When true, response includes facet buckets. filterOnly facets are not returned. */
  includeFacets: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to marketingStatus.inMarketing. Not-searchable facet. Unset = no filter. */
  marketingStatusInMarketing: boolean;
  /** Maps to marketingStatus.newInMarketing. Not-searchable facet. Unset = no filter. */
  marketingStatusNewInMarketing: boolean;
  /** Maps to marketingStatus.published. Not-searchable facet. Unset = no filter. */
  marketingStatusPublished: boolean;
  /** Maps to marketingStatus.status. Not-searchable facet. Empty = no filter. */
  marketingStatusStatuses: string[];
  /** Maps to marketingStatus.vacantAt. filterOnly facet. Empty = no filter. */
  marketingStatusVacantAts: string[];
  /** Maps to networkPartnerAccounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAccountingNames: string[];
  /** Maps to networkPartnerAdministration.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAdministrationNames: string[];
  /** Maps to networkPartnerAsset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAssetNames: string[];
  /** Maps to networkPartners.combinedId. filterOnly facet. Empty = no filter. */
  networkPartnerCombinedIds: string[];
  /** Maps to networkPartnerMarketing.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerMarketingNames: string[];
  /** Maps to networkPartners.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerNames: string[];
  /** Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Maps to preferredCommunicationChannel. Not-searchable facet. Empty = no filter. */
  preferredCommunicationChannels: V2PreferredCommunicationChannel[];
  /** Maps to property.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  propertyNames: string[];
  /** Free-text search over numericId, number, publicId, name, address.street/streetNumber/streetAddition/zip/city, tenancy.tenants.name, networkPartners.name, condominium.owner, condominium.tenants and tenancy.subTenants.tenant.name. Empty = filter/sort only. */
  query: string;
  /** Maps to requestStatistics.status. Not-searchable facet. Empty = no filter. */
  requestStatisticsStatuses: string[];
  /** Maps to rooms. Searchable facet; typeahead is client-side. Empty = no filter. */
  rooms: number[];
  /** Primary sort by categorySortValue. Tie breakers apply. At most one primary sort* should be set. */
  sortCategory: SortSortOrder;
  /** Primary sort by floorSortValue. Tie breakers apply. At most one primary sort* should be set. */
  sortFloor: SortSortOrder;
  /**
   * sortable (default primary order when none set: inactive, categorySortValue, floorSortValue, name)
   * Primary sort by inactive. Default when no sort* is set starts with inactive ASC. At most one primary sort* should be set.
   */
  sortInactive: SortSortOrder;
  /** Primary sort by name. Tie breakers apply. At most one primary sort* should be set. */
  sortName: SortSortOrder;
  /** Maps to status. Not-searchable facet. Empty = no filter. */
  statuses: string[];
  /** Maps to subCategories. Searchable facet; typeahead is client-side. Empty = no filter. */
  subCategories: ObjectSubCategory[];
  /** Maps to tags. Searchable facet; typeahead is client-side. Empty = no filter. */
  tags: string[];
  /** Maps to tenancy.activatedAndTenancy. filterOnly facet. Unset = no filter. */
  tenancyActivatedAndTenancy: boolean;
  /** Maps to tenancy.notActivatedAndTenancy. filterOnly facet. Unset = no filter. */
  tenancyNotActivatedAndTenancy: boolean;
  /** Maps to tenancy.tenants.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  tenantNames: string[];
  /** Maps to address.zip. Searchable facet; typeahead is client-side. Empty = no filter. */
  zips: string[];
}

export interface SearchListObjectsResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchObjectFacets;
  hits: SearchObjectHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchListPropertiesRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /** Maps to assignees.accounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAccountingNames: string[];
  /** Maps to assignees.administration.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAdministrationNames: string[];
  /** Maps to assignees.asset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAssetNames: string[];
  /** Maps to assignees.owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeOwnerNames: string[];
  /**
   * facets without free-text typeahead
   * Maps to buildingCount. Not searchable for typeahead. Empty = no filter.
   */
  buildingCounts: number[];
  /**
   * searchable facets (typeahead client-side)
   * Maps to address.city. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  cities: string[];
  /** When true, response includes facet buckets (cities, zips, assignee/owner/network-partner names, buildingCounts, types). filterOnly networkPartnerCombinedIds are not returned. */
  includeFacets: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to networkPartnerAccounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAccountingNames: string[];
  /** Maps to networkPartnerAsset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAssetNames: string[];
  /**
   * filterOnly
   * Maps to networkPartners.combinedId. filterOnly facet. Empty = no filter.
   */
  networkPartnerCombinedIds: string[];
  /** Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Free-text search over numericId, name, address.zip and address.city. Empty = filter/sort only. */
  query: string;
  /** Primary sort by buildingCount. Tie breakers apply. At most one primary sort* should be set. */
  sortBuildingCount: SortSortOrder;
  /** Primary sort by address.city. Tie breakers apply. At most one primary sort* should be set. */
  sortCity: SortSortOrder;
  /** Primary sort by name. Tie breakers apply. At most one primary sort* should be set. */
  sortName: SortSortOrder;
  /**
   * sortable (default primary order when none set: owner.name, name, address.city, address.zip, buildingCount)
   * Primary sort by owner.name. Default when no sort* is set starts with owner.name ASC. At most one primary sort* should be set.
   */
  sortOwnerName: SortSortOrder;
  /** Primary sort by address.zip. Tie breakers apply. At most one primary sort* should be set. */
  sortZip: SortSortOrder;
  /** Maps to type. Not-searchable facet. Empty = no filter. */
  types: Propertyv2PropertyType[];
  /** Maps to address.zip. Searchable facet; typeahead is client-side. Empty = no filter. */
  zips: string[];
}

export interface SearchListPropertiesResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchPropertyFacets;
  hits: SearchPropertyHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchListTenanciesRequest {
  /**
   * Must match auth. Used for the allowedAccountIds ACL filter.
   * @format int64
   */
  accountId: string;
  /** Maps to obj.assignees.accounting.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAccountingNames: string[];
  /** Maps to obj.assignees.administration.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAdministrationNames: string[];
  /** Maps to obj.assignees.asset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeAssetNames: string[];
  /** Maps to obj.assignees.marketing.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeMarketingNames: string[];
  /** Maps to obj.assignees.owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  assigneeOwnerNames: string[];
  /**
   * searchable facets (typeahead client-side)
   * Maps to building.name. Searchable facet; typeahead is client-side. Empty = no filter.
   */
  buildingNames: string[];
  /**
   * facets without free-text typeahead
   * Maps to obj.category. Not-searchable facet. Empty = no filter.
   */
  categories: ObjectCategory[];
  /** Maps to obj.address.city. Searchable facet; typeahead is client-side. Empty = no filter. */
  cities: string[];
  /**
   * filterOnly
   * Maps to closed. filterOnly facet. Unset = no filter.
   */
  closed: boolean;
  /** Maps to endingAtFilter (month/year, e.g. 3/2024). Searchable facet; typeahead is client-side. Empty = no filter. */
  endingAtFilters: string[];
  /** Maps to endingAt (year/month/day). filterOnly facet. Empty = no filter. */
  endingAts: SearchObjectHitDate[];
  /** Maps to obj.floor (decimalFloor). Not-searchable facet. Empty = no filter. */
  floors: number[];
  /** When true, response includes facet buckets. filterOnly facets are not returned. */
  includeFacets: boolean;
  /**
   * Only used when page is set.
   * @format int32
   */
  itemsPerPage: number;
  /** Maps to obj.networkPartnerAsset.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  networkPartnerAssetNames: string[];
  /** Maps to obj.networkPartners.combinedId. filterOnly facet. Empty = no filter. */
  networkPartnerCombinedIds: string[];
  /** Maps to obj.id. filterOnly facet. Empty = no filter. */
  objectIds: string[];
  /** Maps to owner.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  ownerNames: string[];
  /**
   * 1-based. Leave out or set to 0 to disable pagination.
   * @format int32
   */
  page: number;
  /** Maps to preferredCommunicationChannel. Not-searchable facet. Empty = no filter. */
  preferredCommunicationChannels: V2PreferredCommunicationChannel[];
  /** Maps to property.name. Searchable facet; typeahead is client-side. Empty = no filter. */
  propertyNames: string[];
  /** Free-text search over tenants.name, subTenants.tenant.name, numericId, obj.numericId, obj.address.street/streetNumber/mailbox/subUnit/streetAddition/zip/city. Empty = filter/sort only. */
  query: string;
  /** Maps to obj.rooms. Searchable facet; typeahead is client-side. Empty = no filter. */
  rooms: number[];
  /** Primary sort by obj.categorySortValue. Tie breakers apply. At most one primary sort* should be set. */
  sortCategory: SortSortOrder;
  /** Primary sort by obj.floorSortValue. Tie breakers apply. At most one primary sort* should be set. */
  sortFloor: SortSortOrder;
  /** Primary sort by startingAtTimestamp. Tie breakers apply. At most one primary sort* should be set. */
  sortStartingAt: SortSortOrder;
  /**
   * sortable (default primary order when none set: tenantNameSortValue, obj.categorySortValue, obj.floorSortValue, startingAtTimestamp)
   * Primary sort by tenantNameSortValue. Default when no sort* is set starts with tenantNameSortValue ASC. At most one primary sort* should be set.
   */
  sortTenantName: SortSortOrder;
  /** Maps to startingAtFilter (month/year, e.g. 3/2024). Searchable facet; typeahead is client-side. Empty = no filter. */
  startingAtFilters: string[];
  /** Maps to startingAt (year/month/day). filterOnly facet. Empty = no filter. */
  startingAts: SearchObjectHitDate[];
  /** Maps to status (denormalized label, e.g. current/temporary/closed). Not-searchable facet. Empty = no filter. */
  statuses: string[];
  /** Maps to obj.tags. Searchable facet; typeahead is client-side. Empty = no filter. */
  tags: string[];
  /** Maps to vacancy. filterOnly facet. Unset = no filter. */
  vacancy: boolean;
  /** Maps to obj.address.zip. Searchable facet; typeahead is client-side. Empty = no filter. */
  zips: string[];
}

export interface SearchListTenanciesResponse {
  /** Only set when includeFacets is true. filterOnly facets are not returned. */
  facets: SearchTenancyFacets;
  hits: SearchTenancyHit[];
  /**
   * Total matches before pagination.
   * @format int32
   */
  totalCount: number;
  /** @format int32 */
  totalPageCount: number;
}

export interface SearchObjectAddress {
  city: string;
  country: string;
  mailbox: string;
  state: string;
  street: string;
  streetAddition: string;
  streetNumber: string;
  subUnit: string;
  zip: string;
}

export interface SearchObjectAssignee {
  active: boolean;
  contactId: string;
  name: string;
}

export interface SearchObjectAssignees {
  accounting: SearchObjectAssignee;
  administration: SearchObjectAssignee;
  asset: SearchObjectAssignee;
  marketing: SearchObjectAssignee;
  owner: SearchObjectAssignee;
  viewingAppointment: SearchObjectAssignee;
}

export interface SearchObjectCategoryFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: ObjectCategory;
}

export interface SearchObjectContactRef {
  contactId: string;
  name: string;
}

export interface SearchObjectFacets {
  /** Searchable facet; filter typeahead client-side. */
  assigneeAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAdministrationNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeMarketingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeOwnerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  assigneeViewingAppointmentNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  buildingNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  categories: SearchObjectCategoryFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  cities: SearchStringFacetValue[];
  /** Not-searchable facet (decimalFloor values). */
  floors: SearchDoubleFacetValue[];
  /** Not-searchable facet. */
  futureRentalStatuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  inMarketingStatuses: SearchStringFacetValue[];
  /** Not-searchable facet. */
  marketingStatusInMarketings: SearchBoolFacetValue[];
  /** Not-searchable facet. */
  marketingStatusNewInMarketings: SearchBoolFacetValue[];
  /** Not-searchable facet. */
  marketingStatusPublisheds: SearchBoolFacetValue[];
  /** Not-searchable facet. */
  marketingStatusStatuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAdministrationNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerMarketingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  preferredCommunicationChannels: SearchPreferredCommunicationChannelFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  propertyNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  requestStatisticsStatuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  rooms: SearchDoubleFacetValue[];
  /** Not-searchable facet. */
  statuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  subCategories: SearchObjectSubCategoryFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  tags: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  tenantNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  zips: SearchStringFacetValue[];
}

export interface SearchObjectHit {
  address: SearchObjectAddress;
  assignees: SearchObjectAssignees;
  building: SearchObjectNamedRef;
  buildingId: string;
  category: ObjectCategory;
  /** @format int32 */
  categorySortValue: number;
  condominium: SearchObjectHitCondominium;
  condominiumOwnership: boolean;
  debitUntil: SearchObjectHitDate;
  /** @format int64 */
  debitUntilFilter: string;
  /** @format double */
  effectiveArea: number;
  exportPlatforms: string[];
  /**
   * Maps to object characteristics decimalFloor (may be fractional).
   * @format double
   */
  floor: number;
  /** @format double */
  floorSortValue: number;
  futureRentalStatus: string;
  futureTenancy: SearchObjectHitFutureTenancy;
  hasActivatedTenancy: boolean;
  /** Previously Algolia objectID. */
  id: string;
  images: SearchObjectImage[];
  inMarketingStatus: string;
  inactive: boolean;
  /** @format int64 */
  inactiveDate: string;
  /** @format double */
  livingArea: number;
  /** @format double */
  marketRent: number;
  marketingStatus: SearchObjectHitMarketingStatus;
  name: string;
  networkPartnerAccounting: SearchObjectNetworkPartnerAccount;
  networkPartnerAdministration: SearchObjectNetworkPartnerAccount;
  networkPartnerAsset: SearchObjectNetworkPartnerAccount;
  networkPartnerMarketing: SearchObjectNetworkPartnerAccount;
  networkPartners: SearchObjectNetworkPartner[];
  number: string;
  /** @format int64 */
  numericId: string;
  owner: SearchObjectOwner;
  positions: string[];
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  pricing: SearchObjectPricing;
  property: SearchObjectNamedRef;
  publicId: string;
  requestStatistics: SearchObjectHitRequestStatistics;
  /** @format double */
  rooms: number;
  /** Denormalized rental/condominium status label (Algolia string). */
  status: string;
  subCategories: ObjectSubCategory[];
  tags: string[];
  tenancy: SearchObjectHitTenancy;
  /** @format double */
  valueQuota: number;
  valueQuotaWithTotal: string;
}

export interface SearchObjectHitCondominium {
  billingContact: SearchObjectContactRef;
  condominiumId: string;
  correspondenceContact: SearchObjectContactRef;
  /** @format int64 */
  endingAt: string;
  owner: SearchObjectContactRef[];
  roommates: SearchObjectContactRef[];
  /** @format int64 */
  startingAt: string;
  tenants: SearchObjectContactRef[];
}

export interface SearchObjectHitDate {
  /** @format int32 */
  day: number;
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
}

export interface SearchObjectHitFutureTenancy {
  startingAt: SearchObjectHitDate;
}

export interface SearchObjectHitMarketingStatus {
  inMarketing: boolean;
  /** @format int64 */
  markedAsSeenAt: string;
  /** @format int64 */
  markedForMarketingAt: string;
  marketingNote: string;
  newInMarketing: boolean;
  published: boolean;
  /** @format int64 */
  publishedAt: string;
  rented: boolean;
  /** @format int64 */
  setVacantAt: string;
  specialPublication: SearchObjectHitSpecialPublication;
  /** @format int64 */
  startMarketingAt: string;
  status: string;
  /** @format int64 */
  unPublishedAt: string;
  /** @format int64 */
  vacantAt: string;
}

export interface SearchObjectHitRequestStatistics {
  /** @format int32 */
  applicationsReceived: number;
  /** @format int32 */
  appointmentsDone: number;
  hasNew: boolean;
  hasNewOrUnread: boolean;
  hasUnread: boolean;
  /** @format int64 */
  lastModified: string;
  /** @format int32 */
  new: number;
  /** @format int32 */
  overall: number;
  status: string;
  /** @format int32 */
  unread: number;
}

export interface SearchObjectHitSpecialPublication {
  /** @format int32 */
  exclusiveDays: number;
  /** @format int64 */
  exclusiveUntil: string;
  exclusivity: boolean;
  platform: string;
  /** @format int64 */
  promotedAt: string;
  /** @format int32 */
  promotedDays: number;
  /** @format int64 */
  promotedUntil: string;
  promotion: boolean;
  promotionType: string;
}

export interface SearchObjectHitSubTenancy {
  endingAt: SearchObjectHitDate;
  startingAt: SearchObjectHitDate;
  tenant: SearchObjectContactRef[];
}

export interface SearchObjectHitTenancy {
  /** filterOnly facet path tenancy.activatedAndTenancy. */
  activatedAndTenancy: boolean;
  /** @format double */
  additionalCosts: number;
  /** @format double */
  additionalCostsPerMonth: number;
  billingContact: SearchObjectContactRef;
  /** @format double */
  coldRent: number;
  /** @format double */
  coldRentM2PerYear: number;
  /** @format double */
  coldRentPerMonth: number;
  correspondenceContact: SearchObjectContactRef;
  dueDate: number[];
  endingAt: SearchObjectHitDate;
  /** @format double */
  grossRent: number;
  /** @format double */
  grossRentPerMonth: number;
  guarantors: SearchObjectContactRef[];
  nextPossibleMoveInAt: SearchObjectHitDate;
  /** @format int64 */
  nextPossibleMoveInAtSortValue: string;
  notActivatedAndTenancy: boolean;
  opted: boolean;
  /** @format double */
  rentReduction: number;
  startingAt: SearchObjectHitDate;
  subTenants: SearchObjectHitSubTenancy[];
  taxable: boolean;
  tenancyId: string;
  tenants: SearchObjectContactRef[];
  terminationReasons: string[];
  unjustifiedUseFrom: SearchObjectHitDate;
  unjustifiedUseUntil: SearchObjectHitDate;
  vacancy: boolean;
  vacancyReason: string;
}

export interface SearchObjectImage {
  /** @format int32 */
  order: number;
  thumbnailMUrl: string;
  thumbnailSUrl: string;
  url: string;
}

export interface SearchObjectNamedRef {
  name: string;
  /** @format int64 */
  numericId: string;
}

export interface SearchObjectNetworkPartner {
  /** @format int64 */
  accountId: string;
  /** Format: {targetAccountId}-{scopeString}. */
  combinedId: string;
  name: string;
  scope: string;
}

export interface SearchObjectNetworkPartnerAccount {
  /** @format int64 */
  accountId: string;
  name: string;
}

export interface SearchObjectOwner {
  /** @format int64 */
  id: string;
  name: string;
}

export interface SearchObjectPricing {
  /** @format double */
  additionalCosts: number;
  /** @format double */
  grossRent: number;
  /** @format double */
  marketGrossRent: number;
  /** @format double */
  marketNetRent: number;
  /** @format double */
  netRent: number;
  /** @format double */
  targetGrossRent: number;
  /** @format double */
  targetNetRent: number;
}

export interface SearchObjectSubCategoryFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: ObjectSubCategory;
}

export interface SearchPreferredCommunicationChannelFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: V2PreferredCommunicationChannel;
}

export interface SearchPropertyAddress {
  city: string;
  country: string;
  state: string;
  zip: string;
}

export interface SearchPropertyAssignee {
  active: boolean;
  contactId: string;
  name: string;
}

export interface SearchPropertyAssignees {
  accounting: SearchPropertyAssignee;
  administration: SearchPropertyAssignee;
  asset: SearchPropertyAssignee;
  owner: SearchPropertyAssignee;
}

export interface SearchPropertyBankInfo {
  typeOfUseForInsurance: string;
  useForInsurancePurposes: boolean;
}

export interface SearchPropertyFacets {
  /** Searchable facet; filter typeahead client-side. */
  assigneeAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAdministrationNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeOwnerNames: SearchStringFacetValue[];
  /** Not searchable for typeahead. */
  buildingCounts: SearchInt32FacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  cities: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  types: SearchPropertyTypeFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  zips: SearchStringFacetValue[];
}

export interface SearchPropertyHit {
  /** @format double */
  actualGross: number;
  /** @format double */
  actualNet: number;
  address: SearchPropertyAddress;
  aicSyncMode: Record<string, string>;
  assignees: SearchPropertyAssignees;
  bankInfo: SearchPropertyBankInfo[];
  /** @format int32 */
  buildingCount: number;
  buildingIds: string[];
  /** @format double */
  grossOverallRentPerYear: number;
  /** Previously Algolia objectID. */
  id: string;
  imageUrl: string;
  name: string;
  /** @format double */
  netOverallRentPerYear: number;
  networkPartnerAccounting: SearchPropertyNetworkPartnerAccount;
  networkPartnerAsset: SearchPropertyNetworkPartnerAccount;
  networkPartners: SearchPropertyNetworkPartner[];
  /** @format int64 */
  numericId: string;
  /** @format int32 */
  objectCount: number;
  objectIds: string[];
  owner: SearchPropertyOwner;
  portalEnabled: boolean;
  /** @format double */
  targetGross: number;
  targetIncomplete: boolean;
  /** @format double */
  targetNet: number;
  thumbnailMUrl: string;
  thumbnailSUrl: string;
  transferToAccounting: boolean;
  type: Propertyv2PropertyType;
}

export interface SearchPropertyNetworkPartner {
  /** Format: {targetAccountId}-{scopeString}. */
  combinedId: string;
}

export interface SearchPropertyNetworkPartnerAccount {
  /** @format int64 */
  accountId: string;
  name: string;
}

export interface SearchPropertyOwner {
  /** @format int64 */
  id: string;
  name: string;
}

export interface SearchPropertyTypeFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: Propertyv2PropertyType;
}

export interface SearchSearchIdsResponse {
  ids: string[];
}

/** @default "UNDEFINED_SEARCH_INDEX" */
export enum SearchSearchIndex {
  UNDEFINED_SEARCH_INDEX = "UNDEFINED_SEARCH_INDEX",
  CONTACT_SEARCH_INDEX = "CONTACT_SEARCH_INDEX",
  PROPERTY_SEARCH_INDEX = "PROPERTY_SEARCH_INDEX",
  BUILDING_SEARCH_INDEX = "BUILDING_SEARCH_INDEX",
  OBJECT_SEARCH_INDEX = "OBJECT_SEARCH_INDEX",
  TENANCY_SEARCH_INDEX = "TENANCY_SEARCH_INDEX",
  CONDOMINIUM_SEARCH_INDEX = "CONDOMINIUM_SEARCH_INDEX",
  TICKET_SEARCH_INDEX = "TICKET_SEARCH_INDEX",
}

export interface SearchStringFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  value: string;
}

export interface SearchTenancyFacets {
  /** Searchable facet; filter typeahead client-side. */
  assigneeAccountingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAdministrationNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeMarketingNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  assigneeOwnerNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  buildingNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  categories: SearchObjectCategoryFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  cities: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  endingAtFilters: SearchStringFacetValue[];
  /** Not-searchable facet (obj.floor / decimalFloor). */
  floors: SearchDoubleFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  networkPartnerAssetNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  ownerNames: SearchStringFacetValue[];
  /** Not-searchable facet. */
  preferredCommunicationChannels: SearchPreferredCommunicationChannelFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  propertyNames: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  rooms: SearchDoubleFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  startingAtFilters: SearchStringFacetValue[];
  /** Not-searchable facet. */
  statuses: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  tags: SearchStringFacetValue[];
  /** Searchable facet; filter typeahead client-side. */
  zips: SearchStringFacetValue[];
}

export interface SearchTenancyHit {
  /** @format double */
  additionalCosts: number;
  /** @format double */
  additionalCostsPerMonth: number;
  billingContact: SearchObjectContactRef;
  building: SearchObjectNamedRef;
  closed: boolean;
  /** @format double */
  coldRent: number;
  /** @format double */
  coldRentM2PerYear: number;
  /** @format double */
  coldRentPerMonth: number;
  contractType: string;
  correspondenceContact: SearchObjectContactRef;
  dueDate: number[];
  endingAt: SearchObjectHitDate;
  /** month/year label, e.g. 3/2024. */
  endingAtFilter: string;
  /** @format double */
  grossRent: number;
  /** @format double */
  grossRentPerMonth: number;
  guarantors: SearchObjectContactRef[];
  /** Previously Algolia objectID (tenancy id). */
  id: string;
  /** @format int64 */
  numericId: string;
  obj: SearchTenancyHitObject;
  opted: boolean;
  owner: SearchObjectOwner;
  preferredCommunicationChannel: V2PreferredCommunicationChannel;
  property: SearchObjectNamedRef;
  /** @format double */
  rentReduction: number;
  startingAt: SearchObjectHitDate;
  /** month/year label, e.g. 3/2024. */
  startingAtFilter: string;
  /**
   * Unix seconds used for default/primary starting-at sort. Missing startingAt uses -1.
   * @format int64
   */
  startingAtTimestamp: string;
  /** Denormalized status label (Algolia string), e.g. current/temporary/closed. */
  status: string;
  subTenants: SearchTenancyHitSubTenancy[];
  taxable: boolean;
  tenantNameSortValue: string;
  tenants: SearchObjectContactRef[];
  unjustifiedUseFrom: SearchObjectHitDate;
  unjustifiedUseUntil: SearchObjectHitDate;
  vacancy: boolean;
}

export interface SearchTenancyHitObject {
  address: SearchObjectAddress;
  assignees: SearchObjectAssignees;
  buildingId: string;
  category: ObjectCategory;
  /** @format int32 */
  categorySortValue: number;
  /** @format double */
  effectiveArea: number;
  /**
   * Object characteristics decimalFloor (may be fractional).
   * @format double
   */
  floor: number;
  /** @format double */
  floorSortValue: number;
  id: string;
  /** @format double */
  livingArea: number;
  name: string;
  networkPartnerAsset: SearchObjectNetworkPartnerAccount;
  networkPartners: SearchObjectNetworkPartner[];
  number: string;
  /** @format int64 */
  numericId: string;
  pricing: SearchTenancyHitObjectPricing;
  /** @format double */
  rooms: number;
  subCategories: ObjectSubCategory[];
  tags: string[];
}

export interface SearchTenancyHitObjectPricing {
  /** @format double */
  marketGrossRent: number;
  /** @format double */
  marketNetRent: number;
  /** @format double */
  targetGrossRent: number;
  /** @format double */
  targetNetRent: number;
}

export interface SearchTenancyHitSubTenancy {
  endingAt: SearchObjectHitDate;
  startingAt: SearchObjectHitDate;
  tenant: SearchObjectContactRef[];
}

export interface SearchTypeFacetValue {
  /**
   * Matches under the current filters.
   * @format int32
   */
  count: number;
  /**
   * Type defines the general contact-type for individuals, not companies.
   * A contact can have multiple types.
   */
  value: Contactcontactv2Type;
}

export interface SearchUpdateOngoingRequest {
  entityIds: string[];
}

export interface SearchUpdateOngoingResponse {
  ongoing: boolean;
}

export interface SearchsearchBuildingContact {
  contactId: string;
  name: string;
}

export interface SearchtableLoadSettingsResponse {
  tableSettings: TableTableSettings[];
}

export interface SearchtableSaveSettingsRequest {
  /** @format int64 */
  accountId: string;
  columns: string[];
  table: string;
}

export interface SearchtableSaveSettingsResponse {
  tableSettings: TableTableSettings;
}

export interface TableTableSettings {
  /** @format int64 */
  accountId: string;
  columns: string[];
  id: string;
  table: string;
}

export interface ShareAllowedAccountIdsEntry {
  allowedAccountIds: string[];
  entityId: string;
}

export interface ShareListAllowedAccountIdsRequest {
  entityIds: string[];
}

export interface ShareListAllowedAccountIdsResponse {
  result: ShareAllowedAccountIdsEntry[];
}

export interface ShareListByAccountIdsResponse {
  shares: ShareShare[];
}

export interface ShareListByResourceRequest {
  resourceIds: string[];
}

export interface ShareListByResourceResponse {
  shares: ShareShare[];
}

export interface ShareListBySubResourceIdsRequest {
  subResourceIds: string[];
}

export interface ShareListBySubResourceIdsResponse {
  shares: ShareShare[];
}

export interface ShareListByTargetAccountIdResponse {
  shares: ShareShare[];
}

export interface ShareListIdsByTargetAccountIdResponse {
  ids: string[];
}

export interface ShareListOwnersResponse {
  sourceAccountIds: string[];
}

export interface ShareListPartnersOfAssetResponse {
  partnerAccountIds: string[];
}

export interface ShareListPartnersResponse {
  targetAccountIds: string[];
}

export interface ShareListRootResourceIdsBySubResourceIdsResponse {
  rootResourceIds: string[];
}

export interface ShareListSubResourcesByResourceIdsRequest {
  resourceIds: string[];
  subResourceIdPrefixes: string[];
}

export interface ShareListSubResourcesByResourceIdsResponse {
  shares: ShareSubResourceShare[];
}

export interface ShareListSubResourcesByTargetAccountIdResponse {
  subResourceIds: string[];
}

export interface ShareListTargetAccountIdsBySubResourceIdsResponse {
  shares: ShareSubResourceShare[];
}

export interface ShareSetShareForOwnerRequest {
  /** @format int64 */
  ownerAccountId: string;
  scopes: ShareShareScope[];
  /** @format int64 */
  targetAccountId: string;
}

export interface ShareSetShareForOwnerResponse {
  shares: ShareShare[];
}

export interface ShareSetShareForOwnersRequest {
  ownerAccountIds: string[];
  scopes: ShareShareScope[];
  /** @format int64 */
  targetAccountId: string;
}

export interface ShareSetShareForOwnersResponse {
  shares: ShareShare[];
}

export interface ShareShare {
  resourceIds: string[];
  scope: ShareShareScope;
  /** @format int64 */
  sourceAccountId: string;
  /** @format int64 */
  targetAccountId: string;
}

export interface ShareSubResourceShare {
  /** @format int64 */
  sourceAccountId: string;
  subResourceId: string;
  targetAccountIds: string[];
}

export interface ShareUnsetRequest {
  resourceIds: string[];
  scopes: ShareShareScope[];
  /** @format int64 */
  sourceAccountId: string;
}

export type ShareUnsetResponse = object;

export interface ShareshareSetRequest {
  resourceIds: string[];
  scope: ShareShareScope;
  /** @format int64 */
  sourceAccountId: string;
  /** @format int64 */
  targetAccountId: string;
}

export interface ShareshareSetResponse {
  share: ShareShare;
}

export interface HistoryAssigneeChangedData {
  new: TicketticketAssignee;
  old: TicketticketAssignee;
}

export interface HistoryCommentDeletedData {
  comment: string;
}

export interface HistoryCommentEditedData {
  new: string;
  old: string;
}

export interface HistoryCommentNewData {
  comment: string;
  internal: boolean;
}

export interface HistoryConnectionsAddedData {
  references: TicketTicketReference[];
}

export interface HistoryConnectionsRemovedData {
  references: TicketTicketReference[];
}

export interface HistoryCorrespondencesChangedData {
  new: TicketCorrespondence[];
  old: TicketCorrespondence[];
}

export interface HistoryDescriptionChangedData {
  new: string;
  old: string;
}

export interface HistoryDueDateChanged {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  new: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  old: TypeDate;
}

export interface HistoryEditor {
  /** @format int64 */
  accountId: string;
  name: string;
  userId: string;
}

export interface HistoryExecutedFromChanged {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  new: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  old: TypeDate;
}

export interface HistoryFile {
  mediaId: string;
  name: string;
}

export interface HistoryFileAddedData {
  files: HistoryFile[];
}

export interface HistoryFileRemovedData {
  files: HistoryFile[];
}

/** @default "HISTORY_TYPE_TICKET_CREATED" */
export enum HistoryHistoryType {
  HISTORY_TYPE_TICKET_CREATED = "HISTORY_TYPE_TICKET_CREATED",
  HISTORY_TYPE_PRIORITY = "HISTORY_TYPE_PRIORITY",
  HISTORY_TYPE_ADDED_LINKS = "HISTORY_TYPE_ADDED_LINKS",
  HISTORY_TYPE_REMOVED_LINKS = "HISTORY_TYPE_REMOVED_LINKS",
  HISTORY_TYPE_TITLE = "HISTORY_TYPE_TITLE",
  HISTORY_TYPE_DESCRIPTION = "HISTORY_TYPE_DESCRIPTION",
  HISTORY_TYPE_ADDED_FILES = "HISTORY_TYPE_ADDED_FILES",
  HISTORY_TYPE_REMOVED_FILES = "HISTORY_TYPE_REMOVED_FILES",
  HISTORY_TYPE_ASSIGNEE = "HISTORY_TYPE_ASSIGNEE",
  HISTORY_TYPE_CORRESPONDENCES = "HISTORY_TYPE_CORRESPONDENCES",
  HISTORY_TYPE_DUE_DATE = "HISTORY_TYPE_DUE_DATE",
  HISTORY_TYPE_EXECUTED_FROM = "HISTORY_TYPE_EXECUTED_FROM",
  HISTORY_TYPE_STATUS = "HISTORY_TYPE_STATUS",
  HISTORY_TYPE_NEW_COMMENT = "HISTORY_TYPE_NEW_COMMENT",
  HISTORY_TYPE_EDITED_COMMENT = "HISTORY_TYPE_EDITED_COMMENT",
  HISTORY_TYPE_DELETED_COMMENT = "HISTORY_TYPE_DELETED_COMMENT",
  HISTORY_TYPE_ADDED_CONNECTIONS = "HISTORY_TYPE_ADDED_CONNECTIONS",
  HISTORY_TYPE_REMOVED_CONNECTIONS = "HISTORY_TYPE_REMOVED_CONNECTIONS",
  HISTORY_TYPE_TYPE = "HISTORY_TYPE_TYPE",
  HISTORY_TYPE_MAIL_LINKED = "HISTORY_TYPE_MAIL_LINKED",
  HISTORY_TYPE_CONTACT_PERSON_ON_SITE = "HISTORY_TYPE_CONTACT_PERSON_ON_SITE",
  HISTORY_TYPE_INVOICE_ADDED = "HISTORY_TYPE_INVOICE_ADDED",
  HISTORY_TYPE_INVOICE_DELETED = "HISTORY_TYPE_INVOICE_DELETED",
}

export interface HistoryLinksAddedData {
  links: TicketTicketLink[];
}

export interface HistoryLinksRemovedData {
  links: TicketTicketLink[];
}

export interface HistoryListChangesResponse {
  events: HistoryTicketChangedEvent[];
}

export interface HistoryMailLinkedData {
  subject: string;
  /** @format int64 */
  timestamp: string;
}

export interface HistoryOnSiteContactChangedData {
  new: TicketOnSiteContact;
  old: TicketOnSiteContact;
}

export interface HistoryPriorityChangedData {
  new: TicketTicketPriority;
  old: TicketTicketPriority;
}

export interface HistoryStatusChangedData {
  newStatus: TicketTicketStatus;
  oldStatus: TicketTicketStatus;
}

export interface HistoryTicketChangedEvent {
  assignee: HistoryAssigneeChangedData;
  commentDeleted: HistoryCommentDeletedData;
  commentEdited: HistoryCommentEditedData;
  commentNew: HistoryCommentNewData;
  connectionAdded: HistoryConnectionsAddedData;
  connectionRemoved: HistoryConnectionsRemovedData;
  correspondences: HistoryCorrespondencesChangedData;
  description: HistoryDescriptionChangedData;
  dueDate: HistoryDueDateChanged;
  editor: HistoryEditor;
  executeFrom: HistoryExecutedFromChanged;
  filesAdded: HistoryFileAddedData;
  filesRemoved: HistoryFileRemovedData;
  historyType: HistoryHistoryType;
  isNewInvoiceVersion: boolean;
  linksAdded: HistoryLinksAddedData;
  linksRemoved: HistoryLinksRemovedData;
  mailLinked: HistoryMailLinkedData;
  onSitePerson: HistoryOnSiteContactChangedData;
  priority: HistoryPriorityChangedData;
  status: HistoryStatusChangedData;
  /** @format int64 */
  timestamp: string;
  title: HistoryTitleChangedData;
  type: HistoryTypeChangedData;
}

export interface HistoryTitleChangedData {
  new: string;
  old: string;
}

export interface HistoryTypeChangedData {
  new: TicketTicketType;
  old: TicketTicketType;
}

export interface TicketAddInvoiceResponse {
  ticket: TicketTicket;
}

export interface TicketAddWatcherResponse {
  ticket: TicketTicket;
}

export interface TicketChangeStatusBulkRequest {
  ids: string[];
  status: TicketTicketStatus;
}

export type TicketChangeStatusBulkResponse = object;

export type TicketChangeStatusResponse = object;

export interface TicketChecklistItemTemplate {
  /** Ignored if useChecklistAssignee is set to true. */
  assigneeUserId: string;
  /** @format int32 */
  order: number;
  title: string;
  /** If true, the assignee is taken from the checklist ticket itself. */
  useChecklistAssignee: boolean;
}

export interface TicketChecklistTemplate {
  /** Ignored if usePropertyAssignee is set to true. */
  assigneeUserId: string;
  /** Deprecated. Use checklistItems instead. */
  checklistItemTitles: string[];
  checklistItems: TicketChecklistItemTemplate[];
  id: string;
  mediaIds: string[];
  name: string;
  /** @format int64 */
  ownerId: string;
  usePropertyAssignee: boolean;
}

export interface TicketCountEntry {
  /** @format int32 */
  orders: number;
  referenceId: string;
  /** @format int32 */
  tasks: number;
}

export interface TicketCountMyUnreadTicketsResponse {
  /** @format int32 */
  amount: number;
}

export interface TicketCountTicketsRequest {
  referenceIds: string[];
}

export interface TicketCountTicketsResponse {
  entries: TicketCountEntry[];
}

export interface TicketCreateChecklistTemplateRequest {
  /** Ignored if usePropertyAssignee is set to true. */
  assigneeUserId: string;
  /** Deprecated. Use checklistItems instead. */
  checklistItemTitles: string[];
  checklistItems: TicketChecklistItemTemplate[];
  mediaIds: string[];
  name: string;
  /** @format int64 */
  ownerId: string;
  usePropertyAssignee: boolean;
}

export interface TicketCreateChecklistTemplateResponse {
  template: TicketChecklistTemplate;
}

export type TicketDeleteChecklistTemplatesResponse = object;

export interface TicketDeleteInvoiceResponse {
  ticket: TicketTicket;
}

export interface TicketEnableTicketingRequest {
  /** @format int64 */
  accountId: string;
  enable: boolean;
}

export type TicketEnableTicketingResponse = object;

export interface TicketGetByKeyResponse {
  ticket: TicketTicket;
}

export interface TicketGetNotificationMailboxResponse {
  mailboxId: string;
}

export interface TicketGetTicketStatisticsResponse {
  closedTickets: TicketTicketPriorityGrouped;
  /** @format int32 */
  countOverall: number;
  doneTickets: TicketTicketPriorityGrouped;
  inProgressTickets: TicketTicketPriorityGrouped;
  openTickets: TicketTicketPriorityGrouped;
}

export interface TicketHasTicketingEnabledResponse {
  enabled: boolean;
}

export interface TicketIsContactInUseResponse {
  inUse: boolean;
}

export interface TicketListAllSchedulesResponse {
  schedules: TicketticketSchedule[];
}

export interface TicketListByQueryResponse {
  tickets: TicketTicket[];
}

export interface TicketListChecklistTemplatesResponse {
  templates: TicketChecklistTemplate[];
}

export interface TicketListMyTicketsRequest {
  /** Optional filter parameter */
  assigneeUserIds?: string[];
  closedOnly: boolean;
  /** Optional filter parameter */
  correspondenceContactIds?: string[];
  /** Optional filter parameter */
  creatorUserIds?: string[];
  directReferenceIdsOnly: boolean;
  /** Optional filter parameter. Only tickets with an invoice document are returned. */
  hasInvoiceOnly?: boolean;
  includeClosed: boolean;
  /** Optional filter parameter */
  involvedContactIds?: string[];
  /**
   * Only used when page is set
   * @format int32
   */
  itemsPerPage: number;
  overdueOnly: boolean;
  /** Optional filter parameter */
  ownerIds?: string[];
  /**
   * Optional. Leave out or set to 0 to disable pagination
   * @format int32
   */
  page?: number;
  /** Optional filter parameter */
  priorities?: TicketTicketPriority[];
  /** Optional filter parameter */
  query?: string;
  /** Optional filter parameter */
  referenceIds?: string[];
  /** Optional filter parameter */
  statuses?: TicketTicketStatus[];
  /** Optional filter parameter */
  types?: TicketTicketType[];
  unreadByAssigneeOnly: boolean;
  watchingOnly: boolean;
}

export interface TicketListMyTicketsResponse {
  tickets: TicketTicket[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalTickets: number;
}

export interface TicketListSchedulesResponse {
  schedules: TicketticketSchedule[];
}

export interface TicketListTicketingEnabledRequest {
  accountIds: string[];
}

export interface TicketListTicketingEnabledResponse {
  enabledAccountIds: string[];
}

export interface TicketRemoveWatcherFromTicketsOfAssigneeRequest {
  /** The userId that must be set as assignee on the ticket whose watchers should be modified. */
  assigneeUserId: string;
  /** The userId that should be removed from watchers list. */
  watcherUserId: string;
}

export interface TicketRemoveWatcherFromTicketsOfAssigneeResponse {
  /** @format int32 */
  modifiedTickets: number;
}

export interface TicketReserveKeysRequest {
  /** @format int64 */
  accountId: string;
  /** @format int32 */
  amount: number;
}

export interface TicketReserveKeysResponse {
  keys: string[];
}

/** Field names align with coozzy.search.search.GlobalSearchHit (minus type; plus score). */
export interface TicketSearchGlobalHit {
  /** ticket.key */
  displayId: string;
  id: string;
  /**
   * Atlas $meta searchScore
   * @format double
   */
  score: number;
  subtitle: string;
  title: string;
}

export interface TicketSearchGlobalHitsResponse {
  hits: TicketSearchGlobalHit[];
}

export type TicketSetNotificationMailboxResponse = object;

export interface TicketSetSchedulesRequest {
  schedules: TicketticketSchedule[];
}

export type TicketSetSchedulesResponse = object;

export interface TicketTicketPriorityGrouped {
  /** @format int32 */
  highPriority: number;
  /** @format int32 */
  lowPriority: number;
  /** @format int32 */
  normalPriority: number;
  /** @format int32 */
  overduePriority: number;
}

export interface TicketUpdateChecklistTemplateResponse {
  template: TicketChecklistTemplate;
}

export type TicketticketDeleteResponse = object;

export interface TicketticketGetByPublicIdResponse {
  /** The document that is linked to the invoice. Only set if the ticket has an invoice document. */
  invoiceDocument: MediadocumentDocument;
  /** The media that is linked to the invoice document. Only set if the ticket has an invoice document. */
  invoiceMedia: StoreMedia[];
  ticket: TicketTicket;
}

export interface TicketticketListByContactIdsRequest {
  contactIds: string[];
}

export interface TicketticketListByContactIdsResponse {
  tickets: TicketTicket[];
}

export interface TicketticketListByIdsRequest {
  ids: string[];
}

export interface TicketticketListByIdsResponse {
  tickets: TicketTicket[];
}

export interface TicketticketListByReferenceIdsRequest {
  referenceIds: string[];
}

export interface TicketticketListByReferenceIdsResponse {
  tickets: TicketTicket[];
}

export interface TicketticketMarkReadRequest {
  ids: string[];
}

export type TicketticketMarkReadResponse = object;

export interface TicketticketMarkUnreadRequest {
  ids: string[];
}

export type TicketticketMarkUnreadResponse = object;

export interface TicketticketSchedule {
  /** @format int64 */
  accountId: string;
  /** Optional. If objectAssignee=true then ignored. */
  assigneeUserId?: string;
  category: string;
  /** @format int32 */
  createAtAmount: number;
  createAtUnit: TicketScheduleUnit;
  /** @format int32 */
  dueDateAmount: number;
  dueDateUnit: TicketScheduleUnit;
  enabled: boolean;
  language: LanguagePreferredLanguage;
  /** Only valid for categories that are object related. */
  useObjectAssignee: boolean;
}

/** @default "UNDEFINED_STATE" */
export enum AddressState {
  UNDEFINED_STATE = "UNDEFINED_STATE",
  CH_ZH = "CH_ZH",
  CH_BE = "CH_BE",
  CH_LU = "CH_LU",
  CH_UR = "CH_UR",
  CH_SZ = "CH_SZ",
  CH_OW = "CH_OW",
  CH_NW = "CH_NW",
  CH_GL = "CH_GL",
  CH_ZG = "CH_ZG",
  CH_FR = "CH_FR",
  CH_SO = "CH_SO",
  CH_BS = "CH_BS",
  CH_BL = "CH_BL",
  CH_SH = "CH_SH",
  CH_AR = "CH_AR",
  CH_AI = "CH_AI",
  CH_SG = "CH_SG",
  CH_GR = "CH_GR",
  CH_AG = "CH_AG",
  CH_TG = "CH_TG",
  CH_TI = "CH_TI",
  CH_VD = "CH_VD",
  CH_VS = "CH_VS",
  CH_NE = "CH_NE",
  CH_GE = "CH_GE",
  CH_JU = "CH_JU",
}

/** @default "UNDEFINED" */
export enum Commonv2SubType {
  UNDEFINED = "UNDEFINED",
  TENANT = "TENANT",
  LANDLORD = "LANDLORD",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  MARKETING = "MARKETING",
  OWNER = "OWNER",
  LANDLORD_MARKETING = "LANDLORD_MARKETING",
  ACCOUNTING = "ACCOUNTING",
  LANDLORD_ACCOUNTING = "LANDLORD_ACCOUNTING",
  MARKETING_ACCOUNTING = "MARKETING_ACCOUNTING",
  LANDLORD_MARKETING_ACCOUNTING = "LANDLORD_MARKETING_ACCOUNTING",
  ASSET_MANAGEMENT = "ASSET_MANAGEMENT",
  ASSET_LANDLORD = "ASSET_LANDLORD",
  ASSET_MARKETING = "ASSET_MARKETING",
  ASSET_ACCOUNTING = "ASSET_ACCOUNTING",
  ASSET_LANDLORD_MARKETING = "ASSET_LANDLORD_MARKETING",
  ASSET_LANDLORD_ACCOUNTING = "ASSET_LANDLORD_ACCOUNTING",
  ASSET_MARKETING_ACCOUNTING = "ASSET_MARKETING_ACCOUNTING",
  ASSET_LANDLORD_MARKETING_ACCOUNTING = "ASSET_LANDLORD_MARKETING_ACCOUNTING",
}

export interface Notificationv2GetTokenResponse {
  token: string;
}

export interface PortalAddLinkEntry {
  name: string;
  referenceId: string;
  url: string;
}

export interface PortalAddLinksRequest {
  links: PortalAddLinkEntry[];
}

export interface PortalAddLinksResponse {
  links: PortalLink[];
}

export interface PortalDocumentGroup {
  entries: PortalMediumEntry[];
  id: string;
  subTitle: string;
  title: string;
}

export interface PortalEnablePortalRequest {
  accountIds: string[];
  enable: boolean;
  propertyIds: string[];
}

export type PortalEnablePortalResponse = object;

export interface PortalGetPortalDataResponse {
  data: PortalPortalData[];
}

export interface PortalHasPortalEnabledResponse {
  enabled: boolean;
  propertyIds: string[];
}

export interface PortalLink {
  id: string;
  name: string;
  referenceId: string;
  url: string;
}

export interface PortalListDocumentGroupsResponse {
  groups: PortalDocumentGroup[];
}

export interface PortalListLinksByReferenceIdsRequest {
  referenceIds: string[];
}

export interface PortalListLinksByReferenceIdsResponse {
  links: PortalLink[];
}

export interface PortalMediumEntry {
  mediumId: string;
  mimeType: string;
  name: string;
  objectName: string;
  /** @format int32 */
  size: number;
  type: MediadocumentType;
  /**
   * UNIX timestamp in seconds when the medium was uploaded
   * @format int64
   */
  uploadedAt: string;
  url: string;
  /**
   * UNIX timestamp in seconds until which this URL is valid. Is set to 0 if no expiration.
   * @format int64
   */
  validUntil: string;
}

export interface PortalPortalData {
  entries: PortalMediumEntry[];
  id: string;
  links: PortalLink[];
  subTitle: string;
  title: string;
}

export type PortalRemoveLinksResponse = object;

export interface PortalUpdateLinksRequest {
  links: PortalLink[];
}

export type PortalUpdateLinksResponse = object;

/**
 * Represents a color in the RGBA color space. This representation is designed
 * for simplicity of conversion to/from color representations in various
 * languages over compactness. For example, the fields of this representation
 * can be trivially provided to the constructor of `java.awt.Color` in Java; it
 * can also be trivially provided to UIColor's `+colorWithRed:green:blue:alpha`
 * method in iOS; and, with just a little work, it can be easily formatted into
 * a CSS `rgba()` string in JavaScript.
 *
 * This reference page doesn't carry information about the absolute color
 * space
 * that should be used to interpret the RGB value (e.g. sRGB, Adobe RGB,
 * DCI-P3, BT.2020, etc.). By default, applications should assume the sRGB color
 * space.
 *
 * When color equality needs to be decided, implementations, unless
 * documented otherwise, treat two colors as equal if all their red,
 * green, blue, and alpha values each differ by at most 1e-5.
 *
 * Example (Java):
 *
 *      import com.google.type.Color;
 *
 *      // ...
 *      public static java.awt.Color fromProto(Color protocolor) {
 *        float alpha = protocolor.hasAlpha()
 *            ? protocolor.getAlpha().getValue()
 *            : 1.0;
 *
 *        return new java.awt.Color(
 *            protocolor.getRed(),
 *            protocolor.getGreen(),
 *            protocolor.getBlue(),
 *            alpha);
 *      }
 *
 *      public static Color toProto(java.awt.Color color) {
 *        float red = (float) color.getRed();
 *        float green = (float) color.getGreen();
 *        float blue = (float) color.getBlue();
 *        float denominator = 255.0;
 *        Color.Builder resultBuilder =
 *            Color
 *                .newBuilder()
 *                .setRed(red / denominator)
 *                .setGreen(green / denominator)
 *                .setBlue(blue / denominator);
 *        int alpha = color.getAlpha();
 *        if (alpha != 255) {
 *          result.setAlpha(
 *              FloatValue
 *                  .newBuilder()
 *                  .setValue(((float) alpha) / denominator)
 *                  .build());
 *        }
 *        return resultBuilder.build();
 *      }
 *      // ...
 *
 * Example (iOS / Obj-C):
 *
 *      // ...
 *      static UIColor* fromProto(Color* protocolor) {
 *         float red = [protocolor red];
 *         float green = [protocolor green];
 *         float blue = [protocolor blue];
 *         FloatValue* alpha_wrapper = [protocolor alpha];
 *         float alpha = 1.0;
 *         if (alpha_wrapper != nil) {
 *           alpha = [alpha_wrapper value];
 *         }
 *         return [UIColor colorWithRed:red green:green blue:blue alpha:alpha];
 *      }
 *
 *      static Color* toProto(UIColor* color) {
 *          CGFloat red, green, blue, alpha;
 *          if (![color getRed:&red green:&green blue:&blue alpha:&alpha]) {
 *            return nil;
 *          }
 *          Color* result = [[Color alloc] init];
 *          [result setRed:red];
 *          [result setGreen:green];
 *          [result setBlue:blue];
 *          if (alpha <= 0.9999) {
 *            [result setAlpha:floatWrapperWithValue(alpha)];
 *          }
 *          [result autorelease];
 *          return result;
 *     }
 *     // ...
 *
 *  Example (JavaScript):
 *
 *     // ...
 *
 *     var protoToCssColor = function(rgb_color) {
 *        var redFrac = rgb_color.red || 0.0;
 *        var greenFrac = rgb_color.green || 0.0;
 *        var blueFrac = rgb_color.blue || 0.0;
 *        var red = Math.floor(redFrac * 255);
 *        var green = Math.floor(greenFrac * 255);
 *        var blue = Math.floor(blueFrac * 255);
 *
 *        if (!('alpha' in rgb_color)) {
 *           return rgbToCssColor(red, green, blue);
 *        }
 *
 *        var alphaFrac = rgb_color.alpha.value || 0.0;
 *        var rgbParams = [red, green, blue].join(',');
 *        return ['rgba(', rgbParams, ',', alphaFrac, ')'].join('');
 *     };
 *
 *     var rgbToCssColor = function(red, green, blue) {
 *       var rgbNumber = new Number((red << 16) | (green << 8) | blue);
 *       var hexString = rgbNumber.toString(16);
 *       var missingZeros = 6 - hexString.length;
 *       var resultBuilder = ['#'];
 *       for (var i = 0; i < missingZeros; i++) {
 *          resultBuilder.push('0');
 *       }
 *       resultBuilder.push(hexString);
 *       return resultBuilder.join('');
 *     };
 *
 *     // ...
 */
export interface TypeColor {
  /**
   * The fraction of this color that should be applied to the pixel. That is,
   * the final pixel color is defined by the equation:
   * `pixel color = alpha * (this color) + (1.0 - alpha) * (background color)`
   *
   * This means that a value of 1.0 corresponds to a solid color, whereas
   * a value of 0.0 corresponds to a completely transparent color. This
   * uses a wrapper message rather than a simple float scalar so that it is
   * possible to distinguish between a default value and the value being unset.
   * If omitted, this color object is rendered as a solid color
   * (as if the alpha value had been explicitly given a value of 1.0).
   * @format float
   */
  alpha: number;
  /**
   * The amount of blue in the color as a value in the interval [0, 1].
   * @format float
   */
  blue: number;
  /**
   * The amount of green in the color as a value in the interval [0, 1].
   * @format float
   */
  green: number;
  /**
   * The amount of red in the color as a value in the interval [0, 1].
   * @format float
   */
  red: number;
}

export interface Useraccountv2ContactPerson {
  email: string;
  name: string;
  phone: string;
  userId: string;
}

export interface Useraccountv2CreateRequest {
  /** Only set if type=company */
  company: Usercommonv2Company;
  /** Only set if type=individual */
  individual: Usercommonv2Individual;
  subType: Commonv2SubType;
  type: Usercommonv2Type;
}

export interface Useraccountv2CreateResponse {
  account: V2Account;
}

export type Useraccountv2DeleteResponse = object;

export interface Useraccountv2GetResponse {
  account: V2Account;
}

export interface Useraccountv2ListByIdsResponse {
  accounts: V2Account[];
}

export interface Useraccountv2ListResponse {
  accounts: V2Account[];
  /** @format int32 */
  pageCount: number;
  /** @format int32 */
  totalCount: number;
}

export interface Useraccountv2UpdateCompanyResponse {
  account: V2Account;
}

export interface Useraccountv2UpdateContactPersonResponse {
  account: V2Account;
}

export interface Usercommonv2Company {
  aboutUs: string;
  address: CommonaddressAddress;
  email: string;
  name: string;
  phoneNumber: string;
  vatNumber: string;
  website: string;
}

/** @default "UNDEFINED_GENDER" */
export enum Usercommonv2Gender {
  UNDEFINED_GENDER = "UNDEFINED_GENDER",
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export interface Usercommonv2Individual {
  address: CommonaddressAddress;
  email: string;
  firstName: string;
  gender: Usercommonv2Gender;
  lastName: string;
  phoneNumber: string;
  website: string;
}

/** @default "INDIVIDUAL" */
export enum Usercommonv2Type {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
  PLATFORM_EMPLOYEE = "PLATFORM_EMPLOYEE",
}

export interface Usernotificationv2GetSettingsResponse {
  settings: Usernotificationv2Settings;
}

export interface Usernotificationv2SetSettingsRequest {
  channels: V2NotificationChannel[];
  marketbaseNotifications: V2MarketbaseNotifications;
  otherNotifications: V2OtherNotifications;
  ticketNotifications: V2TicketNotifications;
  userId: string;
}

export interface Usernotificationv2SetSettingsResponse {
  settings: Usernotificationv2Settings;
}

export interface Usernotificationv2Settings {
  channels: V2NotificationChannel[];
  marketbaseNotifications: V2MarketbaseNotifications;
  otherNotifications: V2OtherNotifications;
  ticketNotifications: V2TicketNotifications;
  userId: string;
}

/** @default "UNDEFINED" */
export enum Useruserv2Gender {
  UNDEFINED = "UNDEFINED",
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export interface Useruserv2ListEmployeesResponse {
  employees: V2User[];
}

export interface Useruserv2ListResponse {
  /** @format int32 */
  itemsPerPage: number;
  /** @format int32 */
  overallCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageCount: number;
  users: V2User[];
}

export interface V2Account {
  accountingStates: AddressState[];
  assetStates: AddressState[];
  billing: V2Billing;
  company: Usercommonv2Company;
  contactPerson: Useraccountv2ContactPerson;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  createdAt: TypeDate;
  /** @format int64 */
  id: string;
  individual: Usercommonv2Individual;
  logoUrl: string;
  managementStates: AddressState[];
  marketingStates: AddressState[];
  subType: Commonv2SubType;
  type: Usercommonv2Type;
}

export interface V2Billing {
  billable: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  billableSetDate: TypeDate;
  /** @format int64 */
  billingAddressAccountId: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  contractStart: TypeDate;
  lastModifiedBy: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  lastModifiedDate: TypeDate;
  note: string;
  pricingModel: V2PricingModel;
}

export type V2BlockResponse = object;

export type V2ChangeBillingResponse = object;

export type V2ChangeSubTypeResponse = object;

export type V2DeleteUserResponse = object;

export interface V2GetFontSettingsResponse {
  /**
   * Represents a color in the RGBA color space. This representation is designed
   * for simplicity of conversion to/from color representations in various
   * languages over compactness. For example, the fields of this representation
   * can be trivially provided to the constructor of `java.awt.Color` in Java; it
   * can also be trivially provided to UIColor's `+colorWithRed:green:blue:alpha`
   * method in iOS; and, with just a little work, it can be easily formatted into
   * a CSS `rgba()` string in JavaScript.
   *
   * This reference page doesn't carry information about the absolute color
   * space
   * that should be used to interpret the RGB value (e.g. sRGB, Adobe RGB,
   * DCI-P3, BT.2020, etc.). By default, applications should assume the sRGB color
   * space.
   *
   * When color equality needs to be decided, implementations, unless
   * documented otherwise, treat two colors as equal if all their red,
   * green, blue, and alpha values each differ by at most 1e-5.
   *
   * Example (Java):
   *
   *      import com.google.type.Color;
   *
   *      // ...
   *      public static java.awt.Color fromProto(Color protocolor) {
   *        float alpha = protocolor.hasAlpha()
   *            ? protocolor.getAlpha().getValue()
   *            : 1.0;
   *
   *        return new java.awt.Color(
   *            protocolor.getRed(),
   *            protocolor.getGreen(),
   *            protocolor.getBlue(),
   *            alpha);
   *      }
   *
   *      public static Color toProto(java.awt.Color color) {
   *        float red = (float) color.getRed();
   *        float green = (float) color.getGreen();
   *        float blue = (float) color.getBlue();
   *        float denominator = 255.0;
   *        Color.Builder resultBuilder =
   *            Color
   *                .newBuilder()
   *                .setRed(red / denominator)
   *                .setGreen(green / denominator)
   *                .setBlue(blue / denominator);
   *        int alpha = color.getAlpha();
   *        if (alpha != 255) {
   *          result.setAlpha(
   *              FloatValue
   *                  .newBuilder()
   *                  .setValue(((float) alpha) / denominator)
   *                  .build());
   *        }
   *        return resultBuilder.build();
   *      }
   *      // ...
   *
   * Example (iOS / Obj-C):
   *
   *      // ...
   *      static UIColor* fromProto(Color* protocolor) {
   *         float red = [protocolor red];
   *         float green = [protocolor green];
   *         float blue = [protocolor blue];
   *         FloatValue* alpha_wrapper = [protocolor alpha];
   *         float alpha = 1.0;
   *         if (alpha_wrapper != nil) {
   *           alpha = [alpha_wrapper value];
   *         }
   *         return [UIColor colorWithRed:red green:green blue:blue alpha:alpha];
   *      }
   *
   *      static Color* toProto(UIColor* color) {
   *          CGFloat red, green, blue, alpha;
   *          if (![color getRed:&red green:&green blue:&blue alpha:&alpha]) {
   *            return nil;
   *          }
   *          Color* result = [[Color alloc] init];
   *          [result setRed:red];
   *          [result setGreen:green];
   *          [result setBlue:blue];
   *          if (alpha <= 0.9999) {
   *            [result setAlpha:floatWrapperWithValue(alpha)];
   *          }
   *          [result autorelease];
   *          return result;
   *     }
   *     // ...
   *
   *  Example (JavaScript):
   *
   *     // ...
   *
   *     var protoToCssColor = function(rgb_color) {
   *        var redFrac = rgb_color.red || 0.0;
   *        var greenFrac = rgb_color.green || 0.0;
   *        var blueFrac = rgb_color.blue || 0.0;
   *        var red = Math.floor(redFrac * 255);
   *        var green = Math.floor(greenFrac * 255);
   *        var blue = Math.floor(blueFrac * 255);
   *
   *        if (!('alpha' in rgb_color)) {
   *           return rgbToCssColor(red, green, blue);
   *        }
   *
   *        var alphaFrac = rgb_color.alpha.value || 0.0;
   *        var rgbParams = [red, green, blue].join(',');
   *        return ['rgba(', rgbParams, ',', alphaFrac, ')'].join('');
   *     };
   *
   *     var rgbToCssColor = function(red, green, blue) {
   *       var rgbNumber = new Number((red << 16) | (green << 8) | blue);
   *       var hexString = rgbNumber.toString(16);
   *       var missingZeros = 6 - hexString.length;
   *       var resultBuilder = ['#'];
   *       for (var i = 0; i < missingZeros; i++) {
   *          resultBuilder.push('0');
   *       }
   *       resultBuilder.push(hexString);
   *       return resultBuilder.join('');
   *     };
   *
   *     // ...
   */
  color: TypeColor;
  family: string;
  size: string;
}

export interface V2InviteEmployeeRequest {
  /**
   * The accountId to which the user should be invited
   * @format int64
   */
  accountId: string;
  email: string;
  firstName: string;
  lastName: string;
  /** Optional as it can only be set if platform_employee type */
  password: string;
  roles: string[];
  sendPasswordReset: boolean;
}

export interface V2IsVerifiedResponse {
  emailVerified: boolean;
}

export interface V2ListAllEmployeesRequest {
  accountIds: string[];
}

export interface V2ListAllEmployeesResponse {
  employees: V2User[];
}

export interface V2MarketbaseNotifications {
  newRegistration: boolean;
  newRequest: boolean;
  newResponse: boolean;
  referencesReceived: boolean;
  viewingAppointmentsScheduled: boolean;
}

/** @default "NOTIFICATION_CHANNEL_EMAIL" */
export enum V2NotificationChannel {
  NOTIFICATION_CHANNEL_EMAIL = "NOTIFICATION_CHANNEL_EMAIL",
  NOTIFICATION_CHANNEL_PUSH = "NOTIFICATION_CHANNEL_PUSH",
}

export interface V2OtherNotifications {
  depositConfirmationReceived: boolean;
  firstcautionDepositConfirmationReceived: boolean;
}

/** @default "UNDEFINED_PRICING_MODEL" */
export enum V2PricingModel {
  UNDEFINED_PRICING_MODEL = "UNDEFINED_PRICING_MODEL",
  SAAS_PRICING_MODEL = "SAAS_PRICING_MODEL",
  LICENSE_PRICING_MODEL = "LICENSE_PRICING_MODEL",
  SAAS_AND_LICENSE_PRICING_MODEL = "SAAS_AND_LICENSE_PRICING_MODEL",
}

export interface V2Profile {
  /**
   * DO NOT USE! Deprecated and ignored.
   * @format int64
   */
  birthday: string;
  /**
   * Represents a color in the RGBA color space. This representation is designed
   * for simplicity of conversion to/from color representations in various
   * languages over compactness. For example, the fields of this representation
   * can be trivially provided to the constructor of `java.awt.Color` in Java; it
   * can also be trivially provided to UIColor's `+colorWithRed:green:blue:alpha`
   * method in iOS; and, with just a little work, it can be easily formatted into
   * a CSS `rgba()` string in JavaScript.
   *
   * This reference page doesn't carry information about the absolute color
   * space
   * that should be used to interpret the RGB value (e.g. sRGB, Adobe RGB,
   * DCI-P3, BT.2020, etc.). By default, applications should assume the sRGB color
   * space.
   *
   * When color equality needs to be decided, implementations, unless
   * documented otherwise, treat two colors as equal if all their red,
   * green, blue, and alpha values each differ by at most 1e-5.
   *
   * Example (Java):
   *
   *      import com.google.type.Color;
   *
   *      // ...
   *      public static java.awt.Color fromProto(Color protocolor) {
   *        float alpha = protocolor.hasAlpha()
   *            ? protocolor.getAlpha().getValue()
   *            : 1.0;
   *
   *        return new java.awt.Color(
   *            protocolor.getRed(),
   *            protocolor.getGreen(),
   *            protocolor.getBlue(),
   *            alpha);
   *      }
   *
   *      public static Color toProto(java.awt.Color color) {
   *        float red = (float) color.getRed();
   *        float green = (float) color.getGreen();
   *        float blue = (float) color.getBlue();
   *        float denominator = 255.0;
   *        Color.Builder resultBuilder =
   *            Color
   *                .newBuilder()
   *                .setRed(red / denominator)
   *                .setGreen(green / denominator)
   *                .setBlue(blue / denominator);
   *        int alpha = color.getAlpha();
   *        if (alpha != 255) {
   *          result.setAlpha(
   *              FloatValue
   *                  .newBuilder()
   *                  .setValue(((float) alpha) / denominator)
   *                  .build());
   *        }
   *        return resultBuilder.build();
   *      }
   *      // ...
   *
   * Example (iOS / Obj-C):
   *
   *      // ...
   *      static UIColor* fromProto(Color* protocolor) {
   *         float red = [protocolor red];
   *         float green = [protocolor green];
   *         float blue = [protocolor blue];
   *         FloatValue* alpha_wrapper = [protocolor alpha];
   *         float alpha = 1.0;
   *         if (alpha_wrapper != nil) {
   *           alpha = [alpha_wrapper value];
   *         }
   *         return [UIColor colorWithRed:red green:green blue:blue alpha:alpha];
   *      }
   *
   *      static Color* toProto(UIColor* color) {
   *          CGFloat red, green, blue, alpha;
   *          if (![color getRed:&red green:&green blue:&blue alpha:&alpha]) {
   *            return nil;
   *          }
   *          Color* result = [[Color alloc] init];
   *          [result setRed:red];
   *          [result setGreen:green];
   *          [result setBlue:blue];
   *          if (alpha <= 0.9999) {
   *            [result setAlpha:floatWrapperWithValue(alpha)];
   *          }
   *          [result autorelease];
   *          return result;
   *     }
   *     // ...
   *
   *  Example (JavaScript):
   *
   *     // ...
   *
   *     var protoToCssColor = function(rgb_color) {
   *        var redFrac = rgb_color.red || 0.0;
   *        var greenFrac = rgb_color.green || 0.0;
   *        var blueFrac = rgb_color.blue || 0.0;
   *        var red = Math.floor(redFrac * 255);
   *        var green = Math.floor(greenFrac * 255);
   *        var blue = Math.floor(blueFrac * 255);
   *
   *        if (!('alpha' in rgb_color)) {
   *           return rgbToCssColor(red, green, blue);
   *        }
   *
   *        var alphaFrac = rgb_color.alpha.value || 0.0;
   *        var rgbParams = [red, green, blue].join(',');
   *        return ['rgba(', rgbParams, ',', alphaFrac, ')'].join('');
   *     };
   *
   *     var rgbToCssColor = function(red, green, blue) {
   *       var rgbNumber = new Number((red << 16) | (green << 8) | blue);
   *       var hexString = rgbNumber.toString(16);
   *       var missingZeros = 6 - hexString.length;
   *       var resultBuilder = ['#'];
   *       for (var i = 0; i < missingZeros; i++) {
   *          resultBuilder.push('0');
   *       }
   *       resultBuilder.push(hexString);
   *       return resultBuilder.join('');
   *     };
   *
   *     // ...
   */
  color: TypeColor;
  firstName: string;
  gender: Useruserv2Gender;
  /** @format double */
  hourlyRate: number;
  job: string;
  language: string;
  lastName: string;
  phoneNumber: string;
  pictureUrl: string;
  signatureAuthorization: V2SignatureAuthorization;
  signatureMediaId: string;
}

export interface V2PublishUpdateMessageRequest {
  message: string;
  messageEn: string;
  messageIt: string;
}

export type V2PublishUpdateMessageResponse = object;

export interface V2RegisterRequest {
  password: string;
  token: string;
}

export type V2RegisterResponse = object;

export interface V2ResolveTokenResponse {
  companyName: string;
  email: string;
  firstName: string;
  gender: Useruserv2Gender;
  lastName: string;
}

export type V2SetFontSettingsResponse = object;

export interface V2SetLogoResponse {
  account: V2Account;
}

/** @default "SIGNATURE_AUTHORIZATION_UNDEFINED" */
export enum V2SignatureAuthorization {
  SIGNATURE_AUTHORIZATION_UNDEFINED = "SIGNATURE_AUTHORIZATION_UNDEFINED",
  SIGNATURE_AUTHORIZATION_SOLE = "SIGNATURE_AUTHORIZATION_SOLE",
  SIGNATURE_AUTHORIZATION_COLLECTIVELY_BY_TWO = "SIGNATURE_AUTHORIZATION_COLLECTIVELY_BY_TWO",
}

export interface V2TicketNotifications {
  assigned: boolean;
  comments: boolean;
  created: boolean;
  deleted: boolean;
  eventCreated: boolean;
  externalInvoiceAdded: boolean;
  invoiceAdded: boolean;
  mailReceived: boolean;
  mailSent: boolean;
  overdue: boolean;
  statusChanged: boolean;
  updated: boolean;
}

export type V2UnblockResponse = object;

export interface V2UpdateIndividualResponse {
  account: V2Account;
}

export interface V2UpdateStatesResponse {
  account: V2Account;
}

export interface V2User {
  /**
   * Account to which this user has access to
   * @format int64
   */
  accountId: string;
  address: CommonaddressAddress;
  blocked: boolean;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  createdAt: string;
  deleted: boolean;
  email: string;
  /** Auth0 user ID */
  id: string;
  profile: V2Profile;
  roles: string[];
}

export type AdvertGenerationServiceGetAccountConfigData = AdvertGenerationGetAccountConfigResponse;

export type AdvertGenerationServiceGetAccountConfigError = GooglerpcStatus;

export interface AdvertGenerationServiceSetAccountConfigPayload {
  prompt?: string;
}

export type AdvertGenerationServiceSetAccountConfigData = AdvertGenerationSetAccountConfigResponse;

export type AdvertGenerationServiceSetAccountConfigError = GooglerpcStatus;

export type AdvertGenerationServiceSubmitGenerationFeedbackData = AdvertGenerationSubmitGenerationFeedbackResponse;

export type AdvertGenerationServiceSubmitGenerationFeedbackError = GooglerpcStatus;

export type AdvertGenerationServiceGenerateData = AiadvertGenerationGenerateResponse;

export type AdvertGenerationServiceGenerateError = GooglerpcStatus;

export type AdvertGenerationServiceRegenerateData = AiadvertGenerationGenerateResponse;

export type AdvertGenerationServiceRegenerateError = GooglerpcStatus;

export type AdvertImageServiceSubmitOptimizationFeedbackData = AdvertImageSubmitOptimizationFeedbackResponse;

export type AdvertImageServiceSubmitOptimizationFeedbackError = GooglerpcStatus;

export type AdvertImageServiceOptimizeData = AdvertImageOptimizeResponse;

export type AdvertImageServiceOptimizeError = GooglerpcStatus;

export type AiGatewayServiceGetAccountSettingsData = AiaiGatewayGetAccountSettingsResponse;

export type AiGatewayServiceGetAccountSettingsError = GooglerpcStatus;

export interface AiGatewayServiceSetAccountSettingsPayload {
  enabled?: boolean;
  /** Use cases enabled for this account. When enabled=true and empty, all registered use cases are allowed. */
  enabledUseCases?: AiGatewayAiUseCase[];
}

export type AiGatewayServiceSetAccountSettingsData = AiGatewaySetAccountSettingsResponse;

export type AiGatewayServiceSetAccountSettingsError = GooglerpcStatus;

export type AiGatewayServiceListUsageRecordsData = AiGatewayListUsageRecordsResponse;

export type AiGatewayServiceListUsageRecordsError = GooglerpcStatus;

export type AiGatewayServiceGetQuotaData = AiGatewayGetQuotaResponse;

export type AiGatewayServiceGetQuotaError = GooglerpcStatus;

export interface AiGatewayServiceSetQuotaPayload {
  quotas?: AiGatewayAiQuota[];
}

export type AiGatewayServiceSetQuotaData = AiGatewaySetQuotaResponse;

export type AiGatewayServiceSetQuotaError = GooglerpcStatus;

export interface AiGatewayServiceGetUsageParams {
  /**
   * Start of period (inclusive), UNIX seconds.
   * @format int64
   */
  fromUnix?: string;
  /**
   * End of period (exclusive), UNIX seconds.
   * @format int64
   */
  toUnix?: string;
  /** Optional. If empty, aggregate across all use cases. */
  filterUseCases?: FilterUseCasesEnum[];
  /** @format int64 */
  accountId: string;
}

export enum FilterUseCasesEnum {
  AI_USE_CASE_UNDEFINED = "AI_USE_CASE_UNDEFINED",
  AI_USE_CASE_CLAIM_MANAGEMENT = "AI_USE_CASE_CLAIM_MANAGEMENT",
  AI_USE_CASE_ADVERT_DESCRIPTION = "AI_USE_CASE_ADVERT_DESCRIPTION",
  AI_USE_CASE_ADVERT_IMAGE = "AI_USE_CASE_ADVERT_IMAGE",
}

export type AiGatewayServiceGetUsageData = AiGatewayGetUsageResponse;

export type AiGatewayServiceGetUsageError = GooglerpcStatus;

export enum AiGatewayServiceGetUsageParams1FilterUseCasesEnum {
  AI_USE_CASE_UNDEFINED = "AI_USE_CASE_UNDEFINED",
  AI_USE_CASE_CLAIM_MANAGEMENT = "AI_USE_CASE_CLAIM_MANAGEMENT",
  AI_USE_CASE_ADVERT_DESCRIPTION = "AI_USE_CASE_ADVERT_DESCRIPTION",
  AI_USE_CASE_ADVERT_IMAGE = "AI_USE_CASE_ADVERT_IMAGE",
}

export type NylasServiceCreateEventData = NylasCreateEventResponse;

export type NylasServiceCreateEventError = GooglerpcStatus;

export interface NylasServiceDeleteEventParams {
  userId?: string;
  id: string;
}

export type NylasServiceDeleteEventData = NylasDeleteEventResponse;

export type NylasServiceDeleteEventError = GooglerpcStatus;

export type NylasServiceGetEventByIcsData = NylasGetEventByIcsResponse;

export type NylasServiceGetEventByIcsError = GooglerpcStatus;

export type NylasServiceListAvailableCalendarsData = NylasListAvailableCalendarsResponse;

export type NylasServiceListAvailableCalendarsError = GooglerpcStatus;

export type NylasServiceListCalendarByUserIdData = NylasListCalendarByUserIdResponse;

export type NylasServiceListCalendarByUserIdError = GooglerpcStatus;

export type NylasServiceListCalendarsByUserIdsData = NylasListCalendarsByUserIdsResponse;

export type NylasServiceListCalendarsByUserIdsError = GooglerpcStatus;

export type NylasServiceListEventsData = NylasListEventsResponse;

export type NylasServiceListEventsError = GooglerpcStatus;

export type NylasServiceResolveCalendarByEmailData = NylasResolveCalendarByEmailResponse;

export type NylasServiceResolveCalendarByEmailError = GooglerpcStatus;

export type NylasServiceSendRsvpData = NylasSendRSVPResponse;

export type NylasServiceSendRsvpError = GooglerpcStatus;

export type NylasServiceSetCalendarData = NylasSetCalendarResponse;

export type NylasServiceSetCalendarError = GooglerpcStatus;

export type NylasServiceUpdateEventData = NylasUpdateEventResponse;

export type NylasServiceUpdateEventError = GooglerpcStatus;

export type ReminderServiceCountDueRemindersData = ReminderCountDueRemindersResponse;

export type ReminderServiceCountDueRemindersError = GooglerpcStatus;

export type ReminderServiceCountUndoneRemindersData = ReminderCountUndoneRemindersResponse;

export type ReminderServiceCountUndoneRemindersError = GooglerpcStatus;

export type ReminderServiceCreateData = CalendarreminderCreateResponse;

export type ReminderServiceCreateError = GooglerpcStatus;

export type ReminderServiceCreateBulkData = CalendarreminderCreateBulkResponse;

export type ReminderServiceCreateBulkError = GooglerpcStatus;

export interface ReminderServiceListParams {
  /** Optional, needs to match at least one */
  employeeIds?: string[];
  /** Optional, if empty array then no filtering is done */
  priority?: PriorityEnum[];
  /** @format int64 */
  ownerId: string;
}

export enum PriorityEnum {
  NORMAL_REMINDER_PRIORITY = "NORMAL_REMINDER_PRIORITY",
  LOW_REMINDER_PRIORITY = "LOW_REMINDER_PRIORITY",
  HIGH_REMINDER_PRIORITY = "HIGH_REMINDER_PRIORITY",
}

export type ReminderServiceListData = CalendarreminderListResponse;

export type ReminderServiceListError = GooglerpcStatus;

export enum ReminderServiceListParams1PriorityEnum {
  NORMAL_REMINDER_PRIORITY = "NORMAL_REMINDER_PRIORITY",
  LOW_REMINDER_PRIORITY = "LOW_REMINDER_PRIORITY",
  HIGH_REMINDER_PRIORITY = "HIGH_REMINDER_PRIORITY",
}

export type ReminderServiceListByContactIdsData = CalendarreminderListByContactIdsResponse;

export type ReminderServiceListByContactIdsError = GooglerpcStatus;

export type ReminderServiceListByReferenceIds2Data = CalendarreminderListByReferenceIdsResponse;

export type ReminderServiceListByReferenceIds2Error = GooglerpcStatus;

export interface ReminderServiceListByReferenceIdsParams {
  /** @format int64 */
  ownerId?: string;
  includeDone?: boolean;
  /** @minItems 1 */
  referenceIds: string[];
}

export type ReminderServiceListByReferenceIdsData = CalendarreminderListByReferenceIdsResponse;

export type ReminderServiceListByReferenceIdsError = GooglerpcStatus;

export type ReminderServiceSetDoneData = ReminderSetDoneResponse;

export type ReminderServiceSetDoneError = GooglerpcStatus;

export type ReminderServiceSetUnDoneData = ReminderSetUnDoneResponse;

export type ReminderServiceSetUnDoneError = GooglerpcStatus;

export type ReminderServiceUpdateData = CalendarreminderUpdateResponse;

export type ReminderServiceUpdateError = GooglerpcStatus;

export type ReminderServiceUpdateDateData = ReminderUpdateDateResponse;

export type ReminderServiceUpdateDateError = GooglerpcStatus;

export type ReminderServiceUpdateEmployeeData = ReminderUpdateEmployeeResponse;

export type ReminderServiceUpdateEmployeeError = GooglerpcStatus;

export type ReminderServiceUpdatePriorityData = ReminderUpdatePriorityResponse;

export type ReminderServiceUpdatePriorityError = GooglerpcStatus;

export type ReminderServiceGetData = CalendarreminderGetResponse;

export type ReminderServiceGetError = GooglerpcStatus;

export type ReminderServiceDeleteData = CalendarreminderDeleteResponse;

export type ReminderServiceDeleteError = GooglerpcStatus;

export type SchedulerServiceGetAppointmentData = SchedulerGetAppointmentResponse;

export type SchedulerServiceGetAppointmentError = GooglerpcStatus;

export type SchedulerServiceCancelAppointmentsData = SchedulerCancelAppointmentsResponse;

export type SchedulerServiceCancelAppointmentsError = GooglerpcStatus;

export type SchedulerServiceCreateAppointmentsData = SchedulerCreateAppointmentsResponse;

export type SchedulerServiceCreateAppointmentsError = GooglerpcStatus;

export type SchedulerServiceCreateTokenForRequestingAppointmentsData =
  SchedulerCreateTokenForRequestingAppointmentsResponse;

export type SchedulerServiceCreateTokenForRequestingAppointmentsError = GooglerpcStatus;

export interface SchedulerServiceGetReminderConfigParams {
  /** @format int64 */
  accountId?: string;
}

export type SchedulerServiceGetReminderConfigData = SchedulerGetReminderConfigResponse;

export type SchedulerServiceGetReminderConfigError = GooglerpcStatus;

export interface SchedulerServiceGetSenderMailboxParams {
  /** @format int64 */
  accountId?: string;
}

export type SchedulerServiceGetSenderMailboxData = SchedulerGetSenderMailboxResponse;

export type SchedulerServiceGetSenderMailboxError = GooglerpcStatus;

export type SchedulerServiceGetTokenForRegisteringData = SchedulerGetTokenForRegisteringResponse;

export type SchedulerServiceGetTokenForRegisteringError = GooglerpcStatus;

export type SchedulerServiceListAppointmentsByObjectIdData = SchedulerListAppointmentsByObjectIdResponse;

export type SchedulerServiceListAppointmentsByObjectIdError = GooglerpcStatus;

export type SchedulerServiceGetAvailableSlotsData = SchedulerGetAvailableSlotsResponse;

export type SchedulerServiceGetAvailableSlotsError = GooglerpcStatus;

export type SchedulerServiceCancelRegistrationData = SchedulerCancelRegistrationResponse;

export type SchedulerServiceCancelRegistrationError = GooglerpcStatus;

export type SchedulerServiceListAppointmentsByTokenData = SchedulerListAppointmentsByTokenResponse;

export type SchedulerServiceListAppointmentsByTokenError = GooglerpcStatus;

export type SchedulerServiceGetRegistrationData = SchedulerGetRegistrationResponse;

export type SchedulerServiceGetRegistrationError = GooglerpcStatus;

export type SchedulerServiceSubmitRequestedAppointmentsData = SchedulerSubmitRequestedAppointmentsResponse;

export type SchedulerServiceSubmitRequestedAppointmentsError = GooglerpcStatus;

export type SchedulerServiceSubmitSlotSelectionData = SchedulerSubmitSlotSelectionResponse;

export type SchedulerServiceSubmitSlotSelectionError = GooglerpcStatus;

export type SchedulerServiceSetReminderConfigData = SchedulerSetReminderConfigResponse;

export type SchedulerServiceSetReminderConfigError = GooglerpcStatus;

export type SchedulerServiceSetSenderMailboxData = SchedulerSetSenderMailboxResponse;

export type SchedulerServiceSetSenderMailboxError = GooglerpcStatus;

export type SchedulerServiceUnregisterParticipantData = SchedulerUnregisterParticipantResponse;

export type SchedulerServiceUnregisterParticipantError = GooglerpcStatus;

export type SchedulerServiceUpdateMaxParticipantsData = SchedulerUpdateMaxParticipantsResponse;

export type SchedulerServiceUpdateMaxParticipantsError = GooglerpcStatus;

export type AicServiceConfirmAicSupportData = AicConfirmAicSupportResponse;

export type AicServiceConfirmAicSupportError = GooglerpcStatus;

export type AicServiceCreateDamageReportData = AicCreateDamageReportResponse;

export type AicServiceCreateDamageReportError = GooglerpcStatus;

export type AicServiceCreateDocumentData = AicCreateDocumentResponse;

export type AicServiceCreateDocumentError = GooglerpcStatus;

export type AicServiceAddInsurancePoliceDocumentData = AicAddInsurancePoliceDocumentResponse;

export type AicServiceAddInsurancePoliceDocumentError = GooglerpcStatus;

export type AicServiceAddInvoiceDocumentData = AicAddInvoiceDocumentResponse;

export type AicServiceAddInvoiceDocumentError = GooglerpcStatus;

export type AicServiceAddLossRatioDocumentData = AicAddLossRatioDocumentResponse;

export type AicServiceAddLossRatioDocumentError = GooglerpcStatus;

export type AicServiceEnableAicData = AicEnableAicResponse;

export type AicServiceEnableAicError = GooglerpcStatus;

export type AicServiceGetSyncModeForPropertiesData = AicGetSyncModeForPropertiesResponse;

export type AicServiceGetSyncModeForPropertiesError = GooglerpcStatus;

export type AicServiceGetSyncModeForAccountsByPropertyIdData = AicGetSyncModeForAccountsByPropertyIdResponse;

export type AicServiceGetSyncModeForAccountsByPropertyIdError = GooglerpcStatus;

export type AicServiceCreateInsuranceData = AicCreateInsuranceResponse;

export type AicServiceCreateInsuranceError = GooglerpcStatus;

export interface AicServiceUpdateInsurancePayload {
  /** @format float */
  amount?: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate?: TypeDate;
  /** @format float */
  excess?: number;
  /** @format int64 */
  insuranceWorkspaceId?: string;
  policyNumber?: string;
  /** The propbase propertyId (prop_xxxxx) where this insurance should be attached to */
  referenceId?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate?: TypeDate;
  type?: InsuranceInsuranceType;
  /** @format float */
  yearlyCosts?: number;
}

export type AicServiceUpdateInsuranceData = AicUpdateInsuranceResponse;

export type AicServiceUpdateInsuranceError = GooglerpcStatus;

export type AicServiceHasAicEnabledData = AicHasAicEnabledResponse;

export type AicServiceHasAicEnabledError = GooglerpcStatus;

export type AicServiceGetJwtPublicKeyData = CommonaicGetJwtPublicKeyResponse;

export type AicServiceGetJwtPublicKeyError = GooglerpcStatus;

export type AicServiceCreateNoteData = AicCreateNoteResponse;

export type AicServiceCreateNoteError = GooglerpcStatus;

export type AicServiceSetSyncModeForPropertiesData = AicSetSyncModeForPropertiesResponse;

export type AicServiceSetSyncModeForPropertiesError = GooglerpcStatus;

export interface AicServiceGetSsoUrlParams {
  /** @default "AIC_LANDING_PAGE_DASHBOARD" */
  landingPage?: LandingPageEnum;
  /** Optional. The ID of the entity to open. For example the propertyId, insuranceId or ticketId of the damage report. */
  entityId?: string;
  /** Optional and used only on AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT. The ticketId of which this damage report originates from. */
  ticketId?: string;
}

/** @default "AIC_LANDING_PAGE_DASHBOARD" */
export enum LandingPageEnum {
  AIC_LANDING_PAGE_DASHBOARD = "AIC_LANDING_PAGE_DASHBOARD",
  AIC_LANDING_PAGE_PROPERTY_OVERVIEW = "AIC_LANDING_PAGE_PROPERTY_OVERVIEW",
  AIC_LANDING_PAGE_PROPERTY_DETAILS = "AIC_LANDING_PAGE_PROPERTY_DETAILS",
  AIC_LANDING_PAGE_DAMAGES_OVERVIEW = "AIC_LANDING_PAGE_DAMAGES_OVERVIEW",
  AIC_LANDING_PAGE_DAMAGES_DETAILS = "AIC_LANDING_PAGE_DAMAGES_DETAILS",
  AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT = "AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT",
  AIC_LANDING_PAGE_INSURANCE = "AIC_LANDING_PAGE_INSURANCE",
  AIC_LANDING_PAGE_FASTLANE = "AIC_LANDING_PAGE_FASTLANE",
}

export type AicServiceGetSsoUrlData = CommonaicGetSsoUrlResponse;

export type AicServiceGetSsoUrlError = GooglerpcStatus;

/** @default "AIC_LANDING_PAGE_DASHBOARD" */
export enum AicServiceGetSsoUrlParams1LandingPageEnum {
  AIC_LANDING_PAGE_DASHBOARD = "AIC_LANDING_PAGE_DASHBOARD",
  AIC_LANDING_PAGE_PROPERTY_OVERVIEW = "AIC_LANDING_PAGE_PROPERTY_OVERVIEW",
  AIC_LANDING_PAGE_PROPERTY_DETAILS = "AIC_LANDING_PAGE_PROPERTY_DETAILS",
  AIC_LANDING_PAGE_DAMAGES_OVERVIEW = "AIC_LANDING_PAGE_DAMAGES_OVERVIEW",
  AIC_LANDING_PAGE_DAMAGES_DETAILS = "AIC_LANDING_PAGE_DAMAGES_DETAILS",
  AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT = "AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT",
  AIC_LANDING_PAGE_INSURANCE = "AIC_LANDING_PAGE_INSURANCE",
  AIC_LANDING_PAGE_FASTLANE = "AIC_LANDING_PAGE_FASTLANE",
}

export type AileanServiceActivatePropertiesData = AileanActivatePropertiesResponse;

export type AileanServiceActivatePropertiesError = GooglerpcStatus;

export type AileanServiceCreateTicketData = AileanCreateTicketResponse;

export type AileanServiceCreateTicketError = GooglerpcStatus;

export type AileanServiceCreateTicketCommentData = AileanCreateTicketCommentResponse;

export type AileanServiceCreateTicketCommentError = GooglerpcStatus;

export type AileanServiceDeactivatePropertiesData = AileanDeactivatePropertiesResponse;

export type AileanServiceDeactivatePropertiesError = GooglerpcStatus;

export type AileanServiceEnableAileanData = AileanEnableAileanResponse;

export type AileanServiceEnableAileanError = GooglerpcStatus;

export type AileanServiceGetTenantsByAccountIdData = AileanGetTenantsByAccountIdResponse;

export type AileanServiceGetTenantsByAccountIdError = GooglerpcStatus;

export type AileanServiceGetTicketData = AileanGetTicketResponse;

export type AileanServiceGetTicketError = GooglerpcStatus;

export type AileanServiceHasAileanEnabledData = AileanHasAileanEnabledResponse;

export type AileanServiceHasAileanEnabledError = GooglerpcStatus;

export type AileanServiceGetJwtPublicKeyData = CommonaileanGetJwtPublicKeyResponse;

export type AileanServiceGetJwtPublicKeyError = GooglerpcStatus;

export type AileanServiceListEmployeesByAccountIdData = AileanListEmployeesByAccountIdResponse;

export type AileanServiceListEmployeesByAccountIdError = GooglerpcStatus;

export type AileanServiceListPropertiesByAccountIdData = AileanListPropertiesByAccountIdResponse;

export type AileanServiceListPropertiesByAccountIdError = GooglerpcStatus;

export type AileanServiceListPropertyActivationsData = AileanListPropertyActivationsResponse;

export type AileanServiceListPropertyActivationsError = GooglerpcStatus;

export type AileanServiceListTicketCommentsData = AileanListTicketCommentsResponse;

export type AileanServiceListTicketCommentsError = GooglerpcStatus;

export type AileanServiceGetSsoUrlData = CommonaileanGetSsoUrlResponse;

export type AileanServiceGetSsoUrlError = GooglerpcStatus;

export type AileanServiceUpdateTicketData = AileanUpdateTicketResponse;

export type AileanServiceUpdateTicketError = GooglerpcStatus;

export interface CredittrustServiceGetCertificateParams {
  orderId?: string;
}

export type CredittrustServiceGetCertificateData = CredittrustGetCertificateResponse;

export type CredittrustServiceGetCertificateError = GooglerpcStatus;

export type CredittrustServiceOrderCertificateData = CredittrustOrderCertificateResponse;

export type CredittrustServiceOrderCertificateError = GooglerpcStatus;

export type CredittrustServiceVerifyCertificateData = CredittrustVerifyCertificateResponse;

export type CredittrustServiceVerifyCertificateError = GooglerpcStatus;

export type DeepoServiceAnalyseNodeStatusData = DeepoAnalyseNodeStatusResponse;

export type DeepoServiceAnalyseNodeStatusError = GooglerpcStatus;

export type DeepoServiceGetFileTransmissionsByReferenceIdData = DeepoGetFileTransmissionsByReferenceIdResponse;

export type DeepoServiceGetFileTransmissionsByReferenceIdError = GooglerpcStatus;

export interface DeepoServiceGetPartnerAccessUrlParams {
  /** @format int64 */
  accountId?: string;
}

export type DeepoServiceGetPartnerAccessUrlData = CommondeepoGetPartnerAccessUrlResponse;

export type DeepoServiceGetPartnerAccessUrlError = GooglerpcStatus;

export interface DeepoServiceHasDeepoEnabledParams {
  /** @format int64 */
  accountId?: string;
}

export type DeepoServiceHasDeepoEnabledData = DeepoHasDeepoEnabledResponse;

export type DeepoServiceHasDeepoEnabledError = GooglerpcStatus;

export type DeepoServiceRepairServiceAccountData = DeepoRepairServiceAccountResponse;

export type DeepoServiceRepairServiceAccountError = GooglerpcStatus;

export type DeepoServiceSendFileData = DeepoSendFileResponse;

export type DeepoServiceSendFileError = GooglerpcStatus;

export type DeepsignServiceCountOpenSignRequestsData = DeepsignCountOpenSignRequestsResponse;

export type DeepsignServiceCountOpenSignRequestsError = GooglerpcStatus;

export interface DeepsignServiceGetPartnerAccessUrlParams {
  /** @format int64 */
  accountId?: string;
}

export type DeepsignServiceGetPartnerAccessUrlData = CommondeepsignGetPartnerAccessUrlResponse;

export type DeepsignServiceGetPartnerAccessUrlError = GooglerpcStatus;

export interface DeepsignServiceHasDocumentSignatureEnabledParams {
  /** @format int64 */
  accountId?: string;
}

export type DeepsignServiceHasDocumentSignatureEnabledData = CommondeepsignHasDocumentSignatureEnabledResponse;

export type DeepsignServiceHasDocumentSignatureEnabledError = GooglerpcStatus;

export interface DeepsignServiceListSignRequestsParams {
  /** @format int64 */
  accountId?: string;
}

export type DeepsignServiceListSignRequestsData = DeepsignListSignRequestsResponse;

export type DeepsignServiceListSignRequestsError = GooglerpcStatus;

export type DeepsignServiceListSignRequestsByAttachToReferenceIdsData =
  DeepsignListSignRequestsByAttachToReferenceIdsResponse;

export type DeepsignServiceListSignRequestsByAttachToReferenceIdsError = GooglerpcStatus;

export type DeepsignServiceSignDocumentData = DeepsignSignDocumentResponse;

export type DeepsignServiceSignDocumentError = GooglerpcStatus;

export interface DeepsignServiceCancelSignRequestParams {
  message?: string;
  id: string;
}

export type DeepsignServiceCancelSignRequestData = DeepsignCancelSignRequestResponse;

export type DeepsignServiceCancelSignRequestError = GooglerpcStatus;

export type DeepsignServiceDownloadFileData = DeepsignDownloadFileResponse;

export type DeepsignServiceDownloadFileError = GooglerpcStatus;

export interface EvorestServiceEnablePayload {
  allowSwissCaution?: boolean;
  apiKey?: string;
  enable?: boolean;
}

export type EvorestServiceEnableData = CommonevorestEnableResponse;

export type EvorestServiceEnableError = GooglerpcStatus;

export type EvorestServiceGetAccountSettingsData = CommonevorestGetAccountSettingsResponse;

export type EvorestServiceGetAccountSettingsError = GooglerpcStatus;

export type EvorestServiceGetDepositInfoData = CommonevorestGetDepositInfoResponse;

export type EvorestServiceGetDepositInfoError = GooglerpcStatus;

export type EvorestServiceGetOwnerConfigData = EvorestGetOwnerConfigResponse;

export type EvorestServiceGetOwnerConfigError = GooglerpcStatus;

export type EvorestServiceHasEnabledData = CommonevorestHasEnabledResponse;

export type EvorestServiceHasEnabledError = GooglerpcStatus;

export type EvorestServiceOpenDepositData = CommonevorestOpenDepositResponse;

export type EvorestServiceOpenDepositError = GooglerpcStatus;

export interface EvorestServiceSetOwnerConfigPayload {
  allowInvestment?: ApplicableApplicable;
}

export type EvorestServiceSetOwnerConfigData = EvorestSetOwnerConfigResponse;

export type EvorestServiceSetOwnerConfigError = GooglerpcStatus;

export type FirstcautionServiceEnableData = CommonfirstcautionEnableResponse;

export type FirstcautionServiceEnableError = GooglerpcStatus;

export type FirstcautionServiceGetDepositInfoData = CommonfirstcautionGetDepositInfoResponse;

export type FirstcautionServiceGetDepositInfoError = GooglerpcStatus;

export type FirstcautionServiceHasEnabledData = CommonfirstcautionHasEnabledResponse;

export type FirstcautionServiceHasEnabledError = GooglerpcStatus;

export type FirstcautionServiceOpenDepositData = CommonfirstcautionOpenDepositResponse;

export type FirstcautionServiceOpenDepositError = GooglerpcStatus;

export interface GocautionServiceEnablePayload {
  clientId?: string;
  clientSecret?: string;
  enable?: boolean;
  loginUrl?: string;
}

export type GocautionServiceEnableData = CommongocautionEnableResponse;

export type GocautionServiceEnableError = GooglerpcStatus;

export type GocautionServiceGetAccountSettingsData = CommongocautionGetAccountSettingsResponse;

export type GocautionServiceGetAccountSettingsError = GooglerpcStatus;

export type GocautionServiceGetDepositInfoData = CommongocautionGetDepositInfoResponse;

export type GocautionServiceGetDepositInfoError = GooglerpcStatus;

export type GocautionServiceHasEnabledData = CommongocautionHasEnabledResponse;

export type GocautionServiceHasEnabledError = GooglerpcStatus;

export type GocautionServiceOpenDepositData = CommongocautionOpenDepositResponse;

export type GocautionServiceOpenDepositError = GooglerpcStatus;

export type M2MServiceGetTokenData = Commonm2MGetTokenResponse;

export type M2MServiceGetTokenError = GooglerpcStatus;

export type NoteServiceCreateData = CommonnoteCreateResponse;

export type NoteServiceCreateError = GooglerpcStatus;

export type NoteServiceCreateFromMailData = NoteCreateFromMailResponse;

export type NoteServiceCreateFromMailError = GooglerpcStatus;

export type NoteServiceCreateUnregisteredData = NoteCreateUnregisteredResponse;

export type NoteServiceCreateUnregisteredError = GooglerpcStatus;

export type NoteServiceDeleteData = CommonnoteDeleteResponse;

export type NoteServiceDeleteError = GooglerpcStatus;

export type NoteServiceListByReferenceIdsData = CommonnoteListByReferenceIdsResponse;

export type NoteServiceListByReferenceIdsError = GooglerpcStatus;

export interface NoteServiceUpdatePayload {
  mediaIds?: string[];
  mentions?: NoteMention[];
  note?: string;
}

export type NoteServiceUpdateData = CommonnoteUpdateResponse;

export type NoteServiceUpdateError = GooglerpcStatus;

export type NylasAuthServiceGetMyConfigData = NylasAuthGetMyConfigResponse;

export type NylasAuthServiceGetMyConfigError = GooglerpcStatus;

export interface NylasAuthServiceStartAuthParams {
  /** The scopes to request during authentication. */
  scopes?: ScopesEnum[];
  /** The URL where authentication process was started. */
  initialUrl?: string;
}

export enum ScopesEnum {
  SCOPE_UNDEFINED = "SCOPE_UNDEFINED",
  SCOPE_EMAIL = "SCOPE_EMAIL",
  SCOPE_CALENDAR = "SCOPE_CALENDAR",
}

export type NylasAuthServiceStartAuthData = NylasAuthStartAuthResponse;

export type NylasAuthServiceStartAuthError = GooglerpcStatus;

export enum NylasAuthServiceStartAuthParams1ScopesEnum {
  SCOPE_UNDEFINED = "SCOPE_UNDEFINED",
  SCOPE_EMAIL = "SCOPE_EMAIL",
  SCOPE_CALENDAR = "SCOPE_CALENDAR",
}

export type NylasAuthServiceUnlinkData = NylasAuthUnlinkResponse;

export type NylasAuthServiceUnlinkError = GooglerpcStatus;

export type ZipServiceGetInfoData = ZipGetInfoResponse;

export type ZipServiceGetInfoError = GooglerpcStatus;

export type TelephoneServiceGet3CxApiKeyData = TelephoneGet3CXApiKeyResponse;

export type TelephoneServiceGet3CxApiKeyError = GooglerpcStatus;

export interface TelephoneServiceSet3CxApiKeyPayload {
  apiKey?: string;
}

export type TelephoneServiceSet3CxApiKeyData = TelephoneSet3CXApiKeyResponse;

export type TelephoneServiceSet3CxApiKeyError = GooglerpcStatus;

export type ContactServiceActivateData = Contactv2ActivateResponse;

export type ContactServiceActivateError = GooglerpcStatus;

export type ActivityServiceCreateMixin5Data = Contactactivityv2CreateResponse;

export type ActivityServiceCreateMixin5Error = GooglerpcStatus;

export type ActivityServiceDeleteMixin5Data = Contactactivityv2DeleteResponse;

export type ActivityServiceDeleteMixin5Error = GooglerpcStatus;

export type ActivityServiceGetMixin5Data = Contactactivityv2GetResponse;

export type ActivityServiceGetMixin5Error = GooglerpcStatus;

export type ActivityServiceListByContactIdsData = Activityv2ListByContactIdsResponse;

export type ActivityServiceListByContactIdsError = GooglerpcStatus;

export type ActivityServiceListByReferenceIdsMixin5Data = Activityv2ListByReferenceIdsResponse;

export type ActivityServiceListByReferenceIdsMixin5Error = GooglerpcStatus;

export interface ActivityServiceUpdateMixin5Payload {
  contactIds?: string[];
  documentIds?: string[];
  employeeContactId?: string;
  referenceIds?: string[];
  subject?: string;
  text?: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestamp?: string;
}

export type ActivityServiceUpdateMixin5Data = Contactactivityv2UpdateResponse;

export type ActivityServiceUpdateMixin5Error = GooglerpcStatus;

export type ContactServiceCheckDuplicatesData = V2CheckDuplicatesResponse;

export type ContactServiceCheckDuplicatesError = GooglerpcStatus;

export type ContactServiceCopyContactsData = V2CopyContactsResponse;

export type ContactServiceCopyContactsError = GooglerpcStatus;

export type ContactServiceCreateCompanyData = V2CreateCompanyResponse;

export type ContactServiceCreateCompanyError = GooglerpcStatus;

export type ContactServiceCreatePersonData = V2CreatePersonResponse;

export type ContactServiceCreatePersonError = GooglerpcStatus;

export type ContactServiceDeactivateData = Contactv2DeactivateResponse;

export type ContactServiceDeactivateError = GooglerpcStatus;

export type ContactServiceDeleteData = Contactcontactv2DeleteResponse;

export type ContactServiceDeleteError = GooglerpcStatus;

export type ContactServiceDuplicateContactsData = V2DuplicateContactsResponse;

export type ContactServiceDuplicateContactsError = GooglerpcStatus;

export type ContactServiceGetOwnerContactData = V2GetOwnerContactResponse;

export type ContactServiceGetOwnerContactError = GooglerpcStatus;

export type ContactServiceGetUsedTagsData = Contactv2GetUsedTagsResponse;

export type ContactServiceGetUsedTagsError = GooglerpcStatus;

export type ContactServiceLinkCompaniesData = V2LinkCompaniesResponse;

export type ContactServiceLinkCompaniesError = GooglerpcStatus;

export type ContactServiceLinkPersonsData = V2LinkPersonsResponse;

export type ContactServiceLinkPersonsError = GooglerpcStatus;

export type ContactServiceListData = Contactcontactv2ListResponse;

export type ContactServiceListError = GooglerpcStatus;

export type ContactServiceListEmployeesData = Contactcontactv2ListEmployeesResponse;

export type ContactServiceListEmployeesError = GooglerpcStatus;

export type ContactServiceListForPhoneProviderData = V2ListForPhoneProviderResponse;

export type ContactServiceListForPhoneProviderError = GooglerpcStatus;

export type ContactServicePublishUpdatedEventsData = Contactv2PublishUpdatedEventsResponse;

export type ContactServicePublishUpdatedEventsError = GooglerpcStatus;

export type ContactServiceResolveData = V2ResolveResponse;

export type ContactServiceResolveError = GooglerpcStatus;

export interface ContactServiceResolveByMailPayload {
  emails?: string[];
}

export type ContactServiceResolveByMailData = V2ResolveByMailResponse;

export type ContactServiceResolveByMailError = GooglerpcStatus;

export type ContactServiceResolveByMailMultipleOwnersData = V2ResolveByMailMultipleOwnersResponse;

export type ContactServiceResolveByMailMultipleOwnersError = GooglerpcStatus;

export type ContactServiceResolveEmployeesData = V2ResolveEmployeesResponse;

export type ContactServiceResolveEmployeesError = GooglerpcStatus;

export type ContactServiceSearchByMailData = V2SearchByMailResponse;

export type ContactServiceSearchByMailError = GooglerpcStatus;

export type ContactServiceSetAddressData = V2SetAddressResponse;

export type ContactServiceSetAddressError = GooglerpcStatus;

export type ContactServiceUnLinkCompaniesData = V2UnLinkCompaniesResponse;

export type ContactServiceUnLinkCompaniesError = GooglerpcStatus;

export type ContactServiceUnLinkPersonsData = V2UnLinkPersonsResponse;

export type ContactServiceUnLinkPersonsError = GooglerpcStatus;

export type ContactServiceUpdateAddressHistoryData = V2UpdateAddressHistoryResponse;

export type ContactServiceUpdateAddressHistoryError = GooglerpcStatus;

export interface ContactServiceAddContactPersonPayload {
  address?: CommonaddressAddress;
  birthName?: string;
  birthplace?: string;
  civilStatus?: Contactcontactv2CivilStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth?: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath?: TypeDate;
  email?: string;
  employment?: Contactcontactv2Employment;
  firstName?: string;
  gender?: Contactcontactv2Gender;
  includeInSerialEmails?: boolean;
  lastName?: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name?: string;
  nationality?: string;
  note?: string;
  /** @format int64 */
  numericId?: string;
  phoneNumbers?: V2PhoneNumber[];
  portalAccess?: boolean;
  preferredLanguage?: LanguagePreferredLanguage;
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus?: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil?: TypeDate;
  salutationName?: string;
  title?: string;
}

export type ContactServiceAddContactPersonData = V2AddContactPersonResponse;

export type ContactServiceAddContactPersonError = GooglerpcStatus;

export interface ContactServiceDeleteContactPersonsPayload {
  contactPersonIds?: string[];
}

export type ContactServiceDeleteContactPersonsData = V2DeleteContactPersonsResponse;

export type ContactServiceDeleteContactPersonsError = GooglerpcStatus;

export interface ContactServiceUpdateContactPersonPayload {
  address?: CommonaddressAddress;
  birthName?: string;
  birthplace?: string;
  civilStatus?: Contactcontactv2CivilStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth?: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath?: TypeDate;
  email?: string;
  employment?: Contactcontactv2Employment;
  firstName?: string;
  gender?: Contactcontactv2Gender;
  includeInSerialEmails?: boolean;
  lastName?: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name?: string;
  nationality?: string;
  note?: string;
  phoneNumbers?: V2PhoneNumber[];
  portalAccess?: boolean;
  preferredLanguage?: LanguagePreferredLanguage;
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus?: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil?: TypeDate;
  salutationName?: string;
  title?: string;
}

export type ContactServiceUpdateContactPersonData = Contactcontactv2UpdateContactPersonResponse;

export type ContactServiceUpdateContactPersonError = GooglerpcStatus;

export type ContactServiceAddDocumentsData = Contactv2AddDocumentsResponse;

export type ContactServiceAddDocumentsError = GooglerpcStatus;

export interface ContactServiceDeleteAddressPayload {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom?: TypeDate;
}

export type ContactServiceDeleteAddressData = V2DeleteAddressResponse;

export type ContactServiceDeleteAddressError = GooglerpcStatus;

export type ContactServiceRemoveDocumentsData = Contactv2RemoveDocumentsResponse;

export type ContactServiceRemoveDocumentsError = GooglerpcStatus;

export interface ContactServiceUpdateCompanyPayload {
  address?: CommonaddressAddress;
  /** official contact email of the company, not the email of the responsible person (e.g. info@company.com) */
  email?: string;
  iban?: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId?: string;
  includeInSerialEmails?: boolean;
  industries?: IndustryIndustry[];
  legalForm?: V2LegalForm;
  name?: string;
  note?: string;
  /** @format int64 */
  ownerId?: string;
  phoneNumbers?: V2PhoneNumber[];
  portalAccess?: boolean;
  preferredCommunicationChannel?: V2PreferredCommunicationChannel;
  preferredLanguage?: LanguagePreferredLanguage;
  salutationName?: string;
  tags?: string[];
  types?: Contactcontactv2Type[];
  uniqueEnterpriseIdentification?: string;
  vatNumber?: string;
  website?: string;
}

export type ContactServiceUpdateCompanyData = Contactcontactv2UpdateCompanyResponse;

export type ContactServiceUpdateCompanyError = GooglerpcStatus;

export interface ContactServiceUpdateGenericPayload {
  address?: CommonaddressAddress;
  email?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  phoneNumbers?: V2PhoneNumber[];
}

export type ContactServiceUpdateGenericData = V2UpdateGenericResponse;

export type ContactServiceUpdateGenericError = GooglerpcStatus;

export interface ContactServiceUpdatePersonPayload {
  address?: CommonaddressAddress;
  ahv?: string;
  birthName?: string;
  birthplace?: string;
  civilStatus?: Contactcontactv2CivilStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfBirth?: TypeDate;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  dateOfDeath?: TypeDate;
  email?: string;
  employment?: Contactcontactv2Employment;
  firstName?: string;
  gender?: Contactcontactv2Gender;
  iban?: string;
  /** Optional external ID from an import source (e.g. third-party contact ID) */
  importReferenceId?: string;
  industries?: IndustryIndustry[];
  lastName?: string;
  /**
   * name is the full name of the person. It can be the only field set if no firstName+lastName separation is possible.
   * If 'firstName' and 'lastName' are set and 'name' is not, name is set to: firstName + ' ' + lastName
   */
  name?: string;
  nationality?: string;
  note?: string;
  /** @format int64 */
  ownerId?: string;
  phoneNumbers?: V2PhoneNumber[];
  preferredCommunicationChannel?: V2PreferredCommunicationChannel;
  preferredLanguage?: LanguagePreferredLanguage;
  /**
   * ResidenceStatus provides an enumeration for the different swiss residence status a person can have.
   *
   *  - RESIDENCE_STATUS_B_STAY: B - Aufenthaltsbewilligung
   *  - RESIDENCE_STATUS_C_SETTLE: C - Niederlassungsbewilligung
   *  - RESIDENCE_STATUS_CI_STAY_EMPLOYMENT: Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit
   *  - RESIDENCE_STATUS_G_BORDER_CROSSER: G - Grenzgängerbewilligung
   *  - RESIDENCE_STATUS_L_SHORT_STAY: L -  Kurzaufenthaltsbewilligung
   *  - RESIDENCE_STATUS_F_PRELIMINARY_FOREIGNER: F - Vorläufig aufgenommene Ausländer
   *  - RESIDENCE_STATUS_N_SEEKING_ASYLUM: N - Asylsuchender
   *  - RESIDENCE_STATUS_S_PROTECTION_NEEDED: S - Schutzbedürftige
   */
  residenceStatus?: Contactcontactv2ResidenceStatus;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  residenceStatusValidUntil?: TypeDate;
  salutationName?: string;
  tags?: string[];
  title?: string;
  types?: Contactcontactv2Type[];
  website?: string;
  workEmail?: V2AdditionalEmail;
}

export type ContactServiceUpdatePersonData = V2UpdatePersonResponse;

export type ContactServiceUpdatePersonError = GooglerpcStatus;

export type ActivityServiceCreateData = Activityv3CreateResponse;

export type ActivityServiceCreateError = GooglerpcStatus;

export type ActivityServiceDeleteData = Activityv3DeleteResponse;

export type ActivityServiceDeleteError = GooglerpcStatus;

export type ActivityServiceGetData = Activityv3GetResponse;

export type ActivityServiceGetError = GooglerpcStatus;

export type ActivityServiceListByReferenceIdsData = Activityv3ListByReferenceIdsResponse;

export type ActivityServiceListByReferenceIdsError = GooglerpcStatus;

export interface ActivityServiceUpdatePayload {
  billable?: boolean;
  employeeContactIds?: string[];
  hasEndTime?: boolean;
  hasStartTime?: boolean;
  /** @format double */
  hourlyRate?: number;
  mediaIds?: string[];
  references?: V3ActivityReference[];
  source?: V3Source;
  subject?: string;
  text?: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampEnd?: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  timestampStart?: string;
}

export type ActivityServiceUpdateData = Activityv3UpdateResponse;

export type ActivityServiceUpdateError = GooglerpcStatus;

export interface TendServiceGetRedXAreaModelParams {
  /**
   * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
   * a year.
   * @format int32
   */
  endDateYear?: number;
  /**
   * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
   * month and day.
   * @format int32
   */
  endDateMonth?: number;
  /**
   * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
   * to specify a year by itself or a year and month where the day isn't
   * significant.
   * @format int32
   */
  endDateDay?: number;
}

export type TendServiceGetRedXAreaModelData = TendGetRedXAreaModelResponse;

export type TendServiceGetRedXAreaModelError = GooglerpcStatus;

export interface TendServiceGetRentalIndexCsvParams {
  /**
   * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
   * a year.
   * @format int32
   */
  endDateYear?: number;
  /**
   * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
   * month and day.
   * @format int32
   */
  endDateMonth?: number;
  /**
   * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
   * to specify a year by itself or a year and month where the day isn't
   * significant.
   * @format int32
   */
  endDateDay?: number;
}

export type TendServiceGetRentalIndexCsvData = TendGetRentalIndexCSVResponse;

export type TendServiceGetRentalIndexCsvError = GooglerpcStatus;

export type CredentialServiceCreateData = CredentialsCreateCredentialsResponse;

export type CredentialServiceCreateError = GooglerpcStatus;

export type CredentialServiceFindDecryptedData = CredentialsFindDecryptedCredentialsResponse;

export type CredentialServiceFindDecryptedError = GooglerpcStatus;

export type CredentialServiceUpdateData = CredentialsUpdateCredentialsResponse;

export type CredentialServiceUpdateError = GooglerpcStatus;

export type ExportServiceCreateData = V2CreateExportResponse;

export type ExportServiceCreateError = GooglerpcStatus;

export type ExportServiceDeleteData = V2DeleteExportResponse;

export type ExportServiceDeleteError = GooglerpcStatus;

export type ExportServiceFindData = V2FindExportResponse;

export type ExportServiceFindError = GooglerpcStatus;

export type ExportServiceListData = V2ListExportsResponse;

export type ExportServiceListError = GooglerpcStatus;

export type ExportServiceListObjectPlatformsData = V2ListObjectPlatformsResponse;

export type ExportServiceListObjectPlatformsError = GooglerpcStatus;

export type ExportServiceListPresetsData = V2ListPresetsResponse;

export type ExportServiceListPresetsError = GooglerpcStatus;

export type ExportServiceRemoveAllTargetsData = V2RemoveAllTargetsResponse;

export type ExportServiceRemoveAllTargetsError = GooglerpcStatus;

export type HistoryServiceGetLatestData = Exporthistoryv2GetLatestResponse;

export type HistoryServiceGetLatestError = GooglerpcStatus;

export type HistoryServiceStatisticsData = V2StatisticsResponse;

export type HistoryServiceStatisticsError = GooglerpcStatus;

export type ExportServiceSendExportUploadCommandData = V2SendExportUploadCommandResponse;

export type ExportServiceSendExportUploadCommandError = GooglerpcStatus;

export type ExportServiceSetAgencyIdData = V2SetAgencyIdResponse;

export type ExportServiceSetAgencyIdError = GooglerpcStatus;

export type ExportServiceSetPresetData = V2SetPresetResponse;

export type ExportServiceSetPresetError = GooglerpcStatus;

export type ExportServiceStartData = V2StartExportResponse;

export type ExportServiceStartError = GooglerpcStatus;

export type ExportServiceUpdateData = V2UpdateExportResponse;

export type ExportServiceUpdateError = GooglerpcStatus;

export type ExportServiceUpdatePlatformsData = V2UpdatePlatformsResponse;

export type ExportServiceUpdatePlatformsError = GooglerpcStatus;

export type StoreServiceUploadData = StoreMedia;

export type StoreServiceUploadError = GooglerpcStatus;

export type StoreServiceCompleteUploadData = StoreCompleteUploadResponse;

export type StoreServiceCompleteUploadError = GooglerpcStatus;

export type StoreServiceCreateUploadData = StoreCreateUploadResponse;

export type StoreServiceCreateUploadError = GooglerpcStatus;

export interface DocumentServiceGetParams {
  id?: string;
}

export type DocumentServiceGetData = MediadocumentDocument;

export type DocumentServiceGetError = GooglerpcStatus;

export type DocumentServiceSaveData = MediadocumentDocument;

export type DocumentServiceSaveError = GooglerpcStatus;

export type DocumentServiceListData = MediadocumentListResponse;

export type DocumentServiceListError = GooglerpcStatus;

export type DocumentServiceMergeAllDocumentsData = DocumentMergeAllDocumentsResponse;

export type DocumentServiceMergeAllDocumentsError = GooglerpcStatus;

export interface DocumentServiceUpdatePayload {
  name?: string;
  showInPortal?: boolean;
  type?: MediadocumentType;
}

export type DocumentServiceUpdateData = MediadocumentUpdateResponse;

export type DocumentServiceUpdateError = GooglerpcStatus;

export interface DocumentServiceAddVersionPayload {
  mediaId?: string;
}

export type DocumentServiceAddVersionData = MediadocumentDocument;

export type DocumentServiceAddVersionError = GooglerpcStatus;

export type DocumentServiceRemoveVersionData = MediadocumentDocument;

export type DocumentServiceRemoveVersionError = GooglerpcStatus;

export type StoreServiceListData = StoreListMediaResponse;

export type StoreServiceListError = GooglerpcStatus;

export type StoreServiceSetPublicFlagData = StoreSetPublicFlagResponse;

export type StoreServiceSetPublicFlagError = GooglerpcStatus;

export type StoreServiceGetData = StoreGetMediaResponse;

export type StoreServiceGetError = GooglerpcStatus;

export type StoreServiceDeleteData = StoreDeleteMediaResponse;

export type StoreServiceDeleteError = GooglerpcStatus;

export type MailServiceActivateMailboxesData = V2ActivateMailboxesResponse;

export type MailServiceActivateMailboxesError = GooglerpcStatus;

export type MailServiceAddConfidentialEmailsData = V2AddConfidentialEmailsResponse;

export type MailServiceAddConfidentialEmailsError = GooglerpcStatus;

export type MailServiceArchiveData = V2ArchiveResponse;

export type MailServiceArchiveError = GooglerpcStatus;

export type MailServiceBulkSendMailData = V2BulkSendMailResponse;

export type MailServiceBulkSendMailError = GooglerpcStatus;

export type MailServiceCountDraftsData = V2CountDraftsResponse;

export type MailServiceCountDraftsError = GooglerpcStatus;

export type MailServiceCountUnreadMailsData = V2CountUnreadMailsResponse;

export type MailServiceCountUnreadMailsError = GooglerpcStatus;

export type MailServiceCreateDomainData = V2CreateDomainResponse;

export type MailServiceCreateDomainError = GooglerpcStatus;

export type MailServiceCreateMailboxData = V2CreateMailboxResponse;

export type MailServiceCreateMailboxError = GooglerpcStatus;

export type MailServiceDeactivateMailboxesData = V2DeactivateMailboxesResponse;

export type MailServiceDeactivateMailboxesError = GooglerpcStatus;

export type MailServiceDeleteDomainData = V2DeleteDomainResponse;

export type MailServiceDeleteDomainError = GooglerpcStatus;

export type MailServiceDeleteDraftsData = V2DeleteDraftsResponse;

export type MailServiceDeleteDraftsError = GooglerpcStatus;

export type MailServiceDeleteMailsData = V2DeleteMailsResponse;

export type MailServiceDeleteMailsError = GooglerpcStatus;

export interface MailServiceEditMailboxPayload {
  allowedUserIds?: string[];
  /** Can be empty if no specific user is using this mailbox */
  mainUserId?: string;
  name?: string;
  outboundEmail?: string;
  signatureId?: string;
}

export type MailServiceEditMailboxData = V2EditMailboxResponse;

export type MailServiceEditMailboxError = GooglerpcStatus;

export type MailServiceForwardData = V2ForwardResponse;

export type MailServiceForwardError = GooglerpcStatus;

export type MailServiceGetDeliveryAndEngagementDataData = V2GetDeliveryAndEngagementDataResponse;

export type MailServiceGetDeliveryAndEngagementDataError = GooglerpcStatus;

export type MailServiceGetMailboxData = V2GetMailboxResponse;

export type MailServiceGetMailboxError = GooglerpcStatus;

export interface MailServiceHasDomainDedicatedIpParams {
  fromEmail?: string;
}

export type MailServiceHasDomainDedicatedIpData = V2HasDomainDedicatedIpResponse;

export type MailServiceHasDomainDedicatedIpError = GooglerpcStatus;

export type MailServiceListConfidentialEmailsData = V2ListConfidentialEmailsResponse;

export type MailServiceListConfidentialEmailsError = GooglerpcStatus;

export type MailServiceListDomainsData = V2ListDomainsResponse;

export type MailServiceListDomainsError = GooglerpcStatus;

export type MailServiceListDraftsData = V2ListDraftsResponse;

export type MailServiceListDraftsError = GooglerpcStatus;

export type MailServiceListLatestMailsForReferenceIdsData = V2ListLatestMailsForReferenceIdsResponse;

export type MailServiceListLatestMailsForReferenceIdsError = GooglerpcStatus;

export type MailServiceListMailIdsData = V2ListMailIdsResponse;

export type MailServiceListMailIdsError = GooglerpcStatus;

export type MailServiceListMailboxesByAccountIdData = V2ListMailboxesByAccountIdResponse;

export type MailServiceListMailboxesByAccountIdError = GooglerpcStatus;

export type MailServiceListMailboxesByUserIdData = V2ListMailboxesByUserIdResponse;

export type MailServiceListMailboxesByUserIdError = GooglerpcStatus;

export type MailServiceListMailsData = V2ListMailsResponse;

export type MailServiceListMailsError = GooglerpcStatus;

export type MailServiceListMailsByIdsData = V2ListMailsByIdsResponse;

export type MailServiceListMailsByIdsError = GooglerpcStatus;

export type MailServiceListMailsByReferenceIdsData = V2ListMailsByReferenceIdsResponse;

export type MailServiceListMailsByReferenceIdsError = GooglerpcStatus;

export type MailServiceMarkAsNoSpamData = V2MarkAsNoSpamResponse;

export type MailServiceMarkAsNoSpamError = GooglerpcStatus;

export type MailServiceMarkAsSpamData = V2MarkAsSpamResponse;

export type MailServiceMarkAsSpamError = GooglerpcStatus;

export type MailServiceMarkReadData = Messagemailv2MarkReadResponse;

export type MailServiceMarkReadError = GooglerpcStatus;

export type MailServiceMarkUnreadData = Messagemailv2MarkUnreadResponse;

export type MailServiceMarkUnreadError = GooglerpcStatus;

export type MailServiceMoveToTrashData = V2MoveToTrashResponse;

export type MailServiceMoveToTrashError = GooglerpcStatus;

export type MailServiceRemoveConfidentialEmailsData = V2RemoveConfidentialEmailsResponse;

export type MailServiceRemoveConfidentialEmailsError = GooglerpcStatus;

export type MailServiceUnarchiveData = V2UnarchiveResponse;

export type MailServiceUnarchiveError = GooglerpcStatus;

export type MailServiceRestoreFromTrashData = V2RestoreFromTrashResponse;

export type MailServiceRestoreFromTrashError = GooglerpcStatus;

export type MailServiceSaveDraftData = V2SaveDraftResponse;

export type MailServiceSaveDraftError = GooglerpcStatus;

export type MailServiceSendMailData = V2SendMailResponse;

export type MailServiceSendMailError = GooglerpcStatus;

export type MailServiceSetAutomaticReplyData = V2SetAutomaticReplyResponse;

export type MailServiceSetAutomaticReplyError = GooglerpcStatus;

export type MailServiceSetConfidentialData = V2SetConfidentialResponse;

export type MailServiceSetConfidentialError = GooglerpcStatus;

export type MailServiceSetMailboxesConfidentialData = V2SetMailboxesConfidentialResponse;

export type MailServiceSetMailboxesConfidentialError = GooglerpcStatus;

export interface MailServiceSetReferenceIdsPayload {
  referenceIds?: string[];
}

export type MailServiceSetReferenceIdsData = V2SetReferenceIdsResponse;

export type MailServiceSetReferenceIdsError = GooglerpcStatus;

export type MailServiceValidateDomainData = V2ValidateDomainResponse;

export type MailServiceValidateDomainError = GooglerpcStatus;

export interface SignatureServiceListByAccountIdParams {
  /** @format int64 */
  accountId?: string;
}

export type SignatureServiceListByAccountIdData = V2ListByAccountIdResponse;

export type SignatureServiceListByAccountIdError = GooglerpcStatus;

export type SignatureServiceRenderByIdData = V2RenderByIdResponse;

export type SignatureServiceRenderByIdError = GooglerpcStatus;

export type SignatureServiceSetSignatureData = V2SetSignatureResponse;

export type SignatureServiceSetSignatureError = GooglerpcStatus;

export type SignatureServiceGetData = Messagesignaturev2GetResponse;

export type SignatureServiceGetError = GooglerpcStatus;

export type SignatureServiceRenderData = Messagesignaturev2RenderResponse;

export type SignatureServiceRenderError = GooglerpcStatus;

export interface SignatureServiceSetPayload {
  signature?: string;
}

export type SignatureServiceSetData = Signaturev2SetResponse;

export type SignatureServiceSetError = GooglerpcStatus;

export type SignatureServiceDeleteSignatureData = V2DeleteSignatureResponse;

export type SignatureServiceDeleteSignatureError = GooglerpcStatus;

export type TemplateServiceBulkRenderTextData = V2BulkRenderTextResponse;

export type TemplateServiceBulkRenderTextError = GooglerpcStatus;

export type TemplateServiceCreateData = Messagetemplatev2CreateResponse;

export type TemplateServiceCreateError = GooglerpcStatus;

export interface TemplateServiceListParams {
  /** @format int64 */
  ownerId?: string;
}

export type TemplateServiceListData = Messagetemplatev2ListResponse;

export type TemplateServiceListError = GooglerpcStatus;

export type TemplateServiceRenderTextData = V2RenderTextResponse;

export type TemplateServiceRenderTextError = GooglerpcStatus;

export type TemplateServiceDeleteData = Messagetemplatev2DeleteResponse;

export type TemplateServiceDeleteError = GooglerpcStatus;

export interface TemplateServiceRenderPayload {
  buildingId?: string;
  contactId?: string;
  objectId?: string;
  propertyId?: string;
}

export type TemplateServiceRenderData = Messagetemplatev2RenderResponse;

export type TemplateServiceRenderError = GooglerpcStatus;

export interface TemplateServiceUpdatePayload {
  attachmentMediaIds?: string[];
  language?: string;
  message?: string;
  name?: string;
  subject?: string;
}

export type TemplateServiceUpdateData = Messagetemplatev2UpdateResponse;

export type TemplateServiceUpdateError = GooglerpcStatus;

export type AccountingServiceChangeContractRelationData = AccountingChangeContractRelationResponse;

export type AccountingServiceChangeContractRelationError = GooglerpcStatus;

export interface AccountingServiceGetDocSyncLogsParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** @format int64 */
  accountId: string;
}

export type AccountingServiceGetDocSyncLogsData = AccountingGetDocSyncLogsResponse;

export type AccountingServiceGetDocSyncLogsError = GooglerpcStatus;

export type AccountingServiceGetEnabledData = AccountingGetEnabledResponse;

export type AccountingServiceGetEnabledError = GooglerpcStatus;

export interface AccountingServiceGetLogsParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** @format int64 */
  accountId: string;
}

export type AccountingServiceGetLogsData = AccountingGetLogsResponse;

export type AccountingServiceGetLogsError = GooglerpcStatus;

export type AccountingServiceGetStatisticsData = ObjectaccountingGetStatisticsResponse;

export type AccountingServiceGetStatisticsError = GooglerpcStatus;

export type AccountingServiceIsEnabledData = AccountingIsEnabledResponse;

export type AccountingServiceIsEnabledError = GooglerpcStatus;

export type AccountingServiceListAllContractErrorsData = AccountingListAllContractErrorsResponse;

export type AccountingServiceListAllContractErrorsError = GooglerpcStatus;

export type AccountingServiceSetEnabledData = AccountingSetEnabledResponse;

export type AccountingServiceSetEnabledError = GooglerpcStatus;

export type AccountingServiceSkipNextEventData = AccountingSkipNextEventResponse;

export type AccountingServiceSkipNextEventError = GooglerpcStatus;

export type AccountingServiceTriggerDebitUntilSyncData = AccountingTriggerDebitUntilSyncResponse;

export type AccountingServiceTriggerDebitUntilSyncError = GooglerpcStatus;

export type AccountingServiceTriggerDocumentSyncData = AccountingTriggerDocumentSyncResponse;

export type AccountingServiceTriggerDocumentSyncError = GooglerpcStatus;

export type AccountingServiceTriggerRentAdjustmentSyncData = AccountingTriggerRentAdjustmentSyncResponse;

export type AccountingServiceTriggerRentAdjustmentSyncError = GooglerpcStatus;

export type ObjectServiceAddCraftsmenData = ObjectAddCraftsmenResponse;

export type ObjectServiceAddCraftsmenError = GooglerpcStatus;

export type ObjectServiceAddDocumentsData = ObjectobjectAddDocumentsResponse;

export type ObjectServiceAddDocumentsError = GooglerpcStatus;

export type ObjectServiceAddJanitorsData = ObjectAddJanitorsResponse;

export type ObjectServiceAddJanitorsError = GooglerpcStatus;

export type ObjectServiceAddServiceProvidersData = ObjectAddServiceProvidersResponse;

export type ObjectServiceAddServiceProvidersError = GooglerpcStatus;

export interface BriefbutlerServiceAcknowledgeErrorsParams {
  ids?: string[];
}

export type BriefbutlerServiceAcknowledgeErrorsData = BriefbutlerAcknowledgeErrorsResponse;

export type BriefbutlerServiceAcknowledgeErrorsError = GooglerpcStatus;

export interface BriefbutlerServiceListErrorsByAccountIdParams {
  /** @format int64 */
  ownerId?: string;
}

export type BriefbutlerServiceListErrorsByAccountIdData = BriefbutlerListErrorsByAccountIdResponse;

export type BriefbutlerServiceListErrorsByAccountIdError = GooglerpcStatus;

export interface BriefbutlerServiceLoadSettingsParams {
  /** @format int64 */
  accountId?: string;
}

export type BriefbutlerServiceLoadSettingsData = ObjectbriefbutlerLoadSettingsResponse;

export type BriefbutlerServiceLoadSettingsError = GooglerpcStatus;

export type BriefbutlerServiceSaveSettingsData = ObjectbriefbutlerSaveSettingsResponse;

export type BriefbutlerServiceSaveSettingsError = GooglerpcStatus;

export type BriefbutlerServiceSendRawDocumentData = BriefbutlerSendRawDocumentResponse;

export type BriefbutlerServiceSendRawDocumentError = GooglerpcStatus;

export type BuildingServiceAddBuildingContactsData = BuildingAddBuildingContactsResponse;

export type BuildingServiceAddBuildingContactsError = GooglerpcStatus;

export type BuildingServiceAddDocumentsData = ObjectbuildingAddDocumentsResponse;

export type BuildingServiceAddDocumentsError = GooglerpcStatus;

export interface BuildingServiceCountParams {
  /** @default "UNDEFINED_SCOPE" */
  scope?: ScopeEnum;
  /** @format int64 */
  accountId: string;
}

/** @default "UNDEFINED_SCOPE" */
export enum ScopeEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type BuildingServiceCountData = ObjectbuildingCountResponse;

export type BuildingServiceCountError = GooglerpcStatus;

/** @default "UNDEFINED_SCOPE" */
export enum BuildingServiceCountParams1ScopeEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type BuildingServiceCreateData = ObjectbuildingCreateResponse;

export type BuildingServiceCreateError = GooglerpcStatus;

export type BuildingServiceEditContactNoteData = BuildingEditBuildingContactsResponse;

export type BuildingServiceEditContactNoteError = GooglerpcStatus;

export type BuildingServiceGetData = ObjectbuildingGetResponse;

export type BuildingServiceGetError = GooglerpcStatus;

export type BuildingServiceGetByObjectIdData = BuildingGetByObjectIdResponse;

export type BuildingServiceGetByObjectIdError = GooglerpcStatus;

export interface BuildingServiceListParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  name?: string;
  address?: string;
  /** @format int32 */
  zipFrom?: number;
  /** @format int32 */
  zipTo?: number;
  networkPartnerIds?: string[];
  /** @default "UNDEFINED_SORT_ORDER" */
  sortObjectCount?: SortObjectCountEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortGrossTargetRentPerYear?: SortGrossTargetRentPerYearEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortGrossActualRentPerYear?: SortGrossActualRentPerYearEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortNetTargetRentPerYear?: SortNetTargetRentPerYearEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortNetActualRentPerYear?: SortNetActualRentPerYearEnum;
  /**
   * The accountId of the user who wants to list the buildings
   * @format int64
   */
  accountId: string;
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortObjectCountEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortGrossTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortGrossActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortNetTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortNetActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type BuildingServiceListData = ObjectbuildingListResponse;

export type BuildingServiceListError = GooglerpcStatus;

/** @default "UNDEFINED_SORT_ORDER" */
export enum BuildingServiceListParams1SortObjectCountEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum BuildingServiceListParams1SortGrossTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum BuildingServiceListParams1SortGrossActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum BuildingServiceListParams1SortNetTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum BuildingServiceListParams1SortNetActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type BuildingServiceListAllData = BuildingListAllResponse;

export type BuildingServiceListAllError = GooglerpcStatus;

export type BuildingServiceListByContactIdsData = ObjectbuildingListByContactIdsResponse;

export type BuildingServiceListByContactIdsError = GooglerpcStatus;

export interface BuildingServiceListByCoordinatesParams {
  /** @format double */
  southWestLat?: number;
  /** @format double */
  southWestLng?: number;
  /** @format double */
  northEastLat?: number;
  /** @format double */
  northEastLng?: number;
  /** @default "UNDEFINED_SCOPE" */
  scope?: ScopeEnum1;
}

/** @default "UNDEFINED_SCOPE" */
export enum ScopeEnum1 {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type BuildingServiceListByCoordinatesData = BuildingListByCoordinatesResponse;

export type BuildingServiceListByCoordinatesError = GooglerpcStatus;

/** @default "UNDEFINED_SCOPE" */
export enum BuildingServiceListByCoordinatesParams1ScopeEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type BuildingServiceListByIdsData = ObjectbuildingListByIdsResponse;

export type BuildingServiceListByIdsError = GooglerpcStatus;

export type BuildingServiceListByObjectIdsData = ObjectbuildingListByObjectIdsResponse;

export type BuildingServiceListByObjectIdsError = GooglerpcStatus;

export type BuildingServiceListFilterOptionsData = ObjectbuildingListFilterOptionsResponse;

export type BuildingServiceListFilterOptionsError = GooglerpcStatus;

export type BuildingServiceRemoveBuildingContactsData = BuildingRemoveBuildingContactsResponse;

export type BuildingServiceRemoveBuildingContactsError = GooglerpcStatus;

export type BuildingServiceDeleteData = ObjectbuildingDeleteResponse;

export type BuildingServiceDeleteError = GooglerpcStatus;

export interface BuildingServiceMoveBuildingPayload {
  newContractIds?: boolean;
  newPropertyId?: string;
}

export type BuildingServiceMoveBuildingData = BuildingMoveBuildingResponse;

export type BuildingServiceMoveBuildingError = GooglerpcStatus;

export interface BuildingServiceUpdatePayload {
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  acquisitionDate?: TypeDate;
  address?: CommonaddressAddress;
  /** @format float */
  buildingArea?: number;
  buildingStrategy?: BuildingBuildingStrategy;
  /** @format int64 */
  buildingValue?: string;
  buildingZone?: string;
  characteristics?: ObjectbuildingCharacteristics;
  constructionTypes?: BuildingConstructionType[];
  /** @format int32 */
  constructionYear?: number;
  contacts?: ObjectbuildingBuildingContact[];
  contractAmendments?: string;
  distances?: BuildingDistances;
  documentIds?: string[];
  egid?: string;
  energySources?: ObjectbuildingEnergySource[];
  /** @format int32 */
  floors?: number;
  imageMediaId?: string;
  landRegisterNumber?: string;
  locationQuality?: ObjectbuildingLocationQuality;
  name?: string;
  note?: string;
  /** @format int32 */
  number?: number;
  objectIds?: string[];
  /** @format float */
  plotArea?: number;
  plotIds?: string[];
  rating?: BuildingRating;
  realEstateNumber?: string;
  /** @format int32 */
  renovationYear?: number;
  sia?: BuildingSia;
  /** @format float */
  volume?: number;
}

export type BuildingServiceUpdateData = ObjectbuildingUpdateResponse;

export type BuildingServiceUpdateError = GooglerpcStatus;

export interface BuildingServiceUpdateMicroLocationRatingProposalPayload {
  /** @format float */
  microLocationRatingProposal?: number;
  /**
   * Deprecated. Not saved anymore.
   * @format float
   */
  motorway?: number;
  /**
   * Deprecated. Not saved anymore.
   * @format float
   */
  publicTransport?: number;
  /**
   * Deprecated. Not saved anymore.
   * @format float
   */
  shop?: number;
}

export type BuildingServiceUpdateMicroLocationRatingProposalData = BuildingUpdateMicroLocationRatingProposalResponse;

export type BuildingServiceUpdateMicroLocationRatingProposalError = GooglerpcStatus;

export type CondominiumServiceCreateData = ObjectcondominiumCreateResponse;

export type CondominiumServiceCreateError = GooglerpcStatus;

export type CondominiumServiceDeleteRentAdjustmentsData = ObjectcondominiumDeleteRentAdjustmentsResponse;

export type CondominiumServiceDeleteRentAdjustmentsError = GooglerpcStatus;

export type CondominiumServiceGetData = ObjectcondominiumGetResponse;

export type CondominiumServiceGetError = GooglerpcStatus;

export type CondominiumServiceHasActivatedCondominiumData = CondominiumHasActivatedCondominiumResponse;

export type CondominiumServiceHasActivatedCondominiumError = GooglerpcStatus;

export type CondominiumServiceListByBillingContactIdData = ObjectcondominiumListByBillingContactIdResponse;

export type CondominiumServiceListByBillingContactIdError = GooglerpcStatus;

export interface CondominiumServiceListByContactIdParams {
  billingContact?: boolean;
  owners?: boolean;
  correspondence?: boolean;
  roommates?: boolean;
  tenants?: boolean;
  contactId: string;
}

export type CondominiumServiceListByContactIdData = ObjectcondominiumListByContactIdResponse;

export type CondominiumServiceListByContactIdError = GooglerpcStatus;

export type CondominiumServiceListByIdsData = ObjectcondominiumListByIdsResponse;

export type CondominiumServiceListByIdsError = GooglerpcStatus;

export type CondominiumServiceListByObjectIdsData = ObjectcondominiumListByObjectIdsResponse;

export type CondominiumServiceListByObjectIdsError = GooglerpcStatus;

export type CondominiumServiceListByOwnerData = ObjectcondominiumListByOwnerResponse;

export type CondominiumServiceListByOwnerError = GooglerpcStatus;

export type CondominiumServiceListByOwnerContactData = CondominiumListByOwnerContactResponse;

export type CondominiumServiceListByOwnerContactError = GooglerpcStatus;

export type CondominiumServiceListByTenantContactsData = CondominiumListByTenantContactsResponse;

export type CondominiumServiceListByTenantContactsError = GooglerpcStatus;

export type CondominiumServiceListCurrentByObjectIdsData = ObjectcondominiumListCurrentByObjectIdsResponse;

export type CondominiumServiceListCurrentByObjectIdsError = GooglerpcStatus;

export type CondominiumServicePublishUpdatedEventsData = ObjectcondominiumPublishUpdatedEventsResponse;

export type CondominiumServicePublishUpdatedEventsError = GooglerpcStatus;

export type CondominiumServiceUpdateBulkData = ObjectcondominiumUpdateBulkResponse;

export type CondominiumServiceUpdateBulkError = GooglerpcStatus;

export type CondominiumServiceDeleteData = ObjectcondominiumDeleteResponse;

export type CondominiumServiceDeleteError = GooglerpcStatus;

export type CondominiumServiceActivateData = ObjectcondominiumActivateResponse;

export type CondominiumServiceActivateError = GooglerpcStatus;

export type CondominiumServiceAddDocumentsData = ObjectcondominiumAddDocumentsResponse;

export type CondominiumServiceAddDocumentsError = GooglerpcStatus;

export type CondominiumServiceDeactivateData = ObjectcondominiumDeactivateResponse;

export type CondominiumServiceDeactivateError = GooglerpcStatus;

export type CondominiumServiceRemoveDocumentsData = ObjectcondominiumRemoveDocumentsResponse;

export type CondominiumServiceRemoveDocumentsError = GooglerpcStatus;

export interface CondominiumServiceUpdatePayload {
  activated?: boolean;
  closed?: boolean;
  contract?: ObjectcondominiumContract;
  documentIds?: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt?: TypeDate;
  finalInvoiceCreated?: boolean;
  flatRateValues?: ObjectcondominiumFlatRateValues[];
  opted?: boolean;
  owner?: CondominiumOwner;
  rent?: ObjectcondominiumRent;
  secondaryResidence?: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt?: TypeDate;
  taxable?: boolean;
  tenants?: ObjectcondominiumTenant[];
}

export type CondominiumServiceUpdateData = ObjectcondominiumUpdateResponse;

export type CondominiumServiceUpdateError = GooglerpcStatus;

export type CondominiumServiceDeactivateByNumericIdData = ObjectcondominiumDeactivateByNumericIdResponse;

export type CondominiumServiceDeactivateByNumericIdError = GooglerpcStatus;

export type ContractServiceCreateTemplateData = ObjectcontractCreateTemplateResponse;

export type ContractServiceCreateTemplateError = GooglerpcStatus;

export type ContractServiceDeleteTemplateData = ObjectcontractDeleteTemplateResponse;

export type ContractServiceDeleteTemplateError = GooglerpcStatus;

export type ContractServiceListTemplatesData = ObjectcontractListTemplatesResponse;

export type ContractServiceListTemplatesError = GooglerpcStatus;

export type ContractServiceRenderTemplateData = ContractRenderTemplateResponse;

export type ContractServiceRenderTemplateError = GooglerpcStatus;

export type ContractServiceRenderDeviceTemplateData = ObjectcontractRenderDeviceTemplateResponse;

export type ContractServiceRenderDeviceTemplateError = GooglerpcStatus;

export type ContractServiceRenderTenanciesTemplateData = ObjectcontractRenderTenanciesTemplateResponse;

export type ContractServiceRenderTenanciesTemplateError = GooglerpcStatus;

export interface ContractServiceUpdateTemplatePayload {
  mediaId?: string;
  title?: string;
}

export type ContractServiceUpdateTemplateData = ObjectcontractUpdateTemplateResponse;

export type ContractServiceUpdateTemplateError = GooglerpcStatus;

export type ContractServiceRenderCondominiumTemplateData = ObjectcontractRenderCondominiumTemplateResponse;

export type ContractServiceRenderCondominiumTemplateError = GooglerpcStatus;

export type ContractServiceRenderCondominiumsTemplateData = ObjectcontractRenderCondominiumsTemplateResponse;

export type ContractServiceRenderCondominiumsTemplateError = GooglerpcStatus;

export type ContractServiceRenderContactTemplateData = ObjectcontractRenderContactTemplateResponse;

export type ContractServiceRenderContactTemplateError = GooglerpcStatus;

export type ContractServiceRenderContactsTemplateData = ObjectcontractRenderContactsTemplateResponse;

export type ContractServiceRenderContactsTemplateError = GooglerpcStatus;

export interface CountryIndexServiceGetInflationParams {
  /** @default "COUNTRY_INDEX_BASE_YEAR_1914" */
  baseYear?: BaseYearEnum;
  /** @format int32 */
  month?: number;
  /** @format int32 */
  year?: number;
}

/** @default "COUNTRY_INDEX_BASE_YEAR_1914" */
export enum BaseYearEnum {
  COUNTRYINDEXBASEYEAR1914 = "COUNTRY_INDEX_BASE_YEAR_1914",
  COUNTRYINDEXBASEYEAR1939 = "COUNTRY_INDEX_BASE_YEAR_1939",
  COUNTRYINDEXBASEYEAR1966 = "COUNTRY_INDEX_BASE_YEAR_1966",
  COUNTRYINDEXBASEYEAR1977 = "COUNTRY_INDEX_BASE_YEAR_1977",
  COUNTRYINDEXBASEYEAR1982 = "COUNTRY_INDEX_BASE_YEAR_1982",
  COUNTRYINDEXBASEYEAR1993 = "COUNTRY_INDEX_BASE_YEAR_1993",
  COUNTRYINDEXBASEYEAR2000 = "COUNTRY_INDEX_BASE_YEAR_2000",
  COUNTRYINDEXBASEYEAR2005 = "COUNTRY_INDEX_BASE_YEAR_2005",
  COUNTRYINDEXBASEYEAR2010 = "COUNTRY_INDEX_BASE_YEAR_2010",
  COUNTRYINDEXBASEYEAR2015 = "COUNTRY_INDEX_BASE_YEAR_2015",
  COUNTRYINDEXBASEYEAR2020 = "COUNTRY_INDEX_BASE_YEAR_2020",
  COUNTRYINDEXBASEYEAR2025 = "COUNTRY_INDEX_BASE_YEAR_2025",
}

export type CountryIndexServiceGetInflationData = CountryIndexGetInflationResponse;

export type CountryIndexServiceGetInflationError = GooglerpcStatus;

/** @default "COUNTRY_INDEX_BASE_YEAR_1914" */
export enum CountryIndexServiceGetInflationParams1BaseYearEnum {
  COUNTRYINDEXBASEYEAR1914 = "COUNTRY_INDEX_BASE_YEAR_1914",
  COUNTRYINDEXBASEYEAR1939 = "COUNTRY_INDEX_BASE_YEAR_1939",
  COUNTRYINDEXBASEYEAR1966 = "COUNTRY_INDEX_BASE_YEAR_1966",
  COUNTRYINDEXBASEYEAR1977 = "COUNTRY_INDEX_BASE_YEAR_1977",
  COUNTRYINDEXBASEYEAR1982 = "COUNTRY_INDEX_BASE_YEAR_1982",
  COUNTRYINDEXBASEYEAR1993 = "COUNTRY_INDEX_BASE_YEAR_1993",
  COUNTRYINDEXBASEYEAR2000 = "COUNTRY_INDEX_BASE_YEAR_2000",
  COUNTRYINDEXBASEYEAR2005 = "COUNTRY_INDEX_BASE_YEAR_2005",
  COUNTRYINDEXBASEYEAR2010 = "COUNTRY_INDEX_BASE_YEAR_2010",
  COUNTRYINDEXBASEYEAR2015 = "COUNTRY_INDEX_BASE_YEAR_2015",
  COUNTRYINDEXBASEYEAR2020 = "COUNTRY_INDEX_BASE_YEAR_2020",
  COUNTRYINDEXBASEYEAR2025 = "COUNTRY_INDEX_BASE_YEAR_2025",
}

export type CountryIndexServiceReadData = CountryIndexReadResponse;

export type CountryIndexServiceReadError = GooglerpcStatus;

export type ObjectServiceCreateData = ObjectobjectCreateResponse;

export type ObjectServiceCreateError = GooglerpcStatus;

export type ObjectServiceCreateBulkData = ObjectobjectCreateBulkResponse;

export type ObjectServiceCreateBulkError = GooglerpcStatus;

export type DemoDataServiceGenerateData = ObjectdemoDataGenerateResponse;

export type DemoDataServiceGenerateError = GooglerpcStatus;

export type DeviceServiceCreateData = ObjectdeviceCreateResponse;

export type DeviceServiceCreateError = GooglerpcStatus;

export interface DeviceServiceGetDefaultDataParams {
  /**
   * Optional. If not provided the whole list for all device types will be returned.
   *
   *  - DEVICE_TYPE_CHROME_STEEP_FINISH: Not used
   * @default "DEVICE_TYPE_UNDEFINED"
   */
  type?: TypeEnum;
}

/**
 * Optional. If not provided the whole list for all device types will be returned.
 *
 *  - DEVICE_TYPE_CHROME_STEEP_FINISH: Not used
 * @default "DEVICE_TYPE_UNDEFINED"
 */
export enum TypeEnum {
  DEVICE_TYPE_UNDEFINED = "DEVICE_TYPE_UNDEFINED",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES = "DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES",
  DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER = "DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER",
  DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN = "DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN",
  DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR = "DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE = "DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE",
  DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE = "DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE",
  DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR = "DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION = "DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL",
  DEVICE_TYPE_ROOFING_PENT_ROOF = "DEVICE_TYPE_ROOFING_PENT_ROOF",
  DEVICE_TYPE_ROOFING_SADDLE_ROOF = "DEVICE_TYPE_ROOFING_SADDLE_ROOF",
  DEVICE_TYPE_ROOFING_TERRACE = "DEVICE_TYPE_ROOFING_TERRACE",
  DEVICE_TYPE_ROOFING_HIPPED_ROOF = "DEVICE_TYPE_ROOFING_HIPPED_ROOF",
  DEVICE_TYPE_ROOFING_TENT_ROOF = "DEVICE_TYPE_ROOFING_TENT_ROOF",
  DEVICE_TYPE_ROOFING_FLAT_ROOF = "DEVICE_TYPE_ROOFING_FLAT_ROOF",
  DEVICE_TYPE_ROOFING_SHEARING_ROOF = "DEVICE_TYPE_ROOFING_SHEARING_ROOF",
  DEVICE_TYPE_ROOFING_FRONT_PANEL = "DEVICE_TYPE_ROOFING_FRONT_PANEL",
  DEVICE_TYPE_SEALING_INSULATION_FACADE = "DEVICE_TYPE_SEALING_INSULATION_FACADE",
  DEVICE_TYPE_SEALING_INSULATION_INTERIOR = "DEVICE_TYPE_SEALING_INSULATION_INTERIOR",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD = "DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES = "DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT = "DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT",
  DEVICE_TYPE_FACADE_PLASTER_PAINTING = "DEVICE_TYPE_FACADE_PLASTER_PAINTING",
  DEVICE_TYPE_FACADE_PLASTER = "DEVICE_TYPE_FACADE_PLASTER",
  DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT",
  DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL",
  DEVICE_TYPE_OUTER_FINISHES = "DEVICE_TYPE_OUTER_FINISHES",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING",
  DEVICETYPEHEAVYCURRENTINSTALLATIONCO2 = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CO2",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION",
  DEVICE_TYPE_LIGHTS_ILLUMINANT = "DEVICE_TYPE_LIGHTS_ILLUMINANT",
  DEVICE_TYPE_LIGHTS = "DEVICE_TYPE_LIGHTS",
  DEVICE_TYPE_LIGHTS_CEILING = "DEVICE_TYPE_LIGHTS_CEILING",
  DEVICE_TYPE_LIGHTS_CABINET = "DEVICE_TYPE_LIGHTS_CABINET",
  DEVICE_TYPE_LIGHTS_SPOTS = "DEVICE_TYPE_LIGHTS_SPOTS",
  DEVICE_TYPE_LIGHTS_MIRROR_CABINET = "DEVICE_TYPE_LIGHTS_MIRROR_CABINET",
  DEVICE_TYPE_TELEPHONE_CENTER = "DEVICE_TYPE_TELEPHONE_CENTER",
  DEVICE_TYPE_TELEPHONE_DISTRIBUTOR = "DEVICE_TYPE_TELEPHONE_DISTRIBUTOR",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE",
  DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY = "DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY",
  DEVICE_TYPE_OTHER_ELECTRICITY_OTHER = "DEVICE_TYPE_OTHER_ELECTRICITY_OTHER",
  DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION = "DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION",
  DEVICE_TYPE_OTHER_ELECTRICITY = "DEVICE_TYPE_OTHER_ELECTRICITY",
  DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET = "DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET",
  DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX = "DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION",
  DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY = "DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY",
  DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING = "DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING",
  DEVICE_TYPE_ENERGY_SUPPLY_TANK = "DEVICE_TYPE_ENERGY_SUPPLY_TANK",
  DEVICE_TYPE_ENERGY_SUPPLY_STORAGE = "DEVICE_TYPE_ENERGY_SUPPLY_STORAGE",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED",
  DEVICE_TYPE_HEAT_GENERATION = "DEVICE_TYPE_HEAT_GENERATION",
  DEVICE_TYPE_HEAT_GENERATION_BOILER = "DEVICE_TYPE_HEAT_GENERATION_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BURNER = "DEVICE_TYPE_HEAT_GENERATION_BURNER",
  DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE = "DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE = "DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER = "DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM = "DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER = "DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP = "DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP",
  DEVICE_TYPE_HEAT_GENERATION_FIREPLACE = "DEVICE_TYPE_HEAT_GENERATION_FIREPLACE",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR = "DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR",
  DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER = "DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING = "DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES = "DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES",
  DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER = "DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS = "DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS",
  DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT = "DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING = "DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING",
  DEVICE_TYPE_HEAT_DISTRIBUTION = "DEVICE_TYPE_HEAT_DISTRIBUTION",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER",
  DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP = "DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR",
  DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING",
  DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER = "DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER",
  DEVICE_TYPE_VENTILATION_VENTILATION = "DEVICE_TYPE_VENTILATION_VENTILATION",
  DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN = "DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN",
  DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN = "DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN",
  DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM = "DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM",
  DEVICE_TYPE_VENTILATION = "DEVICE_TYPE_VENTILATION",
  DEVICE_TYPE_VENTILATION_CONTROLLED_HOME = "DEVICE_TYPE_VENTILATION_CONTROLLED_HOME",
  DEVICE_TYPE_VENTILATION_CHANNELS = "DEVICE_TYPE_VENTILATION_CHANNELS",
  DEVICE_TYPE_AIR_CONDITIONING_RECOOLING = "DEVICE_TYPE_AIR_CONDITIONING_RECOOLING",
  DEVICE_TYPE_AIR_CONDITIONING = "DEVICE_TYPE_AIR_CONDITIONING",
  DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS = "DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS",
  DEVICE_TYPE_COOLING_CHILLERS = "DEVICE_TYPE_COOLING_CHILLERS",
  DEVICE_TYPE_COOLING_COLD_RESERVOIR = "DEVICE_TYPE_COOLING_COLD_RESERVOIR",
  DEVICE_TYPE_COOLING_COLD_WATER_TANK = "DEVICE_TYPE_COOLING_COLD_WATER_TANK",
  DEVICE_TYPE_COOLING_COLD_STORAGE_CELL = "DEVICE_TYPE_COOLING_COLD_STORAGE_CELL",
  DEVICE_TYPE_COOLING = "DEVICE_TYPE_COOLING",
  DEVICE_TYPE_SPECIAL_FACILITY = "DEVICE_TYPE_SPECIAL_FACILITY",
  DEVICE_TYPE_INSULATION = "DEVICE_TYPE_INSULATION",
  DEVICE_TYPE_INSULATION_CHIMNEY = "DEVICE_TYPE_INSULATION_CHIMNEY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES",
  DEVICE_TYPE_SANITARY_BATHTUB = "DEVICE_TYPE_SANITARY_BATHTUB",
  DEVICE_TYPE_SANITARY_RENOVATION = "DEVICE_TYPE_SANITARY_RENOVATION",
  DEVICE_TYPE_SANITARY_CONTROL_FITTINGS = "DEVICE_TYPE_SANITARY_CONTROL_FITTINGS",
  DEVICE_TYPE_SANITARY_WASHBASIN = "DEVICE_TYPE_SANITARY_WASHBASIN",
  DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC = "DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET = "DEVICE_TYPE_SANITARY_MIRROR_CABINET",
  DEVICE_TYPE_SANITARY_BIDET = "DEVICE_TYPE_SANITARY_BIDET",
  DEVICE_TYPE_SANITARY_SHOWER = "DEVICE_TYPE_SANITARY_SHOWER",
  DEVICE_TYPE_SANITARY_LAVABO = "DEVICE_TYPE_SANITARY_LAVABO",
  DEVICE_TYPE_SANITARY_URINAL = "DEVICE_TYPE_SANITARY_URINAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK = "DEVICE_TYPE_SANITARY_FLUSH_TANK",
  DEVICE_TYPE_SANITARY_TOILET = "DEVICE_TYPE_SANITARY_TOILET",
  DEVICE_TYPE_SANITARY_TOILET_CERAMIC = "DEVICE_TYPE_SANITARY_TOILET_CERAMIC",
  DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT = "DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT",
  DEVICE_TYPE_SANITARY_TOILET_COVER = "DEVICE_TYPE_SANITARY_TOILET_COVER",
  DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE = "DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE",
  DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC = "DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC",
  DEVICE_TYPE_SANITARY_BATHTUB_STEEL = "DEVICE_TYPE_SANITARY_BATHTUB_STEEL",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED = "DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER",
  DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION = "DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION",
  DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER = "DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE",
  DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER = "DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER",
  DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER = "DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER",
  DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE = "DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE",
  DEVICE_TYPE_SPECIAL_SANITARY = "DEVICE_TYPE_SPECIAL_SANITARY",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER",
  DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER = "DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER",
  DEVICE_TYPE_SANITARY_PIPING_WARM_WATER = "DEVICE_TYPE_SANITARY_PIPING_WARM_WATER",
  DEVICE_TYPE_SANITARY_PIPING = "DEVICE_TYPE_SANITARY_PIPING",
  DEVICE_TYPE_SANITARY_INSULATION = "DEVICE_TYPE_SANITARY_INSULATION",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE = "DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE",
  DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_EQUIPMENT = "DEVICE_TYPE_SANITARY_EQUIPMENT",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE",
  DEVICE_TYPE_SANITARY_SHOWER_ROD = "DEVICE_TYPE_SANITARY_SHOWER_ROD",
  DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL = "DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER",
  DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD = "DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING = "DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC",
  DEVICE_TYPE_OTHER_SANITARY = "DEVICE_TYPE_OTHER_SANITARY",
  DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT = "DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT",
  DEVICE_TYPE_ELEVATOR_BED_LIFT = "DEVICE_TYPE_ELEVATOR_BED_LIFT",
  DEVICE_TYPE_ELEVATOR = "DEVICE_TYPE_ELEVATOR",
  DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT = "DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT",
  DEVICE_TYPE_MOVING_STAIRCASE = "DEVICE_TYPE_MOVING_STAIRCASE",
  DEVICE_TYPE_FACADE_CLEANING = "DEVICE_TYPE_FACADE_CLEANING",
  DEVICE_TYPE_GOODS_CONVEYING_OTHER = "DEVICE_TYPE_GOODS_CONVEYING_OTHER",
  DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE = "DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE",
  DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT = "DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT",
  DEVICE_TYPE_GOODS_CONVEYING = "DEVICE_TYPE_GOODS_CONVEYING",
  DEVICE_TYPE_LIFTING = "DEVICE_TYPE_LIFTING",
  DEVICE_TYPE_PARKING = "DEVICE_TYPE_PARKING",
  DEVICE_TYPE_TRANSPORT_OTHER = "DEVICE_TYPE_TRANSPORT_OTHER",
  DEVICE_TYPE_PLASTERER = "DEVICE_TYPE_PLASTERER",
  DEVICE_TYPE_METAL = "DEVICE_TYPE_METAL",
  DEVICE_TYPE_METAL_CAR_SHELTER = "DEVICE_TYPE_METAL_CAR_SHELTER",
  DEVICE_TYPE_METAL_MAILBOX = "DEVICE_TYPE_METAL_MAILBOX",
  DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT = "DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT",
  DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER = "DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER",
  DEVICE_TYPE_CARPENTER_CELLAR_DOOR = "DEVICE_TYPE_CARPENTER_CELLAR_DOOR",
  DEVICE_TYPE_CARPENTER_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR = "DEVICE_TYPE_CARPENTER_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME = "DEVICE_TYPE_CARPENTER_DOOR_FRAME",
  DEVICE_TYPE_CARPENTER_LOCKS = "DEVICE_TYPE_CARPENTER_LOCKS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR",
  DEVICE_TYPE_CARPENTER = "DEVICE_TYPE_CARPENTER",
  DEVICE_TYPE_CARPENTER_DOOR_WOODEN = "DEVICE_TYPE_CARPENTER_DOOR_WOODEN",
  DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_CARPENTER_DOOR_METAL = "DEVICE_TYPE_CARPENTER_DOOR_METAL",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL",
  DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT = "DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL",
  DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR = "DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR",
  DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR = "DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR",
  DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR = "DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR",
  DEVICE_TYPE_CARPENTER_SHELF = "DEVICE_TYPE_CARPENTER_SHELF",
  DEVICE_TYPE_CARPENTER_SHELF_WOOD = "DEVICE_TYPE_CARPENTER_SHELF_WOOD",
  DEVICE_TYPE_CARPENTER_SHELF_METAL = "DEVICE_TYPE_CARPENTER_SHELF_METAL",
  DEVICE_TYPE_CARPENTER_CLOSET = "DEVICE_TYPE_CARPENTER_CLOSET",
  DEVICE_TYPE_CARPENTER_CLOSET_WOOD = "DEVICE_TYPE_CARPENTER_CLOSET_WOOD",
  DEVICE_TYPE_CARPENTER_CLOSET_METAL = "DEVICE_TYPE_CARPENTER_CLOSET_METAL",
  DEVICE_TYPE_WINDOW_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_INSULATING_GLAZING = "DEVICE_TYPE_WINDOW_INSULATING_GLAZING",
  DEVICE_TYPE_WINDOW_FITTINGS = "DEVICE_TYPE_WINDOW_FITTINGS",
  DEVICE_TYPE_WINDOW_WINDOW_FRAME = "DEVICE_TYPE_WINDOW_WINDOW_FRAME",
  DEVICE_TYPE_WINDOW_SPECIAL_GLAZING = "DEVICE_TYPE_WINDOW_SPECIAL_GLAZING",
  DEVICE_TYPE_WINDOW_WINDOW_SILL = "DEVICE_TYPE_WINDOW_WINDOW_SILL",
  DEVICE_TYPE_WINDOW = "DEVICE_TYPE_WINDOW",
  DEVICE_TYPE_WINDOW_DOUBLE = "DEVICE_TYPE_WINDOW_DOUBLE",
  DEVICE_TYPE_WINDOW_TRIPLE = "DEVICE_TYPE_WINDOW_TRIPLE",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES = "DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE = "DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE",
  DEVICE_TYPE_LOCKING_LOCK = "DEVICE_TYPE_LOCKING_LOCK",
  DEVICE_TYPE_LOCKING_KEY = "DEVICE_TYPE_LOCKING_KEY",
  DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER = "DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER",
  DEVICE_TYPE_LOCKING = "DEVICE_TYPE_LOCKING",
  DEVICE_TYPE_INTERIOR_FINISHES = "DEVICE_TYPE_INTERIOR_FINISHES",
  DEVICE_TYPE_ELEMENT_WALL = "DEVICE_TYPE_ELEMENT_WALL",
  DEVICE_TYPE_CHROME_STEEP_FINISH = "DEVICE_TYPE_CHROME_STEEP_FINISH",
  DEVICETYPEOTHERINTERIOR1 = "DEVICE_TYPE_OTHER_INTERIOR1",
  DEVICE_TYPE_FLOORING_COVERING = "DEVICE_TYPE_FLOORING_COVERING",
  DEVICE_TYPE_FLOORING_BALL_YARN = "DEVICE_TYPE_FLOORING_BALL_YARN",
  DEVICE_TYPE_FLOORING_LAMINATE = "DEVICE_TYPE_FLOORING_LAMINATE",
  DEVICE_TYPE_FLOORING_LINOLEUM = "DEVICE_TYPE_FLOORING_LINOLEUM",
  DEVICE_TYPE_FLOORING_VINYL = "DEVICE_TYPE_FLOORING_VINYL",
  DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET = "DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET",
  DEVICE_TYPE_FLOORING_PARQUET = "DEVICE_TYPE_FLOORING_PARQUET",
  DEVICE_TYPE_FLOORING_PARQUET_SEALING = "DEVICE_TYPE_FLOORING_PARQUET_SEALING",
  DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY = "DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY",
  DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR = "DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR",
  DEVICE_TYPE_FLOORING_TILES = "DEVICE_TYPE_FLOORING_TILES",
  DEVICE_TYPE_FLOORING_CARPET = "DEVICE_TYPE_FLOORING_CARPET",
  DEVICE_TYPE_FLOORING_SKIRTING = "DEVICE_TYPE_FLOORING_SKIRTING",
  DEVICE_TYPE_FLOORING_JOINT = "DEVICE_TYPE_FLOORING_JOINT",
  DEVICE_TYPE_FLOORING = "DEVICE_TYPE_FLOORING",
  DEVICE_TYPE_FLOORING_PVC = "DEVICE_TYPE_FLOORING_PVC",
  DEVICE_TYPE_FLOORING_RUBBER = "DEVICE_TYPE_FLOORING_RUBBER",
  DEVICE_TYPE_FLOORING_CORK = "DEVICE_TYPE_FLOORING_CORK",
  DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY",
  DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES = "DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD",
  DEVICE_TYPE_FLOORING_TILES_CERAMIC = "DEVICE_TYPE_FLOORING_TILES_CERAMIC",
  DEVICE_TYPE_FLOORING_TILES_STONEWARE = "DEVICE_TYPE_FLOORING_TILES_STONEWARE",
  DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE = "DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE",
  DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE = "DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE",
  DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD = "DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD = "DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_FOURNIER = "DEVICE_TYPE_FLOORING_PARQUET_FOURNIER",
  DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER = "DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER",
  DEVICE_TYPE_FLOORING_CARPET_BALL_YARN = "DEVICE_TYPE_FLOORING_CARPET_BALL_YARN",
  DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT = "DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT",
  DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC = "DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC",
  DEVICE_TYPE_FLOORING_SKIRTING_WOOD = "DEVICE_TYPE_FLOORING_SKIRTING_WOOD",
  DEVICE_TYPE_FLOORING_RAW = "DEVICE_TYPE_FLOORING_RAW",
  DEVICE_TYPE_FLOORING_COATED = "DEVICE_TYPE_FLOORING_COATED",
  DEVICE_TYPE_WALL_COVERING_WORK = "DEVICE_TYPE_WALL_COVERING_WORK",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER",
  DEVICE_TYPE_WALL_COVERING_PLASTER = "DEVICE_TYPE_WALL_COVERING_PLASTER",
  DEVICE_TYPE_WALL_COVERING_ABRASION = "DEVICE_TYPE_WALL_COVERING_ABRASION",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER",
  DEVICE_TYPE_WALL_COVERING = "DEVICE_TYPE_WALL_COVERING",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER",
  DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR = "DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR",
  DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL = "DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL",
  DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS = "DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS",
  DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC = "DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING = "DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING",
  DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT = "DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE",
  DEVICE_TYPE_WALL_COVERING_CERAMIC = "DEVICE_TYPE_WALL_COVERING_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_STONEWORK = "DEVICE_TYPE_WALL_COVERING_STONEWORK",
  DEVICE_TYPE_WALL_COVERING_STONEWARE = "DEVICE_TYPE_WALL_COVERING_STONEWARE",
  DEVICE_TYPE_WALL_COVERING_TILES = "DEVICE_TYPE_WALL_COVERING_TILES",
  DEVICE_TYPE_CEILING_WORK = "DEVICE_TYPE_CEILING_WORK",
  DEVICE_TYPE_CEILING_WALLPAPER = "DEVICE_TYPE_CEILING_WALLPAPER",
  DEVICE_TYPE_CEILING_PLASTER = "DEVICE_TYPE_CEILING_PLASTER",
  DEVICE_TYPE_CEILING_ABRASION = "DEVICE_TYPE_CEILING_ABRASION",
  DEVICE_TYPE_CEILING_WOOD_WORKER = "DEVICE_TYPE_CEILING_WOOD_WORKER",
  DEVICE_TYPE_CEILING = "DEVICE_TYPE_CEILING",
  DEVICE_TYPE_CEILING_REGULAR = "DEVICE_TYPE_CEILING_REGULAR",
  DEVICE_TYPE_CEILING_REGULAR_METAL = "DEVICE_TYPE_CEILING_REGULAR_METAL",
  DEVICE_TYPE_CEILING_REGULAR_WOOD = "DEVICE_TYPE_CEILING_REGULAR_WOOD",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING = "DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING",
  DEVICETYPEOTHERINTERIOR2SHUTTER = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER",
  DEVICETYPEOTHERINTERIOR2SHUTTERMOTOR = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER_MOTOR",
  DEVICETYPEOTHERINTERIOR2BLADE = "DEVICE_TYPE_OTHER_INTERIOR2_BLADE",
  DEVICETYPEOTHERINTERIOR2BLIND = "DEVICE_TYPE_OTHER_INTERIOR2_BLIND",
  DEVICETYPEOTHERINTERIOR2LETTERBOX = "DEVICE_TYPE_OTHER_INTERIOR2_LETTER_BOX",
  DEVICETYPEOTHERINTERIOR2 = "DEVICE_TYPE_OTHER_INTERIOR2",
  DEVICETYPEOTHERINTERIOR2SETS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS",
  DEVICETYPEOTHERINTERIOR2SETSSOAPHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_SOAP_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSTOOTHGLASS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOOTH_GLASS",
  DEVICETYPEOTHERINTERIOR2SETSGLASSSHELF = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_GLASS_SHELF",
  DEVICETYPEOTHERINTERIOR2SETSTOWELBARS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOWEL_BARS",
  DEVICETYPEOTHERINTERIOR2SETSHOLDINGRACK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_HOLDING_RACK",
  DEVICETYPEOTHERINTERIOR2SETSCURTAINROD = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_CURTAIN_ROD",
  DEVICETYPEOTHERINTERIOR2SETSPACKAGE = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PACKAGE",
  DEVICETYPEOTHERINTERIOR2SETSWASHBASINBOWL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_WASHBASIN_BOWL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERHOOK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_HOOK",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2ARMATURE = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE",
  DEVICETYPEOTHERINTERIOR2ARMATURESINGLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SINGLE_LEVER",
  DEVICETYPEOTHERINTERIOR2DOUBLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_DOUBLE_LEVER",
  DEVICETYPEOTHERINTERIOR2ARMATURESWIVEL = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SWIVEL",
  DEVICETYPEOTHERINTERIOR2ARMATUREPULLOUTSPRAY = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_PULL_OUT_SPRAY",
  DEVICETYPEOTHERINTERIOR2ARMATURETHERMALMIXER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_THERMAL_MIXER",
  DEVICETYPEOTHERINTERIOR2OPERATINGGARNITURE = "DEVICE_TYPE_OTHER_INTERIOR2_OPERATING_GARNITURE",
  DEVICETYPEOTHERINTERIOR2CRANK = "DEVICE_TYPE_OTHER_INTERIOR2_CRANK",
  DEVICETYPEOTHERINTERIOR2BELT = "DEVICE_TYPE_OTHER_INTERIOR2_BELT",
  DEVICETYPEOTHERINTERIOR2ELECTRIC = "DEVICE_TYPE_OTHER_INTERIOR2_ELECTRIC",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_FENCE = "DEVICE_TYPE_GARDENING_FENCE",
  DEVICE_TYPE_GARDENING_WALLS = "DEVICE_TYPE_GARDENING_WALLS",
  DEVICE_TYPE_GARDENING_CEMENT_BOARD = "DEVICE_TYPE_GARDENING_CEMENT_BOARD",
  DEVICE_TYPE_GARDENING_ACCESS_PATH = "DEVICE_TYPE_GARDENING_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_LAWN = "DEVICE_TYPE_GARDENING_LAWN",
  DEVICE_TYPE_GARDENING = "DEVICE_TYPE_GARDENING",
  DEVICE_TYPE_FENCING = "DEVICE_TYPE_FENCING",
  DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE = "DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE",
  DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND = "DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND",
  DEVICE_TYPE_SUPERSTRUCTURE = "DEVICE_TYPE_SUPERSTRUCTURE",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE",
  DEVICE_TYPE_PLAYGROUND = "DEVICE_TYPE_PLAYGROUND",
  DEVICE_TYPE_PLAYGROUND_DEVICE = "DEVICE_TYPE_PLAYGROUND_DEVICE",
  DEVICE_TYPE_GARDEN_OTHER = "DEVICE_TYPE_GARDEN_OTHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER",
  DEVICE_TYPE_AIR_COMPRESSOR = "DEVICE_TYPE_AIR_COMPRESSOR",
  DEVICE_TYPE_GAS_SYSTEM_LABORATORY = "DEVICE_TYPE_GAS_SYSTEM_LABORATORY",
  DEVICE_TYPE_HOIST_CRANE = "DEVICE_TYPE_HOIST_CRANE",
  DEVICE_TYPE_HEATING_DISTRIBUTOR = "DEVICE_TYPE_HEATING_DISTRIBUTOR",
  DEVICE_TYPE_INTERIOR_METAL_DOORS = "DEVICE_TYPE_INTERIOR_METAL_DOORS",
  DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING = "DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING",
  DEVICE_TYPE_REFRIGERATING_MACHINE = "DEVICE_TYPE_REFRIGERATING_MACHINE",
  DEVICE_TYPE_REFRIGERATED_CEILING = "DEVICE_TYPE_REFRIGERATED_CEILING",
  DEVICE_TYPE_COOLING_DISTRIBUTOR = "DEVICE_TYPE_COOLING_DISTRIBUTOR",
  DEVICE_TYPE_VENTILATION_MONOBLOCK = "DEVICE_TYPE_VENTILATION_MONOBLOCK",
  DEVICE_TYPE_NEUTRALIZATION_SYSTEM = "DEVICE_TYPE_NEUTRALIZATION_SYSTEM",
  DEVICE_TYPE_PURE_WATER_SYSTEM = "DEVICE_TYPE_PURE_WATER_SYSTEM",
  DEVICE_TYPE_WATER_SYSTEM_SEPARATOR = "DEVICE_TYPE_WATER_SYSTEM_SEPARATOR",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT = "DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLER = "DEVICE_TYPE_RECIRCULATING_AIR_COOLER",
  DEVICE_TYPE_STAIR = "DEVICE_TYPE_STAIR",
  DEVICE_TYPE_WARDROBE = "DEVICE_TYPE_WARDROBE",
  DEVICE_TYPE_COAT_HOOKS = "DEVICE_TYPE_COAT_HOOKS",
  DEVICE_TYPE_GATE = "DEVICE_TYPE_GATE",
  DEVICE_TYPE_CURTAIN_RAIL = "DEVICE_TYPE_CURTAIN_RAIL",
  DEVICE_TYPE_FURNITURE_BEDROOM_BED = "DEVICE_TYPE_FURNITURE_BEDROOM_BED",
  DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE = "DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE",
  DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER = "DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER",
  DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE = "DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE",
  DEVICE_TYPE_FURNITURE_OFFICE_DESK = "DEVICE_TYPE_FURNITURE_OFFICE_DESK",
  DEVICE_TYPE_FURNITURE_OFFICE_CHAIR = "DEVICE_TYPE_FURNITURE_OFFICE_CHAIR",
  DEVICE_TYPE_FURNITURE_OFFICE_STOOL = "DEVICE_TYPE_FURNITURE_OFFICE_STOOL",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR",
  DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS = "DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL",
  DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN = "DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN",
  DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS = "DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS",
  DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE = "DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE",
  DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR = "DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR",
  DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES = "DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES",
  DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT",
  DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE = "DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE",
  DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA = "DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA",
  DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED = "DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED",
  DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET = "DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET",
  DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE = "DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER",
  DEVICE_TYPE_LOCKING_CARD_READER = "DEVICE_TYPE_LOCKING_CARD_READER",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER",
  DEVICE_TYPE_COOLING_ENERGY_METER = "DEVICE_TYPE_COOLING_ENERGY_METER",
  DEVICETYPEOTHERINTERIOR1COINCOUNTER = "DEVICE_TYPE_OTHER_INTERIOR1_COIN_COUNTER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING = "DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING",
  DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM = "DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER",
  DEVICE_TYPE_CIRCULATION_PUMP = "DEVICE_TYPE_CIRCULATION_PUMP",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM",
  DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED = "DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN",
  DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE = "DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE",
  DEVICE_TYPE_CARPENTER_FOLDING_LADDER = "DEVICE_TYPE_CARPENTER_FOLDING_LADDER",
  DEVICE_TYPE_SANITARY_CLOTHESLINE = "DEVICE_TYPE_SANITARY_CLOTHESLINE",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER",
  DEVICE_TYPE_LOCKING_KEY_SAFE = "DEVICE_TYPE_LOCKING_KEY_SAFE",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR",
  DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING = "DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE",
  DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING = "DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING",
}

export type DeviceServiceGetDefaultDataData = DeviceGetDefaultDataResponse;

export type DeviceServiceGetDefaultDataError = GooglerpcStatus;

/**
 * Optional. If not provided the whole list for all device types will be returned.
 *
 *  - DEVICE_TYPE_CHROME_STEEP_FINISH: Not used
 * @default "DEVICE_TYPE_UNDEFINED"
 */
export enum DeviceServiceGetDefaultDataParams1TypeEnum {
  DEVICE_TYPE_UNDEFINED = "DEVICE_TYPE_UNDEFINED",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES = "DEVICE_TYPE_MASTER_BUILDER_WORK_DOWN_PIPES",
  DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_BASIC_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE = "DEVICE_TYPE_MASTER_BUILDER_WORK_DRAINAGE_LINE",
  DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER = "DEVICE_TYPE_MASTER_BUILDER_WORK_PUMP_CHAMBER",
  DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN = "DEVICE_TYPE_MASTER_BUILDER_WORK_TERRACE_DRAIN",
  DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR = "DEVICE_TYPE_WINDOW_DOOR_AUTOMATIC_SLIDING_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE = "DEVICE_TYPE_WINDOW_DOOR_FIRE_GATE",
  DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_ROOF_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW = "DEVICE_TYPE_WINDOW_DOOR_WINDOW",
  DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE = "DEVICE_TYPE_WINDOW_DOOR_GATE_DRIVE",
  DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR = "DEVICE_TYPE_WINDOW_DOOR_GARAGE_DOOR",
  DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION = "DEVICE_TYPE_WINDOW_DOOR_DOOR_AUTOMATION",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_SOLID_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL = "DEVICE_TYPE_WINDOW_DOOR_EXTERIOR_DOOR_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_PLASTIC",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_WOOD_METAL",
  DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL = "DEVICE_TYPE_WINDOW_DOOR_WINDOW_METAL",
  DEVICE_TYPE_ROOFING_PENT_ROOF = "DEVICE_TYPE_ROOFING_PENT_ROOF",
  DEVICE_TYPE_ROOFING_SADDLE_ROOF = "DEVICE_TYPE_ROOFING_SADDLE_ROOF",
  DEVICE_TYPE_ROOFING_TERRACE = "DEVICE_TYPE_ROOFING_TERRACE",
  DEVICE_TYPE_ROOFING_HIPPED_ROOF = "DEVICE_TYPE_ROOFING_HIPPED_ROOF",
  DEVICE_TYPE_ROOFING_TENT_ROOF = "DEVICE_TYPE_ROOFING_TENT_ROOF",
  DEVICE_TYPE_ROOFING_FLAT_ROOF = "DEVICE_TYPE_ROOFING_FLAT_ROOF",
  DEVICE_TYPE_ROOFING_SHEARING_ROOF = "DEVICE_TYPE_ROOFING_SHEARING_ROOF",
  DEVICE_TYPE_ROOFING_FRONT_PANEL = "DEVICE_TYPE_ROOFING_FRONT_PANEL",
  DEVICE_TYPE_SEALING_INSULATION_FACADE = "DEVICE_TYPE_SEALING_INSULATION_FACADE",
  DEVICE_TYPE_SEALING_INSULATION_INTERIOR = "DEVICE_TYPE_SEALING_INSULATION_INTERIOR",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD = "DEVICE_TYPE_SEALING_INSULATION_FACADE_WOOD",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES = "DEVICE_TYPE_SEALING_INSULATION_FACADE_PLATES",
  DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT = "DEVICE_TYPE_SEALING_INSULATION_FACADE_ETERNIT",
  DEVICE_TYPE_FACADE_PLASTER_PAINTING = "DEVICE_TYPE_FACADE_PLASTER_PAINTING",
  DEVICE_TYPE_FACADE_PLASTER = "DEVICE_TYPE_FACADE_PLASTER",
  DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_FOLDING_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS",
  DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT = "DEVICE_TYPE_OUTER_FINISHES_SUN_BLINDS_VOLANT",
  DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_GLARE_PROTECTION",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL = "DEVICE_TYPE_OUTER_FINISHES_SHUTTERS_METAL",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_OUTSIDE_ALUMINIUM",
  DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE = "DEVICE_TYPE_OUTER_FINISHES_SLAT_TOWERS_INSIDE",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL = "DEVICE_TYPE_OUTER_FINISHES_BLIND_SHOPS_METAL",
  DEVICE_TYPE_OUTER_FINISHES = "DEVICE_TYPE_OUTER_FINISHES",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_GLASS",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_WOOD",
  DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL = "DEVICE_TYPE_OUTER_FINISHES_PRIVACY_SCREEN_METAL",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LIGHTING",
  DEVICETYPEHEAVYCURRENTINSTALLATIONCO2 = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CO2",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SMOKE_VENT",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PROOF_OF_SAFETY_SINA",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHGEAR_COMBINATION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_PHOTOVOLTAIC",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_LOW_VOLTAGE_SYSTEM",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_UPS",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_INFRASTRUCTURE_ELECTRIC_CHARGING",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_ELECTRIC_CHARGING_STATION",
  DEVICE_TYPE_LIGHTS_ILLUMINANT = "DEVICE_TYPE_LIGHTS_ILLUMINANT",
  DEVICE_TYPE_LIGHTS = "DEVICE_TYPE_LIGHTS",
  DEVICE_TYPE_LIGHTS_CEILING = "DEVICE_TYPE_LIGHTS_CEILING",
  DEVICE_TYPE_LIGHTS_CABINET = "DEVICE_TYPE_LIGHTS_CABINET",
  DEVICE_TYPE_LIGHTS_SPOTS = "DEVICE_TYPE_LIGHTS_SPOTS",
  DEVICE_TYPE_LIGHTS_MIRROR_CABINET = "DEVICE_TYPE_LIGHTS_MIRROR_CABINET",
  DEVICE_TYPE_TELEPHONE_CENTER = "DEVICE_TYPE_TELEPHONE_CENTER",
  DEVICE_TYPE_TELEPHONE_DISTRIBUTOR = "DEVICE_TYPE_TELEPHONE_DISTRIBUTOR",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERCOM_VIDEO",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_BELL",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_DOOR_OPENER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_FIBERGLASS",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_PHONE_LIFT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTERPHONE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MULTIMEDIA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_INTRUSION_DETECTION",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ISDN",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CABLE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCH",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SWITCHBOARD",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_SOCKET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_ANTENNA",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_TV_CABLE",
  DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY = "DEVICE_TYPE_OTHER_ELECTRICITY_BATTERY",
  DEVICE_TYPE_OTHER_ELECTRICITY_OTHER = "DEVICE_TYPE_OTHER_ELECTRICITY_OTHER",
  DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION = "DEVICE_TYPE_OTHER_ELECTRICITY_LIGHTNING_PROTECTION",
  DEVICE_TYPE_OTHER_ELECTRICITY = "DEVICE_TYPE_OTHER_ELECTRICITY",
  DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET = "DEVICE_TYPE_OTHER_ELECTRICITY_SOCKET",
  DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX = "DEVICE_TYPE_OTHER_ELECTRICITY_FUSEBOX",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_ROOF_VENTILATION",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_FILTER_REPLACEMENT",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_AIR_CONDITIONING",
  DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION = "DEVICE_TYPE_HEATING_TRANSITION_POSITION_VENTILATION",
  DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY = "DEVICE_TYPE_ENERGY_SUPPLY_SUPPLY",
  DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING = "DEVICE_TYPE_ENERGY_SUPPLY_LEAKAGE_WARNING",
  DEVICE_TYPE_ENERGY_SUPPLY_TANK = "DEVICE_TYPE_ENERGY_SUPPLY_TANK",
  DEVICE_TYPE_ENERGY_SUPPLY_STORAGE = "DEVICE_TYPE_ENERGY_SUPPLY_STORAGE",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_LINE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_INSIDE",
  DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED = "DEVICE_TYPE_ENERGY_SUPPLY_FUEL_TANK_EARTH_LOADED",
  DEVICE_TYPE_HEAT_GENERATION = "DEVICE_TYPE_HEAT_GENERATION",
  DEVICE_TYPE_HEAT_GENERATION_BOILER = "DEVICE_TYPE_HEAT_GENERATION_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BURNER = "DEVICE_TYPE_HEAT_GENERATION_BURNER",
  DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE = "DEVICE_TYPE_HEAT_GENERATION_EARTH_PROBE",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STORAGE_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE = "DEVICE_TYPE_HEAT_GENERATION_EXPANSION_DEVICE",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION = "DEVICE_TYPE_HEAT_GENERATION_DISTRICT_HEATING_SUBSTATION",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER = "DEVICE_TYPE_HEAT_GENERATION_HEATING_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM = "DEVICE_TYPE_HEAT_GENERATION_THERMAL_SOLAR_SYSTEM",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER = "DEVICE_TYPE_HEAT_GENERATION_HEAT_EXCHANGER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP = "DEVICE_TYPE_HEAT_GENERATION_HEAT_PUMP",
  DEVICE_TYPE_HEAT_GENERATION_FIREPLACE = "DEVICE_TYPE_HEAT_GENERATION_FIREPLACE",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR = "DEVICE_TYPE_HEAT_GENERATION_HEAT_ACCUMULATOR",
  DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER = "DEVICE_TYPE_HEAT_GENERATION_SINGLE_WATER_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING = "DEVICE_TYPE_HEAT_GENERATION_COMBIBOILER_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES = "DEVICE_TYPE_HEAT_GENERATION_BOILER_GAS_APPLIANCES",
  DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER = "DEVICE_TYPE_HEAT_GENERATION_COMBINED_BOILER",
  DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS = "DEVICE_TYPE_HEAT_GENERATION_SOLAR_PANELS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS = "DEVICE_TYPE_HEAT_GENERATION_RADIATORS_HEATWALLS",
  DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS = "DEVICE_TYPE_HEAT_GENERATION_TOWEL_RADIATORS",
  DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_GENERATION_FLOOR_HEATING",
  DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT = "DEVICE_TYPE_HEAT_GENERATION_HEATING_ELEMENT",
  DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE = "DEVICE_TYPE_HEAT_GENERATION_ELECTRIC_STOVE",
  DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING = "DEVICE_TYPE_HEAT_GENERATION_ROOF_HEATING",
  DEVICE_TYPE_HEAT_DISTRIBUTION = "DEVICE_TYPE_HEAT_DISTRIBUTION",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_METER",
  DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP = "DEVICE_TYPE_HEAT_DISTRIBUTION_CIRCULATING_PUMP",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEAT_QUANTITY_FLOW_METERS",
  DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR = "DEVICE_TYPE_HEAT_DISTRIBUTION_HEATING_COST_ALLOCATOR",
  DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING = "DEVICE_TYPE_HEAT_DISTRIBUTION_FLOOR_HEATING",
  DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER = "DEVICE_TYPE_VENTILATION_VENTILATION_CONTROL_CENTER",
  DEVICE_TYPE_VENTILATION_VENTILATION = "DEVICE_TYPE_VENTILATION_VENTILATION",
  DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN = "DEVICE_TYPE_VENTILATION_SUPPLY_AIR_FAN",
  DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN = "DEVICE_TYPE_VENTILATION_EXHAUST_AIR_FAN",
  DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM = "DEVICE_TYPE_VENTILATION_SMOKE_EXTRACTION_SYSTEM",
  DEVICE_TYPE_VENTILATION = "DEVICE_TYPE_VENTILATION",
  DEVICE_TYPE_VENTILATION_CONTROLLED_HOME = "DEVICE_TYPE_VENTILATION_CONTROLLED_HOME",
  DEVICE_TYPE_VENTILATION_CHANNELS = "DEVICE_TYPE_VENTILATION_CHANNELS",
  DEVICE_TYPE_AIR_CONDITIONING_RECOOLING = "DEVICE_TYPE_AIR_CONDITIONING_RECOOLING",
  DEVICE_TYPE_AIR_CONDITIONING = "DEVICE_TYPE_AIR_CONDITIONING",
  DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS = "DEVICE_TYPE_AIR_CONDITIONING_INDIVIDUAL_ROOMS",
  DEVICE_TYPE_COOLING_CHILLERS = "DEVICE_TYPE_COOLING_CHILLERS",
  DEVICE_TYPE_COOLING_COLD_RESERVOIR = "DEVICE_TYPE_COOLING_COLD_RESERVOIR",
  DEVICE_TYPE_COOLING_COLD_WATER_TANK = "DEVICE_TYPE_COOLING_COLD_WATER_TANK",
  DEVICE_TYPE_COOLING_COLD_STORAGE_CELL = "DEVICE_TYPE_COOLING_COLD_STORAGE_CELL",
  DEVICE_TYPE_COOLING = "DEVICE_TYPE_COOLING",
  DEVICE_TYPE_SPECIAL_FACILITY = "DEVICE_TYPE_SPECIAL_FACILITY",
  DEVICE_TYPE_INSULATION = "DEVICE_TYPE_INSULATION",
  DEVICE_TYPE_INSULATION_CHIMNEY = "DEVICE_TYPE_INSULATION_CHIMNEY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_BUILDING_MANAGEMENT_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_CONTROL_SYSTEM",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY",
  DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES = "DEVICE_TYPE_SPECIAL_FACILITY_MEASUREMENT_CONTROL_TECHNOLOGY_VALVES",
  DEVICE_TYPE_SANITARY_BATHTUB = "DEVICE_TYPE_SANITARY_BATHTUB",
  DEVICE_TYPE_SANITARY_RENOVATION = "DEVICE_TYPE_SANITARY_RENOVATION",
  DEVICE_TYPE_SANITARY_CONTROL_FITTINGS = "DEVICE_TYPE_SANITARY_CONTROL_FITTINGS",
  DEVICE_TYPE_SANITARY_WASHBASIN = "DEVICE_TYPE_SANITARY_WASHBASIN",
  DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC = "DEVICE_TYPE_SANITARY_WASHBASIN_CERAMIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET = "DEVICE_TYPE_SANITARY_MIRROR_CABINET",
  DEVICE_TYPE_SANITARY_BIDET = "DEVICE_TYPE_SANITARY_BIDET",
  DEVICE_TYPE_SANITARY_SHOWER = "DEVICE_TYPE_SANITARY_SHOWER",
  DEVICE_TYPE_SANITARY_LAVABO = "DEVICE_TYPE_SANITARY_LAVABO",
  DEVICE_TYPE_SANITARY_URINAL = "DEVICE_TYPE_SANITARY_URINAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK = "DEVICE_TYPE_SANITARY_FLUSH_TANK",
  DEVICE_TYPE_SANITARY_TOILET = "DEVICE_TYPE_SANITARY_TOILET",
  DEVICE_TYPE_SANITARY_TOILET_CERAMIC = "DEVICE_TYPE_SANITARY_TOILET_CERAMIC",
  DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT = "DEVICE_TYPE_SANITARY_TOILET_CLOSOMAT",
  DEVICE_TYPE_SANITARY_TOILET_COVER = "DEVICE_TYPE_SANITARY_TOILET_COVER",
  DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE = "DEVICE_TYPE_SANITARY_TOILET_COVER_SOFT_CLOSE",
  DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC = "DEVICE_TYPE_SANITARY_BATHTUB_ACRYLIC",
  DEVICE_TYPE_SANITARY_BATHTUB_STEEL = "DEVICE_TYPE_SANITARY_BATHTUB_STEEL",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_PLASTIC",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_WOODEN",
  DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL = "DEVICE_TYPE_SANITARY_MIRROR_CABINET_METAL",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED = "DEVICE_TYPE_SANITARY_FLUSH_TANK_FLUSH_MOUNTED",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_PLASTIC",
  DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC = "DEVICE_TYPE_SANITARY_FLUSH_TANK_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CERAMIC",
  DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT = "DEVICE_TYPE_SANITARY_LAVABO_TOILET_BIDET_URINAL_CLOSOMAT",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_PLASTIC",
  DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS = "DEVICE_TYPE_SANITARY_SHOWER_CABIN_GLASWALLS",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_SOFTENER",
  DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION = "DEVICE_TYPE_SPECIAL_SANITARY_LIMESCALE_PROTECTION",
  DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER = "DEVICE_TYPE_SPECIAL_SANITARY_DEHUMIDIFIER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_MACHINE",
  DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER = "DEVICE_TYPE_SPECIAL_SANITARY_COMBI_WASHER_DRYER",
  DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER = "DEVICE_TYPE_SPECIAL_SANITARY_WASHING_ELECTRICITY_METER",
  DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER = "DEVICE_TYPE_SPECIAL_SANITARY_TUMBLER",
  DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE = "DEVICE_TYPE_SPECIAL_SANITARY_VACUUM_DEGASSING_DEVICE",
  DEVICE_TYPE_SPECIAL_SANITARY = "DEVICE_TYPE_SPECIAL_SANITARY",
  DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP = "DEVICE_TYPE_SPECIAL_SANITARY_WATER_TAP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SUPPLY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_DISPOSAL",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_TREATMENT",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_PUMP",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_DISTRIBUTION_BATTERY",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_SEWAGE_TANK",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_PIPING_COLD_WATER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_FINE_FILTER",
  DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER = "DEVICE_TYPE_SANITARY_PIPING_RAIN_WATER",
  DEVICE_TYPE_SANITARY_PIPING_WARM_WATER = "DEVICE_TYPE_SANITARY_PIPING_WARM_WATER",
  DEVICE_TYPE_SANITARY_PIPING = "DEVICE_TYPE_SANITARY_PIPING",
  DEVICE_TYPE_SANITARY_INSULATION = "DEVICE_TYPE_SANITARY_INSULATION",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_ONE_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR_CABINETS_TWO_DOOR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR = "DEVICE_TYPE_SANITARY_EQUIPMENT_MIRROR",
  DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE = "DEVICE_TYPE_SANITARY_EQUIPMENT_BATHROOM_FURNITURE",
  DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN = "DEVICE_TYPE_SANITARY_EQUIPMENT_SHOWER_CABIN",
  DEVICE_TYPE_SANITARY_EQUIPMENT = "DEVICE_TYPE_SANITARY_EQUIPMENT",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOSE",
  DEVICE_TYPE_SANITARY_SHOWER_ROD = "DEVICE_TYPE_SANITARY_SHOWER_ROD",
  DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL = "DEVICE_TYPE_SANITARY_SHOWER_ROD_CHROME_STEEL",
  DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER = "DEVICE_TYPE_SANITARY_SHOWER_HEAD_HOLDER",
  DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD = "DEVICE_TYPE_ELECTRIC_PNEUMATIC_BOARD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_COMPARTMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_SEPARATING_SYSTEM",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WASTE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_BLECH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRID",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_THERMOMETER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_OVEN_ACCESSORIES_GRILL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAM_EXHAUST_HOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STEAMER_ACCESSORIES",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DISH_WASHER_CUTLERY_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GLASS_CERAMIC_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_HOT_PLATES_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB = "DEVICE_TYPE_KITCHEN_EQUIPMENT_GAS_HOB",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MINOR_KITCHEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_MICROWAVE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_STOVE_WITH_OVEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_CARBON_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ALUMINIUM_FILTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRYER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COMBINATION_FURNITURE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING = "DEVICE_TYPE_KITCHEN_EQUIPMENT_SEALING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_VENTILATION_GRILLE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT = "DEVICE_TYPE_KITCHEN_EQUIPMENT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GRANITE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_GLASS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_SYNTHETIC_RESIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_WOODEN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_TOP_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_HIGH_GLOSS",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD = "DEVICE_TYPE_KITCHEN_EQUIPMENT_UNDER_CABINET_WOOD",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_CUTLERY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_BOTTLE_HOLDER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT = "DEVICE_TYPE_KITCHEN_EQUIPMENT_DRAWER_WITH_SLIPS_MAT",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_CHROME_STEEL",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FLUSHING_BASIN_PLASTIC",
  DEVICE_TYPE_OTHER_SANITARY = "DEVICE_TYPE_OTHER_SANITARY",
  DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT = "DEVICE_TYPE_ELEVATOR_HANDICAP_LIFT",
  DEVICE_TYPE_ELEVATOR_BED_LIFT = "DEVICE_TYPE_ELEVATOR_BED_LIFT",
  DEVICE_TYPE_ELEVATOR = "DEVICE_TYPE_ELEVATOR",
  DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT = "DEVICE_TYPE_ELEVATOR_MERCHANDISE_LIFT",
  DEVICE_TYPE_MOVING_STAIRCASE = "DEVICE_TYPE_MOVING_STAIRCASE",
  DEVICE_TYPE_FACADE_CLEANING = "DEVICE_TYPE_FACADE_CLEANING",
  DEVICE_TYPE_GOODS_CONVEYING_OTHER = "DEVICE_TYPE_GOODS_CONVEYING_OTHER",
  DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE = "DEVICE_TYPE_GOODS_CONVEYING_PNEUMATIC_TUBE",
  DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT = "DEVICE_TYPE_GOODS_CONVEYING_FILE_LIFT",
  DEVICE_TYPE_GOODS_CONVEYING = "DEVICE_TYPE_GOODS_CONVEYING",
  DEVICE_TYPE_LIFTING = "DEVICE_TYPE_LIFTING",
  DEVICE_TYPE_PARKING = "DEVICE_TYPE_PARKING",
  DEVICE_TYPE_TRANSPORT_OTHER = "DEVICE_TYPE_TRANSPORT_OTHER",
  DEVICE_TYPE_PLASTERER = "DEVICE_TYPE_PLASTERER",
  DEVICE_TYPE_METAL = "DEVICE_TYPE_METAL",
  DEVICE_TYPE_METAL_CAR_SHELTER = "DEVICE_TYPE_METAL_CAR_SHELTER",
  DEVICE_TYPE_METAL_MAILBOX = "DEVICE_TYPE_METAL_MAILBOX",
  DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT = "DEVICE_TYPE_METAL_BALCONY_ENLARGEMENT",
  DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER = "DEVICE_TYPE_CARPENTER_SCREED_EXTENSION_LADDER",
  DEVICE_TYPE_CARPENTER_CELLAR_DOOR = "DEVICE_TYPE_CARPENTER_CELLAR_DOOR",
  DEVICE_TYPE_CARPENTER_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR = "DEVICE_TYPE_CARPENTER_DOOR",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME = "DEVICE_TYPE_CARPENTER_DOOR_FRAME",
  DEVICE_TYPE_CARPENTER_LOCKS = "DEVICE_TYPE_CARPENTER_LOCKS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR",
  DEVICE_TYPE_CARPENTER = "DEVICE_TYPE_CARPENTER",
  DEVICE_TYPE_CARPENTER_DOOR_WOODEN = "DEVICE_TYPE_CARPENTER_DOOR_WOODEN",
  DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL = "DEVICE_TYPE_CARPENTER_DOOR_WOOD_MATERIAL",
  DEVICE_TYPE_CARPENTER_DOOR_METAL = "DEVICE_TYPE_CARPENTER_DOOR_METAL",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_WOOD",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL_STONE",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_METAL",
  DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_APARTMENT_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR = "DEVICE_TYPE_CARPENTER_LOCKS_ROOM_DOOR",
  DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT = "DEVICE_TYPE_CARPENTER_LOCKS_KITT_JOINT",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_CHANNELBOARDS",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_WOODEN",
  DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS = "DEVICE_TYPE_CARPENTER_BUILT_IN_CLOSETS_HIGH_GLOSS",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_WOODEN_MATERIAL",
  DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS = "DEVICE_TYPE_CARPENTER_SLIDING_DOOR_ROLLS",
  DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL = "DEVICE_TYPE_CARPENTER_DOOR_FRAME_COLOR_OIL",
  DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR = "DEVICE_TYPE_CARPENTER_GLASS_INSERT_DOOR",
  DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR = "DEVICE_TYPE_CARPENTER_FITTINGS_FOR_DOOR",
  DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR = "DEVICE_TYPE_CARPENTER_RUBBER_SEALS_DOOR",
  DEVICE_TYPE_CARPENTER_SHELF = "DEVICE_TYPE_CARPENTER_SHELF",
  DEVICE_TYPE_CARPENTER_SHELF_WOOD = "DEVICE_TYPE_CARPENTER_SHELF_WOOD",
  DEVICE_TYPE_CARPENTER_SHELF_METAL = "DEVICE_TYPE_CARPENTER_SHELF_METAL",
  DEVICE_TYPE_CARPENTER_CLOSET = "DEVICE_TYPE_CARPENTER_CLOSET",
  DEVICE_TYPE_CARPENTER_CLOSET_WOOD = "DEVICE_TYPE_CARPENTER_CLOSET_WOOD",
  DEVICE_TYPE_CARPENTER_CLOSET_METAL = "DEVICE_TYPE_CARPENTER_CLOSET_METAL",
  DEVICE_TYPE_WINDOW_DOUBLE_GLAZING = "DEVICE_TYPE_WINDOW_DOUBLE_GLAZING",
  DEVICE_TYPE_WINDOW_INSULATING_GLAZING = "DEVICE_TYPE_WINDOW_INSULATING_GLAZING",
  DEVICE_TYPE_WINDOW_FITTINGS = "DEVICE_TYPE_WINDOW_FITTINGS",
  DEVICE_TYPE_WINDOW_WINDOW_FRAME = "DEVICE_TYPE_WINDOW_WINDOW_FRAME",
  DEVICE_TYPE_WINDOW_SPECIAL_GLAZING = "DEVICE_TYPE_WINDOW_SPECIAL_GLAZING",
  DEVICE_TYPE_WINDOW_WINDOW_SILL = "DEVICE_TYPE_WINDOW_WINDOW_SILL",
  DEVICE_TYPE_WINDOW = "DEVICE_TYPE_WINDOW",
  DEVICE_TYPE_WINDOW_DOUBLE = "DEVICE_TYPE_WINDOW_DOUBLE",
  DEVICE_TYPE_WINDOW_TRIPLE = "DEVICE_TYPE_WINDOW_TRIPLE",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED = "DEVICE_TYPE_WINDOW_WINDOW_SILL_WOOD_PAINTED",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES = "DEVICE_TYPE_WINDOW_WINDOW_SILL_TILES",
  DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE = "DEVICE_TYPE_WINDOW_WINDOW_SILL_STONE",
  DEVICE_TYPE_LOCKING_LOCK = "DEVICE_TYPE_LOCKING_LOCK",
  DEVICE_TYPE_LOCKING_KEY = "DEVICE_TYPE_LOCKING_KEY",
  DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER = "DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER",
  DEVICE_TYPE_LOCKING = "DEVICE_TYPE_LOCKING",
  DEVICE_TYPE_INTERIOR_FINISHES = "DEVICE_TYPE_INTERIOR_FINISHES",
  DEVICE_TYPE_ELEMENT_WALL = "DEVICE_TYPE_ELEMENT_WALL",
  DEVICE_TYPE_CHROME_STEEP_FINISH = "DEVICE_TYPE_CHROME_STEEP_FINISH",
  DEVICETYPEOTHERINTERIOR1 = "DEVICE_TYPE_OTHER_INTERIOR1",
  DEVICE_TYPE_FLOORING_COVERING = "DEVICE_TYPE_FLOORING_COVERING",
  DEVICE_TYPE_FLOORING_BALL_YARN = "DEVICE_TYPE_FLOORING_BALL_YARN",
  DEVICE_TYPE_FLOORING_LAMINATE = "DEVICE_TYPE_FLOORING_LAMINATE",
  DEVICE_TYPE_FLOORING_LINOLEUM = "DEVICE_TYPE_FLOORING_LINOLEUM",
  DEVICE_TYPE_FLOORING_VINYL = "DEVICE_TYPE_FLOORING_VINYL",
  DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET = "DEVICE_TYPE_FLOORING_DIRT_TRAP_CARPET",
  DEVICE_TYPE_FLOORING_PARQUET = "DEVICE_TYPE_FLOORING_PARQUET",
  DEVICE_TYPE_FLOORING_PARQUET_SEALING = "DEVICE_TYPE_FLOORING_PARQUET_SEALING",
  DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY = "DEVICE_TYPE_FLOORING_FLOOR_UNDERLAY",
  DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR = "DEVICE_TYPE_FLOORING_INSTALLATION_FLOOR",
  DEVICE_TYPE_FLOORING_TILES = "DEVICE_TYPE_FLOORING_TILES",
  DEVICE_TYPE_FLOORING_CARPET = "DEVICE_TYPE_FLOORING_CARPET",
  DEVICE_TYPE_FLOORING_SKIRTING = "DEVICE_TYPE_FLOORING_SKIRTING",
  DEVICE_TYPE_FLOORING_JOINT = "DEVICE_TYPE_FLOORING_JOINT",
  DEVICE_TYPE_FLOORING = "DEVICE_TYPE_FLOORING",
  DEVICE_TYPE_FLOORING_PVC = "DEVICE_TYPE_FLOORING_PVC",
  DEVICE_TYPE_FLOORING_RUBBER = "DEVICE_TYPE_FLOORING_RUBBER",
  DEVICE_TYPE_FLOORING_CORK = "DEVICE_TYPE_FLOORING_CORK",
  DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY = "DEVICE_TYPE_FLOORING_LAMINATE_HIGH_QUALITY",
  DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES = "DEVICE_TYPE_FLOORING_TILES_SOUND_PLATES",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_SOFT",
  DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD = "DEVICE_TYPE_FLOORING_TILES_NATURAL_STONE_HARD",
  DEVICE_TYPE_FLOORING_TILES_CERAMIC = "DEVICE_TYPE_FLOORING_TILES_CERAMIC",
  DEVICE_TYPE_FLOORING_TILES_STONEWARE = "DEVICE_TYPE_FLOORING_TILES_STONEWARE",
  DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE = "DEVICE_TYPE_FLOORING_TILES_ARTIFICIAL_STONE",
  DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE = "DEVICE_TYPE_FLOORING_PARQUET_ADHESIVE",
  DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD = "DEVICE_TYPE_FLOORING_PARQUET_HARDWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD = "DEVICE_TYPE_FLOORING_PARQUET_SOFTWOOD",
  DEVICE_TYPE_FLOORING_PARQUET_FOURNIER = "DEVICE_TYPE_FLOORING_PARQUET_FOURNIER",
  DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER = "DEVICE_TYPE_FLOORING_CARPET_NATURAL_FIBER",
  DEVICE_TYPE_FLOORING_CARPET_BALL_YARN = "DEVICE_TYPE_FLOORING_CARPET_BALL_YARN",
  DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT = "DEVICE_TYPE_FLOORING_CARPET_NEEDLE_FELT",
  DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY = "DEVICE_TYPE_FLOORING_CARPET_MEDIUM_QUALITY",
  DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC = "DEVICE_TYPE_FLOORING_SKIRTING_PLASTIC",
  DEVICE_TYPE_FLOORING_SKIRTING_WOOD = "DEVICE_TYPE_FLOORING_SKIRTING_WOOD",
  DEVICE_TYPE_FLOORING_RAW = "DEVICE_TYPE_FLOORING_RAW",
  DEVICE_TYPE_FLOORING_COATED = "DEVICE_TYPE_FLOORING_COATED",
  DEVICE_TYPE_WALL_COVERING_WORK = "DEVICE_TYPE_WALL_COVERING_WORK",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER",
  DEVICE_TYPE_WALL_COVERING_PLASTER = "DEVICE_TYPE_WALL_COVERING_PLASTER",
  DEVICE_TYPE_WALL_COVERING_ABRASION = "DEVICE_TYPE_WALL_COVERING_ABRASION",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER",
  DEVICE_TYPE_WALL_COVERING = "DEVICE_TYPE_WALL_COVERING",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_MEDIUM_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GOOD_QUALITY",
  DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER = "DEVICE_TYPE_WALL_COVERING_WALLPAPER_GLASS_FIBER",
  DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR = "DEVICE_TYPE_WALL_COVERING_PLASTER_GLUE_COLOR",
  DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL = "DEVICE_TYPE_WALL_COVERING_PLASTER_ACRYL",
  DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS = "DEVICE_TYPE_WALL_COVERING_PLASTER_MINERALS",
  DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC = "DEVICE_TYPE_WALL_COVERING_PLASTER_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING = "DEVICE_TYPE_WALL_COVERING_PLASTER_SILICATE_COATING",
  DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT = "DEVICE_TYPE_WALL_COVERING_PLASTER_DISPERSION_PAINT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_WALL_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_WALL_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_WALL_ROUGH",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_LASED",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_PAINTED_OPAQUE",
  DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE = "DEVICE_TYPE_WALL_COVERING_WOOD_WORKER_GLAZE",
  DEVICE_TYPE_WALL_COVERING_CERAMIC = "DEVICE_TYPE_WALL_COVERING_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_STONEWORK = "DEVICE_TYPE_WALL_COVERING_STONEWORK",
  DEVICE_TYPE_WALL_COVERING_STONEWARE = "DEVICE_TYPE_WALL_COVERING_STONEWARE",
  DEVICE_TYPE_WALL_COVERING_TILES = "DEVICE_TYPE_WALL_COVERING_TILES",
  DEVICE_TYPE_CEILING_WORK = "DEVICE_TYPE_CEILING_WORK",
  DEVICE_TYPE_CEILING_WALLPAPER = "DEVICE_TYPE_CEILING_WALLPAPER",
  DEVICE_TYPE_CEILING_PLASTER = "DEVICE_TYPE_CEILING_PLASTER",
  DEVICE_TYPE_CEILING_ABRASION = "DEVICE_TYPE_CEILING_ABRASION",
  DEVICE_TYPE_CEILING_WOOD_WORKER = "DEVICE_TYPE_CEILING_WOOD_WORKER",
  DEVICE_TYPE_CEILING = "DEVICE_TYPE_CEILING",
  DEVICE_TYPE_CEILING_REGULAR = "DEVICE_TYPE_CEILING_REGULAR",
  DEVICE_TYPE_CEILING_REGULAR_METAL = "DEVICE_TYPE_CEILING_REGULAR_METAL",
  DEVICE_TYPE_CEILING_REGULAR_WOOD = "DEVICE_TYPE_CEILING_REGULAR_WOOD",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC = "DEVICE_TYPE_CEILING_COVERING_ABRASION_PLASTIC",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT = "DEVICE_TYPE_CEILING_COVERING_ABRASION_ROUGH_PUTT",
  DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER = "DEVICE_TYPE_CEILING_COVERING_ABRASION_WHITE_PLASTER",
  DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING = "DEVICE_TYPE_INTERIOR_SURFACE_TREATMENTS_PAINTING",
  DEVICETYPEOTHERINTERIOR2SHUTTER = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER",
  DEVICETYPEOTHERINTERIOR2SHUTTERMOTOR = "DEVICE_TYPE_OTHER_INTERIOR2_SHUTTER_MOTOR",
  DEVICETYPEOTHERINTERIOR2BLADE = "DEVICE_TYPE_OTHER_INTERIOR2_BLADE",
  DEVICETYPEOTHERINTERIOR2BLIND = "DEVICE_TYPE_OTHER_INTERIOR2_BLIND",
  DEVICETYPEOTHERINTERIOR2LETTERBOX = "DEVICE_TYPE_OTHER_INTERIOR2_LETTER_BOX",
  DEVICETYPEOTHERINTERIOR2 = "DEVICE_TYPE_OTHER_INTERIOR2",
  DEVICETYPEOTHERINTERIOR2SETS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS",
  DEVICETYPEOTHERINTERIOR2SETSSOAPHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_SOAP_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSTOOTHGLASS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOOTH_GLASS",
  DEVICETYPEOTHERINTERIOR2SETSGLASSSHELF = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_GLASS_SHELF",
  DEVICETYPEOTHERINTERIOR2SETSTOWELBARS = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_TOWEL_BARS",
  DEVICETYPEOTHERINTERIOR2SETSHOLDINGRACK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_HOLDING_RACK",
  DEVICETYPEOTHERINTERIOR2SETSCURTAINROD = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_CURTAIN_ROD",
  DEVICETYPEOTHERINTERIOR2SETSPACKAGE = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PACKAGE",
  DEVICETYPEOTHERINTERIOR2SETSWASHBASINBOWL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_WASHBASIN_BOWL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2SETSBATHTOWELHOLDERHOOK = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_BATH_TOWEL_HOLDER_HOOK",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDER = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERCHROMESTEEL = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_CHROME_STEEL",
  DEVICETYPEOTHERINTERIOR2SETSPAPERHOLDERPLASTIC = "DEVICE_TYPE_OTHER_INTERIOR2_SETS_PAPER_HOLDER_PLASTIC",
  DEVICETYPEOTHERINTERIOR2ARMATURE = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE",
  DEVICETYPEOTHERINTERIOR2ARMATURESINGLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SINGLE_LEVER",
  DEVICETYPEOTHERINTERIOR2DOUBLELEVER = "DEVICE_TYPE_OTHER_INTERIOR2_DOUBLE_LEVER",
  DEVICETYPEOTHERINTERIOR2ARMATURESWIVEL = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_SWIVEL",
  DEVICETYPEOTHERINTERIOR2ARMATUREPULLOUTSPRAY = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_PULL_OUT_SPRAY",
  DEVICETYPEOTHERINTERIOR2ARMATURETHERMALMIXER = "DEVICE_TYPE_OTHER_INTERIOR2_ARMATURE_THERMAL_MIXER",
  DEVICETYPEOTHERINTERIOR2OPERATINGGARNITURE = "DEVICE_TYPE_OTHER_INTERIOR2_OPERATING_GARNITURE",
  DEVICETYPEOTHERINTERIOR2CRANK = "DEVICE_TYPE_OTHER_INTERIOR2_CRANK",
  DEVICETYPEOTHERINTERIOR2BELT = "DEVICE_TYPE_OTHER_INTERIOR2_BELT",
  DEVICETYPEOTHERINTERIOR2ELECTRIC = "DEVICE_TYPE_OTHER_INTERIOR2_ELECTRIC",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_GREEN",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_PLASTIC_BLACK",
  DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL = "DEVICE_TYPE_OTHER_TRANSPORT_CONTAINER_METAL",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_OUTDOOR_PARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_PLANTING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_GROUND_MARKING",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_CONTAINER_SITE",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_BIKE_SHELTER",
  DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH = "DEVICE_TYPE_GARDENING_TRANSITION_POSITION_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_FENCE = "DEVICE_TYPE_GARDENING_FENCE",
  DEVICE_TYPE_GARDENING_WALLS = "DEVICE_TYPE_GARDENING_WALLS",
  DEVICE_TYPE_GARDENING_CEMENT_BOARD = "DEVICE_TYPE_GARDENING_CEMENT_BOARD",
  DEVICE_TYPE_GARDENING_ACCESS_PATH = "DEVICE_TYPE_GARDENING_ACCESS_PATH",
  DEVICE_TYPE_GARDENING_LAWN = "DEVICE_TYPE_GARDENING_LAWN",
  DEVICE_TYPE_GARDENING = "DEVICE_TYPE_GARDENING",
  DEVICE_TYPE_FENCING = "DEVICE_TYPE_FENCING",
  DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE = "DEVICE_TYPE_SUPERSTRUCTURE_TERRANCE",
  DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND = "DEVICE_TYPE_SUPERSTRUCTURE_BIKE_STAND",
  DEVICE_TYPE_SUPERSTRUCTURE = "DEVICE_TYPE_SUPERSTRUCTURE",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_SAFETY_GLASS",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_METAL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CHROME_STEEL",
  DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE = "DEVICE_TYPE_SUPERSTRUCTURE_RAILING_CONCRETE",
  DEVICE_TYPE_PLAYGROUND = "DEVICE_TYPE_PLAYGROUND",
  DEVICE_TYPE_PLAYGROUND_DEVICE = "DEVICE_TYPE_PLAYGROUND_DEVICE",
  DEVICE_TYPE_GARDEN_OTHER = "DEVICE_TYPE_GARDEN_OTHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_FIRE_EXTINGUISHER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_LAWN_MOWER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_SECURITY_CAMERA",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_INDOOR_BIKE_SHELTER",
  DEVICE_TYPE_AIR_COMPRESSOR = "DEVICE_TYPE_AIR_COMPRESSOR",
  DEVICE_TYPE_GAS_SYSTEM_LABORATORY = "DEVICE_TYPE_GAS_SYSTEM_LABORATORY",
  DEVICE_TYPE_HOIST_CRANE = "DEVICE_TYPE_HOIST_CRANE",
  DEVICE_TYPE_HEATING_DISTRIBUTOR = "DEVICE_TYPE_HEATING_DISTRIBUTOR",
  DEVICE_TYPE_INTERIOR_METAL_DOORS = "DEVICE_TYPE_INTERIOR_METAL_DOORS",
  DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING = "DEVICE_TYPE_INTERIOR_METAL_BALCONY_GLAZING",
  DEVICE_TYPE_REFRIGERATING_MACHINE = "DEVICE_TYPE_REFRIGERATING_MACHINE",
  DEVICE_TYPE_REFRIGERATED_CEILING = "DEVICE_TYPE_REFRIGERATED_CEILING",
  DEVICE_TYPE_COOLING_DISTRIBUTOR = "DEVICE_TYPE_COOLING_DISTRIBUTOR",
  DEVICE_TYPE_VENTILATION_MONOBLOCK = "DEVICE_TYPE_VENTILATION_MONOBLOCK",
  DEVICE_TYPE_NEUTRALIZATION_SYSTEM = "DEVICE_TYPE_NEUTRALIZATION_SYSTEM",
  DEVICE_TYPE_PURE_WATER_SYSTEM = "DEVICE_TYPE_PURE_WATER_SYSTEM",
  DEVICE_TYPE_WATER_SYSTEM_SEPARATOR = "DEVICE_TYPE_WATER_SYSTEM_SEPARATOR",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT = "DEVICE_TYPE_RECIRCULATING_AIR_COOLING_UNIT",
  DEVICE_TYPE_RECIRCULATING_AIR_COOLER = "DEVICE_TYPE_RECIRCULATING_AIR_COOLER",
  DEVICE_TYPE_STAIR = "DEVICE_TYPE_STAIR",
  DEVICE_TYPE_WARDROBE = "DEVICE_TYPE_WARDROBE",
  DEVICE_TYPE_COAT_HOOKS = "DEVICE_TYPE_COAT_HOOKS",
  DEVICE_TYPE_GATE = "DEVICE_TYPE_GATE",
  DEVICE_TYPE_CURTAIN_RAIL = "DEVICE_TYPE_CURTAIN_RAIL",
  DEVICE_TYPE_FURNITURE_BEDROOM_BED = "DEVICE_TYPE_FURNITURE_BEDROOM_BED",
  DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE = "DEVICE_TYPE_FURNITURE_BEDROOM_BEDSIDE_TABLE",
  DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER = "DEVICE_TYPE_FURNITURE_BEDROOM_DRESSER",
  DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE = "DEVICE_TYPE_FURNITURE_BEDROOM_WARDROBE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_TABLE",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_DINING_TABLE",
  DEVICE_TYPE_FURNITURE_OFFICE_DESK = "DEVICE_TYPE_FURNITURE_OFFICE_DESK",
  DEVICE_TYPE_FURNITURE_OFFICE_CHAIR = "DEVICE_TYPE_FURNITURE_OFFICE_CHAIR",
  DEVICE_TYPE_FURNITURE_OFFICE_STOOL = "DEVICE_TYPE_FURNITURE_OFFICE_STOOL",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_CHAIR",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_ARMCHAIR",
  DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS = "DEVICE_TYPE_FURNITURE_BEDROOM_MATTRESS",
  DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA = "DEVICE_TYPE_FURNITURE_LIVING_ROOM_SOFA",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_TELEVISION",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_REMOTE_CONTROL",
  DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN = "DEVICE_TYPE_TEXTILES_BEDROOM_BED_LINEN",
  DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS = "DEVICE_TYPE_TEXTILES_BATHROOM_TOWELS",
  DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE = "DEVICE_TYPE_DECORATION_WALL_DECORATION_PICTURE",
  DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR = "DEVICE_TYPE_DECORATION_BATHROOM_WALL_MIRROR",
  DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_BATHROOM_LAUNDRY_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET = "DEVICE_TYPE_HOUSEHOLD_GOODS_OFFICE_WASTE_PAPER_BASKET",
  DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES = "DEVICE_TYPE_HOUSEHOLD_GOODS_KITCHEN_DISHES",
  DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION = "DEVICE_TYPE_OUTER_FINISHES_HAIL_PROTECTION",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_FIRE_ALARM_SYSTEM",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_EMERGENCY_LIGHT",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ALARM_NET",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ZEV_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_ELECTRICITY_METER",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_CONTROL_UNIT",
  DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE = "DEVICE_TYPE_CARPENTER_HALLWAY_WARDROBE",
  DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA = "DEVICE_TYPE_SUPERSTRUCTURE_OUTDOOR_SEATING_AREA",
  DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED = "DEVICE_TYPE_MEDICAL_DEVICES_DEFIBRILLATOR_AED",
  DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET = "DEVICE_TYPE_ELECTRONICS_DESIGN_TABLET",
  DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE = "DEVICE_TYPE_LABELS_MARKINGS_SIGNAGE",
  DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER = "DEVICE_TYPE_LOW_CURRENT_INSTALLATION_MODEM_ROUTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_REFRIGERATOR_ACCESSORIES_EGG_CONTAINER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY = "DEVICE_TYPE_KITCHEN_EQUIPMENT_FREEZER_ACCESSORIES_ICE_CUBE_TRAY",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COMBI_STEAMER",
  DEVICE_TYPE_LOCKING_CARD_READER = "DEVICE_TYPE_LOCKING_CARD_READER",
  DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER = "DEVICE_TYPE_ENERGY_SUPPLY_GAS_METER",
  DEVICE_TYPE_COOLING_ENERGY_METER = "DEVICE_TYPE_COOLING_ENERGY_METER",
  DEVICETYPEOTHERINTERIOR1COINCOUNTER = "DEVICE_TYPE_OTHER_INTERIOR1_COIN_COUNTER",
  DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING = "DEVICE_TYPE_HEAT_GENERATION_HEAT_TRACING",
  DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM = "DEVICE_TYPE_OTHER_SANITARY_SPRINKLER_SYSTEM",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_FILTER",
  DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER = "DEVICE_TYPE_SANITARY_SUPPLY_DISPOSAL_WATER_METER",
  DEVICE_TYPE_CIRCULATION_PUMP = "DEVICE_TYPE_CIRCULATION_PUMP",
  DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM = "DEVICE_TYPE_HEAVY_CURRENT_INSTALLATION_GAS_DETECTION_SYSTEM",
  DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED = "DEVICE_TYPE_FLOORING_SUBFLOOR_SCREED",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC = "DEVICE_TYPE_KITCHEN_EQUIPMENT_KITCHEN_COVER_CERAMIC",
  DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER = "DEVICE_TYPE_WALL_COVERING_WHITE_PLASTER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INSECT_SCREEN",
  DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE = "DEVICE_TYPE_GARDEN_OTHER_GARDEN_HOSE",
  DEVICE_TYPE_CARPENTER_FOLDING_LADDER = "DEVICE_TYPE_CARPENTER_FOLDING_LADDER",
  DEVICE_TYPE_SANITARY_CLOTHESLINE = "DEVICE_TYPE_SANITARY_CLOTHESLINE",
  DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS = "DEVICE_TYPE_ELECTRONICS_ENTERTAINMENT_USER_MANUALS",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_HEDGE_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_GRASS_TRIMMER",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_VACUUM_CLEANER",
  DEVICE_TYPE_LOCKING_KEY_SAFE = "DEVICE_TYPE_LOCKING_KEY_SAFE",
  DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING = "DEVICE_TYPE_DEVICE_TRANSITION_POSITION_EXHAUST_EMISSIONS_MONITORING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR = "DEVICE_TYPE_KITCHEN_EQUIPMENT_INDUCTION_HOB_WITH_EXTRACTOR",
  DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING = "DEVICE_TYPE_OUTER_FINISHES_VERTICAL_AWNING",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BACKSPLASH",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COFFEE_MACHINE",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_BLAST_CHILLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET = "DEVICE_TYPE_KITCHEN_EQUIPMENT_COLD_BUFFET",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER = "DEVICE_TYPE_KITCHEN_EQUIPMENT_WINE_COOLER",
  DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE = "DEVICE_TYPE_KITCHEN_EQUIPMENT_ICE_CUBE_MACHINE",
  DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING = "DEVICE_TYPE_WALL_COVERING_FIRE_RESISTANT_COATING",
}

export type DeviceServiceListByIdsData = ObjectdeviceListByIdsResponse;

export type DeviceServiceListByIdsError = GooglerpcStatus;

export type DeviceServiceListByReferenceIdsData = ObjectdeviceListByReferenceIdsResponse;

export type DeviceServiceListByReferenceIdsError = GooglerpcStatus;

export type DeviceServiceDeleteData = ObjectdeviceDeleteResponse;

export type DeviceServiceDeleteError = GooglerpcStatus;

export interface DeviceServiceAddDocumentsParams {
  documentIds?: string[];
  id: string;
}

export type DeviceServiceAddDocumentsData = ObjectdeviceAddDocumentsResponse;

export type DeviceServiceAddDocumentsError = GooglerpcStatus;

export interface DeviceServiceUpdatePayload {
  /** @format float */
  acquisitionCosts?: number;
  /** @format int32 */
  amount?: number;
  assetNumberFm?: string;
  /** Construction costs plan for heating (German: Baukostenplan Heizung) */
  bkpH?: string;
  brand?: string;
  /** @format float */
  cataloguePrice?: number;
  condition?: DeviceDeviceCondition;
  conditionNote?: string;
  documentIds?: string[];
  facilityPlant?: DeviceDeviceFacilityPlant;
  images?: ObjectdeviceImage[];
  inspection?: DeviceInspection;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  installation?: TypeDate;
  /** @format int32 */
  lifeSpan?: number;
  lockingKey?: DeviceLockingKey;
  maintenance?: DeviceMaintenance;
  manufacturer?: string;
  measure?: DeviceDeviceMeasure;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  measureUntil?: TypeDate;
  model?: string;
  note?: string;
  /** @format int32 */
  order?: number;
  referenceId?: string;
  revision?: DeviceRevision;
  roomId?: string;
  serialNumber?: string;
  system?: DeviceDeviceSystem;
  type?: DeviceDeviceType;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  uninstallation?: TypeDate;
  unit?: ObjectdeviceDeviceUnit;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  warrantyEnd?: TypeDate;
}

export type DeviceServiceUpdateData = ObjectdeviceUpdateResponse;

export type DeviceServiceUpdateError = GooglerpcStatus;

export type EnergySourceServiceCreateData = ObjectenergySourceCreateResponse;

export type EnergySourceServiceCreateError = GooglerpcStatus;

export type EnergySourceServiceListByIdsData = ObjectenergySourceListByIdsResponse;

export type EnergySourceServiceListByIdsError = GooglerpcStatus;

export type EnergySourceServiceListByReferenceIdsData = ObjectenergySourceListByReferenceIdsResponse;

export type EnergySourceServiceListByReferenceIdsError = GooglerpcStatus;

export type EnergySourceServiceDeleteData = ObjectenergySourceDeleteResponse;

export type EnergySourceServiceDeleteError = GooglerpcStatus;

export interface EnergySourceServiceUpdatePayload {
  /** @format float */
  co2PerYear?: number;
  /** @format float */
  consumption?: number;
  /** @format float */
  consumptionKwhPerYear?: number;
  costDistribution?: EnergySourceCostDistribution;
  costDistribution2?: EnergySourceCostDistribution;
  documentIds?: string[];
  /** @format float */
  energyReferenceArea?: number;
  heatDistribution?: EnergySourceHeatDistribution;
  kind?: EnergySourceEnergySourceKind;
  orders?: EnergySourceOrder[];
  photovoltaic?: boolean;
  selfConsumptionCommunity?: boolean;
  tankReadings?: ObjectenergySourceTankReading[];
  /** @format float */
  tankSize?: number;
  type?: ObjectenergySourceEnergySourceType;
  unit?: ObjectenergySourceEnergySourceUnit;
}

export type EnergySourceServiceUpdateData = ObjectenergySourceUpdateResponse;

export type EnergySourceServiceUpdateError = GooglerpcStatus;

export type FahrlaenderServiceLoadConfigurationData = FahrlaenderLoadConfigurationResponse;

export type FahrlaenderServiceLoadConfigurationError = GooglerpcStatus;

export interface FahrlaenderServiceSaveConfigurationPayload {
  apiPassword?: string;
  apiUser?: string;
  features?: FahrlaenderFahrlaenderFeatures[];
}

export type FahrlaenderServiceSaveConfigurationData = FahrlaenderSaveConfigurationResponse;

export type FahrlaenderServiceSaveConfigurationError = GooglerpcStatus;

export type FahrlaenderServiceUpdateMarketRentData = FahrlaenderUpdateMarketRentResponse;

export type FahrlaenderServiceUpdateMarketRentError = GooglerpcStatus;

export type FahrlaenderServiceUpdateMicroLocationRatingsData = FahrlaenderUpdateMicroLocationRatingsResponse;

export type FahrlaenderServiceUpdateMicroLocationRatingsError = GooglerpcStatus;

export type ObjectServiceGetData = ObjectobjectGetResponse;

export type ObjectServiceGetError = GooglerpcStatus;

export type ObjectServiceGetAccountingStatisticsData = ObjectGetAccountingStatisticsResponse;

export type ObjectServiceGetAccountingStatisticsError = GooglerpcStatus;

export type ObjectServiceGetAdministrationStatisticsData = ObjectGetAdministrationStatisticsResponse;

export type ObjectServiceGetAdministrationStatisticsError = GooglerpcStatus;

export type ObjectServiceGetAssetStatisticsData = ObjectGetAssetStatisticsResponse;

export type ObjectServiceGetAssetStatisticsError = GooglerpcStatus;

export type ObjectServiceGetByPublicIdData = ObjectobjectGetByPublicIdResponse;

export type ObjectServiceGetByPublicIdError = GooglerpcStatus;

export type ObjectServiceGetMarketingData = ObjectGetMarketingResponse;

export type ObjectServiceGetMarketingError = GooglerpcStatus;

export interface ObjectServiceGetMarketingStatisticsParams {
  /** The contactId which should be used for employee based statistics */
  contactIdAssigneeMarketing?: string;
  /**
   * The ID of the account whose marketing statistics are to be calculated (objects he got with share-scope=MARKETING)
   * @format int64
   */
  accountId: string;
}

export type ObjectServiceGetMarketingStatisticsData = ObjectobjectGetMarketingStatisticsResponse;

export type ObjectServiceGetMarketingStatisticsError = GooglerpcStatus;

export type ObjectServiceGetObjectTypesData = ObjectGetObjectTypesResponse;

export type ObjectServiceGetObjectTypesError = GooglerpcStatus;

export type ObjectServiceGetOwnerStatisticsData = ObjectGetOwnerStatisticsResponse;

export type ObjectServiceGetOwnerStatisticsError = GooglerpcStatus;

export type ObjectServiceGetTotalValueQuotaForBuildingData = ObjectGetTotalValueQuotaForBuildingResponse;

export type ObjectServiceGetTotalValueQuotaForBuildingError = GooglerpcStatus;

export type ObjectServiceGetUsedTagsData = ObjectobjectGetUsedTagsResponse;

export type ObjectServiceGetUsedTagsError = GooglerpcStatus;

export type HandoverProtocolServiceCountMyDraftsData = HandoverProtocolCountMyDraftsResponse;

export type HandoverProtocolServiceCountMyDraftsError = GooglerpcStatus;

export type HandoverProtocolServiceCreateData = ObjecthandoverProtocolCreateResponse;

export type HandoverProtocolServiceCreateError = GooglerpcStatus;

export type HandoverProtocolServiceEnableData = ObjecthandoverProtocolEnableResponse;

export type HandoverProtocolServiceEnableError = GooglerpcStatus;

export type HandoverProtocolServiceHasEnabledData = ObjecthandoverProtocolHasEnabledResponse;

export type HandoverProtocolServiceHasEnabledError = GooglerpcStatus;

export interface HandoverProtocolServiceListAllProtocolsParams {
  /**
   * Optional. If set to 0 then no pagination is enabled.
   * @format int32
   */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** Optional filter. */
  statuses?: StatusesEnum[];
}

export enum StatusesEnum {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export type HandoverProtocolServiceListAllProtocolsData = HandoverProtocolListAllProtocolsResponse;

export type HandoverProtocolServiceListAllProtocolsError = GooglerpcStatus;

export enum HandoverProtocolServiceListAllProtocolsParams1StatusesEnum {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export type HandoverProtocolServiceListByIdsData = ObjecthandoverProtocolListByIdsResponse;

export type HandoverProtocolServiceListByIdsError = GooglerpcStatus;

export type HandoverProtocolServiceListByObjectIdsData = ObjecthandoverProtocolListByObjectIdsResponse;

export type HandoverProtocolServiceListByObjectIdsError = GooglerpcStatus;

export interface HandoverProtocolServiceListMyProtocolsParams {
  /**
   * Optional. If set to 0 then no pagination is enabled.
   * @format int32
   */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** Optional filter. */
  statuses?: StatusesEnum1[];
}

export enum StatusesEnum1 {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export type HandoverProtocolServiceListMyProtocolsData = HandoverProtocolListMyProtocolsResponse;

export type HandoverProtocolServiceListMyProtocolsError = GooglerpcStatus;

export enum HandoverProtocolServiceListMyProtocolsParams1StatusesEnum {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export interface HandoverProtocolServiceListOtherProtocolsParams {
  /**
   * Optional. If set to 0 then no pagination is enabled.
   * @format int32
   */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** Optional filter. */
  statuses?: StatusesEnum2[];
}

export enum StatusesEnum2 {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export type HandoverProtocolServiceListOtherProtocolsData = HandoverProtocolListOtherProtocolsResponse;

export type HandoverProtocolServiceListOtherProtocolsError = GooglerpcStatus;

export enum HandoverProtocolServiceListOtherProtocolsParams1StatusesEnum {
  PROTOCOL_STATUS_UNDEFINED = "PROTOCOL_STATUS_UNDEFINED",
  PROTOCOL_STATUS_DRAFT = "PROTOCOL_STATUS_DRAFT",
  PROTOCOL_STATUS_SENT_TO_APP = "PROTOCOL_STATUS_SENT_TO_APP",
  PROTOCOL_STATUS_FINISHED = "PROTOCOL_STATUS_FINISHED",
}

export type HandoverProtocolServiceCreateTemplateData = ObjecthandoverProtocolCreateTemplateResponse;

export type HandoverProtocolServiceCreateTemplateError = GooglerpcStatus;

export type HandoverProtocolServiceListTemplatesData = ObjecthandoverProtocolListTemplatesResponse;

export type HandoverProtocolServiceListTemplatesError = GooglerpcStatus;

export type HandoverProtocolServiceListTemplatesByPropertyIdData = HandoverProtocolListTemplatesByPropertyIdResponse;

export type HandoverProtocolServiceListTemplatesByPropertyIdError = GooglerpcStatus;

export type HandoverProtocolServiceDeleteTemplatesData = HandoverProtocolDeleteTemplatesResponse;

export type HandoverProtocolServiceDeleteTemplatesError = GooglerpcStatus;

export type HandoverProtocolServiceGetTemplateByIdData = HandoverProtocolGetTemplateByIdResponse;

export type HandoverProtocolServiceGetTemplateByIdError = GooglerpcStatus;

export interface HandoverProtocolServiceSetFavoriteTemplatePayload {
  favorite?: boolean;
}

export type HandoverProtocolServiceSetFavoriteTemplateData = HandoverProtocolSetFavoriteTemplateResponse;

export type HandoverProtocolServiceSetFavoriteTemplateError = GooglerpcStatus;

export interface HandoverProtocolServiceUpdateTemplatePayload {
  devicesWithoutRoomIds?: string[];
  name?: string;
  rooms?: HandoverProtocolTemplateRoom[];
  templateReferences?: HandoverProtocolTemplateReference[];
}

export type HandoverProtocolServiceUpdateTemplateData = ObjecthandoverProtocolUpdateTemplateResponse;

export type HandoverProtocolServiceUpdateTemplateError = GooglerpcStatus;

export type HandoverProtocolServiceDeleteData = ObjecthandoverProtocolDeleteResponse;

export type HandoverProtocolServiceDeleteError = GooglerpcStatus;

export interface HandoverProtocolServiceGetPdfPreviewParams {
  /** @default "PREFERRED_LANGUAGE_UNDEFINED" */
  language?: LanguageEnum;
  id: string;
}

/** @default "PREFERRED_LANGUAGE_UNDEFINED" */
export enum LanguageEnum {
  PREFERRED_LANGUAGE_UNDEFINED = "PREFERRED_LANGUAGE_UNDEFINED",
  PREFERRED_LANGUAGE_GERMAN = "PREFERRED_LANGUAGE_GERMAN",
  PREFERRED_LANGUAGE_ENGLISH = "PREFERRED_LANGUAGE_ENGLISH",
  PREFERRED_LANGUAGE_ITALIAN = "PREFERRED_LANGUAGE_ITALIAN",
  PREFERRED_LANGUAGE_FRENCH = "PREFERRED_LANGUAGE_FRENCH",
}

export type HandoverProtocolServiceGetPdfPreviewData = HandoverProtocolGetPdfPreviewResponse;

export type HandoverProtocolServiceGetPdfPreviewError = GooglerpcStatus;

/** @default "PREFERRED_LANGUAGE_UNDEFINED" */
export enum HandoverProtocolServiceGetPdfPreviewParams1LanguageEnum {
  PREFERRED_LANGUAGE_UNDEFINED = "PREFERRED_LANGUAGE_UNDEFINED",
  PREFERRED_LANGUAGE_GERMAN = "PREFERRED_LANGUAGE_GERMAN",
  PREFERRED_LANGUAGE_ENGLISH = "PREFERRED_LANGUAGE_ENGLISH",
  PREFERRED_LANGUAGE_ITALIAN = "PREFERRED_LANGUAGE_ITALIAN",
  PREFERRED_LANGUAGE_FRENCH = "PREFERRED_LANGUAGE_FRENCH",
}

export interface HandoverProtocolServiceSaveDataPayload {
  devicesWithoutRoom?: HandoverProtocolSaveDataDevice[];
  note?: string;
  participants?: HandoverProtocolSaveDataParticipant[];
  rooms?: HandoverProtocolSaveDataRoom[];
}

export type HandoverProtocolServiceSaveDataData = HandoverProtocolSaveDataResponse;

export type HandoverProtocolServiceSaveDataError = GooglerpcStatus;

export interface HandoverProtocolServiceSignPayload {
  language?: LanguagePreferredLanguage;
  signatures?: ObjecthandoverProtocolSignature[];
}

export type HandoverProtocolServiceSignData = HandoverProtocolSignResponse;

export type HandoverProtocolServiceSignError = GooglerpcStatus;

export interface HandoverProtocolServiceUpdatePayload {
  assigneeContactId?: string;
  devicesWithoutRoom?: ObjecthandoverProtocolDevice[];
  draft?: boolean;
  movingInTenancyReferences?: HandoverProtocolWriteTenancyReference[];
  movingOutTenancyReferences?: HandoverProtocolWriteTenancyReference[];
  note?: string;
  participants?: HandoverProtocolWriteParticipant[];
  rooms?: ObjecthandoverProtocolRoom[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  scheduledDate?: TypeDate;
  /**
   * Represents a time of day. The date and time zone are either not significant
   * or are specified elsewhere. An API may choose to allow leap seconds. Related
   * types are [google.type.Date][google.type.Date] and
   * `google.protobuf.Timestamp`.
   */
  scheduledTime?: TypeTimeOfDay;
  templateId?: string;
}

export type HandoverProtocolServiceUpdateData = ObjecthandoverProtocolUpdateResponse;

export type HandoverProtocolServiceUpdateError = GooglerpcStatus;

export type InsuranceServiceCreateData = ObjectinsuranceCreateResponse;

export type InsuranceServiceCreateError = GooglerpcStatus;

export type InsuranceServiceListByIdsData = ObjectinsuranceListByIdsResponse;

export type InsuranceServiceListByIdsError = GooglerpcStatus;

export type InsuranceServiceListByReferenceIdsData = ObjectinsuranceListByReferenceIdsResponse;

export type InsuranceServiceListByReferenceIdsError = GooglerpcStatus;

export type InsuranceServiceDeleteData = ObjectinsuranceDeleteResponse;

export type InsuranceServiceDeleteError = GooglerpcStatus;

export type InsuranceServiceAddDocumentIdsData = InsuranceAddDocumentIdsResponse;

export type InsuranceServiceAddDocumentIdsError = GooglerpcStatus;

export interface InsuranceServiceUpdatePayload {
  /** @format float */
  amount?: number;
  benefits?: InsuranceInsuranceBenefit[];
  documentIds?: string[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  earliestTerminationDate?: TypeDate;
  editedByAic?: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endDate?: TypeDate;
  /** @format float */
  excess?: number;
  /** @format int32 */
  indexYear?: number;
  insuranceCompany?: string;
  notes?: string;
  policyNumber?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  premiumPaidUntil?: TypeDate;
  /** Some opaque ID where this entity is attached to (e.g. propertyId or buildingId) */
  referenceId?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startDate?: TypeDate;
  type?: InsuranceInsuranceType;
  /** @format float */
  yearlyCosts?: number;
}

export type InsuranceServiceUpdateData = ObjectinsuranceUpdateResponse;

export type InsuranceServiceUpdateError = GooglerpcStatus;

export type InvestPlanServiceCreateBulkData = ObjectinvestPlanCreateBulkResponse;

export type InvestPlanServiceCreateBulkError = GooglerpcStatus;

export type InvestPlanServiceDeleteData = ObjectinvestPlanDeleteResponse;

export type InvestPlanServiceDeleteError = GooglerpcStatus;

export type InvestPlanServiceEnableData = ObjectinvestPlanEnableResponse;

export type InvestPlanServiceEnableError = GooglerpcStatus;

export type InvestPlanServiceHasEnabledData = ObjectinvestPlanHasEnabledResponse;

export type InvestPlanServiceHasEnabledError = GooglerpcStatus;

export type InvestPlanServiceListByReferenceIdsData = ObjectinvestPlanListByReferenceIdsResponse;

export type InvestPlanServiceListByReferenceIdsError = GooglerpcStatus;

export type InvestPlanServiceUpdateBulkData = ObjectinvestPlanUpdateBulkResponse;

export type InvestPlanServiceUpdateBulkError = GooglerpcStatus;

export type ObjectServiceIsActiveData = ObjectIsActiveResponse;

export type ObjectServiceIsActiveError = GooglerpcStatus;

export type ObjectServiceIsOnePublishedData = ObjectIsOnePublishedResponse;

export type ObjectServiceIsOnePublishedError = GooglerpcStatus;

export interface ObjectServiceListParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** DO NOT USE! Deprecated. */
  address?: string;
  /** DO NOT USE! Deprecated. */
  categories?: CategoriesEnum[];
  /**
   * DO NOT USE! Deprecated.
   * @format int32
   */
  zipFrom?: number;
  /**
   * DO NOT USE! Deprecated.
   * @format int32
   */
  zipTo?: number;
  /** DO NOT USE! Deprecated. */
  tenantContactIds?: string[];
  /** DO NOT USE! Deprecated. */
  networkPartnerIds?: string[];
  /**
   * DO NOT USE! Deprecated.
   * @default "UNDEFINED_SORT_ORDER"
   */
  sortFloor?: SortFloorEnum;
  /**
   * DO NOT USE! Deprecated.
   * @default "UNDEFINED_SORT_ORDER"
   */
  sortRentPrice?: SortRentPriceEnum;
  /** @format int64 */
  accountId: string;
}

export enum CategoriesEnum {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/**
 * DO NOT USE! Deprecated.
 * @default "UNDEFINED_SORT_ORDER"
 */
export enum SortFloorEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * DO NOT USE! Deprecated.
 * @default "UNDEFINED_SORT_ORDER"
 */
export enum SortRentPriceEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type ObjectServiceListData = ObjectobjectListResponse;

export type ObjectServiceListError = GooglerpcStatus;

export enum ObjectServiceListParams1CategoriesEnum {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/**
 * DO NOT USE! Deprecated.
 * @default "UNDEFINED_SORT_ORDER"
 */
export enum ObjectServiceListParams1SortFloorEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * DO NOT USE! Deprecated.
 * @default "UNDEFINED_SORT_ORDER"
 */
export enum ObjectServiceListParams1SortRentPriceEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type ObjectServiceListByBuildingIdsData = ObjectobjectListByBuildingIdsResponse;

export type ObjectServiceListByBuildingIdsError = GooglerpcStatus;

export type ObjectServiceListByIdsData = ObjectobjectListByIdsResponse;

export type ObjectServiceListByIdsError = GooglerpcStatus;

export type ObjectServiceListFilterOptionsData = ObjectobjectListFilterOptionsResponse;

export type ObjectServiceListFilterOptionsError = GooglerpcStatus;

export type ObjectServiceListFreeByDateData = ObjectListFreeByDateResponse;

export type ObjectServiceListFreeByDateError = GooglerpcStatus;

export type ObjectServiceListIdsInMarketingData = ObjectListIdsInMarketingResponse;

export type ObjectServiceListIdsInMarketingError = GooglerpcStatus;

export interface ObjectServiceListMarketingParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  statuses?: StatusesEnum3[];
  /** Optional: Only partial match needed */
  publicId?: string;
  /** Optional */
  address?: string;
  categories?: CategoriesEnum1[];
  /**
   * Optional: If -1 then do not filter for it
   * @format float
   */
  roomsFrom?: number;
  /**
   * Optional: If -1 then do not filter for it
   * @format float
   */
  roomsTo?: number;
  /** Optional */
  contactIdAssigneeMarketing?: string[];
  /** @default "UNDEFINED_SORT_ORDER" */
  sortUnreadRequests?: SortUnreadRequestsEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortViewingAppointments?: SortViewingAppointmentsEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortApplicationForms?: SortApplicationFormsEnum;
  /**
   * Get all objects with this as ownerId AND all objects that are shared with this accountId
   * @format int64
   */
  accountId: string;
}

export enum StatusesEnum3 {
  NO_MARKETING_STATUS_FILTER = "NO_MARKETING_STATUS_FILTER",
  NEW = "NEW",
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
  RENTED = "RENTED",
}

export enum CategoriesEnum1 {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortUnreadRequestsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortViewingAppointmentsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortApplicationFormsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type ObjectServiceListMarketingData = ObjectListMarketingResponse;

export type ObjectServiceListMarketingError = GooglerpcStatus;

export enum ObjectServiceListMarketingParams1StatusesEnum {
  NO_MARKETING_STATUS_FILTER = "NO_MARKETING_STATUS_FILTER",
  NEW = "NEW",
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
  RENTED = "RENTED",
}

export enum ObjectServiceListMarketingParams1CategoriesEnum {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum ObjectServiceListMarketingParams1SortUnreadRequestsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum ObjectServiceListMarketingParams1SortViewingAppointmentsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum ObjectServiceListMarketingParams1SortApplicationFormsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type ObjectServiceListPublishedData = ObjectListPublishedResponse;

export type ObjectServiceListPublishedError = GooglerpcStatus;

export interface ObjectServiceMarkForMarketingPayload {
  availability?: ObjectAvailability;
  deposit?: ObjectobjectDeposit;
  description?: string;
  documents?: ObjectobjectDocument[];
  images?: ObjectobjectImage[];
  marketingNote?: string;
  parking?: ObjectParking[];
  pricing?: ObjectPricing;
  publishAddress?: boolean;
  publishCharacteristicsInDescription?: boolean;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  startMarketingAt?: string;
  title?: string;
  videoUrl?: string;
  videos?: ObjectVideo[];
  virtualTourUrl?: string;
}

export type ObjectServiceMarkForMarketingData = ObjectMarkForMarketingResponse;

export type ObjectServiceMarkForMarketingError = GooglerpcStatus;

export type ObjectServiceMarketingMarkSeenData = ObjectMarketingMarkSeenResponse;

export type ObjectServiceMarketingMarkSeenError = GooglerpcStatus;

export type MortgageServiceCreateData = ObjectmortgageCreateResponse;

export type MortgageServiceCreateError = GooglerpcStatus;

export type MortgageServiceListByIdsData = ObjectmortgageListByIdsResponse;

export type MortgageServiceListByIdsError = GooglerpcStatus;

export type MortgageServiceListByReferenceIdsData = ObjectmortgageListByReferenceIdsResponse;

export type MortgageServiceListByReferenceIdsError = GooglerpcStatus;

export type MortgageServiceDeleteData = ObjectmortgageDeleteResponse;

export type MortgageServiceDeleteError = GooglerpcStatus;

export type MortgageServiceAddDocumentsData = ObjectmortgageAddDocumentsResponse;

export type MortgageServiceAddDocumentsError = GooglerpcStatus;

export interface MortgageServiceUpdatePayload {
  /** @format double */
  amortisationAmount?: number;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  amortizationFrom?: TypeDate;
  amortizations?: MortgageAmortization[];
  /** @format double */
  amount?: number;
  bankCountry?: string;
  bankName?: string;
  bankNumber?: string;
  bic?: string;
  /** @format double */
  carryingAmount?: number;
  debitAccount?: string;
  designation?: string;
  documentIds?: string[];
  dueDateMonthsAmortization?: number[];
  dueDateMonthsInterestRate?: number[];
  enableAmortizations?: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  expiresAt?: TypeDate;
  /** @format float */
  interestRate?: number;
  mortgageDesignation?: MortgageMortgageDesignation;
  mortgageeAddress?: CommonaddressAddress;
  number?: string;
  /** Could be property, building or object ID */
  referenceId?: string;
  terminableOn?: MortgageMortgageTerminableOn;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  validFrom?: TypeDate;
}

export type MortgageServiceUpdateData = ObjectmortgageUpdateResponse;

export type MortgageServiceUpdateError = GooglerpcStatus;

export type ObjectServiceMoveObjectsData = ObjectMoveObjectsResponse;

export type ObjectServiceMoveObjectsError = GooglerpcStatus;

export type PlotServiceCreateData = ObjectplotCreateResponse;

export type PlotServiceCreateError = GooglerpcStatus;

export type PlotServiceListByIdsData = ObjectplotListByIdsResponse;

export type PlotServiceListByIdsError = GooglerpcStatus;

export interface PlotServiceListByOwnerIdParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** @format int64 */
  ownerId: string;
}

export type PlotServiceListByOwnerIdData = PlotListByOwnerIdResponse;

export type PlotServiceListByOwnerIdError = GooglerpcStatus;

export type PlotServiceListByPropertyIdData = PlotListByPropertyIdResponse;

export type PlotServiceListByPropertyIdError = GooglerpcStatus;

export type PlotServiceListByReferenceIdsData = ObjectplotListByReferenceIdsResponse;

export type PlotServiceListByReferenceIdsError = GooglerpcStatus;

export type PlotServiceUpdateData = ObjectplotUpdateResponse;

export type PlotServiceUpdateError = GooglerpcStatus;

export type PlotServiceDeleteData = ObjectplotDeleteResponse;

export type PlotServiceDeleteError = GooglerpcStatus;

export type ObjectServicePublishData = ObjectPublishResponse;

export type ObjectServicePublishError = GooglerpcStatus;

export type ObjectServicePublishUpdatedEventsData = ObjectobjectPublishUpdatedEventsResponse;

export type ObjectServicePublishUpdatedEventsError = GooglerpcStatus;

export type ObjectServiceRemoveCraftsmenData = ObjectRemoveCraftsmenResponse;

export type ObjectServiceRemoveCraftsmenError = GooglerpcStatus;

export type ObjectServiceRemoveFromMarketingData = ObjectRemoveFromMarketingResponse;

export type ObjectServiceRemoveFromMarketingError = GooglerpcStatus;

export type ObjectServiceRemoveJanitorsData = ObjectRemoveJanitorsResponse;

export type ObjectServiceRemoveJanitorsError = GooglerpcStatus;

export type ObjectServiceRemoveServiceProvidersData = ObjectRemoveServiceProvidersResponse;

export type ObjectServiceRemoveServiceProvidersError = GooglerpcStatus;

export type RentalIndexServiceCreateData = ObjectrentalIndexCreateResponse;

export type RentalIndexServiceCreateError = GooglerpcStatus;

export interface RentalIndexServiceListParams {
  /** @format int64 */
  accountId?: string;
}

export type RentalIndexServiceListData = ObjectrentalIndexListResponse;

export type RentalIndexServiceListError = GooglerpcStatus;

export type RentalIndexServiceRenderData = ObjectrentalIndexRenderResponse;

export type RentalIndexServiceRenderError = GooglerpcStatus;

export type RentalIndexServiceRenderPdfData = RentalIndexRenderPdfResponse;

export type RentalIndexServiceRenderPdfError = GooglerpcStatus;

export type RentalIndexServiceDeleteData = ObjectrentalIndexDeleteResponse;

export type RentalIndexServiceDeleteError = GooglerpcStatus;

export interface RentalIndexServiceUpdatePayload {
  compositionLinesOrColumns?: RentalIndexCompositionLinesOrColumns;
  compositionType?: RentalIndexCompositionType;
  fields?: RentalIndexTemplateField[];
  language?: LanguagePreferredLanguage;
  name?: string;
  onlyMovingInOutTenancies?: boolean;
  sortingType?: RentalIndexSortingType;
  tenancyType?: RentalIndexTenancyType;
}

export type RentalIndexServiceUpdateData = ObjectrentalIndexUpdateResponse;

export type RentalIndexServiceUpdateError = GooglerpcStatus;

export type RoomServiceCreateData = ObjectroomCreateResponse;

export type RoomServiceCreateError = GooglerpcStatus;

export type RoomServiceListByIdsData = ObjectroomListByIdsResponse;

export type RoomServiceListByIdsError = GooglerpcStatus;

export type RoomServiceListByReferenceIdsData = ObjectroomListByReferenceIdsResponse;

export type RoomServiceListByReferenceIdsError = GooglerpcStatus;

export type RoomServiceUpdateData = ObjectroomUpdateResponse;

export type RoomServiceUpdateError = GooglerpcStatus;

export type RoomServiceDeleteData = ObjectroomDeleteResponse;

export type RoomServiceDeleteError = GooglerpcStatus;

export type ObjectServiceSetAccountingAssigneeData = ObjectobjectSetAccountingAssigneeResponse;

export type ObjectServiceSetAccountingAssigneeError = GooglerpcStatus;

export type ObjectServiceSetAdminAssigneeData = ObjectobjectSetAdminAssigneeResponse;

export type ObjectServiceSetAdminAssigneeError = GooglerpcStatus;

export type ObjectServiceSetAssetAssigneeData = ObjectobjectSetAssetAssigneeResponse;

export type ObjectServiceSetAssetAssigneeError = GooglerpcStatus;

export type ObjectServiceSetContactsData = ObjectSetContactsResponse;

export type ObjectServiceSetContactsError = GooglerpcStatus;

export type ObjectServiceSetMarketingAssigneeData = ObjectSetMarketingAssigneeResponse;

export type ObjectServiceSetMarketingAssigneeError = GooglerpcStatus;

export type ObjectServiceSetOwnerAssigneeData = ObjectobjectSetOwnerAssigneeResponse;

export type ObjectServiceSetOwnerAssigneeError = GooglerpcStatus;

export type ObjectServiceSetViewingAppointmentContactData = ObjectSetViewingAppointmentContactResponse;

export type ObjectServiceSetViewingAppointmentContactError = GooglerpcStatus;

export type TenancyServiceCloseTenanciesData = TenancyCloseResponse;

export type TenancyServiceCloseTenanciesError = GooglerpcStatus;

export type TenancyServiceCreateData = ObjecttenancyCreateResponse;

export type TenancyServiceCreateError = GooglerpcStatus;

export type TenancyServiceDeleteRentAdjustmentsData = ObjecttenancyDeleteRentAdjustmentsResponse;

export type TenancyServiceDeleteRentAdjustmentsError = GooglerpcStatus;

export type TenancyServiceGetData = ObjecttenancyGetResponse;

export type TenancyServiceGetError = GooglerpcStatus;

export type TenancyServiceHasActivatedTenancyData = TenancyHasActivatedTenancyResponse;

export type TenancyServiceHasActivatedTenancyError = GooglerpcStatus;

export type TenancyServiceListData = ObjecttenancyListResponse;

export type TenancyServiceListError = GooglerpcStatus;

export type TenancyServiceListByBillingContactIdData = ObjecttenancyListByBillingContactIdResponse;

export type TenancyServiceListByBillingContactIdError = GooglerpcStatus;

export interface TenancyServiceListByContactIdParams {
  billingContact?: boolean;
  tenants?: boolean;
  correspondence?: boolean;
  guarantors?: boolean;
  subTenants?: boolean;
  contactId: string;
}

export type TenancyServiceListByContactIdData = ObjecttenancyListByContactIdResponse;

export type TenancyServiceListByContactIdError = GooglerpcStatus;

export type TenancyServiceListByDateAndObjectIdsData = TenancyListByDateAndObjectIdsResponse;

export type TenancyServiceListByDateAndObjectIdsError = GooglerpcStatus;

export type TenancyServiceListByGuarantorData = TenancyListByGuarantorResponse;

export type TenancyServiceListByGuarantorError = GooglerpcStatus;

export type TenancyServiceListByIdsData = ObjecttenancyListByIdsResponse;

export type TenancyServiceListByIdsError = GooglerpcStatus;

export interface TenancyServiceListByOwnerParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  address?: string;
  categories?: CategoriesEnum2[];
  /** @format int32 */
  zipFrom?: number;
  /** @format int32 */
  zipTo?: number;
  tenantContactIds?: string[];
  /**
   * Int64 Unix Timestamp, NOT string!
   * @format int64
   */
  startingAtFrom?: string;
  /**
   * Int64 Unix Timestamp, NOT string!
   * @format int64
   */
  startingAtTo?: string;
  /**
   * Int64 Unix Timestamp, NOT string!
   * @format int64
   */
  endingAtFrom?: string;
  /**
   * Int64 Unix Timestamp, NOT string!
   * @format int64
   */
  endingAtTo?: string;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortColdRent?: SortColdRentEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortAdditionalCosts?: SortAdditionalCostsEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortTotalRent?: SortTotalRentEnum;
  /** @format int64 */
  ownerId: string;
}

export enum CategoriesEnum2 {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortColdRentEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortAdditionalCostsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortTotalRentEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type TenancyServiceListByOwnerData = ObjecttenancyListByOwnerResponse;

export type TenancyServiceListByOwnerError = GooglerpcStatus;

export enum TenancyServiceListByOwnerParams1CategoriesEnum {
  UNDEFINED_CATEGORY = "UNDEFINED_CATEGORY",
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  COMMERCIAL = "COMMERCIAL",
  GASTRONOMY = "GASTRONOMY",
  GARDEN = "GARDEN",
  PARKING_SPACE = "PARKING_SPACE",
  SECONDARY_ROOM = "SECONDARY_ROOM",
  PLOT = "PLOT",
  AGRICULTURE = "AGRICULTURE",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum TenancyServiceListByOwnerParams1SortColdRentEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum TenancyServiceListByOwnerParams1SortAdditionalCostsEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum TenancyServiceListByOwnerParams1SortTotalRentEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type TenancyServiceListByTenantData = TenancyListByTenantResponse;

export type TenancyServiceListByTenantError = GooglerpcStatus;

export type TenancyServiceListCurrentByObjectIdsData = ObjecttenancyListCurrentByObjectIdsResponse;

export type TenancyServiceListCurrentByObjectIdsError = GooglerpcStatus;

export type TenancyServicePublishUpdatedEventsData = ObjecttenancyPublishUpdatedEventsResponse;

export type TenancyServicePublishUpdatedEventsError = GooglerpcStatus;

export type TenancyServiceUpdateBulkData = ObjecttenancyUpdateBulkResponse;

export type TenancyServiceUpdateBulkError = GooglerpcStatus;

export type TenancyServiceDeleteData = ObjecttenancyDeleteResponse;

export type TenancyServiceDeleteError = GooglerpcStatus;

export type TenancyServiceActivateData = ObjecttenancyActivateResponse;

export type TenancyServiceActivateError = GooglerpcStatus;

export type TenancyServiceAddDocumentsData = ObjecttenancyAddDocumentsResponse;

export type TenancyServiceAddDocumentsError = GooglerpcStatus;

export type TenancyServiceDeactivateData = ObjecttenancyDeactivateResponse;

export type TenancyServiceDeactivateError = GooglerpcStatus;

export type TenancyServiceRemoveDocumentsData = ObjecttenancyRemoveDocumentsResponse;

export type TenancyServiceRemoveDocumentsError = GooglerpcStatus;

export interface TenancyServiceSetTerminationPayload {
  /**
   * Date when tenant wants to move out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredMoveOutAt?: TypeDate;
  documentIds?: string[];
  /**
   * Date when liability ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liabilityEndsAt?: TypeDate;
  /**
   * Date when tenant actually moved out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  movedOutAt?: TypeDate;
  /**
   * Date when next tenant could possibly move in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextPossibleMoveInAt?: TypeDate;
  /** DO NOT USE! Deprecated and ignored. */
  reasonForTermination?: string;
  /**
   * Date when tenant returns object
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  returningAt?: TypeDate;
  /**
   * Date when tenancy should end
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminateAt?: TypeDate;
  terminatedBy?: TenancyTerminatedBy;
  /**
   * Date when on which date tenancy should be terminated
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminatedOn?: TypeDate;
  /**
   * Date when termination was handed in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationCreatedAt?: TypeDate;
  terminationJustification?: string;
  terminationReason?: TenancyTerminationReason[];
  /**
   * Date when termination was sent by tenant
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationSentByTenantAt?: TypeDate;
  terminationType?: TenancyTerminationType;
}

export type TenancyServiceSetTerminationData = TenancySetTerminationResponse;

export type TenancyServiceSetTerminationError = GooglerpcStatus;

export interface TenancyServiceUpdatePayload {
  activated?: boolean;
  closed?: boolean;
  contract?: ObjecttenancyContract;
  contractAmendments?: string;
  deposit?: ObjecttenancyDeposit;
  /**
   * Date when tenant wants to move out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  desiredMoveOutAt?: TypeDate;
  documentIds?: string[];
  earlyRightOfTerminationOptions?: TenancyEarlyRightOfTerminationOption[];
  /**
   * Date when tenancy ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  endingAt?: TypeDate;
  familyFlat?: boolean;
  finalInvoiceCreated?: boolean;
  indexData?: TenancyIndexData;
  /**
   * Date when tenant liability ends
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  liabilityEndsAt?: TypeDate;
  /**
   * Date when tenant actually moved out
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  movedOutAt?: TypeDate;
  /**
   * Date when next tenant could possibly move in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  nextPossibleMoveInAt?: TypeDate;
  note?: string;
  objectId?: string;
  opted?: boolean;
  /** DO NOT USE! Deprecated and ignored. */
  reasonForTermination?: string;
  renewalOptions?: TenancyRenewalOption[];
  rent?: ObjecttenancyRent;
  /**
   * Date when tenant returns object
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  returningAt?: TypeDate;
  roommates?: TenancyRoommate[];
  secondaryResidence?: boolean;
  /**
   * Date when tenancy starts
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  startingAt?: TypeDate;
  subTenants?: TenancySubTenant[];
  taxable?: boolean;
  tenant?: ObjecttenancyTenant;
  terminatedBy?: TenancyTerminatedBy;
  /**
   * Date when on which date tenancy should be terminated
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminatedOn?: TypeDate;
  /**
   * Date when termination was handed in
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationCreatedAt?: TypeDate;
  terminationJustification?: string;
  terminationLandlord?: TenancyTermination;
  terminationReason?: TenancyTerminationReason[];
  /**
   * Date when termination was sent by tenant
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  terminationSentByTenantAt?: TypeDate;
  terminationTenant?: TenancyTermination;
  terminationType?: TenancyTerminationType;
  unjustifiedUse?: TenancyUnjustifiedUse;
  vacancyReason?: TenancyVacancyReason;
}

export type TenancyServiceUpdateData = ObjecttenancyUpdateResponse;

export type TenancyServiceUpdateError = GooglerpcStatus;

export type TenancyServiceDeactivateByNumericIdData = ObjecttenancyDeactivateByNumericIdResponse;

export type TenancyServiceDeactivateByNumericIdError = GooglerpcStatus;

export type ObjectServiceUnPublishData = ObjectUnPublishResponse;

export type ObjectServiceUnPublishError = GooglerpcStatus;

export interface ObjectServiceUpdateMarketingInfoPayload {
  marketingNote?: string;
  /**
   * UNIX timestamp in seconds
   * @format int64
   */
  startMarketingAt?: string;
}

export type ObjectServiceUpdateMarketingInfoData = ObjectUpdateMarketingInfoResponse;

export type ObjectServiceUpdateMarketingInfoError = GooglerpcStatus;

export type ObjectServiceDeleteData = ObjectobjectDeleteResponse;

export type ObjectServiceDeleteError = GooglerpcStatus;

export interface ObjectServiceGetApplicationInfoParams {
  language?: string;
  id: string;
}

export type ObjectServiceGetApplicationInfoData = ObjectGetApplicationInfoResponse;

export type ObjectServiceGetApplicationInfoError = GooglerpcStatus;

export type ObjectServiceGetApplicationLinkData = ObjectGetApplicationLinkResponse;

export type ObjectServiceGetApplicationLinkError = GooglerpcStatus;

export type ObjectServiceGetDefaultAnswerData = ObjectGetDefaultAnswerResponse;

export type ObjectServiceGetDefaultAnswerError = GooglerpcStatus;

export interface ObjectServiceGetMarketingExposeParams {
  language?: string;
  id: string;
}

export type ObjectServiceGetMarketingExposeData = ObjectGetMarketingExposeResponse;

export type ObjectServiceGetMarketingExposeError = GooglerpcStatus;

export type ObjectServiceGetViewingAppointmentData = ObjectGetViewingAppointmentResponse;

export type ObjectServiceGetViewingAppointmentError = GooglerpcStatus;

export interface ObjectServiceSetDefaultAnswerPayload {
  defaultAnswer?: ObjectDefaultAnswer;
}

export type ObjectServiceSetDefaultAnswerData = ObjectSetDefaultAnswerResponse;

export type ObjectServiceSetDefaultAnswerError = GooglerpcStatus;

export interface ObjectServiceSetViewingAppointmentPayload {
  viewingAppointment?: ObjectViewingAppointment;
}

export type ObjectServiceSetViewingAppointmentData = ObjectSetViewingAppointmentResponse;

export type ObjectServiceSetViewingAppointmentError = GooglerpcStatus;

export interface ObjectServiceUpdatePayload {
  acceptsCreditTrust?: boolean;
  administrationType?: ObjectAdministrationType;
  assignedSideRooms?: string;
  /** Per-advert override for automatic digital reference check. UNDEFINED means use account settings. */
  automaticReferenceCheck?: MarketbaseAutomaticReferenceCheckMode;
  availability?: ObjectAvailability;
  /** @format int64 */
  awn?: string;
  category?: ObjectCategory;
  characteristics?: ObjectobjectCharacteristics;
  contacts?: ObjectContacts;
  defaultAnswer?: ObjectDefaultAnswer;
  deposit?: ObjectobjectDeposit;
  description?: string;
  development?: ObjectobjectDevelopment;
  documents?: ObjectobjectDocument[];
  energySources?: ObjectobjectEnergySource[];
  ewid?: string;
  images?: ObjectobjectImage[];
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  inactiveBy?: TypeDate;
  marketingLanguage?: LanguagePreferredLanguage;
  name?: string;
  needsMatching?: boolean;
  note?: string;
  number?: string;
  otoId?: string;
  parking?: ObjectParking[];
  /** Do only use first array element. Others are ignored */
  positions?: ObjectPosition[];
  pricing?: ObjectPricing;
  publishAddress?: boolean;
  publishCharacteristicsInDescription?: boolean;
  /** Per-advert override for mailbox ID used as sender for digital reference request emails. Empty means use account settings. */
  referenceSenderMailboxId?: string;
  renovations?: ObjectRenovation[];
  sharedUse?: string;
  specialFeatures?: string;
  subCategories?: ObjectSubCategory[];
  tags?: string[];
  title?: string;
  type?: ObjectobjectType;
  unusualAgreement?: string;
  utilizations?: ObjectUtilization[];
  /** @format float */
  valueQuota?: number;
  videoUrl?: string;
  videos?: ObjectVideo[];
  viewingAppointment?: ObjectViewingAppointment;
  virtualTourUrl?: string;
}

export type ObjectServiceUpdateData = ObjectobjectUpdateResponse;

export type ObjectServiceUpdateError = GooglerpcStatus;

export interface ObjectServiceUpdatePricingPayload {
  /** @format float */
  marketGrossRent?: number;
  /** @format float */
  marketHeatingAndAdditional?: number;
  /** @format float */
  marketNetRent?: number;
  /** @format float */
  underMarketGrossRent?: number;
  /** @format float */
  underMarketHeatingAndAdditional?: number;
  /** @format float */
  underMarketNetRent?: number;
  /** @format float */
  upperMarketGrossRent?: number;
  /** @format float */
  upperMarketHeatingAndAdditional?: number;
  /** @format float */
  upperMarketNetRent?: number;
}

export type ObjectServiceUpdatePricingData = ObjectUpdatePricingResponse;

export type ObjectServiceUpdatePricingError = GooglerpcStatus;

export type ContractServiceCreateTemplateMixin2Data = Contractv2CreateTemplateResponse;

export type ContractServiceCreateTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceDeleteTemplateMixin2Data = Contractv2DeleteTemplateResponse;

export type ContractServiceDeleteTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceDeleteRenderFileData = V2DeleteRenderFileResponse;

export type ContractServiceDeleteRenderFileError = GooglerpcStatus;

export type ContractServiceDeleteRenderFilesData = V2DeleteRenderFilesResponse;

export type ContractServiceDeleteRenderFilesError = GooglerpcStatus;

export type ContractServiceGetRenderFileData = V2GetRenderFileResponse;

export type ContractServiceGetRenderFileError = GooglerpcStatus;

export type ContractServiceGetRenderStatusData = V2GetRenderStatusResponse;

export type ContractServiceGetRenderStatusError = GooglerpcStatus;

export type ContractServiceListTemplatesMixin2Data = Contractv2ListTemplatesResponse;

export type ContractServiceListTemplatesMixin2Error = GooglerpcStatus;

export type ContractServiceListRenderStatusData = V2ListRenderStatusResponse;

export type ContractServiceListRenderStatusError = GooglerpcStatus;

export type ContractServiceRenderDeviceTemplateMixin2Data = Contractv2RenderDeviceTemplateResponse;

export type ContractServiceRenderDeviceTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceRenderTenanciesTemplateMixin2Data = Contractv2RenderTenanciesTemplateResponse;

export type ContractServiceRenderTenanciesTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceRenderTenancyTemplateData = V2RenderTenancyTemplateResponse;

export type ContractServiceRenderTenancyTemplateError = GooglerpcStatus;

export interface ContractServiceUpdateTemplateMixin2Payload {
  category?: Contractv2TemplateCategory;
  creatorName?: string;
  enforcePdf?: boolean;
  language?: V2Language;
  mediaId?: string;
  /** @format int64 */
  ownerId?: string;
  title?: string;
}

export type ContractServiceUpdateTemplateMixin2Data = Contractv2UpdateTemplateResponse;

export type ContractServiceUpdateTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceGetRenderFilesData = V2GetRenderFilesResponse;

export type ContractServiceGetRenderFilesError = GooglerpcStatus;

export type ContractServiceRenderCondominiumTemplateMixin2Data = Contractv2RenderCondominiumTemplateResponse;

export type ContractServiceRenderCondominiumTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceRenderCondominiumsTemplateMixin2Data = Contractv2RenderCondominiumsTemplateResponse;

export type ContractServiceRenderCondominiumsTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceRenderContactTemplateMixin2Data = Contractv2RenderContactTemplateResponse;

export type ContractServiceRenderContactTemplateMixin2Error = GooglerpcStatus;

export type ContractServiceRenderContactsTemplateMixin2Data = Contractv2RenderContactsTemplateResponse;

export type ContractServiceRenderContactsTemplateMixin2Error = GooglerpcStatus;

export interface PropertyServiceCountParams {
  /** @default "UNDEFINED_SCOPE" */
  scope?: ScopeEnum2;
  /** @format int64 */
  accountId: string;
}

/** @default "UNDEFINED_SCOPE" */
export enum ScopeEnum2 {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type PropertyServiceCountData = Propertyv2CountResponse;

export type PropertyServiceCountError = GooglerpcStatus;

/** @default "UNDEFINED_SCOPE" */
export enum PropertyServiceCountParams1ScopeEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type PropertyServiceCreateData = Objectpropertyv2CreateResponse;

export type PropertyServiceCreateError = GooglerpcStatus;

export type PropertyServiceGetAllowedPropertyTypesData = V2GetAllowedPropertyTypesResponse;

export type PropertyServiceGetAllowedPropertyTypesError = GooglerpcStatus;

export interface PropertyServiceListParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  name?: string;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  zipFrom?: number;
  /** @format int32 */
  zipTo?: number;
  city?: string;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortNumber?: SortNumberEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortLandRegisterNumber?: SortLandRegisterNumberEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortBuildingCount?: SortBuildingCountEnum;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortGrossTargetRentPerYear?: SortGrossTargetRentPerYearEnum1;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortGrossActualRentPerYear?: SortGrossActualRentPerYearEnum1;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortNetTargetRentPerYear?: SortNetTargetRentPerYearEnum1;
  /** @default "UNDEFINED_SORT_ORDER" */
  sortNetActualRentPerYear?: SortNetActualRentPerYearEnum1;
  /** @format int64 */
  ownerId: string;
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortNumberEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortLandRegisterNumberEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortBuildingCountEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortGrossTargetRentPerYearEnum1 {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortGrossActualRentPerYearEnum1 {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortNetTargetRentPerYearEnum1 {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum SortNetActualRentPerYearEnum1 {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type PropertyServiceListData = Objectpropertyv2ListResponse;

export type PropertyServiceListError = GooglerpcStatus;

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortNumberEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortLandRegisterNumberEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortBuildingCountEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortGrossTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortGrossActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortNetTargetRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

/** @default "UNDEFINED_SORT_ORDER" */
export enum PropertyServiceListParams1SortNetActualRentPerYearEnum {
  UNDEFINED_SORT_ORDER = "UNDEFINED_SORT_ORDER",
  ASC = "ASC",
  DESC = "DESC",
}

export type PropertyServiceListByBuildingIdsData = Propertyv2ListByBuildingIdsResponse;

export type PropertyServiceListByBuildingIdsError = GooglerpcStatus;

export type PropertyServiceListByIdsData = Objectpropertyv2ListByIdsResponse;

export type PropertyServiceListByIdsError = GooglerpcStatus;

export type PropertyServiceGetByOwnerIdAndNumericIdData = V2GetByOwnerIdAndNumericIdResponse;

export type PropertyServiceGetByOwnerIdAndNumericIdError = GooglerpcStatus;

export type PropertyServiceListFilterOptionsData = Propertyv2ListFilterOptionsResponse;

export type PropertyServiceListFilterOptionsError = GooglerpcStatus;

export type PropertyServiceListIdsData = V2ListIdsResponse;

export type PropertyServiceListIdsError = GooglerpcStatus;

export type PropertyServiceSellData = V2SellResponse;

export type PropertyServiceSellError = GooglerpcStatus;

export type PropertyServiceSetAccountingAssigneeData = Propertyv2SetAccountingAssigneeResponse;

export type PropertyServiceSetAccountingAssigneeError = GooglerpcStatus;

export type PropertyServiceSetAdminAssigneeData = Propertyv2SetAdminAssigneeResponse;

export type PropertyServiceSetAdminAssigneeError = GooglerpcStatus;

export type PropertyServiceSetAssetAssigneeData = Propertyv2SetAssetAssigneeResponse;

export type PropertyServiceSetAssetAssigneeError = GooglerpcStatus;

export type PropertyServiceSetOwnerAssigneeData = Propertyv2SetOwnerAssigneeResponse;

export type PropertyServiceSetOwnerAssigneeError = GooglerpcStatus;

export type PropertyServiceTransferToAccountingData = Propertyv2TransferToAccountingResponse;

export type PropertyServiceTransferToAccountingError = GooglerpcStatus;

export type PropertyServiceDeleteData = Objectpropertyv2DeleteResponse;

export type PropertyServiceDeleteError = GooglerpcStatus;

export interface PropertyServiceAddBuildingPayload {
  buildingId?: string;
}

export type PropertyServiceAddBuildingData = V2AddBuildingResponse;

export type PropertyServiceAddBuildingError = GooglerpcStatus;

export interface PropertyServiceUpdatePayload {
  additionalRentComponents?: V2AdditionalRentComponentEntry[];
  /** Only zip, city and state are required and set */
  address?: CommonaddressAddress;
  advancePaymentRentComponents?: V2AdvancePaymentRentComponentEntry[];
  assignees?: V2Assignees;
  bankInfo?: V2BankInfo[];
  buildingIds?: string[];
  constructionZone?: string;
  development?: Propertyv2Development;
  documentIds?: string[];
  egrid?: string;
  flatRateRentComponents?: V2FlatRateRentComponentEntry[];
  imageMediaId?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  keyDateServiceChargeSettlement?: TypeDate;
  landRegisterNumber?: string;
  name?: string;
  note?: string;
  onboardingFinished?: boolean;
  opted?: boolean;
  optedPortionKey?: Propertyv2OptedPortionKey;
  /** @format float */
  plotArea?: number;
  /** @format int64 */
  propertyValue?: string;
  transferToAccounting?: boolean;
  type?: Propertyv2PropertyType;
}

export type PropertyServiceUpdateData = Objectpropertyv2UpdateResponse;

export type PropertyServiceUpdateError = GooglerpcStatus;

export type ReportingServiceDeleteJdbcConnectionData = ReportingDeleteJdbcConnectionResponse;

export type ReportingServiceDeleteJdbcConnectionError = GooglerpcStatus;

export type ReportingServiceGetAdditionalReportingsData = ReportingGetAdditionalReportingsResponse;

export type ReportingServiceGetAdditionalReportingsError = GooglerpcStatus;

export type ReportingServiceGetBuildingRentReports2Data = ReportingGetBuildingRentReportsResponse;

export type ReportingServiceGetBuildingRentReports2Error = GooglerpcStatus;

export type ReportingServiceGetBuildingRentReportsData = ReportingGetBuildingRentReportsResponse;

export type ReportingServiceGetBuildingRentReportsError = GooglerpcStatus;

export type ReportingServiceGetDefaultReportingsData = ReportingGetDefaultReportingsResponse;

export type ReportingServiceGetDefaultReportingsError = GooglerpcStatus;

export type ReportingServiceGetJdbcConnectionsData = ReportingGetJdbcConnectionsResponse;

export type ReportingServiceGetJdbcConnectionsError = GooglerpcStatus;

export type ReportingServiceGetMyReportingsData = ReportingGetMyReportingsResponse;

export type ReportingServiceGetMyReportingsError = GooglerpcStatus;

export type ReportingServiceGetPropertyRentReportsData = ReportingGetPropertyRentReportsResponse;

export type ReportingServiceGetPropertyRentReportsError = GooglerpcStatus;

export type ReportingServiceGetReportingUrlsData = ReportingGetReportingUrlsResponse;

export type ReportingServiceGetReportingUrlsError = GooglerpcStatus;

export type ReportingServiceHasJdbcConnectionData = ReportingHasJdbcConnectionResponse;

export type ReportingServiceHasJdbcConnectionError = GooglerpcStatus;

export interface ReportingServiceSetAdditionalReportingsPayload {
  additionalReportings?: ReportingReportingUrl[];
}

export type ReportingServiceSetAdditionalReportingsData = ReportingSetAdditionalReportingsResponse;

export type ReportingServiceSetAdditionalReportingsError = GooglerpcStatus;

export type ReportingServiceSetDefaultReportingsData = ReportingSetDefaultReportingsResponse;

export type ReportingServiceSetDefaultReportingsError = GooglerpcStatus;

export interface ReportingServiceSetJdbcConnectionPayload {
  client?: string;
  host?: string;
  password?: string;
  username?: string;
}

export type ReportingServiceSetJdbcConnectionData = ReportingSetJdbcConnectionResponse;

export type ReportingServiceSetJdbcConnectionError = GooglerpcStatus;

export type ReportingServiceSetReportingPermissionsData = ReportingSetReportingPermissionsResponse;

export type ReportingServiceSetReportingPermissionsError = GooglerpcStatus;

export interface ReportingServiceSetReportingUrlsPayload {
  accounting?: ReportingReportingUrl[];
  accountingOverview?: ReportingReportingUrl[];
  adminOverview?: ReportingReportingUrl[];
  administration?: ReportingReportingUrl[];
  assetOverview?: ReportingReportingUrl[];
  marketing?: ReportingReportingUrl[];
  marketingOverview?: ReportingReportingUrl[];
  overview?: ReportingReportingUrl[];
  ownerOverview?: ReportingReportingUrl[];
  publishHistory?: ReportingReportingUrl[];
  tenantList?: ReportingReportingUrl[];
}

export type ReportingServiceSetReportingUrlsData = ReportingSetReportingUrlsResponse;

export type ReportingServiceSetReportingUrlsError = GooglerpcStatus;

export type ApplicationServiceCreateData = Requestapplicationv2CreateResponse;

export type ApplicationServiceCreateError = GooglerpcStatus;

export interface ApplicationServiceDeleteParams {
  hard?: boolean;
  /** @minItems 1 */
  ids: string[];
}

export type ApplicationServiceDeleteData = Requestapplicationv2DeleteResponse;

export type ApplicationServiceDeleteError = GooglerpcStatus;

export type ApplicationServiceGetByIdData = V2GetByIdResponse;

export type ApplicationServiceGetByIdError = GooglerpcStatus;

export type ApplicationServiceGetLatestData = Requestapplicationv2GetLatestResponse;

export type ApplicationServiceGetLatestError = GooglerpcStatus;

export type ApplicationServiceSendData = V2SendResponse;

export type ApplicationServiceSendError = GooglerpcStatus;

export type ApplicationServiceGetSettingsData = Requestapplicationv2GetSettingsResponse;

export type ApplicationServiceGetSettingsError = GooglerpcStatus;

export interface ApplicationServiceSetSettingsPayload {
  affordability?: V2AffordabilitySettings;
  applicationDossier?: V2ApplicationDossierSettings;
  automaticReferenceCheck?: MarketbaseAutomaticReferenceCheckMode;
  /** @format float */
  contractCreationCost?: number;
  /**
   * Single HTML body for employer reference request emails. May contain one or more language
   * versions in the same mail (Swiss practice). Must include the #link_referenz# placeholder.
   */
  employerReferenceEmailTemplate?: string;
  /**
   * Single HTML body for landlord reference request emails. May contain one or more language
   * versions in the same mail (Swiss practice). Must include the #link_referenz# placeholder.
   */
  landlordReferenceEmailTemplate?: string;
  referenceSenderMailboxId?: string;
  showContractCreationCostAgreement?: boolean;
}

export type ApplicationServiceSetSettingsData = Requestapplicationv2SetSettingsResponse;

export type ApplicationServiceSetSettingsError = GooglerpcStatus;

export type RequestServiceCreateData = Requestrequestv2CreateResponse;

export type RequestServiceCreateError = GooglerpcStatus;

export interface RequestServiceGetMarketingStatisticsParams {
  /** The contactId which should be used for employee based statistics */
  contactIdAssigneeMarketing?: string;
  /**
   * The ID of the account whose marketing statistics are to be calculated (requests to objects he got with share-scope=MARKETING)
   * @format int64
   */
  accountId: string;
}

export type RequestServiceGetMarketingStatisticsData = Requestv2GetMarketingStatisticsResponse;

export type RequestServiceGetMarketingStatisticsError = GooglerpcStatus;

export type RequestServiceGetStatisticsData = Requestv2GetStatisticsResponse;

export type RequestServiceGetStatisticsError = GooglerpcStatus;

export type RequestServiceListByIdsData = Requestrequestv2ListByIdsResponse;

export type RequestServiceListByIdsError = GooglerpcStatus;

export type RequestServiceListByRequesterContactIdData = V2ListByRequesterContactIdResponse;

export type RequestServiceListByRequesterContactIdError = GooglerpcStatus;

export interface RequestServiceListReceivedByObjectIdsParams {
  /** Optional: If new request wasn't read by the receiver at least once */
  new?: boolean;
  /** Optional: If receiver read the last message */
  readByReceiver?: boolean;
  checklistViewingAppointmentContactShared?: boolean;
  checklistViewingAppointmentArranged?: boolean;
  checklistViewingAppointmentDone?: boolean;
  checklistApplicationFormRequested?: boolean;
  checklistApplicationFormReceived?: boolean;
  checklistReferencesObtained?: boolean;
  checklistCreditCheckDone?: boolean;
  checklistContractSent?: boolean;
  checklistContractReceived?: boolean;
  /** Optional */
  marketplaceName?: string[];
  /** @minItems 1 */
  objectIds: string[];
}

export type RequestServiceListReceivedByObjectIdsData = V2ListReceivedByObjectIdsResponse;

export type RequestServiceListReceivedByObjectIdsError = GooglerpcStatus;

export type RequestServiceListSentData = V2ListSentResponse;

export type RequestServiceListSentError = GooglerpcStatus;

export type RequestServiceMarkReadData = Requestrequestv2MarkReadResponse;

export type RequestServiceMarkReadError = GooglerpcStatus;

export type RequestServiceMarkRejectedData = V2MarkRejectedResponse;

export type RequestServiceMarkRejectedError = GooglerpcStatus;

export type RequestServiceMarkUnreadData = Requestrequestv2MarkUnreadResponse;

export type RequestServiceMarkUnreadError = GooglerpcStatus;

export type RequestServicePartiallySetChecklistData = V2PartiallySetChecklistResponse;

export type RequestServicePartiallySetChecklistError = GooglerpcStatus;

export type RequestServiceReactivateData = V2ReactivateResponse;

export type RequestServiceReactivateError = GooglerpcStatus;

export type RequestServiceGetReferenceFormData = V2GetReferenceFormResponse;

export type RequestServiceGetReferenceFormError = GooglerpcStatus;

export interface RequestServiceSubmitReferenceFormPayload {
  contactPersonForQueries?: string;
  employerAnswers?: V2SubmitEmployerReferenceAnswers;
  landlordAnswers?: V2SubmitLandlordReferenceAnswers;
  notes?: string;
}

export type RequestServiceSubmitReferenceFormData = V2SubmitReferenceFormResponse;

export type RequestServiceSubmitReferenceFormError = GooglerpcStatus;

export type RequestServiceSetChecklistData = V2SetChecklistResponse;

export type RequestServiceSetChecklistError = GooglerpcStatus;

export type RequestServiceSetFavoriteData = V2SetFavoriteResponse;

export type RequestServiceSetFavoriteError = GooglerpcStatus;

export type RequestServiceSetNotFavoriteData = V2SetNotFavoriteResponse;

export type RequestServiceSetNotFavoriteError = GooglerpcStatus;

export type RequestServiceDeleteData = Requestrequestv2DeleteResponse;

export type RequestServiceDeleteError = GooglerpcStatus;

export interface RequestServiceAddGuarantorsPayload {
  guarantors?: V2Guarantor[];
}

export type RequestServiceAddGuarantorsData = V2AddGuarantorsResponse;

export type RequestServiceAddGuarantorsError = GooglerpcStatus;

export interface RequestServiceAddRequestersPayload {
  requesters?: V2Requester[];
}

export type RequestServiceAddRequestersData = V2AddRequestersResponse;

export type RequestServiceAddRequestersError = GooglerpcStatus;

export interface RequestServiceMovePayload {
  objectId?: string;
}

export type RequestServiceMoveData = V2MoveResponse;

export type RequestServiceMoveError = GooglerpcStatus;

export interface RequestServiceRemoveRequestersPayload {
  contactIds?: string[];
}

export type RequestServiceRemoveRequestersData = V2RemoveRequestersResponse;

export type RequestServiceRemoveRequestersError = GooglerpcStatus;

export type RequestServiceRequestEmployerReferenceByEmailData = V2RequestEmployerReferenceByEmailResponse;

export type RequestServiceRequestEmployerReferenceByEmailError = GooglerpcStatus;

export type RequestServiceRequestLandlordReferenceByEmailData = V2RequestLandlordReferenceByEmailResponse;

export type RequestServiceRequestLandlordReferenceByEmailError = GooglerpcStatus;

export interface RequestServiceReservePayload {
  /** DO NOT USE! Deprecated. Use tenancyIds */
  tenancyId?: string;
  tenancyIds?: string[];
}

export type RequestServiceReserveData = V2ReserveResponse;

export type RequestServiceReserveError = GooglerpcStatus;

export interface RequestServiceSetEmployerReferencePayload {
  contactId?: string;
  employerReference?: V2EmployerReference;
  generatePdf?: boolean;
  language?: string;
}

export type RequestServiceSetEmployerReferenceData = V2SetEmployerReferenceResponse;

export type RequestServiceSetEmployerReferenceError = GooglerpcStatus;

export interface RequestServiceSetEmployerReferenceFinalizedPayload {
  /** Requester or guarantor contact ID whose employer reference is finalized. */
  contactId?: string;
  finalized?: boolean;
}

export type RequestServiceSetEmployerReferenceFinalizedData = V2SetEmployerReferenceFinalizedResponse;

export type RequestServiceSetEmployerReferenceFinalizedError = GooglerpcStatus;

export interface RequestServiceSetLandlordReferencePayload {
  contactId?: string;
  generatePdf?: boolean;
  landlordReference?: V2LandlordReference;
  language?: string;
}

export type RequestServiceSetLandlordReferenceData = V2SetLandlordReferenceResponse;

export type RequestServiceSetLandlordReferenceError = GooglerpcStatus;

export interface RequestServiceSetLandlordReferenceFinalizedPayload {
  /** Requester or guarantor contact ID whose landlord reference is finalized. */
  contactId?: string;
  finalized?: boolean;
}

export type RequestServiceSetLandlordReferenceFinalizedData = V2SetLandlordReferenceFinalizedResponse;

export type RequestServiceSetLandlordReferenceFinalizedError = GooglerpcStatus;

export type SearchServiceGenerateApiKeyData = SearchGenerateApiKeyResponse;

export type SearchServiceGenerateApiKeyError = GooglerpcStatus;

export type SearchServiceGenerateUnauthorizedApiKeyData = SearchGenerateUnauthorizedApiKeyResponse;

export type SearchServiceGenerateUnauthorizedApiKeyError = GooglerpcStatus;

export type SearchServiceGlobalSearchData = SearchGlobalSearchResponse;

export type SearchServiceGlobalSearchError = GooglerpcStatus;

export type SearchServiceListBuildingsData = SearchListBuildingsResponse;

export type SearchServiceListBuildingsError = GooglerpcStatus;

export type SearchServiceListCondominiumsData = SearchListCondominiumsResponse;

export type SearchServiceListCondominiumsError = GooglerpcStatus;

export type SearchServiceListContactsData = SearchListContactsResponse;

export type SearchServiceListContactsError = GooglerpcStatus;

export type SearchServiceListObjectsData = SearchListObjectsResponse;

export type SearchServiceListObjectsError = GooglerpcStatus;

export type SearchServiceListPropertiesData = SearchListPropertiesResponse;

export type SearchServiceListPropertiesError = GooglerpcStatus;

export type SearchServiceListTenanciesData = SearchListTenanciesResponse;

export type SearchServiceListTenanciesError = GooglerpcStatus;

export type SearchServiceUpdateOngoingData = SearchUpdateOngoingResponse;

export type SearchServiceUpdateOngoingError = GooglerpcStatus;

export interface TableServiceLoadSettingsParams {
  /** @format int64 */
  accountId?: string;
}

export type TableServiceLoadSettingsData = SearchtableLoadSettingsResponse;

export type TableServiceLoadSettingsError = GooglerpcStatus;

export type TableServiceSaveSettingsData = SearchtableSaveSettingsResponse;

export type TableServiceSaveSettingsError = GooglerpcStatus;

export type ShareServiceListAllowedAccountIdsData = ShareListAllowedAccountIdsResponse;

export type ShareServiceListAllowedAccountIdsError = GooglerpcStatus;

export interface ShareServiceListByAccountIdsParams {
  /** If left empty all resourceIds should be returned */
  resourceIdPrefix?: string;
  /** @format int64 */
  sourceAccountId: string;
  /** @minItems 1 */
  targetAccountIds: string[];
}

export type ShareServiceListByAccountIdsData = ShareListByAccountIdsResponse;

export type ShareServiceListByAccountIdsError = GooglerpcStatus;

export type ShareServiceListByResourceData = ShareListByResourceResponse;

export type ShareServiceListByResourceError = GooglerpcStatus;

export type ShareServiceListBySubResourceIdsData = ShareListBySubResourceIdsResponse;

export type ShareServiceListBySubResourceIdsError = GooglerpcStatus;

export interface ShareServiceListByTargetAccountIdParams {
  /** Optional. If left empty all resourceIds should be returned */
  resourceIdPrefix?: string;
  /** @format int64 */
  targetAccountId: string;
}

export type ShareServiceListByTargetAccountIdData = ShareListByTargetAccountIdResponse;

export type ShareServiceListByTargetAccountIdError = GooglerpcStatus;

export interface ShareServiceListIdsByTargetAccountIdParams {
  resourceIdPrefix?: string;
  /** Optional. If empty array then filter is not applied */
  scopes?: ScopesEnum1[];
  /** @format int64 */
  targetAccountId: string;
}

export enum ScopesEnum1 {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type ShareServiceListIdsByTargetAccountIdData = ShareListIdsByTargetAccountIdResponse;

export type ShareServiceListIdsByTargetAccountIdError = GooglerpcStatus;

export enum ShareServiceListIdsByTargetAccountIdParams1ScopesEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type ShareServiceListOwnersData = ShareListOwnersResponse;

export type ShareServiceListOwnersError = GooglerpcStatus;

export type ShareServiceListPartnersData = ShareListPartnersResponse;

export type ShareServiceListPartnersError = GooglerpcStatus;

export type ShareServiceListPartnersOfAssetData = ShareListPartnersOfAssetResponse;

export type ShareServiceListPartnersOfAssetError = GooglerpcStatus;

export type ShareServiceListSubResourcesByResourceIdsData = ShareListSubResourcesByResourceIdsResponse;

export type ShareServiceListSubResourcesByResourceIdsError = GooglerpcStatus;

export interface ShareServiceListSubResourcesByTargetAccountIdParams {
  /** @default "UNDEFINED_SCOPE" */
  scope?: ScopeEnum3;
  subResourceIdPrefix?: string;
  /** @format int64 */
  targetAccountId: string;
}

/** @default "UNDEFINED_SCOPE" */
export enum ScopeEnum3 {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type ShareServiceListSubResourcesByTargetAccountIdData = ShareListSubResourcesByTargetAccountIdResponse;

export type ShareServiceListSubResourcesByTargetAccountIdError = GooglerpcStatus;

/** @default "UNDEFINED_SCOPE" */
export enum ShareServiceListSubResourcesByTargetAccountIdParams1ScopeEnum {
  UNDEFINED_SCOPE = "UNDEFINED_SCOPE",
  MARKETING_SCOPE = "MARKETING_SCOPE",
  MANAGEMENT_SCOPE = "MANAGEMENT_SCOPE",
  ACCOUNTING_SCOPE = "ACCOUNTING_SCOPE",
  ASSET_SCOPE = "ASSET_SCOPE",
}

export type ShareServiceSetData = ShareshareSetResponse;

export type ShareServiceSetError = GooglerpcStatus;

export type ShareServiceSetShareForOwnerData = ShareSetShareForOwnerResponse;

export type ShareServiceSetShareForOwnerError = GooglerpcStatus;

export type ShareServiceSetShareForOwnersData = ShareSetShareForOwnersResponse;

export type ShareServiceSetShareForOwnersError = GooglerpcStatus;

export type ShareServiceUnsetData = ShareUnsetResponse;

export type ShareServiceUnsetError = GooglerpcStatus;

export type TicketServiceChangeStatusBulkData = TicketChangeStatusBulkResponse;

export type TicketServiceChangeStatusBulkError = GooglerpcStatus;

export interface TicketServiceCountMyUnreadTicketsParams {
  userIds?: string[];
}

export type TicketServiceCountMyUnreadTicketsData = TicketCountMyUnreadTicketsResponse;

export type TicketServiceCountMyUnreadTicketsError = GooglerpcStatus;

export type TicketServiceCountTicketsData = TicketCountTicketsResponse;

export type TicketServiceCountTicketsError = GooglerpcStatus;

export type TicketServiceCreateData = TicketticketCreateResponse;

export type TicketServiceCreateError = GooglerpcStatus;

export type TicketServiceCreateChecklistTemplateData = TicketCreateChecklistTemplateResponse;

export type TicketServiceCreateChecklistTemplateError = GooglerpcStatus;

export type TicketServiceDeleteChecklistTemplatesData = TicketDeleteChecklistTemplatesResponse;

export type TicketServiceDeleteChecklistTemplatesError = GooglerpcStatus;

export type TicketServiceEnableTicketingData = TicketEnableTicketingResponse;

export type TicketServiceEnableTicketingError = GooglerpcStatus;

export type TicketServiceGetByKeyData = TicketGetByKeyResponse;

export type TicketServiceGetByKeyError = GooglerpcStatus;

export type TicketServiceGetByPublicIdData = TicketticketGetByPublicIdResponse;

export type TicketServiceGetByPublicIdError = GooglerpcStatus;

export type TicketServiceGetNotificationMailboxData = TicketGetNotificationMailboxResponse;

export type TicketServiceGetNotificationMailboxError = GooglerpcStatus;

export type TicketServiceGetTicketStatisticsData = TicketGetTicketStatisticsResponse;

export type TicketServiceGetTicketStatisticsError = GooglerpcStatus;

export interface TicketServiceHasTicketingEnabledParams {
  /** @format int64 */
  accountId?: string;
}

export type TicketServiceHasTicketingEnabledData = TicketHasTicketingEnabledResponse;

export type TicketServiceHasTicketingEnabledError = GooglerpcStatus;

export interface HistoryServiceListChangesParams {
  publicTicketId?: string;
  ticketId: string;
}

export type HistoryServiceListChangesData = HistoryListChangesResponse;

export type HistoryServiceListChangesError = GooglerpcStatus;

export type TicketServiceIsContactInUseData = TicketIsContactInUseResponse;

export type TicketServiceIsContactInUseError = GooglerpcStatus;

export type TicketServiceListByContactIdsData = TicketticketListByContactIdsResponse;

export type TicketServiceListByContactIdsError = GooglerpcStatus;

export type TicketServiceListByIdsData = TicketticketListByIdsResponse;

export type TicketServiceListByIdsError = GooglerpcStatus;

export interface TicketServiceListByQueryParams {
  query?: string;
}

export type TicketServiceListByQueryData = TicketListByQueryResponse;

export type TicketServiceListByQueryError = GooglerpcStatus;

export type TicketServiceListByReferenceIdsData = TicketticketListByReferenceIdsResponse;

export type TicketServiceListByReferenceIdsError = GooglerpcStatus;

export type TicketServiceListChecklistTemplatesData = TicketListChecklistTemplatesResponse;

export type TicketServiceListChecklistTemplatesError = GooglerpcStatus;

export interface TicketServiceListMyTicketsParams {
  /** Optional filter parameter */
  query?: string;
  /**
   * Optional. Leave out or set to 0 to disable pagination
   * @format int32
   */
  page?: number;
  /**
   * Only used when page is set
   * @format int32
   */
  itemsPerPage?: number;
  /** Optional filter parameter */
  priorities?: PrioritiesEnum[];
  /** Optional filter parameter */
  types?: TypesEnum[];
  /** Optional filter parameter */
  statuses?: StatusesEnum4[];
  /** Optional filter parameter */
  ownerIds?: string[];
  /** Optional filter parameter */
  creatorUserIds?: string[];
  /** Optional filter parameter */
  assigneeUserIds?: string[];
  /** Optional filter parameter */
  correspondenceContactIds?: string[];
  /** Optional filter parameter */
  involvedContactIds?: string[];
  /** Optional filter parameter */
  referenceIds?: string[];
  closedOnly?: boolean;
  overdueOnly?: boolean;
  watchingOnly?: boolean;
  directReferenceIdsOnly?: boolean;
  includeClosed?: boolean;
  unreadByAssigneeOnly?: boolean;
  /** Optional filter parameter. Only tickets with an invoice document are returned. */
  hasInvoiceOnly?: boolean;
}

export enum PrioritiesEnum {
  DEFAULT = "DEFAULT",
  LOW = "LOW",
  HIGH = "HIGH",
}

export enum TypesEnum {
  TICKET_TYPE_UNDEFINED = "TICKET_TYPE_UNDEFINED",
  TICKET_TYPE_ORDER = "TICKET_TYPE_ORDER",
  TICKET_TYPE_OFFER = "TICKET_TYPE_OFFER",
  TICKET_TYPE_ACTIVITY = "TICKET_TYPE_ACTIVITY",
  TICKET_TYPE_TASK = "TICKET_TYPE_TASK",
  TICKET_TYPE_CHECKLIST = "TICKET_TYPE_CHECKLIST",
  TICKET_TYPE_CLAIM = "TICKET_TYPE_CLAIM",
}

export enum StatusesEnum4 {
  TICKET_STATUS_OPEN = "TICKET_STATUS_OPEN",
  TICKET_STATUS_IN_PROGRESS = "TICKET_STATUS_IN_PROGRESS",
  TICKET_STATUS_DONE = "TICKET_STATUS_DONE",
  TICKET_STATUS_CLOSED = "TICKET_STATUS_CLOSED",
  TICKET_STATUS_DRAFT = "TICKET_STATUS_DRAFT",
}

export type TicketServiceListMyTicketsData = TicketListMyTicketsResponse;

export type TicketServiceListMyTicketsError = GooglerpcStatus;

export enum TicketServiceListMyTicketsParams1PrioritiesEnum {
  DEFAULT = "DEFAULT",
  LOW = "LOW",
  HIGH = "HIGH",
}

export enum TicketServiceListMyTicketsParams1TypesEnum {
  TICKET_TYPE_UNDEFINED = "TICKET_TYPE_UNDEFINED",
  TICKET_TYPE_ORDER = "TICKET_TYPE_ORDER",
  TICKET_TYPE_OFFER = "TICKET_TYPE_OFFER",
  TICKET_TYPE_ACTIVITY = "TICKET_TYPE_ACTIVITY",
  TICKET_TYPE_TASK = "TICKET_TYPE_TASK",
  TICKET_TYPE_CHECKLIST = "TICKET_TYPE_CHECKLIST",
  TICKET_TYPE_CLAIM = "TICKET_TYPE_CLAIM",
}

export enum TicketServiceListMyTicketsParams1StatusesEnum {
  TICKET_STATUS_OPEN = "TICKET_STATUS_OPEN",
  TICKET_STATUS_IN_PROGRESS = "TICKET_STATUS_IN_PROGRESS",
  TICKET_STATUS_DONE = "TICKET_STATUS_DONE",
  TICKET_STATUS_CLOSED = "TICKET_STATUS_CLOSED",
  TICKET_STATUS_DRAFT = "TICKET_STATUS_DRAFT",
}

export type TicketServiceListMyTickets2Data = TicketListMyTicketsResponse;

export type TicketServiceListMyTickets2Error = GooglerpcStatus;

export type TicketServiceListTicketingEnabledData = TicketListTicketingEnabledResponse;

export type TicketServiceListTicketingEnabledError = GooglerpcStatus;

export type TicketServiceMarkRead2Data = TicketticketMarkReadResponse;

export type TicketServiceMarkRead2Error = GooglerpcStatus;

export type TicketServiceMarkUnread2Data = TicketticketMarkUnreadResponse;

export type TicketServiceMarkUnread2Error = GooglerpcStatus;

export type TicketServiceRemoveWatcherFromTicketsOfAssigneeData = TicketRemoveWatcherFromTicketsOfAssigneeResponse;

export type TicketServiceRemoveWatcherFromTicketsOfAssigneeError = GooglerpcStatus;

export type TicketServiceReserveKeysData = TicketReserveKeysResponse;

export type TicketServiceReserveKeysError = GooglerpcStatus;

export type TicketServiceSetSchedulesData = TicketSetSchedulesResponse;

export type TicketServiceSetSchedulesError = GooglerpcStatus;

export interface TicketServiceListSchedulesParams {
  /** Optional filter parameter */
  categories?: string[];
  /** @format int64 */
  accountId: string;
}

export type TicketServiceListSchedulesData = TicketListSchedulesResponse;

export type TicketServiceListSchedulesError = GooglerpcStatus;

export interface TicketServiceSetNotificationMailboxPayload {
  mailboxId?: string;
}

export type TicketServiceSetNotificationMailboxData = TicketSetNotificationMailboxResponse;

export type TicketServiceSetNotificationMailboxError = GooglerpcStatus;

export interface TicketServiceUpdateChecklistTemplatePayload {
  /** Ignored if usePropertyAssignee is set to true. */
  assigneeUserId?: string;
  /** Deprecated. Use checklistItems instead. */
  checklistItemTitles?: string[];
  checklistItems?: TicketChecklistItemTemplate[];
  mediaIds?: string[];
  name?: string;
  usePropertyAssignee?: boolean;
}

export type TicketServiceUpdateChecklistTemplateData = TicketUpdateChecklistTemplateResponse;

export type TicketServiceUpdateChecklistTemplateError = GooglerpcStatus;

export type TicketServiceMarkReadData = TicketticketMarkReadResponse;

export type TicketServiceMarkReadError = GooglerpcStatus;

export type TicketServiceMarkUnreadData = TicketticketMarkUnreadResponse;

export type TicketServiceMarkUnreadError = GooglerpcStatus;

export interface TicketServiceAddInvoicePayload {
  /** The medium ID (NOT documentId) from the file that should be added to invoice document. */
  mediaId?: string;
  /** The name of the operator who added the invoice. Only set if publicId is set. */
  operatorName?: string;
  /** Optional. Used to authenticate for unregistered upload by craftsman. */
  publicId?: string;
}

export type TicketServiceAddInvoiceData = TicketAddInvoiceResponse;

export type TicketServiceAddInvoiceError = GooglerpcStatus;

export interface TicketServiceAddWatcherPayload {
  watcher?: TicketSetTicketWatcher;
}

export type TicketServiceAddWatcherData = TicketAddWatcherResponse;

export type TicketServiceAddWatcherError = GooglerpcStatus;

export interface TicketServiceChangeStatusPayload {
  email?: string;
  name?: string;
  status?: TicketTicketStatus;
}

export type TicketServiceChangeStatusData = TicketChangeStatusResponse;

export type TicketServiceChangeStatusError = GooglerpcStatus;

export interface TicketServiceDeleteParams {
  deleteRecurrence?: boolean;
  id: string;
}

export type TicketServiceDeleteData = TicketticketDeleteResponse;

export type TicketServiceDeleteError = GooglerpcStatus;

export interface TicketServiceDeleteInvoicePayload {
  /** The name of the operator who added the invoice. Only set if publicId is set. */
  operatorName?: string;
  /** Optional. Used to authenticate for unregistered upload by craftsman. */
  publicId?: string;
}

export type TicketServiceDeleteInvoiceData = TicketDeleteInvoiceResponse;

export type TicketServiceDeleteInvoiceError = GooglerpcStatus;

export interface TicketServiceUpdatePayload {
  omitCorrespondenceNotification?: boolean;
  update?: {
    additionalData?: TicketAdditionalData[];
    assignee?: TicketSetAssignee;
    checklist?: TicketChecklistItem[];
    correspondences?: TicketSetCorrespondence[];
    /** DEPRECATED!. Use costsEntries array. */
    costs?: TicketticketCosts;
    costsEntries?: TicketticketCosts[];
    description?: string;
    /**
     * * A full date, with non-zero year, month, and day values
     * * A month and day value, with a zero year, such as an anniversary
     * * A year on its own, with zero month and day values
     * * A year and month value, with a zero day, such as a credit card expiration
     * date
     *
     * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
     * `google.protobuf.Timestamp`.
     */
    dueDate?: TypeDate;
    externalTicketWatchers?: TicketExternalTicketWatcher[];
    links?: TicketTicketLink[];
    mediaIds?: string[];
    /** DEPRECATED!. Use onSiteContacts array. */
    onSiteContact?: TicketSetOnSiteContact;
    onSiteContacts?: TicketSetOnSiteContact[];
    /** @format int64 */
    ownerId?: string;
    priority?: TicketTicketPriority;
    recurrence?: TicketRecurrence;
    references?: TicketTicketReference[];
    /**
     * * A full date, with non-zero year, month, and day values
     * * A month and day value, with a zero year, such as an anniversary
     * * A year on its own, with zero month and day values
     * * A year and month value, with a zero day, such as a credit card expiration
     * date
     *
     * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
     * `google.protobuf.Timestamp`.
     */
    startDate?: TypeDate;
    status?: TicketTicketStatus;
    title?: string;
    type?: TicketTicketType;
    watchers?: TicketSetTicketWatcher[];
  };
  updateMask?: string;
  updateRecurrenceFields?: boolean;
}

export type TicketServiceUpdateData = TicketticketUpdateResponse;

export type TicketServiceUpdateError = GooglerpcStatus;

export type PortalServiceAddLinksData = PortalAddLinksResponse;

export type PortalServiceAddLinksError = GooglerpcStatus;

export type PortalServiceEnablePortalData = PortalEnablePortalResponse;

export type PortalServiceEnablePortalError = GooglerpcStatus;

export type PortalServiceGetPortalDataData = PortalGetPortalDataResponse;

export type PortalServiceGetPortalDataError = GooglerpcStatus;

export type PortalServiceHasPortalEnabledData = PortalHasPortalEnabledResponse;

export type PortalServiceHasPortalEnabledError = GooglerpcStatus;

export type PortalServiceListDocumentGroupsData = PortalListDocumentGroupsResponse;

export type PortalServiceListDocumentGroupsError = GooglerpcStatus;

export type PortalServiceListLinksByReferenceIdsData = PortalListLinksByReferenceIdsResponse;

export type PortalServiceListLinksByReferenceIdsError = GooglerpcStatus;

export type PortalServiceRemoveLinksData = PortalRemoveLinksResponse;

export type PortalServiceRemoveLinksError = GooglerpcStatus;

export type PortalServiceUpdateLinksData = PortalUpdateLinksResponse;

export type PortalServiceUpdateLinksError = GooglerpcStatus;

export type AccountServiceCreateData = Useraccountv2CreateResponse;

export type AccountServiceCreateError = GooglerpcStatus;

export type AccountServiceGetData = Useraccountv2GetResponse;

export type AccountServiceGetError = GooglerpcStatus;

export interface AccountServiceListParams {
  /**
   * Items per page to load. Defaults to 10
   * @format int32
   */
  perPage?: number;
  /** The type to filter for */
  types?: TypesEnum1[];
  /** The type to filter for */
  subTypes?: SubTypesEnum[];
  /** Email to filter for (optional) */
  email?: string;
  /** Company name to filter for (optional) */
  companyName?: string;
  /** Contact person name to filter for (optional) */
  contactPersonName?: string;
  /** Optional: All given states need to be part of marketing OR management */
  states?: StatesEnum[];
  /**
   * Page to load. Defaults to 1
   * @format int32
   */
  page: number;
}

export enum TypesEnum1 {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
  PLATFORM_EMPLOYEE = "PLATFORM_EMPLOYEE",
}

export enum SubTypesEnum {
  UNDEFINED = "UNDEFINED",
  TENANT = "TENANT",
  LANDLORD = "LANDLORD",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  MARKETING = "MARKETING",
  OWNER = "OWNER",
  LANDLORD_MARKETING = "LANDLORD_MARKETING",
  ACCOUNTING = "ACCOUNTING",
  LANDLORD_ACCOUNTING = "LANDLORD_ACCOUNTING",
  MARKETING_ACCOUNTING = "MARKETING_ACCOUNTING",
  LANDLORD_MARKETING_ACCOUNTING = "LANDLORD_MARKETING_ACCOUNTING",
  ASSET_MANAGEMENT = "ASSET_MANAGEMENT",
  ASSET_LANDLORD = "ASSET_LANDLORD",
  ASSET_MARKETING = "ASSET_MARKETING",
  ASSET_ACCOUNTING = "ASSET_ACCOUNTING",
  ASSET_LANDLORD_MARKETING = "ASSET_LANDLORD_MARKETING",
  ASSET_LANDLORD_ACCOUNTING = "ASSET_LANDLORD_ACCOUNTING",
  ASSET_MARKETING_ACCOUNTING = "ASSET_MARKETING_ACCOUNTING",
  ASSET_LANDLORD_MARKETING_ACCOUNTING = "ASSET_LANDLORD_MARKETING_ACCOUNTING",
}

export enum StatesEnum {
  UNDEFINED_STATE = "UNDEFINED_STATE",
  CH_ZH = "CH_ZH",
  CH_BE = "CH_BE",
  CH_LU = "CH_LU",
  CH_UR = "CH_UR",
  CH_SZ = "CH_SZ",
  CH_OW = "CH_OW",
  CH_NW = "CH_NW",
  CH_GL = "CH_GL",
  CH_ZG = "CH_ZG",
  CH_FR = "CH_FR",
  CH_SO = "CH_SO",
  CH_BS = "CH_BS",
  CH_BL = "CH_BL",
  CH_SH = "CH_SH",
  CH_AR = "CH_AR",
  CH_AI = "CH_AI",
  CH_SG = "CH_SG",
  CH_GR = "CH_GR",
  CH_AG = "CH_AG",
  CH_TG = "CH_TG",
  CH_TI = "CH_TI",
  CH_VD = "CH_VD",
  CH_VS = "CH_VS",
  CH_NE = "CH_NE",
  CH_GE = "CH_GE",
  CH_JU = "CH_JU",
}

export type AccountServiceListData = Useraccountv2ListResponse;

export type AccountServiceListError = GooglerpcStatus;

export enum AccountServiceListParams1TypesEnum {
  INDIVIDUAL = "INDIVIDUAL",
  COMPANY = "COMPANY",
  PLATFORM_EMPLOYEE = "PLATFORM_EMPLOYEE",
}

export enum AccountServiceListParams1SubTypesEnum {
  UNDEFINED = "UNDEFINED",
  TENANT = "TENANT",
  LANDLORD = "LANDLORD",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  MARKETING = "MARKETING",
  OWNER = "OWNER",
  LANDLORD_MARKETING = "LANDLORD_MARKETING",
  ACCOUNTING = "ACCOUNTING",
  LANDLORD_ACCOUNTING = "LANDLORD_ACCOUNTING",
  MARKETING_ACCOUNTING = "MARKETING_ACCOUNTING",
  LANDLORD_MARKETING_ACCOUNTING = "LANDLORD_MARKETING_ACCOUNTING",
  ASSET_MANAGEMENT = "ASSET_MANAGEMENT",
  ASSET_LANDLORD = "ASSET_LANDLORD",
  ASSET_MARKETING = "ASSET_MARKETING",
  ASSET_ACCOUNTING = "ASSET_ACCOUNTING",
  ASSET_LANDLORD_MARKETING = "ASSET_LANDLORD_MARKETING",
  ASSET_LANDLORD_ACCOUNTING = "ASSET_LANDLORD_ACCOUNTING",
  ASSET_MARKETING_ACCOUNTING = "ASSET_MARKETING_ACCOUNTING",
  ASSET_LANDLORD_MARKETING_ACCOUNTING = "ASSET_LANDLORD_MARKETING_ACCOUNTING",
}

export enum AccountServiceListParams1StatesEnum {
  UNDEFINED_STATE = "UNDEFINED_STATE",
  CH_ZH = "CH_ZH",
  CH_BE = "CH_BE",
  CH_LU = "CH_LU",
  CH_UR = "CH_UR",
  CH_SZ = "CH_SZ",
  CH_OW = "CH_OW",
  CH_NW = "CH_NW",
  CH_GL = "CH_GL",
  CH_ZG = "CH_ZG",
  CH_FR = "CH_FR",
  CH_SO = "CH_SO",
  CH_BS = "CH_BS",
  CH_BL = "CH_BL",
  CH_SH = "CH_SH",
  CH_AR = "CH_AR",
  CH_AI = "CH_AI",
  CH_SG = "CH_SG",
  CH_GR = "CH_GR",
  CH_AG = "CH_AG",
  CH_TG = "CH_TG",
  CH_TI = "CH_TI",
  CH_VD = "CH_VD",
  CH_VS = "CH_VS",
  CH_NE = "CH_NE",
  CH_GE = "CH_GE",
  CH_JU = "CH_JU",
}

export type AccountServiceListByIdsData = Useraccountv2ListByIdsResponse;

export type AccountServiceListByIdsError = GooglerpcStatus;

export interface AccountServiceChangeBillingPayload {
  billable?: boolean;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  billableSetDate?: TypeDate;
  /** @format int64 */
  billingAddressAccountId?: string;
  /**
   * * A full date, with non-zero year, month, and day values
   * * A month and day value, with a zero year, such as an anniversary
   * * A year on its own, with zero month and day values
   * * A year and month value, with a zero day, such as a credit card expiration
   * date
   *
   * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
   * `google.protobuf.Timestamp`.
   */
  contractStart?: TypeDate;
  note?: string;
  pricingModel?: V2PricingModel;
}

export type AccountServiceChangeBillingData = V2ChangeBillingResponse;

export type AccountServiceChangeBillingError = GooglerpcStatus;

export interface AccountServiceChangeSubTypePayload {
  subType?: Commonv2SubType;
}

export type AccountServiceChangeSubTypeData = V2ChangeSubTypeResponse;

export type AccountServiceChangeSubTypeError = GooglerpcStatus;

export type AccountServiceGetFontSettingsData = V2GetFontSettingsResponse;

export type AccountServiceGetFontSettingsError = GooglerpcStatus;

export interface AccountServiceSetFontSettingsPayload {
  /**
   * Represents a color in the RGBA color space. This representation is designed
   * for simplicity of conversion to/from color representations in various
   * languages over compactness. For example, the fields of this representation
   * can be trivially provided to the constructor of `java.awt.Color` in Java; it
   * can also be trivially provided to UIColor's `+colorWithRed:green:blue:alpha`
   * method in iOS; and, with just a little work, it can be easily formatted into
   * a CSS `rgba()` string in JavaScript.
   *
   * This reference page doesn't carry information about the absolute color
   * space
   * that should be used to interpret the RGB value (e.g. sRGB, Adobe RGB,
   * DCI-P3, BT.2020, etc.). By default, applications should assume the sRGB color
   * space.
   *
   * When color equality needs to be decided, implementations, unless
   * documented otherwise, treat two colors as equal if all their red,
   * green, blue, and alpha values each differ by at most 1e-5.
   *
   * Example (Java):
   *
   *      import com.google.type.Color;
   *
   *      // ...
   *      public static java.awt.Color fromProto(Color protocolor) {
   *        float alpha = protocolor.hasAlpha()
   *            ? protocolor.getAlpha().getValue()
   *            : 1.0;
   *
   *        return new java.awt.Color(
   *            protocolor.getRed(),
   *            protocolor.getGreen(),
   *            protocolor.getBlue(),
   *            alpha);
   *      }
   *
   *      public static Color toProto(java.awt.Color color) {
   *        float red = (float) color.getRed();
   *        float green = (float) color.getGreen();
   *        float blue = (float) color.getBlue();
   *        float denominator = 255.0;
   *        Color.Builder resultBuilder =
   *            Color
   *                .newBuilder()
   *                .setRed(red / denominator)
   *                .setGreen(green / denominator)
   *                .setBlue(blue / denominator);
   *        int alpha = color.getAlpha();
   *        if (alpha != 255) {
   *          result.setAlpha(
   *              FloatValue
   *                  .newBuilder()
   *                  .setValue(((float) alpha) / denominator)
   *                  .build());
   *        }
   *        return resultBuilder.build();
   *      }
   *      // ...
   *
   * Example (iOS / Obj-C):
   *
   *      // ...
   *      static UIColor* fromProto(Color* protocolor) {
   *         float red = [protocolor red];
   *         float green = [protocolor green];
   *         float blue = [protocolor blue];
   *         FloatValue* alpha_wrapper = [protocolor alpha];
   *         float alpha = 1.0;
   *         if (alpha_wrapper != nil) {
   *           alpha = [alpha_wrapper value];
   *         }
   *         return [UIColor colorWithRed:red green:green blue:blue alpha:alpha];
   *      }
   *
   *      static Color* toProto(UIColor* color) {
   *          CGFloat red, green, blue, alpha;
   *          if (![color getRed:&red green:&green blue:&blue alpha:&alpha]) {
   *            return nil;
   *          }
   *          Color* result = [[Color alloc] init];
   *          [result setRed:red];
   *          [result setGreen:green];
   *          [result setBlue:blue];
   *          if (alpha <= 0.9999) {
   *            [result setAlpha:floatWrapperWithValue(alpha)];
   *          }
   *          [result autorelease];
   *          return result;
   *     }
   *     // ...
   *
   *  Example (JavaScript):
   *
   *     // ...
   *
   *     var protoToCssColor = function(rgb_color) {
   *        var redFrac = rgb_color.red || 0.0;
   *        var greenFrac = rgb_color.green || 0.0;
   *        var blueFrac = rgb_color.blue || 0.0;
   *        var red = Math.floor(redFrac * 255);
   *        var green = Math.floor(greenFrac * 255);
   *        var blue = Math.floor(blueFrac * 255);
   *
   *        if (!('alpha' in rgb_color)) {
   *           return rgbToCssColor(red, green, blue);
   *        }
   *
   *        var alphaFrac = rgb_color.alpha.value || 0.0;
   *        var rgbParams = [red, green, blue].join(',');
   *        return ['rgba(', rgbParams, ',', alphaFrac, ')'].join('');
   *     };
   *
   *     var rgbToCssColor = function(red, green, blue) {
   *       var rgbNumber = new Number((red << 16) | (green << 8) | blue);
   *       var hexString = rgbNumber.toString(16);
   *       var missingZeros = 6 - hexString.length;
   *       var resultBuilder = ['#'];
   *       for (var i = 0; i < missingZeros; i++) {
   *          resultBuilder.push('0');
   *       }
   *       resultBuilder.push(hexString);
   *       return resultBuilder.join('');
   *     };
   *
   *     // ...
   */
  color?: TypeColor;
  family?: string;
  size?: string;
}

export type AccountServiceSetFontSettingsData = V2SetFontSettingsResponse;

export type AccountServiceSetFontSettingsError = GooglerpcStatus;

export interface AccountServiceSetLogoPayload {
  logoUrl?: string;
}

export type AccountServiceSetLogoData = V2SetLogoResponse;

export type AccountServiceSetLogoError = GooglerpcStatus;

export interface AccountServiceUpdateCompanyPayload {
  company?: Usercommonv2Company;
}

export type AccountServiceUpdateCompanyData = Useraccountv2UpdateCompanyResponse;

export type AccountServiceUpdateCompanyError = GooglerpcStatus;

export interface AccountServiceUpdateContactPersonPayload {
  contactPerson?: Useraccountv2ContactPerson;
}

export type AccountServiceUpdateContactPersonData = Useraccountv2UpdateContactPersonResponse;

export type AccountServiceUpdateContactPersonError = GooglerpcStatus;

export interface AccountServiceUpdateIndividualPayload {
  individual?: Usercommonv2Individual;
}

export type AccountServiceUpdateIndividualData = V2UpdateIndividualResponse;

export type AccountServiceUpdateIndividualError = GooglerpcStatus;

export interface AccountServiceUpdateStatesPayload {
  accountingStates?: AddressState[];
  assetStates?: AddressState[];
  managementStates?: AddressState[];
  marketingStates?: AddressState[];
}

export type AccountServiceUpdateStatesData = V2UpdateStatesResponse;

export type AccountServiceUpdateStatesError = GooglerpcStatus;

export type UserServiceGetData = V2User;

export type UserServiceGetError = GooglerpcStatus;

export type UserServiceGetByMailData = V2User;

export type UserServiceGetByMailError = GooglerpcStatus;

export type UserServiceInviteEmployeeData = V2User;

export type UserServiceInviteEmployeeError = GooglerpcStatus;

export interface UserServiceListParams {
  /**
   * Starting from 1
   * @format int32
   */
  page?: number;
  /** @format int32 */
  itemsPerPage?: number;
  /** @format int64 */
  accountId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export type UserServiceListData = Useruserv2ListResponse;

export type UserServiceListError = GooglerpcStatus;

export type UserServiceListAllEmployeesData = V2ListAllEmployeesResponse;

export type UserServiceListAllEmployeesError = GooglerpcStatus;

export type UserServiceListEmployeesData = Useruserv2ListEmployeesResponse;

export type UserServiceListEmployeesError = GooglerpcStatus;

export interface NotificationServiceGetTokenParams {
  userId?: string;
}

export type NotificationServiceGetTokenData = Notificationv2GetTokenResponse;

export type NotificationServiceGetTokenError = GooglerpcStatus;

export type NotificationServicePublishUpdateMessageData = V2PublishUpdateMessageResponse;

export type NotificationServicePublishUpdateMessageError = GooglerpcStatus;

export interface NotificationServiceGetSettingsParams {
  userId?: string;
}

export type NotificationServiceGetSettingsData = Usernotificationv2GetSettingsResponse;

export type NotificationServiceGetSettingsError = GooglerpcStatus;

export type NotificationServiceSetSettingsData = Usernotificationv2SetSettingsResponse;

export type NotificationServiceSetSettingsError = GooglerpcStatus;

export type UserServiceRegisterData = V2RegisterResponse;

export type UserServiceRegisterError = GooglerpcStatus;

export type UserServiceResolveTokenData = V2ResolveTokenResponse;

export type UserServiceResolveTokenError = GooglerpcStatus;

export type UserServiceBlockData = V2BlockResponse;

export type UserServiceBlockError = GooglerpcStatus;

export type UserServiceUnblockData = V2UnblockResponse;

export type UserServiceUnblockError = GooglerpcStatus;

export type UserServiceAddRoleData = V2User;

export type UserServiceAddRoleError = GooglerpcStatus;

export interface UserServiceChangeEmailPayload {
  newEmail?: string;
}

export type UserServiceChangeEmailData = V2User;

export type UserServiceChangeEmailError = GooglerpcStatus;

export interface UserServiceChangePasswordPayload {
  newPassword?: string;
}

export type UserServiceChangePasswordData = V2User;

export type UserServiceChangePasswordError = GooglerpcStatus;

export type UserServiceRemoveRoleData = V2User;

export type UserServiceRemoveRoleError = GooglerpcStatus;

export interface UserServiceUpdateProfilePayload {
  profile?: V2Profile;
}

export type UserServiceUpdateProfileData = V2User;

export type UserServiceUpdateProfileError = GooglerpcStatus;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Main API Document
 * @version 1.0.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  web = {
    /**
     * @description Returns the advert-generation account config for the given account, including the account-wide style prompt.
     *
     * @tags AdvertGenerationService
     * @name AdvertGenerationServiceGetAccountConfig
     * @summary Get advert generation account config
     * @request GET:/web/ai/advert-generation/accountConfig/{accountId}
     */
    advertGenerationServiceGetAccountConfig: (accountId: string, params: RequestParams = {}) =>
      this.request<AdvertGenerationServiceGetAccountConfigData, AdvertGenerationServiceGetAccountConfigError>({
        path: `/web/ai/advert-generation/accountConfig/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates the account-wide advert-generation prompt for the given account. Returns the updated config.
     *
     * @tags AdvertGenerationService
     * @name AdvertGenerationServiceSetAccountConfig
     * @summary Set advert generation account config
     * @request POST:/web/ai/advert-generation/accountConfig/{accountId}
     */
    advertGenerationServiceSetAccountConfig: (
      accountId: string,
      body: AdvertGenerationServiceSetAccountConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<AdvertGenerationServiceSetAccountConfigData, AdvertGenerationServiceSetAccountConfigError>({
        path: `/web/ai/advert-generation/accountConfig/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Stores feedback for a prior generation identified by generationId, with rating and optional comment. Does not trigger regeneration. Returns the stored feedback.
     *
     * @tags AdvertGenerationService
     * @name AdvertGenerationServiceSubmitGenerationFeedback
     * @summary Submit feedback on a generation
     * @request POST:/web/ai/advert-generation/feedback
     */
    advertGenerationServiceSubmitGenerationFeedback: (
      body: AdvertGenerationSubmitGenerationFeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        AdvertGenerationServiceSubmitGenerationFeedbackData,
        AdvertGenerationServiceSubmitGenerationFeedbackError
      >({
        path: `/web/ai/advert-generation/feedback`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates an advert title and description for the given objectId using account config and object data. Returns title, description, generationId, and the ai-gateway requestId.
     *
     * @tags AdvertGenerationService
     * @name AdvertGenerationServiceGenerate
     * @summary Generate an advert description
     * @request POST:/web/ai/advert-generation/generate
     */
    advertGenerationServiceGenerate: (body: AiadvertGenerationGenerateRequest, params: RequestParams = {}) =>
      this.request<AdvertGenerationServiceGenerateData, AdvertGenerationServiceGenerateError>({
        path: `/web/ai/advert-generation/generate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Revises a prior generation identified by generationId using the provided feedback instruction. Account prompt and object data are reloaded server-side. Returns a new title, description, generationId, requestId, and parentGenerationId.
     *
     * @tags AdvertGenerationService
     * @name AdvertGenerationServiceRegenerate
     * @summary Regenerate an advert description
     * @request POST:/web/ai/advert-generation/regenerate
     */
    advertGenerationServiceRegenerate: (body: AdvertGenerationRegenerateRequest, params: RequestParams = {}) =>
      this.request<AdvertGenerationServiceRegenerateData, AdvertGenerationServiceRegenerateError>({
        path: `/web/ai/advert-generation/regenerate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Stores feedback for a prior optimization identified by optimizationId, with rating and optional comment. Does not trigger a new optimization.
     *
     * @tags AdvertImageService
     * @name AdvertImageServiceSubmitOptimizationFeedback
     * @summary Submit feedback on an image optimization
     * @request POST:/web/ai/advert-image/feedback
     */
    advertImageServiceSubmitOptimizationFeedback: (
      body: AdvertImageSubmitOptimizationFeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdvertImageServiceSubmitOptimizationFeedbackData, AdvertImageServiceSubmitOptimizationFeedbackError>(
        {
          path: `/web/ai/advert-image/feedback`,
          method: "POST",
          body: body,
          type: ContentType.Json,
          ...params,
        },
      ),

    /**
     * @description Analyzes the given store media with a vision model and applies conservative global corrections (exposure, white balance, shadows, highlights, contrast, vibrance, sharpening) to the full-resolution original. Geometry and content are never changed. The result is uploaded as a new store media; the original stays untouched. Returns the optimizationId, the new mediaId, the applied adjustments and the ai-gateway requestId.
     *
     * @tags AdvertImageService
     * @name AdvertImageServiceOptimize
     * @summary Optimize an advert image
     * @request POST:/web/ai/advert-image/optimize
     */
    advertImageServiceOptimize: (body: AdvertImageOptimizeRequest, params: RequestParams = {}) =>
      this.request<AdvertImageServiceOptimizeData, AdvertImageServiceOptimizeError>({
        path: `/web/ai/advert-image/optimize`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns AI gateway settings for the given account, including whether AI is enabled and which use cases are allowed.
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceGetAccountSettings
     * @summary Get AI account settings
     * @request GET:/web/ai/ai-gateway/accountSettings/{accountId}
     */
    aiGatewayServiceGetAccountSettings: (accountId: string, params: RequestParams = {}) =>
      this.request<AiGatewayServiceGetAccountSettingsData, AiGatewayServiceGetAccountSettingsError>({
        path: `/web/ai/ai-gateway/accountSettings/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates AI gateway settings for the given account: enabled flag and enabled use cases. When enabled is true and enabledUseCases is empty, all registered use cases are allowed. Returns the updated settings.
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceSetAccountSettings
     * @summary Set AI account settings
     * @request POST:/web/ai/ai-gateway/accountSettings/{accountId}
     */
    aiGatewayServiceSetAccountSettings: (
      accountId: string,
      body: AiGatewayServiceSetAccountSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AiGatewayServiceSetAccountSettingsData, AiGatewayServiceSetAccountSettingsError>({
        path: `/web/ai/ai-gateway/accountSettings/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of individual AI usage records for the given account in the [fromUnix, toUnix) window. Supports optional use-case filter, pageSize, and pageToken. Response includes records, nextPageToken, and totalCount.
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceListUsageRecords
     * @summary List AI usage records
     * @request POST:/web/ai/ai-gateway/listUsageRecords
     */
    aiGatewayServiceListUsageRecords: (body: AiGatewayListUsageRecordsRequest, params: RequestParams = {}) =>
      this.request<AiGatewayServiceListUsageRecordsData, AiGatewayServiceListUsageRecordsError>({
        path: `/web/ai/ai-gateway/listUsageRecords`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the configured AI quotas for the given account, typically one entry per quota period (daily, monthly).
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceGetQuota
     * @summary Get AI quotas for an account
     * @request GET:/web/ai/ai-gateway/quota/{accountId}
     */
    aiGatewayServiceGetQuota: (accountId: string, params: RequestParams = {}) =>
      this.request<AiGatewayServiceGetQuotaData, AiGatewayServiceGetQuotaError>({
        path: `/web/ai/ai-gateway/quota/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Replaces AI quotas for the given account with the provided quota entries (period, max requests/tokens/cost, hard limit). Returns the updated quotas.
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceSetQuota
     * @summary Set AI quotas for an account
     * @request POST:/web/ai/ai-gateway/quota/{accountId}
     */
    aiGatewayServiceSetQuota: (accountId: string, body: AiGatewayServiceSetQuotaPayload, params: RequestParams = {}) =>
      this.request<AiGatewayServiceSetQuotaData, AiGatewayServiceSetQuotaError>({
        path: `/web/ai/ai-gateway/quota/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns aggregated AI usage for the given account in the [fromUnix, toUnix) window. Optional filterUseCases limits the summary; response includes request counts, tokens, cost, and per-use-case breakdown.
     *
     * @tags AiGatewayService
     * @name AiGatewayServiceGetUsage
     * @summary Get AI usage summary
     * @request GET:/web/ai/ai-gateway/usage/{accountId}
     */
    aiGatewayServiceGetUsage: ({ accountId, ...query }: AiGatewayServiceGetUsageParams, params: RequestParams = {}) =>
      this.request<AiGatewayServiceGetUsageData, AiGatewayServiceGetUsageError>({
        path: `/web/ai/ai-gateway/usage/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates an event for the given ownerId, userId, and calendarId. Accepts title, description, location, start/end date and time (omit times for all-day), attendees, reminders, visibility, referenceIds, mediaIds, recurrence fields, and notifyParticipants. Returns the created event.
     *
     * @tags NylasService
     * @name NylasServiceCreateEvent
     * @summary Create a Nylas calendar event
     * @request POST:/web/calendar/nylas/createEvent
     */
    nylasServiceCreateEvent: (body: NylasCreateEventRequest, params: RequestParams = {}) =>
      this.request<NylasServiceCreateEventData, NylasServiceCreateEventError>({
        path: `/web/calendar/nylas/createEvent`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the event identified by id for the given userId.
     *
     * @tags NylasService
     * @name NylasServiceDeleteEvent
     * @summary Delete a Nylas calendar event
     * @request DELETE:/web/calendar/nylas/deleteEvent/{id}
     */
    nylasServiceDeleteEvent: ({ id, ...query }: NylasServiceDeleteEventParams, params: RequestParams = {}) =>
      this.request<NylasServiceDeleteEventData, NylasServiceDeleteEventError>({
        path: `/web/calendar/nylas/deleteEvent/${id}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Parses and returns the event associated with the given ICS mediaId.
     *
     * @tags NylasService
     * @name NylasServiceGetEventByIcs
     * @summary Get event from ICS media
     * @request GET:/web/calendar/nylas/getEventByIcs/{mediaId}
     */
    nylasServiceGetEventByIcs: (mediaId: string, params: RequestParams = {}) =>
      this.request<NylasServiceGetEventByIcsData, NylasServiceGetEventByIcsError>({
        path: `/web/calendar/nylas/getEventByIcs/${mediaId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the calendars available to the given userId (e.g. from the connected Nylas account).
     *
     * @tags NylasService
     * @name NylasServiceListAvailableCalendars
     * @summary List available calendars for a user
     * @request GET:/web/calendar/nylas/listAvailableCalendars/{userId}
     */
    nylasServiceListAvailableCalendars: (userId: string, params: RequestParams = {}) =>
      this.request<NylasServiceListAvailableCalendarsData, NylasServiceListAvailableCalendarsError>({
        path: `/web/calendar/nylas/listAvailableCalendars/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the Calendar linked to the given user ID.
     *
     * @tags NylasService
     * @name NylasServiceListCalendarByUserId
     * @summary Get calendar by user ID
     * @request GET:/web/calendar/nylas/listCalendarByUserId/{id}
     */
    nylasServiceListCalendarByUserId: (id: string, params: RequestParams = {}) =>
      this.request<NylasServiceListCalendarByUserIdData, NylasServiceListCalendarByUserIdError>({
        path: `/web/calendar/nylas/listCalendarByUserId/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns calendars for the given user IDs.
     *
     * @tags NylasService
     * @name NylasServiceListCalendarsByUserIds
     * @summary List calendars by user IDs
     * @request POST:/web/calendar/nylas/listCalendarsByUserIds
     */
    nylasServiceListCalendarsByUserIds: (body: NylasListCalendarsByUserIdsRequest, params: RequestParams = {}) =>
      this.request<NylasServiceListCalendarsByUserIdsData, NylasServiceListCalendarsByUserIdsError>({
        path: `/web/calendar/nylas/listCalendarsByUserIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns events for the given ownerId and userIds. Supports optional filters by startDate, endDate, attendeeEmails, and referenceIds, and optional sort by start.
     *
     * @tags NylasService
     * @name NylasServiceListEvents
     * @summary List Nylas calendar events
     * @request POST:/web/calendar/nylas/listEvents
     */
    nylasServiceListEvents: (body: NylasListEventsRequest, params: RequestParams = {}) =>
      this.request<NylasServiceListEventsData, NylasServiceListEventsError>({
        path: `/web/calendar/nylas/listEvents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the Calendar associated with the given email address.
     *
     * @tags NylasService
     * @name NylasServiceResolveCalendarByEmail
     * @summary Resolve calendar by email
     * @request GET:/web/calendar/nylas/resolveCalendarByEmail/{email}
     */
    nylasServiceResolveCalendarByEmail: (email: string, params: RequestParams = {}) =>
      this.request<NylasServiceResolveCalendarByEmailData, NylasServiceResolveCalendarByEmailError>({
        path: `/web/calendar/nylas/resolveCalendarByEmail/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sends an RSVP status (accepted, declined, tentative, or needs action) for the given userId, eventId, calendarId, and optional iCalUid.
     *
     * @tags NylasService
     * @name NylasServiceSendRsvp
     * @summary Send an RSVP for an event
     * @request POST:/web/calendar/nylas/sendRSVP
     */
    nylasServiceSendRsvp: (body: NylasSendRSVPRequest, params: RequestParams = {}) =>
      this.request<NylasServiceSendRsvpData, NylasServiceSendRsvpError>({
        path: `/web/calendar/nylas/sendRSVP`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the authenticated user's active calendar by nylasCalendarId. Returns the resulting Calendar.
     *
     * @tags NylasService
     * @name NylasServiceSetCalendar
     * @summary Set the active Nylas calendar
     * @request POST:/web/calendar/nylas/setCalendar
     */
    nylasServiceSetCalendar: (body: NylasSetCalendarRequest, params: RequestParams = {}) =>
      this.request<NylasServiceSetCalendarData, NylasServiceSetCalendarError>({
        path: `/web/calendar/nylas/setCalendar`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the event identified by id for the given userId. Accepts title, description, location, start/end, attendees, reminders, visibility, referenceIds, mediaIds, recurrence fields, notifyParticipants, and editFollowing. Returns the updated event.
     *
     * @tags NylasService
     * @name NylasServiceUpdateEvent
     * @summary Update a Nylas calendar event
     * @request POST:/web/calendar/nylas/updateEvent
     */
    nylasServiceUpdateEvent: (body: NylasUpdateEventRequest, params: RequestParams = {}) =>
      this.request<NylasServiceUpdateEventData, NylasServiceUpdateEventError>({
        path: `/web/calendar/nylas/updateEvent`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of due/overdue reminders for the given ownerId and userId.
     *
     * @tags ReminderService
     * @name ReminderServiceCountDueReminders
     * @summary Count due reminders for a user
     * @request GET:/web/calendar/reminder/countOverdueReminders/{ownerId}/user/{userId}
     */
    reminderServiceCountDueReminders: (ownerId: string, userId: string, params: RequestParams = {}) =>
      this.request<ReminderServiceCountDueRemindersData, ReminderServiceCountDueRemindersError>({
        path: `/web/calendar/reminder/countOverdueReminders/${ownerId}/user/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the number of unfinished reminders for the given ownerId and userId.
     *
     * @tags ReminderService
     * @name ReminderServiceCountUndoneReminders
     * @summary Count undone reminders for a user
     * @request GET:/web/calendar/reminder/countUndoneReminders/{ownerId}/user/{userId}
     */
    reminderServiceCountUndoneReminders: (ownerId: string, userId: string, params: RequestParams = {}) =>
      this.request<ReminderServiceCountUndoneRemindersData, ReminderServiceCountUndoneRemindersError>({
        path: `/web/calendar/reminder/countUndoneReminders/${ownerId}/user/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates a reminder for the given ownerId with optional referenceIds, employeeUserId, contactId, date (UNIX seconds), priority, activity, subject, and done timestamp. Returns the created reminder.
     *
     * @tags ReminderService
     * @name ReminderServiceCreate
     * @summary Create a reminder
     * @request POST:/web/calendar/reminder/create
     */
    reminderServiceCreate: (body: CalendarreminderCreateRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceCreateData, ReminderServiceCreateError>({
        path: `/web/calendar/reminder/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates one reminder per reference bucket for the given ownerId, sharing employeeUserId, contactId, date, priority, activity, subject, and done. Each bucket's referenceIds are attached to that reminder.
     *
     * @tags ReminderService
     * @name ReminderServiceCreateBulk
     * @summary Create reminders in bulk
     * @request POST:/web/calendar/reminder/createBulk
     */
    reminderServiceCreateBulk: (body: CalendarreminderCreateBulkRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceCreateBulkData, ReminderServiceCreateBulkError>({
        path: `/web/calendar/reminder/createBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns reminders for the given ownerId. Optionally filters by employeeIds (match at least one) and priority values.
     *
     * @tags ReminderService
     * @name ReminderServiceList
     * @summary List reminders for an owner
     * @request GET:/web/calendar/reminder/list/{ownerId}
     */
    reminderServiceList: ({ ownerId, ...query }: ReminderServiceListParams, params: RequestParams = {}) =>
      this.request<ReminderServiceListData, ReminderServiceListError>({
        path: `/web/calendar/reminder/list/${ownerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns reminders linked to any of the given contactIds.
     *
     * @tags ReminderService
     * @name ReminderServiceListByContactIds
     * @summary List reminders by contact IDs
     * @request POST:/web/calendar/reminder/listByContactIds
     */
    reminderServiceListByContactIds: (body: CalendarreminderListByContactIdsRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceListByContactIdsData, ReminderServiceListByContactIdsError>({
        path: `/web/calendar/reminder/listByContactIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns reminders for the given ownerId that match any of the referenceIds. Set includeDone to also return completed reminders.
     *
     * @tags ReminderService
     * @name ReminderServiceListByReferenceIds2
     * @summary List reminders by reference IDs
     * @request POST:/web/calendar/reminder/listByReferenceIds
     */
    reminderServiceListByReferenceIds2: (body: CalendarreminderListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceListByReferenceIds2Data, ReminderServiceListByReferenceIds2Error>({
        path: `/web/calendar/reminder/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns reminders for the given ownerId that match any of the referenceIds. Set includeDone to also return completed reminders.
     *
     * @tags ReminderService
     * @name ReminderServiceListByReferenceIds
     * @summary List reminders by reference IDs
     * @request GET:/web/calendar/reminder/listByReferenceIds/{referenceIds}
     */
    reminderServiceListByReferenceIds: (
      { referenceIds, ...query }: ReminderServiceListByReferenceIdsParams,
      params: RequestParams = {},
    ) =>
      this.request<ReminderServiceListByReferenceIdsData, ReminderServiceListByReferenceIdsError>({
        path: `/web/calendar/reminder/listByReferenceIds/${referenceIds}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Marks the reminders matching the given IDs as done.
     *
     * @tags ReminderService
     * @name ReminderServiceSetDone
     * @summary Mark reminders as done
     * @request POST:/web/calendar/reminder/setDone
     */
    reminderServiceSetDone: (body: ReminderSetDoneRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceSetDoneData, ReminderServiceSetDoneError>({
        path: `/web/calendar/reminder/setDone`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Clears the done state on the reminders matching the given IDs.
     *
     * @tags ReminderService
     * @name ReminderServiceSetUnDone
     * @summary Mark reminders as not done
     * @request POST:/web/calendar/reminder/setUnDone
     */
    reminderServiceSetUnDone: (body: ReminderSetUnDoneRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceSetUnDoneData, ReminderServiceSetUnDoneError>({
        path: `/web/calendar/reminder/setUnDone`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the reminder identified by id (referenceIds, employeeUserId, contactId, date, priority, activity, subject, and done).
     *
     * @tags ReminderService
     * @name ReminderServiceUpdate
     * @summary Update a reminder
     * @request POST:/web/calendar/reminder/update
     */
    reminderServiceUpdate: (body: CalendarreminderUpdateRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceUpdateData, ReminderServiceUpdateError>({
        path: `/web/calendar/reminder/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the date (UNIX seconds) on the reminders matching the given IDs.
     *
     * @tags ReminderService
     * @name ReminderServiceUpdateDate
     * @summary Update reminder dates
     * @request POST:/web/calendar/reminder/updateDate
     */
    reminderServiceUpdateDate: (body: ReminderUpdateDateRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceUpdateDateData, ReminderServiceUpdateDateError>({
        path: `/web/calendar/reminder/updateDate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the employeeUserId on the reminders matching the given IDs.
     *
     * @tags ReminderService
     * @name ReminderServiceUpdateEmployee
     * @summary Update reminder employee assignee
     * @request POST:/web/calendar/reminder/updateEmployee
     */
    reminderServiceUpdateEmployee: (body: ReminderUpdateEmployeeRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceUpdateEmployeeData, ReminderServiceUpdateEmployeeError>({
        path: `/web/calendar/reminder/updateEmployee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the priority on the reminders matching the given IDs.
     *
     * @tags ReminderService
     * @name ReminderServiceUpdatePriority
     * @summary Update reminder priorities
     * @request POST:/web/calendar/reminder/updatePriority
     */
    reminderServiceUpdatePriority: (body: ReminderUpdatePriorityRequest, params: RequestParams = {}) =>
      this.request<ReminderServiceUpdatePriorityData, ReminderServiceUpdatePriorityError>({
        path: `/web/calendar/reminder/updatePriority`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the reminder identified by the given ID.
     *
     * @tags ReminderService
     * @name ReminderServiceGet
     * @summary Get a reminder by ID
     * @request GET:/web/calendar/reminder/{id}
     */
    reminderServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<ReminderServiceGetData, ReminderServiceGetError>({
        path: `/web/calendar/reminder/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Deletes the reminder with the given ID.
     *
     * @tags ReminderService
     * @name ReminderServiceDelete
     * @summary Delete a reminder
     * @request DELETE:/web/calendar/reminder/{id}
     */
    reminderServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<ReminderServiceDeleteData, ReminderServiceDeleteError>({
        path: `/web/calendar/reminder/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the appointment identified by the given ID, including participants and status.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetAppointment
     * @summary Get an appointment by ID
     * @request GET:/web/calendar/scheduler/appointment/{id}
     */
    schedulerServiceGetAppointment: (id: string, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetAppointmentData, SchedulerServiceGetAppointmentError>({
        path: `/web/calendar/scheduler/appointment/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Cancels the appointments matching the given IDs. Returns the cancelled appointments.
     *
     * @tags SchedulerService
     * @name SchedulerServiceCancelAppointments
     * @summary Cancel appointments
     * @request POST:/web/calendar/scheduler/cancelAppointments
     */
    schedulerServiceCancelAppointments: (body: SchedulerCancelAppointmentsRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceCancelAppointmentsData, SchedulerServiceCancelAppointmentsError>({
        path: `/web/calendar/scheduler/cancelAppointments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates one or more appointment slots for the given objectId. Each slot specifies date, start/end time, optional maxParticipants, and optional calendarUserId. Returns the created appointments.
     *
     * @tags SchedulerService
     * @name SchedulerServiceCreateAppointments
     * @summary Create appointments for an object
     * @request POST:/web/calendar/scheduler/createAppointments
     */
    schedulerServiceCreateAppointments: (body: SchedulerCreateAppointmentsRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceCreateAppointmentsData, SchedulerServiceCreateAppointmentsError>({
        path: `/web/calendar/scheduler/createAppointments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a public token for objectId that lets the given contactId propose appointment slots. Returns the token.
     *
     * @tags SchedulerService
     * @name SchedulerServiceCreateTokenForRequestingAppointments
     * @summary Create a token for requesting appointments
     * @request POST:/web/calendar/scheduler/createTokenForRequestingAppointments
     */
    schedulerServiceCreateTokenForRequestingAppointments: (
      body: SchedulerCreateTokenForRequestingAppointmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        SchedulerServiceCreateTokenForRequestingAppointmentsData,
        SchedulerServiceCreateTokenForRequestingAppointmentsError
      >({
        path: `/web/calendar/scheduler/createTokenForRequestingAppointments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the reminder mailboxId and hoursBeforeAppointment for the given accountId.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetReminderConfig
     * @summary Get scheduler reminder configuration
     * @request GET:/web/calendar/scheduler/getReminderConfig
     */
    schedulerServiceGetReminderConfig: (query: SchedulerServiceGetReminderConfigParams, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetReminderConfigData, SchedulerServiceGetReminderConfigError>({
        path: `/web/calendar/scheduler/getReminderConfig`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the mailboxId used as sender for viewing appointment emails for the given accountId. Empty means a PROPbase generated no-reply address is used.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetSenderMailbox
     * @summary Get viewing appointment sender mailbox
     * @request GET:/web/calendar/scheduler/getSenderMailbox
     */
    schedulerServiceGetSenderMailbox: (query: SchedulerServiceGetSenderMailboxParams, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetSenderMailboxData, SchedulerServiceGetSenderMailboxError>({
        path: `/web/calendar/scheduler/getSenderMailbox`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the public registration token for the given objectId, used by external participants to pick available slots.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetTokenForRegistering
     * @summary Get registration token for an object
     * @request GET:/web/calendar/scheduler/getTokenForRegistering/{objectId}
     */
    schedulerServiceGetTokenForRegistering: (objectId: string, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetTokenForRegisteringData, SchedulerServiceGetTokenForRegisteringError>({
        path: `/web/calendar/scheduler/getTokenForRegistering/${objectId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all appointments linked to the given objectId.
     *
     * @tags SchedulerService
     * @name SchedulerServiceListAppointmentsByObjectId
     * @summary List appointments by object ID
     * @request POST:/web/calendar/scheduler/listAppointmentsByObjectId
     */
    schedulerServiceListAppointmentsByObjectId: (
      body: SchedulerListAppointmentsByObjectIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<SchedulerServiceListAppointmentsByObjectIdData, SchedulerServiceListAppointmentsByObjectIdError>({
        path: `/web/calendar/scheduler/listAppointmentsByObjectId`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Public endpoint. Returns objectId and future, not-yet-full appointment slots for the given registration token.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetAvailableSlots
     * @summary Get available appointment slots by token
     * @request GET:/web/calendar/scheduler/public/availableSlots/{token}
     */
    schedulerServiceGetAvailableSlots: (token: string, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetAvailableSlotsData, SchedulerServiceGetAvailableSlotsError>({
        path: `/web/calendar/scheduler/public/availableSlots/${token}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Public endpoint. Removes the participant identified by participantId from the appointment they are registered for, so an interested party can unsubscribe from the public form. Both the registration token and the participantId must match the same object.
     *
     * @tags SchedulerService
     * @name SchedulerServiceCancelRegistration
     * @summary Cancel an existing registration by token and participant
     * @request POST:/web/calendar/scheduler/public/cancelRegistration
     */
    schedulerServiceCancelRegistration: (body: SchedulerCancelRegistrationRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceCancelRegistrationData, SchedulerServiceCancelRegistrationError>({
        path: `/web/calendar/scheduler/public/cancelRegistration`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Public endpoint. Returns appointments accessible via the given token (used when requesting appointments).
     *
     * @tags SchedulerService
     * @name SchedulerServiceListAppointmentsByToken
     * @summary List appointments by public token
     * @request GET:/web/calendar/scheduler/public/listAppointments/{token}
     */
    schedulerServiceListAppointmentsByToken: (token: string, params: RequestParams = {}) =>
      this.request<SchedulerServiceListAppointmentsByTokenData, SchedulerServiceListAppointmentsByTokenError>({
        path: `/web/calendar/scheduler/public/listAppointments/${token}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Public endpoint. Returns the slot a participant is registered for, so the interested party form can open on their existing appointment instead of asking them to register again. Both the registration token and the participantId must match the same object, and only the requesting participant is returned - never the other participants of the slot.
     *
     * @tags SchedulerService
     * @name SchedulerServiceGetRegistration
     * @summary Get an existing registration by token and participant
     * @request GET:/web/calendar/scheduler/public/registration/{token}/{participantId}
     */
    schedulerServiceGetRegistration: (token: string, participantId: string, params: RequestParams = {}) =>
      this.request<SchedulerServiceGetRegistrationData, SchedulerServiceGetRegistrationError>({
        path: `/web/calendar/scheduler/public/registration/${token}/${participantId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Public endpoint. Creates appointment slots proposed by an external contact using the request token. Returns the created appointments.
     *
     * @tags SchedulerService
     * @name SchedulerServiceSubmitRequestedAppointments
     * @summary Submit requested appointment slots
     * @request POST:/web/calendar/scheduler/public/submitRequestedAppointments
     */
    schedulerServiceSubmitRequestedAppointments: (
      body: SchedulerSubmitRequestedAppointmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<SchedulerServiceSubmitRequestedAppointmentsData, SchedulerServiceSubmitRequestedAppointmentsError>({
        path: `/web/calendar/scheduler/public/submitRequestedAppointments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Public endpoint. Registers a participant (firstName, lastName, email, phone) for the given appointmentId using the registration token.
     *
     * @tags SchedulerService
     * @name SchedulerServiceSubmitSlotSelection
     * @summary Submit a public slot selection
     * @request POST:/web/calendar/scheduler/public/submitSlotSelection
     */
    schedulerServiceSubmitSlotSelection: (body: SchedulerSubmitSlotSelectionRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceSubmitSlotSelectionData, SchedulerServiceSubmitSlotSelectionError>({
        path: `/web/calendar/scheduler/public/submitSlotSelection`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the reminder mailboxId and hoursBeforeAppointment for the given accountId.
     *
     * @tags SchedulerService
     * @name SchedulerServiceSetReminderConfig
     * @summary Set scheduler reminder configuration
     * @request POST:/web/calendar/scheduler/setReminderConfig
     */
    schedulerServiceSetReminderConfig: (body: SchedulerSetReminderConfigRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceSetReminderConfigData, SchedulerServiceSetReminderConfigError>({
        path: `/web/calendar/scheduler/setReminderConfig`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the mailboxId used as sender for viewing appointment emails for the given accountId. Empty falls back to a PROPbase generated no-reply address.
     *
     * @tags SchedulerService
     * @name SchedulerServiceSetSenderMailbox
     * @summary Set viewing appointment sender mailbox
     * @request POST:/web/calendar/scheduler/setSenderMailbox
     */
    schedulerServiceSetSenderMailbox: (body: SchedulerSetSenderMailboxRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceSetSenderMailboxData, SchedulerServiceSetSenderMailboxError>({
        path: `/web/calendar/scheduler/setSenderMailbox`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the participant identified by participantId from the appointment identified by appointmentId.
     *
     * @tags SchedulerService
     * @name SchedulerServiceUnregisterParticipant
     * @summary Unregister a participant from an appointment
     * @request POST:/web/calendar/scheduler/unregisterParticipant
     */
    schedulerServiceUnregisterParticipant: (body: SchedulerUnregisterParticipantRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceUnregisterParticipantData, SchedulerServiceUnregisterParticipantError>({
        path: `/web/calendar/scheduler/unregisterParticipant`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets or clears the maxParticipants of the appointment identified by appointmentId. Returns the updated appointment.
     *
     * @tags SchedulerService
     * @name SchedulerServiceUpdateMaxParticipants
     * @summary Update the max participants of an appointment
     * @request POST:/web/calendar/scheduler/updateMaxParticipants
     */
    schedulerServiceUpdateMaxParticipants: (body: SchedulerUpdateMaxParticipantsRequest, params: RequestParams = {}) =>
      this.request<SchedulerServiceUpdateMaxParticipantsData, SchedulerServiceUpdateMaxParticipantsError>({
        path: `/web/calendar/scheduler/updateMaxParticipants`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Confirms AIC support for the given property IDs.
     *
     * @tags AicService
     * @name AicServiceConfirmAicSupport
     * @summary Confirm AIC support for properties
     * @request POST:/web/common/aic/confirmSupport
     */
    aicServiceConfirmAicSupport: (body: AicConfirmAicSupportRequest, params: RequestParams = {}) =>
      this.request<AicServiceConfirmAicSupportData, AicServiceConfirmAicSupportError>({
        path: `/web/common/aic/confirmSupport`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates an AIC damage report with name, module object, user, optional Propbase ticket ID, and detailed damage attributes. Returns the created ticket ID.
     *
     * @tags AicService
     * @name AicServiceCreateDamageReport
     * @summary Create a damage report
     * @request POST:/web/common/aic/damageReport/create
     */
    aicServiceCreateDamageReport: (body: AicCreateDamageReportRequest, params: RequestParams = {}) =>
      this.request<AicServiceCreateDamageReportData, AicServiceCreateDamageReportError>({
        path: `/web/common/aic/damageReport/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a document from the given media file and attaches it to the insurance with the specified name and type. Returns the document ID.
     *
     * @tags AicService
     * @name AicServiceCreateDocument
     * @summary Create an insurance document
     * @request POST:/web/common/aic/document/create
     */
    aicServiceCreateDocument: (body: AicCreateDocumentRequest, params: RequestParams = {}) =>
      this.request<AicServiceCreateDocumentData, AicServiceCreateDocumentError>({
        path: `/web/common/aic/document/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Attaches the given media file as an insurance policy document to the specified insurance. Returns the document ID.
     *
     * @tags AicService
     * @name AicServiceAddInsurancePoliceDocument
     * @summary Add an insurance policy document
     * @request POST:/web/common/aic/document/insurancePolice
     */
    aicServiceAddInsurancePoliceDocument: (body: AicAddInsurancePoliceDocumentRequest, params: RequestParams = {}) =>
      this.request<AicServiceAddInsurancePoliceDocumentData, AicServiceAddInsurancePoliceDocumentError>({
        path: `/web/common/aic/document/insurancePolice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Attaches the given media file as an invoice document to the specified insurance. Returns the document ID.
     *
     * @tags AicService
     * @name AicServiceAddInvoiceDocument
     * @summary Add an invoice document
     * @request POST:/web/common/aic/document/invoice
     */
    aicServiceAddInvoiceDocument: (body: AicAddInvoiceDocumentRequest, params: RequestParams = {}) =>
      this.request<AicServiceAddInvoiceDocumentData, AicServiceAddInvoiceDocumentError>({
        path: `/web/common/aic/document/invoice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Attaches the given media file as a loss ratio document to the specified insurance. Returns the document ID.
     *
     * @tags AicService
     * @name AicServiceAddLossRatioDocument
     * @summary Add a loss ratio document
     * @request POST:/web/common/aic/document/lossRatio
     */
    aicServiceAddLossRatioDocument: (body: AicAddLossRatioDocumentRequest, params: RequestParams = {}) =>
      this.request<AicServiceAddLossRatioDocumentData, AicServiceAddLossRatioDocumentError>({
        path: `/web/common/aic/document/lossRatio`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the AIC integration for the given account.
     *
     * @tags AicService
     * @name AicServiceEnableAic
     * @summary Enable or disable AIC
     * @request POST:/web/common/aic/enable
     */
    aicServiceEnableAic: (body: AicEnableAicRequest, params: RequestParams = {}) =>
      this.request<AicServiceEnableAicData, AicServiceEnableAicError>({
        path: `/web/common/aic/enable`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a map of property ID to AIC sync mode for the given account and property IDs.
     *
     * @tags AicService
     * @name AicServiceGetSyncModeForProperties
     * @summary Get AIC sync mode for properties
     * @request POST:/web/common/aic/getSyncModeForProperties
     */
    aicServiceGetSyncModeForProperties: (body: AicGetSyncModeForPropertiesRequest, params: RequestParams = {}) =>
      this.request<AicServiceGetSyncModeForPropertiesData, AicServiceGetSyncModeForPropertiesError>({
        path: `/web/common/aic/getSyncModeForProperties`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a map of account ID to AIC sync mode for the given property.
     *
     * @tags AicService
     * @name AicServiceGetSyncModeForAccountsByPropertyId
     * @summary Get AIC sync modes by property
     * @request GET:/web/common/aic/getSyncModeForProperty/{propertyId}
     */
    aicServiceGetSyncModeForAccountsByPropertyId: (propertyId: string, params: RequestParams = {}) =>
      this.request<AicServiceGetSyncModeForAccountsByPropertyIdData, AicServiceGetSyncModeForAccountsByPropertyIdError>(
        {
          path: `/web/common/aic/getSyncModeForProperty/${propertyId}`,
          method: "GET",
          ...params,
        },
      ),

    /**
     * @description Creates an insurance policy linked to a property (referenceId), including AIC policy ID, type, amounts, excess, and start/end dates. Returns the created insurance.
     *
     * @tags AicService
     * @name AicServiceCreateInsurance
     * @summary Create an AIC insurance
     * @request POST:/web/common/aic/insurance/create
     */
    aicServiceCreateInsurance: (body: AicCreateInsuranceRequest, params: RequestParams = {}) =>
      this.request<AicServiceCreateInsuranceData, AicServiceCreateInsuranceError>({
        path: `/web/common/aic/insurance/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing insurance by ID, including property reference, type, amounts, excess, and start/end dates. Returns the updated insurance.
     *
     * @tags AicService
     * @name AicServiceUpdateInsurance
     * @summary Update an AIC insurance
     * @request POST:/web/common/aic/insurance/{id}/update
     */
    aicServiceUpdateInsurance: (id: string, body: AicServiceUpdateInsurancePayload, params: RequestParams = {}) =>
      this.request<AicServiceUpdateInsuranceData, AicServiceUpdateInsuranceError>({
        path: `/web/common/aic/insurance/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns whether the AIC integration is enabled for the given account.
     *
     * @tags AicService
     * @name AicServiceHasAicEnabled
     * @summary Check if AIC is enabled
     * @request GET:/web/common/aic/isEnabled/{accountId}
     */
    aicServiceHasAicEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<AicServiceHasAicEnabledData, AicServiceHasAicEnabledError>({
        path: `/web/common/aic/isEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the JWT public key in PEM format (base64 encoded) used to verify AIC tokens. The request has no parameters.
     *
     * @tags AicService
     * @name AicServiceGetJwtPublicKey
     * @summary Get AIC JWT public key
     * @request GET:/web/common/aic/jwtPublicKey
     */
    aicServiceGetJwtPublicKey: (params: RequestParams = {}) =>
      this.request<AicServiceGetJwtPublicKeyData, AicServiceGetJwtPublicKeyError>({
        path: `/web/common/aic/jwtPublicKey`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates a note on the given ticket for the specified user, optionally with media attachments. Returns the created note.
     *
     * @tags AicService
     * @name AicServiceCreateNote
     * @summary Create a note on a ticket
     * @request POST:/web/common/aic/note/create
     */
    aicServiceCreateNote: (body: AicCreateNoteRequest, params: RequestParams = {}) =>
      this.request<AicServiceCreateNoteData, AicServiceCreateNoteError>({
        path: `/web/common/aic/note/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets AIC sync modes for properties of the given account using buckets of syncMode and property IDs.
     *
     * @tags AicService
     * @name AicServiceSetSyncModeForProperties
     * @summary Set AIC sync mode for properties
     * @request POST:/web/common/aic/setSyncModeForProperties
     */
    aicServiceSetSyncModeForProperties: (body: AicSetSyncModeForPropertiesRequest, params: RequestParams = {}) =>
      this.request<AicServiceSetSyncModeForPropertiesData, AicServiceSetSyncModeForPropertiesError>({
        path: `/web/common/aic/setSyncModeForProperties`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a single sign-on URL for AIC, targeting the given landing page and optional entity or ticket ID.
     *
     * @tags AicService
     * @name AicServiceGetSsoUrl
     * @summary Get AIC SSO URL
     * @request GET:/web/common/aic/ssoUrl
     */
    aicServiceGetSsoUrl: (query: AicServiceGetSsoUrlParams, params: RequestParams = {}) =>
      this.request<AicServiceGetSsoUrlData, AicServiceGetSsoUrlError>({
        path: `/web/common/aic/ssoUrl`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Activates the given property IDs for Ailean under the specified account.
     *
     * @tags AileanService
     * @name AileanServiceActivateProperties
     * @summary Activate properties for Ailean
     * @request POST:/web/common/ailean/activateProperties
     */
    aileanServiceActivateProperties: (body: AileanActivatePropertiesRequest, params: RequestParams = {}) =>
      this.request<AileanServiceActivatePropertiesData, AileanServiceActivatePropertiesError>({
        path: `/web/common/ailean/activateProperties`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a ticket for the given account using the nested ticket create request and returns the create response.
     *
     * @tags AileanService
     * @name AileanServiceCreateTicket
     * @summary Create an Ailean ticket
     * @request POST:/web/common/ailean/createTicket
     */
    aileanServiceCreateTicket: (body: AileanCreateTicketRequest, params: RequestParams = {}) =>
      this.request<AileanServiceCreateTicketData, AileanServiceCreateTicketError>({
        path: `/web/common/ailean/createTicket`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a comment to the given ticket for the account, optionally with media attachments. When accountInternal is true, the comment is only visible within the account.
     *
     * @tags AileanService
     * @name AileanServiceCreateTicketComment
     * @summary Create a ticket comment
     * @request POST:/web/common/ailean/createTicketComment
     */
    aileanServiceCreateTicketComment: (body: AileanCreateTicketCommentRequest, params: RequestParams = {}) =>
      this.request<AileanServiceCreateTicketCommentData, AileanServiceCreateTicketCommentError>({
        path: `/web/common/ailean/createTicketComment`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deactivates the given property IDs for Ailean under the specified account.
     *
     * @tags AileanService
     * @name AileanServiceDeactivateProperties
     * @summary Deactivate properties for Ailean
     * @request POST:/web/common/ailean/deactivateProperties
     */
    aileanServiceDeactivateProperties: (body: AileanDeactivatePropertiesRequest, params: RequestParams = {}) =>
      this.request<AileanServiceDeactivatePropertiesData, AileanServiceDeactivatePropertiesError>({
        path: `/web/common/ailean/deactivateProperties`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the Ailean integration for the given account.
     *
     * @tags AileanService
     * @name AileanServiceEnableAilean
     * @summary Enable or disable Ailean
     * @request POST:/web/common/ailean/enable
     */
    aileanServiceEnableAilean: (body: AileanEnableAileanRequest, params: RequestParams = {}) =>
      this.request<AileanServiceEnableAileanData, AileanServiceEnableAileanError>({
        path: `/web/common/ailean/enable`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns tenants for the given account, including contact details and their contracts with object, building, and property context.
     *
     * @tags AileanService
     * @name AileanServiceGetTenantsByAccountId
     * @summary Get tenants by account ID
     * @request GET:/web/common/ailean/getTenantsByAccountId/{accountId}
     */
    aileanServiceGetTenantsByAccountId: (accountId: string, params: RequestParams = {}) =>
      this.request<AileanServiceGetTenantsByAccountIdData, AileanServiceGetTenantsByAccountIdError>({
        path: `/web/common/ailean/getTenantsByAccountId/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the ticket identified by the given ticket ID.
     *
     * @tags AileanService
     * @name AileanServiceGetTicket
     * @summary Get an Ailean ticket
     * @request GET:/web/common/ailean/getTicket/{ticketId}
     */
    aileanServiceGetTicket: (ticketId: string, params: RequestParams = {}) =>
      this.request<AileanServiceGetTicketData, AileanServiceGetTicketError>({
        path: `/web/common/ailean/getTicket/${ticketId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the Ailean integration is enabled for the given account.
     *
     * @tags AileanService
     * @name AileanServiceHasAileanEnabled
     * @summary Check if Ailean is enabled
     * @request GET:/web/common/ailean/isEnabled/{accountId}
     */
    aileanServiceHasAileanEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<AileanServiceHasAileanEnabledData, AileanServiceHasAileanEnabledError>({
        path: `/web/common/ailean/isEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the JWT public key in PEM format (base64 encoded) used to verify Ailean tokens. The request has no parameters.
     *
     * @tags AileanService
     * @name AileanServiceGetJwtPublicKey
     * @summary Get Ailean JWT public key
     * @request GET:/web/common/ailean/jwtPublicKey
     */
    aileanServiceGetJwtPublicKey: (params: RequestParams = {}) =>
      this.request<AileanServiceGetJwtPublicKeyData, AileanServiceGetJwtPublicKeyError>({
        path: `/web/common/ailean/jwtPublicKey`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns employees for the given account with name, email, and roles.
     *
     * @tags AileanService
     * @name AileanServiceListEmployeesByAccountId
     * @summary List employees by account ID
     * @request GET:/web/common/ailean/listEmployeesByAccountId/{accountId}
     */
    aileanServiceListEmployeesByAccountId: (accountId: string, params: RequestParams = {}) =>
      this.request<AileanServiceListEmployeesByAccountIdData, AileanServiceListEmployeesByAccountIdError>({
        path: `/web/common/ailean/listEmployeesByAccountId/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns properties for the given account, including address, linked contacts, and the admin assignee.
     *
     * @tags AileanService
     * @name AileanServiceListPropertiesByAccountId
     * @summary List properties by account ID
     * @request GET:/web/common/ailean/listPropertiesByAccountId/{accountId}
     */
    aileanServiceListPropertiesByAccountId: (accountId: string, params: RequestParams = {}) =>
      this.request<AileanServiceListPropertiesByAccountIdData, AileanServiceListPropertiesByAccountIdError>({
        path: `/web/common/ailean/listPropertiesByAccountId/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns activation entries (accountId and propertyId) for the given property IDs. Properties missing from the response are not activated.
     *
     * @tags AileanService
     * @name AileanServiceListPropertyActivations
     * @summary List Ailean property activations
     * @request POST:/web/common/ailean/listPropertyActivations
     */
    aileanServiceListPropertyActivations: (body: AileanListPropertyActivationsRequest, params: RequestParams = {}) =>
      this.request<AileanServiceListPropertyActivationsData, AileanServiceListPropertyActivationsError>({
        path: `/web/common/ailean/listPropertyActivations`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all comments for the given ticket.
     *
     * @tags AileanService
     * @name AileanServiceListTicketComments
     * @summary List ticket comments
     * @request GET:/web/common/ailean/listTicketComments/{ticketId}
     */
    aileanServiceListTicketComments: (ticketId: string, params: RequestParams = {}) =>
      this.request<AileanServiceListTicketCommentsData, AileanServiceListTicketCommentsError>({
        path: `/web/common/ailean/listTicketComments/${ticketId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a single sign-on URL for accessing Ailean. The request has no parameters.
     *
     * @tags AileanService
     * @name AileanServiceGetSsoUrl
     * @summary Get Ailean SSO URL
     * @request GET:/web/common/ailean/ssoUrl
     */
    aileanServiceGetSsoUrl: (params: RequestParams = {}) =>
      this.request<AileanServiceGetSsoUrlData, AileanServiceGetSsoUrlError>({
        path: `/web/common/ailean/ssoUrl`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates an existing ticket using the nested ticket update request and returns the update response.
     *
     * @tags AileanService
     * @name AileanServiceUpdateTicket
     * @summary Update an Ailean ticket
     * @request POST:/web/common/ailean/updateTicket
     */
    aileanServiceUpdateTicket: (body: AileanUpdateTicketRequest, params: RequestParams = {}) =>
      this.request<AileanServiceUpdateTicketData, AileanServiceUpdateTicketError>({
        path: `/web/common/ailean/updateTicket`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the certificate bytes for the given order ID.
     *
     * @tags CredittrustService
     * @name CredittrustServiceGetCertificate
     * @summary Get a credit certificate
     * @request GET:/web/common/credittrust/getCertificate
     */
    credittrustServiceGetCertificate: (query: CredittrustServiceGetCertificateParams, params: RequestParams = {}) =>
      this.request<CredittrustServiceGetCertificateData, CredittrustServiceGetCertificateError>({
        path: `/web/common/credittrust/getCertificate`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Orders a credit certificate for the given person (name, email, address, date of birth, and optional previous address and affiliate data). Returns whether a certificate is issuable, the order ID, and CRIF/Intrum match and approval flags.
     *
     * @tags CredittrustService
     * @name CredittrustServiceOrderCertificate
     * @summary Order a credit certificate
     * @request POST:/web/common/credittrust/orderCertificate
     */
    credittrustServiceOrderCertificate: (body: CredittrustOrderCertificateRequest, params: RequestParams = {}) =>
      this.request<CredittrustServiceOrderCertificateData, CredittrustServiceOrderCertificateError>({
        path: `/web/common/credittrust/orderCertificate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Verifies the given certificate and returns issuer verification details plus the identified person's name and date of birth.
     *
     * @tags CredittrustService
     * @name CredittrustServiceVerifyCertificate
     * @summary Verify a credit certificate
     * @request POST:/web/common/credittrust/verifyCertificate
     */
    credittrustServiceVerifyCertificate: (body: CredittrustVerifyCertificateRequest, params: RequestParams = {}) =>
      this.request<CredittrustServiceVerifyCertificateData, CredittrustServiceVerifyCertificateError>({
        path: `/web/common/credittrust/verifyCertificate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Checks whether processing has finished for the Deepo file transmission identified by fileTransmissionId.
     *
     * @tags DeepoService
     * @name DeepoServiceAnalyseNodeStatus
     * @summary Analyse Deepo node status
     * @request GET:/web/common/deepo/analyseNodeStatus/{fileTransmissionId}
     */
    deepoServiceAnalyseNodeStatus: (fileTransmissionId: string, params: RequestParams = {}) =>
      this.request<DeepoServiceAnalyseNodeStatusData, DeepoServiceAnalyseNodeStatusError>({
        path: `/web/common/deepo/analyseNodeStatus/${fileTransmissionId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns Deepo file transmissions associated with the given reference ID.
     *
     * @tags DeepoService
     * @name DeepoServiceGetFileTransmissionsByReferenceId
     * @summary Get file transmissions by reference ID
     * @request GET:/web/common/deepo/getFileTransmissionsByReferenceId/{referenceId}
     */
    deepoServiceGetFileTransmissionsByReferenceId: (referenceId: string, params: RequestParams = {}) =>
      this.request<
        DeepoServiceGetFileTransmissionsByReferenceIdData,
        DeepoServiceGetFileTransmissionsByReferenceIdError
      >({
        path: `/web/common/deepo/getFileTransmissionsByReferenceId/${referenceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the Deepo partner access URL for the given account.
     *
     * @tags DeepoService
     * @name DeepoServiceGetPartnerAccessUrl
     * @summary Get partner access URL
     * @request GET:/web/common/deepo/getPartnerAccessUrl
     */
    deepoServiceGetPartnerAccessUrl: (query: DeepoServiceGetPartnerAccessUrlParams, params: RequestParams = {}) =>
      this.request<DeepoServiceGetPartnerAccessUrlData, DeepoServiceGetPartnerAccessUrlError>({
        path: `/web/common/deepo/getPartnerAccessUrl`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns whether Deepo is enabled for the given account.
     *
     * @tags DeepoService
     * @name DeepoServiceHasDeepoEnabled
     * @summary Check if Deepo is enabled
     * @request GET:/web/common/deepo/isEnabled
     */
    deepoServiceHasDeepoEnabled: (query: DeepoServiceHasDeepoEnabledParams, params: RequestParams = {}) =>
      this.request<DeepoServiceHasDeepoEnabledData, DeepoServiceHasDeepoEnabledError>({
        path: `/web/common/deepo/isEnabled`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Attempts to repair the Deepo service account for the given account ID. Returns success and an optional message.
     *
     * @tags DeepoService
     * @name DeepoServiceRepairServiceAccount
     * @summary Repair Deepo service account
     * @request POST:/web/common/deepo/repairServiceAccount
     */
    deepoServiceRepairServiceAccount: (body: DeepoRepairServiceAccountRequest, params: RequestParams = {}) =>
      this.request<DeepoServiceRepairServiceAccountData, DeepoServiceRepairServiceAccountError>({
        path: `/web/common/deepo/repairServiceAccount`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends the given media ID to Deepo with optional reference IDs. Returns the created file transmission.
     *
     * @tags DeepoService
     * @name DeepoServiceSendFile
     * @summary Send a file to Deepo
     * @request POST:/web/common/deepo/sendFile
     */
    deepoServiceSendFile: (body: DeepoSendFileRequest, params: RequestParams = {}) =>
      this.request<DeepoServiceSendFileData, DeepoServiceSendFileError>({
        path: `/web/common/deepo/sendFile`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of open (incomplete and not cancelled) Deepsign signature requests for the given account.
     *
     * @tags DeepsignService
     * @name DeepsignServiceCountOpenSignRequests
     * @summary Count open sign requests
     * @request GET:/web/common/deepsign/countOpenSignRequests/{accountId}
     */
    deepsignServiceCountOpenSignRequests: (accountId: string, params: RequestParams = {}) =>
      this.request<DeepsignServiceCountOpenSignRequestsData, DeepsignServiceCountOpenSignRequestsError>({
        path: `/web/common/deepsign/countOpenSignRequests/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the Deepsign partner access URL for the given account.
     *
     * @tags DeepsignService
     * @name DeepsignServiceGetPartnerAccessUrl
     * @summary Get partner access URL
     * @request GET:/web/common/deepsign/getPartnerAccessUrl
     */
    deepsignServiceGetPartnerAccessUrl: (query: DeepsignServiceGetPartnerAccessUrlParams, params: RequestParams = {}) =>
      this.request<DeepsignServiceGetPartnerAccessUrlData, DeepsignServiceGetPartnerAccessUrlError>({
        path: `/web/common/deepsign/getPartnerAccessUrl`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns whether Deepsign document signature is enabled for the given account.
     *
     * @tags DeepsignService
     * @name DeepsignServiceHasDocumentSignatureEnabled
     * @summary Check if document signature is enabled
     * @request GET:/web/common/deepsign/isEnabled
     */
    deepsignServiceHasDocumentSignatureEnabled: (
      query: DeepsignServiceHasDocumentSignatureEnabledParams,
      params: RequestParams = {},
    ) =>
      this.request<DeepsignServiceHasDocumentSignatureEnabledData, DeepsignServiceHasDocumentSignatureEnabledError>({
        path: `/web/common/deepsign/isEnabled`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns all Deepsign signature requests for the given account.
     *
     * @tags DeepsignService
     * @name DeepsignServiceListSignRequests
     * @summary List sign requests
     * @request GET:/web/common/deepsign/listSignRequests
     */
    deepsignServiceListSignRequests: (query: DeepsignServiceListSignRequestsParams, params: RequestParams = {}) =>
      this.request<DeepsignServiceListSignRequestsData, DeepsignServiceListSignRequestsError>({
        path: `/web/common/deepsign/listSignRequests`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns Deepsign signature requests that are attached to any of the given reference IDs.
     *
     * @tags DeepsignService
     * @name DeepsignServiceListSignRequestsByAttachToReferenceIds
     * @summary List sign requests by attach-to reference IDs
     * @request POST:/web/common/deepsign/listSignRequestsByAttachToReferenceIds
     */
    deepsignServiceListSignRequestsByAttachToReferenceIds: (
      body: DeepsignListSignRequestsByAttachToReferenceIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        DeepsignServiceListSignRequestsByAttachToReferenceIdsData,
        DeepsignServiceListSignRequestsByAttachToReferenceIdsError
      >({
        path: `/web/common/deepsign/listSignRequestsByAttachToReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a Deepsign signature request for the given account using the supplied media IDs, signers, legal weight, and optional note and attach-to reference IDs. Returns the created sign request.
     *
     * @tags DeepsignService
     * @name DeepsignServiceSignDocument
     * @summary Sign a document
     * @request POST:/web/common/deepsign/signDocument
     */
    deepsignServiceSignDocument: (body: DeepsignSignDocumentRequest, params: RequestParams = {}) =>
      this.request<DeepsignServiceSignDocumentData, DeepsignServiceSignDocumentError>({
        path: `/web/common/deepsign/signDocument`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Cancels the Deepsign signature request identified by ID. An optional cancellation message may be supplied.
     *
     * @tags DeepsignService
     * @name DeepsignServiceCancelSignRequest
     * @summary Cancel a sign request
     * @request POST:/web/common/deepsign/{id}/cancel
     */
    deepsignServiceCancelSignRequest: (
      { id, ...query }: DeepsignServiceCancelSignRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<DeepsignServiceCancelSignRequestData, DeepsignServiceCancelSignRequestError>({
        path: `/web/common/deepsign/${id}/cancel`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Downloads the PDF for the Deepsign signature request identified by ID.
     *
     * @tags DeepsignService
     * @name DeepsignServiceDownloadFile
     * @summary Download signed file
     * @request GET:/web/common/deepsign/{id}/downloadFile
     */
    deepsignServiceDownloadFile: (id: string, params: RequestParams = {}) =>
      this.request<DeepsignServiceDownloadFileData, DeepsignServiceDownloadFileError>({
        path: `/web/common/deepsign/${id}/downloadFile`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Enables or disables the Evorest integration for the given account, including API key and whether Swiss Caution is allowed.
     *
     * @tags EvorestService
     * @name EvorestServiceEnable
     * @summary Enable or disable Evorest
     * @request POST:/web/common/evorest/enable/{accountId}
     */
    evorestServiceEnable: (accountId: string, body: EvorestServiceEnablePayload, params: RequestParams = {}) =>
      this.request<EvorestServiceEnableData, EvorestServiceEnableError>({
        path: `/web/common/evorest/enable/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns Evorest settings for the given account: enabled flag, allowInvestment, API key, and whether Swiss Caution is allowed.
     *
     * @tags EvorestService
     * @name EvorestServiceGetAccountSettings
     * @summary Get Evorest account settings
     * @request GET:/web/common/evorest/getAccountSettings/{accountId}
     */
    evorestServiceGetAccountSettings: (accountId: string, params: RequestParams = {}) =>
      this.request<EvorestServiceGetAccountSettingsData, EvorestServiceGetAccountSettingsError>({
        path: `/web/common/evorest/getAccountSettings/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the given tenancy has an open Evorest deposit and the Evorest link when available.
     *
     * @tags EvorestService
     * @name EvorestServiceGetDepositInfo
     * @summary Get Evorest deposit info
     * @request GET:/web/common/evorest/getDepositInfo/{tenancyId}
     */
    evorestServiceGetDepositInfo: (tenancyId: string, params: RequestParams = {}) =>
      this.request<EvorestServiceGetDepositInfoData, EvorestServiceGetDepositInfoError>({
        path: `/web/common/evorest/getDepositInfo/${tenancyId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the Evorest owner configuration for the given account, including the allowInvestment applicability setting.
     *
     * @tags EvorestService
     * @name EvorestServiceGetOwnerConfig
     * @summary Get Evorest owner config
     * @request GET:/web/common/evorest/getOwnerConfig/{accountId}
     */
    evorestServiceGetOwnerConfig: (accountId: string, params: RequestParams = {}) =>
      this.request<EvorestServiceGetOwnerConfigData, EvorestServiceGetOwnerConfigError>({
        path: `/web/common/evorest/getOwnerConfig/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether Evorest is enabled for the given account and whether Swiss Caution is allowed.
     *
     * @tags EvorestService
     * @name EvorestServiceHasEnabled
     * @summary Check if Evorest is enabled
     * @request GET:/web/common/evorest/hasEnabled/{accountId}
     */
    evorestServiceHasEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<EvorestServiceHasEnabledData, EvorestServiceHasEnabledError>({
        path: `/web/common/evorest/hasEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Opens an Evorest rental deposit for the given object and tenancy. Optionally allows investment and requires contactPersonId when the tenant is a company.
     *
     * @tags EvorestService
     * @name EvorestServiceOpenDeposit
     * @summary Open an Evorest deposit
     * @request POST:/web/common/evorest/openDeposit
     */
    evorestServiceOpenDeposit: (body: CommonevorestOpenDepositRequest, params: RequestParams = {}) =>
      this.request<EvorestServiceOpenDepositData, EvorestServiceOpenDepositError>({
        path: `/web/common/evorest/openDeposit`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the owner configuration for the given account, including the allowInvestment applicability setting.
     *
     * @tags EvorestService
     * @name EvorestServiceSetOwnerConfig
     * @summary Set Evorest owner config
     * @request POST:/web/common/evorest/setOwnerConfig/{accountId}
     */
    evorestServiceSetOwnerConfig: (
      accountId: string,
      body: EvorestServiceSetOwnerConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvorestServiceSetOwnerConfigData, EvorestServiceSetOwnerConfigError>({
        path: `/web/common/evorest/setOwnerConfig/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the Firstcaution integration for the given account.
     *
     * @tags FirstcautionService
     * @name FirstcautionServiceEnable
     * @summary Enable or disable Firstcaution
     * @request POST:/web/common/firstcaution/enable/{accountId}
     */
    firstcautionServiceEnable: (
      accountId: string,
      body: {
        enable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FirstcautionServiceEnableData, FirstcautionServiceEnableError>({
        path: `/web/common/firstcaution/enable/${accountId}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns whether the given tenancy has an open Firstcaution deposit and the Firstcaution link when available.
     *
     * @tags FirstcautionService
     * @name FirstcautionServiceGetDepositInfo
     * @summary Get Firstcaution deposit info
     * @request GET:/web/common/firstcaution/getDepositInfo/{tenancyId}
     */
    firstcautionServiceGetDepositInfo: (tenancyId: string, params: RequestParams = {}) =>
      this.request<FirstcautionServiceGetDepositInfoData, FirstcautionServiceGetDepositInfoError>({
        path: `/web/common/firstcaution/getDepositInfo/${tenancyId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the Firstcaution integration is enabled for the given account.
     *
     * @tags FirstcautionService
     * @name FirstcautionServiceHasEnabled
     * @summary Check if Firstcaution is enabled
     * @request GET:/web/common/firstcaution/hasEnabled/{accountId}
     */
    firstcautionServiceHasEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<FirstcautionServiceHasEnabledData, FirstcautionServiceHasEnabledError>({
        path: `/web/common/firstcaution/hasEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Opens a Firstcaution rental deposit for the given object and tenancy. contactPersonId is required when the tenant is a company.
     *
     * @tags FirstcautionService
     * @name FirstcautionServiceOpenDeposit
     * @summary Open a Firstcaution deposit
     * @request POST:/web/common/firstcaution/openDeposit
     */
    firstcautionServiceOpenDeposit: (body: CommonfirstcautionOpenDepositRequest, params: RequestParams = {}) =>
      this.request<FirstcautionServiceOpenDepositData, FirstcautionServiceOpenDepositError>({
        path: `/web/common/firstcaution/openDeposit`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the Gocaution integration for the given account, including client ID, client secret, and login URL.
     *
     * @tags GocautionService
     * @name GocautionServiceEnable
     * @summary Enable or disable Gocaution
     * @request POST:/web/common/gocaution/enable/{accountId}
     */
    gocautionServiceEnable: (accountId: string, body: GocautionServiceEnablePayload, params: RequestParams = {}) =>
      this.request<GocautionServiceEnableData, GocautionServiceEnableError>({
        path: `/web/common/gocaution/enable/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns Gocaution settings for the given account: enabled flag, login URL, and client credentials (credentials only for platform employees).
     *
     * @tags GocautionService
     * @name GocautionServiceGetAccountSettings
     * @summary Get Gocaution account settings
     * @request GET:/web/common/gocaution/getAccountSettings/{accountId}
     */
    gocautionServiceGetAccountSettings: (accountId: string, params: RequestParams = {}) =>
      this.request<GocautionServiceGetAccountSettingsData, GocautionServiceGetAccountSettingsError>({
        path: `/web/common/gocaution/getAccountSettings/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the given tenancy has an open Gocaution deposit and the Gocaution link when available.
     *
     * @tags GocautionService
     * @name GocautionServiceGetDepositInfo
     * @summary Get Gocaution deposit info
     * @request GET:/web/common/gocaution/getDepositInfo/{tenancyId}
     */
    gocautionServiceGetDepositInfo: (tenancyId: string, params: RequestParams = {}) =>
      this.request<GocautionServiceGetDepositInfoData, GocautionServiceGetDepositInfoError>({
        path: `/web/common/gocaution/getDepositInfo/${tenancyId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the Gocaution integration is enabled for the given account.
     *
     * @tags GocautionService
     * @name GocautionServiceHasEnabled
     * @summary Check if Gocaution is enabled
     * @request GET:/web/common/gocaution/hasEnabled/{accountId}
     */
    gocautionServiceHasEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<GocautionServiceHasEnabledData, GocautionServiceHasEnabledError>({
        path: `/web/common/gocaution/hasEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Opens a Gocaution rental deposit for the given object and tenancy. contactPersonId is required when the tenant is a company.
     *
     * @tags GocautionService
     * @name GocautionServiceOpenDeposit
     * @summary Open a Gocaution deposit
     * @request POST:/web/common/gocaution/openDeposit
     */
    gocautionServiceOpenDeposit: (body: CommongocautionOpenDepositRequest, params: RequestParams = {}) =>
      this.request<GocautionServiceOpenDepositData, GocautionServiceOpenDepositError>({
        path: `/web/common/gocaution/openDeposit`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Exchanges client credentials (client_id, client_secret, and audience) for an OAuth access token. Returns the access token, scope, expires_in, and token_type.
     *
     * @tags M2MService
     * @name M2MServiceGetToken
     * @summary Get machine-to-machine access token
     * @request POST:/web/common/m2m/oauth/token
     */
    m2MServiceGetToken: (body: Commonm2MGetTokenRequest, params: RequestParams = {}) =>
      this.request<M2MServiceGetTokenData, M2MServiceGetTokenError>({
        path: `/web/common/m2m/oauth/token`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a note for the given owner with reference IDs, text, optional media IDs, mentions, and account-internal flag. Returns the created note.
     *
     * @tags NoteService
     * @name NoteServiceCreate
     * @summary Create a note
     * @request POST:/web/common/note/create
     */
    noteServiceCreate: (body: CommonnoteCreateRequest, params: RequestParams = {}) =>
      this.request<NoteServiceCreateData, NoteServiceCreateError>({
        path: `/web/common/note/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a note from the given mail ID for the owner, with reference IDs and optional account-internal flag. Returns the created note.
     *
     * @tags NoteService
     * @name NoteServiceCreateFromMail
     * @summary Create a note from mail
     * @request POST:/web/common/note/createFromMail
     */
    noteServiceCreateFromMail: (body: NoteCreateFromMailRequest, params: RequestParams = {}) =>
      this.request<NoteServiceCreateFromMailData, NoteServiceCreateFromMailError>({
        path: `/web/common/note/createFromMail`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a note from an unregistered creator identified by name and email, with reference IDs, text, and optional media IDs. Returns the created note.
     *
     * @tags NoteService
     * @name NoteServiceCreateUnregistered
     * @summary Create a note as unregistered user
     * @request POST:/web/common/note/createUnregistered
     */
    noteServiceCreateUnregistered: (body: NoteCreateUnregisteredRequest, params: RequestParams = {}) =>
      this.request<NoteServiceCreateUnregisteredData, NoteServiceCreateUnregisteredError>({
        path: `/web/common/note/createUnregistered`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the note identified by the given ID.
     *
     * @tags NoteService
     * @name NoteServiceDelete
     * @summary Delete a note
     * @request DELETE:/web/common/note/delete/{id}
     */
    noteServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<NoteServiceDeleteData, NoteServiceDeleteError>({
        path: `/web/common/note/delete/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns all notes linked to any of the given reference IDs.
     *
     * @tags NoteService
     * @name NoteServiceListByReferenceIds
     * @summary List notes by reference IDs
     * @request POST:/web/common/note/listByReferenceIds
     */
    noteServiceListByReferenceIds: (body: CommonnoteListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<NoteServiceListByReferenceIdsData, NoteServiceListByReferenceIdsError>({
        path: `/web/common/note/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the note text, media IDs, and mentions for the given note ID. Returns the updated note.
     *
     * @tags NoteService
     * @name NoteServiceUpdate
     * @summary Update a note
     * @request POST:/web/common/note/{id}/update
     */
    noteServiceUpdate: (id: string, body: NoteServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<NoteServiceUpdateData, NoteServiceUpdateError>({
        path: `/web/common/note/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the authenticated caller's Nylas grant configuration (id, account, user, email, provider, and scopes). The request has no parameters.
     *
     * @tags NylasAuthService
     * @name NylasAuthServiceGetMyConfig
     * @summary Get my Nylas config
     * @request GET:/web/common/nylas-auth/config
     */
    nylasAuthServiceGetMyConfig: (params: RequestParams = {}) =>
      this.request<NylasAuthServiceGetMyConfigData, NylasAuthServiceGetMyConfigError>({
        path: `/web/common/nylas-auth/config`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Starts the Nylas OAuth flow for the requested scopes and initial URL. Returns the authentication URL to redirect the user to.
     *
     * @tags NylasAuthService
     * @name NylasAuthServiceStartAuth
     * @summary Start Nylas authentication
     * @request GET:/web/common/nylas-auth/startAuth
     */
    nylasAuthServiceStartAuth: (query: NylasAuthServiceStartAuthParams, params: RequestParams = {}) =>
      this.request<NylasAuthServiceStartAuthData, NylasAuthServiceStartAuthError>({
        path: `/web/common/nylas-auth/startAuth`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Unlinks the authenticated caller's Nylas grant. The request has no parameters.
     *
     * @tags NylasAuthService
     * @name NylasAuthServiceUnlink
     * @summary Unlink Nylas grant
     * @request POST:/web/common/nylas-auth/unlink
     */
    nylasAuthServiceUnlink: (body: NylasAuthUnlinkRequest, params: RequestParams = {}) =>
      this.request<NylasAuthServiceUnlinkData, NylasAuthServiceUnlinkError>({
        path: `/web/common/nylas-auth/unlink`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns city and state entries for the given zip code.
     *
     * @tags ZipService
     * @name ZipServiceGetInfo
     * @summary Get zip code info
     * @request GET:/web/common/zip/{zip}
     */
    zipServiceGetInfo: (zip: string, params: RequestParams = {}) =>
      this.request<ZipServiceGetInfoData, ZipServiceGetInfoError>({
        path: `/web/common/zip/${zip}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the 3CX API key stored for the given account.
     *
     * @tags TelephoneService
     * @name TelephoneServiceGet3CxApiKey
     * @summary Get 3CX API key
     * @request GET:/web/contact/telephone/{accountId}/get3CXApiKey
     */
    telephoneServiceGet3CxApiKey: (accountId: string, params: RequestParams = {}) =>
      this.request<TelephoneServiceGet3CxApiKeyData, TelephoneServiceGet3CxApiKeyError>({
        path: `/web/contact/telephone/${accountId}/get3CXApiKey`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Stores the 3CX API key for the given account.
     *
     * @tags TelephoneService
     * @name TelephoneServiceSet3CxApiKey
     * @summary Set 3CX API key
     * @request POST:/web/contact/telephone/{accountId}/set3CXApiKey
     */
    telephoneServiceSet3CxApiKey: (
      accountId: string,
      body: TelephoneServiceSet3CxApiKeyPayload,
      params: RequestParams = {},
    ) =>
      this.request<TelephoneServiceSet3CxApiKeyData, TelephoneServiceSet3CxApiKeyError>({
        path: `/web/contact/telephone/${accountId}/set3CXApiKey`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Activates the contacts with the given IDs.
     *
     * @tags ContactService
     * @name ContactServiceActivate
     * @summary Activate contacts
     * @request POST:/web/v2/contact/activate
     */
    contactServiceActivate: (body: Contactv2ActivateRequest, params: RequestParams = {}) =>
      this.request<ContactServiceActivateData, ContactServiceActivateError>({
        path: `/web/v2/contact/activate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new activity with employee contact, related contact IDs, timestamp, subject, text, document IDs, and reference IDs. Returns the created activity.
     *
     * @tags ActivityService
     * @name ActivityServiceCreateMixin5
     * @summary Create an activity
     * @request POST:/web/v2/contact/activity/create
     */
    activityServiceCreateMixin5: (body: Contactactivityv2CreateRequest, params: RequestParams = {}) =>
      this.request<ActivityServiceCreateMixin5Data, ActivityServiceCreateMixin5Error>({
        path: `/web/v2/contact/activity/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the activity with the given ID.
     *
     * @tags ActivityService
     * @name ActivityServiceDeleteMixin5
     * @summary Delete an activity
     * @request DELETE:/web/v2/contact/activity/delete/{id}
     */
    activityServiceDeleteMixin5: (id: string, params: RequestParams = {}) =>
      this.request<ActivityServiceDeleteMixin5Data, ActivityServiceDeleteMixin5Error>({
        path: `/web/v2/contact/activity/delete/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the activity identified by the given ID.
     *
     * @tags ActivityService
     * @name ActivityServiceGetMixin5
     * @summary Get an activity by ID
     * @request GET:/web/v2/contact/activity/get/{id}
     */
    activityServiceGetMixin5: (id: string, params: RequestParams = {}) =>
      this.request<ActivityServiceGetMixin5Data, ActivityServiceGetMixin5Error>({
        path: `/web/v2/contact/activity/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns activities linked to any of the given contact IDs.
     *
     * @tags ActivityService
     * @name ActivityServiceListByContactIds
     * @summary List activities by contact IDs
     * @request POST:/web/v2/contact/activity/listByContactIds
     */
    activityServiceListByContactIds: (body: Activityv2ListByContactIdsRequest, params: RequestParams = {}) =>
      this.request<ActivityServiceListByContactIdsData, ActivityServiceListByContactIdsError>({
        path: `/web/v2/contact/activity/listByContactIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns activities linked to any of the given reference IDs.
     *
     * @tags ActivityService
     * @name ActivityServiceListByReferenceIdsMixin5
     * @summary List activities by reference IDs
     * @request POST:/web/v2/contact/activity/listByReferenceIds
     */
    activityServiceListByReferenceIdsMixin5: (body: Activityv2ListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<ActivityServiceListByReferenceIdsMixin5Data, ActivityServiceListByReferenceIdsMixin5Error>({
        path: `/web/v2/contact/activity/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing activity by ID. Accepts employee contact, related contact IDs, timestamp, subject, text, document IDs, and reference IDs.
     *
     * @tags ActivityService
     * @name ActivityServiceUpdateMixin5
     * @summary Update an activity
     * @request POST:/web/v2/contact/activity/update/{id}
     */
    activityServiceUpdateMixin5: (id: string, body: ActivityServiceUpdateMixin5Payload, params: RequestParams = {}) =>
      this.request<ActivityServiceUpdateMixin5Data, ActivityServiceUpdateMixin5Error>({
        path: `/web/v2/contact/activity/update/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Finds potential duplicate person or company contacts for the given owner using emails, phone numbers, name, first name, and address. Set isCompany to search company duplicates; name is company name or person last name accordingly.
     *
     * @tags ContactService
     * @name ContactServiceCheckDuplicates
     * @summary Check for duplicate contacts
     * @request POST:/web/v2/contact/checkDuplicates
     */
    contactServiceCheckDuplicates: (body: V2CheckDuplicatesRequest, params: RequestParams = {}) =>
      this.request<ContactServiceCheckDuplicatesData, ContactServiceCheckDuplicatesError>({
        path: `/web/v2/contact/checkDuplicates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Copies contacts from sourceAccountId to targetTargetId.
     *
     * @tags ContactService
     * @name ContactServiceCopyContacts
     * @summary Copy contacts between accounts
     * @request POST:/web/v2/contact/copy
     */
    contactServiceCopyContacts: (body: V2CopyContactsRequest, params: RequestParams = {}) =>
      this.request<ContactServiceCopyContactsData, ContactServiceCopyContactsError>({
        path: `/web/v2/contact/copy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new company contact for the given owner. Accepts name, email, phone numbers, address, types, industries, VAT number, legal form, tags, and portal/serial-email flags. Optional numericId may be supplied. Returns the created company.
     *
     * @tags ContactService
     * @name ContactServiceCreateCompany
     * @summary Create a company contact
     * @request POST:/web/v2/contact/createCompany
     */
    contactServiceCreateCompany: (body: V2CreateCompanyRequest, params: RequestParams = {}) =>
      this.request<ContactServiceCreateCompanyData, ContactServiceCreateCompanyError>({
        path: `/web/v2/contact/createCompany`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new person contact for the given owner. Accepts personal details, email, phone numbers, address, employment, types, industries, documents, tags, and preferred communication settings. Optional numericId may be supplied. Returns the created person.
     *
     * @tags ContactService
     * @name ContactServiceCreatePerson
     * @summary Create a person contact
     * @request POST:/web/v2/contact/createPerson
     */
    contactServiceCreatePerson: (body: V2CreatePersonRequest, params: RequestParams = {}) =>
      this.request<ContactServiceCreatePersonData, ContactServiceCreatePersonError>({
        path: `/web/v2/contact/createPerson`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deactivates the contacts with the given IDs.
     *
     * @tags ContactService
     * @name ContactServiceDeactivate
     * @summary Deactivate contacts
     * @request POST:/web/v2/contact/deactivate
     */
    contactServiceDeactivate: (body: Contactv2DeactivateRequest, params: RequestParams = {}) =>
      this.request<ContactServiceDeactivateData, ContactServiceDeactivateError>({
        path: `/web/v2/contact/deactivate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the contacts with the given IDs.
     *
     * @tags ContactService
     * @name ContactServiceDelete
     * @summary Delete contacts
     * @request DELETE:/web/v2/contact/delete/{ids}
     */
    contactServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<ContactServiceDeleteData, ContactServiceDeleteError>({
        path: `/web/v2/contact/delete/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Duplicates the contacts with the given IDs under targetOwnerId. Returns the duplicated persons and companies.
     *
     * @tags ContactService
     * @name ContactServiceDuplicateContacts
     * @summary Duplicate contacts to an owner
     * @request POST:/web/v2/contact/duplicate
     */
    contactServiceDuplicateContacts: (body: V2DuplicateContactsRequest, params: RequestParams = {}) =>
      this.request<ContactServiceDuplicateContactsData, ContactServiceDuplicateContactsError>({
        path: `/web/v2/contact/duplicate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the person or company contact that represents the given account as an owner.
     *
     * @tags ContactService
     * @name ContactServiceGetOwnerContact
     * @summary Get owner contact for an account
     * @request GET:/web/v2/contact/getOwnerContact/{accountId}
     */
    contactServiceGetOwnerContact: (accountId: string, params: RequestParams = {}) =>
      this.request<ContactServiceGetOwnerContactData, ContactServiceGetOwnerContactError>({
        path: `/web/v2/contact/getOwnerContact/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the distinct tags already used on contacts for the given account.
     *
     * @tags ContactService
     * @name ContactServiceGetUsedTags
     * @summary Get used contact tags
     * @request GET:/web/v2/contact/getUsedTags/{accountId}
     */
    contactServiceGetUsedTags: (accountId: string, params: RequestParams = {}) =>
      this.request<ContactServiceGetUsedTagsData, ContactServiceGetUsedTagsError>({
        path: `/web/v2/contact/getUsedTags/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates relation links between company contacts using the given relations.
     *
     * @tags ContactService
     * @name ContactServiceLinkCompanies
     * @summary Link company contacts
     * @request POST:/web/v2/contact/linkCompanies
     */
    contactServiceLinkCompanies: (body: V2LinkCompaniesRequest, params: RequestParams = {}) =>
      this.request<ContactServiceLinkCompaniesData, ContactServiceLinkCompaniesError>({
        path: `/web/v2/contact/linkCompanies`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates relation links between person contacts using the given relations.
     *
     * @tags ContactService
     * @name ContactServiceLinkPersons
     * @summary Link person contacts
     * @request POST:/web/v2/contact/linkPersons
     */
    contactServiceLinkPersons: (body: V2LinkPersonsRequest, params: RequestParams = {}) =>
      this.request<ContactServiceLinkPersonsData, ContactServiceLinkPersonsError>({
        path: `/web/v2/contact/linkPersons`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all person and company contacts belonging to the given owner account ID.
     *
     * @tags ContactService
     * @name ContactServiceList
     * @summary List contacts for an owner
     * @request GET:/web/v2/contact/list/{ownerId}
     */
    contactServiceList: (ownerId: string, params: RequestParams = {}) =>
      this.request<ContactServiceListData, ContactServiceListError>({
        path: `/web/v2/contact/list/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns person contacts of type employee belonging to the given owner account ID.
     *
     * @tags ContactService
     * @name ContactServiceListEmployees
     * @summary List employee contacts for an owner
     * @request GET:/web/v2/contact/listEmployees/{ownerId}
     */
    contactServiceListEmployees: (ownerId: string, params: RequestParams = {}) =>
      this.request<ContactServiceListEmployeesData, ContactServiceListEmployeesError>({
        path: `/web/v2/contact/listEmployees/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns owned and shared person and company contacts for the given account, shaped for phone-provider integration.
     *
     * @tags ContactService
     * @name ContactServiceListForPhoneProvider
     * @summary List contacts for a phone provider
     * @request GET:/web/v2/contact/listForPhoneProvider/{accountId}
     */
    contactServiceListForPhoneProvider: (accountId: string, params: RequestParams = {}) =>
      this.request<ContactServiceListForPhoneProviderData, ContactServiceListForPhoneProviderError>({
        path: `/web/v2/contact/listForPhoneProvider/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Publishes updated events for contacts belonging to the given owner account IDs.
     *
     * @tags ContactService
     * @name ContactServicePublishUpdatedEvents
     * @summary Publish contact updated events
     * @request POST:/web/v2/contact/publishUpdatedEvents
     */
    contactServicePublishUpdatedEvents: (body: Contactv2PublishUpdatedEventsRequest, params: RequestParams = {}) =>
      this.request<ContactServicePublishUpdatedEventsData, ContactServicePublishUpdatedEventsError>({
        path: `/web/v2/contact/publishUpdatedEvents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the person and company contacts matching the given contact IDs.
     *
     * @tags ContactService
     * @name ContactServiceResolve
     * @summary Resolve contacts by IDs
     * @request POST:/web/v2/contact/resolve
     */
    contactServiceResolve: (body: V2ResolveRequest, params: RequestParams = {}) =>
      this.request<ContactServiceResolveData, ContactServiceResolveError>({
        path: `/web/v2/contact/resolve`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns person and company contacts owned by the given owner that match any of the provided emails.
     *
     * @tags ContactService
     * @name ContactServiceResolveByMail
     * @summary Resolve contacts by email for an owner
     * @request POST:/web/v2/contact/resolveByMail/{ownerId}
     */
    contactServiceResolveByMail: (
      ownerId: string,
      body: ContactServiceResolveByMailPayload,
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceResolveByMailData, ContactServiceResolveByMailError>({
        path: `/web/v2/contact/resolveByMail/${ownerId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns person and company contacts owned by any of the given owner IDs that match any of the provided emails.
     *
     * @tags ContactService
     * @name ContactServiceResolveByMailMultipleOwners
     * @summary Resolve contacts by email across owners
     * @request POST:/web/v2/contact/resolveByMailMultipleOwners
     */
    contactServiceResolveByMailMultipleOwners: (
      body: V2ResolveByMailMultipleOwnersRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceResolveByMailMultipleOwnersData, ContactServiceResolveByMailMultipleOwnersError>({
        path: `/web/v2/contact/resolveByMailMultipleOwners`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns employee person contacts for the given owner that match any of the provided emails.
     *
     * @tags ContactService
     * @name ContactServiceResolveEmployees
     * @summary Resolve employee contacts by email
     * @request POST:/web/v2/contact/resolveEmployees
     */
    contactServiceResolveEmployees: (body: V2ResolveEmployeesRequest, params: RequestParams = {}) =>
      this.request<ContactServiceResolveEmployeesData, ContactServiceResolveEmployeesError>({
        path: `/web/v2/contact/resolveEmployees`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns person and company contacts matching the given email address.
     *
     * @tags ContactService
     * @name ContactServiceSearchByMail
     * @summary Search contacts by email
     * @request GET:/web/v2/contact/searchByMail/{email}
     */
    contactServiceSearchByMail: (email: string, params: RequestParams = {}) =>
      this.request<ContactServiceSearchByMailData, ContactServiceSearchByMailError>({
        path: `/web/v2/contact/searchByMail/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets the address (with validFrom) on the given contact IDs. Returns the updated persons and companies.
     *
     * @tags ContactService
     * @name ContactServiceSetAddress
     * @summary Set address on contacts
     * @request POST:/web/v2/contact/setAddress
     */
    contactServiceSetAddress: (body: V2SetAddressRequest, params: RequestParams = {}) =>
      this.request<ContactServiceSetAddressData, ContactServiceSetAddressError>({
        path: `/web/v2/contact/setAddress`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes relation links between company contacts using the given relations.
     *
     * @tags ContactService
     * @name ContactServiceUnLinkCompanies
     * @summary Unlink company contacts
     * @request POST:/web/v2/contact/unLinkCompanies
     */
    contactServiceUnLinkCompanies: (body: V2UnLinkCompaniesRequest, params: RequestParams = {}) =>
      this.request<ContactServiceUnLinkCompaniesData, ContactServiceUnLinkCompaniesError>({
        path: `/web/v2/contact/unLinkCompanies`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes relation links between person contacts using the given relations.
     *
     * @tags ContactService
     * @name ContactServiceUnLinkPersons
     * @summary Unlink person contacts
     * @request POST:/web/v2/contact/unLinkPersons
     */
    contactServiceUnLinkPersons: (body: V2UnLinkPersonsRequest, params: RequestParams = {}) =>
      this.request<ContactServiceUnLinkPersonsData, ContactServiceUnLinkPersonsError>({
        path: `/web/v2/contact/unLinkPersons`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an address history entry on the given contact IDs, identified by oldValidFrom, with a new validFrom and address. Returns the updated persons and companies.
     *
     * @tags ContactService
     * @name ContactServiceUpdateAddressHistory
     * @summary Update address history entries
     * @request POST:/web/v2/contact/updateAddressHistory
     */
    contactServiceUpdateAddressHistory: (body: V2UpdateAddressHistoryRequest, params: RequestParams = {}) =>
      this.request<ContactServiceUpdateAddressHistoryData, ContactServiceUpdateAddressHistoryError>({
        path: `/web/v2/contact/updateAddressHistory`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a new contact person to the company identified by companyContactId. Accepts personal details, email, phone numbers, address, employment, and portal/serial-email flags. Optional numericId may be supplied. Returns the created contact person.
     *
     * @tags ContactService
     * @name ContactServiceAddContactPerson
     * @summary Add a contact person to a company
     * @request POST:/web/v2/contact/{companyContactId}/addContactPerson
     */
    contactServiceAddContactPerson: (
      companyContactId: string,
      body: ContactServiceAddContactPersonPayload,
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceAddContactPersonData, ContactServiceAddContactPersonError>({
        path: `/web/v2/contact/${companyContactId}/addContactPerson`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the contact persons with the given IDs from the company identified by companyContactId.
     *
     * @tags ContactService
     * @name ContactServiceDeleteContactPersons
     * @summary Delete company contact persons
     * @request POST:/web/v2/contact/{companyContactId}/deleteContactPerson
     */
    contactServiceDeleteContactPersons: (
      companyContactId: string,
      body: ContactServiceDeleteContactPersonsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceDeleteContactPersonsData, ContactServiceDeleteContactPersonsError>({
        path: `/web/v2/contact/${companyContactId}/deleteContactPerson`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing contact person on the company identified by companyContactId and contactPersonId. Accepts personal details, email, phone numbers, address, employment, and portal/serial-email flags. Returns the updated contact person.
     *
     * @tags ContactService
     * @name ContactServiceUpdateContactPerson
     * @summary Update a company contact person
     * @request POST:/web/v2/contact/{companyContactId}/updateContactPerson/{contactPersonId}
     */
    contactServiceUpdateContactPerson: (
      companyContactId: string,
      contactPersonId: string,
      body: ContactServiceUpdateContactPersonPayload,
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceUpdateContactPersonData, ContactServiceUpdateContactPersonError>({
        path: `/web/v2/contact/${companyContactId}/updateContactPerson/${contactPersonId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Appends the given document IDs to the contact identified by ID.
     *
     * @tags ContactService
     * @name ContactServiceAddDocuments
     * @summary Add documents to a contact
     * @request POST:/web/v2/contact/{id}/addDocuments
     */
    contactServiceAddDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactServiceAddDocumentsData, ContactServiceAddDocumentsError>({
        path: `/web/v2/contact/${id}/addDocuments`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Deletes the address history entry with the given validFrom from the contact identified by ID. Returns the updated persons and companies.
     *
     * @tags ContactService
     * @name ContactServiceDeleteAddress
     * @summary Delete an address history entry
     * @request POST:/web/v2/contact/{id}/deleteAddress
     */
    contactServiceDeleteAddress: (id: string, body: ContactServiceDeleteAddressPayload, params: RequestParams = {}) =>
      this.request<ContactServiceDeleteAddressData, ContactServiceDeleteAddressError>({
        path: `/web/v2/contact/${id}/deleteAddress`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given document IDs from the contact identified by ID.
     *
     * @tags ContactService
     * @name ContactServiceRemoveDocuments
     * @summary Remove documents from a contact
     * @request DELETE:/web/v2/contact/{id}/removeDocuments/{documentIds}
     */
    contactServiceRemoveDocuments: (id: string, documentIds: string[], params: RequestParams = {}) =>
      this.request<ContactServiceRemoveDocumentsData, ContactServiceRemoveDocumentsError>({
        path: `/web/v2/contact/${id}/removeDocuments/${documentIds}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates an existing company contact by ID. Accepts name, email, phone numbers, address, types, industries, VAT number, legal form, tags, and portal/serial-email flags. Returns the updated company.
     *
     * @tags ContactService
     * @name ContactServiceUpdateCompany
     * @summary Update a company contact
     * @request POST:/web/v2/contact/{id}/updateCompany
     */
    contactServiceUpdateCompany: (id: string, body: ContactServiceUpdateCompanyPayload, params: RequestParams = {}) =>
      this.request<ContactServiceUpdateCompanyData, ContactServiceUpdateCompanyError>({
        path: `/web/v2/contact/${id}/updateCompany`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates generic fields on a contact by ID: name, first name, last name, email, phone numbers, and address.
     *
     * @tags ContactService
     * @name ContactServiceUpdateGeneric
     * @summary Update basic contact fields
     * @request POST:/web/v2/contact/{id}/updateGeneric
     */
    contactServiceUpdateGeneric: (id: string, body: ContactServiceUpdateGenericPayload, params: RequestParams = {}) =>
      this.request<ContactServiceUpdateGenericData, ContactServiceUpdateGenericError>({
        path: `/web/v2/contact/${id}/updateGeneric`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing person contact by ID. Accepts personal details, email, phone numbers, address, employment, types, industries, tags, and preferred communication settings. Returns the updated person.
     *
     * @tags ContactService
     * @name ContactServiceUpdatePerson
     * @summary Update a person contact
     * @request POST:/web/v2/contact/{id}/updatePerson
     */
    contactServiceUpdatePerson: (id: string, body: ContactServiceUpdatePersonPayload, params: RequestParams = {}) =>
      this.request<ContactServiceUpdatePersonData, ContactServiceUpdatePersonError>({
        path: `/web/v2/contact/${id}/updatePerson`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new activity for the given owner. Accepts employee contact IDs, references, start/end timestamps, subject, text, source, media IDs, and optional billable/hourly-rate fields. Returns the created activity.
     *
     * @tags ActivityService
     * @name ActivityServiceCreate
     * @summary Create an activity
     * @request POST:/web/v3/contact/activity/create
     */
    activityServiceCreate: (body: Activityv3CreateRequest, params: RequestParams = {}) =>
      this.request<ActivityServiceCreateData, ActivityServiceCreateError>({
        path: `/web/v3/contact/activity/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the activity with the given ID.
     *
     * @tags ActivityService
     * @name ActivityServiceDelete
     * @summary Delete an activity
     * @request DELETE:/web/v3/contact/activity/delete/{id}
     */
    activityServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<ActivityServiceDeleteData, ActivityServiceDeleteError>({
        path: `/web/v3/contact/activity/delete/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the activity identified by the given ID.
     *
     * @tags ActivityService
     * @name ActivityServiceGet
     * @summary Get an activity by ID
     * @request GET:/web/v3/contact/activity/get/{id}
     */
    activityServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<ActivityServiceGetData, ActivityServiceGetError>({
        path: `/web/v3/contact/activity/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns activities linked to any of the given reference IDs.
     *
     * @tags ActivityService
     * @name ActivityServiceListByReferenceIds
     * @summary List activities by reference IDs
     * @request POST:/web/v3/contact/activity/listByReferenceIds
     */
    activityServiceListByReferenceIds: (body: Activityv3ListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<ActivityServiceListByReferenceIdsData, ActivityServiceListByReferenceIdsError>({
        path: `/web/v3/contact/activity/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing activity by ID. Accepts employee contact IDs, references, start/end timestamps, subject, text, source, media IDs, and optional billable/hourly-rate fields.
     *
     * @tags ActivityService
     * @name ActivityServiceUpdate
     * @summary Update an activity
     * @request POST:/web/v3/contact/activity/update/{id}
     */
    activityServiceUpdate: (id: string, body: ActivityServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<ActivityServiceUpdateData, ActivityServiceUpdateError>({
        path: `/web/v3/contact/activity/update/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns RedX area model data (zip UBS PK and zip UBS Sima) for the given end date.
     *
     * @tags TendService
     * @name TendServiceGetRedXAreaModel
     * @summary Get RedX area model
     * @request GET:/web/export/tend/getRedXAreaModel
     */
    tendServiceGetRedXAreaModel: (query: TendServiceGetRedXAreaModelParams, params: RequestParams = {}) =>
      this.request<TendServiceGetRedXAreaModelData, TendServiceGetRedXAreaModelError>({
        path: `/web/export/tend/getRedXAreaModel`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns rental index CSV data (and UBS PK CSV) for the given end date.
     *
     * @tags TendService
     * @name TendServiceGetRentalIndexCsv
     * @summary Get rental index CSV
     * @request GET:/web/export/tend/getRentalIndexCSV
     */
    tendServiceGetRentalIndexCsv: (query: TendServiceGetRentalIndexCsvParams, params: RequestParams = {}) =>
      this.request<TendServiceGetRentalIndexCsvData, TendServiceGetRentalIndexCsvError>({
        path: `/web/export/tend/getRentalIndexCSV`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates FTP credentials (hostname, port, username, password) for platform exports. Username and password are stored AES encrypted. Returns the new credentials ID.
     *
     * @tags CredentialService
     * @name CredentialServiceCreate
     * @summary Create export credentials
     * @request POST:/web/v2/export/credentials/create
     */
    credentialServiceCreate: (body: CredentialsCreateCredentialsRequest, params: RequestParams = {}) =>
      this.request<CredentialServiceCreateData, CredentialServiceCreateError>({
        path: `/web/v2/export/credentials/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the FTP credentials for the given ID with username and password decrypted.
     *
     * @tags CredentialService
     * @name CredentialServiceFindDecrypted
     * @summary Find decrypted credentials by ID
     * @request GET:/web/v2/export/credentials/findDecrypted/{id}
     */
    credentialServiceFindDecrypted: (id: string, params: RequestParams = {}) =>
      this.request<CredentialServiceFindDecryptedData, CredentialServiceFindDecryptedError>({
        path: `/web/v2/export/credentials/findDecrypted/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates FTP credentials by ID (hostname, port, username). Password is updated only when updatePassword is true.
     *
     * @tags CredentialService
     * @name CredentialServiceUpdate
     * @summary Update export credentials
     * @request POST:/web/v2/export/credentials/update
     */
    credentialServiceUpdate: (body: CredentialsUpdateCredentialsRequest, params: RequestParams = {}) =>
      this.request<CredentialServiceUpdateData, CredentialServiceUpdateError>({
        path: `/web/v2/export/credentials/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new export for the given account with credentials, platform, export type, and optional object targets. Custom name, image URL, and agency ID may be supplied.
     *
     * @tags ExportService
     * @name ExportServiceCreate
     * @summary Create an export
     * @request POST:/web/v2/export/export/create
     */
    exportServiceCreate: (body: V2CreateExportRequest, params: RequestParams = {}) =>
      this.request<ExportServiceCreateData, ExportServiceCreateError>({
        path: `/web/v2/export/export/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the export configuration identified by the given ID.
     *
     * @tags ExportService
     * @name ExportServiceDelete
     * @summary Delete an export
     * @request POST:/web/v2/export/export/delete/{id}
     */
    exportServiceDelete: (id: string, body: object, params: RequestParams = {}) =>
      this.request<ExportServiceDeleteData, ExportServiceDeleteError>({
        path: `/web/v2/export/export/delete/${id}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns the export configuration identified by the given ID.
     *
     * @tags ExportService
     * @name ExportServiceFind
     * @summary Find an export by ID
     * @request GET:/web/v2/export/export/find/{id}
     */
    exportServiceFind: (id: string, params: RequestParams = {}) =>
      this.request<ExportServiceFindData, ExportServiceFindError>({
        path: `/web/v2/export/export/find/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all export configurations belonging to the given account ID.
     *
     * @tags ExportService
     * @name ExportServiceList
     * @summary List exports for an account
     * @request POST:/web/v2/export/export/list/{accountId}
     */
    exportServiceList: (accountId: string, body: object, params: RequestParams = {}) =>
      this.request<ExportServiceListData, ExportServiceListError>({
        path: `/web/v2/export/export/list/${accountId}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns the platforms associated with the given object ID.
     *
     * @tags ExportService
     * @name ExportServiceListObjectPlatforms
     * @summary List platforms for an object
     * @request GET:/web/v2/export/export/listObjectPlatforms/{objectId}
     */
    exportServiceListObjectPlatforms: (objectId: string, params: RequestParams = {}) =>
      this.request<ExportServiceListObjectPlatformsData, ExportServiceListObjectPlatformsError>({
        path: `/web/v2/export/export/listObjectPlatforms/${objectId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the available export presets (e.g. all fields disabled, full agency without visit, full). The request has no parameters.
     *
     * @tags ExportService
     * @name ExportServiceListPresets
     * @summary List export presets
     * @request GET:/web/v2/export/export/listPresets
     */
    exportServiceListPresets: (params: RequestParams = {}) =>
      this.request<ExportServiceListPresetsData, ExportServiceListPresetsError>({
        path: `/web/v2/export/export/listPresets`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Removes all targets from the given export and returns the updated export configuration.
     *
     * @tags ExportService
     * @name ExportServiceRemoveAllTargets
     * @summary Remove all targets from an export
     * @request POST:/web/v2/export/export/removeAllTargets/{exportId}
     */
    exportServiceRemoveAllTargets: (exportId: string, body: object, params: RequestParams = {}) =>
      this.request<ExportServiceRemoveAllTargetsData, ExportServiceRemoveAllTargetsError>({
        path: `/web/v2/export/export/removeAllTargets/${exportId}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns the latest export run per platform (e.g. Homegate, ImmoScout, Newhome) for the given account ID.
     *
     * @tags HistoryService
     * @name HistoryServiceGetLatest
     * @summary Get latest export runs by platform
     * @request GET:/web/v2/export/export/runs/latest/{accountId}
     */
    historyServiceGetLatest: (accountId: string, params: RequestParams = {}) =>
      this.request<HistoryServiceGetLatestData, HistoryServiceGetLatestError>({
        path: `/web/v2/export/export/runs/latest/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns overall and today counts of export runs, broken down by status (started, failed, finished) and platform. The request has no parameters.
     *
     * @tags HistoryService
     * @name HistoryServiceStatistics
     * @summary Get export run statistics
     * @request GET:/web/v2/export/export/runs/statistics
     */
    historyServiceStatistics: (params: RequestParams = {}) =>
      this.request<HistoryServiceStatisticsData, HistoryServiceStatisticsError>({
        path: `/web/v2/export/export/runs/statistics`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sends a command to upload export data from the given source path to the target platform using the provided FTP credentials and export/run IDs.
     *
     * @tags ExportService
     * @name ExportServiceSendExportUploadCommand
     * @summary Send an export upload command
     * @request POST:/web/v2/export/export/sendExportUploadCommand
     */
    exportServiceSendExportUploadCommand: (body: V2SendExportUploadCommandRequest, params: RequestParams = {}) =>
      this.request<ExportServiceSendExportUploadCommandData, ExportServiceSendExportUploadCommandError>({
        path: `/web/v2/export/export/sendExportUploadCommand`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the agency ID used when encoding the export for the given export ID.
     *
     * @tags ExportService
     * @name ExportServiceSetAgencyId
     * @summary Set agency ID on an export
     * @request POST:/web/v2/export/export/setAgencyId
     */
    exportServiceSetAgencyId: (body: V2SetAgencyIdRequest, params: RequestParams = {}) =>
      this.request<ExportServiceSetAgencyIdData, ExportServiceSetAgencyIdError>({
        path: `/web/v2/export/export/setAgencyId`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the field preset for all targets of the given export ID.
     *
     * @tags ExportService
     * @name ExportServiceSetPreset
     * @summary Set preset on an export
     * @request POST:/web/v2/export/export/setPreset
     */
    exportServiceSetPreset: (body: V2SetPresetRequest, params: RequestParams = {}) =>
      this.request<ExportServiceSetPresetData, ExportServiceSetPresetError>({
        path: `/web/v2/export/export/setPreset`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an export run for the given export configuration ID and returns the export run ID.
     *
     * @tags ExportService
     * @name ExportServiceStart
     * @summary Start an export run
     * @request POST:/web/v2/export/export/start/{id}
     */
    exportServiceStart: (id: string, body: object, params: RequestParams = {}) =>
      this.request<ExportServiceStartData, ExportServiceStartError>({
        path: `/web/v2/export/export/start/${id}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates an existing export by ID, including account, credentials, platform, type, custom name, image URL, and target IDs.
     *
     * @tags ExportService
     * @name ExportServiceUpdate
     * @summary Update an export
     * @request POST:/web/v2/export/export/update
     */
    exportServiceUpdate: (body: V2UpdateExportRequest, params: RequestParams = {}) =>
      this.request<ExportServiceUpdateData, ExportServiceUpdateError>({
        path: `/web/v2/export/export/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the platforms for the given account and object ID. Returns the affected export configurations.
     *
     * @tags ExportService
     * @name ExportServiceUpdatePlatforms
     * @summary Update platforms for an object
     * @request POST:/web/v2/export/export/updatePlatforms
     */
    exportServiceUpdatePlatforms: (body: V2UpdatePlatformsRequest, params: RequestParams = {}) =>
      this.request<ExportServiceUpdatePlatformsData, ExportServiceUpdatePlatformsError>({
        path: `/web/v2/export/export/updatePlatforms`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Legacy sync Express `multipart/form-data` upload (not a gRPC method). Scans then stores and returns `READY` media immediately. Prefer `CreateUpload` for larger files (signed GCS PUT); both paths are always allowed. The request body must be `multipart/form-data` with a single file field named `file` (plus optional form fields below). On success, returns the created media object as JSON (same fields as `Media`, status `READY`). | Form field | Required | Description | |------------|----------|-------------| | `file` | yes | Binary file (`multer` field name `file`) | | `public` | no | Visibility; truthy when `"true"` or `"1"` (default: private) | | `accountId` | no | Owner account ID; falls back to `x-account-id`, else `-1` | | `filename` | no | Stored filename override (max 255 chars); defaults to the upload original name | | `maxDimension` | no | Max image width/height in pixels before resize (images only) | MIME type is detected from file content when possible. Blocked types (e.g. executables) return **403**. Infected files (ClamAV) return **409**. Missing `file` or invalid multipart return **400**. Example: ``` curl --location 'https://staging.myprop.ch/web/media' \ --form 'public="false"' \ --form 'file=@"/path/to/Vertrag.pdf"' \ --form 'accountId=30001' ```
     *
     * @tags StoreService
     * @name StoreServiceUpload
     * @summary Upload media file (legacy Express)
     * @request POST:/web/media
     */
    storeServiceUpload: (body: StoreUploadMediaRequest, params: RequestParams = {}) =>
      this.request<StoreServiceUploadData, StoreServiceUploadError>({
        path: `/web/media`,
        method: "POST",
        body: body,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description Start scan and promotion of quarantined file.Idempotent if already scanning or ready. Useful for local/dev without GCS notifications; also valid in production. Returns the current `Media` (may still be non-READY).
     *
     * @tags StoreService
     * @name StoreServiceCompleteUpload
     * @summary Complete signed GCS upload
     * @request POST:/web/media/completeUpload
     */
    storeServiceCompleteUpload: (body: StoreCompleteUploadRequest, params: RequestParams = {}) =>
      this.request<StoreServiceCompleteUploadData, StoreServiceCompleteUploadError>({
        path: `/web/media/completeUpload`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a `PENDING` media row and returns a GCS V4 signed PUT URL (valid 15 minutes) to a quarantine bucket. After PUT, the object is scanned asynchronously (ClamAV); poll `Get` until `status` is `READY`, or call `CompleteUpload` to enqueue the scan (also used for local/dev without the GCS Pub/Sub bridge). Prefer this path for larger files; the legacy Express `Upload` remains available for small/sync uploads. No server-enforced size split between the two paths. `url` and thumbnails are empty until `status` is `READY`. Client `mimeType` is a hint only; the worker overwrites MIME from detected file content.
     *
     * @tags StoreService
     * @name StoreServiceCreateUpload
     * @summary Create signed GCS upload
     * @request POST:/web/media/createUpload
     */
    storeServiceCreateUpload: (body: StoreCreateUploadRequest, params: RequestParams = {}) =>
      this.request<StoreServiceCreateUploadData, StoreServiceCreateUploadError>({
        path: `/web/media/createUpload`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the document identified by the given ID.
     *
     * @tags DocumentService
     * @name DocumentServiceGet
     * @summary Get a document by ID
     * @request GET:/web/media/documents
     */
    documentServiceGet: (query: DocumentServiceGetParams, params: RequestParams = {}) =>
      this.request<DocumentServiceGetData, DocumentServiceGetError>({
        path: `/web/media/documents`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new document for the given owner from a media ID, with name, type, and showInPortal flag. Returns the created document.
     *
     * @tags DocumentService
     * @name DocumentServiceSave
     * @summary Save a document
     * @request POST:/web/media/documents
     */
    documentServiceSave: (body: DocumentSaveRequest, params: RequestParams = {}) =>
      this.request<DocumentServiceSaveData, DocumentServiceSaveError>({
        path: `/web/media/documents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the documents matching the given document IDs.
     *
     * @tags DocumentService
     * @name DocumentServiceList
     * @summary List documents by IDs
     * @request POST:/web/media/documents/list
     */
    documentServiceList: (body: MediadocumentListRequest, params: RequestParams = {}) =>
      this.request<DocumentServiceListData, DocumentServiceListError>({
        path: `/web/media/documents/list`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Merges the given media items into a single file with the provided mergeMediumName. Returns the merged media as bytes.
     *
     * @tags DocumentService
     * @name DocumentServiceMergeAllDocuments
     * @summary Merge documents into one file
     * @request POST:/web/media/documents/mergeAllDocuments
     */
    documentServiceMergeAllDocuments: (body: DocumentMergeAllDocumentsRequest, params: RequestParams = {}) =>
      this.request<DocumentServiceMergeAllDocumentsData, DocumentServiceMergeAllDocumentsError>({
        path: `/web/media/documents/mergeAllDocuments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing document by ID with name, type, and showInPortal flag.
     *
     * @tags DocumentService
     * @name DocumentServiceUpdate
     * @summary Update a document
     * @request POST:/web/media/documents/{id}/update
     */
    documentServiceUpdate: (id: string, body: DocumentServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<DocumentServiceUpdateData, DocumentServiceUpdateError>({
        path: `/web/media/documents/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a new version to the document identified by ID, linking the given media ID. Returns the updated document.
     *
     * @tags DocumentService
     * @name DocumentServiceAddVersion
     * @summary Add a document version
     * @request POST:/web/media/documents/{id}/version
     */
    documentServiceAddVersion: (id: string, body: DocumentServiceAddVersionPayload, params: RequestParams = {}) =>
      this.request<DocumentServiceAddVersionData, DocumentServiceAddVersionError>({
        path: `/web/media/documents/${id}/version`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the specified version from the document identified by ID. Returns the updated document.
     *
     * @tags DocumentService
     * @name DocumentServiceRemoveVersion
     * @summary Remove a document version
     * @request DELETE:/web/media/documents/{id}/version/{version}
     */
    documentServiceRemoveVersion: (id: string, version: number, params: RequestParams = {}) =>
      this.request<DocumentServiceRemoveVersionData, DocumentServiceRemoveVersionError>({
        path: `/web/media/documents/${id}/version/${version}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the media items matching the given IDs. Items may be `PENDING`, `SCANNING`, `REJECTED`, or `EXPIRED` with empty `url` and thumbnails; usable URLs are only present when `status` is `READY`. Clients should poll or wait for `media.uploaded` after `CreateUpload`.
     *
     * @tags StoreService
     * @name StoreServiceList
     * @summary List media by IDs
     * @request POST:/web/media/list
     */
    storeServiceList: (body: StoreListMediaRequest, params: RequestParams = {}) =>
      this.request<StoreServiceListData, StoreServiceListError>({
        path: `/web/media/list`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the public flag on the media items with the given IDs according to the public value. Fails unless status is READY.
     *
     * @tags StoreService
     * @name StoreServiceSetPublicFlag
     * @summary Set public flag on media
     * @request POST:/web/media/setPublicFlag
     */
    storeServiceSetPublicFlag: (body: StoreSetPublicFlagRequest, params: RequestParams = {}) =>
      this.request<StoreServiceSetPublicFlagData, StoreServiceSetPublicFlagError>({
        path: `/web/media/setPublicFlag`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the media item identified by the given ID, including filename, MIME type, size, URL, thumbnails, validity, and `status`. `url` and thumbnails are empty unless `status` is `READY`. After `CreateUpload`, poll until `READY` or wait for `media.uploaded`.
     *
     * @tags StoreService
     * @name StoreServiceGet
     * @summary Get media by ID
     * @request GET:/web/media/{id}
     */
    storeServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<StoreServiceGetData, StoreServiceGetError>({
        path: `/web/media/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Deletes the media item identified by the given ID. May cancel a PENDING upload and remove the quarantine object.
     *
     * @tags StoreService
     * @name StoreServiceDelete
     * @summary Delete media by ID
     * @request DELETE:/web/media/{id}
     */
    storeServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<StoreServiceDeleteData, StoreServiceDeleteError>({
        path: `/web/media/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Activates the mailboxes identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceActivateMailboxes
     * @summary Activate mailboxes
     * @request POST:/web/v2/message/mail/activateMailboxes
     */
    mailServiceActivateMailboxes: (body: V2ActivateMailboxesRequest, params: RequestParams = {}) =>
      this.request<MailServiceActivateMailboxesData, MailServiceActivateMailboxesError>({
        path: `/web/v2/message/mail/activateMailboxes`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds email addresses to the confidential email list for the given account.
     *
     * @tags MailService
     * @name MailServiceAddConfidentialEmails
     * @summary Add confidential emails
     * @request POST:/web/v2/message/mail/addConfidentialEmails
     */
    mailServiceAddConfidentialEmails: (body: V2AddConfidentialEmailsRequest, params: RequestParams = {}) =>
      this.request<MailServiceAddConfidentialEmailsData, MailServiceAddConfidentialEmailsError>({
        path: `/web/v2/message/mail/addConfidentialEmails`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Archives the mails identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceArchive
     * @summary Archive mails
     * @request POST:/web/v2/message/mail/archive
     */
    mailServiceArchive: (body: V2ArchiveRequest, params: RequestParams = {}) =>
      this.request<MailServiceArchiveData, MailServiceArchiveError>({
        path: `/web/v2/message/mail/archive`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends multiple mails in one request using the provided entries (owner, participants, subject, body, attachments, and optional reply/confidential settings). Returns the sent mails.
     *
     * @tags MailService
     * @name MailServiceBulkSendMail
     * @summary Bulk send mails
     * @request POST:/web/v2/message/mail/bulkSendMail
     */
    mailServiceBulkSendMail: (body: V2BulkSendMailRequest, params: RequestParams = {}) =>
      this.request<MailServiceBulkSendMailData, MailServiceBulkSendMailError>({
        path: `/web/v2/message/mail/bulkSendMail`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of mail drafts for the authenticated caller. The request has no parameters.
     *
     * @tags MailService
     * @name MailServiceCountDrafts
     * @summary Count mail drafts
     * @request GET:/web/v2/message/mail/countDrafts
     */
    mailServiceCountDrafts: (params: RequestParams = {}) =>
      this.request<MailServiceCountDraftsData, MailServiceCountDraftsError>({
        path: `/web/v2/message/mail/countDrafts`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the number of unread mails across the given mailbox IDs.
     *
     * @tags MailService
     * @name MailServiceCountUnreadMails
     * @summary Count unread mails
     * @request GET:/web/v2/message/mail/countUnreadMails/{mailboxIds}
     */
    mailServiceCountUnreadMails: (mailboxIds: string[], params: RequestParams = {}) =>
      this.request<MailServiceCountUnreadMailsData, MailServiceCountUnreadMailsError>({
        path: `/web/v2/message/mail/countUnreadMails/${mailboxIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates a new mail domain for the given owner. Returns the created domain including its validation key.
     *
     * @tags MailService
     * @name MailServiceCreateDomain
     * @summary Create a mail domain
     * @request POST:/web/v2/message/mail/createDomain
     */
    mailServiceCreateDomain: (body: V2CreateDomainRequest, params: RequestParams = {}) =>
      this.request<MailServiceCreateDomainData, MailServiceCreateDomainError>({
        path: `/web/v2/message/mail/createDomain`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new mailbox for the given owner. Accepts mailbox type, outbound email, name, optional main and allowed user IDs, and an optional signature ID. Returns the created mailbox.
     *
     * @tags MailService
     * @name MailServiceCreateMailbox
     * @summary Create a mailbox
     * @request POST:/web/v2/message/mail/createMailbox
     */
    mailServiceCreateMailbox: (body: V2CreateMailboxRequest, params: RequestParams = {}) =>
      this.request<MailServiceCreateMailboxData, MailServiceCreateMailboxError>({
        path: `/web/v2/message/mail/createMailbox`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deactivates the mailboxes identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceDeactivateMailboxes
     * @summary Deactivate mailboxes
     * @request POST:/web/v2/message/mail/deactivateMailboxes
     */
    mailServiceDeactivateMailboxes: (body: V2DeactivateMailboxesRequest, params: RequestParams = {}) =>
      this.request<MailServiceDeactivateMailboxesData, MailServiceDeactivateMailboxesError>({
        path: `/web/v2/message/mail/deactivateMailboxes`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the mail domain identified by the given ID.
     *
     * @tags MailService
     * @name MailServiceDeleteDomain
     * @summary Delete a mail domain
     * @request DELETE:/web/v2/message/mail/deleteDomain/{id}
     */
    mailServiceDeleteDomain: (id: string, params: RequestParams = {}) =>
      this.request<MailServiceDeleteDomainData, MailServiceDeleteDomainError>({
        path: `/web/v2/message/mail/deleteDomain/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Deletes the mail drafts identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceDeleteDrafts
     * @summary Delete mail drafts
     * @request DELETE:/web/v2/message/mail/deleteDrafts/{ids}
     */
    mailServiceDeleteDrafts: (ids: string[], params: RequestParams = {}) =>
      this.request<MailServiceDeleteDraftsData, MailServiceDeleteDraftsError>({
        path: `/web/v2/message/mail/deleteDrafts/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Permanently deletes the mails identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceDeleteMails
     * @summary Delete mails
     * @request DELETE:/web/v2/message/mail/deleteMails/{ids}
     */
    mailServiceDeleteMails: (ids: string[], params: RequestParams = {}) =>
      this.request<MailServiceDeleteMailsData, MailServiceDeleteMailsError>({
        path: `/web/v2/message/mail/deleteMails/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates an existing mailbox by ID, including outbound email, name, main and allowed user IDs, and signature ID.
     *
     * @tags MailService
     * @name MailServiceEditMailbox
     * @summary Edit a mailbox
     * @request POST:/web/v2/message/mail/editMailbox/{id}
     */
    mailServiceEditMailbox: (id: string, body: MailServiceEditMailboxPayload, params: RequestParams = {}) =>
      this.request<MailServiceEditMailboxData, MailServiceEditMailboxError>({
        path: `/web/v2/message/mail/editMailbox/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Forwards an existing mail identified by forwardingMailId to the given recipients. Accepts owner, participants, subject, body, attachments, and a confidential flag. Returns the forwarded mail.
     *
     * @tags MailService
     * @name MailServiceForward
     * @summary Forward a mail
     * @request POST:/web/v2/message/mail/forward
     */
    mailServiceForward: (body: V2ForwardRequest, params: RequestParams = {}) =>
      this.request<MailServiceForwardData, MailServiceForwardError>({
        path: `/web/v2/message/mail/forward`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns delivery and engagement data for mails matching the given reference IDs, including participants, deliverability status, engagement status, and timestamps.
     *
     * @tags MailService
     * @name MailServiceGetDeliveryAndEngagementData
     * @summary Get delivery and engagement data
     * @request POST:/web/v2/message/mail/getDeliveryAndEngagementData
     */
    mailServiceGetDeliveryAndEngagementData: (
      body: V2GetDeliveryAndEngagementDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<MailServiceGetDeliveryAndEngagementDataData, MailServiceGetDeliveryAndEngagementDataError>({
        path: `/web/v2/message/mail/getDeliveryAndEngagementData`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the mailbox identified by the given ID.
     *
     * @tags MailService
     * @name MailServiceGetMailbox
     * @summary Get a mailbox
     * @request GET:/web/v2/message/mail/getMailbox/{id}
     */
    mailServiceGetMailbox: (id: string, params: RequestParams = {}) =>
      this.request<MailServiceGetMailboxData, MailServiceGetMailboxError>({
        path: `/web/v2/message/mail/getMailbox/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the domain of the given from-email address has a dedicated IP.
     *
     * @tags MailService
     * @name MailServiceHasDomainDedicatedIp
     * @summary Check domain dedicated IP
     * @request GET:/web/v2/message/mail/hasDomainDedicatedIp
     */
    mailServiceHasDomainDedicatedIp: (query: MailServiceHasDomainDedicatedIpParams, params: RequestParams = {}) =>
      this.request<MailServiceHasDomainDedicatedIpData, MailServiceHasDomainDedicatedIpError>({
        path: `/web/v2/message/mail/hasDomainDedicatedIp`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the confidential email addresses registered for the given account.
     *
     * @tags MailService
     * @name MailServiceListConfidentialEmails
     * @summary List confidential emails
     * @request GET:/web/v2/message/mail/listConfidentialEmails/{accountId}
     */
    mailServiceListConfidentialEmails: (accountId: string, params: RequestParams = {}) =>
      this.request<MailServiceListConfidentialEmailsData, MailServiceListConfidentialEmailsError>({
        path: `/web/v2/message/mail/listConfidentialEmails/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all mail domains belonging to the given owner.
     *
     * @tags MailService
     * @name MailServiceListDomains
     * @summary List mail domains for an owner
     * @request GET:/web/v2/message/mail/listDomains/{ownerId}
     */
    mailServiceListDomains: (ownerId: string, params: RequestParams = {}) =>
      this.request<MailServiceListDomainsData, MailServiceListDomainsError>({
        path: `/web/v2/message/mail/listDomains/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all mail drafts for the authenticated caller. The request has no parameters.
     *
     * @tags MailService
     * @name MailServiceListDrafts
     * @summary List mail drafts
     * @request GET:/web/v2/message/mail/listDrafts
     */
    mailServiceListDrafts: (params: RequestParams = {}) =>
      this.request<MailServiceListDraftsData, MailServiceListDraftsError>({
        path: `/web/v2/message/mail/listDrafts`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the latest mail for each of the given reference IDs.
     *
     * @tags MailService
     * @name MailServiceListLatestMailsForReferenceIds
     * @summary List latest mails for reference IDs
     * @request POST:/web/v2/message/mail/listLatestMailsForReferenceIds
     */
    mailServiceListLatestMailsForReferenceIds: (
      body: V2ListLatestMailsForReferenceIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<MailServiceListLatestMailsForReferenceIdsData, MailServiceListLatestMailsForReferenceIdsError>({
        path: `/web/v2/message/mail/listLatestMailsForReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns mail IDs for the given mailbox IDs. Supports query text, unread and folder filters, reference-ID prefix exclusions, and sorting by received time.
     *
     * @tags MailService
     * @name MailServiceListMailIds
     * @summary List mail IDs in mailboxes
     * @request POST:/web/v2/message/mail/listMailIds
     */
    mailServiceListMailIds: (body: V2ListMailIdsRequest, params: RequestParams = {}) =>
      this.request<MailServiceListMailIdsData, MailServiceListMailIdsError>({
        path: `/web/v2/message/mail/listMailIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all mailboxes belonging to the given account ID.
     *
     * @tags MailService
     * @name MailServiceListMailboxesByAccountId
     * @summary List mailboxes by account ID
     * @request GET:/web/v2/message/mail/listMailboxesByAccountId/{accountId}
     */
    mailServiceListMailboxesByAccountId: (accountId: string, params: RequestParams = {}) =>
      this.request<MailServiceListMailboxesByAccountIdData, MailServiceListMailboxesByAccountIdError>({
        path: `/web/v2/message/mail/listMailboxesByAccountId/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all mailboxes accessible to the given user ID.
     *
     * @tags MailService
     * @name MailServiceListMailboxesByUserId
     * @summary List mailboxes by user ID
     * @request GET:/web/v2/message/mail/listMailboxesByUserId/{userId}
     */
    mailServiceListMailboxesByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<MailServiceListMailboxesByUserIdData, MailServiceListMailboxesByUserIdError>({
        path: `/web/v2/message/mail/listMailboxesByUserId/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of mails for the given mailbox IDs. Supports query text, unread and folder filters, reference-ID prefix exclusions, and sorting by received time. Optional limitPagination can cap exact counts for performance. Response includes total and page counts.
     *
     * @tags MailService
     * @name MailServiceListMails
     * @summary List mails in mailboxes
     * @request POST:/web/v2/message/mail/listMails
     */
    mailServiceListMails: (body: V2ListMailsRequest, params: RequestParams = {}) =>
      this.request<MailServiceListMailsData, MailServiceListMailsError>({
        path: `/web/v2/message/mail/listMails`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the mails matching the given mail IDs.
     *
     * @tags MailService
     * @name MailServiceListMailsByIds
     * @summary List mails by IDs
     * @request POST:/web/v2/message/mail/listMailsByIds
     */
    mailServiceListMailsByIds: (body: V2ListMailsByIdsRequest, params: RequestParams = {}) =>
      this.request<MailServiceListMailsByIdsData, MailServiceListMailsByIdsError>({
        path: `/web/v2/message/mail/listMailsByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of mails linked to the given reference IDs. Supports query text, folder filter, and optional mailbox IDs when filtering inbound/outbound. Response includes total mail and page counts.
     *
     * @tags MailService
     * @name MailServiceListMailsByReferenceIds
     * @summary List mails by reference IDs
     * @request POST:/web/v2/message/mail/listMailsByReferenceIds
     */
    mailServiceListMailsByReferenceIds: (body: V2ListMailsByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<MailServiceListMailsByReferenceIdsData, MailServiceListMailsByReferenceIdsError>({
        path: `/web/v2/message/mail/listMailsByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the spam flag from the mails identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceMarkAsNoSpam
     * @summary Mark mails as not spam
     * @request POST:/web/v2/message/mail/markAsNoSpam
     */
    mailServiceMarkAsNoSpam: (body: V2MarkAsNoSpamRequest, params: RequestParams = {}) =>
      this.request<MailServiceMarkAsNoSpamData, MailServiceMarkAsNoSpamError>({
        path: `/web/v2/message/mail/markAsNoSpam`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the mails identified by the given IDs as spam.
     *
     * @tags MailService
     * @name MailServiceMarkAsSpam
     * @summary Mark mails as spam
     * @request POST:/web/v2/message/mail/markAsSpam
     */
    mailServiceMarkAsSpam: (body: V2MarkAsSpamRequest, params: RequestParams = {}) =>
      this.request<MailServiceMarkAsSpamData, MailServiceMarkAsSpamError>({
        path: `/web/v2/message/mail/markAsSpam`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given mails as read for the specified account.
     *
     * @tags MailService
     * @name MailServiceMarkRead
     * @summary Mark mails as read
     * @request POST:/web/v2/message/mail/markRead
     */
    mailServiceMarkRead: (body: Messagemailv2MarkReadRequest, params: RequestParams = {}) =>
      this.request<MailServiceMarkReadData, MailServiceMarkReadError>({
        path: `/web/v2/message/mail/markRead`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given mails as unread for the specified account.
     *
     * @tags MailService
     * @name MailServiceMarkUnread
     * @summary Mark mails as unread
     * @request POST:/web/v2/message/mail/markUnread
     */
    mailServiceMarkUnread: (body: Messagemailv2MarkUnreadRequest, params: RequestParams = {}) =>
      this.request<MailServiceMarkUnreadData, MailServiceMarkUnreadError>({
        path: `/web/v2/message/mail/markUnread`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Moves the mails identified by the given IDs to trash.
     *
     * @tags MailService
     * @name MailServiceMoveToTrash
     * @summary Move mails to trash
     * @request POST:/web/v2/message/mail/moveToTrash
     */
    mailServiceMoveToTrash: (body: V2MoveToTrashRequest, params: RequestParams = {}) =>
      this.request<MailServiceMoveToTrashData, MailServiceMoveToTrashError>({
        path: `/web/v2/message/mail/moveToTrash`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given email addresses from the confidential email list of the account.
     *
     * @tags MailService
     * @name MailServiceRemoveConfidentialEmails
     * @summary Remove confidential emails
     * @request POST:/web/v2/message/mail/removeConfidentialEmails
     */
    mailServiceRemoveConfidentialEmails: (body: V2RemoveConfidentialEmailsRequest, params: RequestParams = {}) =>
      this.request<MailServiceRemoveConfidentialEmailsData, MailServiceRemoveConfidentialEmailsError>({
        path: `/web/v2/message/mail/removeConfidentialEmails`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Restores the given mails from the archive.
     *
     * @tags MailService
     * @name MailServiceUnarchive
     * @summary Unarchive mails
     * @request POST:/web/v2/message/mail/restore
     */
    mailServiceUnarchive: (body: V2UnarchiveRequest, params: RequestParams = {}) =>
      this.request<MailServiceUnarchiveData, MailServiceUnarchiveError>({
        path: `/web/v2/message/mail/restore`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Restores the mails identified by the given IDs from trash.
     *
     * @tags MailService
     * @name MailServiceRestoreFromTrash
     * @summary Restore mails from trash
     * @request POST:/web/v2/message/mail/restoreFromTrash
     */
    mailServiceRestoreFromTrash: (body: V2RestoreFromTrashRequest, params: RequestParams = {}) =>
      this.request<MailServiceRestoreFromTrashData, MailServiceRestoreFromTrashError>({
        path: `/web/v2/message/mail/restoreFromTrash`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates a mail draft for the given mailbox. Optional id updates an existing draft; otherwise a new draft is created. Accepts participants, subject, body, attachments, and optional reply/forward mail IDs. Returns the saved draft.
     *
     * @tags MailService
     * @name MailServiceSaveDraft
     * @summary Save a mail draft
     * @request POST:/web/v2/message/mail/saveDraft
     */
    mailServiceSaveDraft: (body: V2SaveDraftRequest, params: RequestParams = {}) =>
      this.request<MailServiceSaveDraftData, MailServiceSaveDraftError>({
        path: `/web/v2/message/mail/saveDraft`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends a mail for the given owner with from/to/cc/bcc participants, subject, body, and optional attachments. Supports reply threading via replyToMailId, scheduled send via sendAt, and a confidential flag. Returns the sent mail.
     *
     * @tags MailService
     * @name MailServiceSendMail
     * @summary Send a mail
     * @request POST:/web/v2/message/mail/sendMail
     */
    mailServiceSendMail: (body: V2SendMailRequest, params: RequestParams = {}) =>
      this.request<MailServiceSendMailData, MailServiceSendMailError>({
        path: `/web/v2/message/mail/sendMail`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the automatic reply configuration (enabled flag, date/time window, subject and body) on the given mailbox IDs. Returns the updated mailboxes.
     *
     * @tags MailService
     * @name MailServiceSetAutomaticReply
     * @summary Set automatic reply on mailboxes
     * @request POST:/web/v2/message/mail/setAutomaticReply
     */
    mailServiceSetAutomaticReply: (body: V2SetAutomaticReplyRequest, params: RequestParams = {}) =>
      this.request<MailServiceSetAutomaticReplyData, MailServiceSetAutomaticReplyError>({
        path: `/web/v2/message/mail/setAutomaticReply`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the confidential flag on the mails identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceSetConfidential
     * @summary Set mails confidential flag
     * @request POST:/web/v2/message/mail/setConfidential
     */
    mailServiceSetConfidential: (body: V2SetConfidentialRequest, params: RequestParams = {}) =>
      this.request<MailServiceSetConfidentialData, MailServiceSetConfidentialError>({
        path: `/web/v2/message/mail/setConfidential`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the confidential flag on the given mailbox IDs. Returns the updated mailboxes.
     *
     * @tags MailService
     * @name MailServiceSetMailboxesConfidential
     * @summary Set mailboxes confidential flag
     * @request POST:/web/v2/message/mail/setMailboxesConfidential
     */
    mailServiceSetMailboxesConfidential: (body: V2SetMailboxesConfidentialRequest, params: RequestParams = {}) =>
      this.request<MailServiceSetMailboxesConfidentialData, MailServiceSetMailboxesConfidentialError>({
        path: `/web/v2/message/mail/setMailboxesConfidential`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the reference IDs on the mails identified by the given IDs.
     *
     * @tags MailService
     * @name MailServiceSetReferenceIds
     * @summary Set reference IDs on mails
     * @request POST:/web/v2/message/mail/setReferenceIds/{ids}
     */
    mailServiceSetReferenceIds: (ids: string[], body: MailServiceSetReferenceIdsPayload, params: RequestParams = {}) =>
      this.request<MailServiceSetReferenceIdsData, MailServiceSetReferenceIdsError>({
        path: `/web/v2/message/mail/setReferenceIds/${ids}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Validates the mail domain identified by the given ID and returns whether it is valid.
     *
     * @tags MailService
     * @name MailServiceValidateDomain
     * @summary Validate a mail domain
     * @request POST:/web/v2/message/mail/validateDomain/{id}
     */
    mailServiceValidateDomain: (id: string, body: object, params: RequestParams = {}) =>
      this.request<MailServiceValidateDomainData, MailServiceValidateDomainError>({
        path: `/web/v2/message/mail/validateDomain/${id}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns all signatures belonging to the given account.
     *
     * @tags SignatureService
     * @name SignatureServiceListByAccountId
     * @summary List signatures by account ID
     * @request GET:/web/v2/message/signature/listByAccountId
     */
    signatureServiceListByAccountId: (query: SignatureServiceListByAccountIdParams, params: RequestParams = {}) =>
      this.request<SignatureServiceListByAccountIdData, SignatureServiceListByAccountIdError>({
        path: `/web/v2/message/signature/listByAccountId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Renders the signature identified by ID with placeholders replaced for the given user. Returns the rendered signature text.
     *
     * @tags SignatureService
     * @name SignatureServiceRenderById
     * @summary Render a signature by ID
     * @request GET:/web/v2/message/signature/renderById/{id}/user/{userId}
     */
    signatureServiceRenderById: (id: string, userId: string, params: RequestParams = {}) =>
      this.request<SignatureServiceRenderByIdData, SignatureServiceRenderByIdError>({
        path: `/web/v2/message/signature/renderById/${id}/user/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates a new signature or updates an existing one when id is provided. Accepts account ID, name, and signature text. Returns the saved signature.
     *
     * @tags SignatureService
     * @name SignatureServiceSetSignature
     * @summary Create or update a signature
     * @request POST:/web/v2/message/signature/setSignature
     */
    signatureServiceSetSignature: (body: V2SetSignatureRequest, params: RequestParams = {}) =>
      this.request<SignatureServiceSetSignatureData, SignatureServiceSetSignatureError>({
        path: `/web/v2/message/signature/setSignature`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the signature for the given account. This is the legacy single-signature-per-account API.
     *
     * @tags SignatureService
     * @name SignatureServiceGet
     * @summary Get account signature
     * @request GET:/web/v2/message/signature/{accountId}/get
     */
    signatureServiceGet: (accountId: string, params: RequestParams = {}) =>
      this.request<SignatureServiceGetData, SignatureServiceGetError>({
        path: `/web/v2/message/signature/${accountId}/get`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Renders the account signature with placeholders replaced for the given user. Returns the rendered signature text.
     *
     * @tags SignatureService
     * @name SignatureServiceRender
     * @summary Render account signature
     * @request GET:/web/v2/message/signature/{accountId}/render/{userId}
     */
    signatureServiceRender: (accountId: string, userId: string, params: RequestParams = {}) =>
      this.request<SignatureServiceRenderData, SignatureServiceRenderError>({
        path: `/web/v2/message/signature/${accountId}/render/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets the signature text for the given account. This is the legacy single-signature-per-account API.
     *
     * @tags SignatureService
     * @name SignatureServiceSet
     * @summary Set account signature
     * @request POST:/web/v2/message/signature/{accountId}/set
     */
    signatureServiceSet: (accountId: string, body: SignatureServiceSetPayload, params: RequestParams = {}) =>
      this.request<SignatureServiceSetData, SignatureServiceSetError>({
        path: `/web/v2/message/signature/${accountId}/set`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the signature identified by the given ID.
     *
     * @tags SignatureService
     * @name SignatureServiceDeleteSignature
     * @summary Delete a signature
     * @request DELETE:/web/v2/message/signature/{id}/delete
     */
    signatureServiceDeleteSignature: (id: string, params: RequestParams = {}) =>
      this.request<SignatureServiceDeleteSignatureData, SignatureServiceDeleteSignatureError>({
        path: `/web/v2/message/signature/${id}/delete`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Renders the given text and optional title for multiple entries, each with contact, object, property, and building IDs. Returns one rendered text/title result per contact.
     *
     * @tags TemplateService
     * @name TemplateServiceBulkRenderText
     * @summary Bulk render free-form template text
     * @request POST:/web/v2/message/template/bulkRenderText
     */
    templateServiceBulkRenderText: (body: V2BulkRenderTextRequest, params: RequestParams = {}) =>
      this.request<TemplateServiceBulkRenderTextData, TemplateServiceBulkRenderTextError>({
        path: `/web/v2/message/template/bulkRenderText`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new message template for the given owner. Accepts type (email, letter, ticket, or deep sign), name, subject, message body, optional attachment media IDs, and language. Returns the created template.
     *
     * @tags TemplateService
     * @name TemplateServiceCreate
     * @summary Create a message template
     * @request POST:/web/v2/message/template/create
     */
    templateServiceCreate: (body: Messagetemplatev2CreateRequest, params: RequestParams = {}) =>
      this.request<TemplateServiceCreateData, TemplateServiceCreateError>({
        path: `/web/v2/message/template/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all message templates belonging to the given owner.
     *
     * @tags TemplateService
     * @name TemplateServiceList
     * @summary List message templates for an owner
     * @request GET:/web/v2/message/template/list
     */
    templateServiceList: (query: TemplateServiceListParams, params: RequestParams = {}) =>
      this.request<TemplateServiceListData, TemplateServiceListError>({
        path: `/web/v2/message/template/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Renders the given text and optional title using contact and object IDs for placeholder substitution. Returns the rendered text and title.
     *
     * @tags TemplateService
     * @name TemplateServiceRenderText
     * @summary Render free-form template text
     * @request POST:/web/v2/message/template/renderText
     */
    templateServiceRenderText: (body: V2RenderTextRequest, params: RequestParams = {}) =>
      this.request<TemplateServiceRenderTextData, TemplateServiceRenderTextError>({
        path: `/web/v2/message/template/renderText`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the message templates identified by the given IDs.
     *
     * @tags TemplateService
     * @name TemplateServiceDelete
     * @summary Delete message templates
     * @request DELETE:/web/v2/message/template/{ids}
     */
    templateServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<TemplateServiceDeleteData, TemplateServiceDeleteError>({
        path: `/web/v2/message/template/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Renders the template identified by ID using optional contact, object, property, and building IDs for placeholder substitution. Returns subject, rendered text, and attachment media IDs.
     *
     * @tags TemplateService
     * @name TemplateServiceRender
     * @summary Render a message template
     * @request POST:/web/v2/message/template/{id}/render
     */
    templateServiceRender: (id: string, body: TemplateServiceRenderPayload, params: RequestParams = {}) =>
      this.request<TemplateServiceRenderData, TemplateServiceRenderError>({
        path: `/web/v2/message/template/${id}/render`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing message template by ID, including name, subject, message body, attachment media IDs, and language.
     *
     * @tags TemplateService
     * @name TemplateServiceUpdate
     * @summary Update a message template
     * @request POST:/web/v2/message/template/{id}/update
     */
    templateServiceUpdate: (id: string, body: TemplateServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<TemplateServiceUpdateData, TemplateServiceUpdateError>({
        path: `/web/v2/message/template/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the contract relation number for the contract identified by ownerId and numericId.
     *
     * @tags AccountingService
     * @name AccountingServiceChangeContractRelation
     * @summary Change a contract relation number
     * @request POST:/web/objects/accounting/changeContractRelation
     */
    accountingServiceChangeContractRelation: (
      body: AccountingChangeContractRelationRequest,
      params: RequestParams = {},
    ) =>
      this.request<AccountingServiceChangeContractRelationData, AccountingServiceChangeContractRelationError>({
        path: `/web/objects/accounting/changeContractRelation`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of document sync log entries for the given accountId. Response includes totalLogsCount and totalPageCount.
     *
     * @tags AccountingService
     * @name AccountingServiceGetDocSyncLogs
     * @summary Get document sync logs
     * @request GET:/web/objects/accounting/getDocSyncLogs/{accountId}
     */
    accountingServiceGetDocSyncLogs: (
      { accountId, ...query }: AccountingServiceGetDocSyncLogsParams,
      params: RequestParams = {},
    ) =>
      this.request<AccountingServiceGetDocSyncLogsData, AccountingServiceGetDocSyncLogsError>({
        path: `/web/objects/accounting/getDocSyncLogs/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns accounting enablement and connection configuration for the given accountId. Usernames are returned; passwords are never included.
     *
     * @tags AccountingService
     * @name AccountingServiceGetEnabled
     * @summary Get accounting enablement config
     * @request GET:/web/objects/accounting/getEnabled/{accountId}
     */
    accountingServiceGetEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<AccountingServiceGetEnabledData, AccountingServiceGetEnabledError>({
        path: `/web/objects/accounting/getEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of accounting sync log entries for the given accountId. Response includes totalLogsCount and totalPageCount.
     *
     * @tags AccountingService
     * @name AccountingServiceGetLogs
     * @summary Get accounting sync logs
     * @request GET:/web/objects/accounting/getLogs/{accountId}
     */
    accountingServiceGetLogs: ({ accountId, ...query }: AccountingServiceGetLogsParams, params: RequestParams = {}) =>
      this.request<AccountingServiceGetLogsData, AccountingServiceGetLogsError>({
        path: `/web/objects/accounting/getLogs/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns accounting sync statistics for the given accountId, including enablement, source/target accounts, contract sync counts, last sync time, and contract errors.
     *
     * @tags AccountingService
     * @name AccountingServiceGetStatistics
     * @summary Get accounting sync statistics
     * @request GET:/web/objects/accounting/getStatistics/{accountId}
     */
    accountingServiceGetStatistics: (accountId: number, params: RequestParams = {}) =>
      this.request<AccountingServiceGetStatisticsData, AccountingServiceGetStatisticsError>({
        path: `/web/objects/accounting/getStatistics/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether accounting sync is enabled for each of the given property IDs.
     *
     * @tags AccountingService
     * @name AccountingServiceIsEnabled
     * @summary Check accounting enablement for properties
     * @request POST:/web/objects/accounting/isEnabled
     */
    accountingServiceIsEnabled: (body: AccountingIsEnabledRequest, params: RequestParams = {}) =>
      this.request<AccountingServiceIsEnabledData, AccountingServiceIsEnabledError>({
        path: `/web/objects/accounting/isEnabled`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all contract sync error infos (owner, numeric ID, debtor, messages, last sync time). The request has no parameters.
     *
     * @tags AccountingService
     * @name AccountingServiceListAllContractErrors
     * @summary List all contract sync errors
     * @request GET:/web/objects/accounting/listAllContractErrors
     */
    accountingServiceListAllContractErrors: (params: RequestParams = {}) =>
      this.request<AccountingServiceListAllContractErrorsData, AccountingServiceListAllContractErrorsError>({
        path: `/web/objects/accounting/listAllContractErrors`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Configures accounting enablement for accountId, including target account/mandant/provider/system IDs, sync flags, Abacus connection, and optional credentials (passwords applied when updatePasswords is true or on first provision).
     *
     * @tags AccountingService
     * @name AccountingServiceSetEnabled
     * @summary Configure accounting enablement
     * @request POST:/web/objects/accounting/setEnabled
     */
    accountingServiceSetEnabled: (body: AccountingSetEnabledRequest, params: RequestParams = {}) =>
      this.request<AccountingServiceSetEnabledData, AccountingServiceSetEnabledError>({
        path: `/web/objects/accounting/setEnabled`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Skips the next accounting sync event for the given accountId.
     *
     * @tags AccountingService
     * @name AccountingServiceSkipNextEvent
     * @summary Skip the next accounting event
     * @request POST:/web/objects/accounting/skipNextEvent
     */
    accountingServiceSkipNextEvent: (body: AccountingSkipNextEventRequest, params: RequestParams = {}) =>
      this.request<AccountingServiceSkipNextEventData, AccountingServiceSkipNextEventError>({
        path: `/web/objects/accounting/skipNextEvent`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Manually triggers a back-sync of debit-until data from the accounting system for the given accountId.
     *
     * @tags AccountingService
     * @name AccountingServiceTriggerDebitUntilSync
     * @summary Trigger debit-until back-sync
     * @request POST:/web/objects/accounting/triggerDebitUntilSync/{accountId}
     */
    accountingServiceTriggerDebitUntilSync: (accountId: string, params: RequestParams = {}) =>
      this.request<AccountingServiceTriggerDebitUntilSyncData, AccountingServiceTriggerDebitUntilSyncError>({
        path: `/web/objects/accounting/triggerDebitUntilSync/${accountId}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Manually triggers a back-sync of documents from the accounting system for the given accountId.
     *
     * @tags AccountingService
     * @name AccountingServiceTriggerDocumentSync
     * @summary Trigger document back-sync
     * @request POST:/web/objects/accounting/triggerDocumentSync/{accountId}
     */
    accountingServiceTriggerDocumentSync: (accountId: string, params: RequestParams = {}) =>
      this.request<AccountingServiceTriggerDocumentSyncData, AccountingServiceTriggerDocumentSyncError>({
        path: `/web/objects/accounting/triggerDocumentSync/${accountId}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Manually triggers a back-sync of rent adjustments from the accounting system for the given accountId.
     *
     * @tags AccountingService
     * @name AccountingServiceTriggerRentAdjustmentSync
     * @summary Trigger rent adjustment back-sync
     * @request POST:/web/objects/accounting/triggerRentAdjustmentSync/{accountId}
     */
    accountingServiceTriggerRentAdjustmentSync: (accountId: string, params: RequestParams = {}) =>
      this.request<AccountingServiceTriggerRentAdjustmentSyncData, AccountingServiceTriggerRentAdjustmentSyncError>({
        path: `/web/objects/accounting/triggerRentAdjustmentSync/${accountId}`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Adds the given craftsman contact IDs to the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceAddCraftsmen
     * @summary Add craftsmen to objects
     * @request POST:/web/objects/addCraftsmen
     */
    objectServiceAddCraftsmen: (body: ObjectAddCraftsmenRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceAddCraftsmenData, ObjectServiceAddCraftsmenError>({
        path: `/web/objects/addCraftsmen`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Appends document IDs to the object identified by ID. Returns the updated object.
     *
     * @tags ObjectService
     * @name ObjectServiceAddDocuments
     * @summary Add documents to an object
     * @request POST:/web/objects/addDocuments
     */
    objectServiceAddDocuments: (body: ObjectobjectAddDocumentsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceAddDocumentsData, ObjectServiceAddDocumentsError>({
        path: `/web/objects/addDocuments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds the given janitor contact IDs to the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceAddJanitors
     * @summary Add janitors to objects
     * @request POST:/web/objects/addJanitors
     */
    objectServiceAddJanitors: (body: ObjectAddJanitorsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceAddJanitorsData, ObjectServiceAddJanitorsError>({
        path: `/web/objects/addJanitors`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds the given service provider contact IDs to the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceAddServiceProviders
     * @summary Add service providers to objects
     * @request POST:/web/objects/addServiceProviders
     */
    objectServiceAddServiceProviders: (body: ObjectAddServiceProvidersRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceAddServiceProvidersData, ObjectServiceAddServiceProvidersError>({
        path: `/web/objects/addServiceProviders`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the Briefbutler error entries identified by the given IDs as acknowledged.
     *
     * @tags BriefbutlerService
     * @name BriefbutlerServiceAcknowledgeErrors
     * @summary Acknowledge Briefbutler errors
     * @request GET:/web/objects/briefbutler/acknowledgeErrors
     */
    briefbutlerServiceAcknowledgeErrors: (
      query: BriefbutlerServiceAcknowledgeErrorsParams,
      params: RequestParams = {},
    ) =>
      this.request<BriefbutlerServiceAcknowledgeErrorsData, BriefbutlerServiceAcknowledgeErrorsError>({
        path: `/web/objects/briefbutler/acknowledgeErrors`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns Briefbutler error entries for the given ownerId, including error message, media ID, entity ID, timestamp and render ID.
     *
     * @tags BriefbutlerService
     * @name BriefbutlerServiceListErrorsByAccountId
     * @summary List Briefbutler errors for an owner
     * @request GET:/web/objects/briefbutler/listErrorsByAccountId
     */
    briefbutlerServiceListErrorsByAccountId: (
      query: BriefbutlerServiceListErrorsByAccountIdParams,
      params: RequestParams = {},
    ) =>
      this.request<BriefbutlerServiceListErrorsByAccountIdData, BriefbutlerServiceListErrorsByAccountIdError>({
        path: `/web/objects/briefbutler/listErrorsByAccountId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns whether Briefbutler is enabled for the given accountId and the configured Briefbutler profiles.
     *
     * @tags BriefbutlerService
     * @name BriefbutlerServiceLoadSettings
     * @summary Load Briefbutler settings
     * @request GET:/web/objects/briefbutler/loadSettings
     */
    briefbutlerServiceLoadSettings: (query: BriefbutlerServiceLoadSettingsParams, params: RequestParams = {}) =>
      this.request<BriefbutlerServiceLoadSettingsData, BriefbutlerServiceLoadSettingsError>({
        path: `/web/objects/briefbutler/loadSettings`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Saves Briefbutler enabled state and profiles (briefbutlerId and description) for the given accountId.
     *
     * @tags BriefbutlerService
     * @name BriefbutlerServiceSaveSettings
     * @summary Save Briefbutler settings
     * @request POST:/web/objects/briefbutler/saveSettings
     */
    briefbutlerServiceSaveSettings: (body: ObjectbriefbutlerSaveSettingsRequest, params: RequestParams = {}) =>
      this.request<BriefbutlerServiceSaveSettingsData, BriefbutlerServiceSaveSettingsError>({
        path: `/web/objects/briefbutler/saveSettings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends the media document identified by mediaId through the Briefbutler profile identified by briefbutlerId.
     *
     * @tags BriefbutlerService
     * @name BriefbutlerServiceSendRawDocument
     * @summary Send a raw document via Briefbutler
     * @request POST:/web/objects/briefbutler/sendRawDocument
     */
    briefbutlerServiceSendRawDocument: (body: BriefbutlerSendRawDocumentRequest, params: RequestParams = {}) =>
      this.request<BriefbutlerServiceSendRawDocumentData, BriefbutlerServiceSendRawDocumentError>({
        path: `/web/objects/briefbutler/sendRawDocument`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds the given building contacts (type and note) to the buildings identified by ids.
     *
     * @tags BuildingService
     * @name BuildingServiceAddBuildingContacts
     * @summary Add contacts to buildings
     * @request POST:/web/objects/building/addBuildingContacts
     */
    buildingServiceAddBuildingContacts: (body: BuildingAddBuildingContactsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceAddBuildingContactsData, BuildingServiceAddBuildingContactsError>({
        path: `/web/objects/building/addBuildingContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Appends the given document IDs to the building identified by id. Returns the updated building.
     *
     * @tags BuildingService
     * @name BuildingServiceAddDocuments
     * @summary Add documents to a building
     * @request POST:/web/objects/building/addDocuments
     */
    buildingServiceAddDocuments: (body: ObjectbuildingAddDocumentsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceAddDocumentsData, BuildingServiceAddDocumentsError>({
        path: `/web/objects/building/addDocuments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of buildings visible for the given account under the specified share scope.
     *
     * @tags BuildingService
     * @name BuildingServiceCount
     * @summary Count buildings for an account
     * @request GET:/web/objects/building/count/{accountId}
     */
    buildingServiceCount: ({ accountId, ...query }: BuildingServiceCountParams, params: RequestParams = {}) =>
      this.request<BuildingServiceCountData, BuildingServiceCountError>({
        path: `/web/objects/building/count/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new building for the given owner. Optional numericId may be supplied; otherwise it can be generated by the service. Accepts address, plots, objects, construction details, energy sources, contacts, and related metadata. Returns the created building.
     *
     * @tags BuildingService
     * @name BuildingServiceCreate
     * @summary Create a building
     * @request POST:/web/objects/building/create
     */
    buildingServiceCreate: (body: ObjectbuildingCreateRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceCreateData, BuildingServiceCreateError>({
        path: `/web/objects/building/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates notes on the given building contacts for the buildings identified by ids.
     *
     * @tags BuildingService
     * @name BuildingServiceEditContactNote
     * @summary Edit building contact notes
     * @request POST:/web/objects/building/editContactNote
     */
    buildingServiceEditContactNote: (body: BuildingEditBuildingContactsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceEditContactNoteData, BuildingServiceEditContactNoteError>({
        path: `/web/objects/building/editContactNote`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the building identified by the given building ID.
     *
     * @tags BuildingService
     * @name BuildingServiceGet
     * @summary Get a building by ID
     * @request GET:/web/objects/building/get/{id}
     */
    buildingServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<BuildingServiceGetData, BuildingServiceGetError>({
        path: `/web/objects/building/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the building that contains the given object ID.
     *
     * @tags BuildingService
     * @name BuildingServiceGetByObjectId
     * @summary Get a building by object ID
     * @request GET:/web/objects/building/getByObjectId/{objectId}
     */
    buildingServiceGetByObjectId: (objectId: string, params: RequestParams = {}) =>
      this.request<BuildingServiceGetByObjectIdData, BuildingServiceGetByObjectIdError>({
        path: `/web/objects/building/getByObjectId/${objectId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of buildings for the given accountId. Supports filtering by name, address, zip range and network partners, and sorting by object count or rent figures. Response includes total object and page counts.
     *
     * @tags BuildingService
     * @name BuildingServiceList
     * @summary List buildings for an account
     * @request GET:/web/objects/building/list/{accountId}
     */
    buildingServiceList: ({ accountId, ...query }: BuildingServiceListParams, params: RequestParams = {}) =>
      this.request<BuildingServiceListData, BuildingServiceListError>({
        path: `/web/objects/building/list/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns all buildings visible for the given accountId without pagination.
     *
     * @tags BuildingService
     * @name BuildingServiceListAll
     * @summary List all buildings for an account
     * @request GET:/web/objects/building/listAll/{accountId}
     */
    buildingServiceListAll: (accountId: string, params: RequestParams = {}) =>
      this.request<BuildingServiceListAllData, BuildingServiceListAllError>({
        path: `/web/objects/building/listAll/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns buildings associated with any of the given contact IDs.
     *
     * @tags BuildingService
     * @name BuildingServiceListByContactIds
     * @summary List buildings by contact IDs
     * @request POST:/web/objects/building/listByContactIds
     */
    buildingServiceListByContactIds: (body: ObjectbuildingListByContactIdsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceListByContactIdsData, BuildingServiceListByContactIdsError>({
        path: `/web/objects/building/listByContactIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns buildings within the bounding box defined by southWest and northEast coordinates, filtered by the given share scope.
     *
     * @tags BuildingService
     * @name BuildingServiceListByCoordinates
     * @summary List buildings by map coordinates
     * @request GET:/web/objects/building/listByCoordinates
     */
    buildingServiceListByCoordinates: (query: BuildingServiceListByCoordinatesParams, params: RequestParams = {}) =>
      this.request<BuildingServiceListByCoordinatesData, BuildingServiceListByCoordinatesError>({
        path: `/web/objects/building/listByCoordinates`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the buildings matching the given building IDs.
     *
     * @tags BuildingService
     * @name BuildingServiceListByIds
     * @summary List buildings by IDs
     * @request POST:/web/objects/building/listByIds
     */
    buildingServiceListByIds: (body: ObjectbuildingListByIdsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceListByIdsData, BuildingServiceListByIdsError>({
        path: `/web/objects/building/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns buildings that contain any of the given object IDs.
     *
     * @tags BuildingService
     * @name BuildingServiceListByObjectIds
     * @summary List buildings by object IDs
     * @request POST:/web/objects/building/listByObjectIds
     */
    buildingServiceListByObjectIds: (body: ObjectbuildingListByObjectIdsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceListByObjectIdsData, BuildingServiceListByObjectIdsError>({
        path: `/web/objects/building/listByObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns building filter options (id, name, ownerId, objectIds) available to the authenticated caller. Options are determined by authorization data; the request has no parameters.
     *
     * @tags BuildingService
     * @name BuildingServiceListFilterOptions
     * @summary List building filter options
     * @request GET:/web/objects/building/listFilterOptions
     */
    buildingServiceListFilterOptions: (params: RequestParams = {}) =>
      this.request<BuildingServiceListFilterOptionsData, BuildingServiceListFilterOptionsError>({
        path: `/web/objects/building/listFilterOptions`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Removes the given building contacts from the buildings identified by ids.
     *
     * @tags BuildingService
     * @name BuildingServiceRemoveBuildingContacts
     * @summary Remove contacts from buildings
     * @request POST:/web/objects/building/removeBuildingContacts
     */
    buildingServiceRemoveBuildingContacts: (body: BuildingRemoveBuildingContactsRequest, params: RequestParams = {}) =>
      this.request<BuildingServiceRemoveBuildingContactsData, BuildingServiceRemoveBuildingContactsError>({
        path: `/web/objects/building/removeBuildingContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the building identified by id.
     *
     * @tags BuildingService
     * @name BuildingServiceDelete
     * @summary Delete a building
     * @request DELETE:/web/objects/building/{id}
     */
    buildingServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<BuildingServiceDeleteData, BuildingServiceDeleteError>({
        path: `/web/objects/building/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Moves the building identified by id to newPropertyId. Optionally assigns new contract IDs when newContractIds is true.
     *
     * @tags BuildingService
     * @name BuildingServiceMoveBuilding
     * @summary Move a building to another property
     * @request POST:/web/objects/building/{id}/move
     */
    buildingServiceMoveBuilding: (id: string, body: BuildingServiceMoveBuildingPayload, params: RequestParams = {}) =>
      this.request<BuildingServiceMoveBuildingData, BuildingServiceMoveBuildingError>({
        path: `/web/objects/building/${id}/move`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing building by ID, including name, address, plots, objects, construction details, energy sources, contacts, rating, and related metadata. Returns the updated building.
     *
     * @tags BuildingService
     * @name BuildingServiceUpdate
     * @summary Update a building
     * @request POST:/web/objects/building/{id}/update
     */
    buildingServiceUpdate: (id: string, body: BuildingServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<BuildingServiceUpdateData, BuildingServiceUpdateError>({
        path: `/web/objects/building/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the microLocationRatingProposal on the building identified by id. Returns the updated building.
     *
     * @tags BuildingService
     * @name BuildingServiceUpdateMicroLocationRatingProposal
     * @summary Update micro-location rating proposal
     * @request POST:/web/objects/building/{id}/updateMicroLocationRatingProposal
     */
    buildingServiceUpdateMicroLocationRatingProposal: (
      id: string,
      body: BuildingServiceUpdateMicroLocationRatingProposalPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        BuildingServiceUpdateMicroLocationRatingProposalData,
        BuildingServiceUpdateMicroLocationRatingProposalError
      >({
        path: `/web/objects/building/${id}/updateMicroLocationRatingProposal`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new condominium for the given owner and object. Optional numericId may be supplied; otherwise it can be generated by the service. Accepts contract, owner, tenants, rent, documents, and status flags. Returns the created condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceCreate
     * @summary Create a condominium
     * @request POST:/web/objects/condominium/create
     */
    condominiumServiceCreate: (body: ObjectcondominiumCreateRequest, params: RequestParams = {}) =>
      this.request<CondominiumServiceCreateData, CondominiumServiceCreateError>({
        path: `/web/objects/condominium/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes rent adjustments for the given object IDs that match the specified byDate.
     *
     * @tags CondominiumService
     * @name CondominiumServiceDeleteRentAdjustments
     * @summary Delete condominium rent adjustments
     * @request POST:/web/objects/condominium/deleteRentAdjustments
     */
    condominiumServiceDeleteRentAdjustments: (
      body: ObjectcondominiumDeleteRentAdjustmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceDeleteRentAdjustmentsData, CondominiumServiceDeleteRentAdjustmentsError>({
        path: `/web/objects/condominium/deleteRentAdjustments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the condominium identified by the given ID.
     *
     * @tags CondominiumService
     * @name CondominiumServiceGet
     * @summary Get a condominium by ID
     * @request GET:/web/objects/condominium/get/{id}
     */
    condominiumServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<CondominiumServiceGetData, CondominiumServiceGetError>({
        path: `/web/objects/condominium/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description For each given object ID, returns whether an activated condominium exists.
     *
     * @tags CondominiumService
     * @name CondominiumServiceHasActivatedCondominium
     * @summary Check activated condominiums by object IDs
     * @request POST:/web/objects/condominium/hasActivatedCondominium
     */
    condominiumServiceHasActivatedCondominium: (
      body: CondominiumHasActivatedCondominiumRequest,
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceHasActivatedCondominiumData, CondominiumServiceHasActivatedCondominiumError>({
        path: `/web/objects/condominium/hasActivatedCondominium`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns condominiums where the given contact ID is the billing contact.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByBillingContactId
     * @summary List condominiums by billing contact
     * @request GET:/web/objects/condominium/listByBillingContactId/{billingContactId}
     */
    condominiumServiceListByBillingContactId: (billingContactId: string, params: RequestParams = {}) =>
      this.request<CondominiumServiceListByBillingContactIdData, CondominiumServiceListByBillingContactIdError>({
        path: `/web/objects/condominium/listByBillingContactId/${billingContactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns condominiums involving the given contact ID. Role filters (billingContact, owners, correspondence, roommates, tenants) control which contact roles are matched.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByContactId
     * @summary List condominiums by contact ID
     * @request GET:/web/objects/condominium/listByContactId/{contactId}
     */
    condominiumServiceListByContactId: (
      { contactId, ...query }: CondominiumServiceListByContactIdParams,
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceListByContactIdData, CondominiumServiceListByContactIdError>({
        path: `/web/objects/condominium/listByContactId/${contactId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the condominiums matching the given condominium IDs.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByIds
     * @summary List condominiums by IDs
     * @request POST:/web/objects/condominium/listByIds
     */
    condominiumServiceListByIds: (body: ObjectcondominiumListByIdsRequest, params: RequestParams = {}) =>
      this.request<CondominiumServiceListByIdsData, CondominiumServiceListByIdsError>({
        path: `/web/objects/condominium/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns condominiums linked to any of the given object IDs.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByObjectIds
     * @summary List condominiums by object IDs
     * @request POST:/web/objects/condominium/listByObjectIds
     */
    condominiumServiceListByObjectIds: (body: ObjectcondominiumListByObjectIdsRequest, params: RequestParams = {}) =>
      this.request<CondominiumServiceListByObjectIdsData, CondominiumServiceListByObjectIdsError>({
        path: `/web/objects/condominium/listByObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all condominiums belonging to the given owner account ID.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByOwner
     * @summary List condominiums for an owner
     * @request GET:/web/objects/condominium/listByOwner/{ownerId}
     */
    condominiumServiceListByOwner: (ownerId: string, params: RequestParams = {}) =>
      this.request<CondominiumServiceListByOwnerData, CondominiumServiceListByOwnerError>({
        path: `/web/objects/condominium/listByOwner/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns condominiums where the given contact ID is an owner contact.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByOwnerContact
     * @summary List condominiums by owner contact
     * @request GET:/web/objects/condominium/listByOwnerContact/{ownerContactId}
     */
    condominiumServiceListByOwnerContact: (ownerContactId: string, params: RequestParams = {}) =>
      this.request<CondominiumServiceListByOwnerContactData, CondominiumServiceListByOwnerContactError>({
        path: `/web/objects/condominium/listByOwnerContact/${ownerContactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns condominiums linked to any of the given tenant contact IDs.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListByTenantContacts
     * @summary List condominiums by tenant contacts
     * @request GET:/web/objects/condominium/listByTenantContacts/{tenantContactIds}
     */
    condominiumServiceListByTenantContacts: (tenantContactIds: string[], params: RequestParams = {}) =>
      this.request<CondominiumServiceListByTenantContactsData, CondominiumServiceListByTenantContactsError>({
        path: `/web/objects/condominium/listByTenantContacts/${tenantContactIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the current condominiums for the given object IDs.
     *
     * @tags CondominiumService
     * @name CondominiumServiceListCurrentByObjectIds
     * @summary List current condominiums by object IDs
     * @request POST:/web/objects/condominium/listCurrentByObjectIds
     */
    condominiumServiceListCurrentByObjectIds: (
      body: ObjectcondominiumListCurrentByObjectIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceListCurrentByObjectIdsData, CondominiumServiceListCurrentByObjectIdsError>({
        path: `/web/objects/condominium/listCurrentByObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Publishes updated events for condominiums belonging to the given owner account IDs.
     *
     * @tags CondominiumService
     * @name CondominiumServicePublishUpdatedEvents
     * @summary Publish condominium updated events
     * @request POST:/web/objects/condominium/publishUpdatedEvents
     */
    condominiumServicePublishUpdatedEvents: (
      body: ObjectcondominiumPublishUpdatedEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServicePublishUpdatedEventsData, CondominiumServicePublishUpdatedEventsError>({
        path: `/web/objects/condominium/publishUpdatedEvents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple condominiums in one request via the given entries. Returns the updated condominiums.
     *
     * @tags CondominiumService
     * @name CondominiumServiceUpdateBulk
     * @summary Update condominiums in bulk
     * @request POST:/web/objects/condominium/updateBulk
     */
    condominiumServiceUpdateBulk: (body: ObjectcondominiumUpdateBulkRequest, params: RequestParams = {}) =>
      this.request<CondominiumServiceUpdateBulkData, CondominiumServiceUpdateBulkError>({
        path: `/web/objects/condominium/updateBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the condominium with the given ID.
     *
     * @tags CondominiumService
     * @name CondominiumServiceDelete
     * @summary Delete a condominium
     * @request DELETE:/web/objects/condominium/{id}
     */
    condominiumServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<CondominiumServiceDeleteData, CondominiumServiceDeleteError>({
        path: `/web/objects/condominium/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Activates the condominium identified by ID. Optional document IDs may be attached. Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceActivate
     * @summary Activate a condominium
     * @request POST:/web/objects/condominium/{id}/activate
     */
    condominiumServiceActivate: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceActivateData, CondominiumServiceActivateError>({
        path: `/web/objects/condominium/${id}/activate`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Appends document IDs to the condominium identified by ID. Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceAddDocuments
     * @summary Add documents to a condominium
     * @request POST:/web/objects/condominium/{id}/addDocument
     */
    condominiumServiceAddDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceAddDocumentsData, CondominiumServiceAddDocumentsError>({
        path: `/web/objects/condominium/${id}/addDocument`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Deactivates the condominium identified by ID. Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceDeactivate
     * @summary Deactivate a condominium
     * @request POST:/web/objects/condominium/{id}/deactivate
     */
    condominiumServiceDeactivate: (id: string, body: object, params: RequestParams = {}) =>
      this.request<CondominiumServiceDeactivateData, CondominiumServiceDeactivateError>({
        path: `/web/objects/condominium/${id}/deactivate`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Removes the given document IDs from the condominium identified by ID. Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceRemoveDocuments
     * @summary Remove documents from a condominium
     * @request POST:/web/objects/condominium/{id}/removeDocuments
     */
    condominiumServiceRemoveDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceRemoveDocumentsData, CondominiumServiceRemoveDocumentsError>({
        path: `/web/objects/condominium/${id}/removeDocuments`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates an existing condominium by ID (dates, contract, owner, tenants, rent, documents, and status flags). Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceUpdate
     * @summary Update a condominium
     * @request POST:/web/objects/condominium/{id}/update
     */
    condominiumServiceUpdate: (id: string, body: CondominiumServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<CondominiumServiceUpdateData, CondominiumServiceUpdateError>({
        path: `/web/objects/condominium/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deactivates the condominium identified by owner account ID and numeric ID. Returns the updated condominium.
     *
     * @tags CondominiumService
     * @name CondominiumServiceDeactivateByNumericId
     * @summary Deactivate a condominium by numeric ID
     * @request POST:/web/objects/condominium/{numericId}/deactivateByNumericId
     */
    condominiumServiceDeactivateByNumericId: (
      numericId: string,
      body: {
        /** @format int64 */
        ownerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CondominiumServiceDeactivateByNumericIdData, CondominiumServiceDeactivateByNumericIdError>({
        path: `/web/objects/condominium/${numericId}/deactivateByNumericId`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Creates a new contract template for the given owner. Accepts creatorName, title, mediaId, and category. Returns the created template.
     *
     * @tags ContractService
     * @name ContractServiceCreateTemplate
     * @summary Create a contract template
     * @request POST:/web/objects/contract/template/create
     */
    contractServiceCreateTemplate: (body: ObjectcontractCreateTemplateRequest, params: RequestParams = {}) =>
      this.request<ContractServiceCreateTemplateData, ContractServiceCreateTemplateError>({
        path: `/web/objects/contract/template/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the contract templates with the given IDs.
     *
     * @tags ContractService
     * @name ContractServiceDeleteTemplate
     * @summary Delete contract templates
     * @request DELETE:/web/objects/contract/template/delete/{ids}
     */
    contractServiceDeleteTemplate: (ids: string[], params: RequestParams = {}) =>
      this.request<ContractServiceDeleteTemplateData, ContractServiceDeleteTemplateError>({
        path: `/web/objects/contract/template/delete/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the contract templates belonging to any of the given owner IDs.
     *
     * @tags ContractService
     * @name ContractServiceListTemplates
     * @summary List contract templates by owner IDs
     * @request GET:/web/objects/contract/template/list/{ownerIds}
     */
    contractServiceListTemplates: (ownerIds: string[], params: RequestParams = {}) =>
      this.request<ContractServiceListTemplatesData, ContractServiceListTemplatesError>({
        path: `/web/objects/contract/template/list/${ownerIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given tenancyId. Optional attachAutomatically, title, description, and signatories may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderTemplate
     * @summary Render a contract template for a tenancy
     * @request POST:/web/objects/contract/template/render
     */
    contractServiceRenderTemplate: (body: ContractRenderTemplateRequest, params: RequestParams = {}) =>
      this.request<ContractServiceRenderTemplateData, ContractServiceRenderTemplateError>({
        path: `/web/objects/contract/template/render`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given devices. Accepts order description, contact/assignee, on-site contact (onSiteContactPersonId or randomContactData), execution dates, title, and description. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderDeviceTemplate
     * @summary Render a contract template for devices
     * @request POST:/web/objects/contract/template/renderDevice
     */
    contractServiceRenderDeviceTemplate: (
      body: ObjectcontractRenderDeviceTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderDeviceTemplateData, ContractServiceRenderDeviceTemplateError>({
        path: `/web/objects/contract/template/renderDevice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given tenancy IDs. Optional title and description may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderTenanciesTemplate
     * @summary Render a contract template for multiple tenancies
     * @request POST:/web/objects/contract/template/renderTenancies
     */
    contractServiceRenderTenanciesTemplate: (
      body: ObjectcontractRenderTenanciesTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderTenanciesTemplateData, ContractServiceRenderTenanciesTemplateError>({
        path: `/web/objects/contract/template/renderTenancies`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing contract template by ID. Accepts title and mediaId.
     *
     * @tags ContractService
     * @name ContractServiceUpdateTemplate
     * @summary Update a contract template
     * @request POST:/web/objects/contract/template/update/{id}
     */
    contractServiceUpdateTemplate: (
      id: string,
      body: ContractServiceUpdateTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceUpdateTemplateData, ContractServiceUpdateTemplateError>({
        path: `/web/objects/contract/template/update/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given condominiumId. Optional attachAutomatically, title, and description may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderCondominiumTemplate
     * @summary Render a contract template for a condominium
     * @request POST:/web/objects/contracts/template/renderCondominium
     */
    contractServiceRenderCondominiumTemplate: (
      body: ObjectcontractRenderCondominiumTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderCondominiumTemplateData, ContractServiceRenderCondominiumTemplateError>({
        path: `/web/objects/contracts/template/renderCondominium`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given condominium IDs. Optional title and description may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderCondominiumsTemplate
     * @summary Render a contract template for multiple condominiums
     * @request POST:/web/objects/contracts/template/renderCondominiums
     */
    contractServiceRenderCondominiumsTemplate: (
      body: ObjectcontractRenderCondominiumsTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderCondominiumsTemplateData, ContractServiceRenderCondominiumsTemplateError>({
        path: `/web/objects/contracts/template/renderCondominiums`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given contactId. Optional attachAutomatically, title, and description may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderContactTemplate
     * @summary Render a contract template for a contact
     * @request POST:/web/objects/contracts/template/renderContact
     */
    contractServiceRenderContactTemplate: (
      body: ObjectcontractRenderContactTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderContactTemplateData, ContractServiceRenderContactTemplateError>({
        path: `/web/objects/contracts/template/renderContact`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders the contract template identified by ID for the given contact IDs. Optional title and description may be supplied. Returns the rendered contract bytes.
     *
     * @tags ContractService
     * @name ContractServiceRenderContactsTemplate
     * @summary Render a contract template for multiple contacts
     * @request POST:/web/objects/contracts/template/renderContacts
     */
    contractServiceRenderContactsTemplate: (
      body: ObjectcontractRenderContactsTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderContactsTemplateData, ContractServiceRenderContactsTemplateError>({
        path: `/web/objects/contracts/template/renderContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the inflation value for the given country index base year, month, and year.
     *
     * @tags CountryIndexService
     * @name CountryIndexServiceGetInflation
     * @summary Get inflation for a base year
     * @request GET:/web/objects/country-index/getInflation
     */
    countryIndexServiceGetInflation: (query: CountryIndexServiceGetInflationParams, params: RequestParams = {}) =>
      this.request<CountryIndexServiceGetInflationData, CountryIndexServiceGetInflationError>({
        path: `/web/objects/country-index/getInflation`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Reads and processes a country index file from the given fileUrl.
     *
     * @tags CountryIndexService
     * @name CountryIndexServiceRead
     * @summary Read a country index file
     * @request POST:/web/objects/country-index/read
     */
    countryIndexServiceRead: (body: CountryIndexReadRequest, params: RequestParams = {}) =>
      this.request<CountryIndexServiceReadData, CountryIndexServiceReadError>({
        path: `/web/objects/country-index/read`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new object for the given owner and building. Optional numericId may be supplied; otherwise it can be generated by the service. Accepts type, category, address, contacts, media, characteristics, pricing, and marketing fields. Returns the created object.
     *
     * @tags ObjectService
     * @name ObjectServiceCreate
     * @summary Create an object
     * @request POST:/web/objects/create
     */
    objectServiceCreate: (body: ObjectobjectCreateRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceCreateData, ObjectServiceCreateError>({
        path: `/web/objects/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates multiple objects for the given owner and building. Shared fields include address, type, category, administration type, marketing language, and the number of objects to create (amount).
     *
     * @tags ObjectService
     * @name ObjectServiceCreateBulk
     * @summary Create objects in bulk
     * @request POST:/web/objects/createBulk
     */
    objectServiceCreateBulk: (body: ObjectobjectCreateBulkRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceCreateBulkData, ObjectServiceCreateBulkError>({
        path: `/web/objects/createBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates demo data for the given accountId using the selected DemoDataSet (1, 2, or 3).
     *
     * @tags DemoDataService
     * @name DemoDataServiceGenerate
     * @summary Generate demo data
     * @request POST:/web/objects/demo-data/generate
     */
    demoDataServiceGenerate: (body: ObjectdemoDataGenerateRequest, params: RequestParams = {}) =>
      this.request<DemoDataServiceGenerateData, DemoDataServiceGenerateError>({
        path: `/web/objects/demo-data/generate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new device for the given ownerId and referenceId, including facility plant, system, type, manufacturer details, costs, condition, maintenance/inspection/revision data, and optional documents and images. Returns the created device.
     *
     * @tags DeviceService
     * @name DeviceServiceCreate
     * @summary Create a device
     * @request POST:/web/objects/device/create
     */
    deviceServiceCreate: (body: ObjectdeviceCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceServiceCreateData, DeviceServiceCreateError>({
        path: `/web/objects/device/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns default data entries (facility plant, system, bkpH, catalogue price, unit, life span) for the optional device type, or for all device types when type is omitted.
     *
     * @tags DeviceService
     * @name DeviceServiceGetDefaultData
     * @summary Get default device data
     * @request GET:/web/objects/device/getDefaultData
     */
    deviceServiceGetDefaultData: (query: DeviceServiceGetDefaultDataParams, params: RequestParams = {}) =>
      this.request<DeviceServiceGetDefaultDataData, DeviceServiceGetDefaultDataError>({
        path: `/web/objects/device/getDefaultData`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the devices matching the given device IDs.
     *
     * @tags DeviceService
     * @name DeviceServiceListByIds
     * @summary List devices by IDs
     * @request POST:/web/objects/device/listByIds
     */
    deviceServiceListByIds: (body: ObjectdeviceListByIdsRequest, params: RequestParams = {}) =>
      this.request<DeviceServiceListByIdsData, DeviceServiceListByIdsError>({
        path: `/web/objects/device/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns devices for the given reference IDs. Optional page and itemsPerPage enable pagination; response includes totalDevices and totalPages. Optional filters, text search and sorting are evaluated on device data only: anything owned by other services (object category, floor, tenants, object name, localized labels, ...) must be resolved by the caller into referenceIds, roomIds or enum values.
     *
     * @tags DeviceService
     * @name DeviceServiceListByReferenceIds
     * @summary List devices by reference IDs
     * @request POST:/web/objects/device/listByReferenceIds
     */
    deviceServiceListByReferenceIds: (body: ObjectdeviceListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<DeviceServiceListByReferenceIdsData, DeviceServiceListByReferenceIdsError>({
        path: `/web/objects/device/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the device identified by id.
     *
     * @tags DeviceService
     * @name DeviceServiceDelete
     * @summary Delete a device
     * @request DELETE:/web/objects/device/{id}
     */
    deviceServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<DeviceServiceDeleteData, DeviceServiceDeleteError>({
        path: `/web/objects/device/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Appends the given document IDs to the device identified by id. Returns the updated device.
     *
     * @tags DeviceService
     * @name DeviceServiceAddDocuments
     * @summary Add documents to a device
     * @request POST:/web/objects/device/{id}/addDocuments
     */
    deviceServiceAddDocuments: ({ id, ...query }: DeviceServiceAddDocumentsParams, params: RequestParams = {}) =>
      this.request<DeviceServiceAddDocumentsData, DeviceServiceAddDocumentsError>({
        path: `/web/objects/device/${id}/addDocuments`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Updates an existing device by ID, including reference, room, facility plant, system, type, manufacturer details, costs, condition, maintenance/inspection/revision data, documents, and images. Returns the updated device.
     *
     * @tags DeviceService
     * @name DeviceServiceUpdate
     * @summary Update a device
     * @request POST:/web/objects/device/{id}/update
     */
    deviceServiceUpdate: (id: string, body: DeviceServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<DeviceServiceUpdateData, DeviceServiceUpdateError>({
        path: `/web/objects/device/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new energy source for the given owner and referenceId. Accepts kind, type, heat/cost distribution, consumption metrics, tank readings, orders, and document IDs. Returns the created energy source.
     *
     * @tags EnergySourceService
     * @name EnergySourceServiceCreate
     * @summary Create an energy source
     * @request POST:/web/objects/energy-source/create
     */
    energySourceServiceCreate: (body: ObjectenergySourceCreateRequest, params: RequestParams = {}) =>
      this.request<EnergySourceServiceCreateData, EnergySourceServiceCreateError>({
        path: `/web/objects/energy-source/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the energy sources matching the given IDs.
     *
     * @tags EnergySourceService
     * @name EnergySourceServiceListByIds
     * @summary List energy sources by IDs
     * @request POST:/web/objects/energy-source/listByIds
     */
    energySourceServiceListByIds: (body: ObjectenergySourceListByIdsRequest, params: RequestParams = {}) =>
      this.request<EnergySourceServiceListByIdsData, EnergySourceServiceListByIdsError>({
        path: `/web/objects/energy-source/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the energy sources matching the given reference IDs.
     *
     * @tags EnergySourceService
     * @name EnergySourceServiceListByReferenceIds
     * @summary List energy sources by reference IDs
     * @request POST:/web/objects/energy-source/listByReferenceIds
     */
    energySourceServiceListByReferenceIds: (
      body: ObjectenergySourceListByReferenceIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<EnergySourceServiceListByReferenceIdsData, EnergySourceServiceListByReferenceIdsError>({
        path: `/web/objects/energy-source/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the energy sources with the given IDs.
     *
     * @tags EnergySourceService
     * @name EnergySourceServiceDelete
     * @summary Delete energy sources
     * @request DELETE:/web/objects/energy-source/{ids}
     */
    energySourceServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<EnergySourceServiceDeleteData, EnergySourceServiceDeleteError>({
        path: `/web/objects/energy-source/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates an existing energy source by ID. Accepts kind, type, heat/cost distribution, consumption metrics, tank readings, orders, and document IDs. Returns the updated energy source.
     *
     * @tags EnergySourceService
     * @name EnergySourceServiceUpdate
     * @summary Update an energy source
     * @request POST:/web/objects/energy-source/{id}/update
     */
    energySourceServiceUpdate: (id: string, body: EnergySourceServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<EnergySourceServiceUpdateData, EnergySourceServiceUpdateError>({
        path: `/web/objects/energy-source/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the Fahrlaender API configuration for the given account, including credentials and enabled features.
     *
     * @tags FahrlaenderService
     * @name FahrlaenderServiceLoadConfiguration
     * @summary Load Fahrlaender configuration
     * @request GET:/web/objects/fahrlaender/{accountId}/loadConfiguration
     */
    fahrlaenderServiceLoadConfiguration: (accountId: string, params: RequestParams = {}) =>
      this.request<FahrlaenderServiceLoadConfigurationData, FahrlaenderServiceLoadConfigurationError>({
        path: `/web/objects/fahrlaender/${accountId}/loadConfiguration`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Saves the Fahrlaender API configuration for the given account, including apiUser, apiPassword, and enabled features (micro location and/or market rent).
     *
     * @tags FahrlaenderService
     * @name FahrlaenderServiceSaveConfiguration
     * @summary Save Fahrlaender configuration
     * @request POST:/web/objects/fahrlaender/{accountId}/saveConfiguration
     */
    fahrlaenderServiceSaveConfiguration: (
      accountId: string,
      body: FahrlaenderServiceSaveConfigurationPayload,
      params: RequestParams = {},
    ) =>
      this.request<FahrlaenderServiceSaveConfigurationData, FahrlaenderServiceSaveConfigurationError>({
        path: `/web/objects/fahrlaender/${accountId}/saveConfiguration`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Triggers market rent update commands for the given account. Returns the number of commands published.
     *
     * @tags FahrlaenderService
     * @name FahrlaenderServiceUpdateMarketRent
     * @summary Update market rents via Fahrlaender
     * @request POST:/web/objects/fahrlaender/{accountId}/updateMarketRent
     */
    fahrlaenderServiceUpdateMarketRent: (accountId: string, body: object, params: RequestParams = {}) =>
      this.request<FahrlaenderServiceUpdateMarketRentData, FahrlaenderServiceUpdateMarketRentError>({
        path: `/web/objects/fahrlaender/${accountId}/updateMarketRent`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Triggers micro location rating update commands for the given account. Returns the number of commands published.
     *
     * @tags FahrlaenderService
     * @name FahrlaenderServiceUpdateMicroLocationRatings
     * @summary Update micro location ratings via Fahrlaender
     * @request POST:/web/objects/fahrlaender/{accountId}/updateMicroLocationRating
     */
    fahrlaenderServiceUpdateMicroLocationRatings: (accountId: string, body: object, params: RequestParams = {}) =>
      this.request<FahrlaenderServiceUpdateMicroLocationRatingsData, FahrlaenderServiceUpdateMicroLocationRatingsError>(
        {
          path: `/web/objects/fahrlaender/${accountId}/updateMicroLocationRating`,
          method: "POST",
          body: body,
          ...params,
        },
      ),

    /**
     * @description Returns the object identified by the given ID.
     *
     * @tags ObjectService
     * @name ObjectServiceGet
     * @summary Get an object by ID
     * @request GET:/web/objects/get/{id}
     */
    objectServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetData, ObjectServiceGetError>({
        path: `/web/objects/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns vacancy, marketing, and publication statistics for objects shared with the given account under accounting scope.
     *
     * @tags ObjectService
     * @name ObjectServiceGetAccountingStatistics
     * @summary Get accounting statistics for an account
     * @request GET:/web/objects/getAccountingStatistics/{accountId}
     */
    objectServiceGetAccountingStatistics: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetAccountingStatisticsData, ObjectServiceGetAccountingStatisticsError>({
        path: `/web/objects/getAccountingStatistics/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns vacancy, marketing, and publication statistics for objects shared with the given account under management scope.
     *
     * @tags ObjectService
     * @name ObjectServiceGetAdministrationStatistics
     * @summary Get administration statistics for an account
     * @request GET:/web/objects/getAdministrationStatistics/{accountId}
     */
    objectServiceGetAdministrationStatistics: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetAdministrationStatisticsData, ObjectServiceGetAdministrationStatisticsError>({
        path: `/web/objects/getAdministrationStatistics/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns vacancy, marketing, and publication statistics for objects shared with the given account under asset scope.
     *
     * @tags ObjectService
     * @name ObjectServiceGetAssetStatistics
     * @summary Get asset statistics for an account
     * @request GET:/web/objects/getAssetStatistics/{accountId}
     */
    objectServiceGetAssetStatistics: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetAssetStatisticsData, ObjectServiceGetAssetStatisticsError>({
        path: `/web/objects/getAssetStatistics/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the object identified by the given public marketing ID.
     *
     * @tags ObjectService
     * @name ObjectServiceGetByPublicId
     * @summary Get object by public ID
     * @request GET:/web/objects/getByPublicId/{publicId}
     */
    objectServiceGetByPublicId: (publicId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetByPublicIdData, ObjectServiceGetByPublicIdError>({
        path: `/web/objects/getByPublicId/${publicId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns marketing-facing details for the object identified by ID, including title, description, address, availability, pricing, media, and marketing assignee.
     *
     * @tags ObjectService
     * @name ObjectServiceGetMarketing
     * @summary Get marketing data for an object
     * @request GET:/web/objects/getMarketing/{id}
     */
    objectServiceGetMarketing: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetMarketingData, ObjectServiceGetMarketingError>({
        path: `/web/objects/getMarketing/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns marketing and online statistics for objects shared with the given account under marketing scope. Optional contactIdAssigneeMarketing filters employee-based counts.
     *
     * @tags ObjectService
     * @name ObjectServiceGetMarketingStatistics
     * @summary Get marketing statistics for an account
     * @request GET:/web/objects/getMarketingStatistics/{accountId}
     */
    objectServiceGetMarketingStatistics: (
      { accountId, ...query }: ObjectServiceGetMarketingStatisticsParams,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceGetMarketingStatisticsData, ObjectServiceGetMarketingStatisticsError>({
        path: `/web/objects/getMarketingStatistics/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns whether the given account has rental and/or condominium objects.
     *
     * @tags ObjectService
     * @name ObjectServiceGetObjectTypes
     * @summary Get object types for an account
     * @request GET:/web/objects/getObjectTypes/{accountId}
     */
    objectServiceGetObjectTypes: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetObjectTypesData, ObjectServiceGetObjectTypesError>({
        path: `/web/objects/getObjectTypes/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns vacancy, marketing, and publication statistics for objects owned by the given account.
     *
     * @tags ObjectService
     * @name ObjectServiceGetOwnerStatistics
     * @summary Get owner statistics for an account
     * @request GET:/web/objects/getOwnerStatistics/{accountId}
     */
    objectServiceGetOwnerStatistics: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetOwnerStatisticsData, ObjectServiceGetOwnerStatisticsError>({
        path: `/web/objects/getOwnerStatistics/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the summed value quota of objects in the given building.
     *
     * @tags ObjectService
     * @name ObjectServiceGetTotalValueQuotaForBuilding
     * @summary Get total value quota for a building
     * @request GET:/web/objects/getTotalValueQuotaForBuilding/{buildingId}
     */
    objectServiceGetTotalValueQuotaForBuilding: (buildingId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetTotalValueQuotaForBuildingData, ObjectServiceGetTotalValueQuotaForBuildingError>({
        path: `/web/objects/getTotalValueQuotaForBuilding/${buildingId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the tags currently used on objects for the given account.
     *
     * @tags ObjectService
     * @name ObjectServiceGetUsedTags
     * @summary Get used object tags for an account
     * @request GET:/web/objects/getUsedTags/{accountId}
     */
    objectServiceGetUsedTags: (accountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetUsedTagsData, ObjectServiceGetUsedTagsError>({
        path: `/web/objects/getUsedTags/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the number of draft handover protocols assigned to the authenticated caller.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceCountMyDrafts
     * @summary Count my draft handover protocols
     * @request GET:/web/objects/handover-protocol/countMyDrafts
     */
    handoverProtocolServiceCountMyDrafts: (params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceCountMyDraftsData, HandoverProtocolServiceCountMyDraftsError>({
        path: `/web/objects/handover-protocol/countMyDrafts`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Creates a new handover protocol for the given owner. Accepts move-out/move-in tenancy references, assignee, participants, schedule, rooms, devices without a room, an optional note, draft flag, and optional templateId. Returns the created protocol.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceCreate
     * @summary Create a handover protocol
     * @request POST:/web/objects/handover-protocol/create
     */
    handoverProtocolServiceCreate: (body: ObjecthandoverProtocolCreateRequest, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceCreateData, HandoverProtocolServiceCreateError>({
        path: `/web/objects/handover-protocol/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the handover protocol feature for the given account according to the enable flag.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceEnable
     * @summary Enable or disable handover protocol
     * @request POST:/web/objects/handover-protocol/enable/{accountId}
     */
    handoverProtocolServiceEnable: (
      accountId: string,
      body: {
        enable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceEnableData, HandoverProtocolServiceEnableError>({
        path: `/web/objects/handover-protocol/enable/${accountId}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Returns whether the handover protocol feature is enabled for the given account.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceHasEnabled
     * @summary Check if handover protocol is enabled
     * @request GET:/web/objects/handover-protocol/hasEnabled/{accountId}
     */
    handoverProtocolServiceHasEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceHasEnabledData, HandoverProtocolServiceHasEnabledError>({
        path: `/web/objects/handover-protocol/hasEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of all handover protocols visible to the authenticated caller. Supports optional filtering by protocol status. Set page to 0 to disable pagination. Response includes total protocol and page counts.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListAllProtocols
     * @summary List all handover protocols
     * @request GET:/web/objects/handover-protocol/listAllProtocols
     */
    handoverProtocolServiceListAllProtocols: (
      query: HandoverProtocolServiceListAllProtocolsParams,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceListAllProtocolsData, HandoverProtocolServiceListAllProtocolsError>({
        path: `/web/objects/handover-protocol/listAllProtocols`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the handover protocols matching the given protocol IDs.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListByIds
     * @summary List handover protocols by IDs
     * @request POST:/web/objects/handover-protocol/listByIds
     */
    handoverProtocolServiceListByIds: (body: ObjecthandoverProtocolListByIdsRequest, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceListByIdsData, HandoverProtocolServiceListByIdsError>({
        path: `/web/objects/handover-protocol/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns handover protocols linked to any of the given object IDs via move-out or move-in tenancy references.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListByObjectIds
     * @summary List handover protocols by object IDs
     * @request POST:/web/objects/handover-protocol/listByObjectIds
     */
    handoverProtocolServiceListByObjectIds: (
      body: ObjecthandoverProtocolListByObjectIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceListByObjectIdsData, HandoverProtocolServiceListByObjectIdsError>({
        path: `/web/objects/handover-protocol/listByObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of handover protocols assigned to the authenticated caller. Supports optional filtering by protocol status. Set page to 0 to disable pagination. Response includes total protocol and page counts.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListMyProtocols
     * @summary List my handover protocols
     * @request GET:/web/objects/handover-protocol/listMyProtocols
     */
    handoverProtocolServiceListMyProtocols: (
      query: HandoverProtocolServiceListMyProtocolsParams,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceListMyProtocolsData, HandoverProtocolServiceListMyProtocolsError>({
        path: `/web/objects/handover-protocol/listMyProtocols`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns a paginated list of handover protocols assigned to other users (not the authenticated caller). Supports optional filtering by protocol status. Set page to 0 to disable pagination. Response includes total protocol and page counts.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListOtherProtocols
     * @summary List other users' handover protocols
     * @request GET:/web/objects/handover-protocol/listOtherProtocols
     */
    handoverProtocolServiceListOtherProtocols: (
      query: HandoverProtocolServiceListOtherProtocolsParams,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceListOtherProtocolsData, HandoverProtocolServiceListOtherProtocolsError>({
        path: `/web/objects/handover-protocol/listOtherProtocols`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new handover protocol template for the given owner with name, property references, room/device layout, and devices without a room. Returns the created template.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceCreateTemplate
     * @summary Create a handover protocol template
     * @request POST:/web/objects/handover-protocol/templates/create
     */
    handoverProtocolServiceCreateTemplate: (
      body: ObjecthandoverProtocolCreateTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceCreateTemplateData, HandoverProtocolServiceCreateTemplateError>({
        path: `/web/objects/handover-protocol/templates/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all handover protocol templates belonging to the given account.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListTemplates
     * @summary List handover protocol templates for an account
     * @request GET:/web/objects/handover-protocol/templates/list/{accountId}
     */
    handoverProtocolServiceListTemplates: (accountId: string, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceListTemplatesData, HandoverProtocolServiceListTemplatesError>({
        path: `/web/objects/handover-protocol/templates/list/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns handover protocol templates linked to the given property ID.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceListTemplatesByPropertyId
     * @summary List handover protocol templates by property ID
     * @request GET:/web/objects/handover-protocol/templates/listByPropertyId/{propertyId}
     */
    handoverProtocolServiceListTemplatesByPropertyId: (propertyId: string, params: RequestParams = {}) =>
      this.request<
        HandoverProtocolServiceListTemplatesByPropertyIdData,
        HandoverProtocolServiceListTemplatesByPropertyIdError
      >({
        path: `/web/objects/handover-protocol/templates/listByPropertyId/${propertyId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Deletes the handover protocol templates with the given IDs.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceDeleteTemplates
     * @summary Delete handover protocol templates
     * @request DELETE:/web/objects/handover-protocol/templates/{ids}
     */
    handoverProtocolServiceDeleteTemplates: (ids: string[], params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceDeleteTemplatesData, HandoverProtocolServiceDeleteTemplatesError>({
        path: `/web/objects/handover-protocol/templates/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the handover protocol template identified by the given ID.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceGetTemplateById
     * @summary Get a handover protocol template by ID
     * @request GET:/web/objects/handover-protocol/templates/{id}
     */
    handoverProtocolServiceGetTemplateById: (id: string, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceGetTemplateByIdData, HandoverProtocolServiceGetTemplateByIdError>({
        path: `/web/objects/handover-protocol/templates/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets or clears the favorite flag on the handover protocol template identified by ID. Returns the updated template.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceSetFavoriteTemplate
     * @summary Set favorite flag on a handover protocol template
     * @request POST:/web/objects/handover-protocol/templates/{id}/setFavorite
     */
    handoverProtocolServiceSetFavoriteTemplate: (
      id: string,
      body: HandoverProtocolServiceSetFavoriteTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceSetFavoriteTemplateData, HandoverProtocolServiceSetFavoriteTemplateError>({
        path: `/web/objects/handover-protocol/templates/${id}/setFavorite`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing handover protocol template by ID (name, property references, rooms, and devices without a room). Returns the updated template.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceUpdateTemplate
     * @summary Update a handover protocol template
     * @request POST:/web/objects/handover-protocol/templates/{id}/update
     */
    handoverProtocolServiceUpdateTemplate: (
      id: string,
      body: HandoverProtocolServiceUpdateTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceUpdateTemplateData, HandoverProtocolServiceUpdateTemplateError>({
        path: `/web/objects/handover-protocol/templates/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the handover protocol with the given ID.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceDelete
     * @summary Delete a handover protocol
     * @request DELETE:/web/objects/handover-protocol/{id}
     */
    handoverProtocolServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceDeleteData, HandoverProtocolServiceDeleteError>({
        path: `/web/objects/handover-protocol/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Generates and returns a PDF preview of the handover protocol identified by ID, rendered in the requested preferred language.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceGetPdfPreview
     * @summary Get handover protocol PDF preview
     * @request GET:/web/objects/handover-protocol/{id}/getPdfPreview
     */
    handoverProtocolServiceGetPdfPreview: (
      { id, ...query }: HandoverProtocolServiceGetPdfPreviewParams,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceGetPdfPreviewData, HandoverProtocolServiceGetPdfPreviewError>({
        path: `/web/objects/handover-protocol/${id}/getPdfPreview`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Persists inspection data for an existing handover protocol by ID: participants (including new contacts), rooms, devices without a room, and note. Rooms and devices can be created, updated, or marked deleted. Returns the updated protocol.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceSaveData
     * @summary Save handover protocol inspection data
     * @request POST:/web/objects/handover-protocol/{id}/saveData
     */
    handoverProtocolServiceSaveData: (
      id: string,
      body: HandoverProtocolServiceSaveDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceSaveDataData, HandoverProtocolServiceSaveDataError>({
        path: `/web/objects/handover-protocol/${id}/saveData`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Applies participant signatures to the handover protocol identified by ID and finalizes signing in the requested preferred language. Returns the updated protocol.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceSign
     * @summary Sign a handover protocol
     * @request POST:/web/objects/handover-protocol/{id}/sign
     */
    handoverProtocolServiceSign: (id: string, body: HandoverProtocolServiceSignPayload, params: RequestParams = {}) =>
      this.request<HandoverProtocolServiceSignData, HandoverProtocolServiceSignError>({
        path: `/web/objects/handover-protocol/${id}/sign`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing handover protocol by ID. Accepts move-out/move-in tenancy references, assignee, participants, schedule, rooms, devices without a room, note, draft flag, and optional templateId. Returns the updated protocol.
     *
     * @tags HandoverProtocolService
     * @name HandoverProtocolServiceUpdate
     * @summary Update a handover protocol
     * @request POST:/web/objects/handover-protocol/{id}/update
     */
    handoverProtocolServiceUpdate: (
      id: string,
      body: HandoverProtocolServiceUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<HandoverProtocolServiceUpdateData, HandoverProtocolServiceUpdateError>({
        path: `/web/objects/handover-protocol/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new insurance for the given owner, attached to a reference (e.g. property or building). Accepts type, benefits, company, policy details, amounts, dates, notes, and document IDs. Returns the created insurance.
     *
     * @tags InsuranceService
     * @name InsuranceServiceCreate
     * @summary Create an insurance
     * @request POST:/web/objects/insurance/create
     */
    insuranceServiceCreate: (body: ObjectinsuranceCreateRequest, params: RequestParams = {}) =>
      this.request<InsuranceServiceCreateData, InsuranceServiceCreateError>({
        path: `/web/objects/insurance/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the insurances matching the given insurance IDs.
     *
     * @tags InsuranceService
     * @name InsuranceServiceListByIds
     * @summary List insurances by IDs
     * @request GET:/web/objects/insurance/listByIds/{ids}
     */
    insuranceServiceListByIds: (ids: string[], params: RequestParams = {}) =>
      this.request<InsuranceServiceListByIdsData, InsuranceServiceListByIdsError>({
        path: `/web/objects/insurance/listByIds/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns insurances attached to any of the given reference IDs (e.g. property or building IDs).
     *
     * @tags InsuranceService
     * @name InsuranceServiceListByReferenceIds
     * @summary List insurances by reference IDs
     * @request GET:/web/objects/insurance/listByReferenceIds/{referenceIds}
     */
    insuranceServiceListByReferenceIds: (referenceIds: string[], params: RequestParams = {}) =>
      this.request<InsuranceServiceListByReferenceIdsData, InsuranceServiceListByReferenceIdsError>({
        path: `/web/objects/insurance/listByReferenceIds/${referenceIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Deletes the insurance with the given ID.
     *
     * @tags InsuranceService
     * @name InsuranceServiceDelete
     * @summary Delete an insurance
     * @request DELETE:/web/objects/insurance/{id}
     */
    insuranceServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<InsuranceServiceDeleteData, InsuranceServiceDeleteError>({
        path: `/web/objects/insurance/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Appends document IDs to the insurance identified by ID. Returns the updated insurance.
     *
     * @tags InsuranceService
     * @name InsuranceServiceAddDocumentIds
     * @summary Add documents to an insurance
     * @request POST:/web/objects/insurance/{id}/addDocumentIds
     */
    insuranceServiceAddDocumentIds: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<InsuranceServiceAddDocumentIdsData, InsuranceServiceAddDocumentIdsError>({
        path: `/web/objects/insurance/${id}/addDocumentIds`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates an existing insurance by ID. Accepts reference, type, benefits, company, policy details, amounts, dates, notes, and document IDs. Returns the updated insurance.
     *
     * @tags InsuranceService
     * @name InsuranceServiceUpdate
     * @summary Update an insurance
     * @request POST:/web/objects/insurance/{id}/update
     */
    insuranceServiceUpdate: (id: string, body: InsuranceServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<InsuranceServiceUpdateData, InsuranceServiceUpdateError>({
        path: `/web/objects/insurance/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates multiple invest plan components and planned cost entries for the given owners and references. Returns the created components and plans.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceCreateBulk
     * @summary Create invest plan components and planned costs in bulk
     * @request POST:/web/objects/invest-plan/createBulk
     */
    investPlanServiceCreateBulk: (body: ObjectinvestPlanCreateBulkRequest, params: RequestParams = {}) =>
      this.request<InvestPlanServiceCreateBulkData, InvestPlanServiceCreateBulkError>({
        path: `/web/objects/invest-plan/createBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the invest plan component or planned cost entry with the given ID.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceDelete
     * @summary Delete an invest plan item
     * @request DELETE:/web/objects/invest-plan/delete/{id}
     */
    investPlanServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<InvestPlanServiceDeleteData, InvestPlanServiceDeleteError>({
        path: `/web/objects/invest-plan/delete/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Enables or disables the invest plan feature for the given buildings according to each entry's enable flag.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceEnable
     * @summary Enable or disable invest plan for buildings
     * @request POST:/web/objects/invest-plan/enable
     */
    investPlanServiceEnable: (body: ObjectinvestPlanEnableRequest, params: RequestParams = {}) =>
      this.request<InvestPlanServiceEnableData, InvestPlanServiceEnableError>({
        path: `/web/objects/invest-plan/enable`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description For each given building ID, returns whether the invest plan feature is enabled.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceHasEnabled
     * @summary Check if invest plan is enabled for buildings
     * @request POST:/web/objects/invest-plan/hasEnabled
     */
    investPlanServiceHasEnabled: (body: ObjectinvestPlanHasEnabledRequest, params: RequestParams = {}) =>
      this.request<InvestPlanServiceHasEnabledData, InvestPlanServiceHasEnabledError>({
        path: `/web/objects/invest-plan/hasEnabled`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns invest plan components and planned costs linked to any of the given reference IDs.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceListByReferenceIds
     * @summary List invest plan items by reference IDs
     * @request POST:/web/objects/invest-plan/listByReferenceIds
     */
    investPlanServiceListByReferenceIds: (
      body: ObjectinvestPlanListByReferenceIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvestPlanServiceListByReferenceIdsData, InvestPlanServiceListByReferenceIdsError>({
        path: `/web/objects/invest-plan/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple invest plan components and planned cost entries by ID. Returns the updated components and plans.
     *
     * @tags InvestPlanService
     * @name InvestPlanServiceUpdateBulk
     * @summary Update invest plan components and planned costs in bulk
     * @request POST:/web/objects/invest-plan/update
     */
    investPlanServiceUpdateBulk: (body: ObjectinvestPlanUpdateBulkRequest, params: RequestParams = {}) =>
      this.request<InvestPlanServiceUpdateBulkData, InvestPlanServiceUpdateBulkError>({
        path: `/web/objects/invest-plan/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns whether the object with the given ID is active.
     *
     * @tags ObjectService
     * @name ObjectServiceIsActive
     * @summary Check if an object is active
     * @request GET:/web/objects/isActive/{id}
     */
    objectServiceIsActive: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceIsActiveData, ObjectServiceIsActiveError>({
        path: `/web/objects/isActive/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether at least one of the given object IDs is currently published.
     *
     * @tags ObjectService
     * @name ObjectServiceIsOnePublished
     * @summary Check if any object is published
     * @request POST:/web/objects/isOnePublished
     */
    objectServiceIsOnePublished: (body: ObjectIsOnePublishedRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceIsOnePublishedData, ObjectServiceIsOnePublishedError>({
        path: `/web/objects/isOnePublished`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of objects for the given account. Supports page and itemsPerPage. Response includes total object and page counts.
     *
     * @tags ObjectService
     * @name ObjectServiceList
     * @summary List objects for an account
     * @request GET:/web/objects/list/{accountId}
     */
    objectServiceList: ({ accountId, ...query }: ObjectServiceListParams, params: RequestParams = {}) =>
      this.request<ObjectServiceListData, ObjectServiceListError>({
        path: `/web/objects/list/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns objects belonging to any of the given building IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceListByBuildingIds
     * @summary List objects by building IDs
     * @request POST:/web/objects/listByBuildingIds
     */
    objectServiceListByBuildingIds: (body: ObjectobjectListByBuildingIdsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceListByBuildingIdsData, ObjectServiceListByBuildingIdsError>({
        path: `/web/objects/listByBuildingIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the objects matching the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceListByIds
     * @summary List objects by IDs
     * @request POST:/web/objects/listByIds
     */
    objectServiceListByIds: (body: ObjectobjectListByIdsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceListByIdsData, ObjectServiceListByIdsError>({
        path: `/web/objects/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns object filter options (id, name, ownerId) available to the authenticated caller. Options are determined by authorization data; the request has no parameters.
     *
     * @tags ObjectService
     * @name ObjectServiceListFilterOptions
     * @summary List object filter options
     * @request GET:/web/objects/listFilterOptions
     */
    objectServiceListFilterOptions: (params: RequestParams = {}) =>
      this.request<ObjectServiceListFilterOptionsData, ObjectServiceListFilterOptionsError>({
        path: `/web/objects/listFilterOptions`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns objects in the given buildings that are free (available) on the specified date.
     *
     * @tags ObjectService
     * @name ObjectServiceListFreeByDate
     * @summary List free objects by date
     * @request POST:/web/objects/listFreeByDate
     */
    objectServiceListFreeByDate: (body: ObjectListFreeByDateRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceListFreeByDateData, ObjectServiceListFreeByDateError>({
        path: `/web/objects/listFreeByDate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the IDs of objects currently in marketing for the given marketer account.
     *
     * @tags ObjectService
     * @name ObjectServiceListIdsInMarketing
     * @summary List object IDs in marketing for a marketer
     * @request GET:/web/objects/listIdsInMarketing/{marketerAccountId}
     */
    objectServiceListIdsInMarketing: (marketerAccountId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceListIdsInMarketingData, ObjectServiceListIdsInMarketingError>({
        path: `/web/objects/listIdsInMarketing/${marketerAccountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of objects owned by or shared with the given account that are in marketing. Supports filtering by status, publicId, address, categories, rooms, and marketing assignees, plus sorting. Response includes total object and page counts.
     *
     * @tags ObjectService
     * @name ObjectServiceListMarketing
     * @summary List objects in marketing for an account
     * @request GET:/web/objects/listMarketing/{accountId}
     */
    objectServiceListMarketing: (
      { accountId, ...query }: ObjectServiceListMarketingParams,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceListMarketingData, ObjectServiceListMarketingError>({
        path: `/web/objects/listMarketing/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns all currently published objects belonging to the given owner.
     *
     * @tags ObjectService
     * @name ObjectServiceListPublished
     * @summary List published objects for an owner
     * @request GET:/web/objects/listPublished/{ownerId}
     */
    objectServiceListPublished: (ownerId: string, params: RequestParams = {}) =>
      this.request<ObjectServiceListPublishedData, ObjectServiceListPublishedError>({
        path: `/web/objects/listPublished/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Marks the object for marketing with optional start time, note, pricing, title, description, availability, deposit, parking, and media.
     *
     * @tags ObjectService
     * @name ObjectServiceMarkForMarketing
     * @summary Mark an object for marketing
     * @request POST:/web/objects/markForMarketing/{id}
     */
    objectServiceMarkForMarketing: (
      id: string,
      body: ObjectServiceMarkForMarketingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceMarkForMarketingData, ObjectServiceMarkForMarketingError>({
        path: `/web/objects/markForMarketing/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the marketing entry for the object identified by ID as seen.
     *
     * @tags ObjectService
     * @name ObjectServiceMarketingMarkSeen
     * @summary Mark marketing object as seen
     * @request POST:/web/objects/marketingMarkSeen/{id}
     */
    objectServiceMarketingMarkSeen: (id: string, body: object, params: RequestParams = {}) =>
      this.request<ObjectServiceMarketingMarkSeenData, ObjectServiceMarketingMarkSeenError>({
        path: `/web/objects/marketingMarkSeen/${id}`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Creates a new mortgage for the given owner and reference (property, building, or object). Accepts bank details, amounts, interest and amortization settings, and optional documents. Returns the created mortgage.
     *
     * @tags MortgageService
     * @name MortgageServiceCreate
     * @summary Create a mortgage
     * @request POST:/web/objects/mortgage/create
     */
    mortgageServiceCreate: (body: ObjectmortgageCreateRequest, params: RequestParams = {}) =>
      this.request<MortgageServiceCreateData, MortgageServiceCreateError>({
        path: `/web/objects/mortgage/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the mortgages matching the given mortgage IDs.
     *
     * @tags MortgageService
     * @name MortgageServiceListByIds
     * @summary List mortgages by IDs
     * @request POST:/web/objects/mortgage/listByIds
     */
    mortgageServiceListByIds: (body: ObjectmortgageListByIdsRequest, params: RequestParams = {}) =>
      this.request<MortgageServiceListByIdsData, MortgageServiceListByIdsError>({
        path: `/web/objects/mortgage/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns mortgages linked to any of the given reference IDs (property, building, or object).
     *
     * @tags MortgageService
     * @name MortgageServiceListByReferenceIds
     * @summary List mortgages by reference IDs
     * @request POST:/web/objects/mortgage/listByReferenceIds
     */
    mortgageServiceListByReferenceIds: (body: ObjectmortgageListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<MortgageServiceListByReferenceIdsData, MortgageServiceListByReferenceIdsError>({
        path: `/web/objects/mortgage/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the mortgages with the given IDs.
     *
     * @tags MortgageService
     * @name MortgageServiceDelete
     * @summary Delete mortgages
     * @request DELETE:/web/objects/mortgage/{ids}
     */
    mortgageServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<MortgageServiceDeleteData, MortgageServiceDeleteError>({
        path: `/web/objects/mortgage/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Appends document IDs to the mortgage identified by ID.
     *
     * @tags MortgageService
     * @name MortgageServiceAddDocuments
     * @summary Add documents to a mortgage
     * @request POST:/web/objects/mortgage/{id}/addDocument
     */
    mortgageServiceAddDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MortgageServiceAddDocumentsData, MortgageServiceAddDocumentsError>({
        path: `/web/objects/mortgage/${id}/addDocument`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates an existing mortgage by ID (reference, bank details, amounts, interest and amortization settings, and documents). Returns the updated mortgage.
     *
     * @tags MortgageService
     * @name MortgageServiceUpdate
     * @summary Update a mortgage
     * @request POST:/web/objects/mortgage/{id}/update
     */
    mortgageServiceUpdate: (id: string, body: MortgageServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<MortgageServiceUpdateData, MortgageServiceUpdateError>({
        path: `/web/objects/mortgage/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Moves the given objects to the specified new building ID.
     *
     * @tags ObjectService
     * @name ObjectServiceMoveObjects
     * @summary Move objects to another building
     * @request POST:/web/objects/moveObjects
     */
    objectServiceMoveObjects: (body: ObjectMoveObjectsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceMoveObjectsData, ObjectServiceMoveObjectsError>({
        path: `/web/objects/moveObjects`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates one or more plots for the given owner and property. Accepts land register data, area, values, category, operation, strategy, dates, and document IDs. Returns the created plots.
     *
     * @tags PlotService
     * @name PlotServiceCreate
     * @summary Create plots
     * @request POST:/web/objects/plot/create
     */
    plotServiceCreate: (body: ObjectplotCreateRequest, params: RequestParams = {}) =>
      this.request<PlotServiceCreateData, PlotServiceCreateError>({
        path: `/web/objects/plot/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the plots matching the given plot IDs.
     *
     * @tags PlotService
     * @name PlotServiceListByIds
     * @summary List plots by IDs
     * @request GET:/web/objects/plot/listByIds/{ids}
     */
    plotServiceListByIds: (ids: string[], params: RequestParams = {}) =>
      this.request<PlotServiceListByIdsData, PlotServiceListByIdsError>({
        path: `/web/objects/plot/listByIds/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of plots for the given owner. Supports page and itemsPerPage. Response includes total plot and page counts.
     *
     * @tags PlotService
     * @name PlotServiceListByOwnerId
     * @summary List plots for an owner
     * @request GET:/web/objects/plot/listByOwnerId/{ownerId}
     */
    plotServiceListByOwnerId: ({ ownerId, ...query }: PlotServiceListByOwnerIdParams, params: RequestParams = {}) =>
      this.request<PlotServiceListByOwnerIdData, PlotServiceListByOwnerIdError>({
        path: `/web/objects/plot/listByOwnerId/${ownerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns all plots associated with the given property ID.
     *
     * @tags PlotService
     * @name PlotServiceListByPropertyId
     * @summary List plots by property ID
     * @request GET:/web/objects/plot/listByPropertyId/{propertyId}
     */
    plotServiceListByPropertyId: (propertyId: string, params: RequestParams = {}) =>
      this.request<PlotServiceListByPropertyIdData, PlotServiceListByPropertyIdError>({
        path: `/web/objects/plot/listByPropertyId/${propertyId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns plots matching any of the given reference IDs.
     *
     * @tags PlotService
     * @name PlotServiceListByReferenceIds
     * @summary List plots by reference IDs
     * @request POST:/web/objects/plot/listByReferenceIds
     */
    plotServiceListByReferenceIds: (body: ObjectplotListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<PlotServiceListByReferenceIdsData, PlotServiceListByReferenceIdsError>({
        path: `/web/objects/plot/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates one or more existing plots by ID. Accepts land register data, area, values, category, operation, strategy, dates, and document IDs. Returns the updated plots.
     *
     * @tags PlotService
     * @name PlotServiceUpdate
     * @summary Update plots
     * @request POST:/web/objects/plot/updatePlots
     */
    plotServiceUpdate: (body: ObjectplotUpdateRequest, params: RequestParams = {}) =>
      this.request<PlotServiceUpdateData, PlotServiceUpdateError>({
        path: `/web/objects/plot/updatePlots`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the plots with the given IDs.
     *
     * @tags PlotService
     * @name PlotServiceDelete
     * @summary Delete plots
     * @request DELETE:/web/objects/plot/{ids}
     */
    plotServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<PlotServiceDeleteData, PlotServiceDeleteError>({
        path: `/web/objects/plot/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Publishes the given objects. Optional publishAt schedules publication; optional unPublishAt or unPublishAtAmountOfRequests can auto-unpublish. SpecialPublication may also be supplied.
     *
     * @tags ObjectService
     * @name ObjectServicePublish
     * @summary Publish objects
     * @request POST:/web/objects/publish
     */
    objectServicePublish: (body: ObjectPublishRequest, params: RequestParams = {}) =>
      this.request<ObjectServicePublishData, ObjectServicePublishError>({
        path: `/web/objects/publish`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Publishes object-updated events for the given owner account IDs.
     *
     * @tags ObjectService
     * @name ObjectServicePublishUpdatedEvents
     * @summary Publish updated events for owners
     * @request POST:/web/objects/publishUpdatedEvents
     */
    objectServicePublishUpdatedEvents: (body: ObjectobjectPublishUpdatedEventsRequest, params: RequestParams = {}) =>
      this.request<ObjectServicePublishUpdatedEventsData, ObjectServicePublishUpdatedEventsError>({
        path: `/web/objects/publishUpdatedEvents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given craftsman contact IDs from the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceRemoveCraftsmen
     * @summary Remove craftsmen from objects
     * @request POST:/web/objects/removeCraftsmen
     */
    objectServiceRemoveCraftsmen: (body: ObjectRemoveCraftsmenRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceRemoveCraftsmenData, ObjectServiceRemoveCraftsmenError>({
        path: `/web/objects/removeCraftsmen`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given objects from marketing.
     *
     * @tags ObjectService
     * @name ObjectServiceRemoveFromMarketing
     * @summary Remove objects from marketing
     * @request POST:/web/objects/removeFromMarketing
     */
    objectServiceRemoveFromMarketing: (body: ObjectRemoveFromMarketingRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceRemoveFromMarketingData, ObjectServiceRemoveFromMarketingError>({
        path: `/web/objects/removeFromMarketing`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given janitor contact IDs from the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceRemoveJanitors
     * @summary Remove janitors from objects
     * @request POST:/web/objects/removeJanitors
     */
    objectServiceRemoveJanitors: (body: ObjectRemoveJanitorsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceRemoveJanitorsData, ObjectServiceRemoveJanitorsError>({
        path: `/web/objects/removeJanitors`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given service provider contact IDs from the specified objects.
     *
     * @tags ObjectService
     * @name ObjectServiceRemoveServiceProviders
     * @summary Remove service providers from objects
     * @request POST:/web/objects/removeServiceProviders
     */
    objectServiceRemoveServiceProviders: (body: ObjectRemoveServiceProvidersRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceRemoveServiceProvidersData, ObjectServiceRemoveServiceProvidersError>({
        path: `/web/objects/removeServiceProviders`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a rental index template for the given owner with name, language, tenancy type, fields, sorting, composition options, and onlyMovingInOutTenancies. Returns the created template.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceCreate
     * @summary Create a rental index template
     * @request POST:/web/objects/rental-index/create
     */
    rentalIndexServiceCreate: (body: ObjectrentalIndexCreateRequest, params: RequestParams = {}) =>
      this.request<RentalIndexServiceCreateData, RentalIndexServiceCreateError>({
        path: `/web/objects/rental-index/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all rental index templates available for the given accountId.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceList
     * @summary List rental index templates
     * @request GET:/web/objects/rental-index/list
     */
    rentalIndexServiceList: (query: RentalIndexServiceListParams, params: RequestParams = {}) =>
      this.request<RentalIndexServiceListData, RentalIndexServiceListError>({
        path: `/web/objects/rental-index/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Renders a rental index for the given buildingIds using language, tenancy type, date range, fields, sorting, composition options, custom header, and hideInactiveObjects. Returns the rendered file bytes.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceRender
     * @summary Render a rental index file
     * @request POST:/web/objects/rental-index/render
     */
    rentalIndexServiceRender: (body: ObjectrentalIndexRenderRequest, params: RequestParams = {}) =>
      this.request<RentalIndexServiceRenderData, RentalIndexServiceRenderError>({
        path: `/web/objects/rental-index/render`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Renders a rental index PDF for the given buildingIds with language, date range, sorting, and layout flags (buildingBreakPage, displayPropertySummary, displayHeaderEveryPage, withoutTenantsNames, hideInactiveObjects). Returns the PDF file bytes.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceRenderPdf
     * @summary Render a rental index PDF
     * @request POST:/web/objects/rental-index/renderPdf
     */
    rentalIndexServiceRenderPdf: (body: RentalIndexRenderPdfRequest, params: RequestParams = {}) =>
      this.request<RentalIndexServiceRenderPdfData, RentalIndexServiceRenderPdfError>({
        path: `/web/objects/rental-index/renderPdf`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the rental index template identified by id.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceDelete
     * @summary Delete a rental index template
     * @request DELETE:/web/objects/rental-index/{id}
     */
    rentalIndexServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<RentalIndexServiceDeleteData, RentalIndexServiceDeleteError>({
        path: `/web/objects/rental-index/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates the rental index template identified by id (name, language, tenancy type, fields, sorting, composition, and onlyMovingInOutTenancies). Returns the updated template.
     *
     * @tags RentalIndexService
     * @name RentalIndexServiceUpdate
     * @summary Update a rental index template
     * @request POST:/web/objects/rental-index/{id}/update
     */
    rentalIndexServiceUpdate: (id: string, body: RentalIndexServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<RentalIndexServiceUpdateData, RentalIndexServiceUpdateError>({
        path: `/web/objects/rental-index/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates one or more rooms from the given roomCreations. Each creation includes ownerId, referenceId, name, dimensions, note, documents, images, and order. Returns the created rooms.
     *
     * @tags RoomService
     * @name RoomServiceCreate
     * @summary Create rooms
     * @request POST:/web/objects/room/create
     */
    roomServiceCreate: (body: ObjectroomCreateRequest, params: RequestParams = {}) =>
      this.request<RoomServiceCreateData, RoomServiceCreateError>({
        path: `/web/objects/room/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the rooms matching the given IDs.
     *
     * @tags RoomService
     * @name RoomServiceListByIds
     * @summary List rooms by IDs
     * @request POST:/web/objects/room/listByIds
     */
    roomServiceListByIds: (body: ObjectroomListByIdsRequest, params: RequestParams = {}) =>
      this.request<RoomServiceListByIdsData, RoomServiceListByIdsError>({
        path: `/web/objects/room/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the rooms matching the given reference IDs.
     *
     * @tags RoomService
     * @name RoomServiceListByReferenceIds
     * @summary List rooms by reference IDs
     * @request POST:/web/objects/room/listByReferenceIds
     */
    roomServiceListByReferenceIds: (body: ObjectroomListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<RoomServiceListByReferenceIdsData, RoomServiceListByReferenceIdsError>({
        path: `/web/objects/room/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates one or more rooms by ID via roomUpdates. Accepts name, dimensions, note, documents, images, and order. Returns the updated rooms.
     *
     * @tags RoomService
     * @name RoomServiceUpdate
     * @summary Update rooms
     * @request POST:/web/objects/room/updateRooms
     */
    roomServiceUpdate: (body: ObjectroomUpdateRequest, params: RequestParams = {}) =>
      this.request<RoomServiceUpdateData, RoomServiceUpdateError>({
        path: `/web/objects/room/updateRooms`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the rooms with the given IDs.
     *
     * @tags RoomService
     * @name RoomServiceDelete
     * @summary Delete rooms
     * @request DELETE:/web/objects/room/{ids}
     */
    roomServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<RoomServiceDeleteData, RoomServiceDeleteError>({
        path: `/web/objects/room/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Sets the accounting assignee contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetAccountingAssignee
     * @summary Set accounting assignee on objects
     * @request POST:/web/objects/setAccountingAssignee
     */
    objectServiceSetAccountingAssignee: (body: ObjectobjectSetAccountingAssigneeRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetAccountingAssigneeData, ObjectServiceSetAccountingAssigneeError>({
        path: `/web/objects/setAccountingAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the administration assignee contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetAdminAssignee
     * @summary Set admin assignee on objects
     * @request POST:/web/objects/setAdminAssignee
     */
    objectServiceSetAdminAssignee: (body: ObjectobjectSetAdminAssigneeRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetAdminAssigneeData, ObjectServiceSetAdminAssigneeError>({
        path: `/web/objects/setAdminAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the asset assignee contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetAssetAssignee
     * @summary Set asset assignee on objects
     * @request POST:/web/objects/setAssetAssignee
     */
    objectServiceSetAssetAssignee: (body: ObjectobjectSetAssetAssigneeRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetAssetAssigneeData, ObjectServiceSetAssetAssigneeError>({
        path: `/web/objects/setAssetAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the contacts structure for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetContacts
     * @summary Set contacts on objects
     * @request POST:/web/objects/setContacts
     */
    objectServiceSetContacts: (body: ObjectSetContactsRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetContactsData, ObjectServiceSetContactsError>({
        path: `/web/objects/setContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the marketing assignee contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetMarketingAssignee
     * @summary Set marketing assignee on objects
     * @request POST:/web/objects/setMarketingAssignee
     */
    objectServiceSetMarketingAssignee: (body: ObjectSetMarketingAssigneeRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetMarketingAssigneeData, ObjectServiceSetMarketingAssigneeError>({
        path: `/web/objects/setMarketingAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the owner assignee contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetOwnerAssignee
     * @summary Set owner assignee on objects
     * @request POST:/web/objects/setOwnerAssignee
     */
    objectServiceSetOwnerAssignee: (body: ObjectobjectSetOwnerAssigneeRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceSetOwnerAssigneeData, ObjectServiceSetOwnerAssigneeError>({
        path: `/web/objects/setOwnerAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the viewing appointment contact for the given object IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceSetViewingAppointmentContact
     * @summary Set viewing appointment contact on objects
     * @request POST:/web/objects/setViewingAppointmentContact
     */
    objectServiceSetViewingAppointmentContact: (
      body: ObjectSetViewingAppointmentContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceSetViewingAppointmentContactData, ObjectServiceSetViewingAppointmentContactError>({
        path: `/web/objects/setViewingAppointmentContact`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Closes the tenancies with the given IDs.
     *
     * @tags TenancyService
     * @name TenancyServiceCloseTenancies
     * @summary Close tenancies
     * @request POST:/web/objects/tenancy/close
     */
    tenancyServiceCloseTenancies: (body: TenancyCloseRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceCloseTenanciesData, TenancyServiceCloseTenanciesError>({
        path: `/web/objects/tenancy/close`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new tenancy for the given owner and object. Optional numericId may be supplied; otherwise it can be generated by the service. Accepts contract, tenant, rent, deposit, dates, termination data, and status flags. Returns the created tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceCreate
     * @summary Create a tenancy
     * @request POST:/web/objects/tenancy/create
     */
    tenancyServiceCreate: (body: ObjecttenancyCreateRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceCreateData, TenancyServiceCreateError>({
        path: `/web/objects/tenancy/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes rent adjustments for the given object IDs that match the specified byDate.
     *
     * @tags TenancyService
     * @name TenancyServiceDeleteRentAdjustments
     * @summary Delete tenancy rent adjustments
     * @request POST:/web/objects/tenancy/deleteRentAdjustments
     */
    tenancyServiceDeleteRentAdjustments: (
      body: ObjecttenancyDeleteRentAdjustmentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceDeleteRentAdjustmentsData, TenancyServiceDeleteRentAdjustmentsError>({
        path: `/web/objects/tenancy/deleteRentAdjustments`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the tenancy identified by the given ID.
     *
     * @tags TenancyService
     * @name TenancyServiceGet
     * @summary Get a tenancy by ID
     * @request GET:/web/objects/tenancy/get/{id}
     */
    tenancyServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<TenancyServiceGetData, TenancyServiceGetError>({
        path: `/web/objects/tenancy/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description For each given object ID, returns whether an activated tenancy exists.
     *
     * @tags TenancyService
     * @name TenancyServiceHasActivatedTenancy
     * @summary Check activated tenancies by object IDs
     * @request POST:/web/objects/tenancy/hasActivatedTenancy
     */
    tenancyServiceHasActivatedTenancy: (body: TenancyHasActivatedTenancyRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceHasActivatedTenancyData, TenancyServiceHasActivatedTenancyError>({
        path: `/web/objects/tenancy/hasActivatedTenancy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns tenancies linked to any of the given object IDs.
     *
     * @tags TenancyService
     * @name TenancyServiceList
     * @summary List tenancies by object IDs
     * @request POST:/web/objects/tenancy/list
     */
    tenancyServiceList: (body: ObjecttenancyListRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceListData, TenancyServiceListError>({
        path: `/web/objects/tenancy/list`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns tenancies where the given contact ID is the billing contact.
     *
     * @tags TenancyService
     * @name TenancyServiceListByBillingContactId
     * @summary List tenancies by billing contact
     * @request GET:/web/objects/tenancy/listByBillingContactId/{billingContactId}
     */
    tenancyServiceListByBillingContactId: (billingContactId: string, params: RequestParams = {}) =>
      this.request<TenancyServiceListByBillingContactIdData, TenancyServiceListByBillingContactIdError>({
        path: `/web/objects/tenancy/listByBillingContactId/${billingContactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns tenancies involving the given contact ID. Role filters (billingContact, tenants, correspondence, guarantors, subTenants) control which contact roles are matched.
     *
     * @tags TenancyService
     * @name TenancyServiceListByContactId
     * @summary List tenancies by contact ID
     * @request GET:/web/objects/tenancy/listByContactId/{contactId}
     */
    tenancyServiceListByContactId: (
      { contactId, ...query }: TenancyServiceListByContactIdParams,
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceListByContactIdData, TenancyServiceListByContactIdError>({
        path: `/web/objects/tenancy/listByContactId/${contactId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns tenancies for the given object IDs overlapping the optional startDate/endDate range. includeTenancies and includeVacancies control whether real tenancies and vacancies are returned.
     *
     * @tags TenancyService
     * @name TenancyServiceListByDateAndObjectIds
     * @summary List tenancies by date and object IDs
     * @request POST:/web/objects/tenancy/listByDateAndObjectIds
     */
    tenancyServiceListByDateAndObjectIds: (body: TenancyListByDateAndObjectIdsRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceListByDateAndObjectIdsData, TenancyServiceListByDateAndObjectIdsError>({
        path: `/web/objects/tenancy/listByDateAndObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns tenancies where the given contact ID is a guarantor.
     *
     * @tags TenancyService
     * @name TenancyServiceListByGuarantor
     * @summary List tenancies by guarantor contact
     * @request GET:/web/objects/tenancy/listByGuarantor/{guarantorContactId}
     */
    tenancyServiceListByGuarantor: (guarantorContactId: string, params: RequestParams = {}) =>
      this.request<TenancyServiceListByGuarantorData, TenancyServiceListByGuarantorError>({
        path: `/web/objects/tenancy/listByGuarantor/${guarantorContactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the tenancies matching the given tenancy IDs.
     *
     * @tags TenancyService
     * @name TenancyServiceListByIds
     * @summary List tenancies by IDs
     * @request POST:/web/objects/tenancy/listByIds
     */
    tenancyServiceListByIds: (body: ObjecttenancyListByIdsRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceListByIdsData, TenancyServiceListByIdsError>({
        path: `/web/objects/tenancy/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of tenancies for the given owner. Supports filtering by address, categories, zip range, tenant contacts, and start/end date ranges, plus sorting by cold rent, additional costs, or total rent. Response includes total tenancy and page counts.
     *
     * @tags TenancyService
     * @name TenancyServiceListByOwner
     * @summary List tenancies for an owner
     * @request GET:/web/objects/tenancy/listByOwner/{ownerId}
     */
    tenancyServiceListByOwner: ({ ownerId, ...query }: TenancyServiceListByOwnerParams, params: RequestParams = {}) =>
      this.request<TenancyServiceListByOwnerData, TenancyServiceListByOwnerError>({
        path: `/web/objects/tenancy/listByOwner/${ownerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns tenancies for the given owner account ID where the given contact ID is a tenant.
     *
     * @tags TenancyService
     * @name TenancyServiceListByTenant
     * @summary List tenancies by tenant contact
     * @request GET:/web/objects/tenancy/listByTenant/{ownerId}/tenant/{tenantContactId}
     */
    tenancyServiceListByTenant: (ownerId: string, tenantContactId: string, params: RequestParams = {}) =>
      this.request<TenancyServiceListByTenantData, TenancyServiceListByTenantError>({
        path: `/web/objects/tenancy/listByTenant/${ownerId}/tenant/${tenantContactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the current tenancies for the given object IDs.
     *
     * @tags TenancyService
     * @name TenancyServiceListCurrentByObjectIds
     * @summary List current tenancies by object IDs
     * @request POST:/web/objects/tenancy/listCurrentByObjectIds
     */
    tenancyServiceListCurrentByObjectIds: (
      body: ObjecttenancyListCurrentByObjectIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceListCurrentByObjectIdsData, TenancyServiceListCurrentByObjectIdsError>({
        path: `/web/objects/tenancy/listCurrentByObjectIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Publishes updated events for tenancies belonging to the given owner account IDs.
     *
     * @tags TenancyService
     * @name TenancyServicePublishUpdatedEvents
     * @summary Publish tenancy updated events
     * @request POST:/web/objects/tenancy/publishUpdatedEvents
     */
    tenancyServicePublishUpdatedEvents: (body: ObjecttenancyPublishUpdatedEventsRequest, params: RequestParams = {}) =>
      this.request<TenancyServicePublishUpdatedEventsData, TenancyServicePublishUpdatedEventsError>({
        path: `/web/objects/tenancy/publishUpdatedEvents`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates multiple tenancies in one request via the given entries. Returns the updated tenancies.
     *
     * @tags TenancyService
     * @name TenancyServiceUpdateBulk
     * @summary Update tenancies in bulk
     * @request POST:/web/objects/tenancy/updateBulk
     */
    tenancyServiceUpdateBulk: (body: ObjecttenancyUpdateBulkRequest, params: RequestParams = {}) =>
      this.request<TenancyServiceUpdateBulkData, TenancyServiceUpdateBulkError>({
        path: `/web/objects/tenancy/updateBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the tenancy with the given ID.
     *
     * @tags TenancyService
     * @name TenancyServiceDelete
     * @summary Delete a tenancy
     * @request DELETE:/web/objects/tenancy/{id}
     */
    tenancyServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<TenancyServiceDeleteData, TenancyServiceDeleteError>({
        path: `/web/objects/tenancy/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Activates the tenancy identified by ID. Optional document IDs may be attached. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceActivate
     * @summary Activate a tenancy
     * @request POST:/web/objects/tenancy/{id}/activate
     */
    tenancyServiceActivate: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceActivateData, TenancyServiceActivateError>({
        path: `/web/objects/tenancy/${id}/activate`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Appends document IDs to the tenancy identified by ID. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceAddDocuments
     * @summary Add documents to a tenancy
     * @request POST:/web/objects/tenancy/{id}/addDocument
     */
    tenancyServiceAddDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceAddDocumentsData, TenancyServiceAddDocumentsError>({
        path: `/web/objects/tenancy/${id}/addDocument`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Deactivates the tenancy identified by ID. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceDeactivate
     * @summary Deactivate a tenancy
     * @request POST:/web/objects/tenancy/{id}/deactivate
     */
    tenancyServiceDeactivate: (id: string, body: object, params: RequestParams = {}) =>
      this.request<TenancyServiceDeactivateData, TenancyServiceDeactivateError>({
        path: `/web/objects/tenancy/${id}/deactivate`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Removes the given document IDs from the tenancy identified by ID. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceRemoveDocuments
     * @summary Remove documents from a tenancy
     * @request POST:/web/objects/tenancy/{id}/removeDocuments
     */
    tenancyServiceRemoveDocuments: (
      id: string,
      body: {
        documentIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceRemoveDocumentsData, TenancyServiceRemoveDocumentsError>({
        path: `/web/objects/tenancy/${id}/removeDocuments`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Sets termination details on the tenancy identified by ID, including terminateAt, return/move-out dates, terminatedBy, type, reasons, and optional documents. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceSetTermination
     * @summary Set termination on a tenancy
     * @request POST:/web/objects/tenancy/{id}/setTermination
     */
    tenancyServiceSetTermination: (id: string, body: TenancyServiceSetTerminationPayload, params: RequestParams = {}) =>
      this.request<TenancyServiceSetTerminationData, TenancyServiceSetTerminationError>({
        path: `/web/objects/tenancy/${id}/setTermination`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing tenancy by ID (contract, tenant, rent, deposit, dates, termination data, and status flags). Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceUpdate
     * @summary Update a tenancy
     * @request POST:/web/objects/tenancy/{id}/update
     */
    tenancyServiceUpdate: (id: string, body: TenancyServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<TenancyServiceUpdateData, TenancyServiceUpdateError>({
        path: `/web/objects/tenancy/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deactivates the tenancy identified by owner account ID and numeric ID. Returns the updated tenancy.
     *
     * @tags TenancyService
     * @name TenancyServiceDeactivateByNumericId
     * @summary Deactivate a tenancy by numeric ID
     * @request POST:/web/objects/tenancy/{numericId}/deactivateByNumericId
     */
    tenancyServiceDeactivateByNumericId: (
      numericId: string,
      body: {
        /** @format int64 */
        ownerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TenancyServiceDeactivateByNumericIdData, TenancyServiceDeactivateByNumericIdError>({
        path: `/web/objects/tenancy/${numericId}/deactivateByNumericId`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Unpublishes the objects with the given IDs.
     *
     * @tags ObjectService
     * @name ObjectServiceUnPublish
     * @summary Unpublish objects
     * @request POST:/web/objects/unpublish
     */
    objectServiceUnPublish: (body: ObjectUnPublishRequest, params: RequestParams = {}) =>
      this.request<ObjectServiceUnPublishData, ObjectServiceUnPublishError>({
        path: `/web/objects/unpublish`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the marketing start time and marketing note for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceUpdateMarketingInfo
     * @summary Update marketing info for an object
     * @request POST:/web/objects/updateMarketingInfo/{id}
     */
    objectServiceUpdateMarketingInfo: (
      id: string,
      body: ObjectServiceUpdateMarketingInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceUpdateMarketingInfoData, ObjectServiceUpdateMarketingInfoError>({
        path: `/web/objects/updateMarketingInfo/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the object with the given ID.
     *
     * @tags ObjectService
     * @name ObjectServiceDelete
     * @summary Delete an object
     * @request DELETE:/web/objects/{id}
     */
    objectServiceDelete: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceDeleteData, ObjectServiceDeleteError>({
        path: `/web/objects/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Generates and returns an application info PDF for the object identified by ID, rendered in the requested language.
     *
     * @tags ObjectService
     * @name ObjectServiceGetApplicationInfo
     * @summary Get application info PDF for an object
     * @request GET:/web/objects/{id}/getApplicationInfo
     */
    objectServiceGetApplicationInfo: (
      { id, ...query }: ObjectServiceGetApplicationInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceGetApplicationInfoData, ObjectServiceGetApplicationInfoError>({
        path: `/web/objects/${id}/getApplicationInfo`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the public application link for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceGetApplicationLink
     * @summary Get application link for an object
     * @request GET:/web/objects/{id}/getApplicationLink
     */
    objectServiceGetApplicationLink: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetApplicationLinkData, ObjectServiceGetApplicationLinkError>({
        path: `/web/objects/${id}/getApplicationLink`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the default answer configuration for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceGetDefaultAnswer
     * @summary Get default answer for an object
     * @request GET:/web/objects/{id}/getDefaultAnswer
     */
    objectServiceGetDefaultAnswer: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetDefaultAnswerData, ObjectServiceGetDefaultAnswerError>({
        path: `/web/objects/${id}/getDefaultAnswer`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Generates and returns a marketing expose PDF for the object identified by ID, rendered in the requested language.
     *
     * @tags ObjectService
     * @name ObjectServiceGetMarketingExpose
     * @summary Get marketing expose PDF for an object
     * @request GET:/web/objects/{id}/getMarketingExpose
     */
    objectServiceGetMarketingExpose: (
      { id, ...query }: ObjectServiceGetMarketingExposeParams,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceGetMarketingExposeData, ObjectServiceGetMarketingExposeError>({
        path: `/web/objects/${id}/getMarketingExpose`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the viewing appointment configuration for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceGetViewingAppointment
     * @summary Get viewing appointment for an object
     * @request GET:/web/objects/{id}/getViewingAppointment
     */
    objectServiceGetViewingAppointment: (id: string, params: RequestParams = {}) =>
      this.request<ObjectServiceGetViewingAppointmentData, ObjectServiceGetViewingAppointmentError>({
        path: `/web/objects/${id}/getViewingAppointment`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets the default answer configuration for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceSetDefaultAnswer
     * @summary Set default answer for an object
     * @request POST:/web/objects/{id}/setDefaultAnswer
     */
    objectServiceSetDefaultAnswer: (
      id: string,
      body: ObjectServiceSetDefaultAnswerPayload,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceSetDefaultAnswerData, ObjectServiceSetDefaultAnswerError>({
        path: `/web/objects/${id}/setDefaultAnswer`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the viewing appointment configuration for the object identified by ID.
     *
     * @tags ObjectService
     * @name ObjectServiceSetViewingAppointment
     * @summary Set viewing appointment for an object
     * @request POST:/web/objects/{id}/setViewingAppointment
     */
    objectServiceSetViewingAppointment: (
      id: string,
      body: ObjectServiceSetViewingAppointmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<ObjectServiceSetViewingAppointmentData, ObjectServiceSetViewingAppointmentError>({
        path: `/web/objects/${id}/setViewingAppointment`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing object by ID. Accepts type, category, contacts, media, characteristics, pricing, availability, tags, and marketing-related fields. Returns the updated object.
     *
     * @tags ObjectService
     * @name ObjectServiceUpdate
     * @summary Update an object
     * @request POST:/web/objects/{id}/update
     */
    objectServiceUpdate: (id: string, body: ObjectServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<ObjectServiceUpdateData, ObjectServiceUpdateError>({
        path: `/web/objects/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates upper/market/under market rent pricing fields for the object identified by ID. Returns the updated pricing.
     *
     * @tags ObjectService
     * @name ObjectServiceUpdatePricing
     * @summary Update object market pricing
     * @request POST:/web/objects/{id}/updatePricing
     */
    objectServiceUpdatePricing: (id: string, body: ObjectServiceUpdatePricingPayload, params: RequestParams = {}) =>
      this.request<ObjectServiceUpdatePricingData, ObjectServiceUpdatePricingError>({
        path: `/web/objects/${id}/updatePricing`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new contract template for the given owner. Accepts creatorName, title, mediaId, category, enforcePdf, and language. Returns the created template.
     *
     * @tags ContractService
     * @name ContractServiceCreateTemplateMixin2
     * @summary Create a contract template
     * @request POST:/web/v2/objects/contract/template/create
     */
    contractServiceCreateTemplateMixin2: (body: Contractv2CreateTemplateRequest, params: RequestParams = {}) =>
      this.request<ContractServiceCreateTemplateMixin2Data, ContractServiceCreateTemplateMixin2Error>({
        path: `/web/v2/objects/contract/template/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the contract templates with the given IDs.
     *
     * @tags ContractService
     * @name ContractServiceDeleteTemplateMixin2
     * @summary Delete contract templates
     * @request DELETE:/web/v2/objects/contract/template/delete/{ids}
     */
    contractServiceDeleteTemplateMixin2: (ids: string[], params: RequestParams = {}) =>
      this.request<ContractServiceDeleteTemplateMixin2Data, ContractServiceDeleteTemplateMixin2Error>({
        path: `/web/v2/objects/contract/template/delete/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Deletes the rendered contract file for the given renderId.
     *
     * @tags ContractService
     * @name ContractServiceDeleteRenderFile
     * @summary Delete a rendered contract file
     * @request DELETE:/web/v2/objects/contract/template/deleteRenderFile/{renderId}
     */
    contractServiceDeleteRenderFile: (renderId: string, params: RequestParams = {}) =>
      this.request<ContractServiceDeleteRenderFileData, ContractServiceDeleteRenderFileError>({
        path: `/web/v2/objects/contract/template/deleteRenderFile/${renderId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Deletes the rendered contract files for the given render IDs.
     *
     * @tags ContractService
     * @name ContractServiceDeleteRenderFiles
     * @summary Delete multiple rendered contract files
     * @request POST:/web/v2/objects/contract/template/deleteRenderFiles
     */
    contractServiceDeleteRenderFiles: (body: V2DeleteRenderFilesRequest, params: RequestParams = {}) =>
      this.request<ContractServiceDeleteRenderFilesData, ContractServiceDeleteRenderFilesError>({
        path: `/web/v2/objects/contract/template/deleteRenderFiles`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the rendered contract bytes for the given renderId once the async render has finished.
     *
     * @tags ContractService
     * @name ContractServiceGetRenderFile
     * @summary Get a rendered contract file
     * @request GET:/web/v2/objects/contract/template/getRenderFile/{renderId}
     */
    contractServiceGetRenderFile: (renderId: string, params: RequestParams = {}) =>
      this.request<ContractServiceGetRenderFileData, ContractServiceGetRenderFileError>({
        path: `/web/v2/objects/contract/template/getRenderFile/${renderId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the async render identified by renderId has finished or failed, including an optional errorMessage.
     *
     * @tags ContractService
     * @name ContractServiceGetRenderStatus
     * @summary Get async contract render status
     * @request GET:/web/v2/objects/contract/template/getRenderStatus/{renderId}
     */
    contractServiceGetRenderStatus: (renderId: string, params: RequestParams = {}) =>
      this.request<ContractServiceGetRenderStatusData, ContractServiceGetRenderStatusError>({
        path: `/web/v2/objects/contract/template/getRenderStatus/${renderId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the contract templates belonging to any of the given owner IDs.
     *
     * @tags ContractService
     * @name ContractServiceListTemplatesMixin2
     * @summary List contract templates by owner IDs
     * @request GET:/web/v2/objects/contract/template/list/{ownerIds}
     */
    contractServiceListTemplatesMixin2: (ownerIds: string[], params: RequestParams = {}) =>
      this.request<ContractServiceListTemplatesMixin2Data, ContractServiceListTemplatesMixin2Error>({
        path: `/web/v2/objects/contract/template/list/${ownerIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns finished/failed status and optional errorMessage for each of the given render IDs.
     *
     * @tags ContractService
     * @name ContractServiceListRenderStatus
     * @summary List async contract render statuses
     * @request POST:/web/v2/objects/contract/template/listRenderStatus
     */
    contractServiceListRenderStatus: (body: V2ListRenderStatusRequest, params: RequestParams = {}) =>
      this.request<ContractServiceListRenderStatusData, ContractServiceListRenderStatusError>({
        path: `/web/v2/objects/contract/template/listRenderStatus`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given devices. Accepts order description, contact/assignee, on-site contact (onSiteContactPersonId or randomContactData), execution dates, title, description, attachAutomatically, showInPortal, enforcePdf, signatories, orderNumber, and documentName. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderDeviceTemplateMixin2
     * @summary Start async render of a device contract template
     * @request POST:/web/v2/objects/contract/template/renderDevice
     */
    contractServiceRenderDeviceTemplateMixin2: (
      body: Contractv2RenderDeviceTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderDeviceTemplateMixin2Data, ContractServiceRenderDeviceTemplateMixin2Error>({
        path: `/web/v2/objects/contract/template/renderDevice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given tenancy IDs. Optional attachAutomatically, showInPortal, title, description, signatories, order, sendingProfile, enforcePdf, documentName, and oneDocumentPerTenancy may be supplied. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderTenanciesTemplateMixin2
     * @summary Start async render of a contract template for multiple tenancies
     * @request POST:/web/v2/objects/contract/template/renderTenancies
     */
    contractServiceRenderTenanciesTemplateMixin2: (
      body: Contractv2RenderTenanciesTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderTenanciesTemplateMixin2Data, ContractServiceRenderTenanciesTemplateMixin2Error>(
        {
          path: `/web/v2/objects/contract/template/renderTenancies`,
          method: "POST",
          body: body,
          type: ContentType.Json,
          ...params,
        },
      ),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given tenancyId. Optional attachAutomatically, showInPortal, title, description, signatories, useGuarantorAddress, sendingProfile, enforcePdf, and documentName may be supplied. Returns a renderId to poll for status and download the file.
     *
     * @tags ContractService
     * @name ContractServiceRenderTenancyTemplate
     * @summary Start async render of a tenancy contract template
     * @request POST:/web/v2/objects/contract/template/renderTenancy
     */
    contractServiceRenderTenancyTemplate: (body: V2RenderTenancyTemplateRequest, params: RequestParams = {}) =>
      this.request<ContractServiceRenderTenancyTemplateData, ContractServiceRenderTenancyTemplateError>({
        path: `/web/v2/objects/contract/template/renderTenancy`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing contract template by ID. Accepts ownerId, creatorName, title, mediaId, category, enforcePdf, and language.
     *
     * @tags ContractService
     * @name ContractServiceUpdateTemplateMixin2
     * @summary Update a contract template
     * @request POST:/web/v2/objects/contract/template/update/{id}
     */
    contractServiceUpdateTemplateMixin2: (
      id: string,
      body: ContractServiceUpdateTemplateMixin2Payload,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceUpdateTemplateMixin2Data, ContractServiceUpdateTemplateMixin2Error>({
        path: `/web/v2/objects/contract/template/update/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns rendered contract bytes for the given render IDs (combined into a single response payload).
     *
     * @tags ContractService
     * @name ContractServiceGetRenderFiles
     * @summary Get multiple rendered contract files
     * @request POST:/web/v2/objects/contracts/template/getRenderFiles
     */
    contractServiceGetRenderFiles: (body: V2GetRenderFilesRequest, params: RequestParams = {}) =>
      this.request<ContractServiceGetRenderFilesData, ContractServiceGetRenderFilesError>({
        path: `/web/v2/objects/contracts/template/getRenderFiles`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given condominiumId. Optional includeRoommates, attachAutomatically, showInPortal, title, description, signatories, sendingProfile, enforcePdf, and documentName may be supplied. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderCondominiumTemplateMixin2
     * @summary Start async render of a condominium contract template
     * @request POST:/web/v2/objects/contracts/template/renderCondominium
     */
    contractServiceRenderCondominiumTemplateMixin2: (
      body: Contractv2RenderCondominiumTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ContractServiceRenderCondominiumTemplateMixin2Data,
        ContractServiceRenderCondominiumTemplateMixin2Error
      >({
        path: `/web/v2/objects/contracts/template/renderCondominium`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given condominium IDs. Optional includeRoommates, attachAutomatically, showInPortal, title, description, signatories, order, sendingProfile, enforcePdf, and documentName may be supplied. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderCondominiumsTemplateMixin2
     * @summary Start async render of a contract template for multiple condominiums
     * @request POST:/web/v2/objects/contracts/template/renderCondominiums
     */
    contractServiceRenderCondominiumsTemplateMixin2: (
      body: Contractv2RenderCondominiumsTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ContractServiceRenderCondominiumsTemplateMixin2Data,
        ContractServiceRenderCondominiumsTemplateMixin2Error
      >({
        path: `/web/v2/objects/contracts/template/renderCondominiums`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given contactId. Optional attachAutomatically, showInPortal, title, description, signatories, sendingProfile, enforcePdf, and documentName may be supplied. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderContactTemplateMixin2
     * @summary Start async render of a contact contract template
     * @request POST:/web/v2/objects/contracts/template/renderContact
     */
    contractServiceRenderContactTemplateMixin2: (
      body: Contractv2RenderContactTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderContactTemplateMixin2Data, ContractServiceRenderContactTemplateMixin2Error>({
        path: `/web/v2/objects/contracts/template/renderContact`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Starts an asynchronous render of the contract template identified by ID for the given contact IDs. Optional attachAutomatically, showInPortal, title, description, signatories, order, sendingProfile, enforcePdf, and documentName may be supplied. Returns a renderId.
     *
     * @tags ContractService
     * @name ContractServiceRenderContactsTemplateMixin2
     * @summary Start async render of a contract template for multiple contacts
     * @request POST:/web/v2/objects/contracts/template/renderContacts
     */
    contractServiceRenderContactsTemplateMixin2: (
      body: Contractv2RenderContactsTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractServiceRenderContactsTemplateMixin2Data, ContractServiceRenderContactsTemplateMixin2Error>({
        path: `/web/v2/objects/contracts/template/renderContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of properties visible for the given account under the specified share scope.
     *
     * @tags PropertyService
     * @name PropertyServiceCount
     * @summary Count properties for an account
     * @request GET:/web/v2/objects/property/count/{accountId}
     */
    propertyServiceCount: ({ accountId, ...query }: PropertyServiceCountParams, params: RequestParams = {}) =>
      this.request<PropertyServiceCountData, PropertyServiceCountError>({
        path: `/web/v2/objects/property/count/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates a new property for the given owner. Optional numericId may be supplied; otherwise it can be generated by the service. Address requires zip, city and state.
     *
     * @tags PropertyService
     * @name PropertyServiceCreate
     * @summary Create a property
     * @request POST:/web/v2/objects/property/create
     */
    propertyServiceCreate: (body: Objectpropertyv2CreateRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceCreateData, PropertyServiceCreateError>({
        path: `/web/v2/objects/property/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the property types the given account is allowed to use (e.g. rental, condominium ownership, cooperative).
     *
     * @tags PropertyService
     * @name PropertyServiceGetAllowedPropertyTypes
     * @summary Get allowed property types
     * @request GET:/web/v2/objects/property/getAllowedPropertyTypes/{accountId}
     */
    propertyServiceGetAllowedPropertyTypes: (accountId: string, params: RequestParams = {}) =>
      this.request<PropertyServiceGetAllowedPropertyTypesData, PropertyServiceGetAllowedPropertyTypesError>({
        path: `/web/v2/objects/property/getAllowedPropertyTypes/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of properties for the given owner. Supports filtering by name, numeric number, zip range and city, and sorting by number, land register number, building count, or rent figures. Response includes total property and page counts.
     *
     * @tags PropertyService
     * @name PropertyServiceList
     * @summary List properties for an owner
     * @request GET:/web/v2/objects/property/list/{ownerId}
     */
    propertyServiceList: ({ ownerId, ...query }: PropertyServiceListParams, params: RequestParams = {}) =>
      this.request<PropertyServiceListData, PropertyServiceListError>({
        path: `/web/v2/objects/property/list/${ownerId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns properties that contain any of the given building IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceListByBuildingIds
     * @summary List properties by building IDs
     * @request GET:/web/v2/objects/property/listByBuildingIds/{buildingIds}
     */
    propertyServiceListByBuildingIds: (buildingIds: string[], params: RequestParams = {}) =>
      this.request<PropertyServiceListByBuildingIdsData, PropertyServiceListByBuildingIdsError>({
        path: `/web/v2/objects/property/listByBuildingIds/${buildingIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the properties matching the given property IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceListByIds
     * @summary List properties by IDs
     * @request GET:/web/v2/objects/property/listByIds/{ids}
     */
    propertyServiceListByIds: (ids: string[], params: RequestParams = {}) =>
      this.request<PropertyServiceListByIdsData, PropertyServiceListByIdsError>({
        path: `/web/v2/objects/property/listByIds/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a single property identified by owner account ID and property numeric ID.
     *
     * @tags PropertyService
     * @name PropertyServiceGetByOwnerIdAndNumericId
     * @summary Get property by owner and numeric ID
     * @request GET:/web/v2/objects/property/listByOwnerIdAndNumericId/{ownerId}/{numericId}
     */
    propertyServiceGetByOwnerIdAndNumericId: (ownerId: string, numericId: string, params: RequestParams = {}) =>
      this.request<PropertyServiceGetByOwnerIdAndNumericIdData, PropertyServiceGetByOwnerIdAndNumericIdError>({
        path: `/web/v2/objects/property/listByOwnerIdAndNumericId/${ownerId}/${numericId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns property filter options (id, name, ownerId, buildingIds) available to the authenticated caller. Options are determined by authorization data; the request has no parameters.
     *
     * @tags PropertyService
     * @name PropertyServiceListFilterOptions
     * @summary List property filter options
     * @request GET:/web/v2/objects/property/listFilterOptions
     */
    propertyServiceListFilterOptions: (params: RequestParams = {}) =>
      this.request<PropertyServiceListFilterOptionsData, PropertyServiceListFilterOptionsError>({
        path: `/web/v2/objects/property/listFilterOptions`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the numeric IDs of all properties belonging to the given owner.
     *
     * @tags PropertyService
     * @name PropertyServiceListIds
     * @summary List property numeric IDs for an owner
     * @request GET:/web/v2/objects/property/listIds/{ownerId}
     */
    propertyServiceListIds: (ownerId: string, params: RequestParams = {}) =>
      this.request<PropertyServiceListIdsData, PropertyServiceListIdsError>({
        path: `/web/v2/objects/property/listIds/${ownerId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Transfers ownership of the property to targetOwnerId. Optionally keeps existing network partners.
     *
     * @tags PropertyService
     * @name PropertyServiceSell
     * @summary Sell a property to a new owner
     * @request POST:/web/v2/objects/property/sell
     */
    propertyServiceSell: (body: V2SellRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceSellData, PropertyServiceSellError>({
        path: `/web/v2/objects/property/sell`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the accounting assignee contact for the given property IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceSetAccountingAssignee
     * @summary Set accounting assignee on properties
     * @request POST:/web/v2/objects/property/setAccountingAssignee
     */
    propertyServiceSetAccountingAssignee: (body: Propertyv2SetAccountingAssigneeRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceSetAccountingAssigneeData, PropertyServiceSetAccountingAssigneeError>({
        path: `/web/v2/objects/property/setAccountingAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the administration assignee contact for the given property IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceSetAdminAssignee
     * @summary Set admin assignee on properties
     * @request POST:/web/v2/objects/property/setAdminAssignee
     */
    propertyServiceSetAdminAssignee: (body: Propertyv2SetAdminAssigneeRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceSetAdminAssigneeData, PropertyServiceSetAdminAssigneeError>({
        path: `/web/v2/objects/property/setAdminAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the asset assignee contact for the given property IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceSetAssetAssignee
     * @summary Set asset assignee on properties
     * @request POST:/web/v2/objects/property/setAssetAssignee
     */
    propertyServiceSetAssetAssignee: (body: Propertyv2SetAssetAssigneeRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceSetAssetAssigneeData, PropertyServiceSetAssetAssigneeError>({
        path: `/web/v2/objects/property/setAssetAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the owner assignee contact for the given property IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceSetOwnerAssignee
     * @summary Set owner assignee on properties
     * @request POST:/web/v2/objects/property/setOwnerAssignee
     */
    propertyServiceSetOwnerAssignee: (body: Propertyv2SetOwnerAssigneeRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceSetOwnerAssigneeData, PropertyServiceSetOwnerAssigneeError>({
        path: `/web/v2/objects/property/setOwnerAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given properties as transferred to accounting (sets transferToAccounting).
     *
     * @tags PropertyService
     * @name PropertyServiceTransferToAccounting
     * @summary Transfer properties to accounting
     * @request POST:/web/v2/objects/property/transferToAccounting
     */
    propertyServiceTransferToAccounting: (body: Propertyv2TransferToAccountingRequest, params: RequestParams = {}) =>
      this.request<PropertyServiceTransferToAccountingData, PropertyServiceTransferToAccountingError>({
        path: `/web/v2/objects/property/transferToAccounting`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the properties with the given IDs.
     *
     * @tags PropertyService
     * @name PropertyServiceDelete
     * @summary Delete properties
     * @request DELETE:/web/v2/objects/property/{ids}
     */
    propertyServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<PropertyServiceDeleteData, PropertyServiceDeleteError>({
        path: `/web/v2/objects/property/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Associates an additional building ID with the given property.
     *
     * @tags PropertyService
     * @name PropertyServiceAddBuilding
     * @summary Add a building to a property
     * @request POST:/web/v2/objects/property/{id}/addBuildingId
     */
    propertyServiceAddBuilding: (id: string, body: PropertyServiceAddBuildingPayload, params: RequestParams = {}) =>
      this.request<PropertyServiceAddBuildingData, PropertyServiceAddBuildingError>({
        path: `/web/v2/objects/property/${id}/addBuildingId`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing property by ID. Address requires zip, city and state when set.
     *
     * @tags PropertyService
     * @name PropertyServiceUpdate
     * @summary Update a property
     * @request POST:/web/v2/objects/property/{id}/update
     */
    propertyServiceUpdate: (id: string, body: PropertyServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<PropertyServiceUpdateData, PropertyServiceUpdateError>({
        path: `/web/v2/objects/property/${id}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the JDBC connection configured for the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceDeleteJdbcConnection
     * @summary Delete JDBC connection for an account
     * @request DELETE:/web/reporting/deleteJdbcConnection/{accountId}
     */
    reportingServiceDeleteJdbcConnection: (accountId: string, params: RequestParams = {}) =>
      this.request<ReportingServiceDeleteJdbcConnectionData, ReportingServiceDeleteJdbcConnectionError>({
        path: `/web/reporting/deleteJdbcConnection/${accountId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns the additional reporting URLs configured for the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceGetAdditionalReportings
     * @summary Get additional reportings for an account
     * @request GET:/web/reporting/getAdditionalReportings/{accountId}
     */
    reportingServiceGetAdditionalReportings: (accountId: string, params: RequestParams = {}) =>
      this.request<ReportingServiceGetAdditionalReportingsData, ReportingServiceGetAdditionalReportingsError>({
        path: `/web/reporting/getAdditionalReportings/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns rent reports for the given building IDs, including gross and net target, actual, and overall rents per year.
     *
     * @tags ReportingService
     * @name ReportingServiceGetBuildingRentReports2
     * @summary Get building rent reports
     * @request POST:/web/reporting/getBuildingRentReports
     */
    reportingServiceGetBuildingRentReports2: (
      body: ReportingGetBuildingRentReportsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportingServiceGetBuildingRentReports2Data, ReportingServiceGetBuildingRentReports2Error>({
        path: `/web/reporting/getBuildingRentReports`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns rent reports for the given building IDs, including gross and net target, actual, and overall rents per year.
     *
     * @tags ReportingService
     * @name ReportingServiceGetBuildingRentReports
     * @summary Get building rent reports
     * @request GET:/web/reporting/getBuildingRentReports/{buildingIds}
     */
    reportingServiceGetBuildingRentReports: (buildingIds: string[], params: RequestParams = {}) =>
      this.request<ReportingServiceGetBuildingRentReportsData, ReportingServiceGetBuildingRentReportsError>({
        path: `/web/reporting/getBuildingRentReports/${buildingIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the global default reporting URLs for owner, asset, admin, market, and finance base categories. The request has no parameters.
     *
     * @tags ReportingService
     * @name ReportingServiceGetDefaultReportings
     * @summary Get default reportings
     * @request GET:/web/reporting/getDefaultReportings
     */
    reportingServiceGetDefaultReportings: (params: RequestParams = {}) =>
      this.request<ReportingServiceGetDefaultReportingsData, ReportingServiceGetDefaultReportingsError>({
        path: `/web/reporting/getDefaultReportings`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all configured JDBC connections. The request has no parameters.
     *
     * @tags ReportingService
     * @name ReportingServiceGetJdbcConnections
     * @summary List JDBC connections
     * @request GET:/web/reporting/getJdbcConnections
     */
    reportingServiceGetJdbcConnections: (params: RequestParams = {}) =>
      this.request<ReportingServiceGetJdbcConnectionsData, ReportingServiceGetJdbcConnectionsError>({
        path: `/web/reporting/getJdbcConnections`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns default and additional reporting URLs available to the authenticated caller. The request has no parameters.
     *
     * @tags ReportingService
     * @name ReportingServiceGetMyReportings
     * @summary Get reportings for the current caller
     * @request GET:/web/reporting/getMyReportings
     */
    reportingServiceGetMyReportings: (params: RequestParams = {}) =>
      this.request<ReportingServiceGetMyReportingsData, ReportingServiceGetMyReportingsError>({
        path: `/web/reporting/getMyReportings`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns rent reports for the given property IDs, including gross and net target, actual, and overall rents per year.
     *
     * @tags ReportingService
     * @name ReportingServiceGetPropertyRentReports
     * @summary Get property rent reports
     * @request GET:/web/reporting/getPropertyRentReports/{propertyIds}
     */
    reportingServiceGetPropertyRentReports: (propertyIds: string[], params: RequestParams = {}) =>
      this.request<ReportingServiceGetPropertyRentReportsData, ReportingServiceGetPropertyRentReportsError>({
        path: `/web/reporting/getPropertyRentReports/${propertyIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the reporting URL configuration for the given account, including overview and category-specific URL lists.
     *
     * @tags ReportingService
     * @name ReportingServiceGetReportingUrls
     * @summary Get reporting URLs for an account
     * @request GET:/web/reporting/getReportingUrls/{accountId}
     */
    reportingServiceGetReportingUrls: (accountId: string, params: RequestParams = {}) =>
      this.request<ReportingServiceGetReportingUrlsData, ReportingServiceGetReportingUrlsError>({
        path: `/web/reporting/getReportingUrls/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether a JDBC connection is configured for the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceHasJdbcConnection
     * @summary Check if account has JDBC connection
     * @request GET:/web/reporting/hasJdbcConnection/{accountId}
     */
    reportingServiceHasJdbcConnection: (accountId: string, params: RequestParams = {}) =>
      this.request<ReportingServiceHasJdbcConnectionData, ReportingServiceHasJdbcConnectionError>({
        path: `/web/reporting/hasJdbcConnection/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets the additional reporting URLs for the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceSetAdditionalReportings
     * @summary Set additional reportings for an account
     * @request POST:/web/reporting/setAdditionalReportings/{accountId}
     */
    reportingServiceSetAdditionalReportings: (
      accountId: string,
      body: ReportingServiceSetAdditionalReportingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReportingServiceSetAdditionalReportingsData, ReportingServiceSetAdditionalReportingsError>({
        path: `/web/reporting/setAdditionalReportings/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the global default reporting URLs for owner, asset, admin, market, and finance base categories.
     *
     * @tags ReportingService
     * @name ReportingServiceSetDefaultReportings
     * @summary Set default reportings
     * @request POST:/web/reporting/setDefaultReportings
     */
    reportingServiceSetDefaultReportings: (body: ReportingSetDefaultReportingsRequest, params: RequestParams = {}) =>
      this.request<ReportingServiceSetDefaultReportingsData, ReportingServiceSetDefaultReportingsError>({
        path: `/web/reporting/setDefaultReportings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Stores JDBC connection details (host, username, password, client) for the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceSetJdbcConnection
     * @summary Set JDBC connection for an account
     * @request POST:/web/reporting/setJdbcConnection/{accountId}
     */
    reportingServiceSetJdbcConnection: (
      accountId: string,
      body: ReportingServiceSetJdbcConnectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReportingServiceSetJdbcConnectionData, ReportingServiceSetJdbcConnectionError>({
        path: `/web/reporting/setJdbcConnection/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the allowed user IDs for a reporting URL on the given account.
     *
     * @tags ReportingService
     * @name ReportingServiceSetReportingPermissions
     * @summary Set reporting URL permissions
     * @request POST:/web/reporting/setReportingPermissions
     */
    reportingServiceSetReportingPermissions: (
      body: ReportingSetReportingPermissionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReportingServiceSetReportingPermissionsData, ReportingServiceSetReportingPermissionsError>({
        path: `/web/reporting/setReportingPermissions`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets reporting URL collections for the given account across overview, role-specific overview, administration, marketing, accounting, tenant list, and publish history categories.
     *
     * @tags ReportingService
     * @name ReportingServiceSetReportingUrls
     * @summary Set reporting URLs for an account
     * @request POST:/web/reporting/setReportingUrls/{accountId}
     */
    reportingServiceSetReportingUrls: (
      accountId: string,
      body: ReportingServiceSetReportingUrlsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReportingServiceSetReportingUrlsData, ReportingServiceSetReportingUrlsError>({
        path: `/web/reporting/setReportingUrls/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new rental application from either individuals (with optional guarantors) or a company. Individuals and company must not both be provided.
     *
     * @tags ApplicationService
     * @name ApplicationServiceCreate
     * @summary Create an application
     * @request POST:/web/v2/request/application/create
     */
    applicationServiceCreate: (body: Requestapplicationv2CreateRequest, params: RequestParams = {}) =>
      this.request<ApplicationServiceCreateData, ApplicationServiceCreateError>({
        path: `/web/v2/request/application/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the applications with the given IDs. When hard is true, performs a hard delete.
     *
     * @tags ApplicationService
     * @name ApplicationServiceDelete
     * @summary Delete applications
     * @request DELETE:/web/v2/request/application/delete/{ids}
     */
    applicationServiceDelete: ({ ids, ...query }: ApplicationServiceDeleteParams, params: RequestParams = {}) =>
      this.request<ApplicationServiceDeleteData, ApplicationServiceDeleteError>({
        path: `/web/v2/request/application/delete/${ids}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the application identified by the given ID.
     *
     * @tags ApplicationService
     * @name ApplicationServiceGetById
     * @summary Get application by ID
     * @request GET:/web/v2/request/application/getById/{id}
     */
    applicationServiceGetById: (id: string, params: RequestParams = {}) =>
      this.request<ApplicationServiceGetByIdData, ApplicationServiceGetByIdError>({
        path: `/web/v2/request/application/getById/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the most recent application created by the given creator email.
     *
     * @tags ApplicationService
     * @name ApplicationServiceGetLatest
     * @summary Get latest application by creator email
     * @request GET:/web/v2/request/application/getLatest/{creatorEmail}
     */
    applicationServiceGetLatest: (creatorEmail: string, params: RequestParams = {}) =>
      this.request<ApplicationServiceGetLatestData, ApplicationServiceGetLatestError>({
        path: `/web/v2/request/application/getLatest/${creatorEmail}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sends the application for the given object. Optional requestId matches an existing request; otherwise email matching is used. Supports viewingAppointmentDone, desiredStartOfContract, and language.
     *
     * @tags ApplicationService
     * @name ApplicationServiceSend
     * @summary Send an application
     * @request POST:/web/v2/request/application/send
     */
    applicationServiceSend: (body: V2SendRequest, params: RequestParams = {}) =>
      this.request<ApplicationServiceSendData, ApplicationServiceSendError>({
        path: `/web/v2/request/application/send`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns application settings for the given account ID.
     *
     * @tags ApplicationService
     * @name ApplicationServiceGetSettings
     * @summary Get application settings for an account
     * @request GET:/web/v2/request/application/settings/{accountId}
     */
    applicationServiceGetSettings: (accountId: string, params: RequestParams = {}) =>
      this.request<ApplicationServiceGetSettingsData, ApplicationServiceGetSettingsError>({
        path: `/web/v2/request/application/settings/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates application settings for the given account, including contract creation cost, automatic reference check, dossier requirements, affordability ranges, and reference email template bodies. Returns the saved settings.
     *
     * @tags ApplicationService
     * @name ApplicationServiceSetSettings
     * @summary Set application settings for an account
     * @request POST:/web/v2/request/application/settings/{accountId}
     */
    applicationServiceSetSettings: (
      accountId: string,
      body: ApplicationServiceSetSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationServiceSetSettingsData, ApplicationServiceSetSettingsError>({
        path: `/web/v2/request/application/settings/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new rental request for the given owner and object. Accepts source, marketplace name, initial message, requesters, guarantors, checklist, and flags such as favorite, rejected, and sendDefaultAnswer.
     *
     * @tags RequestService
     * @name RequestServiceCreate
     * @summary Create a request
     * @request POST:/web/v2/request/create
     */
    requestServiceCreate: (body: Requestrequestv2CreateRequest, params: RequestParams = {}) =>
      this.request<RequestServiceCreateData, RequestServiceCreateError>({
        path: `/web/v2/request/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns overall and employee-scoped new and unread request counts for the given account under marketing share scope. Optional contactIdAssigneeMarketing scopes the employee figures.
     *
     * @tags RequestService
     * @name RequestServiceGetMarketingStatistics
     * @summary Get marketing request statistics
     * @request GET:/web/v2/request/getMarketingStatistics/{accountId}
     */
    requestServiceGetMarketingStatistics: (
      { accountId, ...query }: RequestServiceGetMarketingStatisticsParams,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceGetMarketingStatisticsData, RequestServiceGetMarketingStatisticsError>({
        path: `/web/v2/request/getMarketingStatistics/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns per-object request statistics including overall, unread, appointments done, and applications received counts.
     *
     * @tags RequestService
     * @name RequestServiceGetStatistics
     * @summary Get request statistics by object IDs
     * @request GET:/web/v2/request/getStatistics/{objectIds}
     */
    requestServiceGetStatistics: (objectIds: string[], params: RequestParams = {}) =>
      this.request<RequestServiceGetStatisticsData, RequestServiceGetStatisticsError>({
        path: `/web/v2/request/getStatistics/${objectIds}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the requests matching the given request IDs.
     *
     * @tags RequestService
     * @name RequestServiceListByIds
     * @summary List requests by IDs
     * @request GET:/web/v2/request/listByIds/{ids}
     */
    requestServiceListByIds: (ids: string[], params: RequestParams = {}) =>
      this.request<RequestServiceListByIdsData, RequestServiceListByIdsError>({
        path: `/web/v2/request/listByIds/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns all requests that include the given requester contact ID.
     *
     * @tags RequestService
     * @name RequestServiceListByRequesterContactId
     * @summary List requests by requester contact ID
     * @request GET:/web/v2/request/listByRequesterContactId/{contactId}
     */
    requestServiceListByRequesterContactId: (contactId: string, params: RequestParams = {}) =>
      this.request<RequestServiceListByRequesterContactIdData, RequestServiceListByRequesterContactIdError>({
        path: `/web/v2/request/listByRequesterContactId/${contactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns received requests for the given object IDs. Supports optional filters for new/unread state, checklist flags, and marketplace names. Response includes overall, new, and unread counts plus whether an object is reserved.
     *
     * @tags RequestService
     * @name RequestServiceListReceivedByObjectIds
     * @summary List received requests by object IDs
     * @request GET:/web/v2/request/listReceivedByObjectIds/{objectIds}
     */
    requestServiceListReceivedByObjectIds: (
      { objectIds, ...query }: RequestServiceListReceivedByObjectIdsParams,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceListReceivedByObjectIdsData, RequestServiceListReceivedByObjectIdsError>({
        path: `/web/v2/request/listReceivedByObjectIds/${objectIds}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns requests sent by the given account ID.
     *
     * @tags RequestService
     * @name RequestServiceListSent
     * @summary List sent requests for an account
     * @request GET:/web/v2/request/listSent/{accountId}
     */
    requestServiceListSent: (accountId: string, params: RequestParams = {}) =>
      this.request<RequestServiceListSentData, RequestServiceListSentError>({
        path: `/web/v2/request/listSent/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Marks the given requests as read. When readByReceiver is true the receiver side is updated; otherwise the requester side is updated.
     *
     * @tags RequestService
     * @name RequestServiceMarkRead
     * @summary Mark requests as read
     * @request POST:/web/v2/request/markRead
     */
    requestServiceMarkRead: (body: Requestrequestv2MarkReadRequest, params: RequestParams = {}) =>
      this.request<RequestServiceMarkReadData, RequestServiceMarkReadError>({
        path: `/web/v2/request/markRead`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given requests as rejected.
     *
     * @tags RequestService
     * @name RequestServiceMarkRejected
     * @summary Mark requests as rejected
     * @request POST:/web/v2/request/markRejected
     */
    requestServiceMarkRejected: (body: V2MarkRejectedRequest, params: RequestParams = {}) =>
      this.request<RequestServiceMarkRejectedData, RequestServiceMarkRejectedError>({
        path: `/web/v2/request/markRejected`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given requests as unread. When unreadByReceiver is true the receiver side is updated; otherwise the requester side is updated.
     *
     * @tags RequestService
     * @name RequestServiceMarkUnread
     * @summary Mark requests as unread
     * @request POST:/web/v2/request/markUnread
     */
    requestServiceMarkUnread: (body: Requestrequestv2MarkUnreadRequest, params: RequestParams = {}) =>
      this.request<RequestServiceMarkUnreadData, RequestServiceMarkUnreadError>({
        path: `/web/v2/request/markUnread`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates only the provided checklist fields on the given requests. Returns the updated requests.
     *
     * @tags RequestService
     * @name RequestServicePartiallySetChecklist
     * @summary Partially update request checklist
     * @request POST:/web/v2/request/partiallySetChecklist
     */
    requestServicePartiallySetChecklist: (body: V2PartiallySetChecklistRequest, params: RequestParams = {}) =>
      this.request<RequestServicePartiallySetChecklistData, RequestServicePartiallySetChecklistError>({
        path: `/web/v2/request/partiallySetChecklist`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Reactivates the given requests by clearing their rejected state.
     *
     * @tags RequestService
     * @name RequestServiceReactivate
     * @summary Reactivate rejected requests
     * @request POST:/web/v2/request/reactivate
     */
    requestServiceReactivate: (body: V2ReactivateRequest, params: RequestParams = {}) =>
      this.request<RequestServiceReactivateData, RequestServiceReactivateError>({
        path: `/web/v2/request/reactivate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the digital reference form for the given public ID, including validity, type, language, applicant and administration details, and prefill data.
     *
     * @tags RequestService
     * @name RequestServiceGetReferenceForm
     * @summary Get digital reference form
     * @request GET:/web/v2/request/reference/{publicId}
     */
    requestServiceGetReferenceForm: (publicId: string, params: RequestParams = {}) =>
      this.request<RequestServiceGetReferenceFormData, RequestServiceGetReferenceFormError>({
        path: `/web/v2/request/reference/${publicId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Submits employer or landlord reference answers for the form identified by public ID, including optional contact person for queries and notes.
     *
     * @tags RequestService
     * @name RequestServiceSubmitReferenceForm
     * @summary Submit digital reference form
     * @request POST:/web/v2/request/reference/{publicId}/submit
     */
    requestServiceSubmitReferenceForm: (
      publicId: string,
      body: RequestServiceSubmitReferenceFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceSubmitReferenceFormData, RequestServiceSubmitReferenceFormError>({
        path: `/web/v2/request/reference/${publicId}/submit`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Replaces the full checklist on the given requests with the provided checklist values.
     *
     * @tags RequestService
     * @name RequestServiceSetChecklist
     * @summary Set request checklist
     * @request POST:/web/v2/request/setChecklist
     */
    requestServiceSetChecklist: (body: V2SetChecklistRequest, params: RequestParams = {}) =>
      this.request<RequestServiceSetChecklistData, RequestServiceSetChecklistError>({
        path: `/web/v2/request/setChecklist`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given requests as favorite.
     *
     * @tags RequestService
     * @name RequestServiceSetFavorite
     * @summary Mark requests as favorite
     * @request POST:/web/v2/request/setFavorite
     */
    requestServiceSetFavorite: (body: V2SetFavoriteRequest, params: RequestParams = {}) =>
      this.request<RequestServiceSetFavoriteData, RequestServiceSetFavoriteError>({
        path: `/web/v2/request/setFavorite`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Clears the favorite flag on the given requests.
     *
     * @tags RequestService
     * @name RequestServiceSetNotFavorite
     * @summary Clear favorite on requests
     * @request POST:/web/v2/request/setNotFavorite
     */
    requestServiceSetNotFavorite: (body: V2SetNotFavoriteRequest, params: RequestParams = {}) =>
      this.request<RequestServiceSetNotFavoriteData, RequestServiceSetNotFavoriteError>({
        path: `/web/v2/request/setNotFavorite`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the requests with the given IDs.
     *
     * @tags RequestService
     * @name RequestServiceDelete
     * @summary Delete requests
     * @request DELETE:/web/v2/request/{ids}
     */
    requestServiceDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<RequestServiceDeleteData, RequestServiceDeleteError>({
        path: `/web/v2/request/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Adds the given guarantors to the request identified by ID and returns the updated request.
     *
     * @tags RequestService
     * @name RequestServiceAddGuarantors
     * @summary Add guarantors to a request
     * @request POST:/web/v2/request/{id}/addGuarantors
     */
    requestServiceAddGuarantors: (id: string, body: RequestServiceAddGuarantorsPayload, params: RequestParams = {}) =>
      this.request<RequestServiceAddGuarantorsData, RequestServiceAddGuarantorsError>({
        path: `/web/v2/request/${id}/addGuarantors`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds the given requesters to the request identified by ID and returns the updated request.
     *
     * @tags RequestService
     * @name RequestServiceAddRequesters
     * @summary Add requesters to a request
     * @request POST:/web/v2/request/{id}/addRequesters
     */
    requestServiceAddRequesters: (id: string, body: RequestServiceAddRequestersPayload, params: RequestParams = {}) =>
      this.request<RequestServiceAddRequestersData, RequestServiceAddRequestersError>({
        path: `/web/v2/request/${id}/addRequesters`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Moves the request to the given target object ID and returns the updated request.
     *
     * @tags RequestService
     * @name RequestServiceMove
     * @summary Move a request to another object
     * @request POST:/web/v2/request/{id}/move
     */
    requestServiceMove: (id: string, body: RequestServiceMovePayload, params: RequestParams = {}) =>
      this.request<RequestServiceMoveData, RequestServiceMoveError>({
        path: `/web/v2/request/${id}/move`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes requesters identified by contact IDs from the request and returns the updated request.
     *
     * @tags RequestService
     * @name RequestServiceRemoveRequesters
     * @summary Remove requesters from a request
     * @request POST:/web/v2/request/{id}/removeRequesters
     */
    requestServiceRemoveRequesters: (
      id: string,
      body: RequestServiceRemoveRequestersPayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceRemoveRequestersData, RequestServiceRemoveRequestersError>({
        path: `/web/v2/request/${id}/removeRequesters`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends a digital employer reference request email for the given contact on the request. Optional language selects the email/form template. Returns the updated employer reference.
     *
     * @tags RequestService
     * @name RequestServiceRequestEmployerReferenceByEmail
     * @summary Request employer reference by email
     * @request POST:/web/v2/request/{id}/requestEmployerReferenceByEmail
     */
    requestServiceRequestEmployerReferenceByEmail: (
      id: string,
      body: {
        contactId?: string;
        /** Optional. Language for the email template / form. Falls back to account/marketing language. */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RequestServiceRequestEmployerReferenceByEmailData,
        RequestServiceRequestEmployerReferenceByEmailError
      >({
        path: `/web/v2/request/${id}/requestEmployerReferenceByEmail`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Sends a digital landlord reference request email for the given contact on the request. Optional language selects the email/form template. Returns the updated landlord reference.
     *
     * @tags RequestService
     * @name RequestServiceRequestLandlordReferenceByEmail
     * @summary Request landlord reference by email
     * @request POST:/web/v2/request/{id}/requestLandlordReferenceByEmail
     */
    requestServiceRequestLandlordReferenceByEmail: (
      id: string,
      body: {
        contactId?: string;
        /** Optional. Language for the email template / form. Falls back to account/marketing language. */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RequestServiceRequestLandlordReferenceByEmailData,
        RequestServiceRequestLandlordReferenceByEmailError
      >({
        path: `/web/v2/request/${id}/requestLandlordReferenceByEmail`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Reserves the request for the given tenancy IDs.
     *
     * @tags RequestService
     * @name RequestServiceReserve
     * @summary Reserve a request for tenancies
     * @request POST:/web/v2/request/{id}/reserve
     */
    requestServiceReserve: (id: string, body: RequestServiceReservePayload, params: RequestParams = {}) =>
      this.request<RequestServiceReserveData, RequestServiceReserveError>({
        path: `/web/v2/request/${id}/reserve`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the employer reference for the given requester or guarantor contact on the request. Optionally generates a PDF in the specified language.
     *
     * @tags RequestService
     * @name RequestServiceSetEmployerReference
     * @summary Set employer reference on a request
     * @request POST:/web/v2/request/{id}/setEmployerReference
     */
    requestServiceSetEmployerReference: (
      id: string,
      body: RequestServiceSetEmployerReferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceSetEmployerReferenceData, RequestServiceSetEmployerReferenceError>({
        path: `/web/v2/request/${id}/setEmployerReference`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets or clears the finalized flag on the employer reference for the given requester or guarantor contact.
     *
     * @tags RequestService
     * @name RequestServiceSetEmployerReferenceFinalized
     * @summary Finalize employer reference
     * @request POST:/web/v2/request/{id}/setEmployerReferenceFinalized
     */
    requestServiceSetEmployerReferenceFinalized: (
      id: string,
      body: RequestServiceSetEmployerReferenceFinalizedPayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceSetEmployerReferenceFinalizedData, RequestServiceSetEmployerReferenceFinalizedError>({
        path: `/web/v2/request/${id}/setEmployerReferenceFinalized`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the landlord reference for the given requester or guarantor contact on the request. Optionally generates a PDF in the specified language.
     *
     * @tags RequestService
     * @name RequestServiceSetLandlordReference
     * @summary Set landlord reference on a request
     * @request POST:/web/v2/request/{id}/setLandlordReference
     */
    requestServiceSetLandlordReference: (
      id: string,
      body: RequestServiceSetLandlordReferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceSetLandlordReferenceData, RequestServiceSetLandlordReferenceError>({
        path: `/web/v2/request/${id}/setLandlordReference`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets or clears the finalized flag on the landlord reference for the given requester or guarantor contact.
     *
     * @tags RequestService
     * @name RequestServiceSetLandlordReferenceFinalized
     * @summary Finalize landlord reference
     * @request POST:/web/v2/request/{id}/setLandlordReferenceFinalized
     */
    requestServiceSetLandlordReferenceFinalized: (
      id: string,
      body: RequestServiceSetLandlordReferenceFinalizedPayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestServiceSetLandlordReferenceFinalizedData, RequestServiceSetLandlordReferenceFinalizedError>({
        path: `/web/v2/request/${id}/setLandlordReferenceFinalized`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates an authorized search API key for the given accountId. Returns the key string.
     *
     * @tags SearchService
     * @name SearchServiceGenerateApiKey
     * @summary Generate a search API key
     * @request POST:/web/search/search/generateApiKey
     */
    searchServiceGenerateApiKey: (body: SearchGenerateApiKeyRequest, params: RequestParams = {}) =>
      this.request<SearchServiceGenerateApiKeyData, SearchServiceGenerateApiKeyError>({
        path: `/web/search/search/generateApiKey`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Generates a search API key without account authorization. The request has no parameters. Returns the key string.
     *
     * @tags SearchService
     * @name SearchServiceGenerateUnauthorizedApiKey
     * @summary Generate an unauthorized search API key
     * @request POST:/web/search/search/generateUnauthorizedApiKey
     */
    searchServiceGenerateUnauthorizedApiKey: (
      body: SearchGenerateUnauthorizedApiKeyRequest,
      params: RequestParams = {},
    ) =>
      this.request<SearchServiceGenerateUnauthorizedApiKeyData, SearchServiceGenerateUnauthorizedApiKeyError>({
        path: `/web/search/search/generateUnauthorizedApiKey`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns up to 7 best Atlas Search matches for accountId across contacts, properties, buildings, objects, tenancies and condominiums. No filters. ACL via allowedAccountIds. Atlas-only (not Algolia).
     *
     * @tags SearchService
     * @name SearchServiceGlobalSearch
     * @summary Global free-text search across entity types
     * @request POST:/web/search/search/globalSearch
     */
    searchServiceGlobalSearch: (body: SearchGlobalSearchRequest, params: RequestParams = {}) =>
      this.request<SearchServiceGlobalSearchData, SearchServiceGlobalSearchError>({
        path: `/web/search/search/globalSearch`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable building list replacing Algolia building index queries. ACL is enforced server-side: only buildings where allowedAccountIds contains accountId (from auth) are returned. Free-text query searches numericId, name, address.street, address.streetNumber, address.streetAddition, address.zip and address.city. Default sort when no sort* field is set: buildingStrategy.reviewAtSortValue ASC, then owner.name ASC, then name ASC, then address.city ASC, then address.zip ASC, then address.street ASC, then address.streetNumber ASC, then objectCount ASC. When a sort* field is set, it is the primary sort; remaining defaults are applied as tie breakers. At most one primary sort* should be set. Searchable facet typeahead (cities, zips, craftsmen/janitors/serviceProviders/owner/network-partner names, objectCounts) is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListBuildings
     * @summary List buildings from the search read model
     * @request POST:/web/search/search/listBuildings
     */
    searchServiceListBuildings: (body: SearchListBuildingsRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListBuildingsData, SearchServiceListBuildingsError>({
        path: `/web/search/search/listBuildings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable condominium list replacing Algolia condominium index queries. ACL is enforced server-side: only condominiums where allowedAccountIds contains accountId (from auth) are returned. Free-text query searches condominiumOwners.name, billingContact.name, tenants.name, roommates.name, numericId, obj.numericId, obj.address.street/streetNumber/mailbox/subUnit/streetAddition/zip/city. Default sort when no sort* field is set: numericId ASC. When sortNumericId is set, it is the primary sort. Searchable facet typeahead is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListCondominiums
     * @summary List condominiums from the search read model
     * @request POST:/web/search/search/listCondominiums
     */
    searchServiceListCondominiums: (body: SearchListCondominiumsRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListCondominiumsData, SearchServiceListCondominiumsError>({
        path: `/web/search/search/listCondominiums`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable contact list replacing Algolia contact index queries. ACL is enforced server-side: only contacts where allowedAccountIds contains accountId (from auth) are returned. Default sort when no sort* field is set: name ASC, then email ASC. When a sort* field is set, it is the primary sort; remaining defaults are applied as tie breakers. At most one primary sort* should be set. Searchable facet typeahead (owner.name, tags) is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListContacts
     * @summary List contacts from the search read model
     * @request POST:/web/search/search/listContacts
     */
    searchServiceListContacts: (body: SearchListContactsRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListContactsData, SearchServiceListContactsError>({
        path: `/web/search/search/listContacts`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable object list replacing Algolia object index queries. ACL is enforced server-side: only objects where allowedAccountIds contains accountId (from auth) are returned. Free-text query searches numericId, number, publicId, name, address.street/streetNumber/streetAddition/zip/city, tenancy.tenants.name, networkPartners.name, condominium.owner, condominium.tenants and tenancy.subTenants.tenant.name. Default sort when no sort* field is set: inactive ASC, then categorySortValue ASC, then floorSortValue ASC, then name ASC. When a sort* field is set, it is the primary sort; remaining defaults are applied as tie breakers. At most one primary sort* should be set. Searchable facet typeahead is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListObjects
     * @summary List objects from the search read model
     * @request POST:/web/search/search/listObjects
     */
    searchServiceListObjects: (body: SearchListObjectsRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListObjectsData, SearchServiceListObjectsError>({
        path: `/web/search/search/listObjects`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable property list replacing Algolia property index queries. ACL is enforced server-side: only properties where allowedAccountIds contains accountId (from auth) are returned. Free-text query searches numericId, name, address.zip and address.city. Default sort when no sort* field is set: owner.name ASC, then name ASC, then address.city ASC, then address.zip ASC, then buildingCount ASC. When a sort* field is set, it is the primary sort; remaining defaults are applied as tie breakers. At most one primary sort* should be set. Searchable facet typeahead (cities, zips, assignee/owner/network-partner names) is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListProperties
     * @summary List properties from the search read model
     * @request POST:/web/search/search/listProperties
     */
    searchServiceListProperties: (body: SearchListPropertiesRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListPropertiesData, SearchServiceListPropertiesError>({
        path: `/web/search/search/listProperties`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Paginated, filterable and searchable tenancy list replacing Algolia tenancy index queries. ACL is enforced server-side: only tenancies where allowedAccountIds contains accountId (from auth) are returned. Free-text query searches tenants.name, subTenants.tenant.name, numericId, obj.numericId, obj.address.street/streetNumber/mailbox/subUnit/streetAddition/zip/city. Default sort when no sort* field is set: tenantNameSortValue ASC, then obj.categorySortValue ASC, then obj.floorSortValue ASC, then startingAtTimestamp ASC. When a sort* field is set, it is the primary sort; remaining defaults are applied as tie breakers. At most one primary sort* should be set. Searchable facet typeahead is done client-side on the returned facet buckets.
     *
     * @tags SearchService
     * @name SearchServiceListTenancies
     * @summary List tenancies from the search read model
     * @request POST:/web/search/search/listTenancies
     */
    searchServiceListTenancies: (body: SearchListTenanciesRequest, params: RequestParams = {}) =>
      this.request<SearchServiceListTenanciesData, SearchServiceListTenanciesError>({
        path: `/web/search/search/listTenancies`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns whether search index updates are still ongoing for any of the given entity IDs.
     *
     * @tags SearchService
     * @name SearchServiceUpdateOngoing
     * @summary Check whether search index updates are ongoing
     * @request POST:/web/search/search/updateOngoing
     */
    searchServiceUpdateOngoing: (body: SearchUpdateOngoingRequest, params: RequestParams = {}) =>
      this.request<SearchServiceUpdateOngoingData, SearchServiceUpdateOngoingError>({
        path: `/web/search/search/updateOngoing`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all saved table settings (table name and column layout) for the given accountId.
     *
     * @tags TableService
     * @name TableServiceLoadSettings
     * @summary Load table settings for an account
     * @request GET:/web/search/table/loadSettings
     */
    tableServiceLoadSettings: (query: TableServiceLoadSettingsParams, params: RequestParams = {}) =>
      this.request<TableServiceLoadSettingsData, TableServiceLoadSettingsError>({
        path: `/web/search/table/loadSettings`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Saves the column layout for the given accountId and table name. Returns the saved table settings.
     *
     * @tags TableService
     * @name TableServiceSaveSettings
     * @summary Save table settings for an account
     * @request POST:/web/search/table/saveSettings
     */
    tableServiceSaveSettings: (body: SearchtableSaveSettingsRequest, params: RequestParams = {}) =>
      this.request<TableServiceSaveSettingsData, TableServiceSaveSettingsError>({
        path: `/web/search/table/saveSettings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns, for each given entity ID, the account IDs allowed to access that entity.
     *
     * @tags ShareService
     * @name ShareServiceListAllowedAccountIds
     * @summary List allowed account IDs by entity
     * @request POST:/web/share/listAllowedAccountIds
     */
    shareServiceListAllowedAccountIds: (body: ShareListAllowedAccountIdsRequest, params: RequestParams = {}) =>
      this.request<ShareServiceListAllowedAccountIdsData, ShareServiceListAllowedAccountIdsError>({
        path: `/web/share/listAllowedAccountIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns shares from sourceAccountId to the given target account IDs. Optional resourceIdPrefix filters which resource IDs are returned.
     *
     * @tags ShareService
     * @name ShareServiceListByAccountIds
     * @summary List shares by source and target accounts
     * @request GET:/web/share/listByAccountIds/{sourceAccountId}/target/{targetAccountIds}
     */
    shareServiceListByAccountIds: (
      { sourceAccountId, targetAccountIds, ...query }: ShareServiceListByAccountIdsParams,
      params: RequestParams = {},
    ) =>
      this.request<ShareServiceListByAccountIdsData, ShareServiceListByAccountIdsError>({
        path: `/web/share/listByAccountIds/${sourceAccountId}/target/${targetAccountIds}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns shares that include any of the given resource IDs.
     *
     * @tags ShareService
     * @name ShareServiceListByResource
     * @summary List shares by resource IDs
     * @request POST:/web/share/listByResource
     */
    shareServiceListByResource: (body: ShareListByResourceRequest, params: RequestParams = {}) =>
      this.request<ShareServiceListByResourceData, ShareServiceListByResourceError>({
        path: `/web/share/listByResource`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns shares associated with the given sub-resource IDs.
     *
     * @tags ShareService
     * @name ShareServiceListBySubResourceIds
     * @summary List shares by sub-resource IDs
     * @request POST:/web/share/listBySubResourceIds
     */
    shareServiceListBySubResourceIds: (body: ShareListBySubResourceIdsRequest, params: RequestParams = {}) =>
      this.request<ShareServiceListBySubResourceIdsData, ShareServiceListBySubResourceIdsError>({
        path: `/web/share/listBySubResourceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns shares targeting the given account. Optional resourceIdPrefix filters which resource IDs are returned.
     *
     * @tags ShareService
     * @name ShareServiceListByTargetAccountId
     * @summary List shares by target account
     * @request GET:/web/share/listByTargetAccountId/{targetAccountId}
     */
    shareServiceListByTargetAccountId: (
      { targetAccountId, ...query }: ShareServiceListByTargetAccountIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ShareServiceListByTargetAccountIdData, ShareServiceListByTargetAccountIdError>({
        path: `/web/share/listByTargetAccountId/${targetAccountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns resource IDs shared with the given target account. Optional resourceIdPrefix and share scopes filter the results.
     *
     * @tags ShareService
     * @name ShareServiceListIdsByTargetAccountId
     * @summary List resource IDs by target account
     * @request GET:/web/share/listIdsByTargetAccountId/{targetAccountId}
     */
    shareServiceListIdsByTargetAccountId: (
      { targetAccountId, ...query }: ShareServiceListIdsByTargetAccountIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ShareServiceListIdsByTargetAccountIdData, ShareServiceListIdsByTargetAccountIdError>({
        path: `/web/share/listIdsByTargetAccountId/${targetAccountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns source (owner) account IDs that share with the given target account.
     *
     * @tags ShareService
     * @name ShareServiceListOwners
     * @summary List owner account IDs for a target
     * @request GET:/web/share/listOwners/{targetAccountId}
     */
    shareServiceListOwners: (targetAccountId: string, params: RequestParams = {}) =>
      this.request<ShareServiceListOwnersData, ShareServiceListOwnersError>({
        path: `/web/share/listOwners/${targetAccountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns target account IDs that are share partners of the given source account.
     *
     * @tags ShareService
     * @name ShareServiceListPartners
     * @summary List partner account IDs for a source
     * @request GET:/web/share/listPartners/{sourceAccountId}
     */
    shareServiceListPartners: (sourceAccountId: string, params: RequestParams = {}) =>
      this.request<ShareServiceListPartnersData, ShareServiceListPartnersError>({
        path: `/web/share/listPartners/${sourceAccountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns partner account IDs associated with the given asset account.
     *
     * @tags ShareService
     * @name ShareServiceListPartnersOfAsset
     * @summary List partners of an asset account
     * @request GET:/web/share/listPartnersOfAsset/{assetAccountId}
     */
    shareServiceListPartnersOfAsset: (assetAccountId: string, params: RequestParams = {}) =>
      this.request<ShareServiceListPartnersOfAssetData, ShareServiceListPartnersOfAssetError>({
        path: `/web/share/listPartnersOfAsset/${assetAccountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns sub-resource shares for the given resource IDs, optionally filtered by sub-resource ID prefixes.
     *
     * @tags ShareService
     * @name ShareServiceListSubResourcesByResourceIds
     * @summary List sub-resource shares by resource IDs
     * @request POST:/web/share/listSubResourceByResourceIds
     */
    shareServiceListSubResourcesByResourceIds: (
      body: ShareListSubResourcesByResourceIdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<ShareServiceListSubResourcesByResourceIdsData, ShareServiceListSubResourcesByResourceIdsError>({
        path: `/web/share/listSubResourceByResourceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns sub-resource IDs shared with the given target account under the specified scope, optionally filtered by sub-resource ID prefix.
     *
     * @tags ShareService
     * @name ShareServiceListSubResourcesByTargetAccountId
     * @summary List sub-resource IDs by target account
     * @request GET:/web/share/listSubResourcesByTargetAccountId/{targetAccountId}
     */
    shareServiceListSubResourcesByTargetAccountId: (
      { targetAccountId, ...query }: ShareServiceListSubResourcesByTargetAccountIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ShareServiceListSubResourcesByTargetAccountIdData,
        ShareServiceListSubResourcesByTargetAccountIdError
      >({
        path: `/web/share/listSubResourcesByTargetAccountId/${targetAccountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Creates or updates a share from sourceAccountId to targetAccountId for the given resource IDs under the specified share scope. Returns the resulting share.
     *
     * @tags ShareService
     * @name ShareServiceSet
     * @summary Set a share
     * @request POST:/web/share/set
     */
    shareServiceSet: (body: ShareshareSetRequest, params: RequestParams = {}) =>
      this.request<ShareServiceSetData, ShareServiceSetError>({
        path: `/web/share/set`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets shares from an owner account to a target account for the given share scopes. Returns the resulting shares.
     *
     * @tags ShareService
     * @name ShareServiceSetShareForOwner
     * @summary Set shares for an owner
     * @request POST:/web/share/setShareForOwner
     */
    shareServiceSetShareForOwner: (body: ShareSetShareForOwnerRequest, params: RequestParams = {}) =>
      this.request<ShareServiceSetShareForOwnerData, ShareServiceSetShareForOwnerError>({
        path: `/web/share/setShareForOwner`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets shares from multiple owner accounts to a target account for the given share scopes. Returns the resulting shares.
     *
     * @tags ShareService
     * @name ShareServiceSetShareForOwners
     * @summary Set shares for multiple owners
     * @request POST:/web/share/setShareForOwners
     */
    shareServiceSetShareForOwners: (body: ShareSetShareForOwnersRequest, params: RequestParams = {}) =>
      this.request<ShareServiceSetShareForOwnersData, ShareServiceSetShareForOwnersError>({
        path: `/web/share/setShareForOwners`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes shares for the given resource IDs from sourceAccountId under the specified share scopes.
     *
     * @tags ShareService
     * @name ShareServiceUnset
     * @summary Unset shares
     * @request POST:/web/share/unset
     */
    shareServiceUnset: (body: ShareUnsetRequest, params: RequestParams = {}) =>
      this.request<ShareServiceUnsetData, ShareServiceUnsetError>({
        path: `/web/share/unset`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the same status on all tickets identified by the given IDs.
     *
     * @tags TicketService
     * @name TicketServiceChangeStatusBulk
     * @summary Change status of multiple tickets
     * @request POST:/web/ticket/changeStatusBulk
     */
    ticketServiceChangeStatusBulk: (body: TicketChangeStatusBulkRequest, params: RequestParams = {}) =>
      this.request<TicketServiceChangeStatusBulkData, TicketServiceChangeStatusBulkError>({
        path: `/web/ticket/changeStatusBulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the number of unread tickets for the given user IDs.
     *
     * @tags TicketService
     * @name TicketServiceCountMyUnreadTickets
     * @summary Count my unread tickets
     * @request GET:/web/ticket/countMyUnreadTickets
     */
    ticketServiceCountMyUnreadTickets: (query: TicketServiceCountMyUnreadTicketsParams, params: RequestParams = {}) =>
      this.request<TicketServiceCountMyUnreadTicketsData, TicketServiceCountMyUnreadTicketsError>({
        path: `/web/ticket/countMyUnreadTickets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns per-reference counts of tasks and orders for the given reference IDs.
     *
     * @tags TicketService
     * @name TicketServiceCountTickets
     * @summary Count tickets by reference IDs
     * @request POST:/web/ticket/countTickets
     */
    ticketServiceCountTickets: (body: TicketCountTicketsRequest, params: RequestParams = {}) =>
      this.request<TicketServiceCountTicketsData, TicketServiceCountTicketsError>({
        path: `/web/ticket/countTickets`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new ticket for the given owner with type, status, title, description, references, assignee, watchers, dates, costs, checklist, and related fields. Optional key may be supplied. Returns the created ticket.
     *
     * @tags TicketService
     * @name TicketServiceCreate
     * @summary Create a ticket
     * @request POST:/web/ticket/create
     */
    ticketServiceCreate: (body: TicketticketCreateRequest, params: RequestParams = {}) =>
      this.request<TicketServiceCreateData, TicketServiceCreateError>({
        path: `/web/ticket/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a checklist ticket template for the owner with name, assignee settings, media, and checklist items. Returns the created template.
     *
     * @tags TicketService
     * @name TicketServiceCreateChecklistTemplate
     * @summary Create a checklist template
     * @request POST:/web/ticket/createChecklistTemplate
     */
    ticketServiceCreateChecklistTemplate: (body: TicketCreateChecklistTemplateRequest, params: RequestParams = {}) =>
      this.request<TicketServiceCreateChecklistTemplateData, TicketServiceCreateChecklistTemplateError>({
        path: `/web/ticket/createChecklistTemplate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the checklist ticket templates identified by the given IDs.
     *
     * @tags TicketService
     * @name TicketServiceDeleteChecklistTemplates
     * @summary Delete checklist templates
     * @request DELETE:/web/ticket/deleteChecklistTemplates/{ids}
     */
    ticketServiceDeleteChecklistTemplates: (ids: string[], params: RequestParams = {}) =>
      this.request<TicketServiceDeleteChecklistTemplatesData, TicketServiceDeleteChecklistTemplatesError>({
        path: `/web/ticket/deleteChecklistTemplates/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Enables or disables ticketing for the given account.
     *
     * @tags TicketService
     * @name TicketServiceEnableTicketing
     * @summary Enable or disable ticketing
     * @request POST:/web/ticket/enableTicketing
     */
    ticketServiceEnableTicketing: (body: TicketEnableTicketingRequest, params: RequestParams = {}) =>
      this.request<TicketServiceEnableTicketingData, TicketServiceEnableTicketingError>({
        path: `/web/ticket/enableTicketing`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a single ticket identified by its human-readable key.
     *
     * @tags TicketService
     * @name TicketServiceGetByKey
     * @summary Get ticket by key
     * @request GET:/web/ticket/getByKey/{key}
     */
    ticketServiceGetByKey: (key: string, params: RequestParams = {}) =>
      this.request<TicketServiceGetByKeyData, TicketServiceGetByKeyError>({
        path: `/web/ticket/getByKey/${key}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a ticket identified by its public ID, usable without auth for non-registered access. Includes invoice document and media when linked.
     *
     * @tags TicketService
     * @name TicketServiceGetByPublicId
     * @summary Get ticket by public ID
     * @request GET:/web/ticket/getByPublicId/{publicId}
     */
    ticketServiceGetByPublicId: (publicId: string, params: RequestParams = {}) =>
      this.request<TicketServiceGetByPublicIdData, TicketServiceGetByPublicIdError>({
        path: `/web/ticket/getByPublicId/${publicId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the notification mailbox ID configured for the given account.
     *
     * @tags TicketService
     * @name TicketServiceGetNotificationMailbox
     * @summary Get notification mailbox
     * @request GET:/web/ticket/getNotificationMailbox/{accountId}
     */
    ticketServiceGetNotificationMailbox: (accountId: string, params: RequestParams = {}) =>
      this.request<TicketServiceGetNotificationMailboxData, TicketServiceGetNotificationMailboxError>({
        path: `/web/ticket/getNotificationMailbox/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns overall ticket count and priority-grouped counts for open, in-progress, done, and closed tickets for the given user.
     *
     * @tags TicketService
     * @name TicketServiceGetTicketStatistics
     * @summary Get ticket statistics for a user
     * @request GET:/web/ticket/getTicketStatistics/{userId}
     */
    ticketServiceGetTicketStatistics: (userId: string, params: RequestParams = {}) =>
      this.request<TicketServiceGetTicketStatisticsData, TicketServiceGetTicketStatisticsError>({
        path: `/web/ticket/getTicketStatistics/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether ticketing is enabled for the given account.
     *
     * @tags TicketService
     * @name TicketServiceHasTicketingEnabled
     * @summary Check if ticketing is enabled
     * @request GET:/web/ticket/hasTicketingEnabled
     */
    ticketServiceHasTicketingEnabled: (query: TicketServiceHasTicketingEnabledParams, params: RequestParams = {}) =>
      this.request<TicketServiceHasTicketingEnabledData, TicketServiceHasTicketingEnabledError>({
        path: `/web/ticket/hasTicketingEnabled`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the change history events for a ticket identified by ticketId or publicTicketId. Events include editor, type, timestamp, and type-specific change data.
     *
     * @tags HistoryService
     * @name HistoryServiceListChanges
     * @summary List ticket history changes
     * @request GET:/web/ticket/history/{ticketId}
     */
    historyServiceListChanges: ({ ticketId, ...query }: HistoryServiceListChangesParams, params: RequestParams = {}) =>
      this.request<HistoryServiceListChangesData, HistoryServiceListChangesError>({
        path: `/web/ticket/history/${ticketId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns whether the given contact ID is referenced by any tickets.
     *
     * @tags TicketService
     * @name TicketServiceIsContactInUse
     * @summary Check if a contact is in use
     * @request GET:/web/ticket/isContactInUse/{contactId}
     */
    ticketServiceIsContactInUse: (contactId: string, params: RequestParams = {}) =>
      this.request<TicketServiceIsContactInUseData, TicketServiceIsContactInUseError>({
        path: `/web/ticket/isContactInUse/${contactId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns tickets associated with any of the given contact IDs.
     *
     * @tags TicketService
     * @name TicketServiceListByContactIds
     * @summary List tickets by contact IDs
     * @request POST:/web/ticket/listByContactIds
     */
    ticketServiceListByContactIds: (body: TicketticketListByContactIdsRequest, params: RequestParams = {}) =>
      this.request<TicketServiceListByContactIdsData, TicketServiceListByContactIdsError>({
        path: `/web/ticket/listByContactIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the tickets matching the given ticket IDs.
     *
     * @tags TicketService
     * @name TicketServiceListByIds
     * @summary List tickets by IDs
     * @request POST:/web/ticket/listByIds
     */
    ticketServiceListByIds: (body: TicketticketListByIdsRequest, params: RequestParams = {}) =>
      this.request<TicketServiceListByIdsData, TicketServiceListByIdsError>({
        path: `/web/ticket/listByIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns tickets matching the given free-text query string.
     *
     * @tags TicketService
     * @name TicketServiceListByQuery
     * @summary List tickets by query
     * @request GET:/web/ticket/listByQuery
     */
    ticketServiceListByQuery: (query: TicketServiceListByQueryParams, params: RequestParams = {}) =>
      this.request<TicketServiceListByQueryData, TicketServiceListByQueryError>({
        path: `/web/ticket/listByQuery`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns tickets that reference any of the given reference IDs.
     *
     * @tags TicketService
     * @name TicketServiceListByReferenceIds
     * @summary List tickets by reference IDs
     * @request POST:/web/ticket/listByReferenceIds
     */
    ticketServiceListByReferenceIds: (body: TicketticketListByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<TicketServiceListByReferenceIdsData, TicketServiceListByReferenceIdsError>({
        path: `/web/ticket/listByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all checklist ticket templates for the given account.
     *
     * @tags TicketService
     * @name TicketServiceListChecklistTemplates
     * @summary List checklist templates
     * @request GET:/web/ticket/listChecklistTemplates/{accountId}
     */
    ticketServiceListChecklistTemplates: (accountId: string, params: RequestParams = {}) =>
      this.request<TicketServiceListChecklistTemplatesData, TicketServiceListChecklistTemplatesError>({
        path: `/web/ticket/listChecklistTemplates/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of tickets for the authenticated caller. Supports filtering by query, priorities, types, statuses, owners, creators, assignees, contacts, references, and flags such as closed, overdue, watching, or unread. Response includes total ticket and page counts.
     *
     * @tags TicketService
     * @name TicketServiceListMyTickets
     * @summary List my tickets
     * @request GET:/web/ticket/listMyTickets
     */
    ticketServiceListMyTickets: (query: TicketServiceListMyTicketsParams, params: RequestParams = {}) =>
      this.request<TicketServiceListMyTicketsData, TicketServiceListMyTicketsError>({
        path: `/web/ticket/listMyTickets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns a paginated list of tickets for the authenticated caller. Supports filtering by query, priorities, types, statuses, owners, creators, assignees, contacts, references, and flags such as closed, overdue, watching, or unread. Response includes total ticket and page counts.
     *
     * @tags TicketService
     * @name TicketServiceListMyTickets2
     * @summary List my tickets
     * @request POST:/web/ticket/listMyTickets
     */
    ticketServiceListMyTickets2: (body: TicketListMyTicketsRequest, params: RequestParams = {}) =>
      this.request<TicketServiceListMyTickets2Data, TicketServiceListMyTickets2Error>({
        path: `/web/ticket/listMyTickets`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description From the given account IDs, returns those that have ticketing enabled.
     *
     * @tags TicketService
     * @name TicketServiceListTicketingEnabled
     * @summary List accounts with ticketing enabled
     * @request POST:/web/ticket/listTicketingEnabled
     */
    ticketServiceListTicketingEnabled: (body: TicketListTicketingEnabledRequest, params: RequestParams = {}) =>
      this.request<TicketServiceListTicketingEnabledData, TicketServiceListTicketingEnabledError>({
        path: `/web/ticket/listTicketingEnabled`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given tickets as read for the assignee.
     *
     * @tags TicketService
     * @name TicketServiceMarkRead2
     * @summary Mark tickets as read
     * @request POST:/web/ticket/markRead
     */
    ticketServiceMarkRead2: (body: TicketticketMarkReadRequest, params: RequestParams = {}) =>
      this.request<TicketServiceMarkRead2Data, TicketServiceMarkRead2Error>({
        path: `/web/ticket/markRead`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given tickets as unread for the assignee.
     *
     * @tags TicketService
     * @name TicketServiceMarkUnread2
     * @summary Mark tickets as unread
     * @request POST:/web/ticket/markUnread
     */
    ticketServiceMarkUnread2: (body: TicketticketMarkUnreadRequest, params: RequestParams = {}) =>
      this.request<TicketServiceMarkUnread2Data, TicketServiceMarkUnread2Error>({
        path: `/web/ticket/markUnread`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given watcher user from all tickets assigned to the given assignee. Returns the number of modified tickets.
     *
     * @tags TicketService
     * @name TicketServiceRemoveWatcherFromTicketsOfAssignee
     * @summary Remove watcher from assignee tickets
     * @request POST:/web/ticket/removeWatcherFromTicketsOfAssignee
     */
    ticketServiceRemoveWatcherFromTicketsOfAssignee: (
      body: TicketRemoveWatcherFromTicketsOfAssigneeRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TicketServiceRemoveWatcherFromTicketsOfAssigneeData,
        TicketServiceRemoveWatcherFromTicketsOfAssigneeError
      >({
        path: `/web/ticket/removeWatcherFromTicketsOfAssignee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Reserves the requested number of human-readable ticket keys for the given account. Returns the reserved keys.
     *
     * @tags TicketService
     * @name TicketServiceReserveKeys
     * @summary Reserve ticket keys
     * @request POST:/web/ticket/reserveKeys
     */
    ticketServiceReserveKeys: (body: TicketReserveKeysRequest, params: RequestParams = {}) =>
      this.request<TicketServiceReserveKeysData, TicketServiceReserveKeysError>({
        path: `/web/ticket/reserveKeys`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates or updates the given automatic ticket schedules (category, timing, language, and assignee settings).
     *
     * @tags TicketService
     * @name TicketServiceSetSchedules
     * @summary Set automatic ticket schedules
     * @request POST:/web/ticket/schedules
     */
    ticketServiceSetSchedules: (body: TicketSetSchedulesRequest, params: RequestParams = {}) =>
      this.request<TicketServiceSetSchedulesData, TicketServiceSetSchedulesError>({
        path: `/web/ticket/schedules`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns automatic ticket schedules for the given account. Optional categories filter may be applied.
     *
     * @tags TicketService
     * @name TicketServiceListSchedules
     * @summary List schedules for an account
     * @request GET:/web/ticket/schedules/{accountId}
     */
    ticketServiceListSchedules: (
      { accountId, ...query }: TicketServiceListSchedulesParams,
      params: RequestParams = {},
    ) =>
      this.request<TicketServiceListSchedulesData, TicketServiceListSchedulesError>({
        path: `/web/ticket/schedules/${accountId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Sets the notification mailbox ID for the given account.
     *
     * @tags TicketService
     * @name TicketServiceSetNotificationMailbox
     * @summary Set notification mailbox
     * @request POST:/web/ticket/setNotificationMailbox/{accountId}
     */
    ticketServiceSetNotificationMailbox: (
      accountId: string,
      body: TicketServiceSetNotificationMailboxPayload,
      params: RequestParams = {},
    ) =>
      this.request<TicketServiceSetNotificationMailboxData, TicketServiceSetNotificationMailboxError>({
        path: `/web/ticket/setNotificationMailbox/${accountId}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates a checklist ticket template by ID, including name, assignee settings, media, and checklist items. Returns the updated template.
     *
     * @tags TicketService
     * @name TicketServiceUpdateChecklistTemplate
     * @summary Update a checklist template
     * @request POST:/web/ticket/updateChecklistTemplate/{id}
     */
    ticketServiceUpdateChecklistTemplate: (
      id: string,
      body: TicketServiceUpdateChecklistTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TicketServiceUpdateChecklistTemplateData, TicketServiceUpdateChecklistTemplateError>({
        path: `/web/ticket/updateChecklistTemplate/${id}`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Marks the given tickets as read for the assignee.
     *
     * @tags TicketService
     * @name TicketServiceMarkRead
     * @summary Mark tickets as read
     * @request POST:/web/ticket/{ids}/markRead
     */
    ticketServiceMarkRead: (ids: string[], params: RequestParams = {}) =>
      this.request<TicketServiceMarkReadData, TicketServiceMarkReadError>({
        path: `/web/ticket/${ids}/markRead`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Marks the given tickets as unread for the assignee.
     *
     * @tags TicketService
     * @name TicketServiceMarkUnread
     * @summary Mark tickets as unread
     * @request POST:/web/ticket/{ids}/markUnread
     */
    ticketServiceMarkUnread: (ids: string[], params: RequestParams = {}) =>
      this.request<TicketServiceMarkUnreadData, TicketServiceMarkUnreadError>({
        path: `/web/ticket/${ids}/markUnread`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Attaches invoice media to the ticket by media ID. Optional publicId and operatorName support unregistered craftsman uploads. Returns the updated ticket.
     *
     * @tags TicketService
     * @name TicketServiceAddInvoice
     * @summary Add an invoice to a ticket
     * @request POST:/web/ticket/{id}/addInvoice
     */
    ticketServiceAddInvoice: (id: string, body: TicketServiceAddInvoicePayload, params: RequestParams = {}) =>
      this.request<TicketServiceAddInvoiceData, TicketServiceAddInvoiceError>({
        path: `/web/ticket/${id}/addInvoice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Adds a watcher (account and user) to the given ticket. Returns the updated ticket.
     *
     * @tags TicketService
     * @name TicketServiceAddWatcher
     * @summary Add a watcher to a ticket
     * @request POST:/web/ticket/{id}/addWatcher
     */
    ticketServiceAddWatcher: (id: string, body: TicketServiceAddWatcherPayload, params: RequestParams = {}) =>
      this.request<TicketServiceAddWatcherData, TicketServiceAddWatcherError>({
        path: `/web/ticket/${id}/addWatcher`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Changes the status of a ticket by ID. Optional name and email identify who performed the change.
     *
     * @tags TicketService
     * @name TicketServiceChangeStatus
     * @summary Change ticket status
     * @request POST:/web/ticket/{id}/changeStatus
     */
    ticketServiceChangeStatus: (id: string, body: TicketServiceChangeStatusPayload, params: RequestParams = {}) =>
      this.request<TicketServiceChangeStatusData, TicketServiceChangeStatusError>({
        path: `/web/ticket/${id}/changeStatus`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes the ticket by ID. Optionally also deletes its recurrence configuration.
     *
     * @tags TicketService
     * @name TicketServiceDelete
     * @summary Delete a ticket
     * @request DELETE:/web/ticket/{id}/delete
     */
    ticketServiceDelete: ({ id, ...query }: TicketServiceDeleteParams, params: RequestParams = {}) =>
      this.request<TicketServiceDeleteData, TicketServiceDeleteError>({
        path: `/web/ticket/${id}/delete`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Removes the invoice document from the ticket. Optional publicId and operatorName support unregistered craftsman access. Returns the updated ticket.
     *
     * @tags TicketService
     * @name TicketServiceDeleteInvoice
     * @summary Delete a ticket invoice
     * @request POST:/web/ticket/{id}/deleteInvoice
     */
    ticketServiceDeleteInvoice: (id: string, body: TicketServiceDeleteInvoicePayload, params: RequestParams = {}) =>
      this.request<TicketServiceDeleteInvoiceData, TicketServiceDeleteInvoiceError>({
        path: `/web/ticket/${id}/deleteInvoice`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates an existing ticket using the update operation and field mask. Optionally updates recurrence fields and can omit correspondence notifications. Returns the updated ticket.
     *
     * @tags TicketService
     * @name TicketServiceUpdate
     * @summary Update a ticket
     * @request POST:/web/ticket/{update.id}/update
     */
    ticketServiceUpdate: (updateId: string, body: TicketServiceUpdatePayload, params: RequestParams = {}) =>
      this.request<TicketServiceUpdateData, TicketServiceUpdateError>({
        path: `/web/ticket/${updateId}/update`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates portal links from the given entries (referenceId, name, url) and returns the created links.
     *
     * @tags PortalService
     * @name PortalServiceAddLinks
     * @summary Add portal links
     * @request POST:/web/user/portal/addLinks
     */
    portalServiceAddLinks: (body: PortalAddLinksRequest, params: RequestParams = {}) =>
      this.request<PortalServiceAddLinksData, PortalServiceAddLinksError>({
        path: `/web/user/portal/addLinks`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Enables or disables the portal for the given accountIds, optionally scoped to propertyIds.
     *
     * @tags PortalService
     * @name PortalServiceEnablePortal
     * @summary Enable or disable portal
     * @request POST:/web/user/portal/enablePortal
     */
    portalServiceEnablePortal: (body: PortalEnablePortalRequest, params: RequestParams = {}) =>
      this.request<PortalServiceEnablePortalData, PortalServiceEnablePortalError>({
        path: `/web/user/portal/enablePortal`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns portal data for the given email, including titles, media entries, and links.
     *
     * @tags PortalService
     * @name PortalServiceGetPortalData
     * @summary Get portal data by email
     * @request GET:/web/user/portal/getPortalData/{email}
     */
    portalServiceGetPortalData: (email: string, params: RequestParams = {}) =>
      this.request<PortalServiceGetPortalDataData, PortalServiceGetPortalDataError>({
        path: `/web/user/portal/getPortalData/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns whether the portal is enabled for the given accountId, along with the related propertyIds.
     *
     * @tags PortalService
     * @name PortalServiceHasPortalEnabled
     * @summary Check if portal is enabled
     * @request GET:/web/user/portal/hasPortalEnabled/{accountId}
     */
    portalServiceHasPortalEnabled: (accountId: string, params: RequestParams = {}) =>
      this.request<PortalServiceHasPortalEnabledData, PortalServiceHasPortalEnabledError>({
        path: `/web/user/portal/hasPortalEnabled/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns document groups (title, subtitle, and media entries) available in the portal for the given email.
     *
     * @tags PortalService
     * @name PortalServiceListDocumentGroups
     * @summary List portal document groups by email
     * @request GET:/web/user/portal/listDocumentGroups/{email}
     */
    portalServiceListDocumentGroups: (email: string, params: RequestParams = {}) =>
      this.request<PortalServiceListDocumentGroupsData, PortalServiceListDocumentGroupsError>({
        path: `/web/user/portal/listDocumentGroups/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns portal links matching the given referenceIds.
     *
     * @tags PortalService
     * @name PortalServiceListLinksByReferenceIds
     * @summary List portal links by reference IDs
     * @request POST:/web/user/portal/listLinksByReferenceIds
     */
    portalServiceListLinksByReferenceIds: (body: PortalListLinksByReferenceIdsRequest, params: RequestParams = {}) =>
      this.request<PortalServiceListLinksByReferenceIdsData, PortalServiceListLinksByReferenceIdsError>({
        path: `/web/user/portal/listLinksByReferenceIds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the portal links identified by the given ids.
     *
     * @tags PortalService
     * @name PortalServiceRemoveLinks
     * @summary Remove portal links
     * @request DELETE:/web/user/portal/removeLinks/{ids}
     */
    portalServiceRemoveLinks: (ids: string[], params: RequestParams = {}) =>
      this.request<PortalServiceRemoveLinksData, PortalServiceRemoveLinksError>({
        path: `/web/user/portal/removeLinks/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Updates the given portal links (id, referenceId, name, url).
     *
     * @tags PortalService
     * @name PortalServiceUpdateLinks
     * @summary Update portal links
     * @request POST:/web/user/portal/updateLinks
     */
    portalServiceUpdateLinks: (body: PortalUpdateLinksRequest, params: RequestParams = {}) =>
      this.request<PortalServiceUpdateLinksData, PortalServiceUpdateLinksError>({
        path: `/web/user/portal/updateLinks`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates a new account with the given type and subType. Provide company for company accounts or individual for individual accounts. Returns the created account.
     *
     * @tags AccountService
     * @name AccountServiceCreate
     * @summary Create an account
     * @request POST:/web/v2/user/account/create
     */
    accountServiceCreate: (body: Useraccountv2CreateRequest, params: RequestParams = {}) =>
      this.request<AccountServiceCreateData, AccountServiceCreateError>({
        path: `/web/v2/user/account/create`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the account identified by the given id, including company/individual data, contact person, states, billing, and logo.
     *
     * @tags AccountService
     * @name AccountServiceGet
     * @summary Get an account by ID
     * @request GET:/web/v2/user/account/get/{id}
     */
    accountServiceGet: (id: string, params: RequestParams = {}) =>
      this.request<AccountServiceGetData, AccountServiceGetError>({
        path: `/web/v2/user/account/get/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a paginated list of accounts. Supports filtering by types, subTypes, email, companyName, contactPersonName, and states. Response includes total and page counts.
     *
     * @tags AccountService
     * @name AccountServiceList
     * @summary List accounts
     * @request GET:/web/v2/user/account/list/{page}
     */
    accountServiceList: ({ page, ...query }: AccountServiceListParams, params: RequestParams = {}) =>
      this.request<AccountServiceListData, AccountServiceListError>({
        path: `/web/v2/user/account/list/${page}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns the accounts matching the given account IDs.
     *
     * @tags AccountService
     * @name AccountServiceListByIds
     * @summary List accounts by IDs
     * @request GET:/web/v2/user/account/listByIds/{ids}
     */
    accountServiceListByIds: (ids: string[], params: RequestParams = {}) =>
      this.request<AccountServiceListByIdsData, AccountServiceListByIdsError>({
        path: `/web/v2/user/account/listByIds/${ids}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Updates billing settings for the account identified by id, including billable flag, billing address account, note, contract start, and pricing model.
     *
     * @tags AccountService
     * @name AccountServiceChangeBilling
     * @summary Change account billing
     * @request POST:/web/v2/user/account/{id}/changeBilling
     */
    accountServiceChangeBilling: (id: string, body: AccountServiceChangeBillingPayload, params: RequestParams = {}) =>
      this.request<AccountServiceChangeBillingData, AccountServiceChangeBillingError>({
        path: `/web/v2/user/account/${id}/changeBilling`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Changes the subType of the account identified by id.
     *
     * @tags AccountService
     * @name AccountServiceChangeSubType
     * @summary Change account sub type
     * @request POST:/web/v2/user/account/{id}/changeSubType
     */
    accountServiceChangeSubType: (id: string, body: AccountServiceChangeSubTypePayload, params: RequestParams = {}) =>
      this.request<AccountServiceChangeSubTypeData, AccountServiceChangeSubTypeError>({
        path: `/web/v2/user/account/${id}/changeSubType`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the font family, size, and color settings for the account identified by id.
     *
     * @tags AccountService
     * @name AccountServiceGetFontSettings
     * @summary Get account font settings
     * @request GET:/web/v2/user/account/{id}/getFontSettings
     */
    accountServiceGetFontSettings: (id: string, params: RequestParams = {}) =>
      this.request<AccountServiceGetFontSettingsData, AccountServiceGetFontSettingsError>({
        path: `/web/v2/user/account/${id}/getFontSettings`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Sets the font family, size, and color for the account identified by id.
     *
     * @tags AccountService
     * @name AccountServiceSetFontSettings
     * @summary Set account font settings
     * @request POST:/web/v2/user/account/{id}/setFontSettings
     */
    accountServiceSetFontSettings: (
      id: string,
      body: AccountServiceSetFontSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AccountServiceSetFontSettingsData, AccountServiceSetFontSettingsError>({
        path: `/web/v2/user/account/${id}/setFontSettings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets the logo URL for the account identified by id and returns the updated account.
     *
     * @tags AccountService
     * @name AccountServiceSetLogo
     * @summary Set account logo
     * @request POST:/web/v2/user/account/{id}/setLogo
     */
    accountServiceSetLogo: (id: string, body: AccountServiceSetLogoPayload, params: RequestParams = {}) =>
      this.request<AccountServiceSetLogoData, AccountServiceSetLogoError>({
        path: `/web/v2/user/account/${id}/setLogo`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the company details of the account identified by id and returns the updated account.
     *
     * @tags AccountService
     * @name AccountServiceUpdateCompany
     * @summary Update company account data
     * @request POST:/web/v2/user/account/{id}/updateCompany
     */
    accountServiceUpdateCompany: (id: string, body: AccountServiceUpdateCompanyPayload, params: RequestParams = {}) =>
      this.request<AccountServiceUpdateCompanyData, AccountServiceUpdateCompanyError>({
        path: `/web/v2/user/account/${id}/updateCompany`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the contact person (userId, name, phone, email) of the account identified by id and returns the updated account.
     *
     * @tags AccountService
     * @name AccountServiceUpdateContactPerson
     * @summary Update account contact person
     * @request POST:/web/v2/user/account/{id}/updateContactPerson
     */
    accountServiceUpdateContactPerson: (
      id: string,
      body: AccountServiceUpdateContactPersonPayload,
      params: RequestParams = {},
    ) =>
      this.request<AccountServiceUpdateContactPersonData, AccountServiceUpdateContactPersonError>({
        path: `/web/v2/user/account/${id}/updateContactPerson`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates the individual details of the account identified by id and returns the updated account.
     *
     * @tags AccountService
     * @name AccountServiceUpdateIndividual
     * @summary Update individual account data
     * @request POST:/web/v2/user/account/{id}/updateIndividual
     */
    accountServiceUpdateIndividual: (
      id: string,
      body: AccountServiceUpdateIndividualPayload,
      params: RequestParams = {},
    ) =>
      this.request<AccountServiceUpdateIndividualData, AccountServiceUpdateIndividualError>({
        path: `/web/v2/user/account/${id}/updateIndividual`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates marketing, management, accounting, and asset states for the account identified by id and returns the updated account.
     *
     * @tags AccountService
     * @name AccountServiceUpdateStates
     * @summary Update account states
     * @request POST:/web/v2/user/account/{id}/updateStates
     */
    accountServiceUpdateStates: (id: string, body: AccountServiceUpdateStatesPayload, params: RequestParams = {}) =>
      this.request<AccountServiceUpdateStatesData, AccountServiceUpdateStatesError>({
        path: `/web/v2/user/account/${id}/updateStates`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns the user identified by the given userId, including profile, address, roles, and blocked/deleted status.
     *
     * @tags UserService
     * @name UserServiceGet
     * @summary Get a user by ID
     * @request GET:/web/v2/user/get/{userId}
     */
    userServiceGet: (userId: string, params: RequestParams = {}) =>
      this.request<UserServiceGetData, UserServiceGetError>({
        path: `/web/v2/user/get/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns the user matching the given email address.
     *
     * @tags UserService
     * @name UserServiceGetByMail
     * @summary Get a user by email
     * @request GET:/web/v2/user/getByMail/{email}
     */
    userServiceGetByMail: (email: string, params: RequestParams = {}) =>
      this.request<UserServiceGetByMailData, UserServiceGetByMailError>({
        path: `/web/v2/user/getByMail/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Invites a user by email to the given accountId with optional roles, password, and password-reset email. Returns the created or invited user.
     *
     * @tags UserService
     * @name UserServiceInviteEmployee
     * @summary Invite an employee to an account
     * @request POST:/web/v2/user/inviteEmployee
     */
    userServiceInviteEmployee: (body: V2InviteEmployeeRequest, params: RequestParams = {}) =>
      this.request<UserServiceInviteEmployeeData, UserServiceInviteEmployeeError>({
        path: `/web/v2/user/inviteEmployee`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a paginated list of users. Supports filtering by accountId, email, firstName, and lastName. Response includes page metadata and overall count.
     *
     * @tags UserService
     * @name UserServiceList
     * @summary List users
     * @request GET:/web/v2/user/list
     */
    userServiceList: (query: UserServiceListParams, params: RequestParams = {}) =>
      this.request<UserServiceListData, UserServiceListError>({
        path: `/web/v2/user/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Returns employee users for all of the given accountIds.
     *
     * @tags UserService
     * @name UserServiceListAllEmployees
     * @summary List employees for multiple accounts
     * @request POST:/web/v2/user/listAllEmployees
     */
    userServiceListAllEmployees: (body: V2ListAllEmployeesRequest, params: RequestParams = {}) =>
      this.request<UserServiceListAllEmployeesData, UserServiceListAllEmployeesError>({
        path: `/web/v2/user/listAllEmployees`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns all employee users belonging to the given accountId.
     *
     * @tags UserService
     * @name UserServiceListEmployees
     * @summary List employees for an account
     * @request GET:/web/v2/user/listEmployees/{accountId}
     */
    userServiceListEmployees: (accountId: string, params: RequestParams = {}) =>
      this.request<UserServiceListEmployeesData, UserServiceListEmployeesError>({
        path: `/web/v2/user/listEmployees/${accountId}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Returns a notification token for the given userId.
     *
     * @tags NotificationService
     * @name NotificationServiceGetToken
     * @summary Get a notification token
     * @request GET:/web/v2/user/notification/getToken
     */
    notificationServiceGetToken: (query: NotificationServiceGetTokenParams, params: RequestParams = {}) =>
      this.request<NotificationServiceGetTokenData, NotificationServiceGetTokenError>({
        path: `/web/v2/user/notification/getToken`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Publishes a system update notification with message text in German, English, and Italian.
     *
     * @tags NotificationService
     * @name NotificationServicePublishUpdateMessage
     * @summary Publish a system update message
     * @request POST:/web/v2/user/notification/publishUpdateMessage
     */
    notificationServicePublishUpdateMessage: (body: V2PublishUpdateMessageRequest, params: RequestParams = {}) =>
      this.request<NotificationServicePublishUpdateMessageData, NotificationServicePublishUpdateMessageError>({
        path: `/web/v2/user/notification/publishUpdateMessage`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns notification settings for the given userId, including channels and ticket, other, and marketbase preferences.
     *
     * @tags NotificationService
     * @name NotificationServiceGetSettings
     * @summary Get notification settings
     * @request GET:/web/v2/user/notification/settings
     */
    notificationServiceGetSettings: (query: NotificationServiceGetSettingsParams, params: RequestParams = {}) =>
      this.request<NotificationServiceGetSettingsData, NotificationServiceGetSettingsError>({
        path: `/web/v2/user/notification/settings`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Updates notification channels and ticket, other, and marketbase preferences for the given userId. Returns the saved settings.
     *
     * @tags NotificationService
     * @name NotificationServiceSetSettings
     * @summary Set notification settings
     * @request POST:/web/v2/user/notification/settings
     */
    notificationServiceSetSettings: (body: Usernotificationv2SetSettingsRequest, params: RequestParams = {}) =>
      this.request<NotificationServiceSetSettingsData, NotificationServiceSetSettingsError>({
        path: `/web/v2/user/notification/settings`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Completes registration using the given invite/register token and password.
     *
     * @tags UserService
     * @name UserServiceRegister
     * @summary Register a user with a token
     * @request POST:/web/v2/user/register
     */
    userServiceRegister: (body: V2RegisterRequest, params: RequestParams = {}) =>
      this.request<UserServiceRegisterData, UserServiceRegisterError>({
        path: `/web/v2/user/register`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Resolves a registration token and returns the associated email, name, gender, and company name.
     *
     * @tags UserService
     * @name UserServiceResolveToken
     * @summary Resolve a registration token
     * @request GET:/web/v2/user/resolveToken/{token}
     */
    userServiceResolveToken: (token: string, params: RequestParams = {}) =>
      this.request<UserServiceResolveTokenData, UserServiceResolveTokenError>({
        path: `/web/v2/user/resolveToken/${token}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Blocks the users identified by the given userIds.
     *
     * @tags UserService
     * @name UserServiceBlock
     * @summary Block users
     * @request POST:/web/v2/user/{userIds}/block
     */
    userServiceBlock: (userIds: string[], params: RequestParams = {}) =>
      this.request<UserServiceBlockData, UserServiceBlockError>({
        path: `/web/v2/user/${userIds}/block`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Unblocks the users identified by the given userIds.
     *
     * @tags UserService
     * @name UserServiceUnblock
     * @summary Unblock users
     * @request POST:/web/v2/user/{userIds}/unBlock
     */
    userServiceUnblock: (userIds: string[], params: RequestParams = {}) =>
      this.request<UserServiceUnblockData, UserServiceUnblockError>({
        path: `/web/v2/user/${userIds}/unBlock`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Adds the given role to the specified userId and returns the updated user.
     *
     * @tags UserService
     * @name UserServiceAddRole
     * @summary Add a role to a user
     * @request POST:/web/v2/user/{userId}/addRole
     */
    userServiceAddRole: (
      userId: string,
      body: {
        role?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserServiceAddRoleData, UserServiceAddRoleError>({
        path: `/web/v2/user/${userId}/addRole`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates the email of the given userId to newEmail and returns the updated user.
     *
     * @tags UserService
     * @name UserServiceChangeEmail
     * @summary Change a user email
     * @request POST:/web/v2/user/{userId}/changeEmail
     */
    userServiceChangeEmail: (userId: string, body: UserServiceChangeEmailPayload, params: RequestParams = {}) =>
      this.request<UserServiceChangeEmailData, UserServiceChangeEmailError>({
        path: `/web/v2/user/${userId}/changeEmail`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets a new password for the given userId and returns the updated user.
     *
     * @tags UserService
     * @name UserServiceChangePassword
     * @summary Change a user password
     * @request POST:/web/v2/user/{userId}/changePassword
     */
    userServiceChangePassword: (userId: string, body: UserServiceChangePasswordPayload, params: RequestParams = {}) =>
      this.request<UserServiceChangePasswordData, UserServiceChangePasswordError>({
        path: `/web/v2/user/${userId}/changePassword`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the given role from the specified userId and returns the updated user.
     *
     * @tags UserService
     * @name UserServiceRemoveRole
     * @summary Remove a role from a user
     * @request POST:/web/v2/user/{userId}/removeRole
     */
    userServiceRemoveRole: (
      userId: string,
      body: {
        role?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserServiceRemoveRoleData, UserServiceRemoveRoleError>({
        path: `/web/v2/user/${userId}/removeRole`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * @description Updates the profile of the given userId and returns the updated user.
     *
     * @tags UserService
     * @name UserServiceUpdateProfile
     * @summary Update a user profile
     * @request POST:/web/v2/user/{userId}/updateProfile
     */
    userServiceUpdateProfile: (userId: string, body: UserServiceUpdateProfilePayload, params: RequestParams = {}) =>
      this.request<UserServiceUpdateProfileData, UserServiceUpdateProfileError>({
        path: `/web/v2/user/${userId}/updateProfile`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
}
